webpackJsonp(["main-code-split"],{

/***/ "../node_modules/core-js/fn/array/find.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.find;

/***/ }),

/***/ "../node_modules/core-js/fn/array/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.includes;

/***/ }),

/***/ "../node_modules/core-js/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.assign;

/***/ }),

/***/ "../node_modules/core-js/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.entries;

/***/ }),

/***/ "../node_modules/core-js/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.values;

/***/ }),

/***/ "../node_modules/core-js/fn/string/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").String.includes;

/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {



// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {



// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {



// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {



var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {



var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {



// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {



// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {



// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {



// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {



module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "../node_modules/core-js/modules/_function-to-string.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__("../node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);

/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {



// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {



var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {



var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {



module.exports = false;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {


// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {



var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {



exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {



var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {



exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {



var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {



module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var $toString = __webpack_require__("../node_modules/core-js/modules/_function-to-string.js");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {



var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {



var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {



// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {



var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {



// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {



var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {



var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var _Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {


// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js") });

/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {


// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "../node_modules/credit-card-type/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = __webpack_require__("../node_modules/credit-card-type/dist/lib/card-types.js");
var add_matching_cards_to_results_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/add-matching-cards-to-results.js");
var is_valid_input_type_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/is-valid-input-type.js");
var find_best_match_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/find-best-match.js");
var clone_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/clone.js");
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function (cardType) {
        return clone_1.clone(findType(cardType));
    });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) {
        ignoreErrorForNotExisting = false;
    }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function (cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [bestMatch];
    }
    return results;
}
creditCardType.getTypeInfo = function (cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType.removeCard = function (name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = function (config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType.updateCard = function (cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function (name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function () {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/add-matching-cards-to-results.js":
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.addMatchingCardsToResults = void 0;
var clone_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/clone.js");
var matches_1 = __webpack_require__("../node_modules/credit-card-type/dist/lib/matches.js");
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        } else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
exports.addMatchingCardsToResults = addMatchingCardsToResults;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/card-types.js":
/***/ (function(module, exports) {



var cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [4],
        gaps: [4, 8, 12],
        lengths: [16, 18, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [34, 37],
        gaps: [4, 10],
        lengths: [15],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [[300, 305], 36, 38, 39],
        gaps: [4, 10],
        lengths: [14, 16, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [6011, [644, 649], 65],
        gaps: [4, 8, 12],
        lengths: [16, 19],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [2131, 1800, [3528, 3589]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [620, [624, 626], [62100, 62182], [62184, 62187], [62185, 62197], [62200, 62205], [622010, 622999], 622018, [622019, 622999], [62207, 62209], [622126, 622925], [623, 626], 6270, 6272, 6276, [627700, 627779], [627781, 627799], [6282, 6289], 6291, 6292, 810, [8110, 8131], [8132, 8151], [8152, 8163], [8164, 8171]],
        gaps: [4, 8, 12],
        lengths: [14, 15, 16, 17, 18, 19],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [493698, [500000, 504174], [504176, 506698], [506779, 508999], [56, 59], 63, 67, 6],
        gaps: [4, 8, 12],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [401178, 401179, 438935, 457631, 457632, 431274, 451416, 457393, 504175, [506699, 506778], [509000, 509999], 627780, 636297, 636368, [650031, 650033], [650035, 650051], [650405, 650439], [650485, 650538], [650541, 650598], [650700, 650718], [650720, 650727], [650901, 650978], [651652, 651679], [655000, 655019], [655021, 655058]],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [[2200, 2204]],
        gaps: [4, 8, 12],
        lengths: [16, 17, 18, 19],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [606282],
        gaps: [4, 8, 12],
        lengths: [16],
        code: {
            name: "CVC",
            size: 3
        }
    }
};
module.exports = cardTypes;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/clone.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
exports.clone = clone;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/find-best-match.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */
    return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function (bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */
        if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
exports.findBestMatch = findBestMatch;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/is-valid-input-type.js":
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}
exports.isValidInputType = isValidInputType;

/***/ }),

/***/ "../node_modules/credit-card-type/dist/lib/matches.js":
/***/ (function(module, exports) {


/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */

Object.defineProperty(exports, "__esModule", { value: true });
exports.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
exports.matches = matches;

/***/ }),

/***/ "../node_modules/lodash/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (true) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"message.msgs || message.msgKeys\">\n    <div id=\"notifications\" role=\"alert\" aria-live=\"assertive\" content >\n        <div id=\"pageLevelErrors\" ng-class=\"[{'extendedMsg': isgreyheader}, 'msg-' + message.type, 'msgPage']\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs track by $index\">\n                    <span data-ng-bind-html=\"msg\" data-test-id=\"message\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys track by $index\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys, message.compileWith)\" data-test-id=\"message\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\" />\n        <p class=\"loader\" />\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">\n            {{ message }}\n        </p>\n        <p id=\"spinner-submessage\" tabIndex=\"0\" role=\"alert\" class=\"loadingSubHeading\" ng-if=\"subMessage\">\n            {{ subMessage }}\n        </p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/qs/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Stringify = __webpack_require__("../node_modules/qs/lib/stringify.js");
var Parse = __webpack_require__("../node_modules/qs/lib/parse.js");


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};



/***/ }),

/***/ "../node_modules/qs/lib/parse.js":
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__("../node_modules/qs/lib/utils.js");


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = Utils.decode(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = Utils.decode(part.slice(0, pos));
            val = Utils.decode(part.slice(pos + 1));
        }
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};



/***/ }),

/***/ "../node_modules/qs/lib/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__("../node_modules/qs/lib/utils.js");


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};



/***/ }),

/***/ "../node_modules/qs/lib/utils.js":
/***/ (function(module, exports) {

// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};



/***/ }),

/***/ "../node_modules/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Api = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getLatestCorrelationID = $getLatestCorrelationID;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 API
 ---

 This layer is responsible for handling api requests. It has a number of responsibilities:

 - Caching responses
 - Transparently returning data that has been preloaded into the initial page response
 - Instrumentation
 - Batching multiple api calls into a single http request
 - Handling multiple types of responses and dispatching to the correct handlers
 - Emitting loading events for all http calls
 */

_config.$meta.headers = _config.$meta.headers || {};
_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];

// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
function cookiesEnabled() {
    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
}

// Cache for api responses, when cache: true
var cache = {};
var standardHeaders = {};

var latestCorrelationID = _config.$meta.correlationId;

// Window load promise
var windowLoad = _util.$util.memoize(function () {
    return _promise.$promise.resolver(function (resolve) {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            window.addEventListener('load', resolve);
        }
    });
});

// Buffer for batch requests made within the same frame
var batchQueue = {};

// Backwards compat
window.pre = {};

// Transient cache resolvers
var transientCache = {};

// Transient cache resolvers
var transientCacheResolvers = {};

// Metabuilder
var metaBuilder = void 0;

// Add to transientCache
window.preload = function (method, url, data, name) {

    if (name) {
        window.pre[name] = {
            method: method,
            uri: url,
            res: data
        };
    }

    var key = method + ':' + url;
    var resolvers = transientCacheResolvers[key] || [];

    transientCache[key] = data;

    while (resolvers.length) {
        resolvers.pop().call();
    }
};

// Preload complete
var preloadComplete = false;

window.preloadComplete = function () {
    preloadComplete = true;
    Object.keys(transientCacheResolvers).forEach(function (key) {
        var resolvers = transientCacheResolvers[key] || [];

        while (resolvers.length) {
            resolvers.pop().call();
        }
    });
};

_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');

var $Api = exports.$Api = _class.$Class.extend('$Api', {

    // Cache any GET responses indefinitely
    cache: false,

    // Http timeout for all requests
    timeout: 45000,

    // Default number of attempts on aborted requests and 500 server errors
    getAttempts: 3,
    postAttempts: 1,

    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
    action: function action(_action, options) {
        options.action = _action;
        return this.post(options);
    },

    // GET on a resource myapi.retrieve() -> GET /my/api
    retrieve: function retrieve(options) {
        options.method = 'get';
        return this.call(options);
    },

    // POST on a resource myapi.retrieve() -> POST /my/api
    post: function post(options) {
        options.method = 'post';
        return this.call(options);
    },

    // Generic handler for calling an api and dispatching requests to the right place
    call: function call(options) {
        var self = this;

        // Set up request options and params. `options` is an object which should contain everything
        // the request needs to run and handle the response

        options.api = this;
        options.uri = this.getURI(options.model, options.action);
        options.params = options.params || {};
        options.cache = options.cache || self.cache && options.method === 'get';
        options.name = this.buildAPIName(options);
        options.meta = this.buildMeta();
        options.transientError = options.transientError || false;
        options.cacheKey = _util.$util.buildURL(options.uri, options.params);

        _logger.$logger.info(options.name + '_call', {
            name: options.name,
            method: options.method,
            uri: options.uri
        });

        if (!options.silent) {
            _event.$event.emit('loading');
        }

        // Decide where to get the response
        return _promise.$promise.first([

        // If caching is enabled and we have the data in local cache, use the cache
        function () {
            if (options.cache && cache[options.cacheKey]) {
                return cache[options.cacheKey];
            }
        },

        // Otherwise if we have transient cache data for this api, we can use that
        function () {
            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {

                // The reason we use self.attemptRequest here is so any errors in the cached response
                // can trigger the retry code path, as if it were a regular request
                return self.attemptRequest(options);
            });
        },

        // If we're in batch mode, queue up a batch request
        function () {
            if (options.batch) {
                return self.batchRequest(options);
            }
        },

        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
        function () {
            return self.attemptRequest(options);
        }])['finally'](function () {

            if (!options.silent) {
                _event.$event.emit('loaded');
            }
        }).then(function (res) {

            // Cache the response if we need to
            if (options.cache) {
                cache[options.cacheKey] = res;
            }

            // Handle the response
            return self.handleResponse(res.data, options);
        }, function (err) {

            // $BatchShortCircuit will be thrown if:
            //
            // 1. batch api call B depends on api call A, but-
            // 2. api call A fails
            //
            // In which case we end up in a situation where had it been a regular chain of events,
            // api B would never have been called in the first place.
            //
            // One possibility here is to return $unresolved, which prevents the promise from ever
            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
            // corner cases.
            //
            // Instead we opt to simply reject the promise, and not call any of the response handlers

            if (err instanceof _error.$BatchShortCircuit) {
                return _promise.$promise.reject(err);
            }

            // Otherwise, handle the error normally
            return self.handleErrorResponse(err, options);
        });
    },

    // Set up a batch request for processing in the next frame
    batchRequest: function batchRequest(options) {

        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
        // layer is to combine multiple atomic api calls into a single http request, without forcing
        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
        //
        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
        // individual api call to the correct handler.
        //
        // The way this is implemented is to place each response in the transient api cache, then to yield
        // control to the regular api request handler, which will handle instrumentation and retries

        // For quick dev-time feedback...
        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);

        var name = options.batch.name;
        var id = options.batch.id;

        // Add the batch request options to the batchQueue for processing on the next frame
        var batch = batchQueue[name] = batchQueue[name] || {};

        batch[id] = options;

        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
        return this.buildBatchRequest(name).then(function (results) {

            // We get back a mapping of id->response, so we now extract the response for our api
            // call. If we have no response, we can assume the call was never made, and short circuit.
            return results[id].then(function (result) {
                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
            });
        });
    },

    // Process all of the accumulated batch api requests
    buildBatchRequest: _promise.$promise.debounce(function (name) {

        var self = this;
        var batch = batchQueue[name];
        var batchIds = _class.$Class.keys(batch);
        var batchData = {};
        var headers = {};

        delete batchQueue[name];

        // If we have just a single request, we can short-circuit and just hit that api

        if (batchIds.length === 1) {

            var batchId = batchIds[0];
            var opts = batch[batchId];

            var results = {};

            results[batchId] = opts.api.attemptRequest(opts);
            return results;
        }

        // Build the request to send to the server side. This is an mapping of id->request, each containing
        // the method, uri, data, and dependencies for each api.
        //
        // Specifying a dependency for an api essentially means the back-end will only
        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.

        _util.$util.forEach(batch, function (options, id) {

            batchData[id] = {
                method: options.method,
                uri: options.api.getURI(options.model, options.action, true),
                data: options.data,
                params: options.params,
                dependencies: options.batch.dependencies
            };

            _util.$util.extend(headers, options.headers);
        });

        // Unfortunate circular dependency... $Api depends on another api.
        //
        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
        // does not respond the first time, our batch request can still get through.

        return $batchApi.action(name, { // eslint-disable-line no-use-before-define
            data: batchData,
            headers: headers
        }).then(function (res) {

            // The final response will be a mapping of id->response-promise.
            //
            // However, we do not treat this data as our final response. Instead, we simply use it to
            // prime our transient cache, then proceed to jump to our regular request handler. This will
            // take care of retries and instrumentation as if this were a regular request.
            //
            // Note that a retry for $batchApi is different to a retry for an individual api. If
            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
            // can just retry the individual api call.

            return self.handleBatchResponse(batch, res.data);
        });
    }),

    // Process the responses for all of the batch requests we sent to the server
    handleBatchResponse: function handleBatchResponse(batch, data) {

        var self = this;

        var promises = {};

        // Loop over each individual api response contained in the batch response, and process the result

        _util.$util.forEach(batch, function (options, id) {

            // Store each response promise so we can check and wait for api dependencies

            promises[id] = _promise.$promise.run(function () {

                // Check if all of the dependencies are present for our individual api call. To do this
                // we must wait until the dependent api call is entirely complete, including any retries.

                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {

                    if (!batch[depName]) {
                        _logger.$logger.info('missing_batch_dependency', {
                            dependency: depName,
                            available: Object.keys(batch).join('|')
                        });
                    }

                    return !batch[depName] || promises[depName].then(function (dependency) {
                        return dependency && dependency.data && dependency.data.ack === 'success';
                    });
                });

                // If our dependencies are present, we can continue, otherwise we are not interested in
                // the result of the individual api call - if its dependency is not present, it will not be.

                return _promise.$promise.providing(depsPresent, function () {

                    // If there is data returned for the individual call, add it to the transient cache

                    return _promise.$promise.providing(data[id], function (result) {
                        var uri = options.api.getURI(options.model, options.action);

                        uri = _util.$util.buildURL(uri, options.params);

                        self.addTransientCacheData(options.method, uri, result);
                    }).then(function () {

                        // Regardless of whether or not there is data, we can now attempt the request.
                        // This will either get the data from the transient cache, or make an http call,
                        // and handle any retries that need to be made.

                        return options.api.attemptRequest(options);
                    });
                });
            });
        });

        return promises;
    },

    // Handle the request and any retries, using either the transient cache or http calls
    attemptRequest: function attemptRequest(options) {
        var self = this;
        var attempts = 1;
        if (_config.$config.enableCheckoutRetries) {
            // ui:enableCheckoutRetries=true
            attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
        }

        // We allow a certain number of attempts/retries for each api call
        return _promise.$promise.attempt(attempts, function (remaining) {

            // Query the transient cache
            return self.getTransientCacheResponse(options).then(function (res) {

                // If we can get a response from the transient cache, then use it
                if (res) {
                    return res;
                }

                // Otherwise resort to making an http call
                return self.getHttpResponse(options);
            })['catch'](function (res) {

                // If our request was aborted without even a status code, force a single retry
                if ((!res || !res.status) && attempts === 1) {

                    _logger.$logger.warn('api_retry_aborted', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // If our request was 401 denied (probably due to a CSRF error), force a single retry
                if (res.status === 401) {

                    _logger.$logger.warn('api_retry_401', {
                        method: options.method,
                        uri: options.uri
                    });

                    return self.getHttpResponse(options);
                }

                return _promise.$promise.reject(res);
            })['catch'](function (res) {

                // Set the correct response and ack for 401
                if (res.status === 401) {
                    return {
                        data: {
                            ack: 'permission_denied'
                        }
                    };
                }

                // Setup to throw a TOO_MANY_REQUESTS contingency for 429 response from ratelimiter (velocityserv)
                if (res.status === 429) {
                    return {
                        data: {
                            ack: 'contingency',
                            contingency: 'TOO_MANY_REQUESTS'
                        }
                    };
                }

                // If we have any remaining retries, log and reject
                if (remaining) {

                    _logger.$logger.warn('api_retry', {
                        method: options.method,
                        uri: options.uri
                    });

                    return _promise.$promise.reject(res);
                }

                // Otherwise reject the request with the appropriate error

                // We got ack=error in the response
                if (res && res.data && res.data.ack === 'error') {
                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
                        name: options.name,
                        method: options.method,
                        uri: options.uri,
                        stack: res.data.stack,
                        transient: options.transientError
                    }));
                }

                // We got a response error status
                else if (res && res.status) {
                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    } else if (res && res.error) {
                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
                            uri: options.uri,
                            transient: options.transientError
                        }));
                    }

                    // The request was aborted
                    else {
                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
                                uri: options.uri,
                                transient: options.transientError
                            }));
                        }
            });
        });
    },

    // Get an api response via http
    getHttpResponse: function getHttpResponse(options) {
        var self = this;

        var startTime = _util.$util.now();

        var request = this.http(options);

        return request['finally'](function () {

            // Calculate the end-to-end duration of the request from the client's perspective
            options.duration = _util.$util.now() - startTime;
        })['catch'](function (res) {

            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
                return res;
            }

            return _promise.$promise.reject(res);
        }).then(function (res) {
            self.saveResponseState(res);

            var loggerPayload = {
                name: options.name,
                method: options.method,
                uri: options.uri,
                server: res.data.server,
                time: options.duration,
                duration: options.duration,
                corrid: res && res.headers('Paypal-Debug-Id')
            };

            // In certain browsers we can match up this api call to the performance data from the browser
            if (window.performance && window.performance.getEntries) {
                _util.$util.forEach(window.performance.getEntries(), function (resource) {
                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
                        _util.$util.extend(loggerPayload, resource);
                    }
                });
            }

            _logger.$logger.info('api_response', loggerPayload);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status);
            }

            return res;
        }, function (res) {
            self.saveResponseState(res);

            if (res && res.status) {
                _logger.$logger.info('http_response_' + res.status, {
                    corrid: res.headers('Paypal-Debug-Id'),
                    referenceId: res.headers('X-Reference-Header') || undefined // To not serialize this data if not present
                });
            }

            return _promise.$promise.reject(res);
        });
    },

    setTransientCache: function setTransientCache(data) {
        throw new Error('NotImplemented');
    },

    // Get an individual api response from the transient cache, as an object
    getTransientCacheData: function getTransientCacheData(options, pop) {

        if (!_config.$config.enablePreload) {
            return _promise.$promise.resolve();
        }

        var preMethod = options.method.toLowerCase();
        var preUri = _util.$util.buildURL(options.uri, options.params);

        var key = preMethod + ':' + preUri;

        return _promise.$promise.resolver(function (resolve) {

            function res() {
                var data = transientCache[key];

                if (pop) {
                    delete transientCache[key];
                }
                resolve(data);
            }

            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
                return res();
            }

            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
            transientCacheResolvers[key].push(res);

            windowLoad().then(res);
        });
    },

    // Check if the transient cache has the data for a particular api
    hasTransientCacheData: function hasTransientCacheData(options) {
        return this.getTransientCacheData(options, false).then(function (data) {
            return Boolean(data);
        });
    },

    // Add data to the transient cache
    addTransientCacheData: function addTransientCacheData(method, uri, data) {
        var key = method + ':' + uri;

        transientCache[key] = data;
    },

    // Get an individual api response from transient cache, as a res promise with the correct status code
    getTransientCacheResponse: function getTransientCacheResponse(options) {

        return this.getTransientCacheData(options, true).then(function (data) {

            // Preload data does not come with a response code, so massage it into a response promise
            if (data) {
                if (data.ack === 'error') {
                    return _promise.$promise.reject({
                        status: 500,
                        data: data
                    });
                } else if (data.ack === 'permission_denied') {
                    return _promise.$promise.reject({
                        status: 401,
                        data: data
                    });
                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
                    return {
                        status: 400,
                        data: data
                    };
                } else {
                    return {
                        status: 200,
                        data: data
                    };
                }
            }

            // Log a cache miss if we are currently in the first-page load
            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
                    _logger.$logger.info('preload_cache_miss', {
                        uri: options.uri
                    });
                }
        });
    },

    getHeaders: function getHeaders(options) {

        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
            _logger.$logger.warn('missing_csrf_jwt');
        }

        var headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
        };

        _util.$util.extend(headers, standardHeaders);

        if (window.xprops && window.xprops.clientMetadataID) {
            headers['paypal-client-metadata-id'] = window.xprops.clientMetadataID;
        } else if (_util.$util.param('client-metadata-id')) {
            headers['paypal-client-metadata-id'] = _util.$util.param('client-metadata-id');
        }

        if (!cookiesEnabled()) {
            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
        }

        if (options.headers) {
            _util.$util.extend(headers, options.headers);
        }

        return headers;
    },
    http: function http(options) {
        return this.httpJQuery(options);
    },


    /*
     // Raw http call
    httpAngular: function(options) {
         let request = {
            method: options.method,
            url: options.uri,
            data: {
                data: options.data,
                meta: options.meta
            },
            headers: this.getHeaders(options),
            params: options.params,
            requestType: 'json',
            responseType: 'json',
            timeout: this.timeout
        };
         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
            request.params.meta = JSON.stringify(options.meta);
        }
         return $http(request);
    },
     */

    httpJQuery: function httpJQuery(options) {

        var request = {
            method: options.method,
            data: options.method === 'get' ? options.params : JSON.stringify({
                data: options.data,
                meta: options.meta || {}
            }),
            headers: this.getHeaders(options),
            timeout: this.timeout
        };

        if (options.method === 'post') {
            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
        } else if (options.method === 'get') {
            request.data.meta = JSON.stringify(options.meta);
        }

        return _promise.$promise.resolver(function (resolve, reject) {

            function getRes(res, data) {
                return {
                    status: res.status,
                    data: data,
                    headers: function headers(name) {
                        return res.getResponseHeader(name);
                    }
                };
            }

            request.success = function (data, status, res) {
                return resolve(getRes(res, data));
            };

            request.error = function (res) {
                if (res && res.status) {
                    if (res.status >= 400) {
                        return reject(getRes(res, res.responseJSON));
                    } else {
                        return resolve(getRes(res, res.responseJSON));
                    }
                }

                return reject({
                    status: 0,
                    headers: _util.$util.noop,
                    error: res && res.statusText
                });
            };

            _jquery2['default'].ajax(options.uri, request);
        });
    },

    // Save cookies and jwt-csrf token from the response
    saveResponseState: function saveResponseState(res) {

        if (res.headers('x-csrf-jwt')) {
            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
        }

        if (res.headers('X-cookies')) {

            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');

            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
        }

        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
    },

    // Dispatch the response to the correct handlers
    handleResponse: function handleResponse(res, options) {
        var loggerName = 'ui_' + options.name;

        var loggerPayload = {
            name: options.name,
            method: options.method,
            uri: options.uri,
            time: options.duration,
            duration: options.duration
        };

        // Here we dispatch the response to the correct handler based on the ack.
        //
        // ack=success     -> options.success()
        // ack=error       -> options.error()
        // ack=validation  -> options.validation()
        // ack=contingency -> options.contingencies[contingency]()
        //
        // Why do this rather than just rejecting the promise with a custom error?
        //
        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
        //    every error they want to. This is exacerbated by the fact that there is no single thread
        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
        //
        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
        // and the global error handler will be invoked. The api responses are also given as promises.

        var resultModel = options.resultModel || options.model;

        /* jshint maxcomplexity: 17 */
        return _promise.$promise.call(function () {

            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack

            if (res.data && resultModel) {

                if (resultModel.populate) {
                    resultModel.populate(res.data);
                } else {
                    _util.$util.extend(resultModel, res.data);
                }
            }

            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
                    return _util.$util.extend(resultModel, children);
                });
            }
        }).then(function () {
            // eslint-disable-line max-statements

            // Handle each ack type, throw errors accordingly

            if (res.ack === 'success') {
                _logger.$logger.info(loggerName + '_success', loggerPayload);

                if (options.success) {
                    if (options.success instanceof Function) {
                        return options.success(res.data);
                    }
                    return options.success;
                }

                return res;
            }

            if (options.failSilently) {
                return;
            }

            if (res.ack === 'contingency') {
                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
                    contingency: res.contingency
                }));

                if (!res.contingency) {
                    throw new _error.$ApiError('expected_contingency_name', {
                        api: options.name
                    });
                }

                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });

                if (resultModel) {
                    resultModel.errorData = res.errorData || {};
                }

                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);

                _util.$util.extend(contingency, res.errorData);

                if (handler) {
                    if (handler instanceof Function) {
                        return handler(contingency.message, contingency);
                    }
                    return handler;
                }

                throw contingency;
            } else if (res.ack === 'validation') {
                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
                    validation: res.validation
                }));

                if (options.validation) {
                    return options.validation(res.validation);
                }

                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            } else if (res.ack === 'permission_denied') {
                _logger.$logger.info(loggerName + '_denied', loggerPayload);

                var properties = {
                    transient: options.transientError
                };

                if (res.reason) {
                    properties.reason = res.reason;
                }

                throw new _error.$Forbidden(options.uri + ': forbidden', properties);
            } else {
                _logger.$logger.info(loggerName + '_noack', loggerPayload);

                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
                    transient: options.transientError
                });
            }
        });
    },

    // Handle http error responses (ack=error or unhandled errors)
    handleErrorResponse: function handleErrorResponse(err, options) {

        return _promise.$promise.run(function () {

            // If the caller provides an error handler, let them handle it
            if (options.error) {
                return options.error(err);
            }

            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
            // this will always end up in the global error handler due to how angular promises work.
            throw err;
        });
    },

    // Build the uri for the api call
    getURI: function getURI(model, action, relative) {
        var self = this;

        // build the uri as a seriest of segments
        var uri = [];

        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {

            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})

            key = key.slice(2);
            key = key.substring(0, key.length - 1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                return '';
            }

            return '/' + component;
        }).replace(/:[\w\.]+/g, function (key) {

            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})

            key = key.slice(1);

            var component = model.get ? model.get(key) : model[key];

            if (!component) {
                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
            }

            return component;
        }));

        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
        if (action) {
            uri.push(action);
        }

        // Add the extension (e.g. for doing a GET on a .json resource)
        if (this.ext) {
            uri[uri.length - 1] += '.' + this.ext;
        }

        // Join the uri segments and strip any extra slashes
        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');

        // Add on the base uri, e.g. /webapps/hermes
        if (!relative) {
            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
        }

        return uri;
    },

    // Attach meta data provided by the parent app
    buildMeta: function buildMeta() {
        if (metaBuilder) {
            return metaBuilder();
        }
    },

    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
    buildAPIName: function buildAPIName(options) {
        var self = this;
        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
        replace(/\//g, '_'). // Replace remaining '/' with '_'
        replace(/\?(.*)/, ''). // Remove everything after '?'
        replace(/[^a-zA-Z0-9_]/g, '');

        apiName = options.action ? apiName + '_' + options.action : apiName;
        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
        return apiName;
    }
});

$Api.reopenClass({
    clearCache: function clearCache() {
        cache = {};
    }
});

$Api.registerMetaBuilder = function (builder) {
    metaBuilder = builder;
};

$Api.addHeader = function (name, value) {
    standardHeaders[name] = value;
};

var $batchApi = new $Api({
    uri: '/api/batch',
    postAttempts: 3
});

function $getLatestCorrelationID() {
    return latestCorrelationID;
}

angular.value("$Api", $Api);
angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
_logger.$logger;

_event.$event;

_class.$Class;

_util.$util;

_promise.$promise;

_config.$config;

_config.$meta;

_error.$Contingency;

_error.$Forbidden;

_error.$ApiError;

_error.$BatchShortCircuit;

_loader.$loader;

/***/ }),

/***/ "../node_modules/squid/dist/core/class.js":
/***/ (function(module, exports) {



exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 Class
 -----

 A class pattern, adding sugar on top of javascript prototypes

 ### Basic Usage

 let MyClass = Class.extend({
 foo: 'bar';
 });

 myInstance = new MyClass({
 hello: 'world'
 });

 console.log(myInstance.foo, myInstance.hello)

 In this example, `foo` becomes a property on `MyClass`'s prototype,
 and `hello` becomes a property on `myInstance`.

 ### Default Object Methods

 - `init()`: Called after the object is first instantiated, with all properties available

 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default

 e.g. `myInstance.get('foo.bar.baz', 'some_default');`

 Default return value is undefined

 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep

 e.g. `myInstance.set('foo.bar.baz', 'some_value');`

 Error is thrown if no object is found to set the value on

 - `setProperties(<object>)`: Set all the properties from an object onto your object

 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`

 Can not be used with nested properties

 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair

 */

// Object Create
// -------------
//
// Shim for Object.create, if it is not supported by our browser
//
// let myPrototype = {foo: 'bar'}
// let myObject = create(myPrototype)

// Create an empty anonymous constructor with no side effects, for re-use later
var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function

var create = Object.create || function create(obj) {

    // Set a temporary prototype
    EmptyConstructor.prototype = obj;

    // Create an object using our temporary constructor/prototype
    var instance = new EmptyConstructor();

    // Reset the prototype for next time
    EmptyConstructor.prototype = null;

    // Return our new object, created without side effects
    return instance;
};

function _extend(obj, source) {

    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

// Is Object
// ---------
//
// Check of a let is an object or not
//
// isobject({}) -> true
// isobject('foo') -> false

function isobject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
}

// Transpose properties
// -------------------------------------------------------------------
//
// Transpose properties from a list of objects onto a recipient object
//
// let recipient = {};
// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
// recipient -> {a: 1, b: 2, c:3}

function transpose(recipient, args) {

    // Loop through all args
    for (var i = 0; i < args.length; i++) {
        var ob = args[i];

        // Ignore anything that is not an object
        if (!isobject(ob)) {
            continue;
        }

        // Loop through all keys in our object
        for (var key in ob) {

            // Ignore any prototypal properties
            if (!ob.hasOwnProperty(key)) {
                continue;
            }

            var item = ob[key];

            // Give the function a name
            if (item instanceof Function) {
                item.__name__ = key;
            }

            recipient[key] = item;
        }
    }
}

// Construct a Class
// -----------------
//
// This is the primary constructor for all $Class objects

function construct() {
    // eslint-disable-line no-unused-vars

    // Call any custom constructor;
    if (this.construct) {
        var ob = this.construct.apply(this, arguments);

        // If we get a new object back, return that to the user
        if (isobject(ob)) {
            return ob;
        }
    }

    // Load any provided properties directly onto the object
    transpose(this, arguments);

    // Initialize the object
    if (this.init) {
        this.init();
    }
}

// Reopen an object
// ----------------
//
// Add properties to the constructor's prototype
//
//     let Animal = $Class.extend();
//
//     Animal.reopen({
//       type: 'animal',
//     });
//
//     let cat = new Animal;
//     console.log(cat.type);
function reopen() {

    // Add some more properies to our prototype
    transpose(this.prototype, arguments);

    return this;
}

// Reopen a class
// --------------
//
// Add properties to the constructor. These will propogate through future extends
//
//     let Animal = $Class.extend();
//
//     Animal.reopenClass({
//       fromCache: function(id) {
//         return cache[id] || new this({id: id});
//       }
//     }
//
//     let cat = Animal.fromCache('cat_54');

function reopenClass() {

    // Add some more properies to our class
    transpose(this, arguments);

    // Add to __classmethods__
    transpose(this.__classmethods__, arguments);

    return this;
}

function isChild(Cls) {
    return Cls && Cls.prototype instanceof this;
}

// Generate a new class
// --------------------
//
// Generate a new constructor, with the specified name, and attach all static and prototypal methods

var id = 0;

function extend(name) {
    // eslint-disable-line max-statements
    var Cls = void 0;
    var className = void 0;
    var args = void 0;
    var argsLength = void 0;
    var startIndex = void 0;

    // Accept an optional class name
    if (typeof name === 'string') {

        // Guard against javascript injection
        if (!name.match(/^[\w$][\w\d]*$/)) {
            throw new Error('Class name can not include special characters: ' + name);
        }

        // Use the provided name and slice out the first argument
        className = name;
        argsLength = arguments.length && arguments.length - 1;
        startIndex = 1;
    } else {

        // Otherwise default to the parent name, or 'Object' if generating our first class
        className = this.name || 'Object';
        argsLength = arguments.length;
        startIndex = 0;
    }

    args = new Array(argsLength);
    for (var i = startIndex; i < arguments.length; i++) {
        args[i - startIndex] = arguments[i];
    }

    // Dynamically create our constructor with a custom name
    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval

    // Store the class name for future reference
    Cls.__name__ = className;

    // Set up a classmethods object. These will be inherited through subsequent extend() calls
    Cls.__classmethods__ = {
        extend: extend,
        reopen: reopen,
        reopenClass: reopenClass,
        isChild: isChild
    };

    id += 1;
    Cls.id = id;

    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
    if (this && this !== window) {

        // Inherit everything from superclass prototype
        Cls.prototype = create(this.prototype);

        // Re-set the constructor, which is overwritten by create
        Cls.prototype.constructor = Cls;

        // Add a reference to the superclass prototype for super method calls
        Cls.prototype._super = this.prototype;

        // Inherit any class methods from the superclass
        _extend(Cls.__classmethods__, this.__classmethods__);
    }

    // Add the class methods to our existing class
    _extend(Cls, Cls.__classmethods__);

    // Load any provided properties onto the constructor's prototype
    transpose(Cls.prototype, args);

    // Temporary: allow access from console/debugger
    if (className.indexOf('$') === 0) {
        window[className] = Cls;
    } else {
        window['$' + className] = Cls;
    }

    return Cls;
}

// Multi-layer get
// ---------------
//
// Recursively gets a deep path from an object, returning a default value if any level is not found
//
// let obj = {bar: {baz: 1}}
// get(obj, 'bar.baz', 'default') -> 1
// get(obj, 'aaa.bbb', 'default') -> default

function _get(item, path, def) {

    if (!path) {
        return def;
    }

    path = path.split('.');

    // Loop through each section of our key path
    for (var i = 0; i < path.length; i++) {

        // If we have an object, we can get the key
        if (isobject(item)) {
            item = item[path[i]];
            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default
    return item === undefined ? def : item;
}

// Multi-layer set
// ---------------
//
// Recursively sets a deep path from an object
//
// let obj = {bar: {baz: 1}}
// set(obj, 'bar.baz', 2)
// obj.bar.baz -> 1

function _set(item, path, value) {
    path = path.split('.');

    // Loop through each section of our key path except the last
    for (var i = 0; i < path.length - 1; i++) {

        // Get the next item down
        item = item[path[i]];

        // If we have an object, we're good
        if (isobject(item)) {
            continue;
            // Otherwise, there's nothing to set our key on
        } else {
            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
        }
    }

    // Do the set on the retrieved object with our value
    item[path[path.length - 1]] = value;
}

// Loop through object
// -------------------
//
// Loop an object and apply a function for each key/value
//
// let ob = {a: 1, b: 2, c: 3}
// each(ob, console.log) -> a 1  b 2  c 3

function each(ob, callback) {
    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            callback.call(ob, key, ob[key]);
        }
    }
}

// Gey keys of object
// ------------------
//
// Shim for Object.keys if it does not already exist
//
// let ob = {a: 1, b: 2, c: 3}
// keys(ob) -> ['a', 'b', 'c']

function _keys(ob) {

    if (Object.keys) {
        return Object.keys(ob);
    }

    var result = [];

    for (var key in ob) {
        if (ob.hasOwnProperty(key)) {
            result.push(key);
        }
    }

    return result;
}

// Create a base class that can be inherited from
// ----------------------------------------------
//
// This is the public interface to the Class module.
// All classes with extend from Class and be provided with a set of base convenience methods.

var $Class = exports.$Class = extend('Class', {

    init: function init() {
        // Empty init class, so calls to _super can be safely made
    },

    get: function get(path, def) {
        return _get(this, path, def);
    },

    set: function set(path, value) {
        _set(this, path, value);
    },

    setProperties: function setProperties() {
        transpose(this, arguments);
    },

    forEach: function forEach(callback) {
        each(this, callback);
    },

    keys: function keys() {
        return _keys(this);
    }
});

$Class.get = _get;
$Class.set = _set;
$Class.keys = _keys;

angular.value("$Class", $Class);

/***/ }),

/***/ "../node_modules/squid/dist/core/config.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);

/***/ }),

/***/ "../node_modules/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dom = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var $dom = exports.$dom = {

    elementReady: function elementReady(id) {

        return _promise.$promise.resolver(function (resolve, reject) {

            if (document.getElementById(id)) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (document.getElementById(id)) {
                    clearInterval(interval);
                    return resolve();
                }
            }, 10);

            setTimeout(60000, reject);
        });
    },

    loadScript: function loadScript(name, src, timeout) {
        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        return _promise.$promise.resolver(function (resolve, reject) {
            var script = document.createElement('script');
            var loadTimeout = void 0;

            function clearScriptLoadTimeout() {
                if (loadTimeout) {
                    clearTimeout(loadTimeout);
                    loadTimeout = undefined;
                }
            }

            script.onload = function () {
                clearScriptLoadTimeout();
                setTimeout(resolve, 10);
            };

            // For Internet explorer 8 support
            script.onreadystatechange = function () {
                if (this.readyState === 'complete' || this.readyState === 'loaded') {
                    clearScriptLoadTimeout();
                    setTimeout(resolve, 10);
                }
            };

            script.onerror = function (event) {
                _logger.$logger.info('script_error', {
                    script: src
                });
                return reject(new Error(name + '_loading_error'));
            };

            if (timeout) {
                loadTimeout = setTimeout(function () {
                    _logger.$logger.info('script_load_timedout', {
                        script: src
                    });
                    return reject(new Error(name + '_loading_timed_out'));
                }, timeout);
            }

            script.setAttribute('src', src);

            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var attribute = _ref;

                script.setAttribute(attribute, attributes[attribute]);
            }

            document.body.appendChild(script);
        });
    },

    cssReady: function cssReady(id) {

        var el = document.getElementById(id);

        return _promise.$promise.resolver(function (resolve, reject) {

            var timeout = void 0;
            var interval = void 0;

            function check() {
                _util.$util.forEach(document.styleSheets, function (stylesheet) {
                    if (stylesheet.href === el.href) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        resolve();
                    }
                });
            }

            timeout = setTimeout(function () {
                clearInterval(interval);
                reject();
                throw new Error('css_loading_timed_out');
            }, 30000);

            interval = setInterval(check, 20);
            check();
        });
    }
};

angular.value("$dom", $dom);
_logger.$logger;

_promise.$promise;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BatchShortCircuit = exports.$ShortCircuit = exports.$FallbackError = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
    var message = _ref[0],
        file = _ref[1],
        line = _ref[2],
        col = _ref[3],
        err = _ref[4];


    original();

    _event.$event.emit('$windowError', {
        message: message && (message.stack || message).toString(),
        file: file && file.toString(),
        line: line && line.toString(),
        col: col && col.toString(),
        stack: err && (err.stack || err).toString()
    });
});

var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {

    construct: function construct(err, properties) {

        if (err instanceof Error) {
            err = err.message;
        }

        if (properties) {
            _util.$util.extend(this, properties);
        }

        this.payload = properties;

        this.message = err;
    }
});

var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
    handle: function handle(handlers) {
        var handler = handlers[this.message] || handlers['DEFAULT'];

        if (handler) {
            var result = handler.call(this, this.message, this);

            if (typeof result !== 'undefined') {
                return result;
            }
            return true;
        }
    }
});

var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');

var $ApiError = exports.$ApiError = $Error.extend('$ApiError');

var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
    init: function init() {
        this.reason = this.reason || '';
        this.product = this.product || '';
        this.entryPoint = this.entryPoint || '';
    }
});

/**
 * $ShortCircuit should be thrown if you want to bypass the remainder of a promise chain, and you've already
 * done error handling for the rejection. It should be handled with a no-op in app's $exceptionHandler
 */
var $ShortCircuit = exports.$ShortCircuit = $Error.extend('$ShortCircuit');

// TO-BE-DEPRECATED: Use $ShortCircuit instead
var $BatchShortCircuit = exports.$BatchShortCircuit = $ShortCircuit;

angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$FallbackError", $FallbackError);
angular.value("$ShortCircuit", $ShortCircuit);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
_event.$event;

_class.$Class;

_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$event = undefined;

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var handlers = {};

var customEventEmitter = void 0;

var $event = exports.$event = {
    use: function use(eventEmitter) {
        customEventEmitter = eventEmitter;

        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var eventName = _ref;

            if (handlers[eventName]) {
                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var handler = _ref2;

                    customEventEmitter.on(eventName, handler);
                }
            }
        }
    },
    on: function on(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.on(eventName, method);
        }

        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(method);

        var cancelled = false;

        function cancel() {
            if (!cancelled) {
                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
                cancelled = true;
            }
        }

        cancel.cancel = cancel;
        return cancel;
    },
    once: function once(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.once(eventName, method);
        }

        var listener = $event.on(eventName, function () {
            listener.cancel();
            return method.apply(this, arguments);
        });

        return listener;
    },
    emit: function emit(eventName) {
        if (customEventEmitter) {
            var _customEventEmitter;

            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
        }

        var event = {
            preventDefault: function preventDefault() {
                event.defaultPrevented = true;
            }
        };

        if (handlers[eventName]) {
            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var handler = _ref3;

                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
            }
        }

        return event;
    },
    broadcast: function broadcast(eventName) {

        if (customEventEmitter) {
            var _customEventEmitter2;

            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
        }

        return $event.emit.apply($event, arguments);
    },


    refCount: function refCount($scope, start, stop) {
        return _promise.$promise.resolver(function (resolve) {

            var count = 0;

            var cancelStartListener = $scope.$on(start, function (event, data) {
                count += 1;
            });

            var cancelStopListener = $scope.$on(stop, function (event, data) {
                setTimeout(function () {
                    count -= 1;
                    res(); // eslint-disable-line no-use-before-define
                }, 50);
            });

            function res() {
                if (!count) {

                    if (cancelStartListener && cancelStopListener) {
                        cancelStartListener();
                        cancelStopListener();
                    }

                    return resolve();
                }
            }

            setTimeout(res, 50);
        });
    },

    compose: function compose(start, end, startAll, endAll) {
        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


        var count = 0;
        var active = false;

        $event.on(start, function () {
            if (!count) {
                setTimeout(function () {
                    if (count && !active) {
                        active = true;
                        $event.emit(startAll);
                    }
                }, debounce);
            }

            count += 1;
        });

        $event.on(end, function () {

            setTimeout(function () {
                count -= 1;

                if (!count && active) {
                    active = false;
                    $event.emit(endAll);
                }
            }, 0);
        });

        return {
            getCount: function getCount() {
                return count;
            },
            isActive: function isActive() {
                return Boolean(count);
            },
            reset: function reset() {
                count = 0;
            }
        };
    }
};

angular.value("$event", $event);
_promise.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/squid/dist/core/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

Object.keys(_class).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _class[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _event[key];
    }
  });
});

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

Object.keys(_integration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _integration[key];
    }
  });
});

var _model = __webpack_require__("../node_modules/squid/dist/core/model.js");

Object.keys(_model).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _model[key];
    }
  });
});

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");

Object.keys(_loader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _loader[key];
    }
  });
});

var _dom = __webpack_require__("../node_modules/squid/dist/core/dom.js");

Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dom[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var $DEFAULT = exports.$DEFAULT = 'DEFAULT';

var $CONTEXT = exports.$CONTEXT = {

    // Full page checkout
    FULLPAGE: 'FULLPAGE',

    // Checkout in popup
    POPUP: 'POPUP',

    // Checkout in lightbox (iframe)
    LIGHTBOX: 'LIGHTBOX',

    // Web view
    WEBVIEW: 'WEBVIEW',

    // Native checkout
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};

var $integration = exports.$integration = {

    flow: $DEFAULT,

    init: function init(flow, config) {
        this.config = config || {};

        if (flow) {
            this.setFlow(flow);
        }

        this.setContext(this.getContext());
    },
    getContext: function getContext() {

        if (this.isIFrame()) {
            return $CONTEXT.LIGHTBOX;
        } else if (this.isPopup()) {
            return $CONTEXT.POPUP;
        } else {
            return $CONTEXT.FULLPAGE;
        }
    },
    isPopup: function isPopup() {
        return Boolean(window.opener);
    },
    isIFrame: function isIFrame() {
        return window.top !== window.self;
    },
    setContext: function setContext(context) {
        _logger.$logger.info('integration_context_' + context);
        this.context = context;
    },
    setFlow: function setFlow(flow) {
        _logger.$logger.info('integration_flow_' + flow);
        this.flow = flow;
    },
    is: function is(context, flow) {
        return this.isContext(context) && this.isFlow(flow);
    },
    isContext: function isContext(context) {
        return this.context === context;
    },
    isFlow: function isFlow(flow) {
        return this.flow === flow;
    },
    getConfig: function getConfig(key) {

        this.context = this.getContext();

        if (!this.config) {
            return;
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {

            return this.config[this.context][this.flow][key];
        }

        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {

            return this.config[this.context][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {

            return this.config[$DEFAULT][this.flow][key];
        }

        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {

            return this.config[$DEFAULT][key];
        }
    },
    error: function error(message) {
        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
    }
};

angular.value("$DEFAULT", $DEFAULT);
angular.value("$CONTEXT", $CONTEXT);
angular.value("$integration", $integration);
_logger.$logger;

/***/ }),

/***/ "../node_modules/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$loader = undefined;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _firstLoad = false;

var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);

var $loader = exports.$loader = {

    isLoading: function isLoading() {
        return Boolean(loader.getCount());
    },
    firstLoad: function firstLoad() {
        return _firstLoad;
    },
    reset: function reset() {
        loader.reset();
    }
};

_event.$event.on('allLoaded', function () {
    _firstLoad = true;
});

angular.value("$loader", $loader);
_event.$event;

/***/ }),

/***/ "../node_modules/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Model = undefined;

var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");

var $Model = exports.$Model = _class.$Class.extend('$Model', {

    init: function init() {

        if (this.keys().length) {
            this.onPopulate();
        }

        if (this.id) {
            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};

            _cache[this.id] = this;
        }

        this.meta = {
            populated: false
        };
    },

    /**
     * Add the passed in properties to this Model.
     * Sets the meta.populated to true. This flag
     * can be used later to determine if the model is populated.
     * Calls onPopulate() in the end.
     */
    populate: function populate() {

        this.meta.populated = true;
        this.setProperties.apply(this, arguments);
        delete this.meta.invalidated;
        this.onPopulate();
        return this;
    },

    fetchChildren: function fetchChildren() {
        return _promise.$promise.resolve();
    },

    /**
     * Override this method, to execute any logic after model is populated.
     */
    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method, to execute any logic after model is invalidated.
     */
    onInvalidate: function onInvalidate() {// eslint-disable-line no-empty-function

    },

    /**
     * Override this method to return a Mock instance. Must return a promise which resolves to model.
     */
    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function

    },

    /**
     * Retrieves the model.
     *
     * If model is already populated just returns a promise which resolves to `this`
     * If there is a retriever for this model, then return the retreiver.
     * Else calls the api to retrieve the model.
     *
     * @param options
     * @returns {*}
     */
    retrieve: function retrieve(options) {
        var self = this;

        options = options || {};

        if (self.meta.populated) {

            if (options.success) {
                return _promise.$promise.resolve(options.success(self));
            }

            return _promise.$promise.resolve(this);
        }

        if (this.retriever) {
            return this.retriever;
        }

        if (!this.api) {
            throw new Error('Tried to populate a model with no api');
        }

        options.model = this;

        this.retriever = this.api.retrieve(options).then(function (res) {
            return self;
        })['finally'](function () {
            delete self.retriever;
        });

        return this.retriever;
    },

    /**
     * Calls a post on the api to save this model. Takes options as parameters.
     * options will passed down to api.post.
     *
     * @param options
     * @returns {*|HttpPromise}
     */
    save: function save(options) {
        options = options || {};
        options.model = this;

        options.data = options.data || this.serialize();

        return this.api.post(options);
    },

    /**
     * Calls Api.action to perform any action on the model.
     *
     * Takes action name and optional 'options' object as parameters.
     *
     * Ex: $CheckoutSession.actions('create', [options])
     *
     * @param action
     * @param options
     * @returns {*}
     */
    action: function action(_action, options) {
        options = options || {};
        options.model = this;

        return this.api.action(_action, options);
    },

    /**
     * Use this method to force a api call to get the data.
     *
     * @param options
     * @returns {*}
     */
    reload: function reload(options) {
        this.meta.populated = false;
        return this.retrieve(options);
    },

    stringify: function stringify() {
        return JSON.stringify(this, 2);
    },

    log: function log() {
        console.log(this.stringify());
    },

    serialize: function serialize() {// eslint-disable-line no-empty-function

    },

    /**
     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
     */
    invalidate: function invalidate() {
        this.meta.populated = false;
        this.meta.invalidated = true;
        this.onInvalidate();
    },

    /**
     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
     *
     * @param Cls
     * @param child
     * @returns {*}
     */
    child: function child(Cls, _child) {

        if (!_child) {
            return;
        }

        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
    },

    /**
     *
     * @param Cls
     * @param children
     * @returns {*}
     */
    children: function children(Cls, _children) {
        var self = this;

        if (!_children) {
            return _children;
        }

        return _util.$util.map(_children, function (child) {
            return self.child(Cls, child);
        });
    }
});

var cache = {};

$Model.reopenClass({

    instance: function instance(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] || this.create.apply(this, arguments);

        return instance;
    },

    retrieveInstance: function retrieveInstance() {
        return this.instance.apply(this, arguments).retrieve();
    },

    create: function create(id) {

        var modelCache = cache[this.id] = cache[this.id] || {};
        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
            id: id || 0
        });

        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));

        return instance;
    },

    fetch: function fetch() {
        console.warn('Model.fetch is deprecated, please use Model.instance');
        return this.instance.apply(this, arguments);
    },

    clearCache: function clearCache() {
        cache = {};
    },

    /**
     * should invalidate all models where the invalidationKey is found truthy
     *
     * invalidationKey: key of type string to look for in a model
     * example: $Model.bulkInvalidate('invalidateOnLogout');
     */
    bulkInvalidate: function bulkInvalidate(invalidationKey) {
        if (!invalidationKey) {
            return;
        }
        _util.$util.forEach(cache, function (modelCache, key) {
            _util.$util.forEach(modelCache, function (modelInstance, instanceId) {
                if (modelInstance[invalidationKey]) {
                    modelInstance.invalidate();
                }
            });
        });
    }
});

angular.value("$Model", $Model);
_class.$Class;

_util.$util;

_promise.$promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$promise = $promise;

var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");

var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");

var Promise = window.Promise;

function $promise(obj) {
    return Promise.resolve(obj);
}

_util.$util.extend($promise, {
    use: function use(CustomPromise) {
        Promise = CustomPromise;
        if (!window.Promise) {
            window.Promise = CustomPromise;
        }
    },
    resolver: function resolver(method) {
        return new Promise(method);
    },
    resolve: function resolve(value) {
        return Promise.resolve(value);
    },
    reject: function reject(value) {
        return Promise.reject(value);
    },


    run: function run(method) {
        return Promise.resolve().then(method);
    },

    call: function call(method) {
        return Promise.resolve().then(method);
    },

    sequential: function sequential(methods) {

        var prom = Promise.resolve();

        _util.$util.forEach(methods, function (method) {
            prom = prom.then(method);
        });

        return prom;
    },

    sleep: function sleep(time) {
        return new Promise(function (resolve) {
            setTimeout(resolve, time);
        });
    },

    map: function map(items, method) {

        var promises = void 0;

        if (items instanceof Array) {
            promises = [];
        } else if (items instanceof Object) {
            promises = {};
        } else {
            return Promise.resolve();
        }

        return this.all(_util.$util.map(items, function (item, key) {

            promises[key] = Promise.resolve(item).then(function (result) {
                return method(result, key, promises);
            });

            return promises[key];
        }));
    },

    all: function all(items) {

        if (items instanceof Array) {
            return Promise.all(items);
        } else if (items instanceof Object) {
            return this.hash(items);
        }

        return Promise.resolve([]);
    },

    hash: function hash(obj) {
        var results = {};

        return Promise.all(_util.$util.map(obj, function (item, key) {
            return Promise.resolve(item).then(function (result) {
                results[key] = result;
            });
        })).then(function () {
            return results;
        });
    },

    extend: function extend(obj, hash) {
        return this.hash(hash || {}).then(function (data) {
            _util.$util.extend(obj, data);
        });
    },

    attempt: function attempt(attempts, method) {

        attempts -= 1;

        return Promise.resolve().then(function () {
            return method(attempts);
        })['catch'](function (err) {

            if (attempts) {
                return $promise.attempt(attempts, method);
            }

            return Promise.reject(err);
        });
    },

    debounce: function debounce(method, time) {

        var timeout = void 0;
        var resolvers = {};

        return function () {

            var self = this;
            var args = arguments;
            var key = JSON.stringify(args);

            resolvers[key] = resolvers[key] || [];

            return new Promise(function (resolve) {
                resolvers[key].push(resolve);
                clearTimeout(timeout);

                timeout = setTimeout(function () {

                    var result = method.apply(self, args);

                    _util.$util.forEach(resolvers[key], function (resolver) {
                        resolver(result);
                    });

                    delete resolvers[key];
                }, time);
            });
        };
    },

    every: function every(collection, handler) {
        return this.map(collection, function (item) {
            return handler(item);
        }).then(function (results) {
            return _util.$util.every(results);
        });
    },

    providing: function providing(condition, handler) {
        return Promise.resolve(condition).then(function (result) {
            if (result) {
                return handler(result);
            }
        });
    },

    until: function until(condition, pollTime, timeout, alwaysResolve) {

        return new Promise(function (resolve, reject) {
            if (condition()) {
                return resolve();
            }

            var interval = setInterval(function () {
                if (condition()) {
                    clearInterval(interval);
                    return resolve();
                }
            }, pollTime);

            if (timeout) {
                setTimeout(function () {
                    clearInterval(interval);
                    return alwaysResolve ? resolve() : reject();
                }, timeout);
            }
        });
    },

    first: function first(handlers) {

        var prom = $promise.resolve();
        var result = void 0;

        _util.$util.forEach(handlers, function (handler) {
            prom = prom.then(function () {
                return result || handler();
            }).then(function (handlerResult) {
                result = handlerResult;
                return result;
            });
        });

        return prom;
    },

    shortCircuit: function shortCircuit() {
        return $promise.reject(new _error.$ShortCircuit());
    }
});

angular.value("$promise", $promise);
_util.$util;

_error.$ShortCircuit;

/***/ }),

/***/ "../node_modules/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$unresolved = exports.$util = exports.isUnsafeRedirect = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.$getRedirectUrl = $getRedirectUrl;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;

var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var redirected = false;
var paramCache = {};

var blacklist = ['password', 'pr_password'];
var blacklistRegex = new RegExp('(' + blacklist.join('|') + ')=([^&]*)', 'g');
var sanitizeUrlForLogging = function sanitizeUrlForLogging(inputUrl) {
    return inputUrl.replace(blacklistRegex, function (match, key, value) {
        return key + '=**';
    });
};

var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
    return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {

    forEach: function forEach(collection, method) {
        if (collection instanceof Array) {
            for (var i = 0; i < collection.length; i++) {
                method(collection[i], i);
            }
        } else if (collection instanceof Object) {
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    method(collection[key], key);
                }
            }
        }
    },

    idleTimeout: function idleTimeout(time) {
        setTimeout(function () {
            _logger.$logger.info('page_idle');
            $util.reload();
        }, time);
    },


    reload: function reload() {
        _logger.$logger.info('reload');
        _event.$event.emit('loading');
        location.reload();
    },

    /**
     * replace:
     * Insert URL params provided and reload the window
     * This does not find the param if it already exists in the URL. It will add it again
     * @param params {Object} param - Params to add as URL params
     */
    replace: function replace(params) {
        if (params) {
            // Note: This won't replace the
            var url = $util.buildURL(location.href.split('#')[0], params);

            url = '' + url + window.location.hash;

            _logger.$logger.info('replace', { url: url });
            _event.$event.emit('loading');
            location.replace(url);
        } else {
            $util.reload();
        }
    },

    /**
    * redirect:
    * Redirects user to the given Url with options for different redirect behaviours
    * @param params {String} url - redirect url
    * @param params {Object} options - Optional param can have flags effecting behaviour of redirect
    */
    redirect: function redirect(url, options) {

        // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
        var frameBust = options && options.frameBust;

        // Optional flag for url to not show up in browsing history. Handles back button scenario from CAPE to HERMES
        var replace = options && options.replace;

        if (isUnsafeRedirect(url)) {
            // eslint-disable-line
            _logger.$logger.error('unsafe_redirect_url', {
                url: url
            });
            throw new Error('Unsafe redirect url: ' + url);
        }

        _logger.$logger.info('redirect', {
            url: sanitizeUrlForLogging(url)
        });

        _event.$event.on('$stateChangeStart', function (event) {
            if (_angular.$rootScope.allowStateChangeAfterRedirect) {
                // at this point flow redirected buyer to return url. The return url did not display any page.
                // So, the review page/xoon sign up page with spinner(processing) will not be cleared giving impression that PayPal is still processing
                // At this time, we redirect buyer to a generic message page indicating that PayPal's processing is finished
                _logger.$logger.info('allow_state_change_after_redirect');
                _event.$event.emit('loaded');
                return;
            }
            _logger.$logger.info('state_change_after_redirect');
            event.preventDefault();
        });

        function redir() {

            if (redirected) {
                _logger.$logger.info('redirected');
                return;
            }

            _logger.$logger.info('redir', {
                url: sanitizeUrlForLogging(url)
            });

            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
                if (replace) {
                    _logger.$logger.info('windowLocationReplace', {
                        redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
                        frameBust: frameBust
                    });
                    window.top.location.replace(url);
                } else {
                    _logger.$logger.info('windowTopLocation', {
                        redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
                        frameBust: frameBust
                    });
                    window.top.location = url;
                }
            } else if (replace) {
                _logger.$logger.info('windowLocationReplace');
                window.location.replace(url);
            } else {
                _logger.$logger.info('windowLocation');
                window.location = url;
            }

            redirected = true;
        }

        _event.$event.emit('loading');

        _logger.$logger.flush().then(redir);
        setTimeout(redir, 500);

        _logger.$logger.done();
    },

    cookiesEnabled: function cookiesEnabled() {
        var cookiesEnabled = void 0;

        document.cookie = '_cookiecheck=1';
        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return cookiesEnabled;
    },

    storageEnabled: function storageEnabled(api) {
        try {
            window[api].setItem('__feature_test__', '0');
            window[api].removeItem('__feature_test__');
            return true;
        } catch (e) {
            return false;
        }
    },

    sessionStorageEnabled: function sessionStorageEnabled() {
        return this.storageEnabled('sessionStorage');
    },

    localStorageEnabled: function localStorageEnabled() {
        return this.storageEnabled('localStorage');
    },

    params: function params(string) {

        if (typeof string !== 'string') {
            string = this.queryString().slice(1);
        }

        var params = {};

        if (!string) {
            return params;
        }

        if (paramCache[string]) {
            return $util.extend({}, paramCache[string]);
        }

        $util.forEach(string.split('&'), function (pair) {
            pair = pair.split('=');

            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
            }
        });

        paramCache[string] = params;

        return params;
    },

    queryString: function queryString() {
        if (window.location.search) {
            return window.location.search;
        } else {
            var string = window.location.href;
            var idx = string.indexOf('&');
            var rIdx = string.lastIndexOf('#');

            if (idx) {
                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
            }
        }
        return '';
    },

    queryStringSplice: function queryStringSplice(qs, insert, remove) {
        if (qs.indexOf('?') === 0) {
            qs = qs.slice(1);
        }

        var params = $util.extend(this.params(qs), insert);

        $util.forEach(remove, function (key) {
            delete params[key];
        });

        return '?' + this.paramToQueryString(params);
    },

    extend: function extend(obj, source) {

        if (!source) {
            return obj;
        }

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                obj[key] = source[key];
            }
        }

        return obj;
    },


    paramToQueryString: function paramToQueryString(params) {
        return this.filter(this.map(Object.keys(params).sort(), function (key) {
            if (!params[key]) {
                return;
            }

            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })).join('&');
    },

    param: function $param(name) {
        return this.params()[name];
    },

    hashParam: function hashParam(name) {
        return this.params(window.location.hash.slice(1))[name];
    },

    base64Decode: function base64Decode(encodedString) {
        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    base64Encode: function base64Encode(decodedString) {
        return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
        }
    },

    assert: function $assert(value, message, payload) {
        if (!value) {
            throw new Error(message, payload || {});
        }
    },

    map: function $map(array, method) {

        array = array || [];

        var results = void 0;

        if (array instanceof Array) {
            results = [];

            $util.forEach(array, function () {
                results.push(method.apply(this, arguments));
            });

            return results;
        } else if (array instanceof Object) {

            results = {};

            $util.forEach(array, function (val, key) {
                results[key] = method.apply(this, arguments);
            });

            return results;
        } else {
            throw new Error('$util.map expects array or object');
        }
    },

    filter: function $filter(array, method) {
        method = method || Boolean;
        var results = [];

        $util.forEach(array, function (item) {
            if (method.apply(this, arguments)) {
                results.push(item);
            }
        });

        return results;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#find()
     * If you have an object, use the lodash or underscore .find() method
     *
     * @deprecated
     */
    find: function $find(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
        }

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return array[i];
            }
        }
    },

    findIndex: function $find(array, method) {

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return i;
            }
        }
    },

    range: function range(start, end) {
        if (!end) {
            end = start;
            start = 0;
        }

        var result = [];

        for (var i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    },

    pad: function $pad(string, n, char) {

        n = n || 0;
        char = char || '0';

        var padding = Array(n + 1).join(char.toString());

        return (padding + string).slice(-n);
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
     * the return value of $util.some() isn't always a Boolean. It's return value
     * is whatever the passed callback returns. If you are using $util.some to
     * find an object in an array then you need to use $util.find instead of Array#some().
     * Ex:
     *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
     *          preferredCard will be the preferred card object or undefined if there isn't a
     *          preferred card.
     *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
     *          Taking the code from #1 and simply swapping out $util.some for Array#some()
     *          will result in a different return value, in this case the Boolean true if
     *          there is a preferred card, otherwise false. In this case, instead of using
     *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
     *          as seen below:
     *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
     *
     * If you have an object, use the lodash or underscore .some() method
     *
     * @deprecated
     */
    some: function $some(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.');
        }

        var result = void 0;

        $util.forEach(array, function (item, key) {
            if (!result) {
                result = method(item, key);
            }
        });

        return result;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#every()
     * If you have an object, use the lodash or underscore .every() method
     *
     * @deprecated
     */
    every: function $every(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
        }

        method = method || Boolean;

        var result = true;

        $util.forEach(array, function (item) {
            if (!method(item)) {
                result = false;
            }
        });

        return result;
    },

    reduce: function $reduce(array, method, intial) {
        $util.forEach(array, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            intial = method.apply(undefined, [intial].concat(args));
        });

        return intial;
    },

    isPopup: function isPopup() {
        return _integration.$integration.isPopup();
    },

    isIFrame: function isIFrame() {
        return _integration.$integration.isIFrame();
    },

    buildURL: function buildURL(url, params) {
        /*
         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
         */
        this.assert(url, 'buildURL :: expected url');

        var paramKeys = Object.keys(params || {});

        if (JSON.stringify(params) === '{}') {
            return url;
        }

        if (!paramKeys.length) {
            return url;
        }

        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }

        url += this.paramToQueryString(params);

        return url;
    },

    paypalURL: function paypalURL(url, params) {
        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;

        return this.buildURL(url, params);
    },

    override: function override(obj, methodName, handler) {
        var existing = obj[methodName];

        obj[methodName] = function () {
            if (existing) {
                try {
                    existing.apply(obj, arguments);
                } catch (err) {
                    _logger.$logger.error(methodName + 'event_error', {
                        error: err.toString
                    });
                }
            }

            return handler.apply(obj, arguments);
        };
    },

    result: function result(method) {
        return method();
    },

    memoize: function memoize(method) {

        function memoized() {
            var key = JSON.stringify(arguments, function (_, value) {
                switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
                    case 'function':
                        throw new Error('Cannot memoize functional arguments');
                    case 'undefined':
                        return 'undefined';
                    default:
                        return value;
                }
            });

            if (!memoized.cache.hasOwnProperty(key)) {
                memoized.cache[key] = method.apply(this, arguments);
            }

            return memoized.cache[key];
        }

        memoized.cache = {};

        memoized.flush = function () {
            memoized.cache = {};
        };

        return memoized;
    },

    now: function now() {
        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
    },

    bindObject: function bindObject(obj, self) {
        return $util.map(obj, function (method) {
            return method.bind(self);
        });
    },

    hashStr: function hashStr(str) {
        var hash = 0;
        var i = void 0;
        var chr = void 0;
        var len = void 0;

        if (str.length === 0) {
            return hash;
        }
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
            // Convert to 32bit integer
            hash |= 0; // eslint-disable-line no-bitwise
        }
        return Math.abs(hash);
    },

    hash: function hash() {
        return this.hashStr(Math.random());
    },

    popup: function popup(name, url, options, callback) {

        callback = $util.once(callback);

        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
            return key + '=' + options[key];
        }).join(', '));

        var interval = void 0;

        function checkWindowClosed() {
            if (win.closed) {
                clearInterval(interval);
                callback();
            }
        }

        interval = setInterval(checkWindowClosed, 50);
        setTimeout(checkWindowClosed);

        try {
            var close = win.close;

            win.close = function () {
                close.apply(this, arguments);
                checkWindowClosed();
            };
        } catch (err) {
            // pass
        }

        return win;
    },

    unique: function unique(collection) {
        return collection.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    monkeyPatch: function monkeyPatch(mod, prop, method) {
        var original = mod[prop];

        mod[prop] = function () {
            var _this = this,
                _arguments = arguments;

            return method.call(this, arguments, function (self, args) {
                if (original) {
                    return original.apply(self || _this, args || _arguments);
                }
            });
        };
    },
    once: function once(method) {
        var called = false;

        return function () {
            if (!called) {
                called = true;
                return method.apply(this, arguments);
            }
        };
    },
    camelToDasherize: function camelToDasherize(string) {
        return string.replace(/([A-Z])/g, function (g) {
            return '-' + g.toLowerCase();
        });
    },
    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1];
        }).toUpperCase();
    },
    dasherizeToCamel: function dasherizeToCamel(string) {
        return string.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },


    parentWindow: function parentWindow() {
        if (window.opener) {
            return window.opener;
        } else if (window.parent !== window) {
            return window.parent;
        }
    },

    hasRTL: function hasRTL(str) {
        return new RegExp('[\u0590-\u07BF]').test(str);
    },
    noop: function noop() {// eslint-disable-line no-empty-function

    },


    /**
     * @function isObject - tests to see if a passed argument is an Object. Returns `false`
     *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
     *      as well as for `null` and `Object.create(null)`
     * @param {*} o
     * @returns {boolean}
     */
    isObject: function isObject(o) {
        var oAsString = Object.prototype.toString.call(o);

        return o instanceof Object && oAsString === '[object Object]';
    },


    /**
     * @function debounce
     * @param {function} callback
     * @param {number} time
     * @returns {function}
     */
    debounce: function debounce(callback, time) {
        var timeout = void 0;

        return function () {
            var _this2 = this;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var functionCall = function functionCall() {
                return callback.apply(_this2, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
        };
    },


    /**
     * @function getProperty
     * @param {object} obj
     * @param {string} propString
     * @param {string} splitOn
     * @returns {*}
     *
     * Ex:
     *  const obj = {
     *      a: {
     *          b: {
     *              c: 'property c'
     *          },
     *          'key.with.periods': 10
     *      }
     *  };
     *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
     *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
     *  const fDefault = $util.getProperty(
     *      obj,
     *      'a.b.c.d.e.f',
     *      { default: 'default value for f' }
     *  ); // f === 'default value for f'
     *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
     */
    getProperty: function getProperty(obj) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$splitOn = options.splitOn,
            splitOn = _options$splitOn === undefined ? '.' : _options$splitOn,
            defaultValue = options['default'];


        if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
            return;
        }

        var pathArray = path.split(splitOn);
        var prop = obj[pathArray.shift()];

        while (prop && pathArray.length && this.isObject(prop)) {
            prop = prop[pathArray.shift()];
        }

        return pathArray.length || prop === undefined ? defaultValue : prop;
    }
};

var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };

function $getRedirectUrl(product, params) {
    var url = '';
    var urlParams = $util.params();

    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
    }

    url += _config.$config.urls.fallbackUrl[product];

    $util.extend(urlParams, params || {});

    // cmd is a reserved slingshot param
    if (urlParams.cmd) {
        delete urlParams.cmd;
    }

    return $util.buildURL(url, urlParams);
}

function $dispatch(product, params, stateChange) {
    $util.assert(product, 'expected product');

    _logger.$logger.log('info', 'dispatch', {
        product: product
    });

    _event.$event.emit('loading');

    var url = '';

    url = $getRedirectUrl(product, params);

    // fire an event for xo-tracking to listen to and do fpti logging
    if (stateChange) {
        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
    }

    return $util.redirect(url);
}

function $experiment(name, sample, id, loggerPayload) {

    var throttle = $util.hashStr(name + '_' + id) % 100;

    var group = void 0;

    if ($util.param(name) === 'true') {
        group = 'test_forced';
    } else if ($util.param(name) === 'false') {
        group = 'control_forced';
    } else if (throttle < sample) {
        group = 'test';
    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
        // eslint-disable-line no-extra-parens
        group = 'control';
    } else {
        group = 'throttle';
    }

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: name,
        pxp_trtmnt_id: group
    });

    _logger.$logger.info(name + '_' + group, loggerPayload || {});

    if (group === 'test' || group === 'test_forced') {
        return true;
    } else if (group === 'control') {
        return false;
    }
}

angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;

_logger.$logger;

_config.$config;

_config.$meta;

_integration.$integration;

_angular.$log;

_angular.$rootScope;

/***/ }),

/***/ "../node_modules/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _ng = __webpack_require__("../node_modules/squid/dist/ng/index.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paypal[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCurrencySymbol = exports.truncateCurrencyConversionString = undefined;
exports.roundingAndSeparators = roundingAndSeparators;
exports.formatCurrency = formatCurrency;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g'); // everything to do with currency formatting

// quick Griffin reference on currency format:
// ¤ : Currency Symbol = $
// # : Amount = 186432.431
// C : Currency Code = USD

var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
var ENDS_IN_WHITESPACE = new RegExp('\s$');
var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex

// This seems to be the only currency / locale specific exception in Griffin
var STYLE_EXCEPTION = {
    'tr TR TRY': '# ¤;-# ¤'
};

var AmountOnlyStyle = '#;-#'; // A currency style for number only. $9USD -> 9.00

// Griffin exceptions for separators at hundreds- xx,xx,xxx format
var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];

var isObject = function isObject(param) {
    return Object.prototype.toString.call(param) === '[object Object]';
};

// Griffin "fuzzy logic"
// apparently if the symbol is at least "66% similar" to the code, ignore it
function maybeIgnoreSymbol(style, symbol, code) {

    // THIS IS NOT COMMUTATIVE
    function fuzzyMatch(code, symbol) {
        // eslint-disable-line no-shadow
        if (code === symbol) {
            return 100;
        } else {
            var codeParts = code.split('');
            var symbolParts = symbol.split('');
            var equivalency = codeParts.reduce(function (equiv, codePart) {
                var symbolPos = symbolParts.indexOf(codePart);

                if (symbolPos !== -1) {
                    symbolParts.splice(symbolPos, 1);
                    return equiv + 1;
                }
                return equiv;
            }, 0);
            var weight = equivalency / codeParts.length;

            return weight * 100;
        }
    }

    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;

    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
}

// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
// and thousand separators
function roundingAndSeparators(amountString, _ref, _ref2) {
    var lang = _ref.lang,
        country = _ref.country;
    var decimalPlaces = _ref2.decimalPlaces,
        dot = _ref2.dot,
        comma = _ref2.comma;

    var value = parseFloat(amountString);
    var truncate = decimalPlaces === 0;
    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
    var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
    var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
    var decimalString = amountParts[1] || '00';

    return truncate ? wholeString : '' + wholeString + dot + decimalString;
}

// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
function forceCodeToRight(style) {
    var parts = CODE_IN_FRONT.exec(style) || [];
    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
    var newStyle = style;

    // if CODE_IN_FRONT regex matches, array indexes -
    // [1] negative symbol plus whitespace, if any,
    // [2] the "C" plus any whitespace,
    // [3] whatever is after "C"
    if (parts.length === 4) {
        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
    }

    return newStyle;
}

// deal with
// 1. exceptions for specific locales
// 2. positive and negative styles
// 3. griffin fuzzy logic
// 4. UED consistency logic
function getFinalStyle() {
    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
    var _ref3 = arguments[1];
    var lang = _ref3.lang,
        country = _ref3.country;
    var _ref4 = arguments[2];
    var value = _ref4.value,
        _ref4$symbol = _ref4.symbol,
        symbol = _ref4$symbol === undefined ? '' : _ref4$symbol,
        code = _ref4.code;

    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
    var currencyStyle = exception || styleString;

    var _currencyStyle$split = currencyStyle.split(';'),
        positiveStyle = _currencyStyle$split[0],
        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;


    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions

    return forceCodeToRight(griffinStyle);
}

// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
// and produce the final result.
//
// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
    var symbol = _ref5.symbol,
        code = _ref5.code,
        _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
        wrapCodeInSpan = _ref5$wrapCodeInSpan === undefined ? false : _ref5$wrapCodeInSpan;

    // the style will take care of negative symbol (see getFinalStyle function above)
    var absoluteAmountFormatted = amountFormatted.replace('-', '');

    // parallel operation is safer than serial replace
    return finalStyle.split('').map(function (char) {
        switch (char) {
            case 'C':
                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
            case '¤':
                return symbol;
            case '#':
                return absoluteAmountFormatted;
            default:
                return char;
        }
    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
}

/**
 * @function formatCurrency
 * @param {string|number} amount Amount can be a string or a number
 * @param {string} code
 * @param {boolean} wrapCodeInSpan
 * @param {string} [style=SymbolISOCurrency]
 * @returns {string} formatted currency string
 */
function formatCurrency(amount, code, wrapCodeInSpan) {
    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';

    if (isObject(amount) || typeof amount === 'undefined' || amount === null) {
        return;
    }

    var _ref6 = _locale.$locale.metadata || {},
        _ref6$number = _ref6.number,
        numberConfig = _ref6$number === undefined ? {} : _ref6$number,
        _ref6$currency = _ref6.currency,
        currencyConfig = _ref6$currency === undefined ? {} : _ref6$currency;

    var _currencyConfig$digit = currencyConfig.digits,
        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
        _currencyConfig$style = currencyConfig.styles,
        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
        _currencyConfig$suppo = currencyConfig.supportedSymbols,
        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;

    var value = parseFloat(amount);

    styles.AmountOnlyStyle = AmountOnlyStyle;
    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, { decimalPlaces: digits[code], dot: dot, comma: comma });

    if (code) {
        var symbol = currencySymbols[code];
        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });

        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
    }

    return amountFormatted; // HTML?
}

/**
 * @function truncateCurrencyConversionString
 * @description Takes a fullString, amount, and amountForex and truncates
 *      the number in the full string to number of digits in amountForex.
 *      This function is used to format the PayPal currency conversion
 *      rate that is displayed to the user (e.g. '1 CAD = $0.7459 USD')
 *      e.g. inputs of:
 *          fullString = '$0.745994235 USD'
 *          amount = '0.745994235'
 *          amountForex = '0.7459'
 *      results in an output of '$0.7459 USD'
 * @param {object} Contains keys 'fullString', 'amount', and 'amountForex'
 * @returns {string}
 */
var truncateCurrencyConversionString = exports.truncateCurrencyConversionString = function truncateCurrencyConversionString() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fullString = _ref7.fullString,
        amount = _ref7.amount,
        amountForex = _ref7.amountForex;

    var allArgsAreStrings = [fullString, amount, amountForex].every(function (s) {
        return typeof s === 'string';
    });

    if (!allArgsAreStrings) {
        return fullString || '';
    }

    // Some countries, e.g. France, use commas instead of decimals
    var target = amountForex.includes(',') ? amount.replace('.', ',') : amount;

    return fullString.replace(target, amountForex);
};

/**
 * @description takes a currency code and
 *  returns either a code or a symbol based
 *  on our currency mapping.
 *  eg: USD -> $ , RUB -> RUB
 *
 * @param {*} code
 * @returns {string}
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(code) {
    var _ref8 = _locale.$locale.metadata || {},
        _ref8$currency = _ref8.currency,
        currency = _ref8$currency === undefined ? {
        supportedSymbols: {}
    } : _ref8$currency;

    return currency.supportedSymbols[code];
};

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$feature = $feature;
exports.$featureCountries = $featureCountries;

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

function $feature(prop, def, country) {

    var features = _core.$config.features || {};

    country = country || _locale.$locale.country;
    // 1. Check the feature is present in country
    var result = _core.$Class.get(features[country], prop);

    if (result !== undefined) {
        return result;
    }
    // 2. Check the feature is present in feature group

    Object.keys(_core.$config.regions).some(function (region) {
        if (_core.$config.regions[region].indexOf(country) !== -1) {
            result = _core.$Class.get(features[region], prop);
            return result !== undefined;
        }

        return false;
    });

    if (result !== undefined) {
        return result;
    }
    // 3. Check the feature is present in default group
    result = _core.$Class.get(features.DEFAULT, prop);

    if (result !== undefined) {
        return result;
    }
    return def;
}

// Build a list of all countries in our feature list and regions
// populate countries with out REGION names in the list
var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
});

// populate all the region countries in to allcountries
_core.$util.forEach(_core.$config.regions, function (countries, region) {
    _core.$util.forEach(countries, function (country) {
        if (allCountries.indexOf(country) === -1) {
            allCountries.push(country);
        }
    });
});

function $featureCountries(prop) {
    // Find the countries with a certain feature enabled
    return allCountries.filter(function (country) {
        return $feature(prop, false, country);
    });
}

angular.value("$feature", $feature);
angular.value("$featureCountries", $featureCountries);
_core.$config;

_core.$Class;

_core.$util;

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _currency[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/locale/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _name = __webpack_require__("../node_modules/squid/dist/locale/name.js");

Object.keys(_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _name[key];
    }
  });
});

var _quantity = __webpack_require__("../node_modules/squid/dist/locale/quantity.js");

Object.keys(_quantity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _quantity[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
exports.sanitize = sanitize;
exports.Content = Content;
exports.$contentVersion = $contentVersion;
exports.$renderContent = $renderContent;
exports.$flushContent = $flushContent;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");

function sanitize(html) {
    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
} /* eslint-disable no-use-before-define */


var JSONStringify = JSON.stringify;

JSON.stringify = function (item) {
    if (item instanceof Content) {
        return item.toString();
    }
    return JSONStringify.apply(this, arguments);
};

function Content(key, props) {
    this.key = key;
    this.props = props;
}

Content.cache = {};

Content.get = function (key, props) {

    if (!key) {
        return '';
    }

    props = props || {};

    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
    var cacheVal = Content.cache[cacheKey];

    if (cacheVal !== undefined) {
        return cacheVal;
    }

    cacheVal = Content.cache[cacheKey] = new Content(key, props);

    return cacheVal;
};

Content.prototype.toString = Content.prototype.valueOf = function () {
    if (this.string) {
        return this.string;
    }

    this.string = this.render(false);

    return this.string;
};

Content.prototype.toSafeString = function () {
    if (this.safeString) {
        return this.safeString;
    }

    this.safeString = this.render(true);

    return this.safeString;
};

Content.prototype.render = function (safe) {
    var _this = this;

    if (!this.key) {
        return '';
    }

    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
    var keys = this.key.split('.');

    for (var i = 0; i < keys.length; i++) {
        if (value) {
            value = value[keys[i]];
        } else {
            break;
        }
    }

    if (!value) {
        return '';
    }

    return value.replace(/\{\w+\}/g, function (prop) {
        prop = prop.slice(1, prop.length - 1);

        if (prop === 'country') {
            return $locale.country;
        }

        if (prop === 'lang') {
            return $locale.lang;
        }

        if (!_this.props[prop]) {
            if (!_core.$loader.isLoading()) {
                _logger.$logger.warn('missing_content_prop', {
                    key: _this.key,
                    prop: prop
                }, { unique: true });
            }

            return '';
        }

        var propStr = _this.props[prop].toString();

        if (safe) {
            return sanitize(propStr);
        }

        return propStr;
    });
};

var contentCache = {};
var currentVersion = void 0;

window.addContent = function (country, lang, content, version) {
    var countryCache = contentCache[country] = contentCache[country] || {};

    countryCache[lang] = content;
    currentVersion = version;
};

var metadataCache = {};

window.addMetadata = function (country, lang, metadata) {
    var metadataVersion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';

    var countryCache = metadataCache[country] = metadataCache[country] || {};

    countryCache[lang] = countryCache[lang] || {};
    countryCache[lang][metadataVersion] = metadata;
};

function $contentVersion() {
    return currentVersion || '';
}

var PP_SPECIAL_COUNTRIES_ISO_CODES = {
    C2: 'CN'
};

var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/locales/:countryCode/:lang',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                    _logger.$logger.info('cached_content');
                    return contentCache[model.countryCode][model.lang];
                }

                _logger.$logger.info('retrieve_content', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
                            _logger.$logger.info('content_retrieved');
                            return contentCache[model.countryCode][model.lang];
                        }

                        throw new Error('content_not_available');
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (content) {
                model.setProperties(content);
                return content;
            });
        }
    }),

    change: function change(country, lang) {

        if (country === this.countryCode && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        this.countryCode = country;
        this.lang = lang;

        return this.reload().then(function () {
            _core.$event.broadcast('contentChange');
        });
    }
});

var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {

    api: new _core.$Api({

        baseURI: _core.$meta.staticUrl,
        uri: '/metadata/:country/:lang/:version?/metadata',
        ext: 'js',

        retrieve: function retrieve(options) {
            var self = this;
            var model = options.model;

            var uri = self.getURI(model);

            return _core.$promise.resolve().then(function () {

                var metadataVersion = model.version || 'default';

                if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                    _logger.$logger.info('cached_metadata');
                    return metadataCache[model.country][model.lang][metadataVersion];
                }

                _logger.$logger.info('retrieve_metadata', {
                    uri: uri
                });

                _core.$event.emit('loading');

                return _core.$promise.attempt(3, function () {
                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
                        if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
                            _logger.$logger.info('metadata_retrieved', {
                                uri: uri
                            });
                            return metadataCache[model.country][model.lang][metadataVersion];
                        }

                        // Retry if not found in cache
                        _logger.$logger.info('metadata_not_available', {
                            uri: uri
                        });
                        return _core.$promise.reject(new Error('metadata_not_available'));
                    });
                })['catch'](function (err) {
                    throw err;
                })['finally'](function () {
                    _core.$event.emit('loaded');
                });
            }).then(function (metadata) {
                model.setProperties(metadata);
                return metadata;
            });
        }
    }),

    setVersion: function setVersion(country, lang) {
        var _this2 = this;

        var versionPxpName = _core.$config.features[country] && _core.$config.features[country].metadataVersionName;

        if (versionPxpName && _core.$config.metadataPxpExperiments[versionPxpName]) {
            var pxp = (0, _paypal.$pxp)(_core.$config.metadataPxpExperiments[versionPxpName].experimentName, {
                'ctx.COUNTRY': country,
                'ctx.LANGUAGE': lang
            }, _core.$config.metadataPxpExperiments[versionPxpName].experimentTreatmentName);

            return pxp.then(function (treatment) {
                if (treatment) {
                    _this2.version = versionPxpName;
                    _logger.$logger.info('metadata_version_set', {
                        country: country,
                        lang: lang,
                        version: versionPxpName
                    });
                } else {
                    delete _this2.version;
                }
            })['catch'](function () {
                delete _this2.version;
            })['finally'](function () {
                return _core.$promise.resolve();
            });
        } else {
            delete this.version;
            return _core.$promise.resolve();
        }
    },

    change: function change(country, lang) {
        var _this3 = this;

        this.country = country;
        this.lang = lang;

        return this.setVersion(country, lang).then(function () {
            return _this3.reload().then(function () {
                if (!_this3.noBroadcast) {
                    _core.$event.broadcast('metadataChange');
                }
            });
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (_core.$config.supportedCountries) {
            if (!_core.$config.supportedCountries[country]) {
                country = this.country;
            }

            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
                lang = _core.$config.supportedCountries[country][0];
            }
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    normalizeAddressFields: function normalizeAddressFields(content) {

        var CONTENT_MAPPING = {
            line1Label: 'streetAddress',
            line2Label: 'streetAddress2',
            cityLabel: 'city',
            stateLabel: 'state',
            postcodeLabel: 'postalCode'
        };

        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
        for (var prop in CONTENT_MAPPING) {
            if (this.addressEntry && this.addressEntry.strings[prop]) {
                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
            }
        }
    }
});

function mapLanguage(lang) {
    var unselectableLanguages = _core.$config.unselectableLanguages || [];

    if (unselectableLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            return 'en';
        }
    }

    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];

    if (unsupportedLanguages.indexOf(lang) !== -1) {
        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
            var s = lang + '_locale_not_supported';

            throw new Error(s);
        }
    }

    return lang;
}

var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
    api: new _core.$Api({
        uri: '/api/locale'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.content = $ContentModel.instance();
        this.metadata = $MetadataModel.instance();
    },

    retrieve: function retrieve() {
        var self = this;

        return this._super.retrieve.apply(this, arguments).then(function (result) {
            self.lang = mapLanguage(self.lang);
            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {

                // TODO: This at build time... or make sure griffin metadata is complete
                self.metadata.normalizeAddressFields(self.content);

                return result;
            });
        });
    },

    change: function change(country, lang) {

        var self = this;

        lang = mapLanguage(lang);

        if (country === this.country && lang === this.lang) {
            return _core.$promise.resolve(this);
        }

        _logger.$logger.info('locale_change', {
            country: country,
            lang: lang
        });

        this.country = country;
        this.lang = lang;

        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {

            // TODO: This at build time... or make sure griffin metadata is complete
            self.metadata.normalizeAddressFields(self.content);

            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
            return loadedData;
        });
    },

    choose: function choose(country, lang, override) {

        if (country && (!this.chosenCountry || override !== false)) {
            this.chosenCountry = country;
        }

        if (lang && (!this.chosenLang || override !== false)) {
            this.chosenLang = lang;
        }

        country = this.chosenCountry || this.country;
        lang = this.chosenLang;

        if (!_core.$config.supportedCountries[country]) {
            country = this.country;
        }

        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
            lang = _core.$config.supportedCountries[country][0];
        }

        if (!lang) {
            lang = this.lang;
        }

        return this.change(country, lang);
    },

    chooseCountry: function chooseCountry(country) {
        return this.choose(country, null);
    },

    chooseLang: function chooseLang(lang) {
        return this.choose(null, lang);
    },

    getLocaleCode: function getLocaleCode() {
        return this.lang + '_' + this.country;
    },

    getCountryCodeISO: function getCountryCodeISO() {
        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
    }
});

var $locale = exports.$locale = $LocaleModel.instance();

function $renderContent(key, props) {
    return Content.get(key, props);
}

function $flushContent() {
    contentCache = {};
    Content.cache = {};
    $locale.content = $ContentModel.create();
    $locale.metadata = $MetadataModel.create();
    metadataCache = {};
}

var $localeHelper = exports.$localeHelper = {
    /**
     *
     * @param locale - Ex: en_US
     * @returns {{country: *, dialect}}
     */
    normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
            return {};
        }

        locale = locale.replace('-', '_');

        var country = void 0;
        var language = void 0;

        if (locale.match(/^\w{2}_\w{2}$/)) {
            locale = locale.split('_');

            language = locale[0];
            country = locale[1];
        } else {
            language = locale;
        }

        return {
            country: country,
            language: language
        };
    }
};

angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$flushContent", $flushContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;

_core.$event;

_core.$Model;

_core.$Api;

_core.$meta;

_core.$promise;

_core.$config;

_core.$loader;

_core.$dom;

_paypal.$pxp;

/***/ }),

/***/ "../node_modules/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
    givenName: 'first_name',
    surname: 'last_name'
};

// Taken from griffin-paypal: test if a string is Latin
function isLatin(str) {
    if (!str) {
        return true;
    }

    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 0x24F) {
            return false;
        }
    }

    return true;
}

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
    var layoutMetadata = _locale.$locale.metadata.nameInformal;
    var layout = null;

    if (!layoutMetadata) {
        return name.first_name || null; // Default to first name if metadata not loaded
    }

    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
        layout = layoutMetadata['latinLayout'];
    } else {
        layout = layoutMetadata['layout'];
    }

    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
    var formattedName = [];

    for (var i = 0; i < layout.length; i++) {
        var namePart = layout[i];

        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
        } else if (namePart['$'] === 'separator') {
            formattedName.push(namePart._);
        }
    }

    return formattedName.join('');
}

_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatQuantity = formatQuantity;

var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");

var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");

// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
    var _ref = _locale.$locale.metadata || {},
        _ref$number = _ref.number,
        numberConfig = _ref$number === undefined ? {} : _ref$number;

    var dot = '';
    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;

    return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, { decimalPlaces: 0, dot: dot, comma: comma });
}

_locale.$locale;

_currency.roundingAndSeparators;

/***/ }),

/***/ "../node_modules/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Component = undefined;
exports.$populate = $populate;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

(0, _directive.$registerDirective)('prevent-default', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click', function (event) {
                event.preventDefault();
            });
        }
    };
});

(0, _directive.$registerDirective)('stop-propagation', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click keydown keypress keyup', function (event) {
                event.stopPropagation();
            });
        }
    };
});

(0, _directive.$registerDirective)('validate-submit', function () {

    return {
        link: function link($scope, $element, $attrs) {

            var $form = $element.closest('form');
            var form = $scope[$form.prop('name')];
            var formID_element = $attrs.form; // take the form attribute from submit button
            var formID_linked = $element[0] // take the id from the linked form element
            && $element[0].form && $element[0].form.id;
            var isLinkedForm = formID_element && formID_element === formID_linked; // Checking for confirmation. May not be required. Presence should be good enough.

            if (isLinkedForm) {
                $form = angular.element(document.getElementById(formID_linked));
                var scope = $form.scope(); // Linked forms should mantain form scope

                form = scope[$form.prop('name')];
            }

            $element.on('click', function (event) {
                event.preventDefault();

                $form.addClass('validated');
                $scope.validated = true;
                form.$setSubmitted();

                if (form.$valid) {
                    try {
                        $scope.$eval($attrs.validateSubmit);
                    } catch (err) {
                        _angular.$injector.get('$exceptionHandler')(err);
                    }
                } else {
                    $form.find('.ng-invalid:first').focus();
                }
            });
        }
    };
});

function assertModelsRetrievedOrEmpty(items) {
    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
        angular.forEach(items, function (item, name) {
            if (item instanceof _core.$Model) {
                if (item.meta.populated) {
                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
                }
            }
        });
    }
}

function setUpComponentRoute($scope, $Component, angular) {
    var componentRoute = $scope.componentRoute;

    componentRoute.scope = $scope;

    componentRoute.scope.goto = function (route) {
        componentRoute.goto(route);
    };

    var parentRoute = componentRoute.parent;

    if (parentRoute) {
        var parentScope = parentRoute.scope;
        var parentDirective = parentRoute.getDirective();
        var childSpec = componentRoute.childSpec;

        if (childSpec.config) {
            if (parentDirective instanceof $Component) {
                parentScope.viewConfig = childSpec.config.call(parentScope);
            } else {
                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }

        if (childSpec.props) {
            if (parentDirective instanceof $Component) {
                angular.extend($scope, childSpec.props.call(parentScope));
            } else {
                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }
    }
}

var $Component = exports.$Component = _core.$Class.extend('$Component', {

    onPopulate: angular.noop,

    init: function init() {
        var _this = this,
            _arguments = arguments;

        this.validate();

        this.name = _core.$util.dasherizeToCamel(this.tag);

        var wrapperType = this.wrapperType === 'span' ? 'span' : 'div';

        this.template = '<' + wrapperType + ' class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</' + wrapperType + '>';

        this.scope = this.scope || {};
        this.resolve = this.resolve || {};
        this.props = this.props || {};
        this.rootEvents = this.rootEvents || {};

        this.actions = this.actions || {};

        this.lifecycle = this.lifecycle || {};
        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
        this.lifecycle.populate = this.lifecycle.populate || angular.noop;

        if (this.scope && Object.keys(this.scope).length) {

            if (this.props && Object.keys(this.props).length) {
                throw new Error('Can not defined scope and props on the same component');
            }

            this.scope.componentRoute = '=';
            this.scope['export'] = '@';

            this.props = _core.$util.map(this.scope, function (type, key) {
                return {
                    type: {
                        '=': 'var',
                        '@': 'str'
                    }[type],
                    required: false
                };
            });
        } else {

            this.props.componentRoute = {
                type: 'var',
                required: false
            };

            this.props['export'] = {
                type: 'str',
                required: false
            };

            var isRequired = function isRequired() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    required = _ref.required,
                    optional = _ref.optional;

                return [true, 'true'].indexOf(required) > -1 || [false, 'false'].indexOf(optional) > -1;
            };

            this.scope = _core.$util.map(this.props, function (spec, key) {
                return {
                    'var': isRequired(spec) ? '=' : '=?',
                    str: isRequired(spec) ? '@' : '@?'
                }[spec.type || 'var'];
            });
        }

        var originalController = this.controller || angular.noop;

        this.controller = ['$scope', '$element', function ($scope, $element) {
            $scope.$element = $element;

            $scope.$on('$destroy', function () {
                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
                    delete $scope.componentRoute.parent.scope.viewConfig;
                }
                _this.lifecycle.exit.call($scope);
            });

            $scope.props = {};

            if ($scope.componentRoute) {
                setUpComponentRoute($scope, $Component, angular);
            }

            angular.forEach(_this.props, function (type, key) {

                var prop = _this.props[key];
                var required = prop.required !== false;
                var def = void 0;

                if (prop['default'] instanceof Function) {
                    def = _core.$util.memoize(prop['default'].bind($scope));
                } else {
                    def = function def() {
                        return prop['default'];
                    };
                }

                var UNDEFINED = {
                    'var': undefined,
                    str: ''
                }[prop.type];

                Object.defineProperty($scope.props, key, {
                    get: function get() {
                        var val = $scope[key];

                        if (val === UNDEFINED) {
                            if (required) {
                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
                            }

                            return def();
                        }

                        return val;
                    },

                    set: function set() {
                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
                    }
                });
            });

            $scope.fields = {};

            $scope.actions = _core.$util.bindObject(_this.actions, $scope);

            Object.keys(_this.rootEvents).forEach(function (eventName) {
                var cancel = _core.$event.on(eventName, function (event) {
                    _this.rootEvents[eventName].apply($scope, _arguments);
                });

                $scope.$on('$destroy', cancel);
            });

            $scope.display = true;

            $scope.reload = function () {

                if (!$scope.populated) {
                    throw new Error('Can not reload unpopulated component');
                }

                $scope.display = false;
                setTimeout(function () {
                    $scope.display = true;
                });
            };

            $scope.componentScope = $scope;

            if ($scope.props['export'] && $scope.$parent.componentScope) {

                $scope.exports = angular.extend({}, _this.exports || {}, {
                    reload: $scope.reload
                });

                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
                    get: function get() {
                        return $scope.exports;
                    },

                    configurable: true
                });
            }

            $scope._enablePopulateEvents = true;

            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
            _this.lifecycle.enter.call($scope);

            $scope._enablePopulateEvents = false;

            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
                if (toState === $scope.props.componentRoute) {
                    _this.lifecycle.reenter.call($scope);
                }
            });

            $scope.$on('$destroy', cancelReEnterEvent);

            return _core.$promise.sequential([function () {
                $scope.$emit('_populating');
            }, function () {
                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {

                    if (angular.isObject(resolver)) {
                        $scope[name] = resolver;
                        return resolver;
                    }

                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
                        assertModelsRetrievedOrEmpty(data);

                        return _core.$promise.hash(data).then(function (resolvedData) {

                            $scope[name] = resolvedData;
                            return resolvedData;
                        });
                    });
                });
            }, function () {

                $scope.populated = true;

                $scope.$emit('_populated');

                _core.$event.refCount($scope, '_populating', '_populated').then(function () {

                    $scope.$on('populated', function (populatedEvent) {
                        populatedEvent.stopPropagation();
                    });

                    $scope.$emit('populated');
                    _this.onPopulate.call($scope);
                    _this.lifecycle.populate.call($scope);
                });
            }]);
        }];
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var componentName = this.constructor.name;

        if (!this.tag) {
            throw new Error(componentName + ' :: expected property \'tag\'');
        }

        if (!this.tag.match(/^[a-z0-9-]+$/)) {
            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
        }

        if (!this.template) {
            throw new Error(componentName + ' :: expected property \'template\'');
        }

        if (this.resolve) {
            angular.forEach(this.resolve, function (resolver, name) {
                if (!(resolver instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
                }
            });
        }

        if (this.props) {
            angular.forEach(this.props, function (prop, name) {

                if (!(prop instanceof Object)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
                }

                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
                }

                if (prop['default'] && prop.required) {
                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
                }

                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
                }
            });
        }

        if (this.actions) {
            angular.forEach(this.actions, function (action, name) {
                if (!(action instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
                }
            });
        }

        if (this.lifecycle) {
            Object.keys(this.lifecycle).forEach(function (name) {
                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
                }
            });
        }
    }
});

$Component.reopenClass({

    extend: function extend() {

        var SubClass = _core.$Class.extend.apply(this, arguments);
        var spec = new SubClass();

        angular.module().directive(spec.name, function () {
            return spec;
        });

        return SubClass;
    },

    render: function render(scope) {
        _core.$event.emit('$resetState');

        var $scope = _angular.$rootScope.$new();

        angular.extend($scope, scope);

        var attrs = Object.keys(scope).map(function (key) {
            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
        }.bind(this)).join(' ');

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';

        console.log('RENDER', html, scope);

        var element = (0, _angular.$compile)(html)($scope);

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            element.remove();
        }));

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        element.updateProps = function (props) {
            angular.extend($scope, props);
            $scope.$digest();
            setTimeout.flush();
        };

        return element;
    }
});

function autoConvertDirectiveToComponent(_ref2, original) {
    var name = _ref2[0],
        factory = _ref2[1];


    if (!angular.isFunction(factory)) {
        return original();
    }

    var tag = _core.$util.camelToDasherize(name);
    var spec = _angular.$injector.invoke(factory);

    if (spec.controller) {
        var originalController = spec.controller;

        spec.controller = ['$scope', '$element', function ($scope, $element) {
            $scope._enablePopulateEvents = true;
            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });

            $scope._enablePopulateEvents = false;
            return result;
        }];
    }

    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
        return original(this, [name, function () {
            return spec;
        }]);
    }

    if (spec.componentize) {

        $Component.extend('$' + name + 'Component', spec, {
            tag: tag
        });

        return this;
    }

    return original(this, [name, function () {
        return spec;
    }]);
}

_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {

    $scope.$on = $scope.$on || angular.noop;
    $scope.$emit = $scope.$emit || angular.noop;

    var _enablePopulateEvents = $scope._enablePopulateEvents;

    if (_enablePopulateEvents) {
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
            $scope.$emit('populated');
        });
    }

    $scope.$on('populated', function (populatedEvent) {
        populatedEvent.stopPropagation();
    });

    if (_enablePopulateEvents) {
        $scope.$emit('_populating');
    }

    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {

        var promise = void 0;

        if (instance.then) {
            promise = instance;
        } else {
            promise = instance.retrieve();
            $scope[name] = instance;
        }

        return promise.then(function (result) {
            $scope[name] = result;
            return result;
        });
    })).then(function (result) {

        if (_enablePopulateEvents) {
            $scope.$emit('_populated');
        }

        return result;
    });
}

angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;

_angular.$compile;

_angular.$injector;

_angular.$compileProvider;

_core.$Class;

_core.$Model;

_core.$util;

_core.$promise;

_core.$config;

_core.$event;

_ng.$cleanRootScope;

_directive.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.use({
    on: function on() {
        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
    },
    once: function once(name, handler) {
        var cancel = _core.$event.on(name, function () {
            cancel();
            handler.apply(this, arguments);
        }, true);

        return cancel;
    },
    emit: function emit() {
        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
    },
    broadcast: function broadcast() {
        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
    }
});

_core.$promise.use(_angular.$q);

_angular.$q;

_angular.$rootScope;

_core.$event;

_core.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$registerDirective = $registerDirective;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function $registerDirective(tag, definition) {

    var directiveName = tag.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });

    return _angular2["default"].module().directive(directiveName, definition);
}

_angular2["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "../node_modules/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

angular.module().run(function () {

    _core.$event.on('$stateChangeStart', function (event) {
        _core.$event.emit('loading');
        _core.$event.emit('loaded');
    });

    var startLoadTime = 0;
    var currentState = 'checkout_init';

    function currentStateName() {
        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
    }

    _core.$event.on('startLoad', function () {

        if (startLoadTime) {
            startLoadTime = _core.$util.now();
        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {

            var performance = window.performance;
            var timing = window.performance.timing || {};
            var now = performance.now();

            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
    });

    _core.$event.on('allLoaded', function () {

        var newState = currentStateName();

        if (!newState) {
            return;
        }

        if (currentState === newState) {
            _core.$event.emit('page_reloaded', currentState);
        } else {

            var duration = void 0;

            if (startLoadTime) {
                duration = _core.$util.now() - startLoadTime;
            }

            var payload = {
                start: currentState,
                end: newState,
                time: duration,
                duration: duration
            };

            _core.$event.emit('$transition', {
                from: currentState,
                toState: _uiRouter.$state.current,
                duration: duration
            });

            _logger.$logger.info('transition', payload);
            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);

            _core.$event.emit('page_loaded', currentState, newState);
            _logger.$logger.flush();

            currentState = newState;
        }
    });

    _core.$event.emit('loading');

    var cancel = _core.$event.on('$stateChangeSuccess', function () {
        if (_uiRouter.$state.current.template) {
            cancel();
            setTimeout(function () {
                _core.$event.emit('loaded');
            }, 50);
        }
    });
});

_uiRouter.$state;

_logger.$logger;

_core.$event;

_core.$util;

/***/ }),

/***/ "../node_modules/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {



var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

(0, _directive.$registerDirective)('feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
            };
        }
    };
});

(0, _directive.$registerDirective)('unless-feature', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {},
        template: '<span ng-if="!enabled()" ng-transclude></span>',
        link: function link($scope, element, attr) {
            $scope.enabled = function () {
                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
            };
        }
    };
});
_directive.$registerDirective;

_locale.$feature;

_core.$integration;

/***/ }),

/***/ "../node_modules/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _core = __webpack_require__("../node_modules/squid/dist/ng/core.js");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _route = __webpack_require__("../node_modules/squid/dist/ng/route.js");

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _component[key];
    }
  });
});

var _feature = __webpack_require__("../node_modules/squid/dist/ng/feature.js");

Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _feature[key];
    }
  });
});

var _locale = __webpack_require__("../node_modules/squid/dist/ng/locale.js");

Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locale[key];
    }
  });
});

var _module = __webpack_require__("../node_modules/squid/dist/ng/module.js");

Object.keys(_module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _module[key];
    }
  });
});

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ng[key];
    }
  });
});

var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});

var _events = __webpack_require__("../node_modules/squid/dist/ng/events.js");

Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _events[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/ng/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

Object.keys(_lazyLoadRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lazyLoadRoutes[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/ng/lazyLoadRoutes.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.lazyLoadRoute = exports.findRelativeState = exports.initRoute = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var getHash = function getHash(url) {
    if (!url || !~url.indexOf('#')) {
        // eslint-disable-line no-bitwise
        return;
    }

    url = url.split('#');
    return url[url.length - 1];
};

/**
 *
 * get parent state, e.g "checkout.sidebar.addCard" -> "checkout.sidebar"
 */
var getParentState = function getParentState(path) {
    return _uiRouter.$state.get(path.slice(0, path.lastIndexOf('.')));
};

/**
 * Find route by slug
 * path - full path of the current route, e.g "checkout.payWithSelection"
 * slug - path of the route that we want to search, e.g "payWithSelection"
 */
var getRoute = function getRoute(path, slug) {
    var route = getParentState(path);

    if (!route) {
        return;
    }
    var children = route.children;

    if (children) {
        return children.find(function (child) {
            return child.slug === slug;
        });
    }
};

/**
 * Lazy load children routes in the background
 */
var lazyLoadChildren = function lazyLoadChildren(children) {
    if (children) {
        _logger.$logger.info('lazy_loading_route_load_children');
        children.forEach(function (child) {
            if (child.lazyRoute) {
                // request to download js chunk (dynamic import)
                child.lazyRoute();
            }
        });
    }
};

/**
 * Dynamically load route and initialize / register it
 * @param {Object} routeObj - route object from Route definition, e.g
 *  {
 *      name: '$PayWithSelection',
 *      slug: 'payWithSelection',
 *      lazyRouter: () => import('pages/payWithSelection/route)
 *  }
 *
 * @param {Route} parent - parent of the passed routeObj
 * @param {String} fullRoutePath - full path of the route, e.g "checkout.payWithselection"
 */
var initRoute = exports.initRoute = function initRoute(routeObj, parent, fullRoutePath) {
    if (!routeObj) {
        return;
    }

    var name = routeObj.name,
        slug = routeObj.slug,
        attributes = routeObj.attributes,
        lazyRoute = routeObj.lazyRoute;


    _logger.$logger.info('lazy_loading_route_init', {
        name: name,
        slug: slug,
        fullRoutePath: fullRoutePath
    });

    return lazyRoute().then(function (route) {
        if (!route) {
            return;
        }
        if ((typeof route === 'undefined' ? 'undefined' : _typeof(route)) === 'object') {
            route = route[name];
        }
        var childRoute = new route({ //eslint-disable-line
            parent: parent || getParentState(fullRoutePath),
            childSpec: _core.$util.extend(routeObj, { route: route }),
            childAttributes: attributes
        });
        childRoute.register();
        return childRoute;
    });
};

/**
 * Promisify all lazy routes
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes
 *      1. Go through each possible route, e.g 'checkout', 'checkout.sidebar', 'checkout.sidebar.addCardFlow', 'checkout.sidebar.addCardFlow.addCard'
 *      2. Check if each exists / already registered
 *      3. if route is not registered -> find that route and return promise
 * @param {String} targetState full path of the target route
 * Returns an array of promisified functions
 */
var findAndPromisifyRoutes = function findAndPromisifyRoutes(targetState) {
    var splittedTargetState = targetState.split('.');
    var states = splittedTargetState.slice(1);
    var routes = [];
    var path = splittedTargetState[0];

    states.forEach(function (state) {
        path += '.' + state;
        var fullRoutePath = path;

        if (!_uiRouter.$state.get(path)) {
            routes.push(function (parent) {
                var route = getRoute(fullRoutePath, state);

                return initRoute(route, parent, fullRoutePath);
            });
        }
    });
    return routes;
};

/**
 * Checks if it's a relative path (having `.` or `^`)
 * @param {String} stateName - path of the state, e.g `.mychildRoute`
 */
var isRelative = function isRelative(stateName) {
    return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
};

/**
 * finds a full path of the relative state name
 * examples:
 * '^' - will go to a parent state
 * '^.sibling' - will go to a sibling state
 * '.child.grandchild' - will go to grandchild state
 * @param {String / Object} stateOrName - state to find, e.g `^.selectFi`
 * Returns full path name of the state, e.g `^.selectFi` -> `checkout.selectFi`
 */
var findRelativeState = exports.findRelativeState = function findRelativeState(stateOrName) {
    if (!stateOrName) {
        return;
    }
    var base = _uiRouter.$state.current;

    var rel = stateOrName.split('.');
    var current = base;
    var i = 0;

    for (; i < rel.length; i++) {
        if (rel[i] === '' && i === 0) {
            current = base;
            continue;
        }
        if (rel[i] === '^') {
            if (!current.parent) {
                throw new Error('lazy-loading: path \'' + stateOrName + '\' not valid for state \'' + base.name + '\'');
            }
            current = current.parent;
            continue;
        }
        break;
    }
    rel = rel.slice(i).join('.');
    return current.name + (current.name && rel ? '.' : '') + rel;
};

/**
 * Lazy load route and redirect if successfull or reject if route was not found
 * Note: routes will be loading sequentialy for now to load parent routes first if they are lazy as well.
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes and represent separate js chunk
 *      We have to load each js chunk in order one by one to be able to register them and attach to corresponding parents.
 * @param {String} targetState - route path, e.g 'checkout.payWithSelection'
 * @param {Object} targetParams - params which route may need
 * @param {Boolean} shouldChangeState - if state should be changed after route is loaded
 */
var lazyLoadRoute = exports.lazyLoadRoute = function lazyLoadRoute(targetState) {
    var targetParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shouldChangeState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!targetState) {
        return _core.$promise.reject(new Error('lazy_loading_target_state_is_empty'));
    }
    _logger.$logger.info('lazy_loading_route', {
        targetState: targetState,
        targetParams: targetParams
    });
    if (isRelative(targetState)) {
        targetState = findRelativeState(targetState, _uiRouter.$state.current);
    }
    _core.$event.emit('loading');

    var routes = findAndPromisifyRoutes(targetState);

    return _core.$promise.sequential(routes).then(function (result) {
        if (_uiRouter.$state.get(targetState)) {
            if (result) {
                lazyLoadChildren(result.children);
            }
            _logger.$logger.info('lazy_loading_route_state_change', {
                targetState: targetState,
                targetParams: targetParams
            });
            if (!shouldChangeState) {
                return _core.$promise.resolve();
            }
            return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                if (err.message === 'transition prevented' || err.message === 'transition superseded') {
                    return _core.$promise.resolve();
                }
                return _core.$promise.reject(err);
            });
        } else {
            return _core.$promise.reject(new Error('lazy_loading_state_was_not_loaded'));
        }
    })['catch'](function (error) {
        // in case of exceptions, spinner must dissapear, because for each 'loading' event
        // that's sent in the beginning of the function must be corresponding 'loaded' event
        // otherwise, there will be infinite spinner

        _logger.$logger.info('lazy_loading_route_error', {
            targetState: targetState,
            targetParams: targetParams,
            errorMessage: error && error.message,
            errorStack: error && error.stack
        });

        return _core.$promise.reject(error);
    })['finally'](function () {
        _core.$event.emit('loaded');
    });
};

/**
 * mostly needed for use cases when user types route manually
 */
window.addEventListener('hashchange', function (event) {
    if (_config.$meta.codeSplitting) {
        var fromHash = getHash(event.oldURL);
        var toHash = getHash(event.newURL || window.location.hash);

        // skip lazy loading in case hash is undefined or empty
        // example -> <a href="#" ng-click="openModal()">OpenModal</a>
        // in that case `toHash` will be empty
        if (!toHash) {
            return;
        }

        var getHashQueryParams = function getHashQueryParams(path) {
            var splittedPath = path.split('?');
            // e.g #/checkout/genericError?code=ERROR_CODE -> code=ERROR_CODE
            var hashParams = splittedPath.length > 1 && splittedPath[1];

            if (hashParams) {
                // e.g code=ERROR_CODE -> { code: ERROR_CODE }
                return _core.$util.params(hashParams);
            }
        };
        // e.g #/checkout/review -> checkout.review
        var path = toHash.slice(1).replace(/\//g, '.');
        var hashQueryParams = getHashQueryParams(path);

        if (hashQueryParams) {
            // e.g checkout.genericError?code=ERROR_CODE -> checkout.genericError
            path = path.split('?')[0];
        }

        if (_uiRouter.$state.get(path)) {
            return;
        }

        _logger.$logger.info('hashchange_lazy_loading', {
            from: fromHash,
            to: toHash
        });

        lazyLoadRoute(path, hashQueryParams)['catch'](function () {
            _logger.$logger.info('hashchange_lazy_loading_error', {
                from: fromHash,
                to: toHash,
                params: hashQueryParams
            });
        });
    }
});

_uiRouter.$state;

_logger.$logger;

_core.$util;

_core.$promise;

_core.$event;

_config.$meta;

/***/ }),

/***/ "../node_modules/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

(0, _angular.$registerDirective)('content', function () {
    return {
        restrict: 'A',

        link: function link($scope, element, attributes) {
            $scope.content = $scope.htmlContent = function (key, props) {
                if (attributes.content) {
                    key = attributes.content + '.' + key;
                }
                var content = _locale.Content.get(key, props);

                if (content.toString()) {
                    return content;
                } else {
                    return;
                }
            };
        }
    };
});

(0, _angular.$registerDirective)('bind-html-compile', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $scope.$watch(function () {
                return $scope.$eval($attrs.bindHtmlCompile);
            }, function (value) {
                $element.html(value && value.toString());
                (0, _angular.$compile)($element.contents())($scope);
            });
        }
    };
});

(0, _angular.$registerDirective)('format-currency', function () {

    return {
        restrict: 'E',
        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
        scope: {
            amount: '=?',
            symbol: '=?',
            code: '=?',
            currencyStyle: '@?'
        },
        controller: ['$scope', function ($scope) {

            function format() {
                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
            }

            $scope.$on('$destroy', _core.$event.on('localeChange', format));

            $scope.$watch('amount', function (newValue, oldValue) {
                if (newValue !== oldValue && _locale.$locale.country) {
                    format();
                }
            });

            if (_locale.$locale.country) {
                format();
            }
        }] // controller
    }; // return
}); // registerDirective


(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().value('$sanitize', function (val) {
    if (val instanceof _locale.Content) {
        return val.toSafeString();
    }
    return (0, _locale.sanitize)(val);
});

_angular.$sce;

_angular.$registerDirective;

_angular.$compile;

_core.$event;

_locale.formatCurrency;

_locale.sanitize;

_locale.Content;

_locale.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/squid/dist/ng", "../node_modules/squid/dist/ng/locale.js"))

/***/ }),

/***/ "../node_modules/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.module = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = _angular2['default'].module;
exports.module = _module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$angularInvoke = $angularInvoke;
exports.$once = $once;
exports.$cleanRootScope = $cleanRootScope;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

function $angularInvoke(method) {
    try {
        return method();
    } catch (err) {
        _angular.$injector.get('$exceptionHandler')(err);
    }
}

function $once(name, handler) {
    var cancel = _core.$event.on(name, function () {
        cancel();
        handler.apply(this, arguments);
    }, true);
}

function $cleanRootScope(rootScope) {

    var keys = Object.keys(rootScope);

    var autoCleanupEventHandlers = [];
    var eventHandlers = [];
    var eventCancelers = [];

    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
        var name = _ref[0],
            handler = _ref[1],
            once = _ref[2];


        var cancel = original();

        var $state = void 0;

        try {
            $state = _angular.$injector.get('$state');
        } catch (err) {
            // pass
        }

        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
            autoCleanupEventHandlers.push(cancel);
            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
        }

        if (once) {
            eventCancelers.push(cancel);
            return cancel;
        }

        // Let ng-router do its thing
        if (handler.toString().indexOf('updateView') !== -1) {
            return cancel;
        }

        var stack = void 0;

        try {
            throw new Error('$rootScope.$on');
        } catch (err) {
            stack = err.stack;
        }

        var reference = {
            name: name,
            handler: handler.toString(),
            stack: stack
        };

        eventHandlers.push(reference);

        return function () {
            cancel();
            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
        };
    });

    return function () {

        _core.$event.emit('$destroy');

        autoCleanupEventHandlers.forEach(function (canceler) {
            return canceler();
        });
        autoCleanupEventHandlers = [];

        Object.keys(rootScope).forEach(function (key) {
            if (keys.indexOf(key) === -1) {
                delete rootScope[key];
            }
        });

        if (eventHandlers.length) {
            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
            }).join('\n\n'));
        }

        eventCancelers.forEach(function (cancel) {
            return cancel();
        });
    };
}

angular.value("$angularInvoke", $angularInvoke);
angular.value("$once", $once);
angular.value("$cleanRootScope", $cleanRootScope);
_angular.$injector;

_core.$util;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

_core.$event.on('pxp_res', function (event, pxpRes) {
    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});

_uiRouter.$state;

_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ComponentRoute = exports.$Route = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");

var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");

var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {

    childSpec: {},

    init: function init() {
        var _this = this;

        this.validate();

        this.url = '/' + (this.path || this.name);

        if (this.query) {
            this.url += '?' + this.query.join('&');
        }

        this.hasResolver = Boolean(this.resolve);

        var controller = this.controller = ['$scope', function ($scope) {
            $scope.route = _this;
            if ($scope.componentScope) {
                delete $scope.componentScope.view;
            }
        }];

        if (this.get('resolve.action')) {
            this.controller = ['$scope', 'action', function ($scope, action) {
                _angular.$injector.invoke(controller, this, { $scope: $scope });
                if (action) {
                    if (!action.newState) {
                        _angular.$location.replace();
                    }

                    if (angular.isObject(action) && action.to) {
                        _uiRouter.$state.go(action.to, action.params);
                    } else {
                        _uiRouter.$state.go(action);
                    }
                }
            }];
        }
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var routeName = this.constructor.name;

        if (!this.name && !this.path) {
            throw new Error(routeName + ' :: expected property \'path\'');
        }

        if (this.url) {
            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
        }

        if (this.query && !(this.query instanceof Array)) {
            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
        }

        if (this.controller) {
            // throw new Error(`${routeName} :: unexpected property 'controller'`);
        }

        if (this.resolve) {
            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
            }

            Object.keys(this.resolve).forEach(function (name) {
                if (name === 'data') {
                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
                } else if (name !== 'action') {
                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
                }
            });
        }

        if (this.template) {
            throw new Error(routeName + ' :: unexpected property \'template\'');
        }

        if (!this.directive && !this.resolve && !this.resolve.action) {
            throw new Error(routeName + ' :: expected property \'directive\'');
        }

        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
        }

        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
        }

        if (this.children) {
            this.children.forEach(function (childSpec) {

                if (!childSpec.route && !childSpec.name) {
                    throw new Error(routeName + ' :: child expected property \'route\'');
                }

                var ChildRoute = childSpec.route;
                var childName = childSpec.name || ChildRoute.name;

                // skip loading route as it won't be available to validate
                if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                    return;
                }

                if (!ChildRoute && childSpec.name) {
                    try {
                        ChildRoute = _angular.$injector.get(childSpec.name);
                    } catch (err) {
                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
                    }
                }

                if (!$Route.isChild(ChildRoute)) {
                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
                }
            });
        }
    },
    goto: function goto(route) {
        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
    },
    getDirective: function getDirective() {
        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
    },
    getDirectiveTag: function getDirectiveTag() {
        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
    },


    bootstrap: function bootstrap(defaultState, middleware) {
        var _this2 = this;

        return (0, _ng.$angularInvoke)(function () {
            // only bootstrap if not bootstrapped already
            var element = angular.element(document.body);

            if (!element.injector()) {
                angular.bootstrap(element, ['app']);
            }

            return _this2.load(defaultState, middleware);
        });
    },

    load: function load(defaultState, middleware) {

        defaultState = defaultState || this.defaultState;
        middleware = middleware || this.middleware;

        _logger.$logger.info('bootstrap_route', {
            route: this.path || this.name
        });

        var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
            var unfoundState = _ref.unfoundState,
                fromState = _ref.fromState,
                fromParams = _ref.fromParams,
                _ref$logName = _ref.logName,
                logName = _ref$logName === undefined ? '' : _ref$logName;

            _logger.$logger.error('state_not_found' + logName, {
                name: unfoundState.to,
                from: fromState.name,
                fromParams: fromParams,
                hash: window.location.hash
            });
            throw new Error('state_not_found' + logName + ': ' + unfoundState.to);
        };

        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (!_config.$meta.codeSplitting) {
                event.preventDefault();
                logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams });
            }
        });

        // for code splitting this event handler will be triggered every single time user tries to load lazy route
        // so we need to have it being listening more than once
        _core.$event.on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
            if (_config.$meta.codeSplitting) {
                event.preventDefault();
                // if route was not found - lazy load it or throw state_not_found if it was not found
                (0, _lazyLoadRoutes.lazyLoadRoute)(unfoundState.to, unfoundState.toParams)['catch'](function () {
                    logStateNotFoundAndThrow({ unfoundState: unfoundState, fromState: fromState, fromParams: fromParams, logName: '_lazy_loading' });
                });
            }
        });

        this.register();

        _uiRouter.$urlRouterProvider.otherwise(function () {
            return _logger.$logger.info('otherwise_after_bootstrap', {
                hash: window.location.hash
            });
        });

        this.runMiddleware(middleware).then(function () {
            var targetState = void 0;
            var targetParams = void 0;

            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {

                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');

                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
            }

            _logger.$logger.info('initializing_route', {
                target: targetState,
                defaultState: defaultState,
                hash: window.location.hash
            });

            _angular.$location.replace();

            /**
             * load default state in case target state was not found
             * e.g checkout.landing - is the default state in Hermes
             */
            var loadDefaultState = function loadDefaultState() {
                if (_uiRouter.$state.get(defaultState)) {
                    _logger.$logger.info('default_state', {
                        stateName: defaultState
                    });
                    return _uiRouter.$state.go(defaultState)['catch'](function (err) {
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: defaultState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                }

                throw new Error('Default state not found: ' + defaultState);
            };

            if (targetState) {
                var logUnknownState = function logUnknownState() {
                    var logName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    _logger.$logger.info('unknown_state' + logName, {
                        stateName: targetState
                    });
                };

                if (_uiRouter.$state.get(targetState)) {
                    _logger.$logger.info('existing_state', {
                        stateName: targetState
                    });
                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
                        // lib/js/security.js event listener handles auth required state changes
                        // and cancels transitions if user not authenticated
                        if (err.message === 'transition prevented') {
                            _logger.$logger.warn('transition_prevented', {
                                targetState: targetState
                            });
                            return _core.$promise.resolve();
                        }
                        return _core.$promise.reject(err);
                    });
                } else if (_config.$meta.codeSplitting) {
                    // try to lazy load route and catch / handle redirect errors
                    // 1. If route was not found -> log and try to load default state
                    // 2. If route was found but redirect throws an error -> reject
                    return (0, _lazyLoadRoutes.lazyLoadRoute)(targetState, targetParams)['catch'](function (err) {
                        if (err.message === 'lazy_loading_state_was_not_loaded') {
                            logUnknownState('_lazy_loading');
                            return loadDefaultState();
                        } else {
                            return _core.$promise.reject(err);
                        }
                    });
                } else {
                    logUnknownState();
                }
            }
            return loadDefaultState();
        })['catch'](function (err) {
            return _angular.$injector.get('$exceptionHandler')(err);
        });
    },

    runMiddleware: function runMiddleware(middleware) {

        _logger.$logger.info('middleware', {
            priority: _core.$util.map(middleware, function (method) {
                return method.name;
            }).join('|')
        });

        var promise = _core.$promise.resolve();

        angular.forEach(middleware, function (method) {
            promise = promise.then(function () {

                if (method.name) {
                    _logger.$logger.info('middleware_' + method.name);
                }

                return method();
            });
        });

        return promise;
    },

    register: function register() {
        var _this3 = this;

        this.template = this.constructTemplate(this.childAttributes || {});

        this.absolutePath = this.path || this.name;

        if (this.parent) {
            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
        }

        if (!_uiRouter.$state.get(this.absolutePath)) {
            _uiRouter.$stateProvider.state(this.absolutePath, this);
        }

        angular.forEach(this.children, function (childSpec) {
            // skip registering child if it's supposed to be lazy loaded
            if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
                return;
            }
            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);

            var childRoute = new ChildRoute({
                parent: _this3,
                childSpec: childSpec,
                childAttributes: childSpec.attributes
            });

            childRoute.register();
        });
    },

    /**
     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
     * '<xo-add-bank/>'.
     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
     *
     * @param attributes - A map of name value pairs - {name: value}.
     * @returns {string}
     */
    constructTemplate: function constructTemplate(attributes) {
        var self = this;

        if (!self.directive) {
            return;
        }

        attributes['component-route'] = 'route';

        if (this.parent) {
            attributes['export'] = 'view';
        }

        var tag = this.getDirectiveTag();

        var paramString = '';

        angular.forEach(attributes, function (value, key) {
            paramString += ' ' + key + '="' + value + '"';
        });

        return '<div ' + tag + ' ' + paramString + '></div>';
    }
});

if (!_uiRouter.$state.get('default')) {
    _uiRouter.$stateProvider.state('default', {
        auth: false
    });
}

$Route.reopenClass({
    render: function render(props) {

        _core.$event.emit('$resetState');
        _core.$loader.reset();
        _uiRouter.$state.go('default');
        setTimeout.flush();

        var $scope = angular.extend(_angular.$rootScope.$new(), props);

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var element = (0, _angular.$compile)('<div id="app"><ui-view></ui-view></div>')($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
            _core.$loader.reset();
            angular.element(document.getElementById('app')).remove();
        }));

        var route = new this({
            // Pass child attributes to simulate a route receiving scope variables from the parent
            childAttributes: _core.$util.reduce(props, function (result, val, key) {
                result[_core.$util.camelToDasherize(key)] = key;
                return result;
            }, {})
        });

        route.bootstrap(route.defaultState || route.path || route.name);
        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
        angular.element(document.body).append(element);

        return element;
    },


    assertActive: function assertActive() {
        var isState = _uiRouter.$state.current instanceof this;

        if (!isState) {
            throw new Error('Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
        }
    }
});

function getPageTitle(stateName) {

    var state = _uiRouter.$state.get(stateName);

    if (!state) {
        return;
    }

    if (state.titleContent) {
        return _locale.$locale.content.get(state.titleContent);
    }
}

function changePageTitle() {

    document.documentElement.setAttribute('lang', _locale.$locale.lang);

    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
        return;
    }

    var fullStateTitle = [];

    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {

        var stateName = [a, b].filter(Boolean).join('.');
        var stateTitle = getPageTitle(stateName);

        if (stateTitle) {
            fullStateTitle.push(stateTitle);
        }

        return stateName;
    }, null);

    document.title = _core.$util.unique(fullStateTitle).join(' - ');
}

_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);

var $ComponentRoute = exports.$ComponentRoute = $Route;

angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;

_angular.$location;

_angular.$injector;

_angular.$compile;

_uiRouter.$state;

_uiRouter.$stateProvider;

_uiRouter.$urlRouterProvider;

_logger.$logger;

_core.$config;

_core.$Class;

_core.$util;

_core.$promise;

_core.$event;

_core.$loader;

_locale.$locale;

_component.$Component;

_ng.$cleanRootScope;

_ng.$angularInvoke;

_ng.$once;

_config.$meta;

_lazyLoadRoutes.lazyLoadRoute;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {



var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

_core.$config.deploy = _core.$config.deploy || _env.$env;

_core.$config;

_env.$env;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/env.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var $env = exports.$env = {

    isLocal: function isLocal() {
        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
    },

    isStage: function isStage() {
        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
    },

    isSandbox: function isSandbox() {
        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
    },

    isLive: function isLive() {
        return window.location.hostname === 'www.paypal.com';
    },

    isTest: function isTest() {
        return false;
    }
};

angular.value("$env", $env);

/***/ }),

/***/ "../node_modules/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");

Object.keys(_env).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _env[key];
    }
  });
});

var _config = __webpack_require__("../node_modules/squid/dist/paypal/config.js");

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _pxp = __webpack_require__("../node_modules/squid/dist/paypal/pxp.js");

Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pxp[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPModel = undefined;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpMatch = $pxpMatch;
exports.$pxpFactors = $pxpFactors;
exports.$elmo = $elmo;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");

var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");

var $PXPModel = exports.$PXPModel = _core.$Model.extend({
    api: new _core.$Api({
        uri: '/api/pxp/:pagename'
    })
});

function logPxp(pxpRes, params, logPayload) {
    var exp_name = [];
    var xe = [];
    var xt = [];
    var isElmoExperiment = params.isElmoExperiment;

    angular.forEach(pxpRes.treatments, function (treatment) {

        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
            experiment: pxpRes.pagename,
            treatment: treatment.treatment_name,
            experiment_id: treatment.experiment_id,
            treatment_id: treatment.treatment_id,
            loc_country: _locale.$locale.country,
            loc_lang: _locale.$locale.lang,
            exp_source: isElmoExperiment ? 'elmo' : 'pxp'
        }, params, logPayload));

        exp_name.push(treatment.treatment_name);
        xe.push(treatment.experiment_id);
        xt.push(treatment.treatment_id);
    });

    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
        pxp_exp_id: xe.join('|'),
        pxp_trtmnt_id: xt.join('|'),
        treatments: exp_name.join('|'),
        loc_country: _locale.$locale.country,
        loc_lang: _locale.$locale.lang,
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    }, params, logPayload));

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: xe.join(','),
        pxp_trtmnt_id: xt.join(','),
        exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    });

    _core.$event.emit('pxp_res', pxpRes);
}

function $getPxpTreatments(id, params, logPayload) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


    return _core.$promise.run(function () {
        if (isElmoExperiment) {
            Object.assign(params, { isElmoExperiment: isElmoExperiment });
        }

        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
        var forceTreatments = _core.$util.param('pxp_' + id) || _core.$util.param('elmo_' + id);

        if (forceTreatments) {
            var treatments = forceTreatments.split(',').filter(Boolean);

            pxp.treatments = treatments.map(function (treatment_name) {
                return {
                    treatment_name: treatment_name
                };
            });

            return pxp;
        }

        if (forceApiCall) {
            pxp.cached = false;

            return pxp.reload({
                params: params,
                silent: silent
            });
        }

        return pxp.retrieve({
            params: params,
            silent: silent,
            // Ignore all errors from this api, by passing transientError as true
            // Pxps are not critical calls, so they should fail silently without fallbacks (page reload / showing error page)
            transientError: true
        });
    }).then(function (pxp) {
        if (!pxp.cached) {
            logPxp(pxp, params, logPayload);
        }

        pxp.cached = true;

        return pxp;
    });
}

function $pxp(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isElmoExperiment = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (!pattern) {
        pattern = params;
        params = {};
    }

    pattern = new RegExp('^' + pattern + '$');

    return exports.$getPxpTreatments(id, params, null, forceApiCall, silent, isElmoExperiment).then(function (experimentResponse) {
        var result = void 0;

        (experimentResponse.treatments || []).some(function (treatment) {
            if (!pattern.test(treatment.treatment_name)) {
                return false;
            }

            result = {
                treatment_name: treatment.treatment_name,
                factors: treatment.factors
            };

            return true;
        });

        return result;
    });
}

function $pxpMatch(id, params, patterns, logPayload) {
    if (!patterns) {
        patterns = params;
        params = {};
    }

    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
        var result = {};

        angular.forEach(patterns, function (pattern, name) {
            pattern = new RegExp('^' + pattern + '$');
            result[name] = false;

            (pxpResponse.treatments || []).some(function (treatment) {
                if (!pattern.test(treatment.treatment_name)) {
                    return false;
                }

                result[name] = true;
                return true;
            });
        });

        return result;
    });
}

function $pxpFactors(id, params, pattern) {
    params.factors = 'true';
    return $pxp(id, params, pattern).then(function (pxpResponse) {
        var result = void 0;

        if (pxpResponse && pxpResponse.factors) {
            result = { treatment_name: pxpResponse.treatment_name };
            var pxpFactors = pxpResponse.factors;
            var length = pxpFactors.length;

            for (var i = 0; i < length; i++) {
                result[pxpFactors[i].name] = pxpFactors[i].value;
            }
        }

        return result;
    });
}

function $elmo(id, params, pattern) {
    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var isElmoExperiment = true;

    return $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment);
}

window.$pxp = $pxp;
window.$elmo = $elmo;

angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
angular.value("$elmo", $elmo);
_logger.$logger;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_locale.$locale;

/***/ }),

/***/ "../node_modules/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});

}.call(window));

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddressDisplayComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-address-components/src/address-display/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-address-components/src/address-display/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _squid.$Component.extend('$xoAddressDisplayComponent', {
    tag: 'xo-address-display',
    template: _template2['default'],
    props: {
        address: {
            type: 'var',
            required: false
        },
        showPreferred: {
            type: 'str',
            required: false
        },
        countryCode: {
            type: 'var',
            required: false
        },
        displayFormattedAddr: {
            type: 'var',
            required: false
        }
    },
    actions: {
        formatAddress: function formatAddress(address) {
            var COMMA = ', ';
            var SPACE = ' ';

            function prefix(str, prefixStr) {
                if (str) {
                    return (prefixStr ? prefixStr : '') + str;
                }
                return '';
            }

            var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
            var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
            var displayLine3 = address.country ? prefix(address.country) : '';

            return {
                displayLine1: displayLine1,
                displayLine2: displayLine2,
                displayLine3: displayLine3
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var address = this.props.address || {};
            var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;

            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _squid.$feature)('preferredShipping', false, countryCode);
            if (this.props.displayFormattedAddr) {
                this.formattedAddr = this.actions.formatAddress(address);
                this.$watchCollection('props.address', function (newVal) {
                    _this.formattedAddr = _this.actions.formatAddress(newVal);
                });
            }
        }
    }
});

angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
_squid.$Component;

_squid.$feature;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\" data-test-id=\"fullAddress\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization-edit/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddressNormalizationFactory', function () {
    var getAddressNormalizationElmoResult = function getAddressNormalizationElmoResult(shippingCountry) {
        return (0, _squid.$elmo)('xo_hermes_address_normalization', { 'ctx.country': _squid.$locale.country, 'ctx.shippingCountry': shippingCountry }, 'xo_hermes_address_normalization_treatment').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        getAddressNormalizationElmoResult: getAddressNormalizationElmoResult
    };
});

_squid.$locale;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-address-components/src/address-normalization-edit", "../node_modules/xo-address-components/src/address-normalization-edit/factory.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module('beaver.level', []).factory('$logLevel', function () {
    return {
        INFO: 'info',
        DEBUG: 'debug',
        ERROR: 'error',
        WARN: 'warn',
        ALERT: 'alert'
    };
}).factory('$consoleLogLevel', function () {
    return {
        info: 'info',
        debug: 'debug',
        error: 'error',
        warn: 'warn',
        alert: 'info'
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/level.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _level = __webpack_require__("../node_modules/xo-beaver/dist/level.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable angular/di */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Logger', function () {
    var logger = {};
    var HERMES_DEV_COOKIE = 'hermesdev';

    _angular2['default'].forEach(_level.$logLevel, function (level) {
        logger[level] = function (event, payload, settings) {
            return this.log(level, event, payload, settings);
        };
    });

    var hostname = _angular.$window.location && _angular.$window.location.hostname || '';
    var uniqueEvents = [];

    _angular2['default'].extend(logger, {
        autoLog: [_level.$logLevel.WARNING, _level.$logLevel.ERROR],
        flushInterval: 10 * 60 * 1000,
        heartbeatInterval: 5000,
        sizeLimit: 500,
        debounceInterval: 10,
        uri: '/api/log',
        rootTxnUri: '/api/log/crt',
        hearbeatMaxThreshold: 50,
        deploy: {
            isLocal: function isLocal() {
                return hostname === 'localhost' || hostname === 'localhost.paypal.com';
            },

            isStage: function isStage() {
                return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
            },

            isLive: function isLive() {
                return hostname === 'www.paypal.com';
            }
        },

        init: function init() {
            var self = this;

            this.buffer = [];

            var previousBeforeUnloadHandler = _angular.$window.onbeforeunload;

            _angular.$window.onbeforeunload = function (event) {
                if (self.isDone) {
                    return;
                }

                self.info('window_beforeunload');

                if (previousBeforeUnloadHandler) {
                    return previousBeforeUnloadHandler.apply(this, arguments);
                }
            };

            var previousUnloadHandler = _angular.$window.onunload;

            _angular.$window.onunload = function (event) {

                if (self.isDone) {
                    return;
                }

                self.info('window_unload');
                self._flush();

                self.done();

                if (previousUnloadHandler) {
                    return previousUnloadHandler.apply(this, arguments);
                }
            };

            this.heartbeat();
            this.daemon();
        },

        heartbeat: function heartbeat() {
            var self = this;

            if (!window.enablePerformance) {
                return;
            }

            function timestamp() {
                var perf = window.performance;

                return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
            }

            var howBusy = {
                lastSampledTime: timestamp(),
                lastLag: 0,
                maxLag: 0,
                dampendedLag: 0
            };

            var count = 0;

            (0, _angular.$interval)(function () {

                if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
                    count = 0;
                }

                if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
                    return;
                }

                count += 1;

                var payload = {
                    count: count
                };

                var now = timestamp();

                howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
                howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
                howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
                howBusy.lastSampledTime = now;

                payload.lastLag = howBusy.lastLag.toFixed(4);
                payload.maxLag = howBusy.maxLag.toFixed(4);
                payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
                payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);

                if (howBusy.lastLag > 10000) {
                    self.info('toobusy', {}, {
                        noConsole: true,
                        unique: true
                    });
                }

                self.info('heartbeat', payload, {
                    noConsole: true
                });
            }, this.heartbeatInterval);
        },

        done: function done() {
            this.flush(true);
            this.isDone = true;
        },

        addPerformanceData: function addPerformanceData(payload) {

            if (window.enablePerformance) {
                var performance = window.performance;
                var timing = window.performance.timing || {};
                var now = performance.now();

                if (window.clientStartTime && _angular2['default'].isUndefined(payload.client_elapsed)) {
                    payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
                }

                if (timing.connectEnd && timing.navigationStart && _angular2['default'].isUndefined(payload.req_elapsed)) {
                    payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
                }
            }
        },

        addLocaleData: function addLocaleData(payload) {

            var context = {};

            try {
                context = _angular.$injector.get('$metaBuilder').buildContext();
            } catch (err) {
                return; // Continue without adding locale data
            }
            if (context.locale && context.locale.country) {
                payload.site_cntry = context.locale.country;
            }
        },

        /* jslint maxcomplexity: false */
        log: function log(level, event, payload, settings) {
            var self = this;

            payload = payload || {};

            if (_angular2['default'].isArray(payload) || !_angular2['default'].isObject(payload)) {
                payload = {
                    payload: payload
                };
            }
            settings = settings || {};

            if (settings.unique) {
                var hash = event + ':' + _angular2['default'].toJson(payload);

                if (uniqueEvents.indexOf(hash) > -1) {
                    return self;
                }
                uniqueEvents.push(hash);
            }

            payload.pageID = window.meta && window.meta.pageID;

            this.addPerformanceData(payload);
            this.addLocaleData(payload);

            self.print(level, event, payload, settings);

            if (this.buffer.length >= this.sizeLimit) {
                if (this.buffer.length === this.sizeLimit) {
                    return self.enqueue('warn', 'logger_max_buffer_length');
                }
                return self;
            }

            return self.enqueue(level, event, payload, settings);
        },

        getTimestamp: function getTimestamp() {
            var now = Date.now();

            return window.logOffset ? window.logOffset + now : now;
        },

        enqueue: function enqueue(level, event, payload, settings) {
            payload = payload || {};
            settings = settings || {};

            var data = {
                level: level,
                event: event,
                timestamp: this.getTimestamp(),
                payload: payload
            };

            this.buffer.push(data);

            // If the log level is classified as autolog, then flush the data
            if (this.autoLog.indexOf(level) > -1) {
                this.flush();
            }

            return this;
        },

        shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {

            if (settings.noConsole) {
                return false;
            }

            if (window.meta && window.meta.corp) {
                return true;
            }

            if (this.deploy.isLocal() || this.deploy.isStage()) {
                return true;
            }

            var cookies = window.cookies || {};

            if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
                return true;
            }

            return false;
        },

        print: function print(level, event, payload, settings) {

            if (!this.shouldPrintLogsToConsole(settings)) {
                return;
            }

            var args = [event];

            if (payload) {
                args.push(payload);

                if (payload.stack || payload.error || payload.warning) {
                    args.push('\n\n', payload.stack || payload.error || payload.warning);
                }
            }

            _angular.$log[_level.$consoleLogLevel[level] || 'info'].apply(_angular.$log, args);
        },

        flush: function flush(immediate) {
            var self = this;

            if (!this.buffer.length) {
                return _angular.$q.when();
            }

            if (immediate) {
                return _angular.$q.when(this._flush());
            }

            if (self.debouncer_timeout) {
                _angular.$timeout.cancel(self.debouncer_timeout);
            }

            self.debouncer_timeout = (0, _angular.$timeout)(function () {

                var resolver = self.debouncer_resolver;

                delete self.debouncer_promise;
                delete self.debouncer_resolver;
                delete self.debouncer_timeout;

                self._flush().then(function () {
                    resolver();
                });
            }, this.debounceInterval);

            self.debouncer_promise = self.debouncer_promise || (0, _angular.$q)(function (resolver) {
                self.debouncer_resolver = resolver;
            });

            return self.debouncer_promise;
        },

        _flush: function _flush() {
            var self = this;

            if (!self.buffer.length) {
                return _angular.$q.when();
            }

            var meta = {};

            try {
                meta = _angular.$injector.get('$metaBuilder').build();
            } catch (err) {
                // @TODO - Log error
            }

            var req = this.ajax('post', _angular.$window.meta.logURL || _angular.$window.config.urls.baseUrl + this.uri, {
                data: {
                    events: self.buffer
                },
                meta: meta
            });

            self.buffer = [];

            return req;
        },

        ajax: function ajax(method, url, json) {
            return (0, _angular.$q)(function (resolve) {
                var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
                var req = new XRequest('MSXML2.XMLHTTP.3.0');
                var logAppName = _angular.$window.meta.logAppName;

                req.open(method.toUpperCase(), url);

                req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                req.setRequestHeader('Content-type', 'application/json');

                if (logAppName) {
                    req.setRequestHeader('x-app-name', logAppName);
                }

                req.onreadystatechange = function () {
                    if (req.readyState > 3) {
                        resolve();
                    }
                };
                req.send(_angular2['default'].toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
            });
        },

        daemon: function daemon() {
            this.stop();

            var self = this;

            this.timer = (0, _angular.$interval)(function () {
                self.flush();
            }, this.flushInterval);
        },

        stop: function stop() {
            if (this.timer) {
                _angular.$interval.cancel(this.timer);
            }
        },

        createCalRootTxn: function createCalRootTxn(data, txnName) {
            if (data !== null && _angular2['default'].isObject(data)) {
                var rootTxnData = { 'data': {}, 'transactionName': '' };
                var url = '' + _angular.$window.config.urls.baseUrl + this.rootTxnUri;
                if (_angular2['default'].isString(txnName)) {
                    rootTxnData.transactionName = txnName;
                }
                Object.assign(rootTxnData.data, data);
                this.ajax('post', url, rootTxnData);
            }
        }
    });

    function Logger(val) {
        _angular2['default'].extend(this, val);
        this.init();
    }

    Logger.prototype = logger;
    Logger.prototype.constructor = Logger;

    return Logger;
}).factory('$logger', ['$Logger', function ($Logger) {
    return new $Logger();
}]).run(['$logger', function ($logger) {
    _angular2['default'].forEach(window.beaconQueue, function (payload) {
        $logger.log(payload.level, payload.event, payload);
    });

    window.beacon = function (level, events, payload) {
        _angular2['default'].forEach(events, function (event) {
            $logger.log(level, event, payload);
        });
    };
}]);

_level.$logLevel;

_level.$consoleLogLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlPopup', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token)
            }).then(function () {
                if ($scope.checkoutSession.showDeclinePopup) {
                    if (!_angular.$rootScope.bml) {
                        _angular.$rootScope.bml = new _bml.$BMLModel();
                    }
                    if (!$scope.bml) {
                        $scope.bml = _angular.$rootScope.bml;
                    }

                    $scope.bml.preferenceCheck = false;
                    $scope.bml.showModal = true;
                    $scope.bml.showModalBackdrop = true;

                    if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
                        $scope.bml.showModalBackdrop = true;
                    }
                }
            });

            $scope.bmlSetPreferrence = function () {
                if ($scope.bml.preferenceCheck) {
                    $scope.bml.action('preference', {
                        data: {
                            financial_instrument_id: $scope.bml.financial_instrument_id
                        },
                        success: function success() {
                            _logger.$logger.info('COMPLETEBMLAPPLY_PREFERRED');
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['memberReview.bmlPreferredConfirmation']
                            };
                        }
                    });
                } else {
                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                }
                $scope.bml.showModal = false;
            };

            $scope.bmlClickContinue = function ($event) {
                $event.preventDefault();
                $scope.bml.showModalBackdrop = false;
                $scope.bml.showModal = false;
            };
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_logger.$logger;

_bml.$BMLModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"xoBmlPopup\" content>\n    <!-- BML Decision -->\n    <div ng-if=\"bml.application_status !== undefined || bml.contingency\">\n        <div ng-show=\"bml.showModal\" id=\"bmlModal\" style=\"display:block;\" class=\"modal bmlModal\" aria-labelledby=\"modal-title\" role=\"alertdialog\" tabindex=\"-1\">\n\n            <div ng-show=\"bml.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n            <div class=\"modal-wrap\">\n\n                <div ng-switch=\"bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\">\n                    <div ng-switch-when=\"true\">\n                        <span class=\"bmlLogoVert\"></span>\n                        <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSuccessHeader') }}</h2>\n\n                        <div ng-if=\"bml.nape == 'napePositive'\">\n                            <p>{{ content('memberReview.bmlNapeLinkSuccess')}}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value == 0\">\n                            <p>{{ content('memberReview.bmlApprovalMessage') }}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value > 0\">\n                            <p ng-bind-html=\"htmlContent('memberReview.bmlSuccessMessage', {creditLine: bml.credit_line.value})\"></p>\n                            <p>{{ content('memberReview.bmlSuccessMessageSend', {email: bml.user_info.email_address}) }}</p>\n                        </div>\n\n                        <form method=\"post\" name=\"confirm\" ng-submit=\"bmlSetPreferrence()\">\n                            <div class=\"checkbox\">\n                                <input type=\"checkbox\" ng-model=\"bml.preferenceCheck\" name=\"bmlPreferred\" id=\"bmlPreferredCheckbox\" class=\"chkbx\">\n                                <label for=\"bmlPreferredCheckbox\" class=\"chkbxLabel\">{{ content('memberReview.bmlSetPreferred')}}</label>\n                            </div>\n                            <input class=\"btn btn-submit full\" type=\"submit\" value=\"{{ content('memberReview.bmlContinue')}}\">\n                        </form>\n\n                    </div>\n                    <div ng-switch-default>\n                        <div ng-switch=\"bml.application_status\">\n                            <!-- bmlMaxAttempts -->\n                            <div ng-switch-when=\"SOFT_DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSorry')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- bmlDeclineLinkedToDiffMember -->\n                            <div ng-switch-when=\"FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.bmlAcctLinkedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.bmlAcctLinkedMsg')}}</p>\n                            </div>\n                            <!-- creditDeclineHard -->\n                            <div ng-switch-when=\"DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.hardDeclineHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- ??? creditPaymentNotAllowed -->\n                            <div ng-switch-when=\"CREDIT_PAYMENT_NOT_ALLOWED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditNotAllowedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditNotAllowedMsg')}}</p>\n                            </div>\n                            <!-- ??? creditEligibilityDeclined -->\n                            <div ng-switch-when=\"CREDIT_ELIGIBILITY_DECLINE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditEligibilityDeniedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditEligibilityDeniedMsg')}}</p>\n                            </div>\n                            <!-- ??? declineOtherCreditInstrumentExists -->\n                            <div ng-switch-when=\"FP_DECLINED_DUE_TO_CREDIT_IN_WALLET_RULE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.declineOtherCreditInstrumentExistsHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine1')}}</p>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine2\" merchantName=\"{bmlResult.merchantFullName}')}}</p>\n                            </div>\n                            <!-- systemError, bmlGenericError, invalidError -->\n                            <div ng-switch-default> <!-- ng-switch-when=\"UNKNOWN_DECISION\" -->\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.systemErrorHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.systemErrorMsg')}}</p>\n                            </div>\n                        </div>\n\n                        <!--\n                         && bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\n                        -->\n                        <div ng-if=\"bml.application_status !== undefined || bml.contingency\" >\n                            <div ng-if=\"locale.countryCode === 'DE'\">\n                                <p class=\"cancelUrl\">\n                                    <a href=\"{{cancel}}\" role=\"button\" class=\"btn full\">{{ content('common.returnToCart') }}</a>\n                                </p>\n                            </div>\n                            <div ng-if=\"locale.countryCode !== 'DE'\">\n                                <input class=\"btn btn-submit full buttonGroup button-spacing\" type=\"button\" id=\"continueBml\" value=\"{{ content('common.payWithPayPal') }}\" ng-click=\"bmlClickContinue($event)\" />\n                                <a href=\"{{cancel}}\" role=\"button\" class=\"btn btn-secondary full buttonGroup\" id=\"cancelLink\">\n                                    {{ merchant ? content('common.bmlCancelButtonLabel', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- BML Decision -->\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/personalizationManager.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.PERSONALIZATION_PHASES = undefined;
exports.personalizationManager = personalizationManager;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var PERSONALIZATION_PHASES = exports.PERSONALIZATION_PHASES = {
    'SHADOW': 'SHADOW',
    'RAMP': 'RAMP',
    'CONTROL': 'CONTROL',
    'RAMP_NO_FALLBACK': 'RAMP_NO_FALLBACK'
};

/**
 * Calls SSOT for UK flow and MORS/SearchAds for US flows
 * @param token
 * @param models
 * @param contentKeys
 * @returns {*}
 */
function callDefaultServiceAndMapBanner(token, models, contentKeys) {
    if (_squid.$locale.country.toUpperCase() === 'GB') {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(token, models, contentKeys);
    }
}

/**
 * This is a generic manager for personalization.
 * Typically, personalization has 3 phases.
 * CONTROL: Calls and use ONLY banner returned from MORS/searchAds
 * SHADOW: Calls MORS/searchAds && MORS/discoverMessages, compares results and logs differences. But returns banner from MORS/searchAds to use in Hermes
 * RAMP: Calls and use ONLY banner returned from MORS/discoverMessage. If MORS fails, it will proceed to fallback routine (usually `callSsotAndMapBanner`)
 * RAMP_NO_FALLBACK: Same as RAMP, but if MORS call fails, it will not attempt fallback routine to resolve banner content
 * @param {string} phase
 * @param token
 * @param model
 * @param contentKeys
 * @returns {banner}
 */
function personalizationManager(phase, token, models, contentKeys) {
    switch (phase) {
        case PERSONALIZATION_PHASES.SHADOW:
            return _angular.$q.all([callDefaultServiceAndMapBanner(token, models, contentKeys), _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(token, models)]).then(function (_ref) {
                var originalBanner = _ref[0],
                    discoverMessageBanner = _ref[1].banner;

                _xoCreditBannerUtils.$xoCreditBannerUtils.compareAdObjects(originalBanner, discoverMessageBanner);
                return originalBanner;
            });
        case PERSONALIZATION_PHASES.RAMP:
        case PERSONALIZATION_PHASES.RAMP_NO_FALLBACK:
            return _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(token, models).then(function (_ref2) {
                var discoverMessageBanner = _ref2.banner;

                if (discoverMessageBanner) {
                    // return banner if it's defined
                    return discoverMessageBanner;
                }

                // US1247972: for UK x-currency, if MORs call fail, do NOT call SSOT and show NO banner
                if (_squid.$locale.country.toUpperCase() === 'GB') {
                    var currencyCode = models.checkoutCart.getCartCurrencyCode();
                    if (currencyCode && currencyCode !== 'GBP') {
                        return _angular.$q.when();
                    }
                }

                if (phase === PERSONALIZATION_PHASES.RAMP_NO_FALLBACK) {
                    // If the caller has specified RAMP_NO_FALLBACK, return here.
                    // No need to attempt the fallback routine to resolve the banner content
                    return _angular.$q.when();
                }

                // else call ssot
                return _xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(token, models, contentKeys);
            });
        default:
            return callDefaultServiceAndMapBanner(token, models, contentKeys).then(function (banner) {
                return banner;
            });
    }
}

_angular.$q;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var COUNTRY_CODE = exports.COUNTRY_CODE = {
    'GreatBritain': 'GB',
    'UnitedStates': 'US',
    'Germany': 'DE'
};

var CUSTOMER_TYPE = exports.CUSTOMER_TYPE = {
    REUSE: 'REUSE',
    ACQ: 'ACQ'
};

var BANNER_TYPE = exports.BANNER_TYPE = {
    PROMINENT: 'Prominent',
    PASSIVE: 'Passive'
};

var PERSONALIZATION_MESSAGE_PREFIX = exports.PERSONALIZATION_MESSAGE_PREFIX = 'PS-';
var DEFAULT_MESSAGE_PREFIX = exports.DEFAULT_MESSAGE_PREFIX = 'JS-';
var DEFAULT_MESSAGE = exports.DEFAULT_MESSAGE = 'default_banner';
var DEFAULT_MESSAGE_MSGID = exports.DEFAULT_MESSAGE_MSGID = '' + DEFAULT_MESSAGE_PREFIX + DEFAULT_MESSAGE;

var bannerTypes = exports.bannerTypes = {
    'ACQ': 'ACQ', // Standard acquisition banner
    'REUSE': 'REUSE', // Standard reuse banner
    'REUSE_FI': 'REUSE_FI', // Reuse text under PPC FI
    'NONE': 'NONE'
};

var bannerStyle = exports.bannerStyle = {
    'Prominent': 'Prominent'
};

var INSTALLMENT_OPTIONS_SORT = exports.INSTALLMENT_OPTIONS_SORT = {
    APR_ASCE: 'APR_ASCE',
    TERM_DESC: 'TERM_DESC'
};

/***/ }),

/***/ "../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditBannerUtils = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var formatText = function formatText(inputTxt) {
    var amount = /\$\d*\.?\d+/g;
    var htmlTag = /(<([^>]+)>)/ig;
    return inputTxt.replace(amount, '{amount}').replace(htmlTag, '');
};

var buildOfferTextTemplate = function buildOfferTextTemplate(text1, text2) {
    if (angular.isString(text1) && angular.isString(text2)) {
        var t1 = formatText(text1);
        var t2 = formatText(text2);
        if (t1 !== '' && !t1.match(/(!|\.)$/g)) {
            t1 += '.';
        }
        return t1 + ' ' + t2;
    }
    return;
};

var $xoCreditBannerUtils = exports.$xoCreditBannerUtils = {
    getCreditInWallet: function getCreditInWallet(checkoutSession, isBANoPurchase) {
        if (!checkoutSession) {
            return false;
        }

        if (isBANoPurchase) {
            return checkoutSession.get('futurePayment.isCreditInWallet');
        } else {
            var plans = checkoutSession.getPlanList();
            if (plans) {
                return plans.find(function (fi) {
                    return fi && fi.primaryFs && fi.primaryFs.name === 'BILL_ME_LATER';
                });
            } else {
                return false;
            }
        }
    },
    hasThreeMonthInstallments: function hasThreeMonthInstallments(financingCode) {
        var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
        var hasThreeMonthInstallment = Boolean(financingCode.filter(function (value) {
            return threeMonthFinancingCodeArray.includes(value);
        }).length > 0);

        // Throw error if its a three month financing code on old CYCO page
        return hasThreeMonthInstallment ? true : false;
    },
    /**
     * Check to see if PayPal Credit is in wallet
     * If the current transaction is BA without purchase, it looks at checkoutSession.futurePayment.isCreditInWallet
     * Otherwise, it loops through funding options to find BILL_ME_LATER instrument
     * @param checkoutSession
     * @param isBANoPurchase
     * @returns {*}
     */
    isCreditInWallet: function isCreditInWallet(checkoutSession, isBANoPurchase) {
        return this.getCreditInWallet(checkoutSession, isBANoPurchase) ? true : false;
    },
    /**
     * Check if PPC is set as default FI for the transaction
     * For BA-NOP, it checks sticky instrument.
     * For other BA transactions, it looks for future payment instruments
     * For non-BA transactions, it checks funding option instead
     * @param checkoutSession
     * @param isBANoPurchase
     * @returns {*}
     */
    isCreditSelected: function isCreditSelected(checkoutSession, isBANoPurchase) {
        var creditInWallet = this.getCreditInWallet(checkoutSession, isBANoPurchase);

        if (!creditInWallet) {
            return false;
        }

        if (isBANoPurchase) {
            var stickyFI = checkoutSession.getSelectedStickyInstrument();
            return stickyFI.type === 'BILL_ME_LATER';
        } else {
            return creditInWallet.selected;
        }
    },
    /**
     * Call SSOT and return $CreditInstallmentOptionsModel to caller
     * @param token
     * @param payee
     * @param checkoutCart
     * @param checkoutAppData
     * @param silent
     * @returns {*}
     */
    executeSsotCall: function executeSsotCall(token, payee, checkoutCart, checkoutAppData) {
        var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

        var offers = new _index.$CreditInstallmentOptionsModel({
            id: token,
            payee: payee,
            checkoutCart: checkoutCart,
            checkoutAppData: checkoutAppData,
            isMemberCredit: true
        });

        return offers.save({
            silent: silent,
            cache: true,
            success: function success(result) {
                _logger.$logger.info('xo-credit-banner-utils: executeSsotCall succeeded');
                return offers;
            },
            error: function error(err) {
                _logger.$logger.error('xo-credit-banner-utils: executeSsotCall error', { error: err });
                return;
            },
            contingencies: {
                DEFAULT: function DEFAULT() {
                    _logger.$logger.info('xo-credit-banner-utils: executeSsotCall: GET_INSTALLMENT_CONTINGENCY');
                }
            }
        });
    },
    /**
     * Constructs the application context to be used in the executeMorsDiscoverMessageCall()
     * @param models
     * @returns Array of Object {name, value}
     */
    getApplicationContext: function getApplicationContext(models) {
        var applicationContext = [{
            name: 'transaction_amount',
            value: (models.checkoutCart.get('purchase.amounts.total.amount', 0) * 100).toFixed(0)
        }, {
            name: 'transaction_currency',
            value: models.checkoutCart.get('purchase.amounts.total.currency_code', '')
        }, {
            name: 'ppc_in_wallet',
            value: this.isCreditInWallet(models.checkoutSession, models.checkoutCart.isBillingNoPurchase())
        }, {
            name: 'ppc_default_fi',
            value: models.checkoutSession.get('plan.paypal_credit')
        }, {
            name: 'is_mobile',
            value: _index3.$DeviceInfo.isDevice()
        }, {
            name: 'installments_not_allowed',
            value: models.checkoutCart.isBilling()
        }, {
            name: 'is_ba_rt_no_purchase',
            value: models.checkoutCart.isBillingNoPurchase() && !models.checkoutCart.get('purchase.amounts.total.currency_code', '')
        }, {
            name: 'source_id',
            value: 'HERMESNODEWEB'
        }, {
            name: 'merchantId',
            value: models.payee.get('merchant.id')
        }];
        var ppcConversionInfo = models.checkoutSession.getPPCconversionInfo();
        if (ppcConversionInfo) {
            var ppcConversionRate = {
                name: 'currency_conversion_rate',
                value: ppcConversionInfo.to_amount
            };
            applicationContext.push(ppcConversionRate);
        }
        return applicationContext;
    },
    /**
     * Verify if the purchaseAmount is eligible for CORE offer
     * @param purchaseAmount
     * @returns {boolean}
     */
    isEligibleForCORE: function isEligibleForCORE(purchaseAmount) {
        var threshold = _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country];

        _logger.$logger.info('$xoCreditBannerUtils: purchaseAmount: ' + purchaseAmount + ', threshold: ' + threshold);

        return purchaseAmount < threshold;
    },

    /**
     * Calls $renderContent with all content keys for banner
     * Put all the dynamic content needs to be swapped out from bodyText or bodyText2 into props
     * @param keys
     * @param props
     * @returns {{ctaText: *, logo: *, bodyText: *, bodyText2: *, termsLink: *}}
     */
    renderContentByKey: function renderContentByKey(keys) {
        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!keys) {
            return {};
        }
        return Object.assign({
            ctaText: (0, _squid.$renderContent)(keys.ctaText),
            logo: keys.logo,
            bodyText: (0, _squid.$renderContent)(keys.bodyText, props),
            bodyText2: (0, _squid.$renderContent)(keys.bodyText2, props),
            termsLink: keys.termsLink,
            termsText: (0, _squid.$renderContent)(keys.termsText, props),
            termsLinkText: (0, _squid.$renderContent)(keys.termsLinkText),
            statusText: (0, _squid.$renderContent)(keys.statusText).toString(),
            messageId: _xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID
        }, props);
    },

    /**
     *
     * Call SSOT and map SSOT response to a banner object
     * @param token
     * @param models
     * @returns {*}
        */
    callSsotAndMapBanner: function callSsotAndMapBanner(token, models, targetContentKey) {
        var _this = this;

        if (!token || !models.payee || !models.checkoutCart || !models.checkoutAppData || !models.checkoutSession || !targetContentKey) {
            _logger.$logger.error('$xoCreditBannerUtils callSsotAndMapBanner(): Invalid models arguement passed in');
            return _angular.$q.when();
        }

        var isBillingNoPurchase = models.checkoutCart.isBillingNoPurchase();
        var isReuse = this.isCreditInWallet(models.checkoutSession, isBillingNoPurchase);

        if (isBillingNoPurchase) {
            // Use CORE content if is billing agreement without purchase
            _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapBanner(): BA-NOP, use CORE banner');
            return _angular.$q.when().then(function () {
                var model = _this.renderContentByKey(targetContentKey.core);
                model.offerType = _constants.CREDIT_TYPE.CORE;
                return model;
            });
        } else {
            return this.executeSsotCall(token, models.payee, models.checkoutCart, models.checkoutAppData).then(function (creditInstallmentOptionsModel) {

                var formattedCartAmount = models.checkoutCart.get('purchase.amounts.total.amount_formatted');
                var props = { cartAmount: formattedCartAmount };
                var model = void 0;

                if (!creditInstallmentOptionsModel) {
                    _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapGBBanner(): No offer received from SSOT');
                    return _angular.$q.when().then(function () {
                        // If SSOT fails we want banner content for acq & reuse US and only UK reuse
                        if (_squid.$locale.country.toUpperCase() === 'GB' && isReuse || _squid.$locale.country.toUpperCase() === 'US') {
                            if (_squid.$locale.country.toUpperCase() === 'GB') {
                                props = {
                                    amount: models.checkoutCart.getPurchaseAmount()
                                };
                            }
                            if (_this.isEligibleForCORE(models.checkoutCart.getPurchaseAmount())) {
                                _logger.$logger.info('$xoCreditBannerUtils: CORE Offer');
                                model = _this.renderContentByKey(targetContentKey.core, props);
                                model.offerType = _constants.CREDIT_TYPE.CORE;
                                return model;
                            } else {
                                _logger.$logger.info('$xoCreditBannerUtils: NI Offer');
                                model = _this.renderContentByKey(targetContentKey.ni, props);
                                model.offerType = _constants.CREDIT_TYPE.NI;
                                return model;
                            }
                        }
                        return;
                    });
                }

                if (creditInstallmentOptionsModel.getInstallmentOptionsPresent()) {
                    _logger.$logger.info('$xoCreditBannerUtils callSsotAndMapBanner(): INST Offer');
                    var creditSharedInfoModel = _index.$CreditSharedInfoModel.instance();
                    creditSharedInfoModel.setInstallmentOfferPresent(true);

                    var installmentOffer = _squid.$locale.country.toUpperCase() === 'GB' ? creditInstallmentOptionsModel.getInstallmentOffers(_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT.TERM_DESC) : creditInstallmentOptionsModel.getInstallmentOffers(_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT.APR_ASCE);

                    if (_squid.$locale.country.toUpperCase() === 'GB') {
                        var monthly = installmentOffer.monthlyPayment && installmentOffer.monthlyPayment.formattedAmt;
                        var term = installmentOffer.term;
                        props = {
                            monthlyPayment: monthly,
                            term: term
                        };
                    }

                    if (_squid.$locale.country.toUpperCase() === 'DE') {
                        var cartAmount = models.checkoutCart.get('purchase.amounts.total.amount');
                        var cartAmountCurrency = models.checkoutCart.get('purchase.amounts.total.currency_code');
                        props = {
                            cartAmount: cartAmount,
                            cartCurrency: cartAmountCurrency,
                            financingCode: installmentOffer.financingCode,
                            apr: installmentOffer.apr,
                            nominalRate: installmentOffer.nominalRate,
                            ssotType: installmentOffer.creditType,
                            totalDue: installmentOffer.totalPayment.value,
                            totalDueCurrencyCode: installmentOffer.monthlyPayment.currency,
                            totalInterest: installmentOffer.totalInterest.value,
                            totalInterestCurrencyCode: installmentOffer.monthlyPayment.currency,
                            term: installmentOffer.term,
                            monthlyPayment: installmentOffer.monthlyPayment.value,
                            monthlyPaymentCurrencyCode: installmentOffer.monthlyPayment.currency,
                            totalInterestFormatted: installmentOffer.totalInterest.formattedAmt,
                            monthlyPercentageRate: installmentOffer.monthlyPercentageRate,
                            paypalSubsidy: installmentOffer.paypalSubsidy
                        };
                        creditSharedInfoModel.setInstallmentOffer(props);
                        creditSharedInfoModel.setInstallmentOfferFinancingDetails({
                            financing_code: installmentOffer.financingCode,
                            apr: installmentOffer.apr,
                            nominal_rate: installmentOffer.nominalRate,
                            credit_type: installmentOffer.creditType,
                            total_cost: installmentOffer.totalPayment.value,
                            total_interest: installmentOffer.totalInterest.value,
                            term: installmentOffer.term,
                            monthly_payment: installmentOffer.monthlyPayment.value,
                            currency: installmentOffer.monthlyPayment.currency,
                            monthly_percentage_rate: installmentOffer.monthlyPercentageRate,
                            paypal_subsidy: installmentOffer.paypalSubsidy
                        });
                    }

                    model = _this.renderContentByKey(targetContentKey.installment, props);
                    model.offerType = _constants.CREDIT_TYPE.INST;

                    if (_squid.$locale.country.toUpperCase() === 'US') {
                        // grab financing code for US search for 3M and update content
                        var installmentArray = creditInstallmentOptionsModel.getInstallmentOffers().installment_options;
                        var creditofferDetails = installmentArray.map(function (item) {
                            return item.financingCode;
                        });
                        var hasThreeMonthInstallment = _this.hasThreeMonthInstallments(creditofferDetails);
                        props = {
                            monthlyPayment: installmentOffer.monthlyPayment.formattedAmt
                        };
                        if (hasThreeMonthInstallment) {
                            model = _this.renderContentByKey(targetContentKey.threeMonthInst, props);
                            model.offerType = _constants.CREDIT_TYPE.INST;
                            model.hasThreeMonthOffer = true;
                        }
                    }
                    return model;
                } else if (creditInstallmentOptionsModel.getNiOfferPresent()) {
                    _logger.$logger.info('$xoCreditBannerUtils: NI Offer');
                    model = _this.renderContentByKey(targetContentKey.ni, props);
                    model.offerType = _constants.CREDIT_TYPE.NI;
                    return model;
                } else {
                    // if we don't see any (either EZP or NI) offer from SSOT, it's always CORE
                    _logger.$logger.info('$xoCreditBannerUtils: CORE Offer');
                    model = _this.renderContentByKey(targetContentKey.core, props);
                    model.offerType = _constants.CREDIT_TYPE.CORE;
                    return model;
                }
            });
        }
    },
    /**
     * Build Credit Offer FPTI Object
     * @param token
     * @param banner
     * @returns {*}
     */
    buildCreditOfferFptiObject: function buildCreditOfferFptiObject(token, banner) {
        var isSecondButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isReturnFromCape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


        var Device = '';

        if (!_index3.$DeviceInfo.isDevice()) {
            Device = 'Desktop';
        } else if (_index3.$DeviceInfo.isTablet()) {
            Device = 'Tablet';
        } else {
            Device = 'Mobile';
        }
        var defaultValues = {
            'buyer_country': _squid.$locale.country,
            'locale': _squid.$locale.lang,
            'context_id': token,
            'context_type': 'EC-Token',
            'device_type': Device,
            'from': 'PERSONALIZATION',
            'to': 'PERSONALIZATION_CREDIT',
            'banner_type': banner.presentmentStyle + '-' + banner.presentmentType,
            'ppc_button_y_n': isSecondButton,
            'ppc_app_interaction': isReturnFromCape ? 'isReturnFromCape' : ''
        };
        var mapBannerToFptiProperties = {
            'visaActive': 'visa_active',
            'merchantUpstreamPresentment': 'merchant_presented_banner',
            'product': 'product_identifier',
            'offerCategory': 'offer_category',
            'offerType': 'credit_offer_type',
            // offerText1 and bodyText are mapped to the same FPTI attribute intentionally for backward compatibility
            // Should use bodyText during US refactor
            'offerText1': 'credit_offer_text',
            'bodyText': 'credit_offer_text',
            'offerTextTemplate': 'credit_offer_text',
            'incentiveOfferProgramId': 'incentive_offer_program_id',
            'incentiveOfferValue': 'incentive_offer_value',
            'propensity': 'model_propensity',
            'approvability': 'credit_user_approvability',
            'campaignId': 'caid',
            'currencyConversionRate': 'fx_conversion_to',
            'cartCurrency': 'currency_conversion_to_currency',
            'merchantListingCurrency': 'currency_conversion_from_currency',
            'cartAmount': 'currency_conversion_to_amount',
            'banner_suppression_type': 'banner_suppression_type',
            'payerId': 'sndr_payer_id'
        };
        var queryValues = {};

        for (var key in mapBannerToFptiProperties) {
            if (banner[key] !== null && typeof banner[key] !== 'undefined') {
                queryValues[mapBannerToFptiProperties[key]] = banner[key];
            }
        }

        var creditSharedInfo = _index.$CreditSharedInfoModel.instance();
        queryValues.funding_instrument_count = creditSharedInfo.getFiCount();
        queryValues.cart_show_amt = creditSharedInfo.getCartAmountVisible();

        return Object.assign({}, defaultValues, queryValues);
    },
    /**
     * Create root transaction for PS monitoring
     * @param message
     * @param banner
     * @param err
     * @param bannerType
     * @returns {*}
     */
    buildPSMonitoringObject: function buildPSMonitoringObject(token, message, banner, err) {
        var psMonitorObject = { token: token };
        psMonitorObject.m_chnl = 'Desktop';
        if (_index3.$DeviceInfo.isDevice()) {
            psMonitorObject.m_chnl = _index3.$DeviceInfo.isTablet() ? 'Tablet' : 'Mobile';
        }
        if (err) {
            psMonitorObject.m_err = err;
        } else {
            psMonitorObject.msgClass = message.presentmentStyle + '_' + message.presentmentType;
            psMonitorObject.message = message.offerType;
            psMonitorObject.m_udf1 = message.offerCategory;
            psMonitorObject.m_udf2 = message.visaActive;
            psMonitorObject.m_udf3 = message.merchantUpstreamPresentment;
            psMonitorObject.m_inptype = !!message.incentiveOfferProgramId;
        }
        if (banner) {
            psMonitorObject.m_prod_type = banner.showPassiveBanner;
            psMonitorObject.m_trdtype = !!banner.incentives;
            psMonitorObject.m_event = banner.offerType;
        }
        return psMonitorObject;
    },
    /**
     * Collect fallback banner info for FPTI logging when MORs call failed and SSOT call success
     * @param ssot_banner
     * @param isReuse
     * @returns {*}
     */
    collectFallbackBannerInfo: function collectFallbackBannerInfo(banner, isReuse, isProminent) {
        banner = banner || {};
        var resObj = {
            presentmentType: 'Banner',
            product: 'PPC',
            banner_suppression_type: 'default_banner',
            offerCategory: isReuse ? 'REUSE' : 'ACQ',
            presentmentStyle: isProminent ? _xoCreditBannerConstants.BANNER_TYPE.PROMINENT : _xoCreditBannerConstants.BANNER_TYPE.PASSIVE,
            offerType: banner.offerType,
            payerId: banner.payerId
        };
        var text1 = void 0,
            text2 = void 0;
        if (isReuse) {
            text1 = banner.bodyText && banner.bodyText.toSafeString();
            text2 = banner.bodyText2 && banner.bodyText2.toSafeString();
        } else {
            text1 = banner.ctaText && banner.ctaText.toSafeString();
            text2 = banner.bodyText && banner.bodyText.toSafeString();
        }
        resObj.offerTextTemplate = buildOfferTextTemplate(text1, text2);
        return resObj;
    },
    /**
     * Calculating number of funding instruments
     * FI count is used in FPTI logs after calling MORS/DiscoverMessage for both US and UK
     * @param models
     * @returns {number}
     */
    getFiCount: function getFiCount(checkoutSessionModel, isBillingNoPurchase) {
        var fundingInstruments = void 0;
        var isBalanceCoveringPurchase = false;

        if (!isBillingNoPurchase) {
            var plans = checkoutSessionModel.get('fundingOptions.plans');
            isBalanceCoveringPurchase = plans && plans.find(function (fi) {
                return fi && fi.primaryFs && !fi.secondaryFIs && fi.primaryFs.name === 'BALANCE';
            });
            fundingInstruments = checkoutSessionModel.get('fundingOptions.instruments');
        } else {
            fundingInstruments = checkoutSessionModel.get('futurePaymentInstruments');
        }

        var fiApplicableForThisTransaction = 0;

        if (fundingInstruments && fundingInstruments.length > 0) {
            fundingInstruments.forEach(function (fundingOption, index) {
                if (fundingOption.type !== 'BALANCE' || isBalanceCoveringPurchase) {
                    fiApplicableForThisTransaction++;
                }
            });
        }
        return fiApplicableForThisTransaction;
    },
    /**
     * Call MORS' /message-recommendation endpoint and return $CreditOfferModel to caller
     * @param token
     * @param models
     * @param silent
     * @returns $CreditOfferModel
     */
    executeMorsDiscoverMessagesCall: function executeMorsDiscoverMessagesCall(token, models, silent) {
        var application_context = this.getApplicationContext(models);

        var creditOfferModel = new _index2.$CreditOfferModel({
            id: token,
            locale: _squid.$locale,
            payer: models.checkoutSession.payer.id || '',
            payee: models.payee.merchant.id || '',
            touchpoint: 'PPC_HERMES_RYI',
            message_count: 10,
            application_context: application_context,
            MorsError: null
        });

        return creditOfferModel.save({
            silent: silent,
            cache: true,
            params: creditOfferModel.getCacheKey(),
            data: creditOfferModel.serialize(),
            success: function success(result) {
                _logger.$logger.info('xo-credit-banner-utils: executeMorsDiscoverMessagesCall Success');
                return creditOfferModel;
            },
            error: function error(_error) {
                _logger.$logger.error('xo-credit-banner-utils: executeMorsDiscoverMessagesCall Fail', { error: _error });
                creditOfferModel.MorsError = 'MORS_error_' + _error.message;
                return creditOfferModel;
            },
            contingencies: {
                DEFAULT: function DEFAULT(name) {
                    _logger.$logger.error('xo-credit-banner-utils: executeMorsDiscoverMessagesCall contingency', { contingency: name });
                    creditOfferModel.MorsError = 'MORS_contingency_' + name;
                    return creditOfferModel;
                }
            }
        });
    },
    /**
     * Call /message-recommendations & map the response to a banner object
     * @param token
     * @param models
     * @returns {*}
     */
    callDiscoverMessagesAndMapToBanner: function callDiscoverMessagesAndMapToBanner(token, models) {
        var _this2 = this;

        if (!token || !models.payee || !models.checkoutCart || !models.checkoutSession) {
            _logger.$logger.error('$xoCreditBannerUtils callDiscoverMessagesAndMapToBanner(): Invalid models arguement passed in');
            return _angular.$q.when();
        }

        return this.executeMorsDiscoverMessagesCall(token, models, true).then(function (creditOfferModel) {
            var banner = void 0,
                morsErr = void 0;
            if (creditOfferModel.hasBannerMessage()) {
                banner = {};
                var morsBanner = creditOfferModel.getBannerMessage().content.json;
                // Map to banner fields
                banner.messageId = '' + _xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX + morsBanner.MessageDescription;
                banner.ctaText = morsBanner.CTAText;
                banner.logo = morsBanner.Logo;
                banner.bodyText = morsBanner.OfferText1;
                banner.bodyText2 = morsBanner.OfferText2;
                banner.termsLink = morsBanner.TermsLink; // US only
                banner.termsLinkText = morsBanner.TermsLinkText; // US only
                banner.termsText = morsBanner.TermsText; // US only
                banner.termsText2 = morsBanner.TermsText2;
                banner.headlineText = morsBanner.HeadlineText; // US
                banner.or = 'or'; // for seperator Prominent US banner
                banner.cartAmount = morsBanner.CartAmount;
                banner.cartCurrency = morsBanner.CartAmountCurrencyCode;
                banner.offerCategory = morsBanner.OfferCategory;
                banner.offerType = morsBanner.OfferType;
                banner.product = morsBanner.Product;
                banner.presentmentStyle = morsBanner.PresentmentStyle;
                banner.presentmentType = morsBanner.PresentmentType;
                banner.campaignId = creditOfferModel.getBannerMessage().id;
                banner.financingCode = morsBanner.FinancingCode;
                banner.apr = morsBanner.Apr;
                banner.term = morsBanner.Term;
                banner.nominalRate = morsBanner.NominalInterestRate;
                banner.monthlyPayment = morsBanner.MonthlyPayment;
                banner.monthlyPaymentCurrencyCode = morsBanner.MonthlyPaymentCurrencyCode;
                banner.totalDue = morsBanner.TotalDue;
                banner.totalDueCurrencyCode = morsBanner.TotalDueCurrencyCode;
                banner.totalInterest = morsBanner.TotalInterest;
                banner.totalInterestCurrencyCode = morsBanner.TotalInterestCurrencyCode;
                banner.ssotType = morsBanner.SsotType;
                banner.statusText = morsBanner.StatusText;
                banner.taglineText = morsBanner.TaglineText;
                banner.visaActive = morsBanner.VisaActive; // US only
                banner.merchantUpstreamPresentment = morsBanner.MerchantUpstreamPresentment; // for FPTI log only
                banner.approvability = morsBanner.Approvability; // for FPTI log only
                banner.monthlyPercentageRate = morsBanner.MonthlyPercentageRate;
                banner.paypalSubsidy = morsBanner.PayPalSubsidy === 'true';
                banner.formattedInterestAmount = morsBanner.FormattedInterestAmount;
                banner.formattedMonthlyPayment = morsBanner.FormattedMonthlyPayment;
                banner.formattedTotalAmount = morsBanner.FormattedTotalAmount;
                banner.formattedCartAmount = morsBanner.FormattedCartAmount;

                if (morsBanner['Incentive-OfferProgramId']) {
                    banner.incentivesOffer = true;
                    banner.incentiveOfferProgramId = morsBanner['Incentive-OfferProgramId'];
                    banner.incentiveOfferValue = morsBanner['Incentive-OfferValue'];
                    banner.incentiveOfferCurrencyCode = morsBanner['Incentive-OfferCurrencyCode'];
                    banner.incentiveOfferProgramCode = morsBanner['Incentive-OfferProgramCode'];
                }

                if (morsBanner.CrossCurrencyTransaction === 'true' && morsBanner.CurrencyConversionRate && models.checkoutCart.get('purchase.amounts.total.currency_code')) {
                    banner.crossCurrencyTransaction = true;
                    banner.currencyConversionRate = morsBanner.CurrencyConversionRate;
                    banner.toTargetCurrency = morsBanner.CurrencyConversionRate + ' ' + models.checkoutCart.purchase.amounts.total.currency_code;
                    banner.fromUnitCurrency = '1 ' + morsBanner.CartAmountCurrencyCode;
                    banner.merchantListingCurrency = models.checkoutCart.purchase.amounts.total.currency_code;
                }

                // Address US1226988
                if (morsBanner.OfferType === 'EZP' || morsBanner.OfferType === 'PALA') {
                    _logger.$logger.info('$xoCreditBannerUtils callDiscoverMessagesAndMapToBanner(): EZP Offer');
                    var creditSharedInfoModel = _index.$CreditSharedInfoModel.instance();
                    creditSharedInfoModel.setInstallmentOffer(banner);
                    creditSharedInfoModel.setInstallmentOfferFinancingDetails({
                        financing_code: banner.financingCode,
                        apr: banner.apr,
                        nominal_rate: banner.nominalRate,
                        credit_type: banner.ssotType,
                        total_cost: banner.totalDue,
                        total_interest: banner.totalInterest,
                        term: banner.term,
                        monthly_payment: banner.monthlyPayment,
                        currency: banner.monthlyPaymentCurrencyCode,
                        monthly_percentage_rate: banner.monthlyPercentageRate,
                        paypal_subsidy: banner.paypalSubsidy
                    });
                    creditSharedInfoModel.setInstallmentOfferPresent(true);
                }

                // Banner color experiment
                if (morsBanner.BackgroundType && morsBanner.BackgroundParams) {
                    banner.bannerColorObj = _this2.bannerColorExp(morsBanner.BackgroundType, morsBanner.BackgroundParams);
                }

                banner.buyItemId = creditOfferModel.getBannerMessage().id;
                banner.cachePlacementCode = '210004';
                banner.placementCode = creditOfferModel.getTouchpointCode();
                banner.HeadlineText = morsBanner.HeadlineText;
                banner.OfferText1 = morsBanner.OfferText1;
                banner.OfferText2 = morsBanner.OfferText2;
                banner.TermsLink = morsBanner.TermsLink;
                banner.TermsText = morsBanner.TermsText;
                banner.TermsLinkText = morsBanner.TermsLinkText;
                banner.PPCinWallet = _this2.isCreditInWallet(models.checkoutSession, models.checkoutCart.isBillingNoPurchase());
            } else {
                morsErr = creditOfferModel.MorsError || 'MORS_empty_message';
            }
            return { banner: banner, morsErr: morsErr };
        });
    },
    /**
     * Compares the equivalency of banner objects `base` & `compare`
     * @param base
     * @param compare
     * @returns Object {expected, actual}
     */
    compareAdObjects: function compareAdObjects(base, compare) {
        _logger.$logger.info('Comparing ad objects', { base_ad: base, recommended_message: compare });
        var diff = [];
        var keysToIgnore = ['campaignId', 'buyItemId', 'placementCode', 'impressionUrl', 'clickUrl', 'client_elapsed', 'req_elapsed', 'messageId'];

        if (!base) {
            diff.push('base_ad is not present');
        } else if (!compare) {
            diff.push('recommended_message is not present');
        } else {
            Object.keys(base).forEach(function (key) {
                if (keysToIgnore.indexOf(key) === -1) {
                    if (!compare[key]) {
                        if (base[key].toString().length > 0) {
                            diff.push({
                                key: key,
                                expected: base[key].toString(),
                                actual: undefined
                            });
                        }
                    } else if (compare[key].toString() !== base[key].toString()) {
                        diff.push({
                            key: key,
                            expected: base[key].toString(),
                            actual: compare[key].toString()
                        });
                    }
                }
            });
        }

        if (diff.length !== 0) {
            _logger.$logger.warn('recommended_message_warning', diff);
        }
    },

    /**
     * Experiment of banner color
     * @param backgroundType
     * @param backgroundParams
     * @returns {*}
     */
    bannerColorExp: function bannerColorExp(backgroundType, backgroundParams) {
        var bannerColorObj = void 0;
        if (backgroundType === 'flat') {
            bannerColorObj = {
                'background': '' + backgroundParams.trim()
            };
        }
        return bannerColorObj;
    }
};

angular.value("$xoCreditBannerUtils", $xoCreditBannerUtils);
_angular.$q;

_logger.$logger;

_squid.$locale;

_squid.$renderContent;

_squid.$feature;

_index.$CreditSharedInfoModel;

_index.$CreditInstallmentOptionsModel;

_index2.$CreditOfferModel;

_checkout.$CreditOptionsModel;

_index3.$DeviceInfo;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants.BANNER_TYPE;

_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID;

_xoCreditBannerConstants.INSTALLMENT_OPTIONS_SORT;

_constants.CREDIT_TYPE;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoPayWithCredit', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            var stateName = 'gce_pay_with_credit';

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
                // wallet and is not the current funding option

                // required to avoid looging every digest cycle.
                // TODO: remove this when debounce is fixed for logger
                var offerShown = false;

                $scope.showPayWithCredit = function () {
                    if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
                        offerShown = false;
                        return false;
                    }

                    var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
                    var minAmount = _angular.$window.config.minCreditAmtNoInterest[_squid.$locale.country];
                    var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
                    var fundingSource = $scope.checkoutSession.plan.sources;
                    var showOffer = _squid.$config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;

                    if (showOffer && minAmount && amount >= minAmount && hasCredit) {
                        for (var i in fundingSource) {
                            if (fundingSource[i].type === 'BILL_ME_LATER') {
                                offerShown = false;
                                return false;
                            }
                        }
                        if (!offerShown) {
                            _logger.$logger.info(stateName + '_offer_shown');
                        }
                        offerShown = true;
                        return true;
                    }
                    offerShown = false;
                    return false;
                };

                $scope.onSubmit = function () {
                    _logger.$logger.info(stateName + '_offer_clicked');
                    $scope.checkoutSession.message = null;

                    var instruments = $scope.checkoutSession && $scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.instruments;
                    var creditPlanId = void 0;

                    for (var i in instruments) {
                        if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
                            creditPlanId = instruments[i].planId;
                        }
                    }

                    if (!creditPlanId) {
                        _logger.$logger.info(stateName + '_credit_planid_not_found');
                        return;
                    }

                    return $scope.checkoutSession.fundingOptions.action('select', {
                        resultModel: $scope.checkoutSession,
                        data: {
                            planId: creditPlanId
                        },
                        success: function success() {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            _logger.$logger.info(stateName + '_success');
                        }
                    });
                };
            });
        }]
    };
});

_angular.$window;

_logger.$logger;

_squid.$config;

_squid.$locale;

_squid.$populate;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/pay-with-credit/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"pay-with-credit\" class=\"bmlCtaWrap\" ng-if=\"showPayWithCredit()\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div class=\"decreasedWidth noBottom\">\n            <p>{{ content('memberReview.switchToBml') }}</p>\n            <span class=\"disclaimer\" bind-html-compile=\"htmlContent('offers.seeBmlTerms')\"></span>\n        </div>\n        <a href=\"\" track-submit class=\"button-as-link edits\" ng-click=\"onSubmit()\">{{ content('common.select') }}</a>\n    </div>\n</div>\t"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var deContentKeys = exports.deContentKeys = {
    reuse: {
        installment: {
            logo: 'https://www.paypalobjects.com/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deReuseBodyText',
            bodyText2: 'offers.deReuseBodyText2',
            termsText: 'offers.deReuseTermsText'
        }
    },
    acq: {
        installment: {
            logo: 'https://www.paypalobjects.com/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deBodyText',
            bodyText2: 'offers.deBodyText2',
            termsText: 'offers.deTermsText',
            termsLinkText: 'offers.deTermsLinkText',
            termsLink: 'https://www.paypal.com/ppclander',
            statusText: 'offers.deStatusText'
        }
    }
};

var deOfferEligibleCartAmount = exports.deOfferEligibleCartAmount = {
    min: 99,
    max: 5000,
    currency: 'EUR'
};

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferDEBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _personalizationManager = __webpack_require__("../node_modules/xo-credit-components/src/lib/personalizationManager.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/styles.less");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferDEBanner = exports.$xoCreditOfferDEBanner = _squid.$Component.extend('$xoCreditOfferDEBanner', {
    tag: 'xo-credit-offer-de-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        },
        radio: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                creditSharedInfo: _index2.$CreditSharedInfoModel.instance()
            };
        },
        experiments: function experiments(resolvers) {}
    },
    actions: {
        clickTooltip: function clickTooltip(event) {
            // prevent click event on tooltip
            event.preventDefault();
        },
        handleModalClick: function handleModalClick(event) {
            // if click anywhere else except X button on modal, do nothing
            if (event.target.className !== 'close ng-scope') {
                event.preventDefault();
            }
        },
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        selectAcqBml: function selectAcqBml() {
            var financing_option_details = {
                credit_type: this.banner.ssotType,
                financing_code: this.banner.financingCode,
                apr: this.banner.apr,
                term: this.banner.term,
                total_cost: this.banner.totalDue,
                monthly_payment: this.banner.monthlyPayment,
                currency: this.banner.monthlyPaymentCurrencyCode,
                nominal_rate: this.banner.nominalRate
            };
            return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: financing_option_details });
        }
    },
    lifecycle: {
        enter: function enter() {
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            this.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            this.displayBannerType = null;
        },
        populate: function populate() {
            var _this = this;

            var self = this;
            self.models.creditData = _index2.$CreditDataModel.instance(this.props.token);
            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, isBillingNoPurchase);
            var contentKeys = isReuse ? _constants.deContentKeys.reuse : _constants.deContentKeys.acq;
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();

            var processBanner = function processBanner(banner) {
                if (banner) {
                    // use whatever banner returned from personalizationManager
                    self.banner = banner;

                    // stick cartAmount and cartCurrency into creditData so it's passed to CAPE
                    if (banner.cartAmount && banner.cartCurrency) {
                        self.models.creditData.setCartAmountAndCurrency({
                            cart_amount: banner.cartAmount,
                            cart_currency: banner.cartCurrency
                        });
                    }
                    // Send FPTI log
                    if (banner.messageId && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX) === 0) {
                            _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        }

                        // Send FPTI log if the banner is from ssot and it's not already sent
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_PREFIX) === 0) {
                            var bodyText = banner.bodyText;
                            var bodyText2 = banner.bodyText2;
                            var presentmentStyle = _xoCreditBannerConstants.bannerStyle.Prominent;
                            var presentmentType = isReuse ? _xoCreditBannerConstants.bannerTypes.REUSE : _xoCreditBannerConstants.bannerTypes.ACQ;
                            var bannerMessage = Object.assign({}, banner, { 'bodyText': bodyText + bodyText2 }, { 'banner_suppression_type': _xoCreditBannerConstants.DEFAULT_MESSAGE }, { 'presentmentStyle': presentmentStyle }, { 'presentmentType': presentmentType });
                            _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(_this.props.token, bannerMessage, isSecondButton, isCapeReturnKey));
                        }
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                    }

                    if (self.props.reusetext) {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE_FI;
                    } else {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.ACQ;
                        self.bannerColor = self.banner.bannerColorObj;
                    }
                } else {
                    self.displayBannerType = _xoCreditBannerConstants.bannerTypes.NONE;
                }
            };

            this.$watch('models.checkoutCart.grossTotalAmount', function () {
                if (self.banner) {
                    (0, _personalizationManager.personalizationManager)(_personalizationManager.PERSONALIZATION_PHASES.RAMP_NO_FALLBACK, self.props.token, self.models, contentKeys).then(function (banner) {
                        processBanner(banner);
                    });
                }
            });

            (0, _personalizationManager.personalizationManager)(_personalizationManager.PERSONALIZATION_PHASES.RAMP_NO_FALLBACK, self.props.token, self.models, contentKeys).then(function (banner) {
                processBanner(banner);
            });
        }
    }
});

angular.value("$xoCreditOfferDEBanner", $xoCreditOfferDEBanner);
_angular.noop;

_auth.$AuthModel;

_squid.$Component;

_logger.$logger;

_uiRouter.$state;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_xoCreditBannerConstants.bannerStyle;

_xoCreditBannerConstants.bannerTypes;

_xoCreditBannerConstants.DEFAULT_MESSAGE;

_xoCreditBannerConstants.DEFAULT_MESSAGE_PREFIX;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_index2.$CreditSharedInfoModel;

_index2.$CreditDataModel;

_personalizationManager.personalizationManager;

_personalizationManager.PERSONALIZATION_PHASES;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.deContentKeys;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"ppcBannerDE\" content>\n    <input type=\"hidden\" data-test-id=\"ppcBannerDeMessageId\" value=\"{{banner.messageId}}\"/>\n\n    <!-- ACQ Banner-->\n    <div ng-if=\"displayBannerType === bannerTypes.ACQ\"  id=\"bmlAcqOfferInfo\">\n\n        <div ng-if=\"!props.radio\">\n            <a track-click=\"acquisition_offer_banner\" link-button ng-click=\"actions.selectAcqBml()\"\n               class=\"ctaLink\" ng-bind-html=\"banner.ctaText\"\n               data-test-id=\"ppcBannerUkApplyButton\"/>\n        </div>\n\n        <div id=\"installmentOfferT1\" class=\"fiTableLayout\" ng-style=\"bannerColor\">\n            <div class=\"row\">\n                <div class=\"cell\">\n                    <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n                </div>\n                <div class=\"cell contentCell\">\n                    <div class=\"mainOfferText\">\n                        {{banner.bodyText}} <div ng-if=\"banner.statusText && banner.statusText.length > 0\" class=\"statusIndicator\">{{banner.statusText}}</div>\n                    </div>\n                    <div class=\"offerDetails\">\n                        <p class=\"offerText2\">\n                            <span>{{banner.bodyText2}}</span><span id=\"icon\">&nbsp;<a ng-if=\"+banner.apr === 0\" class=\"infoIcon\" href=\"#\" ng-click=\"actions.openModal()\"></a></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"termsAndConditions\">\n            <span ng-bind-html=\"banner.termsText\"/>\n            <span><a href=\"{{banner.termsLink}}\">{{banner.termsLinkText}}</a></span>\n        </div>\n\n        <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\"  ng-click=\"actions.handleModalClick($event)\">\n            <div class=\"installmentSummary\">\n                <div class=\"summary-header\">\n                    <p ng-bind-html=\"htmlContent('paymentMethod.installmentMonthlyDue',{term: banner.term, monthlyPayment: banner.formattedMonthlyPayment})\"></p>\n                </div>\n                <div class=\"summary-box\">\n                    <p >{{content('paymentMethod.transactionAmount')}}\n                        <a class=\"infoIcon\" href=\"#\" id=\"eMoney\"></a>\n                        <span class=\"float-right\">\n                            {{banner.formattedCartAmount}}\n                        </span></p>\n                    <xo-tooltip trigger=\"#eMoney\" show-event=\"click\" ng-click=\"actions.clickTooltip($event)\">\n                        {{ content('paymentMethod.eMoney') }}\n                    </xo-tooltip>\n                    <p>{{content('paymentMethod.interestAmount')}}\n                        <span class=\"float-right\">\n                            {{banner.formattedInterestAmount}}\n                        </span></p>\n                    <hr />\n                    <p>{{content('paymentMethod.totalAmount')}}\n                        <span class=\"float-right totalAmount\">\n                            {{banner.formattedTotalAmount}}\n                        </span></p>\n                </div>\n                <div class=\"summary-footer\">\n                    <p class=\"lenderText\">{{content('paymentMethod.lednerText')}}</p>\n                    <p>{{content('paymentMethod.installmentAgreement')}}</p>\n                </div>\n            </div>\n        </xo-modal>\n    </div>\n\n    <!-- Reuse text under PPC FI -->\n    <div id=\"bmlReuseOfferInfo\" class=\"reuseTextFI\" ng-if=\"displayBannerType === bannerTypes.REUSE_FI\">\n        <div>{{banner.bodyText}}</div>\n        <div>{{banner.bodyText2}}</div>\n        <div>{{banner.termsText}}</div>\n        <div ng-if=\"banner.termsText2 && banner.termsText2.length > 0\">{{banner.termsText2}}</div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOffer = undefined;

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/directive.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOffer = exports.$xoCreditOffer = _index.$Component.extend('$xoCreditOfferBannersDirective', {
    tag: 'xo-credit-offer-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        },
        radio: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },
    lifecycle: {
        enter: function enter() {},
        populate: function populate() {
            var self = this;
            self.buyerCountry = _index.$locale.country;
            self.showCreditBanner = false;
            self.models.creditData = _index3.$CreditDataModel.instance(self.props.token);
            self.models.creditSharedInfo = _index3.$CreditSharedInfoModel.instance();

            var isUSCrossCurrency = (self.models.checkoutCart && self.models.checkoutCart.grossTotalAmount && self.models.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && self.buyerCountry === 'US') === true;
            var isReturnFromCape = self.models.creditData && self.models.creditData.getCapeKey() && _index.$util.param('success') === 'true';

            // Hide representative example by default
            self.models.creditSharedInfo.setShowCreditExample(false);

            // Don't show credit banner if it's redirected from CAPE
            // or if it's US Cross Currency
            if (isReturnFromCape && !self.props.reusetext || isUSCrossCurrency) {
                return;
            }

            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isCreditSelected = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditSelected(self.models.checkoutSession, isBillingNoPurchase);
            // FI count is used in FPTI logs after calling MORS/DiscoverMessage for both US and UK
            self.models.creditSharedInfo.setFiCount(_xoCreditBannerUtils.$xoCreditBannerUtils.getFiCount(self.models.checkoutSession, isBillingNoPurchase));

            if (!isCreditSelected || self.props.reusetext) {
                // only show credit banner when PPC is not selected/no PPC
                self.showCreditBanner = true;
            }
        }
    }
});

angular.value("$xoCreditOffer", $xoCreditOffer);
_index.$Component;

_index.$locale;

_index.$util;

_index2.$CheckoutSessionModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index3.$CreditSharedInfoModel;

_index3.$CreditDataModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferGBBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferGBBanner = exports.$xoCreditOfferGBBanner = _squid.$Component.extend('$xoCreditOfferGBBanner', {
    tag: 'xo-credit-offer-gb-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                _this.models.creditData = _index2.$CreditDataModel.instance(_this.props.token);
                _this.models.creditSharedInfo = _index2.$CreditSharedInfoModel.instance();

                var userAction = models.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.get('purchase.items.length', 0) <= 0;
                return {
                    showCartAmount: (0, _pxp.$pxpCartAmt)(models.checkoutAppData.get('merchant.merchant_country'), models.payee.get('merchant.id'), noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
                        models.creditSharedInfo.setCartAmountVisible(showAmount);
                    }),
                    // This will call for the new CYCO experiment
                    redirect_to_cape_cyco: (0, _squid.$elmo)('xo_gb_ppc_cape_cyco', {
                        'ctx.COUNTRY': models.checkoutAppData.get('merchant.merchant_country'),
                        'ctx.merchantID': models.payee.get('merchant.id')
                    }, 'Trmt_xo_gb_ppc_cape_cyco', false, true).then(function (result) {
                        if (result && result.treatment_name) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                };
            });
        }
    },
    actions: {
        selectExistingBml: function selectExistingBml() {
            // This is called on UI when user clicks on "Select" link in reuse banner
            // might be sharable between country flows
            _logger.$logger.info('Select existing BML');
            var self = this;

            // FPTI tracking for when user clicks link for REUSE
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCReuse',
                'to': 'banner_click'
            });

            if (self.models.checkoutCart.isBillingNoPurchase()) {
                // if this is a BA-NOP transaction, set sticky FI and go to review page
                var fpList = self.models.checkoutSession.get('futurePaymentInstruments');
                var ppc = fpList.find(function (fp) {
                    return fp.type === 'BILL_ME_LATER';
                });
                self.models.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: ppc.instrument_id
                    },
                    success: function success(result) {
                        self.showReuseBannerFlag = false;
                        self.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        _uiRouter.$state.go('checkout.review');
                    }
                });
            } else {
                // Anything other than BA-NOP, we set fundingOption for this transaction and go to the next page
                var _fpList = self.models.checkoutSession.get('fundingOptions.instruments');
                var fundingSource = _fpList.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });

                self.models.checkoutSession.fundingOptions.action('select', {
                    resultModel: self.models.checkoutSession,
                    data: {
                        planId: fundingSource.planId
                    },
                    success: function success(result) {
                        // Do not show PPC banner after user selected PPC
                        self.showReuseBanner = false;

                        if (result) {
                            // Update the installments to support the user selecting a card that does not support installments.
                            self.models.checkoutSession.installments = result.installments;
                        }

                        // If selected fundingSource is CREDIT and there's installment offers present, we go to CYCO
                        if (fundingSource.type === 'CREDIT' && self.models.creditSharedInfo.hasInstallmentOffers()) {
                            if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                                _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                            } else {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            }
                        } else {
                            // otherwise, we go to review page
                            if (!fundingSource.selected) {
                                self.models.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
                                };
                                if (self.models.checkoutSession.selectedInstallmentData && !self.models.checkoutSession.selectedInstallmentData.preventChange) {
                                    // Resetting selected installment data, if installment change is not explicitly prohibited.
                                    self.models.checkoutSession.selectedInstallmentData = undefined;
                                }
                            }
                            _uiRouter.$state.go('checkout.review');
                        }
                    }
                });
            }
        },
        selectAcqBml: function selectAcqBml() {
            var self = this;
            // this is called on UI when user clicks on "Apply" link in ACQ banner
            // if installment offers are present, go CYCO.
            // otherwise, go CAPE

            // FPTI tracking for when user clicks link for ACQ
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCAcq',
                'to': 'banner_click'
            });
            if (self.models.creditSharedInfo.hasInstallmentOffers()) {
                // get elmo experiment for 3M or new CYCO experiments
                if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            } else {
                _uiRouter.$state.go('checkout.redirectToCape');
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            this.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            this.displayBannerType = null;
        },
        populate: function populate() {
            var self = this;

            var isBillingNoPurchase = self.models.checkoutCart.isBillingNoPurchase();
            var isReuse = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, isBillingNoPurchase);
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();

            if (self.experiments.redirect_to_cape_cyco) {
                // for the new cyco page in cape, user should go to CAPE based on the treatment value returned through elmo
                self.models.creditSharedInfo.setRedirectToCapeCyco(true);
            }

            self.displayBannerType = undefined;
            // putting bannerTypes into scope so we can use bannerTypes.REUSE or bannerTypes.ACQ in template.html
            self.bannerTypes = _xoCreditBannerConstants.bannerTypes;
            // personalizationManager(self.experiments.gb_personalization, self.props.token, self.models, contentKeys)
            _xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(this.props.token, this.models).then(function (_ref) {
                var banner = _ref.banner;

                if (banner) {
                    // use whatever banner returned from personalizationManager
                    self.banner = banner;

                    // stick cartAmount and cartCurrency into creditData so it's passed to CAPE
                    if (banner.cartAmount && banner.cartCurrency) {
                        self.models.creditData.setCartAmountAndCurrency({
                            cart_amount: banner.cartAmount,
                            cart_currency: banner.cartCurrency
                        });
                    }
                    if (self.props.reusetext) {
                        self.banner.presentmentStyle = 'WALLET';
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE_FI;
                    } else if (isReuse) {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.REUSE;
                    } else {
                        self.displayBannerType = _xoCreditBannerConstants.bannerTypes.ACQ;
                        self.bannerColor = self.banner.bannerColorObj;
                    }

                    // Send FPTI log if the banner is from personalization studio and it's not already sent
                    if (banner.messageId && (banner.messageId.indexOf(_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX) === 0 || banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID) === 0) && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        banner.payerId = self.models.checkoutSession.payer.id || '';
                        if (banner.messageId.indexOf(_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID) === 0) {
                            banner = _xoCreditBannerUtils.$xoCreditBannerUtils.collectFallbackBannerInfo(banner, isReuse, true);
                        }
                        _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                        _logger.$logger.flush();
                    }
                } else {
                    // Address US1226993. But need to be tested
                    self.displayBannerType = _xoCreditBannerConstants.bannerTypes.NONE;
                }

                // show UK credit example whenever we show credit banner
                if (self.displayBannerType !== _xoCreditBannerConstants.bannerTypes.NONE) {
                    self.models.creditSharedInfo.setShowCreditExample(true);
                }
            });
        }
    }
});

angular.value("$xoCreditOfferGBBanner", $xoCreditOfferGBBanner);
_angular.noop;

_logger.$logger;

_uiRouter.$state;

_squid.$Component;

_squid.$elmo;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$CreditSharedInfoModel;

_index2.$CreditDataModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_xoCreditBannerConstants.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants.bannerTypes;

_xoCreditBannerConstants.DEFAULT_MESSAGE_MSGID;

_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"ppcBannerUK\" content>\n    <input type=\"hidden\" data-test-id=\"ppcBannerUkMessageId\" value=\"{{banner.messageId}}\"/>\n\n    <!-- ACQ Banner-->\n    <div id=\"installmentOfferT1\" class=\"bmlCtaWrap prominentBanner creditBanner purpleBanner\"\n         ng-if=\"displayBannerType === bannerTypes.ACQ\" ng-style=\"bannerColor\">\n        <div class=\"bmlCtaHeader\">\n            <span class=\"prominentBannerIcon\">\n                <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n            </span>\n            <span class=\"bmlApplyLink\">\n                <a track-click=\"acquisition_offer_banner\" link-button ng-click=\"actions.selectAcqBml()\"\n                   class=\"proceed apply_uk_credit\" ng-bind-html=\"banner.ctaText\"\n                   data-test-id=\"ppcBannerUkApplyButton\"/>\n            </span>\n        </div>\n        <p class=\"bmlAcqOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\"/>\n        <p class=\"bmlAcqOfferText bannerLine\" ng-bind-html=\"banner.bodyText2\"/>\n    </div>\n\n    <!-- Conversion info for banner - only show for ACQ -->\n    <div class=\"conversion\" data-test-id=\"ppcBannerCrossCurrencyRate\" ng-if=\"displayBannerType === bannerTypes.ACQ && banner.crossCurrencyTransaction\">\n        <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n        <span class=\"conversionRate\">&nbsp;{{content('paymentMethod.conversionRate', {currencyFrom: banner.fromUnitCurrency, currencyTo: banner.toTargetCurrency})}}</span>\n    </div>\n\n    <!-- Reuse banner -->\n    <div id=\"bmlExistingOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"displayBannerType === bannerTypes.REUSE\">\n        <div class=\"bmlCtaHeader\">\n            <span class=\"prominentBannerIcon\">\n                <img ng-src=\"{{banner.logo}}\" alt=\"{{banner.logo}}\" />\n            </span>\n\n            <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                <a track-link=\"reuse_offer_banner\" link-button ng-click=\"actions.selectExistingBml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" />\n            </span>\n        </div>\n\n        <p class=\"bmlExistingOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\" />\n        <p class=\"bmlExistingOfferText bannerLine\" ng-bind-html=\"banner.bodyText2\" />\n    </div>\n\n    <!-- Reuse text under PPC FI -->\n    <div id=\"bmlReuseOfferInfo\" ng-if=\"displayBannerType === bannerTypes.REUSE_FI\">\n        <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"banner.bodyText2\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCreditExampleUkDirective', {
    tag: 'xo-credit-example-uk',
    template: _template2['default'],
    resolve: {
        experiments: function experiments() {
            var returnValue = {};

            return returnValue;
        }
    },
    lifecycle: {
        populate: function populate() {
            this.aprContent = _squid.$config.representativeExampleGB;
        }
    }
});


_squid.$Component;

_squid.$config;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"xoCreditExampleUk\" action=\"#\" method=\"POST\" >\n    <div class=\"representativeExample\">\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.header}}</p>\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.subHeader}}</p>\n        <table class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n            <tr class=\"span6\">\n                <td class=\"representativeExKey\">{{aprContent.purchaseRate}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.purchaseRateValue}}</td>\n            </tr>\n            <tr class=\"span6\">\n                <td class=\"representativeExKey\">{{aprContent.APR}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.APRValue}}</td>\n            </tr>\n            <tr class=\"span6 last\">\n                <td class=\"representativeExKey\">{{aprContent.creditLimit}}</td>\n                <td class=\"representativeExampleAPRAmount\">{{aprContent.creditLimitValue}}</td>\n            </tr>\n        </table>\n        <p class=\"disclaimer reviewMsg bmlLender\">{{aprContent.terms}}</p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xoCreditOfferBanners\" ng-if=\"showCreditBanner\">\n    <div ng-if=\"buyerCountry === 'GB'\">\n        <xo-credit-offer-gb-banners token=\"token\" reusetext=\"reusetext\" />\n    </div>\n    <div ng-if=\"buyerCountry === 'DE'\">\n        <xo-credit-offer-de-banners token=\"token\" reusetext=\"reusetext\" radio=\"radio\"/>\n    </div>\n    <div ng-if=\"buyerCountry === 'US'\">\n        <xo-credit-offer-us-banners token=\"token\" reusetext=\"reusetext\"/>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var US_TERMS = exports.US_TERMS = {
    acq: 'https://www.paypal.com/ppclander',
    reuse: 'https://www.paypal.com/ppclander',
    ezpTerms: 'https://www.paypal.com/us/webapps/mpp/credit-easy-payments?country=US&mid=H7EV58FZX96U6&sign=3UGhAgFlRIVa7Pw-EJTs9g'
};

var CREDIT_TYPE = exports.CREDIT_TYPE = {
    CORE: 'CORE',
    NI: 'NI',
    INST: 'PALA',
    BA: 'BA'
};

var RYI_OR = exports.RYI_OR = 'or';

var reuseRadioBannerContent = exports.reuseRadioBannerContent = {

    // No purchase or 0 cart amount flow
    NoP: {
        bodyText: 'offers.assetLite.bmlExistingOfferAmountZeroDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'

    },
    CORE: {
        bodyText: 'offers.assetLite.bmlExistingOfferSmallDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    BA: {
        bodyText: 'offers.assetLite.bmlExistingOfferSmallDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    NI: {
        bodyText: 'offers.assetLite.bmlExistingOfferLargeDetails',
        termsLink: US_TERMS.reuse,
        termsLinkText: 'offers.seeTermsText'
    },
    INST: {
        bodyText: 'offers.assetLite.bmlExistingOfferEZPDetails',
        ctaText: 'offers.assetLite.cycoOfferBtn'
    },
    THREEMONTHINSTCORE: {
        bodyText: 'offers.assetLite.bmlExistingOfferthreeMonthEZPDetails',
        ctaText: 'offers.assetLite.cycoOffersThreeMonthCoreBtn'
    },
    THREEMONTHINSTNI: {
        bodyText: 'offers.assetLite.bmlExistingOfferthreeMonthEZPDetails',
        ctaText: 'offers.assetLite.cycoOfferBtn'
    },
    THREEMONTHINSTRETURN: {
        bodyText: 'offers.assetLite.bmlReturnOfferthreeMonthEZPDetails'
    }
};

var usContentKeys = exports.usContentKeys = {
    reuse: {
        core: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferSmall',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        ba_nop: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferSmallDetails',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        ni: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferLarge',
            ctaText: 'offers.bmlOfferReuseCta',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.reuse
        },
        installment: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.bmlExistingOfferEZP',
            ctaText: 'offers.assetLite.cycoOfferBtn',
            termsLink: US_TERMS.ezpTerms
        },
        threeMonthInst: {
            bodyText: 'offers.bmlExistingOfferTitle',
            bodyText2: 'offers.assetLite.threeMonthINSTDetails',
            ctaText: 'offers.assetLite.cycoOfferBtn',
            termsLink: US_TERMS.ezpTerms
        }
    },
    acq: {
        core: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveDetails',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLinkText: 'offers.seeTermsText',
            termsLink: US_TERMS.acq

        },
        ba_nop: {
            bodyText2: 'offers.assetLite.bmlOfferTitleWithAmountZero',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.acq,
            termsLinkText: 'offers.seeTermsText'

        },
        ni: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveNIDetails',
            bodyText: 'offers.bmlOfferPassiveCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.acq,
            termsLinkText: 'offers.seeTermsText'

        },
        installment: {
            bodyText2: 'offers.assetLite.bmlOfferPassiveEZPDetails',
            bodyText: 'offers.bmlOfferPassiveEZPCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.ezpTerms
        },
        threeMonthInst: {
            bodyText2: 'offers.assetLite.threeMonthINSTDetails',
            bodyText: 'offers.assetLite.bmlOfferPassiveEZPCta',
            termsText: 'offers.subjectToApproval',
            termsLink: US_TERMS.ezpTerms,
            termsLinkText: 'offers.seeTermsText'
        }

    }
};

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCreditOfferUSBanner = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/styles.less");

var _xoCreditBannerConstants = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

var _utils = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/utils.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var _xoCreditBannerConstants2 = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCreditOfferUSBanner = exports.$xoCreditOfferUSBanner = _squid.$Component.extend('$xoCreditOfferUSBanner', {
    tag: 'xo-credit-offer-us-banners',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        reusetext: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                installmentOfferTypeModel: _index2.$CreditInstallmentModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        experiments: function experiments(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var userAction = models.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.get('purchase.items.length', 0) <= 0;
                _this.models.creditSharedInfo = _index2.$CreditSharedInfoModel.instance();

                return {
                    // this is shared between the two countries
                    showCartAmount: (0, _pxp.$pxpCartAmt)(models.checkoutAppData.get('merchant.merchant_country'), models.payee.get('merchant.id'), noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
                        models.creditSharedInfo.setCartAmountVisible(showAmount);
                    }),
                    // This will call for the new CYCO experiment
                    redirect_to_cape_cyco: (0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': models.checkoutAppData.get('merchant.merchant_country'),
                        'ctx.merchantID': models.payee.get('merchant.id')
                    }, 'Trmt_xo_us_ppc_.*', false, true).then(function (result) {
                        if (result && result.treatment_name) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                };
            });
        }
    },
    actions: {
        selectExistingBml: function selectExistingBml(offerType) {
            _logger.$logger.info('Select existing BML');
            var self = this;

            // FPTI tracking for when user clicks link for REUSE
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCReuse',
                'to': 'banner_click'
            });

            if (self.models.checkoutCart.isBillingNoPurchase()) {
                // if this is a BA-NOP transaction, set sticky FI and go to review page
                var fpList = self.models.checkoutSession.get('futurePaymentInstruments');
                var ppc = fpList.find(function (fp) {
                    return fp.type === 'BILL_ME_LATER';
                });
                this.models.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: ppc.instrument_id
                    },
                    success: function success(result) {
                        self.showReuseBannerFlag = false;
                        self.models.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                        _uiRouter.$state.go('checkout.review');
                    }
                });
            } else {

                // Anything other than BA-NOP, we set fundingOption for this transaction and go to the next page
                var _fpList = self.models.checkoutSession.get('fundingOptions.instruments');
                var fundingSource = _fpList.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
                // If the user has to redirect to CYCO to choose an installment offer, we do not want
                // to select PPC as an FI in case the click "checkout with PayPal" on CYCO instead.
                if (fundingSource && offerType === _constants.CREDIT_TYPE.INST) {
                    // get financing code from MORS/SSOT
                    // get elmo experiment
                    if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                        // add FPTI tracking here

                        _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                    } else {
                        _uiRouter.$state.go('checkout.chooseCreditOffer');
                    }
                } else {
                    // CORE and NI offers will select PPC because they skip CYCO
                    self.models.checkoutSession.fundingOptions.action('select', {
                        resultModel: self.models.checkoutSession,
                        data: {
                            planId: fundingSource.planId
                        },
                        success: function success(result) {
                            // Do not show PPC banner after user selected PPC
                            self.showReuseBanner = false;

                            if (result) {
                                // Update the installments to support the user selecting a card that does not support installments.
                                self.models.checkoutSession.installments = result.installments;
                            }

                            // If selected fundingSource is CREDIT and there's installment offers present, we go to CYCO
                            if (fundingSource.type === 'CREDIT' && self.models.creditSharedInfo.hasInstallmentOffers()) {
                                _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else {
                                // otherwise, we go to review page
                                if (!fundingSource.selected) {
                                    self.models.checkoutSession.message = {
                                        type: 'success',
                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                                    };
                                    if (self.models.checkoutSession.selectedInstallmentData && !self.models.checkoutSession.selectedInstallmentData.preventChange) {
                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
                                        self.models.checkoutSession.selectedInstallmentData = undefined;
                                    }
                                }
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                }
            }
        },
        selectAcqBml: function selectAcqBml() {
            // this is called on UI when user clicks on "Apply" link in ACQ banner
            // if installment offers are present, go CYCO.
            // otherwise, go CAPE

            // We now need to check our elmo experiment and the financing code to redirect to 
            // the new CYCO page in CAPE. 

            var self = this;

            // FPTI tracking for when user clicks link for ACQ
            _logger.$logger.info('checkout_fpti', {
                'from': 'clickPPCAcq',
                'to': 'banner_click'
            });

            if (self.models.creditSharedInfo.hasInstallmentOffers()) {
                // get elmo experiment for 3M or new CYCO experiments
                if (self.models.creditSharedInfo.getRedirectToCapeCyco()) {
                    // add FPTI tracking here 
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            } else {
                _uiRouter.$state.go('checkout.redirectToCape');
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var self = this;
            var cartAmount = self.models.checkoutCart.get('purchase.amounts.total.amount', 0);
            var baNOP = self.models.checkoutCart.isBillingNoPurchase();
            var isCreditInWallet = _xoCreditBannerUtils.$xoCreditBannerUtils.isCreditInWallet(self.models.checkoutSession, self.models.checkoutCart.isBillingNoPurchase());
            var customerType = isCreditInWallet ? _xoCreditBannerConstants.CUSTOMER_TYPE.REUSE : _xoCreditBannerConstants.CUSTOMER_TYPE.ACQ;
            var creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
            var isCapeReturnKey = creditDataModel && creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
            var isSecondButton = self.models.checkoutAppData.isSecondButton();
            self.or = _constants.RYI_OR; // 'or' string for grey line to split banner from FI's

            if (self.experiments.redirect_to_cape_cyco) {
                // for the new cyco page in cape, user should go to CAPE based on the treatment value returned through elmo
                self.models.creditSharedInfo.setRedirectToCapeCyco(true);
            }

            this.$watch('models.checkoutCart.grossTotalAmount', function () {

                if (self.banner) {
                    _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(self.props.token, self.models)).then(function (_ref) {
                        var banner = _ref.banner;

                        if (banner) {
                            self.banner = banner;
                        }
                    });
                }
            });

            _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callDiscoverMessagesAndMapToBanner(self.props.token, self.models)).then(function (_ref2) {
                var banner = _ref2.banner,
                    morsErr = _ref2.morsErr;

                // Constants for template logic
                self.CREDIT_TYPE = _constants.CREDIT_TYPE;
                self.CUSTOMER_TYPE = _xoCreditBannerConstants.CUSTOMER_TYPE;
                self.bannerType = _xoCreditBannerConstants.BANNER_TYPE;
                if (banner) {
                    _logger.$logger.info('us-banner/directive.js: displaying content from MORS/PS response');

                    // banner fields gotten back from MORS
                    self.banner = banner;
                    self.displayBanner = banner.presentmentStyle;
                    self.banner.showPassiveBanner = self.displayBanner === _xoCreditBannerConstants.BANNER_TYPE.PASSIVE;
                    self.customer = banner.offerCategory;
                    self.banner.incentives = banner.incentivesOffer;

                    if (self.customer === _xoCreditBannerConstants.CUSTOMER_TYPE.REUSE) {
                        // Set up content for wallet banner
                        // We want to set the experiment in the template only for NI offers. 

                        // When customer selects NI on CYCO page we want to update the banner content on RYI
                        var niSelectedOnCYCO = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType === _constants.CREDIT_TYPE.NI;
                        var offerSelected = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType;

                        var offerType = (0, _utils.getCreditType)(niSelectedOnCYCO, banner.offerType, baNOP, cartAmount);

                        // Sets up redirect for REUSE customers which click link in Reuse Banner
                        if (offerType === _constants.CREDIT_TYPE.INST) {
                            self.models.creditSharedInfo.setInstallmentOfferPresent(true);
                        }
                        var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                        var hasThreeMonthInstallment = threeMonthFinancingCodeArray.includes(banner.financingCode);

                        self.reuseWalletBanner = (0, _utils.getReuseRadioBannerInfo)(offerType, cartAmount, hasThreeMonthInstallment, isCapeReturn, offerSelected);
                        self.reuseWalletBanner.offerType = offerType;
                        if (self.props.reusetext) {
                            self.banner.presentmentStyle = 'WALLET';
                        }
                    }

                    // Send FPTI log if the banner is from personalization studio and it's not already sent
                    if (banner.messageId && banner.messageId.indexOf(_xoCreditBannerConstants2.PERSONALIZATION_MESSAGE_PREFIX) === 0 && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                        banner.payerId = self.models.checkoutSession.payer.id || '';
                        _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, banner, isSecondButton, isCapeReturnKey));
                        _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                        self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                        _logger.$logger.flush();
                    }
                } else {
                    // Fallback banners
                    var contentKeys = isCreditInWallet ? _constants.usContentKeys.reuse : _constants.usContentKeys.acq;
                    _logger.$logger.error('us-banner/directive.js: MORS call to PS failed, showing fallback banners');

                    // Call SSOT for special financing offers
                    _angular.$q.when(_xoCreditBannerUtils.$xoCreditBannerUtils.callSsotAndMapBanner(self.props.token, self.models, contentKeys)).then(function (ssot_banner) {
                        if (ssot_banner) {
                            self.banner = ssot_banner;

                            if (!self.experiments.redirect_to_cape_cyco && ssot_banner.hasThreeMonthOffer) {
                                // we receive a 3 month financing code from SSOT but user falls into treatment. We have to ignore the 
                                // offer and display and ALWAYS ON offer. We should remove this code once we are ramped to 100%
                                _logger.$logger.info('us-banner/directive.js: SSOT response with ' + (0, _squid.$feature)('threeMonthFinancingCode') + ' and elmo experiment: xo_us_ppc_ezp = ' + self.experiments.redirect_to_cape_cyco);

                                if (parseFloat(cartAmount) >= 99) {
                                    _logger.$logger.info('us-banner/directive.js: 3M fallback to NI Offer');
                                    self.banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(contentKeys.ni, { cartAmount: cartAmount });
                                    self.banner.offerType = _constants.CREDIT_TYPE.NI;
                                    ssot_banner = self.banner; // set for reuse condition below 
                                } else {
                                    // if we don't see any (either EZP or NI) offer from SSOT, it's always CORE
                                    _logger.$logger.info('us-banner/directive.js: 3M fallback to CORE Offer');
                                    self.banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(contentKeys.core, { cartAmount: cartAmount });
                                    self.banner.offerType = _constants.CREDIT_TYPE.CORE;
                                    ssot_banner = self.banner; // set for reuse condition below
                                }
                                self.models.creditSharedInfo.setInstallmentOfferPresent(false); // need this for redirect logic
                            }

                            self.displayBanner = _xoCreditBannerConstants.BANNER_TYPE.PASSIVE; // acquisition banner should be passive (will not impact reuse)
                            self.banner.showPassiveBanner = self.displayBanner === _xoCreditBannerConstants.BANNER_TYPE.PASSIVE;
                            self.customer = customerType;
                            self.banner.fallback = true;

                            // MORS call failed, this is fallback for REUSE banner in wallet
                            if (isCreditInWallet) {
                                _logger.$logger.info('us-banner/directive.js: Reuse customer wallet banner fallback');

                                // Set up content for wallet banner
                                // When customer selects NI on CYCO page we want to update the banner content on RYI
                                var _niSelectedOnCYCO = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType === _constants.CREDIT_TYPE.NI;
                                var _offerSelected = self.models.installmentOfferTypeModel && self.models.installmentOfferTypeModel.creditType;

                                var _offerType = (0, _utils.getCreditType)(_niSelectedOnCYCO, ssot_banner.offerType, baNOP, cartAmount);

                                // Sets up redirect for REUSE customers which click link in Reuse Banner
                                if (_offerType === _constants.CREDIT_TYPE.INST) {
                                    self.models.creditSharedInfo.setInstallmentOfferPresent(true);
                                }
                                self.reuseWalletBanner = (0, _utils.getReuseRadioBannerInfo)(_offerType, cartAmount, ssot_banner.hasThreeMonthOffer, isCapeReturn, _offerSelected);
                                self.reuseWalletBanner.offerType = _offerType;
                                if (self.props.reusetext) {
                                    self.banner.presentmentStyle = 'WALLET';
                                }
                            }

                            // Send FPTI log if the banner is from personalization studio and it's not already sent
                            if (ssot_banner.messageId && ssot_banner.messageId.indexOf(_xoCreditBannerConstants2.DEFAULT_MESSAGE_PREFIX) === 0 && !self.models.creditSharedInfo.getMorsFptiFiredFlag()) {
                                ssot_banner.payerId = self.models.checkoutSession.payer.id || '';
                                _logger.$logger.info('checkout_fpti', _xoCreditBannerUtils.$xoCreditBannerUtils.buildCreditOfferFptiObject(self.props.token, _xoCreditBannerUtils.$xoCreditBannerUtils.collectFallbackBannerInfo(self.banner, isCreditInWallet, isCreditInWallet), isSecondButton, isCapeReturnKey));

                                _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                                self.models.creditSharedInfo.setMorsFptiFiredFlag(true);
                                _logger.$logger.flush();
                            }
                        } else {
                            // SSOT and always on offer failed to be set. 
                            _logger.$logger.error('us-banner/directive.js: callSSOTAndMapBanner() did not return banner content.');
                            self.banner = undefined;
                            _logger.$logger.createCalRootTxn(_xoCreditBannerUtils.$xoCreditBannerUtils.buildPSMonitoringObject(self.props.token, banner, self.banner, morsErr), 'hermes_personalization');
                        }
                    });
                }
            });
        }
    }
});

angular.value("$xoCreditOfferUSBanner", $xoCreditOfferUSBanner);
_angular.noop;

_angular.$q;

_logger.$logger;

_uiRouter.$state;

_squid.$Component;

_squid.$elmo;

_squid.$feature;

_squid.$util;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index2.$CreditDataModel;

_index2.$CreditSharedInfoModel;

_index2.$CreditInstallmentModel;

_auth.$AuthModel;

_xoCreditBannerUtils.$xoCreditBannerUtils;

_pxp.$pxpCartAmt;

_xoCreditBannerConstants.BANNER_TYPE;

_xoCreditBannerConstants.CUSTOMER_TYPE;

_utils.getReuseRadioBannerInfo;

_utils.getCreditType;

_constants.CREDIT_TYPE;

_constants.usContentKeys;

_constants.RYI_OR;

_xoCreditBannerConstants2.PERSONALIZATION_MESSAGE_PREFIX;

_xoCreditBannerConstants2.DEFAULT_MESSAGE_PREFIX;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"usPPCBanners\">\n    <div ng-if=\"customer == CUSTOMER_TYPE.ACQ\">\n        <!-- ACQUISITON CUSTOMERS -->\n        <div id=\"bmlAcqOfferPassive\" class=\"payWithOption passiveBanner creditBanner\" ng-if=\"banner && displayBanner == bannerType.PASSIVE\">\n            <span class=\"plusicon\" ng-click=\"actions.selectAcqBml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\"></span>\n            <div class=\"payWithOptionBody\">\n                <div class=\"payWithOptionIcon\" ng-click=\"actions.selectAcqBml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\" tabindex=\"-1\">\n                    <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"banner.fallback\"></span>\n                    <img ng-src=\"{{banner.logo}}\" ng-if=\"!banner.fallback\" alt=\"{{htmlContent('paymentMethod.billmelater')}}\" />\n                </div>\n                <div class=\"payWithOptionContent\">\n                    <div><a href=\"#\" ng-click=\"actions.selectAcqBml()\" class=\"name proceed\" ng-bind-html=\"banner.bodyText\" track-link=\"acquisition_offer_banner_MORS\"\n                        data-test-id=\"passiveBannerApplyLink\"></a></div>\n                    <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText2\"></span></div>\n                    <div>\n                        <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                        <a href=\"{{banner.termsLink}}\"\n                        class=\"popup payWithOptionTermsLink\"\n                        target='_blank'\n                        ng-bind-html=\"banner.termsLinkText\"\n                        track-link=\"acquisition_offer_banner_MORS_terms_link\"></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n\n        <div id=\"bmlAcqOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"banner && displayBanner == bannerType.PROMINENT\">\n            <div class=\"prominentBannerSeparator\">\n                <span class=\"prominentBannerSeparatorLine\"></span>\n                <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"or\"></span>\n            </div>\n            <div class=\"bmlCtaWrap purpleBanner\" ng-style=\"banner.bannerColorObj\">\n                <div class=\"bmlCtaHeader\">\n                    <span class=\"prominentBannerIcon\">\n                        <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                    </span>\n                    <span class=\"bmlApplyLink\">\n                        <a href=\"#\" ng-click=\"actions.selectAcqBml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"\n                        data-test-id=\"ppcBannerApplyButton\"></a>\n                    </span>\n                </div>\n                <p class=\"bmlOfferTitle bannerLine\" ng-class=\"{'strongBmlOfferTitle': banner.incentives}\" ng-bind-html=\"banner.headlineText\"></p>\n                <p class=\"bmlOfferTitle bannerLine\" ng-class=\"{'strongBmlOfferTitle': banner.incentives}\" ng-bind-html=\"banner.bodyText\"></p>\n                <p id=\"bmlOfferTitleSecRow\" ng-if=\"banner.bodyText2\" class=\"bmlOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText2\"></p>\n                <p class=\"offerSmallText bannerLine\">\n                    <span class=\"seeTermsLink ng-scope\" ng-bind-html=\"banner.termsText\"></span>\n                    <a href='{{banner.termsLink}}'\n                        class='popup bmlTermsLink'\n                        target='_blank'\n                        ng-bind-html=\"banner.termsLinkText\"\n                        track-link=\"acquisition_offer_banner_MORS_terms_link\"\n                        xo-popup></a>\n                </p>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"customer == CUSTOMER_TYPE.REUSE\">\n        <!-- REUSE CUSTOMERS -->\n        <div ng-if=\"reusetext\">\n            <!-- Reuse text under FI's in wallet -->\n            <div id=\"bmlReuseOfferInfo\">\n                <div ng-if=\"reuseWalletBanner.offerType != CREDIT_TYPE.NI\">\n                    <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"reuseWalletBanner.bodyText\"></span>\n                    <span class=\"seeTermsLink ng-scope\">\n                        <a href='{{reuseWalletBanner.termsLink}}'\n                            class='popup bmlTermsLink' target='_blank'\n                            xo-popup>{{reuseWalletBanner.termsLinkText}}</a>\n                    </span>\n                    <span ng-if=\"reuseWalletBanner.offerType == CREDIT_TYPE.INST\" class=\"bmlChangeLink\">\n                        <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"actions.selectExistingBml(reuseWalletBanner.offerType); $event.stopPropagation();\" class=\"proceed\"\n                            ng-bind-html=\"reuseWalletBanner.ctaText\"></a>\n                    </span>\n                </div>\n                <div ng-class=\"checkMarkWrapper\" ng-if=\"reuseWalletBanner.offerType == CREDIT_TYPE.NI\">\n                    <div class=\"checkmark\">\n                        <span class=\"greenCheck\" />\n                        <span class=\"offerInfoCheck ng-binding ng-scope\">\n                                {{reuseWalletBanner.bodyText}}\n                                <a href='{{reuseWalletBanner.termsLink}}'\n                                class='popup seeTermsLink bmlTermsLink' target='_blank'\n                                xo-popup>{{reuseWalletBanner.termsLinkText}}</a>\n                        </span>\n                    </div>\n                    <div class=\"checkmark\">\n                        <span class=\"greenCheck\" />\n                        <span class=\"offerInfoCheck ng-binding ng-scope\" ng-bind-html=\"reuseWalletBanner.bodyText2\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"!reusetext\">\n            <!-- Reuse Prominent Banner content-->\n            <div id=\"bmlExistingOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"!reuseText && banner\">\n                <div class=\"prominentBannerSeparator\">\n                    <span class=\"prominentBannerSeparatorLine\"></span>\n                    <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"or\"></span>\n                </div>\n                <div class=\"bmlCtaWrap\">\n                    <div class=\"bmlCtaHeader\">\n                        <span class=\"prominentBannerIcon\">\n                            <span class=\"creditIcon\" ng-if=\"banner.fallback\"></span>\n                            <img ng-src=\"{{banner.logo}}\" ng-if=\"!banner.fallback\" />\n                        </span>\n                        <span class=\"bmlChangeLink bmlChangeLinkInBanner\">\n                            <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"actions.selectExistingBml(banner.offerType)\" class=\"proceed\"\n                            data-test-id=\"ppcBannerApplyButton\" ng-bind-html=\"banner.ctaText\"></a>\n                        </span>\n                    </div>\n                    <p class=\"bmlExistingOfferTitle bannerLine\" ng-bind-html=\"banner.bodyText\"></p>\n                    <p class=\"bmlExistingOfferText bannerLine\"\n                            ng-bind-html=\"banner.bodyText2\"></p>\n                    <p class=\"seeTermsLink ng-scope bannerLine\">\n                        <a href='{{banner.termsLink}}'\n                            class='popup bmlTermsLink'\n                            target='_blank'\n                            ng-bind-html=\"banner.termsLinkText\"\n                            track-link=\"reuse_offer_banner_MORS_terms_link\"\n                            xo-popup></a>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getReuseRadioBannerInfo = exports.getCreditType = undefined;

var _xoCreditBannerUtils = __webpack_require__("../node_modules/xo-credit-components/src/lib/xo-credit-banner-utils.js");

var _constants = __webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/us-banner/constants.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var alwaysOnOffer = function alwaysOnOffer(cartAmount) {
    // In case MORS fails we want to have an offer available based on cart amount
    if (cartAmount <= 99) {
        return _constants.CREDIT_TYPE.CORE;
    } else {
        return _constants.CREDIT_TYPE.NI;
    }
};

var getCreditType = exports.getCreditType = function getCreditType(niSelectedOnCyco, psBannerOfferType, isBaNOP, cartAmount) {
    // Check if there is an offer already selected
    // This is the scenario where user has EZP but selects SAC or NI
    var creditType = void 0;

    if (isBaNOP) {
        creditType = _constants.CREDIT_TYPE.BA;
    } else if (niSelectedOnCyco) {
        // NI selected from CYCO page (for wallet banner content change on RYI)
        creditType = _constants.CREDIT_TYPE.NI;
    } else if (psBannerOfferType) {
        // Check PS offer type
        creditType = psBannerOfferType;
    } else {
        return alwaysOnOffer(cartAmount);
    }
    _logger.$logger.info('us-banner/utils getCreditType(): showing user creditType of ', creditType);
    return creditType;
};

var getReuseRadioBannerInfo = exports.getReuseRadioBannerInfo = function getReuseRadioBannerInfo(creditType, amount, hasThreeMonthInstallment, isCapeReturn, offerSelected) {
    // No purchase or 0 cart amount flow
    if (!amount || amount === '') {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.NoP);
    } else if (creditType === _constants.CREDIT_TYPE.CORE || creditType === _constants.CREDIT_TYPE.BA) {
        return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.CORE);
    } else if (creditType === _constants.CREDIT_TYPE.NI) {
        var banner = {};
        banner = _constants.reuseRadioBannerContent.NI;
        banner.bodyText2 = 'offers.assetLite.bmlOfferCheckMark2';
        banner = _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(banner);
        return banner;
    } else if (creditType === _constants.CREDIT_TYPE.INST) {
        if (hasThreeMonthInstallment) {
            if (isCapeReturn && offerSelected) {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTRETURN);
            } else if (parseFloat(amount) >= 99) {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTNI);
            } else {
                return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.THREEMONTHINSTCORE);
            }
        } else {
            return _xoCreditBannerUtils.$xoCreditBannerUtils.renderContentByKey(_constants.reuseRadioBannerContent.INST);
        }
    }
};

_xoCreditBannerUtils.$xoCreditBannerUtils;

_constants.reuseRadioBannerContent;

_constants.CREDIT_TYPE;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoOfferTopBanner', {
    tag: 'xo-offer-top-banner',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.isTopBannerVisible = false;
        $scope.offerTopBanner = {};

        // this data comes from an $emit() call in:
        // xo-credit-components/src/offer/directive.js
        var unbind = _angular.$rootScope.$on('setOfferTopBanner', function (event, data) {
            $scope.offerTopBanner = data;
            $scope.isTopBannerVisible = true;
        });

        $scope.$on('$destroy', unbind);
    }]
});


_squid.$Component;

_angular.$rootScope;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-credit-components/src/xo-offer-top-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n  ng-if=\"isTopBannerVisible\"\n  class=\"xo-offer-top-banner-container\"\n>\n  <div class=\"banner-container\">\n    <img\n      src=\"https://www.paypalobjects.com/webstatic/credit/img/PPClogo_banner.png\"\n      width=\"52\"\n    />\n    <div class=\"body-text\">\n      <span ng-bind-html=\"offerTopBanner.banner.bodyText\"></span>\n    </div>\n    <div>\n      <a\n        href=\"#\"\n        class=\"apply-btn\"\n        ng-click=\"offerTopBanner.bml()\"\n        ng-bind-html=\"offerTopBanner.banner.ctaText\"\n      >\n      </a>\n    </div>\n    <div class=\"terms-container\">\n      <span ng-bind-html=\"offerTopBanner.banner.termsText\"></span>\n      <a\n        href=\"{{offerTopBanner.banner.termsLink}}\"\n        class=\"popup smallPopup bmlTermsLink\"\n        target=\"_blank\"\n        xo-popup\n        track-link=\"acquisition_offer_banner_MORS_terms_link\"\n        ng-bind-html=\"offerTopBanner.banner.termsLinkText\"\n      >\n      </a>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$DeviceInfo', function () {
    var userAgent = _angular.$window.navigator.userAgent;
    var standalone = _angular.$window.navigator.standalone;
    var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
    var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
    var IOS_PATTERN = /iP(hone|od|ad)/i;

    function getIntegrationContext(integrationKey) {
        // additonal context sent via partners in regards to integration
        var integrationContext = _squid.$meta.integrationCTX || {};

        return integrationContext[integrationKey];
    }

    // Supports iOS and Android. Updated / more accurate method of detecting webviews
    function isWebView() {
        var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;

        var ios = /iphone|ipod|ipad/i.test(ua);
        var android = /Android/i.test(ua);

        if (ios) {
            // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
            // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
            var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);

            if (!standalone && ios_uiwebview && !isSafariViewController()) {
                // uiwebview
                logWebView('iOS');
                return true;
            }
        } else if (android) {
            // not iOS, Android platform handling
            // Whitelist for x-requested-with header values for web view detection
            var allowedXRequestedWithRegexMap = {
                ajax: /XMLHttpRequest/i,
                baiduBrowser: /com.baidu.browser.inter/i,
                operaMini: /com.opera.mini.native/i,
                maxthon: /com.mx.browser/i,
                litterPenguinBrowser: /com.explore.web.browser/i
            };
            var xRequestedWithHeaderVal = _squid.$meta.requestHeaders['x-requested-with'];

            if (xRequestedWithHeaderVal) {
                // check if x-requested-with header val is in whitelist
                for (var key in allowedXRequestedWithRegexMap) {
                    if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
                        if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
                            return false;
                        }
                    }
                }
                logWebView('Android');
                return true;
            }
        }

        return false;

        function logWebView(device) {
            if (!logEnabled) {
                return;
            }
            // cal log
            _logger.$logger.info('WebView :: ' + device);
        }
    }

    /**
     * Check if the given the user-agent string is belongs to a device.
     */
    function isDevice() {
        if (_angular2['default'].isString(userAgent)) {
            return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a tablet.
     */
    function isTablet() {
        if (_angular2['default'].isString(userAgent)) {
            return TABLET_PATTERN.test(userAgent);
        }

        return false;
    }

    /**
     * Check if the given the user-agent string is belongs to a mobile
     */
    function isMobile() {
        return isDevice(userAgent) && !isTablet(userAgent);
    }

    /**
     * Get the mobile platform value given the user-agent string.
     */
    function getDevicePlatform() {
        if (_angular2['default'].isString(userAgent)) {
            var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);

            if (matched && matched.length > 0) {
                return matched[0];
            }
        }
    }

    /**
     * Check if the give user agent is from an app.
     */
    function isApp(uaString) {
        userAgent = uaString || userAgent;

        if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
            if (getDevicePlatform(userAgent) === 'Android') {
                return (/Version\/\d.\d/i.test(userAgent)
                );
            }

            return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
            );
        }

        return false;
    }

    function isSafariViewController() {
        if (getIntegrationContext('brainTreeIntegration') === 'SFVC') {
            return true;
        }
        if (_angular2['default'].isString(userAgent)) {
            var ios = /iphone|ipod|ipad/i.test(userAgent);

            return ios && _angular.$window.indexedDB && isApp();
        } else {
            return false;
        }
    }

    /**
     * Get the device capabilities
     */
    function getCapabilities() {
        var capabilities = {};
        var device = DEVICE_PATTERN.test(userAgent);
        var tablet = TABLET_PATTERN.test(userAgent);
        var app = isApp(userAgent);

        if (_angular2['default'].isString(userAgent)) {
            capabilities.isWireless = device || tablet;
            capabilities.isTablet = tablet;
            capabilities.isMobile = device && !tablet;
            capabilities.isDesktop = !device;
            capabilities.isApp = app;
        }
        return capabilities;
    }

    /**
     * Get various AppIntegrationType
     */
    function getAppIntegrationType() {
        var app_int_type = void 0;

        if (isDevice()) {
            if (isApp()) {
                if (isSafariViewController()) {
                    app_int_type = 'SFVC';
                } else {
                    app_int_type = 'WebView';
                }
            } else {
                app_int_type = 'Browser';
            }
        }
        return app_int_type;
    }

    function isSafariiOSBrowserView() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);
        var safari = /safari/i.test(ua);
        var isIOSApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
        var isChromeOnIOS = /(.*?CriOS)/i.test(ua);
        var isFirefoxOnIOS = /(.*?FxiOS)/i.test(ua);
        var isSafariBrowserOnly = safari && !isChromeOnIOS && !isFirefoxOnIOS;

        return ios && !standalone && isSafariBrowserOnly && !isIOSApp;
    }

    function getiOSVersion() {
        var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userAgent;

        var ios = IOS_PATTERN.test(ua);

        if (ios) {
            var version = ua.match(/OS (\d+)_(\d+)/);
            return [parseInt(version[1], 10), parseInt(version[2], 10)];
        }
        return false;
    }

    return {
        isDevice: isDevice,
        isTablet: isTablet,
        isMobile: isMobile,
        isApp: isApp,
        isSafariViewController: isSafariViewController,
        getCapabilities: getCapabilities,
        getAppIntegrationType: getAppIntegrationType,
        isWebView: isWebView,
        isSafariiOSBrowserView: isSafariiOSBrowserView,
        getiOSVersion: getiOSVersion
    };
});

_squid.$meta;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-device-info/dist", "../node_modules/xo-device-info/dist/index.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.VALID_DIRECTION = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/language-options/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
    return VALID_DIRECTION.includes(n);
};

angular.module().directive('xoLanguageOptions', function () {
    return {
        template: _template2['default'],

        scope: {
            direction: '@?'
        },

        controller: ['$scope', function ($scope) {
            $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
            $scope.showLanguages = false;

            function setLanguageVars() {
                $scope.localeModel = _squid.$locale;
                $scope.currentLanguage = $scope.localeModel.lang;
                $scope.currentCountry = $scope.localeModel.country;
                $scope.languageList = $scope.localeModel.metadata.languageLabel;
                $scope.supportedLanguages = _squid.$config.supportedCountries[$scope.currentCountry];
                $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
            }

            $scope.selectLanguage = function (language) {
                $scope.currentLanguage = language;
                _squid.$locale.chooseLang(language);
            };

            $scope.toggle = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.showLanguages = !$scope.showLanguages;
            };

            setLanguageVars();

            // Reset locale properties for languageToggle
            $scope.$on('localeChange', function () {
                setLanguageVars();
            });

            // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
            $scope.$on('clickBody', function ($event, target) {
                if ($(target).parents('.languageToggleDisplay div').length === 0) {
                    $scope.showLanguages = false;
                    $scope.$apply();
                }
            });
        }]
    };
});

_squid.$config;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"{{ direction }}\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages track by $index\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var callbackShippingOptions = void 0,
    fallbackShippingOptions = void 0,
    callbackInsuranceOffered = void 0; // Import the decodeEntities angular filter

var defaultFallbackOptionIndex = void 0;

exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
    tag: 'xo-select-shipping-method',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        },
        showShippingAddress: {
            type: 'var',
            required: false
        },
        errorHandlerHelper: {
            type: 'var',
            required: false
        },
        instantUpdateFeature: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve(),
                creditDataModel: _credit.$CreditDataModel.instance(this.props.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
        },
        openModal: function openModal() {
            this.showModal = true;
        },
        continueHandler: function continueHandler() {

            /**
             * Function responsible to patch Cart for
             * 1. Buyer select's a new shipping method.
             * 2. Buyer chooses to opt for insurance or chooses not to.
             */
            if (this.selectedMethod.current.index !== this.selectedMethod.previous.index || this.selectedMethod.current.insuranceSelected !== this.selectedMethod.previous.insuranceSelected) {

                var selectedMethodCharges = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;

                selectedMethodCharges = this.response.charges[this.selectedMethod.current.index];
                taxAmtApplied = this.getTax(selectedMethodCharges);
                insurance = this.getInsurance(selectedMethodCharges);
                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
                if (this.isInstantUpdateFlow) {
                    this.selectedMethod.showInsuranceAmount = this.selectedMethod.current.insuranceSelected;
                    this.insuranceApplied = insurance;
                    this.updateSelectedExternalCallbackOption(this.response.shipping_options_source, this.selectedMethod.previous.index, this.selectedMethod.current.index);
                    this.selectedMethod.previous.insuranceSelected = this.selectedMethod.current.insuranceSelected;
                }
                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type, insurance);
                this.selectedShippingMethod = selectedMethodCharges.shipping_charge.shipping_method;
                this.selectedMethod.previous.index = this.selectedMethod.current.index;
            }

            this.actions.closeModal();
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.selectedMethod = {
                current: {
                    index: 0,
                    insuranceSelected: false
                },
                previous: {
                    index: 0,
                    insuranceSelected: false
                },
                insuranceAvailable: false,
                showInsuranceAmount: false
            };

            // Initialization
            this.showModal = false;
            this.shippingInfoDisplay = 'noHighlight';
            this.addressChanged = false;

            var timer = void 0;

            this.previousCosts = {};

            // Function used to format amount based on currency code
            this.formatAmount = function (amount) {
                if (amount && amount.value) {
                    var amountToBeFormatted = (parseInt(amount.value.toString(), 10) / 100).toFixed(2);

                    if (amountToBeFormatted) {
                        return (0, _squid.formatCurrency)(amountToBeFormatted, _this.currencyCode);
                    }
                }
            };

            this.uncheckInsuranceCheckbox = function () {
                _this.selectedMethod.current.insuranceSelected = false;
            };

            this.showInsurance = function (selectedIndex) {
                return Number(_this.selectedMethod.current.index) === selectedIndex;
            };

            // Function to check if is insurance is offered for a shipping charge
            this.isInsuranceOfferedInCharge = function (charge) {
                return charge.shipping_charge.offer_insurance_option;
            };

            var responseHasShippingCharges = function responseHasShippingCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].shipping_charge;
            };

            var responseHasTaxCharges = function responseHasTaxCharges() {
                if (_this.response.charges.length === 0) {
                    return false;
                }
                return !!_this.response.charges[0].tax;
            };

            this.safeConvert = function (value) {
                value = Number(value);
                if (isNaN(value)) {
                    throw new Error(value + ' cannot be divided');
                }
                return value / 100;
            };

            /*
             This function is responsible to update the previously selected external callback option to newly selected one.
             */
            this.updateSelectedExternalCallbackOption = function (optionsSource, prevIndex, index) {
                if (optionsSource === 'CALLBACK' && callbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        callbackShippingOptions[prevIndex].is_selected = false;
                    }
                    callbackShippingOptions[index].is_selected = true;
                } else if (optionsSource === 'FALLBACK' && fallbackShippingOptions) {
                    if (!isNaN(prevIndex)) {
                        fallbackShippingOptions[prevIndex].is_selected = false;
                    }
                    fallbackShippingOptions[index].is_selected = true;
                }
            };

            var highlight = function highlight(duration) {
                _this.shippingInfoDisplay = 'highlight';
                if (timer) {
                    _angular.$timeout.cancel(timer);
                }
                timer = (0, _angular.$timeout)(function () {
                    _this.shippingInfoDisplay = 'noHighlight';
                }, duration);
            };

            this.getTax = function (charge) {
                var tax = void 0;

                if (!_this.isInstantUpdateFlow && (_this.isBuyNow || _this.isCartUpload) && _this.cartAmounts.taxAmt >= 0) {
                    tax = _this.cartAmounts.taxAmt;
                }
                // tax calculation
                else {
                        charge = charge || responseHasTaxCharges() && _this.response.charges[0];
                        if (charge && charge.tax && charge.tax.total_tax) {
                            tax = _this.safeConvert(charge.tax.total_tax.value);
                        }
                    }
                return tax;
            };

            /**
             * Function to return the insurance from shipping charge.
             * 1. By default return insurance amount from the charge.
             * 2. In case insurance is offered and is not chosen , do not return the insurance amount.
             * @param charge - shipping charge
             * @param index - index of the shipping charge
             */
            this.getInsurance = function (charge) {
                if (charge && charge.shipping_charge && charge.shipping_charge.insurance_amount) {
                    if (charge.shipping_charge.offer_insurance_option && !_this.selectedMethod.current.insuranceSelected) {
                        return;
                    }
                    return _this.safeConvert(charge.shipping_charge.insurance_amount.value);
                }
            };

            var updatePreviousCosts = function updatePreviousCosts() {
                _this.previousCosts = {};
                if (_this.models.checkoutCart.purchase.amounts.shipping) {
                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
                }
                if (_this.models.checkoutCart.purchase.amounts.tax) {
                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
                }
            };

            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
                if (newShipping !== undefined) {
                    return newShipping.amount !== _this.previousCosts.shippingAmount;
                }
                return newShipping !== _this.previousCosts.shippingAmount;
            };

            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
                if (newTax !== undefined) {
                    return newTax.amount !== _this.previousCosts.taxAmount;
                }
                return newTax !== _this.previousCosts.taxAmount;
            };

            var setToolTipMessage = function setToolTipMessage() {
                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
            };

            var addExternalCallBackOptionsToPatchRequest = function addExternalCallBackOptionsToPatchRequest(patchEntities) {
                var externalCallbackOptions = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;

                if (_this.response.shipping_options_source === 'CALLBACK') {
                    externalCallbackOptions.callback_shipping_options = callbackShippingOptions;
                    externalCallbackOptions.callback_insurance_option_offered = callbackInsuranceOffered;
                } else if (_this.response.shipping_options_source === 'FALLBACK') {
                    externalCallbackOptions.fallback_shipping_options = fallbackShippingOptions;

                    // if callback shipping option failed, delete it as fallback is default now
                    // use case , say if buyer changes shipping address multiple times and the first attempt callback success
                    // and second attempt callback failed, as patchCart of first attempt updated checkout session we may endup in having
                    // both callback and fallback shipping option , and only one if possible (useful) from checkout session
                    // delete the callback as it is not always source of shipping charge
                    delete externalCallbackOptions.callback_shipping_options;
                }

                patchEntities.push({
                    field: 'externalCallbackOptions',
                    value: externalCallbackOptions
                });
            };

            var populatePatchShippingDetails = function populatePatchShippingDetails(patchEntities, shipMethod) {
                if (_this.isInstantUpdateFlow) {
                    addExternalCallBackOptionsToPatchRequest(patchEntities);
                } else {
                    patchEntities.push({
                        field: 'shippingMethod',
                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
                    });
                }
            };

            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
                var newTotal = _this.cartAmounts.total;

                Object.keys(patchableAmountEntities).forEach(function (key) {
                    var detail = patchableAmountEntities[key];

                    if (!isNaN(detail.value)) {
                        detail.value = Number(detail.value);
                        amounts.details[key] = detail.value.toFixed(decimalDigits);
                    } else {
                        detail.value = 0;
                    }
                    newTotal += detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
                });
                amounts.total = newTotal.toFixed(decimalDigits);
                Object.keys(constantAmountEntities).forEach(function (key) {
                    var detail = constantAmountEntities[key];

                    if (detail.valueInCart !== undefined) {
                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
                    }
                });
            };

            // Generates the request body to be used for patch Cart
            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
                // 1. amount values in the cart,
                // 2. shipping method (only in case of non instant update flows)
                // 3. external_callback_options (only in case of instant update flows)

                var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];

                if (isNaN(decimalDigits)) {
                    decimalDigits = 2;
                }
                var patchEntities = [];
                var amounts = {
                    'currency': _this.currencyCode,
                    'details': {
                        'subtotal': _this.cartAmounts.subTotal.toFixed(decimalDigits)
                    }
                };
                var patchableAmountEntities = {
                    shipping: {
                        value: shippingAmt,
                        valueInCart: _this.cartAmounts.shippingAmt
                    },
                    tax: {
                        value: taxAmt,
                        valueInCart: _this.cartAmounts.taxAmt
                    },
                    insurance: {
                        value: insuranceAmt,
                        valueInCart: _this.cartAmounts.insuranceAmt
                    }
                };

                // amount details which are not affected by SnT response,
                // but still need to get included in the patch request if initially present
                var constantAmountEntities = {
                    handling_fee: {
                        valueInCart: _this.cartAmounts.handlingAmt
                    },
                    shipping_discount: {
                        valueInCart: _this.cartAmounts.shippingDiscountAmt
                    },
                    discount: {
                        valueInCart: _this.cartAmounts.discountAmt
                    }
                };

                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);

                patchEntities.push({
                    field: 'purchaseAmount',
                    value: amounts
                });

                populatePatchShippingDetails(patchEntities, shipMethod);

                return {
                    id: _this.token,
                    patchEntities: patchEntities
                };
            };

            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod, insurance) {
                _this.models.checkoutCart.action('patchCartData', {
                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod, insurance),
                    success: function success(result) {
                        _this.models.checkoutSession.invalidate();
                        (0, _squid.$populate)(_this, {
                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
                        }).then(function () {
                            // update checkout cart model with item information
                            // this is for displaying additional item information in cart
                            // any modification here need check in xo-page-component-> cart directive also
                            _this.models.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                                item.details = {};

                                if (item.quantity > 1) {
                                    item.details.price = item.price.amount;
                                    item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                                }

                                if (item.description) {
                                    if (!item.name) {
                                        item.name = item.description;
                                    } else {
                                        item.details.description = item.description;
                                    }
                                }

                                // move options to detail section
                                if (item.item_option_selections) {
                                    item.details.hasSelections = true;
                                    item.details.item_option_selections = item.item_option_selections;
                                }

                                if (item.sku) {
                                    item.details.sku = item.sku;
                                }

                                item.hasDetails = Object.keys(item.details).length > 0;
                                item.details.hasMore = item.hasDetails || item.details.hasSelections;
                            });
                        }).then(function () {
                            highlight(4000);
                            if (_this.addressChanged) {
                                setToolTipMessage();
                                _this.addressChanged = false;
                            }
                            updatePreviousCosts();
                        });
                    }
                });
            };

            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
                var charges = _this.response && _this.response.charges;

                if (charges) {
                    callbackShippingOptions = charges.map(function (charge, index) {
                        var shippingCharge = charge.shipping_charge;
                        var taxCharge = charge.tax;
                        var option = {};

                        if (shippingCharge) {
                            option = {
                                method: shippingCharge.shipping_method,
                                amount: {
                                    value: _this.safeConvert(shippingCharge.shipping_amount.value),
                                    currency: shippingCharge.shipping_amount.currency_code
                                },
                                is_default: shippingCharge.default_method,
                                is_selected: false
                            };
                            if (shippingCharge.insurance_amount) {
                                option.insurance = {
                                    value: _this.safeConvert(shippingCharge.insurance_amount.value),
                                    currency: shippingCharge.insurance_amount.currency_code
                                };
                                callbackInsuranceOffered = shippingCharge.offer_insurance_option;
                            }
                            if (taxCharge) {
                                option.tax = {
                                    value: _this.safeConvert(taxCharge.total_tax.value),
                                    currency: taxCharge.total_tax.currency_code
                                };
                            }
                        }
                        return option;
                    });
                }
            };

            var setDefaultShippingMethod = function setDefaultShippingMethod() {
                _this.showShippingOptions = true;
                var chargesElement = void 0,
                    methodType = void 0,
                    taxAmtApplied = void 0,
                    insurance = void 0;

                for (var i = 0; i < _this.response.charges.length; i++) {
                    chargesElement = _this.response.charges[i];
                    if (chargesElement.shipping_charge.default_method) {
                        _this.selectedMethod.current.index = i;
                        _this.selectedMethod.previous.index = i;
                        insurance = _this.getInsurance(chargesElement);
                        if (_this.isInstantUpdateFlow) {
                            _this.updateSelectedExternalCallbackOption(_this.response.shipping_options_source, _this.selectedMethod.previous.index, _this.selectedMethod.current.index);
                        }
                        _this.selectedShippingMethod = chargesElement.shipping_charge.shipping_method;
                        methodType = chargesElement.shipping_charge.shipping_method_type;
                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);

                        taxAmtApplied = _this.getTax(chargesElement);

                        insurance = _this.getInsurance(chargesElement);

                        break;
                    }
                }
                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType, insurance);
            };

            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
            };

            // Find the charges of the default option and patch cart with corresponding values.
            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
                var defaultOption = void 0,
                    shippingAmt = void 0,
                    taxAmt = void 0,
                    insuranceAmt = void 0,
                    methodType = void 0;

                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(defaultFallbackOptionIndex)) {
                    defaultOption = fallbackShippingOptions[defaultFallbackOptionIndex];
                }
                if (defaultOption) {
                    shippingAmt = defaultOption.amount && defaultOption.amount.value;
                    taxAmt = defaultOption.tax && defaultOption.tax.value;
                    insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
                    methodType = defaultOption.shipping_method_type || 'DEFAULT';
                }
                _this.updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
            };

            /**
             Function to enable the link to select insurance's by the user if offered in charges
             */
            var enableUserToChooseInsuranceOptionsIfAvailable = function enableUserToChooseInsuranceOptionsIfAvailable() {
                var charges = _this.response && _this.response.charges;

                if (!charges) {
                    return;
                }
                for (var i = 0; i < charges.length; i++) {
                    if (_this.isInsuranceOfferedInCharge(charges[i])) {
                        _this.selectedMethod.insuranceAvailable = true;
                        _this.selectedMethod.showInsuranceAmount = false;
                        break;
                    }
                }
            };

            /*  Function which is responsible to process shipping tax response
             Use cases
             ---------
             1. (i) WPS: If response has shipping charges and shipping options are to be shown, set default shipping method else patch cart
             with shipping amount returned.
             (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
             2. If no_shipping = 1
             (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
             (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
             3. Apply tax if applicable.
             */
            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {

                var applicableShippingAmt = void 0,
                    applicableTaxAmt = void 0;

                if (_this.isInstantUpdateFlow) {
                    if (!_this.response.shipping_region_supported) {
                        _this.errorHandlerHelper.addPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.nonEmptyMerchantDisplayName });
                        _this.instantUpdateFeature.shippingRegionSupported = false;
                    }

                    if (_this.response.shipping_options_source === 'CALLBACK') {
                        populateCallbackShippingOptions();
                    }

                    enableUserToChooseInsuranceOptionsIfAvailable();

                    // no_shipping = 0
                    if (_this.showShippingAddress) {
                        if (responseHasShippingCharges()) {
                            setDefaultShippingMethod();
                        }
                    }
                    // no_shipping=1 in case of instant update api , hide the overlay, shipping and tax from default fallback or callback options should be applied
                    else {
                            _this.showShippingOptions = false;
                            updateShippingTaxChargeWithDefaultOption();
                        }
                    return;
                }

                // shipping calculation
                if (_this.showShippingAddress) {
                    if (responseHasShippingCharges()) {
                        if (_this.response.show_shipping_options) {
                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
                            return;
                        } else if (_this.response.charges[0].shipping_charge.shipping_amount) {
                            // if no shipping options , try to get the shipping amount if returned from SNTService
                            applicableShippingAmt = _this.safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
                        }
                    }
                }
                // when not instant update flow , no_shipping is 1, shipping is applied only when override is true and shipping is passed in button
                else if (_this.response.profile_override_allowed) {
                        if (_this.cartAmounts.shippingAmt !== undefined) {
                            applicableShippingAmt = _this.cartAmounts.shippingAmt;
                        }
                    }

                applicableTaxAmt = _this.getTax();

                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
                }
            };

            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
                for (var i = 0; i < fallbackShippingOptions.length; i++) {
                    fallbackShippingOptions[i].is_selected = false;
                }
            };

            this.getShippingMethods = function () {
                _this.showShippingOptions = false;
                _this.selectedShippingMethod = '';
                _this.shippingAmtApplied = 0;
                _this.insuranceAmountOffered = 0;
                _this.response = {};

                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();

                var sntRequest = {
                    'address': shippingAddress,
                    'cart_weight': _this.cartWeight,
                    'cart_handling': { value: _this.cartAmounts.handlingAmt, currency_code: _this.currencyCode },
                    'discount': _this.cartDiscount,
                    'item_list': _this.models.checkoutCart.purchase.items,
                    'tax_on_shipping_required': _this.showShippingAddress, //    tax on shipping is not applicable when no_shipping is 1
                    'merchant_id': _this.models.checkoutPayee.merchant.id,
                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry,
                    'currency_code': _this.currencyCode,
                    'id': _this.token
                };

                if (_this.isInstantUpdateFlow) {
                    _this.selectedMethod = {
                        current: {
                            index: 0,
                            insuranceSelected: false
                        },
                        previous: {
                            index: 0,
                            insuranceSelected: false
                        },
                        insuranceAvailable: false,
                        showInsuranceAmount: false
                    };
                    callbackShippingOptions = [];
                    callbackInsuranceOffered = false;
                    clearFallbackOptionsSelectionFlags();
                    _this.instantUpdateFeature.shippingRegionSupported = true;
                    _this.errorHandlerHelper.clearPageErrors();

                    if (_this.models.checkoutCart.purchaseUnits && _this.models.checkoutCart.purchaseUnits[0]) {
                        sntRequest.external_callback_options = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
                    }
                }

                _this.shippingMethods = new _index.$ShippingMethodModel(sntRequest);

                _logger.$logger.info('calculate_shipping_charges_call');
                _this.shippingMethods.save({
                    data: _this.shippingMethods,
                    success: function success(result) {
                        _this.response = result;
                        processShippingAndTaxResponse();
                    }
                });
            };
        },
        populate: function populate() {
            var _this2 = this;

            var set = function set(key, value) {
                if (value) {
                    _this2.cartAmounts[key] = Number(value.amount);
                }
            };

            function hasAddressChanged(newValue, oldValue, isInstantUpdateFlow) {
                // only these values determine if the shiptax service needs to be called again
                var countryZipStateCityChanged = newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;

                if (!countryZipStateCityChanged && isInstantUpdateFlow) {
                    // For instant update flow any change of address variable must trigger a call to shiptax
                    var anyAddressFieldChanged = newValue.line1 !== oldValue.line1 || newValue.line2 !== oldValue.line2;

                    return anyAddressFieldChanged;
                }

                return countryZipStateCityChanged;
            }

            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;

            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;

            // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
            // then we need the value of merchantDisplayName to be 'The merchant' as it is the first word
            // in page level error below (look for place where nonEmptyMerchantDisplayName var is used)
            this.nonEmptyMerchantDisplayName = this.models.checkoutAppData && this.models.checkoutAppData.getMerchantDisplayName({
                nonEmptyReturnValue: true,
                isSentenceBeginning: true
            });

            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;

            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;

            this.isInstantUpdateFlow = this.models.checkoutCart && this.models.checkoutCart.instantUpdateIntegration;

            if (this.isInstantUpdateFlow) {
                fallbackShippingOptions = this.models.checkoutCart.purchaseUnits[0].external_callback_options.fallback_shipping_options;
                if (fallbackShippingOptions) {
                    defaultFallbackOptionIndex = _squid.$util.findIndex(fallbackShippingOptions, function (option) {
                        return option.is_default;
                    });
                }
            }

            this.cartAmounts = {};
            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
            set('total', this.models.checkoutCart.purchase.amounts.total);
            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
            this.previousCosts = {
                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
            };

            if (this.models.checkoutCart.cartWeight) {
                this.cartWeight = {};
                if (this.models.checkoutCart.cartWeight.value) {
                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
                }
                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
            }

            if (this.models.checkoutCart.purchase.amounts.discount) {
                this.cartDiscount = {
                    value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
                    currency_code: this.currencyCode
                };
            }

            if (this.showShippingAddress) {
                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
                    if (hasAddressChanged(newValue, oldValue, _this2.isInstantUpdateFlow)) {
                        _this2.addressChanged = true;
                        _this2.getShippingMethods();
                    }
                });
            }

            // if all the following conditions are true, we will be queuing the execution of
            // getShippingMethods once the credit-return-flow is completed. In details:
            // - is this the ReturnFromCape flow?
            // - was the credit application approved?
            // - is the return flow still running?
            // - this flow does not requires a change of Installments?
            var isCapeReturnInProgress = this.models.creditDataModel.getCapeKey() && _squid.$util.param('success') && !this.models.creditDataModel.isReturnFromCapeComplete() && !this.models.creditDataModel.isChangeStatus();
            if (isCapeReturnInProgress) {
                _logger.$logger.info('watching_return_from_cape_complete');
                this.$watch('this.models.creditDataModel.return_from_cape_complete', function (newValue, oldValue) {
                    if (newValue === true && oldValue === false) {
                        _this2.getShippingMethods();
                    }
                });
            } else {
                this.getShippingMethods();
            }
        }
    }
});


_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$util;

_squid.formatCurrency;

_squid.formatQuantity;

_index.$ShippingMethodModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutShippingAddressesModel;

_index2.$CheckoutAppDataModel;

_logger.$logger;

_credit.$CreditDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-method/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingMethod\" content>\n    <div id=\"selectShippingMethodContainer\" ng-if=\"showShippingOptions\">\n        <div id=\"storePickUpDetails\" ng-if=\"models.checkoutCart.isShippingMethodStorePickUp()\">\n            <hr class=\"lightHR\">\n            <div class=\"shipTo\">{{ content('shippingMethod.shipTo') }}</div>\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div id=\"shippingInformation\">\n            <div id=\"methodCharges\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"shippingText\">{{ content('shippingMethod.shipping') }}:</span>\n            <span>\n                <a id=\"shippingMethodCharge\" class=changeShippingMethod link-button aria-label=\"{{ content('shippingMethod.selectMethod')}}\"\n                    ng-click=\"actions.openModal()\" focus-when=\"!showModal\" focused-once-before>\n                    <span class=\"selectedShippingMethod\">{{selectedShippingMethod | decodeEntities}} - </span>\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"shippingAmtApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n            <div id=\"insuranceInfo\" ng-if=\"selectedMethod.insuranceAvailable\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"insuranceText\">{{ content('shippingMethod.shippingInsurance') }}:</span>\n            <span>\n                <a id=\"insuranceNoneApplied\" ng-if=\"!selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.insuranceNoneSelected') }}\" ng-click=\"actions.openModal()\">\n                    <span class=\"noInsuranceOption\"> {{ content('shippingMethod.insuranceNoneSelected')}}</span>\n                </a>\n                <a id=\"insuranceAmtOffered\" ng-if=\"selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.shippingInsurance') }}\" ng-click=\"actions.openModal()\">\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"insuranceApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n        </div>\n        <xo-modal show=showModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n            <div class=\"shippingMethodsContainer\">\n                <div>\n                    <div class=\"shippingOptions\">\n                        <span class=\"shippingHeader\" id=\"shippingHeader1\">{{ content('shippingMethod.selectMethod') }}</span>\n                        <span class=\"gamma\" id=\"shippingHeader2\">{{ content('shippingMethod.merchantOptions') }}</span>\n                        <br>\n                        <div>\n                            <div ng-repeat=\"charge in response.charges track by $index\">\n                                <div class=\"row-fluid radioButton\">\n                                    <input type=\"radio\" name=\"shippingMethodRadioButton\" id=\"{{$index}}\" value=\"{{$index}}\" ng-model=\"selectedMethod.current.index\" ng-change=\"isInstantUpdateFlow && uncheckInsuranceCheckbox()\"/>\n                                    <label class=\"noBottom\" for=\"{{$index}}\">\n                                            <span class=\"methodContents\">\n                                        <span>\n                                            <span>\n                                                <span class=\"methodName\">\n                                                    {{charge.shipping_charge.shipping_method | decodeEntities}} -\n                                                </span>\n                                                <span class=\"shippingCharge\">\n                                                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"charge.shipping_charge.shipping_amount.value / 100\"></format-currency>\n                                                </span>\n                                            </span>\n                                            <span class=\"deliveryTime\">\n                                                {{charge.shipping_charge.delivery_time}}\n                                            </span>\n                                            <span class=\"description animate-show\" ng-if=\"shippingMethods.isStorePickUp(charge.shipping_charge.shipping_method_type)\" ng-show=\"selectedMethod.current.index == $index\">\n                                                {{ content('shippingMethod.storeLocationInfo') }}\n                                            </span>\n                                        </span>\n                                        <span ng-if=\"charge.shipping_charge.offer_insurance_option\" ng-show=\"showInsurance($index)\" class=\"insuranceOfferedInOption checkbox\">\n                                            <input ng-model=\"selectedMethod.current.insuranceSelected\" type=\"checkbox\" id=\"insurance\" value=\"false\">\n                                            <label for=\"insurance\" ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance', { amount: formatAmount(charge.shipping_charge.insurance_amount) })\"></label>\n                                        </span>\n                                    </span>\n                                    </label>\n                                </div>\n                                <hr class=\"hr\" ng-if=\"!$last\">\n                            </div>\n                        </div>\n                        <input id=\"confirmShippingMethod\" type=\"button\" class=\"confirmation btn\" value=\"{{ content('shippingMethod.continue') }}\" ng-click=\"actions.continueHandler()\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"logo\"></div>\n        </xo-modal>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/styles.less");

var _template = __webpack_require__("../node_modules/xo-login-components/src/create-password/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CONTENT_KEY_MAP = {
    ADD_CARD: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddCard'
    },
    ADD_SHIPPING: {
        benefitsKey: 'passwordRecovery.stepUpBenefits',
        reasonKey: 'passwordRecovery.stepUpAddShipping'
    },
    APPLY_PPC: {
        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
        reasonKey: 'passwordRecovery.stepUpApplyPPC'
    },
    GENERIC: {
        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
        reasonKey: 'passwordRecovery.stepUpGeneric'
    },
    NEW_PHONE: {
        reasonKey: 'passwordRecovery.stepUpNewPhone'
    },
    NEED_US_ADDRESS: {
        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
    },
    CARD_EXPIRED: {
        reasonKey: 'passwordRecovery.stepUpCardExpired'
    },
    MERCHANT_NOT_ACCEPT_AMEX: {
        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
    },
    NEED_CREDIT_CARD: {
        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
    },
    PAYER_AUTHENTICATION_REQUIRED: {
        reasonKey: 'passwordRecovery.stepUpNewAddress'
    },
    BILLING_AGREEMENTS: {
        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
    },
    GENERIC_CONTINGENCY: {
        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
    }
};

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
    tag: 'xo-create-password',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onCancel: {
            type: 'var',
            required: false
        },
        reason: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
            this.getReasonKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
            };

            this.getBenefitsKey = function () {
                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
            };
            this.onSubmit = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'quick_security_check',
                    to: 'process_quick_security_check'
                });
                _this.onContinue();
            };
        }
    }
});


_squid.$Component;

_squid.$util;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/create-password/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"createPassword\" content>\n    <div class=\"heading\">{{content('passwordRecovery.quickSecurityCheck')}}</div>\n\n    <div class=\"msg\">{{content(getReasonKey())}}</div>\n\n    <div class=\"msg\">{{content(getBenefitsKey())}}</div>\n\n    <button class=\"btn full continueBtn\" ng-click=\"onSubmit()\">{{content('common.continueLabel')}}</button>\n    <div ng-if=\"onCancel\" class=\"cancelLink\"><a ng-click=\"onCancel($event)\">{{content('common.cancel')}}</a></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/dolphin/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/dolphin/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-dolphin',
    template: _template2['default'],
    actions: {
        startTimer: function startTimer() {
            var _this = this;

            _logger.$logger.info('xoDolphin_startTimer');
            // Set a 10 second timer to check if UL has loaded or not
            this.isTimerRunning = true;
            (0, _angular.$timeout)(function () {
                if (!_this.hasOverlayLoaded && _this.isTimerRunning) {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_timeout',
                        'context_id': _angular.$rootScope.token
                    });
                    _this.isTimerRunning = false;
                    _this.showSpinner = false;
                }
            }, this.timerDuration);
        },
        closeBanner: function closeBanner() {
            this.showBanner = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'close_banner',
                'context_id': _angular.$rootScope.token
            });
        },
        openOverlay: function openOverlay() {
            var _this2 = this;

            var onPostMessagesHandler = function onPostMessagesHandler(postMessage) {
                if (!angular.isObject(postMessage)) {
                    try {
                        postMessage = JSON.parse(postMessage);
                    } catch (e) {
                        _logger.$logger.info('xoDolphin_jsonParseFailed');
                    }
                }

                if (!postMessage || !postMessage.data || !postMessage.data.event) {
                    _logger.$logger.info('xoDolphin_invalidPostMessage');
                    return;
                }

                _this2.showSpinner = false;

                if (postMessage.data.event === 'phoneConfirmationLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _angular.$rootScope.$emit('loaded');
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'overlay_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'phoneConfirmationCompleted') {
                    _this2.isPhoneConfirmed = true;
                    // For auto triggered overlays (confirm3 & add3), the banner is hidden by default
                    // Unhide it once phone confirmation completes or SMS to complete it is sent out
                    if (_this2.toastParams.autoTriggeredOverlay) {
                        _logger.$logger.info('xoDolphin_showBannerOnAutoTriggeredOverlay');
                        _this2.showBanner = true;
                    }
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'successfully_confirmed',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'smsSent') {
                    // Set isPhoneConfirmed to true as user will complete the phone confirmation from sms
                    // hence from app point of view it s completed for the 'current' request
                    // Also, the experience is exactly the same (show success message)
                    _this2.isPhoneConfirmed = true;
                    _this2.successContent = _this2.toastParams.smsSentKey;
                    _this2.showBanner = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'sms_sent',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'phoneConfirmationError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'generic_error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'close') {
                    _this2.hasOverlayLoaded = true;
                    _this2.actions.closeOverlay();
                }

                // One Touch WPS Post Messages
                if (postMessage.data.event === 'oneTouchWPSError') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'error',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }

                if (postMessage.data.event === 'oneTouchWPSViewLoaded') {
                    _this2.hasOverlayLoaded = true;
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'view_loaded',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'oneTouchWPSActivateButtonClicked') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'activate',
                        'context_id': _angular.$rootScope.token
                    });
                }

                if (postMessage.data.event === 'oneTouchWPSSuccess') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'success',
                        'context_id': _angular.$rootScope.token
                    });
                    (0, _angular.$timeout)(function () {
                        _this2.actions.closeOverlay();
                    }, 3000);
                }

                if (postMessage.data.event === 'oneTouchWPSNotNowClicked') {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'one_touch_wps',
                        'to': 'not_now',
                        'context_id': _angular.$rootScope.token
                    });
                    _this2.actions.closeOverlay();
                }
            };
            (0, _angular.$timeout)(function () {
                _logger.$logger.info(_utils.flowName, {
                    'from': 'show_banner',
                    'to': 'show_overlay',
                    'context_id': _angular.$rootScope.token
                });

                _this2.$element.addClass('overlayOpen').promise().then(function () {
                    // Note: A second timeout is added here to avoid a race condition where the DOM is not yet available
                    // for the inject script to pick a targetElement for injecting the iframe.
                    (0, _angular.$timeout)(function () {
                        var variant = _this2.toastParams && _this2.toastParams.variant;
                        var options = (0, _utils.getInjectULBaseObject)(variant);
                        options.onPostMessage = onPostMessagesHandler;
                        if (!options.targetElement) {
                            _logger.$logger.info('xoDolphin_missingTargetElement');
                        }
                        // Since, One Touch interstitial has a spinnner with lock icon
                        // hidinng this spinnner for consistent experience
                        if (variant !== 'wpsOneTouchInterstitial') {
                            _this2.showSpinner = true;
                        }
                        if (window.PAYPAL && window.PAYPAL.unifiedLogin && options.targetElement) {
                            _logger.$logger.info('xoDolphin_injectIframe');
                            window.PAYPAL.unifiedLogin.inject(options);
                            _this2.actions.startTimer();
                        }
                    });
                });
            });
        },
        closeOverlay: function closeOverlay() {
            var _this3 = this;

            this.$element.removeClass('overlayOpen');
            this.isTimerRunning = false;
            this.showSpinner = false;
            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': 'overlay_closed',
                'context_id': _angular.$rootScope.token
            });
            (0, _angular.$timeout)(function () {
                _logger.$logger.info('xoDolphin_hideOverlay');
                _this3.showOverlay = false;
                _this3.hasOverlayLoaded = false;
            }, 300);
        }
    },
    lifecycle: {
        enter: function enter() {
            var ulToast = _squid.$util.param('ulToast') || _squid.$util.param('ulToastWpsDone');
            this.toastParams = ulToast && _utils.variantParams[ulToast];
            this.isPhoneConfirmed = false;
            this.hasOverlayLoaded = false;
            this.isTimerRunning = false;
            this.timerDuration = 10000;
        },
        populate: function populate() {
            var _this4 = this;

            if (!this.toastParams) {
                _logger.$logger.info('Missing or invalid toast param!');
                return;
            }

            this.showBanner = !this.toastParams.autoTriggeredOverlay;
            this.showOverlay = this.toastParams.autoTriggeredOverlay;
            this.bannerContent = this.toastParams.messageKey;
            this.successContent = this.toastParams.successKey;
            this.autoTriggeredOverlay = this.toastParams.autoTriggeredOverlay;
            this.variant = this.toastParams.variant;
            // DeviceInfo doesnt seem to have isDesktop, hence just avoiding the mobile use case
            this.fixedBanner = _index.$DeviceInfo.isMobile() ? '' : 'dolphinBannerFixed';

            _logger.$logger.info(_utils.flowName, {
                'from': 'show_banner',
                'to': this.toastParams.transitionName,
                'banner_type': this.toastParams.bannerType,
                'context_id': _angular.$rootScope.token
            });

            // Cannot use `$apply` as we need to wait for the entire digest cycle to complete
            (0, _angular.$timeout)(function () {
                if (_this4.autoTriggeredOverlay) {
                    _this4.actions.openOverlay();
                    return;
                }
                angular.element('#confirmPhoneBtn').on('click', function () {
                    _logger.$logger.info(_utils.flowName, {
                        'from': 'show_banner',
                        'to': 'click_link',
                        'context_id': _angular.$rootScope.token
                    });
                    _this4.showOverlay = true;
                    // Allow overlay DOM to be added before animating it in
                    (0, _angular.$timeout)(_this4.actions.openOverlay, 150);
                });
                // Add a delay to open the overlay when it's A) auto trigger and B) Not WPS OR
                // Add a delay to open the overlay when it's A) auto trigger and B) WPS Done with One Touch variant
                // `ulToastWpsDone` will be added by UL only if it is indeed a WPS flow
            }, this.autoTriggeredOverlay && !_squid.$util.param('ulToastWpsDone') || this.autoTriggeredOverlay && _squid.$util.param('ulToastWpsDone') === 'wpsOneTouchInterstitial' ? 1800 : 0);
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_utils.getInjectULBaseObject;

_utils.flowName;

_utils.variantParams;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dolphinContainer\" ng-if=\"showBanner\">\n    <section class=\"dolphinBanner {{ fixedBanner }}\" content>\n        <div class=\"dolphinBannerContent {{ variant }}\" ng-if=\"!isPhoneConfirmed\" ng-bind-html=\"htmlContent(bannerContent)\"></div>\n        <div class=\"dolphinBannerContent\" ng-if=\"isPhoneConfirmed\">\n            <span class=\"dolphinBannerSuccessIcon\"></span>\n            <span class=\"dolphinBannerSuccessContent\">{{ content(successContent) }}</p>\n        </div>\n        <div class=\"dolphinBannerCloseIcon\" ng-click=\"actions.closeBanner()\"></div>\n    </section>\n</div>\n<section ng-if=\"showOverlay\" class=\"pageOverlay\">\n    <div ng-if=\"!autoTriggeredOverlay\" class=\"overlayMask\"></div>\n    <div ng-if=\"autoTriggeredOverlay\" class=\"overlayAutoTriggerMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"actions.closeOverlay()\"></a>\n                <div id=\"injectedULPhoneConfirmation\"></div>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n    <div ng-if=\"showSpinner\" class=\"spinner\">\n        <div class=\"spinWrap\">\n            <p class=\"loader\"></p>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getDolphinEligibility = exports.variantParams = exports.flowName = exports.getInjectULBaseObject = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var getCreditInterstitialEligibility = function getCreditInterstitialEligibility() {
    // TODO: Refactor the usage of PXP result stored in rootScope once Credit team make a change to this
    var creditInterstitialPXPResult = _angular.$rootScope['creditInterstitialPXPResult'];
    var creditInterstitialControl = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_control';
    // If there is a value && it is not Control, then it's any of the treatments
    return creditInterstitialPXPResult && creditInterstitialPXPResult !== creditInterstitialControl;
};

var getInjectULBaseObject = exports.getInjectULBaseObject = function getInjectULBaseObject(variant) {
    var options = {
        config: {
            name: 'PPFrameRedirect',
            height: 577
        },
        queryParams: {
            intent: variant === 'add3' || variant === 'confirm3' || 'wpsOneTouchInterstitial' ? 'xoAutoTrigger' : 'xoToast',
            flowId: _angular.$rootScope.token,
            flowInfo: _uiRouter.$state.current && _uiRouter.$state.current.name,
            'country.x': _squid.$locale.country,
            'locale.x': _squid.$locale.getLocaleCode()
        },
        iframePathname: '/signin/phone-confirmation',
        targetElement: document.getElementById('injectedULPhoneConfirmation')
    };
    if (variant === 'wpsOneTouchInterstitial') {
        options.queryParams.flowName = 'wpsOneTouchInterstitial';
        options.iframePathname = '/signin/activate-one-touch';
    }
    return options;
};

var flowName = exports.flowName = 'ul_dolphin';

// A simple object to map all the properties specific to a particular variant
// Not creating a function & abstracting common things for the sake of simplicity
// Once the performance is measured, only 1 of the 4 variants will be left behind
// and this object will have only 2 props again.
// A variant prop is added to define the class name in the template
// The query param's value is not used directly to avoid XSS
var variantParams = exports.variantParams = {
    confirm: {
        messageKey: 'login.confirmPhone',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_link',
        // `variant` uses a hardcoded value for th ulToast query param
        // it is used later in the flow from here instead of the query param
        variant: 'confirm'
    },
    confirm1: {
        messageKey: 'login.confirmPhoneWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'short_text_button',
        variant: 'confirm1'
    },
    confirm2: {
        messageKey: 'login.confirmPhoneLongWithButton',
        successKey: 'login.confirmPhoneSuccess',
        transitionName: 'confirm_phone',
        bannerType: 'long_text_button',
        variant: 'confirm2'
    },
    confirm3: {
        // There is no messageKey in this variant
        successKey: 'login.confirmPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'confirm_phone',
        bannerType: 'auto_trigger',
        variant: 'confirm3',
        autoTriggeredOverlay: true
    },
    add: {
        messageKey: 'login.addPhone',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_link',
        variant: 'add'
    },
    add1: {
        messageKey: 'login.addPhoneWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'short_text_button',
        variant: 'add1'
    },
    add2: {
        messageKey: 'login.addPhoneLongWithButton',
        successKey: 'login.addPhoneSuccess',
        transitionName: 'add_phone',
        bannerType: 'long_text_button',
        variant: 'add2'
    },
    add3: {
        // There is no messageKey in this variant
        successKey: 'login.addPhoneSuccess',
        smsSentKey: 'login.smsSent',
        transitionName: 'add_phone',
        bannerType: 'auto_trigger',
        variant: 'add3',
        autoTriggeredOverlay: true
    },
    wpsOneTouchInterstitial: {
        variant: 'wpsOneTouchInterstitial',
        autoTriggeredOverlay: true
    }
};

var getDolphinEligibility = exports.getDolphinEligibility = function getDolphinEligibility(stateName) {
    var isReviewOrFi = /checkout\.review|checkout\.selectFi/.test(stateName) && _squid.$util.param('ulToast');

    if (!isReviewOrFi) {
        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': 'not_ryp',
            'context_id': _angular.$rootScope.token
        });
        return _squid.$promise.resolve();
    }

    return _eligibility.$stickyCTA.instance().getEligibility()
    // Dolphin can be enabled only in case sticky & credit interstitial are not eligibile
    .then(function (isStickyEligible) {
        var eligibilityReason = 'no_sticky_or_credit';
        var isCreditInsterstialEligible = getCreditInterstitialEligibility();

        if (isCreditInsterstialEligible) {
            eligibilityReason = 'has_credit_interstitial';
        }

        if (isStickyEligible) {
            eligibilityReason = 'has_sticky';
        }

        _logger.$logger.info(flowName, {
            'from': 'dolphin_elg_chk',
            'to': 'process_dolphin_elg_chk',
            'eligibility_reason': eligibilityReason,
            'context_id': _angular.$rootScope.token
        });

        return !isStickyEligible && !isCreditInsterstialEligible;
    });
};

_angular.$rootScope;

_uiRouter.$state;

_squid.$locale;

_squid.$promise;

_squid.$util;

_logger.$logger;

_eligibility.$stickyCTA;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-login-components/src/create-password/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/password-recovery/directive.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginOverlay', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            stateInfo: '=?',
            modalCallback: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.autoLogin = false;
            $scope.ulEligibility = true;
            $scope.auth = _auth.$AuthModel.instance();

            var stateInfo = {};
            var subFlowTitles = {
                addCard: 'loginAddCard',
                bank: 'loginAddBank',
                addShipping: 'loginAddAddress',
                deleteShipping: 'loginDeleteAddress',
                confirmUpop: 'loginConfirmUpop',
                redirectToCape: 'loginApplyCredit',
                sepaAgreement: 'riskyLoginSepa',
                DEFAULT: 'loginTitle'
            };

            function getFptiStateName() {
                if ($scope.createPassword) {
                    return 'quick_security_check';
                } else if ($scope.passwordRecovery) {
                    return 'password_recovery';
                } else {
                    return 'LOGIN_STEP_UP_AUTH';
                }
            }

            /**
             * Use iframe for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaIframe = function doRiskyLoginViaIframe(event, data) {
                _logger.$logger.debug('doRiskyLoginViaIframe');
                $scope.showOverlay = true;

                $('#wrapper #spinner').hide();

                stateInfo = data;

                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');

                if (subFlowName) {
                    $scope.subFlowName = subFlowName;
                    $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
                }

                $scope.createPassword = (0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less;
                $scope.passwordRecovery = false;
                if ($scope.createPassword) {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_quick_security_check'
                    });
                } else {
                    _logger.$logger.info('checkout_fpti', {
                        from: getFptiStateName(),
                        to: 'prepare_login_step_up_AUTH'
                    });
                }

                (0, _angular.$timeout)(function () {
                    $element.addClass('overlayOpen');
                });
            };

            /**
             * Do a full page redirect to ul as landing for risky login use case.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLoginViaFullpageRedirect = function doRiskyLoginViaFullpageRedirect(event, data) {
                _logger.$logger.debug('doRiskyLoginViaFullpageRedirect');
                stateInfo = data;
                var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');
                var subFlowTitleKey = subFlowName && subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;

                return $scope.auth.redirectToLogin('insufficientPermission', {
                    ulClientKey: subFlowTitleKey
                });
            };

            /**
             * Decide to do fullpage or iframe risky login.
             *
             * @param {any} event: name of the event.
             * @param {any} data: state and contextual data
             */
            var doRiskyLogin = function doRiskyLogin(event, data) {
                var isCredit = _index.$CheckoutAppDataModel.instance($scope.token).isSecondButton();
                _logger.$logger.debug('doRiskyLogin');
                if (_squid.$config.fullPageRiskyLogin && !isCredit) {
                    return doRiskyLoginViaFullpageRedirect(event, data);
                } else {
                    return doRiskyLoginViaIframe(event, data);
                }
            };

            var cancelInsufficientPermission = _angular.$rootScope.$on('$insufficientPermission', doRiskyLogin);

            $scope.$on('$destroy', cancelInsufficientPermission);

            var hideOverlay = function hideOverlay() {
                $('#wrapper #spinner').attr('style', '');
                $element.removeClass('overlayOpen');
                return (0, _angular.$timeout)(function () {
                    $scope.showOverlay = false;
                }, 300);
            };

            function logCancel() {
                _logger.$logger.info('checkout_fpti', {
                    from: getFptiStateName(),
                    to: 'process_user_cancel'
                });
            }

            $scope.hideModal = function (event) {
                event.preventDefault();
                logCancel();
                hideOverlay();
                _uiRouter.$state.go(stateInfo.oldState);
            };

            $scope.onCreatePassword = function () {
                _angular.$rootScope.$emit('loading');
                $scope.passwordRecovery = true;
            };

            $scope.onPasswordRecoveryReady = function () {
                _angular.$rootScope.$emit('loaded');
                $scope.createPassword = false;
            };

            $scope.onCompletePasswordRecovery = function () {
                $scope.passwordRecovery = false;
            };

            $scope.onPasswordRecovery = function () {
                $scope.auth.password_less = false;
            };

            $scope.onSuccess = function () {
                var checkoutSession = _index.$CheckoutSessionModel.instance($scope.token);
                var checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
                return checkoutSession.action('create', {
                    data: {
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
                    },
                    success: function success() {
                        if (stateInfo.pageOnOverlay) {
                            _uiRouter.$state.go(stateInfo.newState, { fromLoginOverlay: true });
                            $scope.showOverlay = false;
                        } else {
                            hideOverlay().then(function () {
                                _uiRouter.$state.go(stateInfo.newState);
                            });
                        }

                        _logger.$logger.info('checkout_fpti', {
                            from: getFptiStateName(),
                            to: 'process_login_step_up_AUTH'
                        });
                    }
                })['finally'](function () {
                    hideOverlay();
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section class=\"login\" id=\"login\">\n                    <xo-login-handler ng-if=\"!passwordRecovery && !createPassword\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\" ul-eligibility=\"ulEligibility\" sub-flow-title-key=\"subFlowTitleKey\" hideloginpp=\"true\"></xo-login-handler>\n                    <xo-create-password ng-if=\"createPassword\" token=\"token\" reason=\"subFlowName\" on-continue=\"onCreatePassword\" on-cancel=\"hideModal\"></xo-create-password>\n                    <xo-password-recovery ng-if=\"passwordRecovery\" token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onCompletePasswordRecovery\" on-cancel=\"onCancel\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/popup/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            doneFn: '=?',
            errorFn: '=?',
            clientId: '=?',
            redirectUri: '=?',
            scope: '=?',
            autoLogin: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.locale = _squid.$locale;
            var lang = _squid.$locale.lang ? _squid.$locale.lang : 'en';
            var country = _squid.$locale.country ? _squid.$locale.country : 'US';
            var localeNVP = 'locale.x=' + lang.toLowerCase() + '_' + country.toUpperCase();
            var forgotPasswordUrl = 'https://www.paypal.com/' + country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
            var legacyForgotPasswordUrl = 'https://www.paypal.com/' + country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
            var checkoutInputData = _user.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
            var creditData = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
            var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
            var $passwordField = $element.find('[ng-model="auth.password"]');
            var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';

            $scope.forgotPasswordUrl = (0, _squid.$feature)('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;
            _fn.$fn.sendTypingSpeedPayload('Hermes');

            /* ******** Here goes the Remember User controls *************************** */

            // Show the RM consent section when
            // 1. feature is ON
            // 2. when its not a contingency flow
            // 3. eBay doesn't want to hide it explicitly

            if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
                fptiStateName = 'LOGIN_RM';
                $scope.rememberMe = 'nonKmli';
            } else if (apsRemMe) {
                $scope.rememberMe = 'kmli';
            }
            $scope.rememberMeChkBox = {
                // Leave the consent box un-ticked by default
                agreed: false
            };

            // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
            $scope.showRmMore = false;

            // Expand details when RM check-box is ticked and Remember the user
            $scope.toggleRMDetails = function () {
                $scope.showRmMore = $scope.rememberMeChkBox.agreed;
            };

            function setRememberUser() {
                if (checkoutInputData.rmEnabled(Boolean(_squid.$config.rememberMeFeatureEnabled))) {
                    if (checkoutInputData.hideRM() === 'true') {
                        // Feature is ON but consent box is hidden since hideRM param is true
                        // Do not remember user in this case
                        $scope.auth.rememberUser = false;
                    } else {
                        // RM is enabled and consent box displayed on login page
                        // Remember the user based on the consent of user
                        $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
                    }
                } else {
                    // Feature is wired off
                    // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
                    $scope.auth.rememberUser = true;
                }
            }

            /* ************ Remember User Ends *************************************** */

            function showLoadingMessage() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
            }

            function loginAction() {
                showLoadingMessage();
                var loginInput = {
                    user: {
                        email: $scope.auth.email,
                        password: $scope.auth.password
                    }
                };

                if ($scope.clientId) {
                    loginInput.client = {
                        redirect_uri: _squid.$config.app_redirect_uri,
                        client_id: _squid.$config.app_clientId || '',
                        target_client_id: _squid.$util.param('fromLipp') === 'true' ? $scope.clientId : _squid.$util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
                        scope: $scope.scope,
                        response_type: 'token id_token',
                        skip_oauth: false,
                        skip_consent: true
                    };
                } else if ($scope.apsIntegration) {
                    loginInput.client = {
                        remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
                    };
                    loginInput.fastLogin = true;
                }

                // updated the product to decide the entry point
                loginInput.product = _angular.$rootScope.wps ? 'wps' : 'ec';

                // if risk_correlation_id (fraudNetId) is present in cart, then include it to req
                loginInput.fraudnet_id = $scope.checkoutCart.supplementary && $scope.checkoutCart.supplementary.risk_correlation_id;

                // add token (cart-id) in context for RL
                var adsClientContextData = { context_type: 'Cart-ID', context_id: $scope.token };

                loginInput['ads-client-context-data'] = adsClientContextData;
                $scope.auth.action('login', {
                    data: loginInput,
                    headers: {
                        'x-pp-ads-client-context-data': JSON.stringify(adsClientContextData)
                    },
                    success: function success(result) {
                        var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiStateName,
                            'to': transition_name
                        });

                        if (window.xprops && window.xprops.onAuth && $scope.auth.access_token) {
                            return window.xprops.onAuth({
                                accessToken: $scope.auth.access_token
                            }).then(function () {
                                return $scope.doneFn($scope.auth);
                            });
                        }
                        return $scope.doneFn($scope.auth);
                    },

                    contingencies: {
                        DEFAULT: function DEFAULT(name, contingency) {
                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
                            var error_source = $scope.apsIntegration ? 'aps' : 'userauth';

                            _logger.$logger.info('checkout_fpti', {
                                'from': fptiStateName,
                                'to': transition_name,
                                'int_error_description': contingency && contingency.message,
                                'error_type': 'soft_decline',
                                'error_source': error_source
                            });
                            $scope.auth.password = '';
                            $passwordField.focus();
                            return $scope.errorFn(name, contingency);
                        }
                    }
                });
            }

            $scope.$on('$destroy', function () {
                $scope.auth.password = '';
            });

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.auth.loggedIn()) {
                    if ($scope.autoLogin) {
                        showLoadingMessage();
                        if ($scope.auth.remembered) {
                            _logger.$logger.info('REMEMBERED_ACTIVE_SESSION');
                        } else {
                            _logger.$logger.info('ACTIVE_SESSION');
                        }
                        return $scope.doneFn($scope.auth);
                    }
                } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
                    $scope.auth.email = $scope.checkoutCart.payer.email;
                }
                var transition_name = void 0;

                if (apsRemMe) {
                    transition_name = 'prepare_login_rm';
                } else if (creditData.isCreditTxn()) {
                    transition_name = 'prepare_login_ppc';
                } else {
                    transition_name = 'prepare_login';
                }

                var app_int_type = _dist.$DeviceInfo.getAppIntegrationType();

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiStateName,
                    'to': transition_name,
                    'app_int_type': app_int_type
                });
                $scope.onSubmit = function () {
                    setRememberUser();
                    loginAction();
                };
            });
        }]
    };
});

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_dist.$DeviceInfo;

_credit.$CreditDataModel;

_user.$CheckoutInputDataModel;

_index.$CheckoutCartModel;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$util;

_fn.$fn;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/fn.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fn', function () {
    var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
    var fnCorrId;
    var fraudnetConfig = _squid.$config.fraudnet;
    var token = _angular.$rootScope.token || _squid.$meta.token;

    if (_squid.$meta.baToken) {
        _logger.$logger.info('BEAM_In_Hermes_Checkout');
        fnCorrId = _squid.$meta.baToken;
    } else if (_angular.$rootScope.fraudNetId) {
        fnCorrId = _angular.$rootScope.fraudNetId;
    } else {
        fnCorrId = _angular.$rootScope.token || _squid.$meta.token;
    }

    var options = {
        fnSessionId: fnCorrId,
        sourceId: fraudnetConfig && fraudnetConfig.sourceId || 'HERMES_SIGNIN',
        allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular2['default'].isFunction(CustomEvent)
    };

    function init() {

        _logger.$logger.info('FN_contexts', {
            'token': token,
            'fnSessionId': options.fnSessionId
        });

        // Todo: remove the conditional logic after all the boxes picked up latest config.
        if (_angular2['default'].isString(_squid.$config.urls.fraudnetUrl)) {
            options.fnUrl = _squid.$config.urls.fraudnetUrl;
        } else {
            options.fnUrl = _squid.$config.urls.fraudnetUrl && _squid.$config.urls.fraudnetUrl.passive;
        }

        _logger.$logger.info('FN_Initialised', {
            'allowsCustomEvent': options.allowsCustomEvent
        });
    }

    var enableFraudnet = function enableFraudnet() {
        var userAgent = _angular.$window.navigator.userAgent;

        // Disable for web view
        if (_index.$DeviceInfo.isApp()) {
            if (_angular.$window.enableFraudNetForMobileWebView) {
                _logger.$logger.info('Enable_FN_MobileApp_PXP_Decision');
                return true;
            }

            _logger.$logger.info('Disable_FN_Mobileapp');
            return false;
        } else if (userAgent.indexOf('EtsyInc') > -1) {
            _logger.$logger.info('Disable_FN_Etsy');
            return false;
        }
        _logger.$logger.info('Enable_FN');
        return true;
    };

    function injectScript(fnUrl) {
        var script = document.createElement('script');
        script.id = 'js-sync';
        script.src = fnUrl;
        document.body.appendChild(script);
    }

    function injectIframe(beaconOptions) {
        var iframe = document.createElement('iframe');
        var dom;
        var doc;
        var where;

        iframe.src = 'about:blank'; // eslint-disable-line no-script-url
        iframe.title = '';
        iframe.role = 'presentation';
        (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';

        where = document.getElementsByTagName('script');
        where = where[where.length - 1];
        where.parentNode.insertBefore(iframe, where);

        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            dom = document.domain;
            iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
            doc = iframe.contentWindow.document;
        }

        doc.open()._l = function () {
            var js = this.createElement('script');
            if (dom) {
                this.domain = dom;
            }
            js.id = 'js-iframe-async';
            js.src = beaconOptions.fnUrl;
            this.body.appendChild(js);
        };
        function listener() {
            doc._l();
        }
        if (iframe.addEventListener) {
            iframe.addEventListener('load', listener, false);
        } else if (iframe.attachEvent) {
            iframe.attachEvent('onload', listener);
        } else {
            doc.write('<body onload="document._l();">');
        }
        doc.close();
    }

    function _injectConfig(configOptions) {
        var script = document.getElementById('fconfig');

        if (script) {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }

        script = document.createElement('script');
        script.id = 'fconfig';
        script.type = 'application/json';
        script.setAttribute('fncls', fncls);

        script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
        document.body.appendChild(script);
    }

    /**
     * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
     *
     * Integration pattern ripped from the Fraudnet Integration guide:
     * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
     */
    function _loadBeacon(beaconOptions) {
        if (_index.$DeviceInfo.isApp() && _angular.$window.enableFraudNetForMobileWebView) {
            injectScript(beaconOptions.fnUrl);
        } else {
            injectIframe(beaconOptions);
        }
    }

    function trigger(scope) {

        var fnLoaded = !!_angular.$rootScope.fnLoaded;

        if (fnLoaded) {
            return false;
        }
        _logger.$logger.info('Trigger_FN');

        if (options.fnUrl) {
            if (enableFraudnet()) {
                _angular.$window.fnCallback = function () {
                    if (scope) {
                        scope.$emit('fnCallback');
                    }
                };
                _injectConfig(options);
                _loadBeacon(options);
                _angular.$rootScope.fnLoaded = true;
                return true;
            }
        }
        return false;
    }

    /**
     * send a payload to fraudnet for analysing typing speed
     * @param type
     */
    function sendTypingSpeedPayload(type) {

        var tsLoadPayload = {
            'detail': {
                'type': type
            }
        };

        if (type === 'Hermes') {
            tsLoadPayload.detail['fields'] = ['username', 'password'];
        }
        if (type === 'HermesUL') {
            tsLoadPayload.detail['frame'] = 'injectedUl';
            tsLoadPayload.detail['fields'] = ['email', 'password'];
        }

        if (type) {
            var event;
            if (options.allowsCustomEvent) {
                // document.createEvent deprecated
                _logger.$logger.info('fn_CustomEvent_type1');
                event = new CustomEvent('tsLoad', tsLoadPayload);
            } else {
                // IE does not support CustomEvent constructor
                try {
                    _logger.$logger.info('fn_CustomEvent_type2');
                    event = window.document.createEvent('CustomEvent');
                    event.initCustomEvent('tsLoad', true, true, tsLoadPayload.detail);
                } catch (err) {
                    _logger.$logger.info('fn_CustomEvent_None', {
                        'error': err
                    });
                }
            }
            if (event) {
                window.document.dispatchEvent(event);
                _logger.$logger.info('Dispatched_FN_TS_Payload_' + type);
            }
        }
    }

    return {
        init: init,
        trigger: trigger,
        sendTypingSpeedPayload: sendTypingSpeedPayload
    };
});

_squid.$config;

_squid.$meta;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-login-components/src/login", "../node_modules/xo-login-components/src/login/fn.js"))

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _props = __webpack_require__("../node_modules/xo-login-components/src/login/props.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/login/handler/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoLoginHandler', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            successCallback: '=?',
            contingencyCallback: '=?',
            autoLogin: '=?',
            ulEligibility: '=?',
            subFlowTitleKey: '=?',
            apsIntegration: '=?',
            batch: '=?',
            loginSubmit: '=?',
            logout: '=?',
            preAuth: '=?',
            hideloginpp: '=?',
            flowcontext: '=?',
            hideTitle: '=?'
        },

        controller: ['$scope', function ($scope) {
            // Login Contingency Handling
            var CONTENT_KEY = {
                INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
                ACCOUNT_LOCKED: 'accountLockedPageError',
                ACCOUNT_CLOSED: 'accountLockedPageError',
                INVALID_PHONE: 'invalidPhone',
                INVALID_PIN: 'invalidPin',
                INVALID_ACCESS_TOKEN: 'invalidAccessToken',
                TIMED_OUT: 'loginStatusTimedOut',
                CANNOT_PAY_SELF: 'cannotPaySelf',
                RISK_DECLINE: 'riskDeclinePageError',
                LOGIN_ADD_PHONE: 'loginAddPhone',
                LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
                LOGIN_CONTINGENCY: 'loginContingency',
                LOGIN_REACTIVATE: 'checkOneTouch',
                LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
                LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch',
                VENMO_GENERIC_ERROR: 'venmoGenericError'
            };

            var CONTENT_MAPPING = {
                INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
                INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
                INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
                LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
                TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
                CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
                RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
                addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
                PAYER_AUTHENTICATION_REQUIRED: {
                    content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
                    type: 'info'
                },
                LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
                ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
                ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
                ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' },
                VENMO_ERROR: { content: CONTENT_KEY.VENMO_GENERIC_ERROR, type: 'error' }
            };

            function populateMessage(name, type) {
                var contentKey = CONTENT_MAPPING[name];
                if (contentKey) {
                    $scope.message = {
                        msgKeys: ['login.' + contentKey.content],
                        type: type || contentKey.type
                    };
                } else {
                    _logger.$logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
                }
            }

            function handleAuthChallengeFailure(urlParams) {
                if (urlParams.acRedirect === '2fa') {
                    var userLocale = urlParams['locale.test'];

                    if (userLocale) {
                        _squid.$locale.chosenLang = _squid.$localeHelper.normalizeLocale(userLocale).language;
                    }

                    if (urlParams.ulMethod === 'phone') {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_PHONE');
                        populateMessage('INVALID_PHONE_PIN', 'error');
                    } else {
                        _logger.$logger.debug('2FA_RETURNED_FAILED_EMAIL');
                        populateMessage('INVALID_USER', 'error');
                    }
                } else if (urlParams.acRedirect === 'loginato') {
                    _logger.$logger.debug('LOGIN_ATO_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                } else if (urlParams.acRedirect === 'safe') {
                    _logger.$logger.debug('SAFE_RETURNED_FAILED');
                    _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                }
            }

            function handleAuthChallengeSuccess(urlParams) {
                switch (urlParams.acRedirect) {
                    case '2fa':
                        _logger.$logger.debug('2FA_RETURNED_SUCCESS');
                        break;
                    case 'loginato':
                        _logger.$logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
                        break;
                    case 'safe':
                        _logger.$logger.debug('SAFE_RETURNED_SUCCESS');
                        break;
                    default:
                    // do nothing
                }
                $scope.auth.is_auth_api_call = !urlParams.acRedirect;
            }

            $scope.onComplete = function (auth) {
                // Dont show the login contingency message once poma password recovery is enabled.
                if (!(0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                    populateMessage('LOGIN_CONTINGENCY', 'info');
                }

                if (_angular.$rootScope.contingency && _angular.$rootScope.contingency.message) {
                    populateMessage(_angular.$rootScope.contingency.message, 'error');
                } else {
                    if (!_squid.$util.param('langTgl')) {
                        //  for UL Landing
                        _squid.$locale.choose(auth.country, auth.language, false);
                    }
                    $scope.successCallback();
                }
            };

            // Make country and lang available to htmlContent for dynamically generating content
            $scope.locale = _squid.$locale;

            if (_uiRouter.$stateParams.targetPage) {
                if (_props.$loginProps.inList(_uiRouter.$stateParams.targetPage) && (0, _squid.$feature)('riskyLoginContingency')) {
                    var riskyLoginInfo = _props.$loginProps.mapInfo(_uiRouter.$stateParams.targetPage);
                    $scope.subFlowTitleKey = riskyLoginInfo.title;
                    $scope.contingencyDesc = riskyLoginInfo.subtitle;
                    $scope.hideloginpp = true;
                    $scope.postlogout = function () {
                        delete $scope.subFlowTitleKey;

                        if ($scope.contingencyDesc) {
                            delete $scope.contingencyDesc;
                        }

                        delete $scope.hideloginpp;
                        $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                        $scope.logout();
                    };
                } else {
                    var errMessage = CONTENT_MAPPING[_uiRouter.$stateParams.targetPage] ? _uiRouter.$stateParams.targetPage : 'LOGIN_CONTINGENCY';
                    var type = errMessage.type ? errMessage.type : 'info';
                    populateMessage(errMessage, type);
                }
            }

            if (_auth.$AuthModel.instance().meta.invalidated) {
                populateMessage('TIMED_OUT', 'error');
            } else if (_auth.$AuthModel.instance().meta.selfPay) {
                populateMessage('CANNOT_PAY_SELF', 'error');
                _auth.$AuthModel.instance().meta.selfPay = false;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {
                // Land on create password info page in case poma user was routed to login, after the
                // initial login/auth.
                if ((0, _squid.$feature)('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
                    _uiRouter.$state.go('checkout.createPassword', { targetPage: _uiRouter.$stateParams.targetPage });
                    return;
                }

                var ULCallbacks = {
                    showErrorMessages: function showErrorMessages(errorCase) {
                        populateMessage(errorCase);
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    },
                    toggleUnifiedLogin: function toggleUnifiedLogin(value) {
                        $scope.ulEligibility = value;
                        $scope.apsIntegration = true;
                        _angular.$rootScope.continueLoadingForUL = value;
                        (0, _angular.$timeout)(function () {
                            $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                        });
                    }
                };

                // redirect to UL if config says true and we have targetPage
                if (_squid.$config.fullPageRiskyLogin && _uiRouter.$stateParams.targetPage && !$scope.checkoutAppData.isSecondButton()) {
                    _logger.$logger.debug('doRiskyLoginViaRedirectToUL');
                    // delete scope variables to avoid UL iframe execution
                    delete $scope.ulEligibility;
                    delete $scope.apsIntegration;

                    var subFlowTitleKey = $scope.subFlowTitleKey && $scope.subFlowTitleKey.split('.')[1];

                    return $scope.auth.redirectToLogin('insufficientPermission', {
                        ulClientKey: subFlowTitleKey
                    });
                } else {
                    _logger.$logger.debug('doRiskyLoginViaiFrameInHermes');
                    $scope.ULCallback = function (name, value) {
                        var callback = ULCallbacks[name];
                        if (callback) {
                            callback(value);
                        }
                    };
                }

                if ($scope.auth.timed_out) {
                    populateMessage('TIMED_OUT', 'error');
                }

                if (!$scope.subFlowTitleKey) {
                    $scope.showLanguageDropdown = (0, _squid.$feature)('languageToggle');
                }

                var urlParams = _squid.$util.params();

                if (urlParams.acRedirect) {
                    // Returning from auth challenge
                    if (urlParams.failedBecause) {
                        handleAuthChallengeFailure(urlParams);
                    } else {
                        handleAuthChallengeSuccess(urlParams);
                    }
                }

                var getErrorDesc = function getErrorDesc(msg) {
                    return decodeURIComponent(msg);
                };

                var getErrorType = function getErrorType(msg) {
                    var errorNum = decodeURIComponent(msg).match(/\d+/g); // to extract the error type from the error msg
                    return errorNum ? errorNum : '';
                };

                var mapCodeToError = function mapCodeToError(code) {

                    var errorMap = {
                        '82016': 'RISK',
                        '82017': 'COMPLIANCE'
                    };

                    return errorMap[code];
                };

                if (_uiRouter.$stateParams.venmoError) {

                    if (_uiRouter.$stateParams.errorCode) {

                        var errorSource = mapCodeToError(_uiRouter.$stateParams.errorCode);
                        if (errorSource) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_ENTRYPOINT',
                                to: 'process_checkout_login',
                                'int_error_code': _uiRouter.$stateParams.errorCode,
                                'int_error_description': _uiRouter.$stateParams.errorMessage ? getErrorDesc(_uiRouter.$stateParams.errorMessage) : '',
                                'error_type': _uiRouter.$stateParams.errorMessage ? getErrorType(_uiRouter.$stateParams.errorMessage) : '',
                                'error_source': errorSource
                            });
                        }
                    }

                    populateMessage('VENMO_ERROR', 'error');
                }

                var handleContingency = {
                    // Errors - Show Page Level Error
                    INVALID_USER: populateMessage,
                    LOCKED_USER: populateMessage,
                    ACCOUNT_LOCKED: populateMessage,
                    CLOSED_USER: populateMessage,
                    ONETOUCH_REACTIVATE: populateMessage,
                    ONETOUCH_LEAVECHECKED: populateMessage

                };

                $scope.onContingency = function (name, contingency, type) {
                    // eslint-disable-line no-shadow

                    _squid.$locale.choose($scope.auth.country, $scope.auth.language, false);

                    if (!handleContingency[name]) {
                        return $scope.contingencyCallback(name, contingency);
                    }

                    var message_type = type || 'error';
                    return handleContingency[name](name, message_type);
                };
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$localeHelper;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_props.$loginProps;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/handler/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\" id=\"loginSection\" content>\n    <xo-message message=\"message\"></xo-message>\n    <div class=\"pr row-fluid\" ng-class=\"{hasError: message}\" ng-hide=\"hideTitle\">\n        <xo-title class=\"xoTitle\" title-txt=\"{{content(subFlowTitleKey ? subFlowTitleKey : 'login.loginTitle')}}\" ng-class=\"{span17: showLanguageDropdown, riskyTitle: subFlowTitleKey}\"></xo-title>\n        <xo-language-options class=\"span7\" ng-if=\"showLanguageDropdown\"></xo-language-options>\n    </div>\n    <div class=\"inline-prop\" unless-feature=\"propValue\" ng-hide=\"hideloginpp\">\n        <p ng-bind-html=\"htmlContent('login.propValAlt', {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <div class=\"inline-prop\" ng-show= \"contingencyDesc\" ng-class=\"{riskySubtitle: contingencyDesc}\">\n        <p ng-bind-html=\"htmlContent(contingencyDesc, {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <xo-login ng-if=\"!ulEligibility\" token=token auth=auth done-fn=\"onComplete\" error-fn=\"onContingency\" auto-login=\"autoLogin\" aps-integration=\"apsIntegration\" batch=\"batch\" login-submit=\"loginSubmit\"></xo-login>\n    <xo-unified-login ng-if=\"ulEligibility\" token=token error-fn=\"onContingency\" parent-callback=\"ULCallback\" pre-auth=\"preAuth\" post-auth=\"onComplete\" auto-login=\"autoLogin\" flowcontext=\"flowcontext\" login-submit=\"loginSubmit\" logout-callback=\"postlogout\" ></xo-unified-login>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/kmliEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var scope = { eligibility: {} };
var ulMeta = _squid.$config.ulMeta || {};

var getPXPList = function getPXPList(country) {
    // returns a list of Pxp's that needs to be executed
    var countryCTX = { 'ctx.COUNTRY': country };
    var pxpExpId = ulMeta.pxpExpId;
    var pxpList = [(0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*', false, true), (0, _squid.$pxp)(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment', false, true)];

    return pxpList;
};

var routingReason = function routingReason() {
    // Check for conditions that deviates from the PXP eligibility
    // Reasons that deviates from control to treatment
    var isRememberedUser = scope.auth.refreshToken();

    if (scope.kmli === true) {
        return 'kmliMandated';
    } else if (isRememberedUser) {
        return 'rememberedUser';
    } else if (_squid.$util.param('ul') === '2') {
        return 'ulParam';
    } else if (_squid.$meta.corp && ulMeta.allowKMLIForInternalIP) {
        var merchantCountry = scope.checkoutAppData.merchant.merchant_country;

        if ((0, _squid.$feature)('enableOneTouchInternalIP', false, merchantCountry)) {
            return 'internalIP';
        }
    } else if (ulMeta.enableOneTouchByDefault) {
        return 'oneTouchByDefault';
    }
};

var compatibility = function compatibility(reasons) {
    // Check for compatibility/environment issues which impacts UL/KMLI overall
    // This should override previous decisions
    if (_index.$DeviceInfo.isApp()) {
        scope.kmliEligibility = false;
        reasons.push('Webview');
    } else if (!_squid.$util.cookiesEnabled()) {
        scope.kmliEligibility = false;
        reasons.push('cookiesDisabled');
    } else if (scope.auth.ota) {
        scope.kmliEligibility = false;
        reasons.push('otaDevice');
    }

    if (scope.forcedLogin === true) {
        scope.kmliEligibility = false;
        reasons.push('forcedLogin');
    }
    if (scope.logoutCallback) {
        scope.kmliEligibility = true;
        reasons.push('riskyLoginContingency');
    }
};

var isULpreload = function isULpreload(preloadULTreatments) {
    // const userAgent = $window.navigator.userAgent;
    // const isIE = !!userAgent.match(/MSIE|trident|edge/i);
    var isTreatment = Boolean(preloadULTreatments && preloadULTreatments.treatment_name);
    var forceUlss = _squid.$util.param('_ulss') === 'true';
    var preloadUL = forceUlss || isTreatment;

    return preloadUL;
};

var isUlAsLanding = function isUlAsLanding() {
    // markes
    var forceUlAsLanding = _squid.$util.param('ul') === 'landing';
    var ulAsLandingParam = _squid.$util.param('ulReturn') === 'true';

    // tried Ul as landing -> failed -> used iframe
    var failedAttempt = _squid.$util.param('lndgFailedBecause'); // eslint-disable-line no-unused-vars


    return forceUlAsLanding || ulAsLandingParam;
};

var getTimeoutLimit = function getTimeoutLimit(pxpTimeoutTrt) {
    var ulTimeoutLimit = void 0;
    var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
    var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;

    if (pxpTimeoutVal) {
        ulTimeoutLimit = pxpTimeoutVal;
        _logger.$logger.info('pxp_timeout_treatment', { ulTimeoutLimit: ulTimeoutLimit });
    }
    return ulTimeoutLimit;
};

var $KmliEligibility = exports.$KmliEligibility = {
    init: function init(params) {
        if (scope.eligibility.treatment) {
            // do not init twice
            return _angular.$q.resolve(scope.eligibility);
        }
        _logger.$logger.debug('kmliEligibility_init');
        scope.forcedLogin = params && params.forcedLogin;
        scope.logoutCallback = params && params.logoutCallback;

        return (0, _squid.$populate)(scope, {
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var country = scope.checkoutAppData.merchant.merchant_country;

            return _angular.$q.all(getPXPList(country)).then(function (result) {
                scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[0]);
                scope.eligibility.preloadUL = isULpreload(result[1]);
                scope.eligibility.safeEligibility = true;
                scope.eligibility.ulAsLanding = isUlAsLanding();
            });
        }).then(function () {
            // STEP1: kmli pxp ramped to 100%, so always kmli eligible
            scope.kmliEligibility = true;

            // STEP2: Push the eligible reasons from routingReason check.
            var reasons = []; // Reasons that deviates from control to treatment

            reasons.push('pxpFullyRamped');

            var reason = routingReason();

            if (reason) {
                scope.kmliEligibility = true;
                reasons.push(reason);
            }

            // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
            compatibility(reasons);

            var routing_reason = reasons[reasons.length - 1];

            scope.eligibility.treatment = true;
            scope.eligibility.routingReason = routing_reason;
            scope.eligibility.deviatingReasons = reasons;
            scope.eligibility.kmliEligibility = scope.kmliEligibility;

            // STEP4: Instrument deterministically whether KMLI is shown to the user or not
            _logger.$logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
            _logger.$logger.info('checkout_fpti', {
                'from': 'KMLI_ELG_CHK',
                'to': 'process_kmli_elg_chk',
                routing_reason: routing_reason
            });
            return scope.eligibility;
        });
    },
    eligible: function eligible() {
        return scope.eligibility;
    }
};

angular.value("$KmliEligibility", $KmliEligibility);
_angular.$q;

_angular.$rootScope;

_squid.$config;

_squid.$feature;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$util;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/props.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var RISKY_LOGIN_TITLE = {
    ECONSENT_REQUIRED: '',
    ELV_DECLINE: '',
    EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
    INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
    NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
    NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
    NEED_CONFIRMED_CARD: '',
    NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
    TAX_ID_REQUIRED: ''
};
var RISKY_LOGIN_SUBTITLE = {
    EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
    NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
    PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
    SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
    PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
};

var $loginProps = exports.$loginProps = {
    mapInfo: function mapInfo(contingency) {
        var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
        var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];

        return { title: contingencyTitle, subtitle: contingencySubTitle };
    },

    inList: function inList(contingency) {
        return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
    }
};

angular.value("$loginProps", $loginProps);

/***/ }),

/***/ "../node_modules/xo-login-components/src/login/template.html":
/***/ (function(module, exports) {

module.exports = "<form name=\"loginForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n    <div class=\"inputField emailField confidential\">\n        <label for=\"username\" class=\"focus accessAid\">\n            {{ content('index.EmailLabel') }}\n        </label>\n        <input ng-model=\"auth.email\" id=\"username\" name=\"username\" type=\"email\" ng-readonly=\"auth.emailReadOnly\" value=\"\"\n               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\" placeholder=\"{{ content('index.EmailLabel') }}\" data-error-key=\"email.invalid\" xo-error-tooltip required autofocus/>\n    </div>\n\n    <div class=\"inputField passwordField confidential\">\n        <label for=\"password\" class=\"focus accessAid\">\n            {{ content('login.passwordLabel') }}\n        </label>\n        <input ng-model=\"auth.password\" id=\"password\" name=\"password\" type=\"password\" value=\"\" aria-required=\"true\" autocapitalize=\"off\" autocomplete=\"off\" placeholder=\"{{ content('login.passwordLabel') }}\" xo-error-tooltip required>\n    </div>\n\n    <div ng-switch class=\"checkbox\" id=\"rmSection\" on=\"rememberMe\">\n        <div ng-switch-when=\"nonKmli\" class=\"secondary\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\" ng-click=\"toggleRMDetails()\"/>\n            <label for=\"agree\">\n                {{content('rememberMe.remember')}}\n                <a ng-click=\"showRmMore=!showRmMore\">\n                    <span ng-bind=\"showRmMore ? content('rememberMe.close'): content('rememberMe.more')\"></span>\n                </a>\n            </label>\n            <ul id=\"rmLearnMore\" ng-show=\"showRmMore\">\n                <li>{{ content('rememberMe.skipLogin') }}</li>\n                <li>{{ content('rememberMe.toCancel') }}</li>\n                <li>{{ content('rememberMe.protectAccounts') }}</li>\n            </ul>\n        </div>\n        <div ng-switch-when=\"kmli\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\">\n            <label for=\"agree\" ng-bind=\"content('login.keepMeLoggedIn')\" class=\"kmliCheckboxLabel\"></label>\n            <div class=\"signupbml kmliHelpIcon\">\n                <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\"><img alt=\"{{ content('login.kmliTooltipTitle') }}\" /></a>\n            </div>\n        </div>\n    </div>\n\n    <xo-tooltip trigger=\"#verifyHelp\" display-inline=\"true\">\n        <div class=\"keepMeLoginTerms\" id=\"keepMeLoginTerms\">\n            <p>{{ content('login.kmliTooltipLine1') }}</p>\n            <p>{{ content('login.kmliTooltipLine2') }}</p>\n            <p>{{ content('login.kmliTooltipLine3') }}</p>\n        </div>\n    </xo-tooltip>\n\n    <input track-submit type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn\" validate-submit=\"onSubmit()\" />\n\n    <div class=\"center mt10 secondary\" id=\"forgotPasswordSection\">\n        <a href=\"{{forgotPasswordUrl}}\" id=\"forgot_password_link\" target=\"_blank\" class=\"smallPopup\" xo-popup>\n            {{ content('common.forgotYourPassword') }}</a>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$KmliUpsell = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

// Model Retrived
var idToken = void 0;
// models

var successfulLogin = void 0;
var isOneTouched = void 0;
var upsellOptInDisplayed = void 0; // eslint-disable-line no-unused-vars
var kmliEligible = void 0;
var walletTokenization = void 0;
var preloadUL = void 0;
var lastUpsellVersion = void 0; // eslint-disable-line no-unused-vars
var showReactivationInterstitial = void 0;
var kmliChecked = void 0; // Passed in init
var expPromise = void 0; // Promisified experience data
var scope = {};

var getKmliContentKey = function getKmliContentKey() {
    // NOTE: `xo_hermesnode_kmli_upsell` has been removed
    // and currently it's always returned `xo_hermesnode_kmli_content_t1`
    scope.oneTouchContentVersion = 1;
    return _angular.$q.resolve();
};

// Determine if the NMJ experience the user has is ineligible
var getIsNmj = function getIsNmj() {
    return _newMember.$NewMemberEligibility.instance().isNmj(scope.token);
};

var resolveEligibilityConditions = function resolveEligibilityConditions(params) {
    idToken = Boolean(scope.auth.idTokenPresent);
    successfulLogin = scope.auth.loggedIn();
    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
    walletTokenization = scope.checkoutCart.isWalletTokenization() || scope.auth.remembered_partner_assertion; // android pay, apple pay, etc
    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
    _logger.$logger.debug('kmliUpsell_resolveEligibilityConditions', { params: params });

    if (walletTokenization || preloadUL || scope.oneTouchContentVersion !== '3') {
        // do not trigger pxp for walletTokenization, ulpreload
        // Interstitial is only eligibile when the contentKey is set to treatment 3
        _logger.$logger.debug('kmliUpsell_init_ineligible');
    }
    return _angular.$q.resolve();
};

var $KmliUpsell = exports.$KmliUpsell = {
    init: function init(params) {
        scope.token = _angular.$rootScope.token;

        if (expPromise) {
            return; // do not init twice
        }
        _logger.$logger.debug('kmliUpsell_init', params);
        expPromise = _kmliEligibility.$KmliEligibility.init().then(function (KmliEligibility) {
            kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
            preloadUL = Boolean(KmliEligibility.preloadUL);
            return (0, _squid.$populate)(scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutCart: _index.$CheckoutCartModel.instance(scope.token),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(scope.token)
            });
        }).then(getKmliContentKey).then(function () {
            return resolveEligibilityConditions(params);
        });
    },
    // This should be called after checkout session is populated
    // Any data depending on the checkout session should be resolved here
    eligible: function eligible() {
        var eligibility = {};

        if (!expPromise) {
            _logger.$logger.debug('kmliUpsell_init_not_executed');
            return _angular.$q.resolve(eligibility);
        }
        return _angular.$q.all([expPromise, getIsNmj()]).then(function (result) {
            var experience = result[0];
            var isNmj = result[1];
            var eligibilityCriteria = {
                pxp: experience,
                profile_country: (0, _squid.$feature)('ryiOptIn'),
                isNotNmj: !isNmj
            };

            _logger.$logger.debug('kmliUpsell_eligiblityCheck', { eligibilityCriteria: eligibilityCriteria });

            var ineligibleReasons = _squid.$util.filter(Object.keys(eligibilityCriteria), function (key) {
                return !eligibilityCriteria[key];
            });
            var upsellFeatureEnabled = ineligibleReasons.length === 0;
            var regularLogin = kmliEligible && idToken;
            var autoLoginEnabled = isOneTouched || kmliChecked || scope.auth.remembered;

            eligibility.banner = upsellFeatureEnabled && (0, _squid.$feature)('optinToggle') && Boolean(isOneTouched || regularLogin);

            eligibility.interstitial = {
                eligible: upsellFeatureEnabled && !autoLoginEnabled && experience && experience.name && (experience.name.slice(-1) === '1' || experience.name.slice(-1) === '3') // use only treatment 1,3 for interstitial
                && experience.version,
                type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '', // eslint-disable-line no-nested-ternary
                color: experience && experience.color,
                pxpVersion: experience && experience.pxpVersion
            };

            var elgStr = 'interstitial-' + eligibility.interstitial.eligible + '&toggle-';

            _logger.$logger.info('ryi_optin', {
                'from': 'ryi_optin_elg_chk',
                'to': 'process_ryi_optin_elg_chk',
                'eligibility_reason': upsellFeatureEnabled ? elgStr + 'eligible' : elgStr + 'ineligible_' + ineligibleReasons.join()
            });
            _logger.$logger.debug('kmliUpsell_eligibility', {
                eligibility: eligibility,
                experience: experience,
                cases: {
                    activeOT: isOneTouched,
                    regularLogin: regularLogin,
                    feature: upsellFeatureEnabled
                }
            });
            return eligibility;
        });
    },
    getOptions: function getOptions() {
        if (showReactivationInterstitial) {
            return {
                flowName: 'expiredUpsell'
            };
        }
    },
    getFPTIAttributes: function getFPTIAttributes() {
        if (showReactivationInterstitial) {
            return {
                stateName: 'KMLI_reactivation',
                transInfix: '_kmli_reactivation_'
            };
        } else {
            return {
                stateName: 'KMLI_UPSELL',
                transInfix: '_kmli_upsell_'
            };
        }
    }
};

angular.value("$KmliUpsell", $KmliUpsell);
_angular.$q;

_angular.$rootScope;

_squid.$feature;

_squid.$populate;

_squid.$util;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_newMember.$NewMemberEligibility;

_kmliEligibility.$KmliEligibility;

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/password-recovery/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
    tag: 'xo-password-recovery',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        onContinue: {
            type: 'var',
            required: false
        },
        onPasswordRecovery: {
            type: 'var',
            required: false
        },
        onLoad: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var PAYPAL = window.PAYPAL;

            this.loaded = false;
            var postMessageHandler = function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    switch (response.event) {
                        case 'render':
                            if (response.pageName === 'authflow/password-recovery/done') {
                                _this.onPasswordRecovery();
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'process_password_recovery'
                                });
                            } else if (response.pageName === 'authflow/password-recovery') {
                                _this.onLoad();
                                _this.loaded = true;
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'prepare_password_recovery'
                                });
                            } else {
                                // Do nothing
                            }
                            break;
                        case 'passwordSetSuccess':
                            _this.onContinue();
                            break;
                        default:
                            break;
                    }
                });
            };

            this.loadPasswordRecoveryFlow = function () {
                var isHermesInsideIframe = _squid.$util.isIFrame();

                if (isHermesInsideIframe) {
                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                }
                var options = {
                    targetElement: document.getElementById('injectedPasswordRecovery'),
                    xhrRequest: isHermesInsideIframe,
                    iframePathname: '/authflow/password-recovery',
                    caller: 'secondaryIframe',
                    queryParams: {
                        'country.x': _squid.$locale.country,
                        'locale.x': _squid.$locale.getLocaleCode(),
                        'contextId': _this.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId()
                    },
                    onPostMessage: postMessageHandler
                };

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    PAYPAL.unifiedLogin.inject(options);
                }
            };

            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$meta;

_squid.$util;

_model.$CalDataModel;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-login-components/src/password-recovery/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _kmliEligibility = __webpack_require__("../node_modules/xo-login-components/src/login/kmliEligibility.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _template = __webpack_require__("../node_modules/xo-login-components/src/unified-login/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoUnifiedLogin', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            redirectUri: '=?',
            parentCallback: '=?',
            doneFn: '=?',
            errorFn: '=?',
            autoLogin: '=?',
            promptlogin: '=?',
            logoutCallback: '=?',
            kmli: '=?',
            preAuth: '=?',
            postAuth: '=?',
            flowcontext: '=?'
        },
        controller: ['$scope', function ($scope) {
            var ulClientRedirect = _squid.$util.param('ulClientRedirect') || '';
            var redirect_reason_timeout = 'timeout';
            var PAYPAL = window.PAYPAL || {};
            var failureReasons = {
                timeout: 'TIMEDOUT',
                error: 'INTERNALERROR',
                blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
                fallback: 'FALLBACK'
            };
            var enteringTime = Date.now();
            var loginAttemptedMethod = '';
            var userSelectedLanguage = '';

            _logger.$logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario

            if (_uiRouter.$stateParams.source === 'NOT_YOU' || _uiRouter.$stateParams.source === 'FRESH_START') {
                $scope.forcedLogin = false;
            }

            var ulTimeoutLimit = 35000;
            var ulTimeoutPromise = null;
            var loadCnt = 0;

            if (ulClientRedirect === redirect_reason_timeout) {
                _logger.$logger.info('ulClientRedirect_timeout');
            }

            function setLoading(tag, isRT) {
                _angular.$rootScope.$emit('loading');
                if (isRT && !$scope.auth.loggedIn()) {
                    _angular.$rootScope.$emit('loadingMessage', {
                        heading: _squid.$locale.content.get('base.loggingIn'),
                        subHeading: _squid.$locale.content.get('login.rmSubHeading')
                    });
                }
                loadCnt++;
                _logger.$logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
            }

            function setLoaded(tag) {
                if (loadCnt > 0) {
                    _angular.$rootScope.$emit('loaded');
                    loadCnt--;
                } else {
                    _logger.$logger.error('loadCnt_zero');
                }
                _logger.$logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
            }

            function fallback(product, reason, params) {
                throw new _squid.$FallbackError({
                    product: product || 'ux',
                    reason: reason,
                    params: params
                });
            }

            function appLoginHandler(status) {
                _logger.$logger.debug('ULLOGIN_' + status);
                _logger.$logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
                fallback('ux', 'ul_server_error');
            }

            var startTimerTS = void 0;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.debug('startTimer by ' + tag, {
                    startTime: startTimerTS
                });
                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    _logger.$logger.error('load_ul_timeout');
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'UL_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    if (!_squid.$config.disableUlTimeout) {
                        fallback('ux', 'ul_load_timeout');
                    } else {
                        // remove after ulAsLanding risky login
                        var isRememberedUser = $scope.auth && $scope.auth.remembered;

                        // remove after ulAsLanding starts to support tokenexchange
                        var isTokenExchange = $scope.auth && $scope.auth.refreshToken() && !$scope.auth.accessToken();
                        // Do trigger for remebered user
                        // Do not trigger if already triggered before
                        // Do not trigger for RT to AT case
                        if (!ulClientRedirect && !isRememberedUser && !isTokenExchange) {
                            $scope.auth.redirectToLogin(redirect_reason_timeout);
                        }
                    }
                }, ulTimeoutLimit);
            }

            function stopTimer(tag, keepLoading) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.debug('stopTimer by ' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'UL_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (!keepLoading) {
                    setLoaded('stopTimer');
                }

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logFptiData(fptiData, eventName) {
                var errorDescription = void 0;

                switch (eventName) {
                    case '2fa':
                        errorDescription = '2fa_required';
                        break;
                    case 'safeRequired':
                        errorDescription = 'SAFE_required';
                        break;
                    case 'stepupRequired':
                        errorDescription = 'Login_ATO_required';
                        break;
                    default:
                    // nothing to do here
                }
                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.fptiState,
                    'to': fptiData.fptiTransition,
                    'int_error_code': eventName,
                    'int_error_description': errorDescription,
                    'error_type': 'soft_decline',
                    'error_source': 'unifiedloginnodeweb'
                });
            }

            function buildRedirectURL(contingencyUrl, eventName) {
                var authChallengeUrl = contingencyUrl;
                var paramIndex = authChallengeUrl.indexOf('?');
                var urlParams = _squid.$util.params(authChallengeUrl.substring(paramIndex + 1));

                urlParams.returnUri = _squid.$config.ulMeta.authChallengeReturnUri;
                if (userSelectedLanguage) {
                    urlParams['locale.x'] = _squid.$locale.getLocaleCode();
                    urlParams['state'] += '&locale.test=' + _squid.$locale.getLocaleCode();
                }
                switch (eventName) {
                    case '2fa':
                        urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
                        break;
                    case 'safeRequired':
                        urlParams['state'] += '&acRedirect=safe';
                        break;
                    case 'stepupRequired':
                        urlParams['state'] += '&acRedirect=loginato';
                        break;
                    default:
                    // nothing to do here
                }
                var redirectUrl = _squid.$util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);

                return redirectUrl;
            }

            if (!_squid.$config.ulMeta) {
                _logger.$logger.error('config_no_ulMeta');
            }

            var ulMeta = _squid.$config.ulMeta || {};

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                // if remebered user then update spinner text
                var isRememberedUser = $scope.auth.refreshToken();

                setLoading('loadUL', isRememberedUser);

                return _kmliEligibility.$KmliEligibility.init({
                    forcedLogin: $scope.forcedLogin,
                    logoutCallback: $scope.logoutCallback
                });
            }).then(function (eligibility) {
                ulTimeoutLimit = eligibility.ulTimeoutLimit ? eligibility.ulTimeoutLimit : ulTimeoutLimit;
                $scope.preloadUL = eligibility.preloadUL;
                $scope.safeEligibility = eligibility.safeEligibility;
                $scope.kmliEligibility = eligibility.kmliEligibility;

                if ($scope.preloadUL) {
                    _logger.$logger.debug('ULSS_CLIENT_PRELOAD_TREATMENT');
                    return (0, _squid.$populate)($scope, { ulSource: _auth.$ULoginModel.instance() });
                }

                if (!$scope.checkoutCart.isWalletTokenization() && !$scope.preloadUL) {
                    $scope.ryiOptin = false;
                }
                return _angular.$q.resolve(true);
            }).then(function () {
                var rememberMe = !$scope.auth.refreshToken() ? false : $scope.kmliEligibility; // UL needs 'rememberMe=true' for RT exchange
                var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

                if ($scope.auth.refreshToken() && !$scope.forcedLogin) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': 'LOGIN_UL_RM',
                        'to': 'prepare_login_ul_RM',
                        app_int_type: app_int_type
                    });
                }

                function getPostLoginFpti(data) {
                    var result = void 0;

                    if (data.event === 'tokenExchanged') {
                        // This is either OneTouch or JWT (Partner Integration).
                        if (data.authorizationToken === 'jwt_token') {
                            result = { fptiState: 'LOGIN_UL_JWT', fptiTransition: 'process_UL_JWT' };
                        } else {
                            result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
                        }
                    } else {
                        var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
                        var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        result = { fptiState: ULState, fptiTransition: fptiTransitionName };
                    }

                    return result;
                }

                var cancelLocaleChange = void 0;

                function loginComplete(data) {
                    var jwtBasedAssertion = data.event === 'tokenExchanged' && data.authorizationToken === 'jwt_token';
                    var rtExchanged = data.event === 'tokenExchanged' && data.authorizationToken !== 'jwt_token';

                    _squid.$promise.run(function () {
                        // eslint-disable-line
                        $scope.auth.stepupAuthRequired = false;

                        stopTimer('loginComplete');

                        if (cancelLocaleChange) {
                            cancelLocaleChange();
                        }

                        $scope.auth.isKmliSet = data.keepMeLoggedIn || rtExchanged;
                        $scope.auth.rtExchanged = rtExchanged;

                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': fptiData.fptiTransition
                        });

                        if (window.xprops && window.xprops.onAuth && data && data.accessToken) {
                            return window.xprops.onAuth({
                                accessToken: data.accessToken
                            });
                        }
                    }).then(function () {
                        var upsellEligibilityData = { ulData: data };

                        // Doesn't exist in risky login case
                        if ($scope.preAuth) {
                            // Fires off eligibility + econsent + xosession in batch mode
                            $scope.preAuth();
                        }

                        if (data.event === 'tokenExchanged') {
                            if ((0, _squid.$feature)('rmSpinnerText') && !jwtBasedAssertion) {
                                _angular.$rootScope.$emit('loadingMessage', {
                                    heading: _squid.$locale.content.get('base.planning'),
                                    subHeading: _squid.$locale.content.get('login.rmSubHeading')
                                });
                            } else {
                                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.planning'));
                            }
                        }

                        return $scope.auth.reload({
                            resultModel: $scope.auth,
                            headers: {
                                'x-paypal-internal-euat': data.accessToken
                            },
                            batch: {
                                name: 'setbuyer',
                                id: 'securityCtx',
                                dependencies: []
                            },
                            success: function success() {
                                $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';
                                angular.extend(upsellEligibilityData, {
                                    buyerCountry: $scope.auth.country,
                                    jwtBasedAssertion: jwtBasedAssertion,
                                    showReactivationInterstitial: $scope.showReactivationInterstitial
                                });
                                _kmliUpsell.$KmliUpsell.init(upsellEligibilityData);
                                $scope.postAuth($scope.auth);
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, contingency) {
                                    $scope.auth.password = '';
                                    $scope.errorFn(name, contingency);
                                }
                            }
                        });
                    });
                }

                var ulEventHandlers = {
                    'loginRendered': function loginRendered(data) {
                        var loadingCompletedTime = Date.now();

                        _logger.$logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
                            page_load_time: loadingCompletedTime - enteringTime
                        });

                        // Check if this is triggered by JWT assertion failure.
                        // If so, do FPTI instrumentation.
                        if (data.authorizationType === 'token' && data.authorizationToken === 'jwt_token') {
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_JWT',
                                'to': 'process_UL_JWT',
                                'int_error_code': 'unknown',
                                'int_error_description': 'JWT assertion failed',
                                'error_source': 'unifiedloginnodeweb',
                                'error_type': 'soft_decline'
                            });
                        }
                    },
                    'loginFullyLoaded': function loginFullyLoaded(data) {
                        stopTimer(data.event);

                        if ($scope.notYou) {
                            _angular.$rootScope.$emit('loaded');
                            delete $scope.notYou;
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'LOGIN_UL_RM',
                                'to': 'prepare_login_ul'
                            });
                            _fn.$fn.sendTypingSpeedPayload('HermesUL');
                            return $scope.logoutCallback();
                        }

                        if (!_uiRouter.$state.current.trackingData) {
                            _uiRouter.$state.current.trackingData = { fptiState: 'ulLoginDefault' };
                        }
                        _uiRouter.$state.current.trackingData.pageQualifier = 'ulLogin';

                        var loadingCompletedTime = Date.now();
                        var timeTaken = loadingCompletedTime - enteringTime;

                        _logger.$logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
                            page_load_time: timeTaken
                        });

                        if ($scope.preLoadedSource) {
                            _logger.$logger.debug('ULSS_CLIENT_LOADED_SUCCESSFULLY', {
                                page_load_time: timeTaken
                            });
                        }

                        var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';

                        _logger.$logger.info('checkout_fpti', {
                            'from': ULState,
                            'to': 'prepare_iframe',
                            'page_load_time': timeTaken
                        });

                        var payload = {
                            'from': ULState,
                            'to': 'prepare_login_ul',
                            'app_int_type': app_int_type
                        };

                        if (_uiRouter.$stateParams.targetPage) {
                            angular.extend(payload, { 'int_error_code': _uiRouter.$stateParams.targetPage });
                        }

                        _logger.$logger.info('checkout_fpti', payload);
                        _fn.$fn.sendTypingSpeedPayload('HermesUL');
                        _logger.$logger.flush();
                    },
                    'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
                        loginAttemptedMethod = 'email';
                    },
                    'loginPhonePinAttempted': function loginPhonePinAttempted() {
                        loginAttemptedMethod = 'phone';
                    },
                    'loginAttempted': function loginAttempted(data) {
                        setLoading(data.event);
                        _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('base.loggingIn'));
                        if (rememberMe === true) {
                            var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';

                            _logger.$logger.debug(kmliStatus);
                        }
                        startTimer(data.event);
                    },
                    'loginSuccess': loginComplete,
                    'tokenExchanged': function tokenExchanged(data) {
                        _logger.$logger.info('TOKEN_EXCHANGED', {
                            authorizationType: data.authorizationType,
                            authorizationToken: data.authorizationToken || ''
                        });
                        loginComplete(data);
                    },
                    'notYouLinkClicked': function notYouLinkClicked(data) {
                        _angular.$rootScope.$emit('loading');
                        $scope.notYou = true;
                        _logger.$logger.info('checkout_fpti', {
                            from: 'LOGIN_UL',
                            to: 'login_with_diff_user'
                        });
                        startTimer(data.event);
                    },
                    '2fa': function fa(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if (data.contingencyUrl) {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    },
                    'safeRequired': function safeRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);
                        if ($scope.safeEligibility && data.contingencyUrl) {
                            if (data.authorizationType && data.authorizationType === 'token') {
                                // for remembered user redirect to login instead of SAFE APP
                                _logger.$logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
                                _uiRouter.$state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
                            }
                            _logger.$logger.debug('ULSAFE_REDIRECTION');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('ULSAFE_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                    },
                    'serverError': function serverError(data) {
                        stopTimer(data.event);
                        var error_code = 'INVALID_USER';
                        var error = {
                            type: 'pageError',
                            code: 500
                        };

                        // internalServerError, code: 500, take user to hermes login, no need for error message
                        switch (data.reason) {
                            case 'serverValidationError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else if (loginAttemptedMethod === 'phone') {
                                    error_code = 'INVALID_PHONE_PIN';
                                    error.msg = _squid.$locale.content.get('login.invalidPin');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                break;
                            case 'invalidUser':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                }
                                break;
                            case 'internalServerError':
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.invalidEmailPasswordPageError');
                                }
                                _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                                return appLoginHandler(failureReasons.error);
                            case 'accountTemporaryLocked':
                            case 'accountPermanentlyLocked':
                                error.code = data.code;
                                error.msg = _squid.$locale.content.get('login.accountLockedPageError');
                                error_code = 'ACCOUNT_LOCKED';
                                break;
                            case 'riskDecline':
                                error.code = data.code;
                                if (data.authorizationType === 'token') {
                                    error_code = 'ONETOUCH_GENERIC_ERROR';
                                    error.msg = _squid.$locale.content.get('login.reactivateOneTouch');
                                } else {
                                    error.msg = _squid.$locale.content.get('login.riskDeclinePageError');
                                    error_code = 'RISK_DECLINE';
                                }
                                break;
                            default:
                            // Do nothing
                        }
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.code,
                            'int_error_description': data.reason,
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                        $scope.parentCallback('showErrorMessages', error_code);
                    },
                    'client_validation_error': function client_validation_error(data) {
                        var error = {
                            type: 'pageError',
                            msg: _squid.$locale.content.get('login.invalidEmailPasswordPageError')
                        };
                        var fptidata = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptidata.fptiState,
                            'to': fptidata.fptiTransition,
                            'int_error_code': data.event,
                            'int_error_description': 'invalid_credentials',
                            'error_type': 'soft_decline',
                            'error_source': 'unifiedloginnodeweb'
                        });
                        _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
                    },
                    'stepupRequired': function stepupRequired(data) {
                        stopTimer(data.event);
                        var fptidata = getPostLoginFpti(data);

                        logFptiData(fptidata, data.event);

                        if (data.authorizationType && data.authorizationType === 'token') {
                            // for remembered user redirect to login instead of AuthChallenge APP
                            _logger.$logger.debug('LOGIN_ATO_RM_USER');

                            // doing nothing, ul will render the login page, we need to show warning on top though
                            var error_code = 'ONETOUCH_GENERIC_ERROR';
                        } else if (data.contingencyUrl) {
                            _logger.$logger.debug('LOGIN_ATO_USER');
                            var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);

                            _squid.$util.redirect(authChallengeRedirectUrl);
                        } else {
                            _logger.$logger.debug('LOGIN_ATO_GENERIC_ERROR');
                            _uiRouter.$state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                        }
                        // to show error message on login page
                        $scope.parentCallback('showErrorMessages', error_code); // eslint-disable-line block-scoped-var
                    },
                    'captcha': function captcha(data) {
                        var fptiData = getPostLoginFpti(data);

                        _logger.$logger.info('checkout_fpti', {
                            'from': fptiData.fptiState,
                            'to': 'prepare_captcha'
                        });
                    },
                    'bodyClick': function bodyClick() {
                        _angular.$rootScope.$broadcast('clickBody');
                    },
                    'expiredRefreshToken': function expiredRefreshToken(data) {
                        var treatment = data.treatment;

                        _logger.$logger.info('EXPIRED_RT_' + treatment);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'LOGIN_UL_RM',
                            'to': 'process_RT_AT_exch',
                            'int_error_code': 'expired_RT_Token',
                            'int_error_desc': treatment,
                            'error_source': 'unifiedloginnodeweb',
                            'error_type': 'soft_decline'
                        });

                        switch (treatment) {
                            case 'showInterstitial':
                                $scope.showReactivationInterstitial = true;
                                break;

                            case 'checkboxPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
                                break;

                            case 'checkboxNotPreselectedWithNotification':
                                $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
                                break;

                            case 'expiredRefreshTokenControl':
                                break;

                            default:
                                break;
                        }
                    }
                };

                function postMessageHandler(response) {
                    (0, _angular.$timeout)(function () {
                        _logger.$logger.info('ul_postmessaged_received', response);
                        var data = response.data || response.error;
                        var eventId = data && data.event;

                        if (eventId) {
                            _logger.$logger.debug('ULLOGIN_' + eventId, response);
                            var handler = ulEventHandlers[eventId];

                            if (handler) {
                                handler(data);
                            }
                        }
                    });
                }

                function loadUnifiedLogin(iframeCopy) {
                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
                        'flow': '1-P',
                        'token': $scope.token
                    }, ['cmd']);
                    var isHermesInsideIframe = _squid.$util.isIFrame();

                    if (isHermesInsideIframe) {
                        _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                    }

                    var options = {
                        targetElement: document.getElementById('injectedUnifiedLogin'),
                        xhrRequest: isHermesInsideIframe,
                        queryParams: {
                            'stsRedirectUri': ulMeta.stsReturnUrl,
                            'country.x': $scope.locale.country,
                            'locale.x': $scope.locale.getLocaleCode(),
                            'returnUri': ulMeta.ulReturnUri,
                            'state': queryString,
                            'flowId': $scope.token,
                            'correlationId': _model.$CalDataModel.getCalCorrId()
                        },
                        config: {
                            title: 'PayPal - ' + _squid.$locale.content.get('common.login')
                        },
                        onPostMessage: postMessageHandler
                    };

                    if (_squid.$meta.baToken) {
                        angular.extend(options.queryParams, { 'fn_dt': _squid.$meta.baToken });
                    }

                    if ($scope.forcedLogin) {
                        angular.extend(options.queryParams, { 'prompt': 'login' });
                    }

                    if ($scope.logoutCallback) {
                        angular.extend(options.queryParams, { 'showNotYou': true });
                    }

                    if (_uiRouter.$stateParams.source !== 'NOT_YOU') {
                        $scope.flowcontext = $scope.checkoutCart.flow_context;
                    } else {
                        $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
                    }

                    if ($scope.flowcontext) {
                        angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
                    }

                    if (_squid.$config.deploy.isLocal()) {
                        options.origin = 'https://' + _squid.$meta.stage;
                        if (!_squid.$meta.stage) {
                            // if no stage url shows up then use any backup url for origin
                            var backupURL = _squid.$config.onboarding.url.split('/webapps/')[0];
                            options.origin = backupURL;
                        }
                    }

                    // preload only for first time login attempts
                    if ($scope.preloadUL && $scope.ulSource && $scope.ulSource.src && !$scope.forcedLogin && _uiRouter.$stateParams.source !== 'NOT_YOU' && !userSelectedLanguage && rememberMe) {
                        _logger.$logger.debug('ULSS_CLIENT_PRELOAD_INJECT');
                        $scope.preLoadedSource = true;
                        options.preLoadedSource = decodeURI($scope.ulSource.src);
                    }

                    function ulInvoke() {
                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('ulInvoke');
                            if (!iframeCopy) {
                                PAYPAL.unifiedLogin.inject(options);
                            } else {
                                PAYPAL.unifiedLogin.copyPasteIframe({
                                    targetElement: document.getElementById('injectedUnifiedLogin'),
                                    onPostMessage: postMessageHandler
                                });
                            }
                        } else {
                            return appLoginHandler(failureReasons.fallback);
                        }
                    }

                    var jwtToken = _squid.$util.param('jwtToken');

                    if (jwtToken) {
                        options.queryParams.jwtToken = jwtToken;
                    }

                    if (rememberMe === true) {
                        options.queryParams.rememberMe = true;
                        // NOTE: `xo_hermesnode_kmli_upsell` has been ramped to 100%
                        // and it's always return `xo_hermesnode_kmli_content_t1`
                        options.queryParams.rememberMeContent = 1;
                    }
                    return ulInvoke();
                }

                var cancelAllLoaded = _angular.$rootScope.$on('allLoaded', function () {
                    cancelLocaleChange = $scope.$on('localeChange', function () {
                        userSelectedLanguage = _squid.$locale.lang;
                        setLoading('localeChange');
                        loadUnifiedLogin();
                    });
                    cancelAllLoaded();
                });

                $scope.$on('$destroy', cancelAllLoaded);
                loadUnifiedLogin(ulMeta.iframeCopy);
            });
        }]
    };
});

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_squid.$populate;

_squid.$util;

_squid.$promise;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_auth.$ULoginModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_fpti.$fpti;

_model.$CalDataModel;

_fn.$fn;

_kmliEligibility.$KmliEligibility;

_kmliUpsell.$KmliUpsell;

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/template.html":
/***/ (function(module, exports) {

module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ul = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/ul-inline/dist/inject.js");

/**
 * Created by upigilam on 4/8/16.
 * UL handler is to exchange ST to RT exchanges.
 */

var $ul = exports.$ul = {

    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {

        return (0, _angular.$q)(function (resolve, reject) {

            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 10000;
            var ulTimeoutPromise = null;

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
                };
                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            function failureHandler(reason) {
                logSubmit({ errorCode: reason });
                _logger.$logger.info('UL_Loading_error_' + reason);
                return reject(new Error('UL_Loading_error_' + reason));
            }

            function startTimer(tag) {
                _logger.$logger.info('UL_START_TIMER_' + tag);
                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    failureHandler('timed_out');
                    if (!silent) {
                        _angular.$rootScope.$emit('loaded');
                    }
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                if (!silent) {
                    _angular.$rootScope.$emit('loaded');
                }
                _logger.$logger.info('UL_STOP_TIMER_' + tag);

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                    ulTimeoutPromise = null;
                }
            }

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    logSubmit();
                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.refresh_token = true;
                    });
                    return resolve();
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    failureHandler(data.event);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
                    // actions on the element which is causing excess spinners later.
                    var child = document.getElementById('ulTargetAttribute');
                    child.parentNode.removeChild(child);
                    stopTimer(data.event);
                    failureHandler(data.event);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;
                    if (eventId) {
                        _logger.$logger.debug('UL' + eventId, response);
                        var handler = ulEventHandlers[eventId];
                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function loadOneTouchUpsell() {
                if (!silent) {
                    _angular.$rootScope.$emit('loading');
                }

                var ulTargetAttribute = document.createElement('div');
                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
                // ulTargetAttribute.style.display = "None";

                // Making 0px, it works for FF, Chrome, Safari
                ulTargetAttribute.style.width = '0px';
                ulTargetAttribute.style.margin = '0px';
                ulTargetAttribute.style.height = '0px';
                ulTargetAttribute.style.padding = '0px';

                document.body.appendChild(ulTargetAttribute);

                var options = {
                    targetElement: document.getElementById('ulTargetAttribute'),
                    queryParams: {
                        'country.x': locale_country,
                        'locale.x': locale_code,
                        'flowId': token,
                        'correlationId': _model.$CalDataModel.getCalCorrId(),
                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
                    },
                    iframePathname: '/signin/activate-one-touch',
                    onPostMessage: postMessageHandler
                };

                if (_config.$config.deploy.isLocal()) {
                    if (_config.$meta.stage) {
                        options.origin = 'https://' + _config.$meta.stage;
                    } else {
                        // if no stage url shows up then use any backup url for origin
                        options.origin = _config.$config.urls.onboarding.split('/webapps/')[0];
                    }
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    startTimer('initializeUl');
                    PAYPAL.unifiedLogin.inject(options);
                } else {
                    failureHandler('PAYPAL.unifiedLogin_undefined');
                }
            }

            loadOneTouchUpsell();
        });
    }
};

// Loads unifiedLogin key on to PAYPAL window object


angular.value("$ul", $ul);
_angular.$rootScope;

_angular.$q;

_angular.$timeout;

_logger.$logger;

_config.$config;

_config.$meta;

_model.$CalDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoBackupLabel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/backup-label/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/backup-label/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoBackupLabel = exports.$xoBackupLabel = _squid.$Component.extend('$xoBackupLabel', {
    tag: 'xo-backup-label',
    template: _template2['default'],
    props: {
        plan: {
            type: 'var',
            required: false
        },
        hasMask: {
            type: 'var',
            required: false
        }
    }
});

angular.value("$xoBackupLabel", $xoBackupLabel);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/backup-label/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"backupFi\" class=\"backupContainer\" ng-class=\"{ hasMask: hasMask }\" content>\n    {{plan.backup.name}}\n    <span ng-if=\"!plan.isAuthRequired\">\n        <span ng-if=\"!props.hasMask\">x-{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n        <span ng-if=\"props.hasMask\"><span class=\"cardMask\"><span/><span/><span/><span/></span>{{plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n    </span>\n</div>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/billing-address/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/billing-address/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(0, _squid.$registerDirective)('xo-billing-address', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            editUri: '=?'
        },
        lifecycle: {
            enter: function enter() {
                _logger.$logger.info('xo-billing-address_enter');
            }
        },
        controller: ['$scope', function ($scope) {
            var getBillingAddress = function getBillingAddress(cardId) {
                return (0, _squid.$populate)($scope, {
                    cardInfo: _fi.$CardInfoModel.instance(cardId)
                }).then(function () {
                    return $scope.cardInfo && $scope.cardInfo.billingAddress;
                });
            };

            var updateScopeData = function updateScopeData(checkoutSession) {
                $scope.selectedCardId = $scope.checkoutSession.plan.sources[0].instrument_id;
                return getBillingAddress($scope.selectedCardId).then(function (address) {
                    $scope.address = address;
                    $scope.line3 = address.city + ', ' + address.state + ' ' + address.postal_code;
                });
            };

            (0, _squid.$populate)($scope, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.header = _squid.$locale.content.get('addCard.billingAddress');
                $scope.updateType = _squid.$locale.content.get('common.edit');
                return updateScopeData($scope.checkoutSession);
            }); // populate

            $scope.$watchCollection('checkoutSession', function (newVal) {
                if (newVal) {
                    // Clear the cached CardInfo so we can get the latest associated Billing Address
                    if ($scope.cardInfo) {
                        $scope.cardInfo.invalidate();
                    }
                }
                return updateScopeData($scope.checkoutSession);
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_squid.$registerDirective;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_fi.$CardInfoModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/billing-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"billing-address-wrapper\" ng-model=\"checkoutSession\">\n    <div class=\"box-header\">\n        <div class=\"headerText\">{{header}}</div>\n    </div>\n    <div class=\"box-body\">\n        <span>{{address.line1}},</span>\n        <span ng-if=\"address.line2\">{{address.line2}},</span>\n        <span>{{line3}}</span>\n        <a track-link=\"edit_billing_address\" ui-sref=\"checkout.payWithCard.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: selectedCardId})\" class=\"addCardLink\" role=\"button\">\n            {{updateType}}\n        </a>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/card-backup/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/card-backup/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * xo-card-backup
 * Render a dropdown for user to select their backup instrument in case their card
 * gets declined
 * @params {String} token - token for models
 */
exports['default'] = _squid.$Component.extend('$CardBackupComponent', {
    tag: 'xo-card-backup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        // Since selected method means the user might have something different selected compared to the checkout session,
        // might need to have this passed in to filter out the plan
        selectedmethod: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()
            };
        }
    },
    actions: {
        getAllowedBackups: function getAllowedBackups() {
            var planList = this.models.checkoutSession.getPlanList() || [];
            var currentPlanId = this.props.selectedmethod ? this.props.selectedmethod.planId : planList[0].planId;

            return planList.filter(function (a) {
                return a.planId !== currentPlanId && a.primaryFs && a.primaryFs.type === 'CARD' && a.secondaryFIs === false;
            });
        },
        renderCover: function renderCover() {
            var backup = this.models.checkoutSession.cardBackup.getPlan();

            if (!backup) {
                return (0, _squid.$renderContent)('paymentMethod.chooseBackup');
            } else {
                return this.actions.renderOption(backup) + ' ' + (0, _squid.$renderContent)('paymentMethod.backup');
            }
        },
        renderOption: function renderOption(plan) {
            return this.models.fiMeta.getName(plan.primaryFs) + ' x-' + plan.primaryFs.lastDigits;
        },
        selectBackup: function selectBackup(plan) {
            var _this = this;

            var selectedmethodPlan = this.props.selectedmethod ? (this.models.checkoutSession.getPlanList() || []).find(function (p) {
                return p.planId === _this.props.selectedmethod.planId;
            }) : null;

            this.models.checkoutSession.cardBackup.setPlan(plan, selectedmethodPlan);
            this.actions.toggleDropdown();
        },
        toggleDropdown: function toggleDropdown() {
            var _this2 = this;

            this.showDropdown = !this.showDropdown;

            if (this.showDropdown) {
                (0, _angular.$timeout)(function () {
                    return _this2.actions.showDropdownUI();
                });
            }
        },

        // UI change - the box is right aligned, but need to position it so that
        // it doesn't overflow on the left
        showDropdownUI: function showDropdownUI(open) {
            var position = this.$element.find('.card-backup-dropdown').position();

            this.$element.find('.card-backup-options').css({
                right: position && position.left < 0 ? position.left : 0,
                visibility: 'visible'
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this3 = this;

            // Close the dropdown if focus leaves the menu
            _angular.$document.on('focusin.cardBackup', function (event) {
                if (_this3.showDropdown && !_this3.$element[0].contains(event.target)) {
                    _this3.showDropdown = false;
                }
            });
        },
        exit: function exit() {
            // Clean up the dropdown handler
            _angular.$document.off('focusin.cardBackup');
        }
    }
});


_angular.$document;

_angular.$timeout;

_squid.$Component;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/card-backup/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-backup\" content>\n    <div class=\"card-backup-head\">\n        <span class=\"common-icon info\"></span>\n        <a ng-click=\"actions.toggleDropdown()\"\n            class=\"card-backup-cover link-dotted\"\n            href=\"#\" select-button aria-expanded=\"{{showDropdown}}\" focus-when=\"!showDropdown\" focused-once-before>\n            {{actions.renderCover()}}\n            <span class=\"card-backup-expand common-icon expand\"></span>\n        </a>\n        <div ng-if=\"showDropdown\" class=\"card-backup-dropdown\" tabindex=\"-1\" select-box select-cancel=\"actions.toggleDropdown()\" form-autofocus>\n            <div class=\"arrow-top\"></div>\n            <div class=\"card-backup-options\">\n                <li ng-repeat=\"plan in actions.getAllowedBackups() track by $index\"\n                    class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(plan)\">\n                        {{actions.renderOption(plan)}}\n                    </a>\n                    <span ng-if=\"models.checkoutSession.cardBackup.getPlan() === plan\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n                <li class=\"card-backup-option secondary\">\n                    <a href=\"#\" link-button\n                        ng-click=\"actions.selectBackup(null)\">\n                        {{content('paymentMethod.noBackup')}}\n                    </a>\n                    <span ng-if=\"!models.checkoutSession.cardBackup.getPlan()\"\n                        class=\"common-icon check-blue\">\n                    </span>\n                </li>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-backup-info secondary\">\n        {{content('paymentMethod.cardBackupDescription')}}\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoDonate', {
    tag: 'xo-donate',
    template: _template2['default'],
    props: {
        merchantName: {
            type: 'str',
            required: false
        }
    },
    actions: {
        showConsent: function showConsent() {
            this.showConsentBox = !this.showConsentBox;
            _factory.$GiveAtCheckoutFactory.set({ donateCheckboxSelected: this.showConsentBox });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showConsentBox = false;
        },
        populate: function populate() {
            this.isWpsflow = _factory.$GiveAtCheckoutFactory.get().isWPSflow || false;
            this.charity = _factory.$GiveAtCheckoutFactory.get().charity || {};
            if (this.charity.amount && this.charity.currency) {
                this.formattedAmount = (0, _squid.formatCurrency)(this.charity.amount, this.charity.currency, false, 'Currency');
            }
            this.tracking = _factory.$GiveAtCheckoutFactory.get().tracking;
        }
    }
});


_squid.$Component;

_squid.formatCurrency;

_factory.$GiveAtCheckoutFactory;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function parseMessage(mors) {
    if (!(mors && mors.data)) {
        return {};
    }
    var touchpoints = mors.data.touchpoint_messages || [];

    if (Array.isArray(touchpoints) && touchpoints.length > 0) {
        var messages = touchpoints[0].messages || [];

        var chosen = messages.filter(function (message) {
            return message.content && message.content.json && message.content.json.model_score;
        }).reduce(function (prev, curr) {
            return prev && prev.content.json.model_score > curr.content.json.model_score ? prev : curr;
        }, undefined);

        if (chosen) {
            var charity = chosen.content.json;
            var tracking = chosen.tracking_details;

            if (charity) {
                return { charity: charity, tracking: tracking };
            }
        }
    }
    return {};
}

/*
function parseUserType(charity) {
    if (charity && charity.user_type) {
        return charity.user_type;
    }
    const DONOR_MODELS = ['0', '1'];
    if (charity && charity.model_id) {
        return DONOR_MODELS.indexOf(charity.model_id) >= 0 ? 'DONOR' : 'NONDONOR';
    }
}
*/

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$GiveAtCheckoutFactory', function () {
    var state = {
        donateCheckboxSelected: false,
        eligible: false,
        charity: undefined,
        tracking: undefined,
        isWPSflow: undefined
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var decideEligibility = function decideEligibility() {
        var models = {};

        return (0, _squid.$populate)(models, {
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
            payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
        }).then(function () {
            return _marketingoffer.$MessageDiscoverModel.instance().save({
                silent: true,
                data: {
                    'country_code': _squid.$locale.getCountryCodeISO(),
                    'language': _squid.$locale.getLocaleCode(),
                    'identity_context': [{
                        'type': 'PAYER_ID',
                        'value': models.checkoutSession.get('payer.id')
                    }, {
                        'type': 'MERCHANT_PAYER_ID',
                        'value': models.payee && models.payee.merchant && models.payee.merchant.id
                    }],
                    'recommendation_context': {
                        'touchpoint_details': [{
                            'code': 'hermes_gac_touchpoint',
                            'message_count': -1
                        }]
                    }
                },
                error: function error(err) {
                    return _squid.$promise.reject(err);
                }
            });
        }).then(function (mors) {
            var _parseMessage = parseMessage(mors),
                charity = _parseMessage.charity,
                tracking = _parseMessage.tracking;

            if (charity) {
                state.charity = charity;
                state.tracking = tracking;
                _logger.$logger.info('mors_eligibility', {
                    eligible: !!charity,
                    charityName: charity.name,
                    chaityLogo: charity.logo_url,
                    amount: charity.amount
                });

                return charity;
            }
        }).then(function (charity) {
            // we are now temporally return false to disable the experience to deprecate pxp call.
            // we will work on to bring it back post pxp decpredation.
            state.eligible = false;
            return false;
        })['catch'](function (err) {
            _logger.$logger.error('gac_eligibility', err);
            state.eligible = false;
            return state.eligible;
        });
    };

    return {
        get: get,
        set: set,
        decideEligibility: decideEligibility
    };
});

_angular.$rootScope;

_logger.$logger;

_squid.$util;

_squid.$populate;

_squid.$promise;

_squid.$locale;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutPayeeModel;

_marketingoffer.$MessageDiscoverModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/give-at-checkout", "../node_modules/xo-member-components/src/give-at-checkout/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/give-at-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"give-at-checkout\" ng-if=\"charity.name && charity.logo_url && formattedAmount\" content>\n    <div class=\"prominentGacSeparator\">\n        <span class=\"prominentGacSeparatorLine\"></span>\n    </div>\n    <div class=\"donate checkbox\">\n        <input type=\"checkbox\" class=\"donateCheckbox\" name=\"donate\" id=\"donate\" data-test-id=\"donate-checkbox\" ng-click=\"actions.showConsent()\"/>\n        <label data-test-id=\"donate-label\" class=\"donate-label\" for=\"donate\">\n            <div data-test-id=\"charity-logo\" class=\"charity-logo\"  ng-style=\"{ background: 'url(' + charity.logo_url + ') center center / contain no-repeat' }\"></div>\n            <div class=\"charity-content\">\n                <p class=\"charity-name\">{{content('donate.label', { amount: formattedAmount, charityName: charity.name})}}</p>\n                <p ng-if=\"charity.promo_message\" class=\"promo-msg\">{{ charity.promo_message }}</p>\n            </div>\n        </label>\n    </div>\n    <div class=\"donate-consent\" ng-if=\"showConsentBox\">\n        <div ng-if=\"!isWpsflow\">\n            <p class=\"title-ec\">\n                {{content('donate.ecFlowConsentLine1')}}\n            </p>\n            <p class=\"title\">\n                {{content('donate.ecFlowConsentLine2')}}\n            </p>\n            <p class=\"content\">\n                {{content('donate.ecFlowConsentLine3')}}\n            </p>\n        </div>\n        <div ng-if=\"isWpsflow\">\n            <p class=\"title-wps\">\n                {{content('donate.wpsFlowConsentLine1')}}\n            </p>\n            <p class=\"content\">\n                {{content('donate.wpsFlowConsentLine2')}}\n            </p>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoMsbOffer = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/msb-offer/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Component for rendering Merchant specific balance on the review page for multi fi
 * It renders on top of the list of the FI's
 * As far as we know - there can only be 1 msb applied per plan
 * and so each should have "incentive" attached
*/
var $xoMsbOffer = exports.$xoMsbOffer = _squid.$Component.extend('$xoMsbOffer', {
    tag: 'xo-msb-offer',
    template: _template2['default'],
    props: {
        /**
         * incentive field from FI object
         */
        msb: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var msb = this.props.msb;


            this.amount = (0, _squid.formatCurrency)(msb.amount.value, msb.amount.currency);
            this.minPurchaseAmount = msb.minPurchaseAmount;
        }
    }
});

angular.value("$xoMsbOffer", $xoMsbOffer);
_squid.$Component;

_squid.formatCurrency;

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/msb-offer/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <div class=\"msbOfferContainer\">\n        <div class=\"wrapper\">\n            <span class=\"fsIcon INCENTIVE\"></span>\n            <div class=\"fsdetails\">\n                <span class=\"name\">\n                    {{ content('paymentMethod.msbOffer') }}\n                </span>\n\n                <div class=\"msbHelpText secondary\">\n                    {{ content('paymentMethod.msbHelpText', {amount: amount})}}\n\n                    <a class=\"msbDetails\" id=\"msbOfferTooltipId\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n    <xo-tooltip trigger=\"#msbOfferTooltipId\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n        <div class=\"tip tipDesc\">\n            <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n            <div class=\"msbToolTipDescription\">\n                <p ng-if=\"minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText', {amount: amount, minimumPurchase: minPurchaseAmount}) }}\n                </p>\n                <p ng-if=\"!minPurchaseAmount\">\n                    {{ content('paymentMethod.msbToolTipText2', {amount: amount}) }}\n                </p>\n            </div>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNoBalance = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/no-balance/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/no-balance/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Banner with text messages that user have pending (not claimed yet) balance available,
 * but needs to go through verification steps on 8ball
 *
 * Used in the following pages:
 * 1. review page - hermesnodeweb/public/pages/xo-review
 * 2. add card contingency page - hermesnodeweb/public/pages/xo-add-card
 */
var $xoNoBalance = exports.$xoNoBalance = _squid.$Component.extend('$xoNoBalance', {
    tag: 'xo-no-balance-banner',
    template: _template2['default'],
    actions: {
        /**
         * event when clicking on info icon to show secondary message
         */
        onShowSecondaryMsg: function onShowSecondaryMsg($event) {
            $event.preventDefault();
            this.showSecondaryMsg = true;
            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_click_info'
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _$NoBalanceFactory$ge = _factory.$NoBalanceFactory.get(),
                showMsgWithAmount = _$NoBalanceFactory$ge.showMsgWithAmount,
                pendingBalances = _$NoBalanceFactory$ge.pendingBalances;

            if (showMsgWithAmount) {
                var balance1 = pendingBalances[0],
                    balance2 = pendingBalances[1];


                if (pendingBalances.length === 1) {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithAmt', { amt: (0, _squid.formatCurrency)(balance1.value, balance1.currency) });
                } else {
                    this.msg = (0, _squid.$renderContent)('noBalance.primaryMsgWithMultiAmt', {
                        amt1: (0, _squid.formatCurrency)(balance1.value, balance1.currency),
                        amt2: (0, _squid.formatCurrency)(balance2.value, balance2.currency)
                    });
                }
            } else {
                this.msg = (0, _squid.$renderContent)('noBalance.primaryMsg');
            }
        }
    }
});

angular.value("$xoNoBalance", $xoNoBalance);
_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_logger.$logger;

_factory.$NoBalanceFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

/**
 * Money Waiting (no balance) factory
 * story with details - https://rally1.rallydev.com/#/42145958143/detail/userstory/243026109436
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$NoBalanceFactory', function () {

    /**
     * eligible - to show / hide xo-no-balance component
     * showMsgWithAmount - to show / hide message with amount
     * pendingBalances - list of pending(non claimed yet) balances amounts
     * isAlreadyShown - was banner already shown or not
     */
    var state = {
        eligible: false,
        showMsgWithAmount: false,
        pendingBalances: undefined,
        isAlreadyShown: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    /**
     * Decide to show / hide message with amount / amounts
     * @param {Object} pxpResult - pxp result
     * @param {Object} pendingBalances - array of pending (non claimed yet) balances
     */
    var shouldShowMsgWithAmount = function shouldShowMsgWithAmount(_ref) {
        var pendingBalances = _ref.pendingBalances;

        return pendingBalances.length > 0;
    };

    /**
     * req.user has noBalance flag in case there is pending balance availaible which is getting mapped to auth model
     * mapping - https://github.paypal.com/Checkout/xo-hercules/blob/master/apis/auth/outputMapper.js
     */
    var hasUserPendingBalance = function hasUserPendingBalance() {
        return _auth.$AuthModel.instance().no_balance;
    };

    /**
     * Mark as already shown, for example:
     * if user doesn't have any FI -> user will see "no balance" banner on Add Card Page.
     * And so after user adds cart successfully -> we should not show banner on review page
     */
    var markAsAlreadyShown = function markAsAlreadyShown() {
        state.isAlreadyShown = true;
        state.eligible = false;
    };

    /**
     * experiment is eligible in the following cases:
     * 1. user has `no_balance` flag as `true` - means there is pending balance that user can claim, but need to go through verification first on 8ball
     * 2. user has less than 3 balance accounts
     * 3. pxp returns treatment1 or treatment2
     */
    var decideEligibility = function decideEligibility() {
        if (state.isAlreadyShown) {
            return _squid.$promise.resolve({});
        }

        var isUserWithPendingBalance = hasUserPendingBalance();

        return _wallet.$WalletModel.instance(_angular.$rootScope.token).retrieve().then(function (wallet) {
            var pendingBalances = wallet.getAmountsOfBalances();
            var isNoBalanceEligible = isUserWithPendingBalance && pendingBalances.length > 0 && pendingBalances.length < 3;

            var balance1 = pendingBalances[0],
                balance2 = pendingBalances[1];


            _logger.$logger.info('no_balance', {
                from: 'no_balance',
                to: 'no_balance_eligibility',
                number_of_balances: pendingBalances.length,
                no_balance_eligible: isNoBalanceEligible,
                balance_amount1: balance1 && balance1.value,
                balance_currency1: balance1 && balance1.currency,
                balance_amount2: balance2 && balance2.value,
                balance_currency2: balance2 && balance2.currency
            });

            if (!isNoBalanceEligible) {
                return _squid.$promise.resolve({});
            }

            state.eligible = true;
            state.pendingBalances = pendingBalances;
            state.showMsgWithAmount = shouldShowMsgWithAmount({ pendingBalances: pendingBalances });

            return state;
        });
    };

    return {
        get: get,
        set: set,
        markAsAlreadyShown: markAsAlreadyShown,
        decideEligibility: decideEligibility
    };
});

_squid.$util;

_squid.$promise;

_logger.$logger;

_wallet.$WalletModel;

_auth.$AuthModel;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/no-balance", "../node_modules/xo-member-components/src/no-balance/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/no-balance/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"noBalanceContainer\">\n    <div class=\"primaryMsgWrapper\">\n        <a ng-click=\"actions.onShowSecondaryMsg($event)\" class=\"questionMark\"></a>\n        <div class=\"primaryMsg\">{{ msg }}</div>\n    </div>\n    <div ng-if=\"showSecondaryMsg\" class=\"secondaryMsg\">{{ content('noBalance.secondaryMsg') }}</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-preferred-checkbox',
    template: _template2['default'],
    props: {
        makeFiPreferred: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    actions: {
        toggleModel: function toggleModel() {
            if (this.props.makeFiPreferred.selected) {
                this.props.makeFiPreferred.planId = this.props.plan.planId;
                this.props.makeFiPreferred.fiId = this.props.plan.primaryFs.type === 'BALANCE' ? this.props.plan.primaryFs.type : // Balance doesn't have an instrument id
                this.props.plan.primaryFs.id;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
        }
    }
});


_squid.$Component;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PreferredCheckboxFactory', function () {
    var state = {
        eligible: false
    };

    /**
     * check choice eligibility based on:
     * 1. is billing or not
     */
    var getChoicePreferredCheckboxEligibility = function getChoicePreferredCheckboxEligibility(checkoutCart) {
        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            return checkboxVariants.indexOf(variant) !== -1 && !checkoutCart.isBilling();
        });
    };

    /**
     * eligible if:
     *
     * 1. choice eligibility is successfull
     * 2. number of plans >= 1
     *
     * If there is only 1 plan, xo_hermes_single_preffered_checkbox pxp (https://engineering.paypalcorp.com/pxptoolstage/configuration?exptId=5480&version=1)
     * must return treatment
     *
    */
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans,
            checkoutCart = _ref.checkoutCart;

        if (!plans || plans.length === 0) {
            state.eligible = false;
            return;
        }

        return getChoicePreferredCheckboxEligibility(checkoutCart).then(function (choiceEligibility) {
            if (!choiceEligibility) {
                state.eligible = false;
                return;
            }

            _logger.$logger.info('preferred_checkbox_enabled');
            state.eligible = true;
            return;
        });
    };

    var isSinglePreferredCheckboxEligible = function isSinglePreferredCheckboxEligible(_ref2) {
        var plans = _ref2.plans;

        return plans && plans.length > 0 && state.eligible;
    };

    var showPreferredCheckbox = function showPreferredCheckbox(plan, fundingOptions) {
        return (plan.primaryFs.id || plan.primaryFs.type === 'BALANCE') && !fundingOptions.isPreferred(plan) && !(plan.primaryFs.type === 'CREDIT' && plan.primaryFs.name.includes('PAY_LATER_')) && !(_squid.$locale.country === 'DE' && plan.primaryFs.name === 'BILL_ME_LATER');
    };

    return {
        isSinglePreferredCheckboxEligible: isSinglePreferredCheckboxEligible,
        decideEligibility: decideEligibility,
        showPreferredCheckbox: showPreferredCheckbox
    };
});

_squid.$config;

_squid.$locale;

_logger.$logger;

_index.$ChoiceEligibility;

_angular.$rootScope;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/preferred-checkbox", "../node_modules/xo-member-components/src/preferred-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/preferred-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"checkboxFiPreferred sCheckbox checkbox {{plan.primaryFs.name}}\" ng-class=\"{cardart: cardart}\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\" aria-describedby=\"backupFi\">\n    <label for=\"makeFiPreferred\">{{\n    \tcontent(\n    \t\t'memberReview.prefer_' + plan.primaryFs.type,\n    \t\t{ name: content('fsMappings.'+ plan.primaryFs.name) }\n    \t)\n\t}}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-address/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-review-address',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        makeAddrPreferred: {
            type: 'var',
            required: false
        },
        countryCode: {
            type: 'str',
            required: false
        },
        storePickUpSelected: {
            type: 'var',
            required: false
        },
        nmjExperience: {
            type: 'var',
            required: false
        },
        hideShipToHeader: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                auth: _index2.$AuthModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoShipping: function gotoShipping() {
            if (this.models.checkoutAppData.flags.allow_change_shipping) {
                _uiRouter.$state.go('checkout.review.sidebar.shipping');
            } else {
                this.cannotChangeShippingInfoMessages = true;
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
                if (_this.makeAddrPreferred) {
                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
                    _this.makeAddrPreferred.shown = flag;
                }
                return flag;
            };

            /**
             * Decision on whether to show Make Preferred Checkbox
             * @returns {boolean}
             */
            this.isMakePreferred = function () {
                if (_this.models.auth.remembered) {
                    return updateMakePreferredFlag(false);
                }

                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
                    return updateMakePreferredFlag(true);
                }
                return updateMakePreferredFlag(false);
            };
        },
        populate: function populate() {
            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};

            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
            this.isNmj = this.props.nmjExperience && (this.props.nmjExperience.one_page || this.props.nmjExperience.design_2 || this.props.nmjExperience.design_3);
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$feature;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingForm\" class=\"shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div id=\"shippingAddress\">\n            <div ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button disable-role ng-click=\"actions.gotoShipping()\">\n                <h2 ng-show=\"!(storePickUpSelected || hideShipToHeader)\" class=\"noBottom gamma\">{{ content('shippingAddress.shipTo') }}</h2>\n                <div ng-show=\"storePickUpSelected\">\n                    <h2 class=\"noBottom gamma\">{{ content('shippingAddress.yourAddress') }}</h2>\n                    <span class=\"merchantReq\">{{ content('shippingAddress.merchantReq') }}</span>\n                </div>\n                <div class=\"addressDisplay\">\n                    <div ng-if='!(nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3))'>\n                        <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                        <span class=\"family-name\"></span>\n                        <xo-address-display address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                    </div>\n                    <div ng-if='nmjExperience && (nmjExperience.design_2 || nmjExperience.design_3)'>\n                        <span class=\"dropPin\" id=\"dropPin\"></span>\n                        <div class=\"nameAddress\">\n                            <span class=\"given-name\" data-test-id=\"fullName\">{{models.checkoutSession.shipping.name}}</span>\n                            <xo-address-display class=\"\" address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <a ng-show='!isNmj' class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" data-test-id=\"shipToChangeLink\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n    </div>\n    <div id=\"infoMessages\" class=\"msgPage msg-info shipNotification\" ng-if=\"cannotChangeShippingInfoMessages\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li ng-if=\"models.checkoutAppData.useraction() === 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsgUserActionCommit', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n            <li ng-if=\"models.checkoutAppData.useraction() !== 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsg', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"reviewPreferredShipping sCheckbox checkbox\" ng-if=\"isMakePreferred()\">\n    <input type=\"checkbox\" ng-model=\"makeAddrPreferred.selected\" name=\"makePreferred\" id=\"makePreferred\" />\n    <label for=\"makePreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n</div>\n\n<div ng-if=\"isNmj\" class=\"multipleShipping addShipping\">\n    <a track-link=\"change_shipping\" ng-click=\"actions.gotoShipping()\" class=\"addAddressLink\" id=\"addAddressLink\" data-test-id=\"shipToChangeLink\" role=\"button\">\n        <span class=\"plusicon\"></span>\n        <p class=\"addOption\">\n            <span class=\"name\">{{content('addShipping.switchAddress')}}</span>\n        </p>\n    </a>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/experience/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/pay-with-credit/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-member-components/src/billing-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/card-backup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/directive.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-member-components/src/show-more-fi/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/preferred-checkbox/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/directive.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/factory.js");

__webpack_require__("../node_modules/xo-member-components/src/msb-offer/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/backup-label/directive.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-paywith/template.html");

var _template2 = _interopRequireDefault(_template);

var _factory5 = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// billing address display
// PPC banners
// <xo-tooltip>
var ADD_CARD_URLS = {
    SIDEBAR_DEFAULT: {
        route: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard',
        label: 'fundingInstruments.addNewCard'
    },
    SIDEBAR_ADDCARD_WITH_ADDBANK: {
        route: 'checkout.review.sidebar.sidebarAddNew.bank.add',
        label: 'common.addNew'
    }
}; // <pay-with-credit>
// accessibility directives
// <xo-cvv>


(0, _angular.$registerDirective)('xo-review-paywith', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            token: '=?',
            showBmlPopup: '=?',
            installmentNotSelected: '=?',
            payButtonText: '=?',
            installment: '=?',
            padToggleFeature: '=?',
            selectedmethod: '=?',
            makeFiPreferred: '=?',
            selectFiVariant: '=?',
            nmjExperience: '=?',
            creditParentContext: '=?',
            choiceBalanceCheckboxState: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.locale = _squid.$locale;
            $scope.formatCurrency = _squid.formatCurrency;
            $scope.nmjMultiPage = $scope.nmjExperience && $scope.nmjExperience.multiPage;
            $scope.showMoreFiFactory = _factory.$ShowMoreFiFactory;
            $scope.smartAuthFactory = _factory4.$SmartAuthFactory;
            $scope.currencyConversionFactory = _factory5.$CurrencyConversionFactory;
            $scope.isCountryDE = _squid.$locale.country === 'DE';
            $scope.isCountryHU = _squid.$locale.country === 'HU';
            $scope.creditSharedInfo = _index3.$CreditSharedInfoModel.instance();

            // check for feature enabled in config/inc/ui.json for AU country
            // this feature is there only in country AU as of June 29th, 2015
            $scope.showUachFeatureDiscalimer = false;

            /**
             * isMultiFiPadEligible
             * Used to determine if we should combine plans to be able to show
             * a PAD toggle checkbox instead of 2 plans
             *
             * padToggleEnabled is used to control ramp per country using a combination of pxp
             * and a feature flag
             *
             * If the coutnry is included on the list of countires that should look at the pxp config
             * we check the pxp and then the feature flag to check if its enabled,
             *
             * If the country its not included in the list of countries that should check pxp
             * we just use the feature flag.
             *
             */
            var isMultiFiPadEligible = function isMultiFiPadEligible() {
                return $scope.isPadToggleFeatureApplicable() && $scope.padToggleEnabled;
            };

            var setPadStatus = function setPadStatus(state) {
                $scope.padToggleFeature.checkboxEnabled = state;
            };

            var getPadStatus = function getPadStatus() {
                return $scope.padToggleFeature.checkboxEnabled;
            };

            var getMultiFiPadCheckboxState = function getMultiFiPadCheckboxState(id) {
                return $scope.padToggleFeature.multiFiCheckboxStates[id];
            };

            // used for multiFi DE
            // update pad status which is used to show/hide "Pay after 14 Days" label as a text on a blue Pay button
            var setPadStatusForMultiFi = function setPadStatusForMultiFi(plan) {
                if ($scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACH(plan)) {
                    setPadStatus(getMultiFiPadCheckboxState(plan.primaryFs.id));
                } else {
                    setPadStatus(false);
                }
            };

            // TODO: remove after PAPS fix
            $scope.balanceWithRewards = function (fi) {
                return _factory3.$RewardsCheckboxFactory.hideAmount(fi);
            };

            $scope.hasRewards = function (plan) {
                return _factory3.$RewardsCheckboxFactory.isRewardsPlan(plan);
            };

            $scope.getRewardsContent = function (plan) {
                // Need a content mapper because content experience
                // changes based on type of rewards in plan.
                var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(plan);

                return contentKeys || {};
            };

            $scope.isSelected = function (plan) {
                if (!plan) {
                    return false;
                }
                var getID = function getID(obj) {
                    return obj.planId || obj.id;
                };
                var selection = $scope.selectedmethod ? $scope.selectedmethod : $scope.checkoutSession.plan;
                var result = getID(plan) === getID(selection);
                // When the user is on RYI after selectFI
                // selection logic is maintained by the session
                // and not by radio button clicks on $scope.selectedmethod

                return result;
            };

            $scope.$on('$destroy', function () {
                return _factory3.$RewardsCheckboxFactory.destroy();
            });

            $scope.showChangeFI = function () {
                return $scope.canChangeFI && !$scope.selectedmethod && !$scope.nmjExperience;
            };

            $scope.showCreditPlacement = function (fs) {
                return fs && !fs.is_pinless_debit && fs.name === 'PayPal Credit' || fs.primaryFs && fs.primaryFs.name === 'BILL_ME_LATER';
            };

            // This is set in xo-credit-components apart of an A/B test for PPC reuse radio button.
            // FOR PPC reuse customers with NI offer a special financing badge is shown for treatment 1.
            // TODO: If this is a winning experiment move over getter and setter to model.
            $scope.showSpecialFinancingBadge = function () {
                return _angular.$rootScope.specialFinancingBadge;
            };

            $scope.isGplFI = function (fs) {
                return fs.primaryFs && fs.primaryFs.type === 'CREDIT' && fs.primaryFs.name.includes('PAY_LATER_');
            };

            $scope.isDEInstallmentsFI = function (fs) {
                return $scope.isCountryDE && (fs.type === 'BILL_ME_LATER' || fs.primaryFs && fs.primaryFs.name === 'BILL_ME_LATER');
            };

            $scope.isDEInstallmentsOrGplFI = function (fs) {
                return $scope.isDEInstallmentsFI(fs) || $scope.isGplFI(fs);
            };

            $scope.ppcInstallmentContentReady = function () {
                return $scope.creditSharedInfo.hasInstallmentOffers() && $scope.creditSharedInfo.hasInstallmentOfferFinancingDetails();
            };

            $scope.showInstallmentDetailsSecondLine = function (fs) {
                if ($scope.isDEInstallmentsFI(fs)) {
                    if ($scope.installment.financing_details) {
                        return true;
                    }
                    return false;
                }
            };

            $scope.isDEInstallmentsOptionSelected = function () {
                var deInstallmentsPlanSelected = false;

                if ($scope.isCountryDE) {
                    var plans = $scope.checkoutSession.getPlanList();

                    if (plans) {
                        deInstallmentsPlanSelected = plans.filter(function (p) {
                            return p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'BILL_ME_LATER' && p.selected;
                        }).length > 0;
                    }
                }
                // If the DE installments plan is selected, restict "changeFI" & "Manage"
                if (deInstallmentsPlanSelected) {
                    $scope.canChangeFI = false;
                    $scope.selectedmethod = undefined;
                }
                return deInstallmentsPlanSelected;
            };

            $scope.showInstallmentsFiTitle = function () {
                return $scope.isCountryDE && !$scope.checkoutSession.fundingOptions.hasCredit() && $scope.ppcInstallmentContentReady();
            };

            $scope.getInstallmentsFiTitle = function () {
                if ($scope.creditSharedInfo.getInstallmentOffer() && $scope.creditSharedInfo.getInstallmentOffer().taglineText) {
                    // This tagline text will be localization already by Personalization platform
                    return $scope.creditSharedInfo.getInstallmentOffer().taglineText;
                }
                return $scope.content('memberReview.installmentsTitle');
            };

            $scope.isPadToggleFeatureApplicable = function () {
                return $scope.padToggleEnabled && $scope.padToggleFeature.applicable;
            };

            // for PAD eligible get combined plans
            $scope.getSortedPlans = function () {
                if (isMultiFiPadEligible()) {
                    return $scope.checkoutSession.fundingOptions.getPadAndIachCombinedPlans();
                } else {
                    return $scope.checkoutSession.getPlanList();
                }
            };

            $scope.showMultiFiPadToggle = function (plan) {
                var padToggle = false;

                if (isMultiFiPadEligible() && $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS(plan.planId) && plan.planId === $scope.selectedmethod.planId) {
                    padToggle = true;
                    setPadStatusForMultiFi(plan);
                }
                return padToggle;
            };

            $scope.showPadLabelForPadEligibleCountries = function (plan) {
                return $scope.checkoutSession.fundingOptions.isPAD(plan) || $scope.checkoutSession.fundingOptions.isIACHWithPad(plan) && $scope.padToggleEnabled && plan.planId !== $scope.selectedmethod.planId;
            };

            $scope.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.merchant && $scope.checkoutAppData.merchant.merchant_country === 'US';

                return $scope.payee && $scope.payee.isGambling() && isUSBuyer && isUSmerchant;
            };

            // get add card link state to display different versions based on country
            $scope.getAddCardLink = function () {
                var linkObj = ADD_CARD_URLS.SIDEBAR_DEFAULT;

                if ((0, _squid.$feature)('addBank')) {
                    linkObj = ADD_CARD_URLS.SIDEBAR_ADDCARD_WITH_ADDBANK;
                }

                var state = {
                    show: $scope.selectedmethod && !$scope.nmjExperience && !$scope.isUSGambling(),
                    route: linkObj.route,
                    label: $scope.content(linkObj.label)
                };

                return state;
            };

            var populateModels = function populateModels() {
                _index2['default'].instance($scope.token).fetch();
                return (0, _squid.$populate)($scope, {
                    checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
                    payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
                    showManageLink: _factory4.$SmartAuthFactory.disallowedManageLinkExp()
                });
            };

            var setShowAmount = function setShowAmount() {
                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            };

            var setShowBalanceComprehensionBanner = function setShowBalanceComprehensionBanner() {
                $scope.showBalanceComprehensionBanner = false;
                var experimentCalled = Experiments.balanceComprehensionBannerExperiment.experimentCalled();

                if (experimentCalled) {
                    _logger.$logger.info('balanceComprehensionBannerExperiment_EXP_CALLED');
                    return _angular.$q.when();
                }
                return Experiments.balanceComprehensionBannerExperiment.getTreatment({
                    page: 'review',
                    cart: $scope.checkoutCart,
                    checkoutAppData: $scope.checkoutAppData,
                    checkoutSession: $scope.checkoutSession,
                    payee: $scope.payee
                }).then(function (result) {
                    $scope.showBalanceComprehensionBanner = result && result.treatment_name === 'Trmt_balance_banner_ramp_hermes_bottom';
                    if ($scope.showBalanceComprehensionBanner) {
                        $scope.balanceComprehensionBannerMessage = {
                            type: 'info',
                            msgs: [_squid.$locale.content.get('billingAgreement.paypalBalanceInfoBanner')]
                        };
                    }
                })['catch'](function () {
                    _logger.$logger.info('balanceComprehensionBannerExperiment_GET_TREATMENT_ERROR', { page: 'review' });
                    return _angular.$q.when();
                });
            };

            var setNegativeBalanceData = function setNegativeBalanceData() {
                var negBals = $scope.checkoutSession && $scope.checkoutSession.negBals;

                // re-order multiple currencies when first balance has different currency
                if (negBals && negBals[0].currency_code !== $scope.checkoutCart.purchase.amounts.currency_code) {
                    negBals = negBals.reverse();
                }
                $scope.negBals = negBals;
            };

            var setShowBillingAddress = function setShowBillingAddress() {
                if (!$scope.nmjMultiPage) {
                    return;
                }
                // only show billing address if the selected instrument is a Credit Card
                var selectedInstrument = $scope.checkoutSession.plan.sources && $scope.checkoutSession.plan.sources[0];

                if (selectedInstrument && selectedInstrument.type === 'PAYMENT_CARD') {
                    $scope.showBillingAddress = true;
                }
            };

            // Eligibility for displaying the new AS1/AS2 FX transaction (new 72 hours compliance)
            // See: https://github.paypal.com/Checkout-R/hermesnodeweb/issues/3750
            var showComplianceContent = function showComplianceContent() {
                if ((0, _squid.$feature)('temporaryComplianceDisable')) {
                    return false;
                }
                var paymentAction = $scope.checkoutCart.get('payment_action', '').toLowerCase();

                return ['authorize', 'order'].indexOf(paymentAction) > -1;
            };

            // Fallback if either current either $CheckoutCartModel.purchase.amounts.total.amount_formatted_number
            // or $CheckoutCartModel.purchase.amounts.total.currency_code is undefined, we will construct
            // the `value` and `currencyCode` from $CheckoutCartModel.grossTotalAmount
            var getTotalIssuerAmount = function getTotalIssuerAmount() {
                var _ref = $scope.checkoutCart && $scope.checkoutCart.get('grossTotalAmount', {}) || {},
                    value = _ref.value,
                    currencyCode = _ref.currency;

                return {
                    value: value,
                    currencyCode: currencyCode
                };
            };

            var getTotalAmount = function getTotalAmount() {
                var amount = {};

                amount.value = $scope.checkoutCart.get('purchase.amounts.total.amount_formatted_number', '');
                amount.currencyCode = $scope.checkoutCart.get('purchase.amounts.total.currency_code', '');

                if (!amount.value || !amount.currencyCode) {
                    amount = getTotalIssuerAmount();
                }

                return amount;
            };

            // Initialize currency conversion new content for HU and 72 hours compliance
            var initComplianceContent = function initComplianceContent() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    fromPayPal = _ref2.paypal,
                    fromCurrencyCode = _ref2.from_code,
                    totalConvertedAmount = _ref2.total_converted_amount,
                    toAmount = _ref2.to_amount_forex,
                    toCurrencyCode = _ref2.to_code;

                return {
                    fromPayPal: fromPayPal,
                    conversionRateLabel: fromPayPal ? (0, _squid.$renderContent)('currencyOptions.payPalConversionRate') : (0, _squid.$renderContent)('currencyOptions.issuerConversionRate'),
                    conversionRate: fromPayPal ? (0, _squid.$renderContent)('paymentMethod.conversionRate', {
                        currencyTo: toAmount + ' ' + toCurrencyCode,
                        currencyFrom: '1 ' + fromCurrencyCode
                    }) : '',
                    amount: fromPayPal ? { value: totalConvertedAmount } : getTotalAmount(),
                    chooseLink: fromPayPal ? (0, _squid.$renderContent)('currencyOptions.chooseIssuerRate') : (0, _squid.$renderContent)('currencyOptions.choosePayPalRate')
                };
            };

            // In case we still have the pxp treatment for displaying the sidebar currency conversion UI
            // instead of interstitial one, this adds the support for that UI view.
            $scope.$on('reloadCheckoutSession', function (event, data) {
                if (data && data.checkoutSession) {
                    var _ref3 = data.checkoutSession || {},
                        plan = _ref3.plan;

                    var _ref4 = plan || {},
                        _ref4$conversion = _ref4.conversion,
                        conversion = _ref4$conversion === undefined ? {} : _ref4$conversion;

                    $scope.complianceContent = conversion && initComplianceContent(conversion);
                }
            });

            // Callback for <xo-currency-conversion-overlay /> interstitial
            // when it's done updating checkoutSession
            $scope.onComplete = function (checkoutSession) {
                if (checkoutSession) {
                    var _ref5 = checkoutSession.plan || {},
                        _ref5$conversion = _ref5.conversion,
                        conversion = _ref5$conversion === undefined ? {} : _ref5$conversion;

                    $scope.complianceContent = conversion && initComplianceContent(conversion);
                }
            };

            $scope.setSelectedFiBufsDisclosureContent = function (plan) {
                var isSelected = plan.planId === $scope.selectedmethod.planId;
                var primary = plan && plan.primaryFs;
                var backup = plan.backup;
                var conversion = plan.conversion;
                var content = (0, _squid.$renderContent)('bufs.nonCurrencyConversion', {
                    backupName: backup && backup.name,
                    backupLast4: backup && backup.last4
                });
                var eligible = isSelected && primary && backup && !conversion && content;

                if (eligible) {
                    $scope.bufsDisclosureText = content;
                    $scope.hideBackupLabel = true; // Do not show backup if there is a disclosure
                    return true;
                } else {
                    $scope.bufsDisclosureText = '';
                    return false;
                }
            };

            $scope.setBufsDisclosureContent = function () {
                var _ref6 = $scope.checkoutSession || {},
                    _ref6$plan = _ref6.plan,
                    plan = _ref6$plan === undefined ? {} : _ref6$plan;

                var primary = plan && plan.sources && plan.sources[0];
                var backup = plan.backup;
                var conversion = plan.conversion;
                var CONSTANTS = {
                    'BANK_ACCOUNT': 'bank',
                    'BALANCE': 'balance',
                    'American Express': 'amex',
                    'Discover': 'discover'
                };
                var type = primary && CONSTANTS[primary.type]; // Only show disclosure where applicable
                var fi = backup && CONSTANTS[backup.name] || 'default';
                var formatedAmount = $scope.checkoutCart.get('purchase.amounts.total', {}).amount_formatted_currency;

                if (primary && backup && !(0, _squid.$feature)('temporaryComplianceDisable')) {
                    var content = '';

                    if (conversion && type) {
                        // Card providers may have different content during currency conversion
                        content = (0, _squid.$renderContent)('bufs.' + type + '.' + fi, {
                            backupName: backup && backup.name,
                            backupLast4: backup && backup.last4,
                            cartAmount: formatedAmount,
                            conversionToCode: conversion.to_code
                        });
                    } else if (!conversion) {
                        // Content is the same for all providers without currency conversion
                        content = (0, _squid.$renderContent)('bufs.nonCurrencyConversion', {
                            backupName: backup && backup.name,
                            backupLast4: backup && backup.last4
                        });
                    }
                    if (content) {
                        $scope.bufsDisclosureText = content;
                        $scope.hideBackupLabel = true; // Do not show backup if there is a disclosure
                    }
                    return true;
                } else {
                    $scope.bufsDisclosureText = '';
                    $scope.hideBackupLabel = false;
                    return false;
                }
            };

            var setCurrencyConversion = function setCurrencyConversion() {
                var _ref7 = $scope.checkoutSession || {},
                    _ref7$plan = _ref7.plan,
                    plan = _ref7$plan === undefined ? {} : _ref7$plan;

                var _plan$conversion = plan.conversion,
                    conversion = _plan$conversion === undefined ? {} : _plan$conversion;
                // Determine whether is AS1/AS2 type of transaction
                // 72 hours compliance content only applies to AS1/AS2

                $scope.displayASContent = showComplianceContent();

                if (conversion) {
                    $scope.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                    $scope.fromUnitCurrency = '1 ' + conversion.from_code;
                }

                $scope.complianceContent = conversion && initComplianceContent(conversion);
            };

            var setMultiFiPadCheckboxState = function setMultiFiPadCheckboxState(id, state) {
                $scope.padToggleFeature.multiFiCheckboxStates[id] = state;
            };

            $scope.getPadStatus = getPadStatus;

            var logFptiForPadToggle = function logFptiForPadToggle(status) {
                _logger.$logger.info('checkout_fpti', {
                    'pad_toggle_status': 'padToggle' + status
                });
            };

            // for PAD checking the corresponding IACH bank is preferred or not
            // only MEFT and IACH subtypes can have isPreferred as true
            $scope.showPreferredLabelForMultiFi = function (plan) {
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && preferred && !$scope.checkoutSession.fundingOptions.isMEFT(plan);
            };

            $scope.showPreferredLabelForSingleFi = function (fs) {
                var plans = $scope.checkoutSession.get('fundingOptions.plans') || [];
                var filteredPlans = plans.filter(function (plan) {
                    return plan.planId === fs.id && plan.primaryFs && plan.primaryFs.id === fs.instrument_id;
                });

                if (filteredPlans.length > 0) {
                    return $scope.checkoutSession.fundingOptions.isPreferred(filteredPlans[0]) && $scope.showPreferredLabel;
                } else {
                    return false;
                }
            };

            // show / hide preferred checkbox for multi fi use case
            $scope.showPreferredCheckboxForMultiFi = function (plan) {
                if ($scope.checkoutCart.referenceCheckout) {
                    return false;
                }
                var preferred = $scope.checkoutSession.fundingOptions.isPreferred(plan);

                return $scope.makeFiPreferred && plan.planId === $scope.selectedmethod.planId && !preferred;
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            var initPadToggleFeatureParams = function initPadToggleFeatureParams() {
                $scope.padToggleFeature.applicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();
                setPadStatus($scope.padToggleFeature.applicable && $scope.checkoutSession.plan.isPAD() ? true : false);
                var sortedPlans = $scope.getSortedPlans();

                // sortedPlans (fundingOptions.plans) is undefined for BA no purchase case
                if (sortedPlans) {
                    sortedPlans.forEach(function (plan) {
                        if ($scope.checkoutSession.fundingOptions.isPAD(plan)) {
                            setMultiFiPadCheckboxState(plan.primaryFs.id, true);
                        }
                    });
                }
                $scope.padToggleFeature.defaultPlan = $scope.checkoutSession.plan.isPAD();
            };

            // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
            $scope.showMultipleFi = function () {

                if ($scope.isDEInstallmentsOptionSelected()) {
                    return false;
                }

                // if currency conversion in plan, disable multiFI
                var isCurrencyConversionInPlan = $scope.checkoutSession && $scope.checkoutSession.plan && $scope.checkoutSession.plan.conversion;

                if (isCurrencyConversionInPlan) {
                    // make the selectedMethod as undefined to avoid showing manage link and to show change link
                    // manage link won't allow buyer to change the FI
                    $scope.selectedmethod = undefined;
                    return false;
                }

                var length = $scope.selectedmethod && $scope.getSortedPlans() && $scope.getSortedPlans().length || 0;

                // If the PPC Acquisition Banner experiment is treatment 1, add banner as an "FI"
                if ($scope.installment && $scope.installment.showPPCAcquisitionRadioButton) {
                    length++;
                }

                return length > 1;
            };

            var setPadToggleEligbiility = function setPadToggleEligbiility() {
                if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    return Experiments.padToggleFeatureSupported().then(function (result) {
                        $scope.padToggleEnabled = result;
                    });
                } else {
                    $scope.padToggleEnabled = false;
                }
            };

            return populateModels().then(function () {
                var sortedPlans = $scope.getSortedPlans();

                _fiMessages.$fiMessages.isDeclinedCard($scope.checkoutSession);

                return _angular.$q.all([setShowAmount(), setNegativeBalanceData(), setShowBillingAddress(), setCurrencyConversion(), _factory.$ShowMoreFiFactory.decideEligibility({
                    plans: sortedPlans
                }), _factory2.$PreferredCheckboxFactory.decideEligibility({
                    plans: sortedPlans,
                    checkoutCart: $scope.checkoutCart
                }), setPadToggleEligbiility(), _factory3.$RewardsCheckboxFactory.buildCache(), setShowBalanceComprehensionBanner()]).then(function () {
                    if (sortedPlans) {
                        _factory.$ShowMoreFiFactory.init(sortedPlans);
                    }

                    var plans = $scope.checkoutSession.get('fundingOptions.plans') || [];
                    var merchant = $scope.checkoutAppData.merchant;
                    var instrumentsDisallowed = $scope.checkoutSession.get('fundingOptions.disallowedInstruments');
                    var lengthOfDisallowed = instrumentsDisallowed && instrumentsDisallowed.length;

                    $scope.isOptionalVaulting = $scope.checkoutCart.billing && $scope.checkoutCart.billing.save_paypal_as_option && _squid.$config.baOptOutEnabledCountries.indexOf(_squid.$locale.country) > -1;
                    var disallowedInPlan = lengthOfDisallowed && instrumentsDisallowed.filter(function (disallowed) {
                        var isBalanceDisallowed = disallowed.type === 'BALANCE' || disallowed.type === 'REWARDS';
                        var isFIinPrimary = plans.find(function (plan) {
                            return plan.primaryFs.id === disallowed.id;
                        });
                        //  for cases where pinlessDebit is disallowed but other form of card transactions are allowed on the card

                        return isBalanceDisallowed || isFIinPrimary;
                    }).length === lengthOfDisallowed;

                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                    if ($scope.showManageLink && $scope.showManageLink === 'Trmt_xo_hermes_display_disallowed_fi_1') {
                        if (lengthOfDisallowed) {
                            $scope.hideManageLink = disallowedInPlan;
                        } else {
                            $scope.hideManageLink = true;
                        }
                    }

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_review',
                        mng_wallet_lnk: !$scope.hideManageLink
                    });

                    // add FPTI tracking for CVV field
                    var cvvData = $scope.checkoutSession.cvvData;

                    if (cvvData && !cvvData.lastAddedCard) {
                        _logger.$logger.info('checkout_fpti', {
                            'iscvvshown': 'true'
                        });
                    }

                    var isBilling = $scope.checkoutCart.isBilling();
                    var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
                    var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
                    var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
                    var isWpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                    var isWpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
                    var isWpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();

                    // Hide 'change' link for sticky disabled merchants
                    $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);

                    // Hide 'Pay With' header for NMJ multiple step experience
                    $scope.showPayWithText = !$scope.nmjMultiPage && !$scope.showPayMerchantWithPayPal;
                    $scope.showPreferredLabel = $scope.selectFiVariant && $scope.makeFiPreferred && $scope.checkoutSession.getPlanList() && $scope.checkoutSession.getPlanList().length > 1;

                    var checkoutPlan = $scope.checkoutSession.plan;

                    $scope.canChangeFI = true;
                    if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB() || $scope.nmjMultiPage) {
                        $scope.canChangeFI = false;
                    } else if (checkoutPlan.isBalance() && !(0, _squid.$feature)('choiceExperiment')) {
                        // Show the change link always for US, where planning is finished ramping choice.
                        // For other countries, keep old checks until we're sure planning has ramped choice changes there.
                        $scope.canChangeFI = $scope.checkoutSession.plan.hasConversion() || $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred()) || Boolean($scope.checkoutSession.fundingOptions.getPreferred());
                    }

                    $scope.hasMultipleBalances = plans && plans.filter(function (p) {
                        return p.primaryFs.type === 'BALANCE';
                    }).length > 1;

                    $scope.gotoWallet = function () {
                        // For choice variant, go to manage wallet instead. Always available
                        if ($scope.selectedmethod) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }

                        if ($scope.canChangeFI) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet', { padToggleFeature: $scope.padToggleFeature });
                        }
                    };

                    $scope.bmlSeeTerms = function () {
                        $scope.showBmlPopup();
                    };

                    var currentPlanId = $scope.checkoutSession.plan.id;

                    $scope.isSplitPaymentWithBalanceAndIachPlan = false;

                    if ($scope.padToggleEnabled) {
                        initPadToggleFeatureParams();
                    }

                    // page section changes to show pad toggle tooltip properly
                    if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                        var checkoutPageSection = angular.element(document.getElementById('sliding-area'));

                        checkoutPageSection.css('overflow', 'visible');
                    }

                    $scope.showPadToggle = function () {
                        var padToggle = false;

                        if ($scope.padToggleEnabled && $scope.padToggleFeature.applicable) {
                            var padToggleForFS = $scope.checkoutSession.fundingOptions.isPadToggleApplicableForFS($scope.checkoutSession.plan.id);
                            var isPadPlan = $scope.checkoutSession.plan.isPAD();

                            $scope.isIachPlan = $scope.checkoutSession.plan.isIACH();
                            if ($scope.isIachPlan && !$scope.isSplitPaymentWithBalanceAndIachPlan) {
                                $scope.isSplitPaymentWithBalanceAndIachPlan = $scope.checkoutSession.plan.isSplitPaymentWithBalanceAndIach();
                            }

                            $scope.padToggleFeature.showCheckbox = padToggleForFS && (isPadPlan || $scope.isIachPlan);

                            if (!padToggleForFS) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && !isPadPlan) {
                                setPadStatus(false);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            } else if (currentPlanId !== $scope.checkoutSession.plan.id && isPadPlan) {
                                setPadStatus(true);
                                currentPlanId = $scope.checkoutSession.plan.id;
                            }

                            if ($scope.padToggleFeature.showCheckbox) {
                                padToggle = true;

                                // padToggle is false when split balance and `choice` balance checkbox is selected by user
                                var checkboxBalanceChecked = $scope.choiceBalanceCheckboxState && $scope.choiceBalanceCheckboxState.checkbox;

                                if ($scope.isSplitPaymentWithBalanceAndIachPlan && checkboxBalanceChecked) {
                                    padToggle = false;
                                }
                            }
                        }
                        return padToggle;
                    };

                    $scope.getPadFsContent = function (fs) {
                        return $scope.isPadToggleFeatureApplicable() ? $scope.content('paymentMethod.padToggleFs', { bank: fs.name, last4: fs.last4 }) : $scope.content('paymentMethod.padFs', { bank: fs.name, date: fs.hop_date, last4: fs.last4 });
                    };

                    $scope.updatePlan = function (planId) {
                        currentPlanId = planId;

                        $scope.checkoutSession.fundingOptions.action('select', {
                            data: {
                                planId: planId
                            },
                            success: function success(result) {
                                $scope.checkoutSession.populate(result);
                                if (result) {
                                    // Update the installments to support the user selecting a card that does not support installments.
                                    $scope.checkoutSession.installments = result.installments;
                                }
                            }
                        });
                    };

                    function getBankInstrumentId() {
                        var instrumentId = void 0;

                        if ($scope.isSplitPaymentWithBalanceAndIachPlan) {
                            var iachSource = $scope.checkoutSession.plan.sources.find(function (source) {
                                return source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER';
                            });

                            instrumentId = iachSource && iachSource.instrument_id;
                        } else if ($scope.isIachPlan) {
                            instrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;
                        }
                        return instrumentId;
                    }

                    $scope.multiFiPadToggleCheckboxEvent = function (plan) {
                        setPadStatusForMultiFi(plan);

                        // if pad checkbox is checked for the selected plan
                        if (getMultiFiPadCheckboxState(plan.primaryFs.id)) {
                            logFptiForPadToggle('On');
                        } else {
                            logFptiForPadToggle('Off');
                        }
                    };

                    $scope.padToggleCheckboxEvent = function () {
                        var planId = void 0;

                        // For choice multi FI experience, we want to keep this in sync since this is read on clicking 'Continue' in RYI page
                        // Skip the rest of it though. Doesn't apply for the multiFi variant
                        if ($scope.selectedmethod) {
                            var plan = $scope.checkoutSession.fundingOptions.plans[0];

                            $scope.padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id] = getPadStatus();
                            return $scope.multiFiPadToggleCheckboxEvent(plan);
                        }

                        // if getPadStatus() === true, that means we're currently selecting a PAD plan
                        if (getPadStatus()) {
                            var bankInstrumentId = getBankInstrumentId();

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(bankInstrumentId, 'IACH');
                            logFptiForPadToggle('On');
                        } else {
                            // otherwise we have to find the corresponding IACH plan
                            var padInstrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;

                            planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(padInstrumentId, 'PAD');

                            // when a user intentionally un-check the PayPal balance from choice view
                            var isChoiceBalanceUnchecked = $scope.choiceBalanceCheckboxState.checkbox !== undefined && $scope.choiceBalanceCheckboxState.checkbox === false;

                            if (isChoiceBalanceUnchecked) {
                                // find a IACH plan without a balance
                                var iachPlanWithoutBalance = $scope.checkoutSession.fundingOptions.plans.find(function (p) {
                                    return (p.primaryFs && p.primaryFs.id) === padInstrumentId && $scope.checkoutSession.fundingOptions.isIACH(p) && !p.secondaryFIs;
                                });

                                if (iachPlanWithoutBalance) {
                                    planId = iachPlanWithoutBalance.planId;
                                }
                            }
                            logFptiForPadToggle('Off');
                        }

                        return $scope.updatePlan(planId);
                    };

                    var processAllLoadedPadToggle = function processAllLoadedPadToggle() {
                        if ($scope.padToggleEnabled && $scope.showPadToggle()) {
                            // To remove focus from checkbox so that focus style is not applied
                            if (getPadStatus()) {
                                var section = document.querySelector('#padToggleHelp');

                                if (section) {
                                    section.focus();
                                    section.blur();
                                }
                            }
                            // fpti logging
                            if (!$scope.padToggleFeature.fptiLogged) {
                                if (getPadStatus()) {
                                    _logger.$logger.info('pad_toggle_on_feature_shown');
                                    logFptiForPadToggle('OnShown');
                                } else {
                                    _logger.$logger.info('pad_toggle_off_feature_shown');
                                    logFptiForPadToggle('OffShown');
                                }

                                $scope.padToggleFeature.fptiLogged = true;
                            }
                        }
                    };

                    var handleAllLoadedForPadToggle = _angular.$rootScope.$on('allLoaded', processAllLoadedPadToggle);

                    $scope.$on('$destroy', handleAllLoadedForPadToggle);

                    var stickyEligible = isBilling && !disableStickyForMerchant;

                    // save sticky decision - to be used in the app and other components
                    _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;
                    $scope.getPlanList = function (n) {
                        // with purchase - always use plan
                        var sources = $scope.checkoutSession.plan.sources || [];
                        var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : sources.filter(function (instrument) {
                            return instrument.type !== 'REWARDS';
                        });

                        $scope.showUachFeatureDiscalimer = false;

                        // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
                        angular.forEach(planList, function (plan) {
                            // display uach - direct debit agreement for AU as of July 1st, 2015
                            if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
                                $scope.showUachFeatureDiscalimer = true;
                            }
                        });

                        if (!n) {
                            return planList;
                        } else {
                            return planList.slice(0, n);
                        }
                    };

                    $scope.showBackupPlan = function (plan) {
                        return plan.backup && !(stickyEligible && isBillingNoPurchase) && !$scope.hideBackupLabel;
                    };

                    var isRP = void 0;
                    var isSubscriptionsV1 = void 0;

                    if (isBilling) {
                        isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
                        isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();
                    }

                    $scope.showRpBaText = isRP || isWpsSubscription;
                    $scope.showInstallmentPlanBaText = $scope.checkoutCart.isBilling() && isWpsInstallmentPlan;
                    $scope.showSubscriptionsV1BaText = isSubscriptionsV1 || isWpsAutobilling;

                    // Show expanded Variant of Text
                    $scope.showExpandedText = function () {
                        $scope.isExpandedAgreementText = true;
                    };

                    // CIB BA text in case of BalanceComprehensionBanner has no expanded or collapsed variant
                    if (_squid.$locale.country === 'US' || _squid.$locale.country === 'IN' || Experiments.balanceComprehensionBannerExperiment.bannerDisplayed()) {
                        $scope.isExpandedAgreementText = true;
                    }

                    $scope.showMibBAText = function () {
                        return $scope.checkoutCart.isBilling() && !$scope.isCIB && !$scope.showRpBaText && !isWpsInstallmentPlan && !isWpsAutobilling && !isSubscriptionsV1 && !$scope.isOptionalVaulting;
                    };

                    $scope.getBAContent = function () {
                        var consentCode = $scope.checkoutCart.billing.consent_code;
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
                        var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();
                        var stickyOrNoStickyText = stickyEligible && stickyFI ? 'FiSticky' : 'NoFiSticky';
                        var expandedOrCollapsedText = $scope.isExpandedAgreementText === true ? 'Expanded' : 'Collapsed';
                        var isIndiaDomestic = _squid.$locale.country === 'IN' && _squid.$locale.country === $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                        var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
                        var contentKey = void 0;

                        if (consentCode) {
                            contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
                        } else {
                            contentKey = 'billingAgreement.';

                            $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING';

                            if ($scope.isCIB) {
                                if (Experiments.balanceComprehensionBannerExperiment.bannerDisplayed() && !isIndiaDomestic) {
                                    contentKey = 'enterpriseAgreement.prepaidCIB' + stickyOrNoStickyText + 'Consent';
                                } else {
                                    contentKey += 'memberAgreementCib' + stickyOrNoStickyText + useraction + expandedOrCollapsedText;
                                }
                            } else if (Experiments.balanceComprehensionBannerExperiment.bannerDisplayed() && !isIndiaDomestic) {
                                contentKey = 'billingAgreement.memberAgreementMibWithBalanceUsageInfo';
                            } else {
                                contentKey += 'memberAgreement' + stickyOrNoStickyText + indiaDomestic + useraction;
                            }
                            // content change for review page start
                            if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                                if ($scope.isCIB) {
                                    contentKey = 'billingAgreement.rtCib';
                                } else if ($scope.checkoutAppData.isMerchantCountry('IN')) {
                                    if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                                        contentKey = 'billingAgreement.rp';
                                    } else {
                                        contentKey = 'billingAgreement.rt';
                                    }
                                } else {
                                    contentKey = 'billingAgreement.rp';
                                }
                            }
                            // content change for review page end
                        }
                        var showBAContent = $scope.checkoutCart.billing && !$scope.showRpBaText && !$scope.showSubscriptionsV1BaText;

                        if (showBAContent && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('BA consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getRPContent = function () {
                        var contentKey = 'billingAgreement.';
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                        if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
                            contentKey += 'rpAgreementFiSticky' + useraction;
                        } else {
                            contentKey += 'rpAgreementNoFiSticky' + useraction;
                        }

                        if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                            if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                                contentKey = 'billingAgreement.rp';
                            }
                        }

                        var showRPContent = $scope.checkoutCart.billing && $scope.showRpBaText;

                        if (showRPContent && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('RP consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getSubscriptionsV1BaText = function () {
                        var contentKey = 'billingAgreement.';
                        var hasStickyFI = stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument();
                        var stickyOrNoStickyText = hasStickyFI ? 'FiSticky' : 'NoFiSticky';
                        var isIndiaDomestic = _squid.$locale.country === 'IN' && _squid.$locale.country === $scope.checkoutAppData.get('merchant.merchant_country', 'US');
                        var indiaDomestic = isIndiaDomestic ? 'Domestic' : '';
                        var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';

                        contentKey += 'memberAgreement' + stickyOrNoStickyText + indiaDomestic + useraction;

                        if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                            if ($scope.checkoutCart.isSubscriptionsV1()) {
                                contentKey = 'billingAgreement.rp';
                            }
                        }
                        var showSubscriptionsV1Content = $scope.checkoutCart.billing && $scope.showSubscriptionsV1BaText;

                        if (showSubscriptionsV1Content && !_squid.$locale.content.get(contentKey)) {
                            _logger.$logger.error('subscriptions V1 consent not displayed', { contentKey: contentKey });
                            _uiRouter.$state.go('checkout.genericError');
                        }
                        return contentKey;
                    };

                    $scope.getStickyFiName = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                        return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.name;
                    };

                    $scope.getStickyFiLast4 = function () {
                        var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();

                        return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
                    };

                    // Choice Experiment
                    // Preferred checkbox for single FI variants should only be shown if:
                    $scope.showSinglePreferred = function () {
                        return _factory2.$PreferredCheckboxFactory.isSinglePreferredCheckboxEligible({ plans: $scope.getSortedPlans() });
                    };

                    $scope.showPreferredCheckbox = function (plan) {
                        if ($scope.checkoutCart.referenceCheckout) {
                            return false;
                        }
                        return _factory2.$PreferredCheckboxFactory.showPreferredCheckbox(plan, $scope.checkoutSession.fundingOptions);
                    };

                    // Update selectedmethod to call update on checkout session later
                    $scope.updateFS = function (fundingsource, index) {
                        $scope.selectedmethod.planId = fundingsource.planId;
                        $scope.selectedmethod.index = index;

                        if ($scope.makeFiPreferred) {
                            $scope.makeFiPreferred.selected = false;
                        }

                        $scope.checkoutSession.cardBackup.resetIfDoesNotApply(fundingsource);
                        setPadStatusForMultiFi(fundingsource);

                        // update the fundingoptions with the selected FI so user checks out with the
                        // right FI on RYI page.
                        var prevSelectedPlan = $scope.checkoutSession.fundingOptions.instruments.find(function (fi) {
                            return fi.selected === true;
                        });

                        // the DE member flow uses a dummy FI inside the RYI page not listed
                        // inside $scope.checkoutSession.fundingOptions.instruments;
                        // prevSelectedPlan will be undefined in that case
                        $scope.checkoutSession.fundingOptions.instruments.forEach(function (fi) {
                            if (fi.planId === fundingsource.planId) {
                                fi.selected = true;
                            } else if (prevSelectedPlan && fi.planId === prevSelectedPlan.planId) {
                                fi.selected = false;
                            }
                        });
                    };

                    $scope.isBillingNoCards = function () {
                        if ($scope.checkoutCart.isBillingNoPurchase()) {
                            var emptyPlan = $scope.checkoutSession.futurePaymentInstruments && $scope.checkoutSession.futurePaymentInstruments.length === 0;

                            if ($scope.checkoutAppData.flags.allow_billing_agreement_without_bufs && emptyPlan) {
                                $scope.canChangeFI = false;
                                $scope.showEmptyPlanHeader = true;
                                _logger.$logger.info('BA_nocards_toggle_on_and_empty_plan');
                                return true;
                            }
                        }
                        return false;
                    };

                    $scope.showPPCAcquisitionRadioButton = function () {
                        return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
                    };

                    $scope.selectApplyForPPC = function () {
                        return $scope.updateFS({
                            planId: 'applyForPPCRadio'
                        });
                    };

                    $scope.showConversionOptions = function () {
                        if (_factory5.$CurrencyConversionFactory.getConversionOverlayFlag()) {
                            _angular.$rootScope.$broadcast('$showConversionOverlay');
                        } else {
                            return _uiRouter.$state.go('checkout.review.sidebar.currencyConversion');
                        }
                    };
                });
            });
        }]
    };
});

_logger.$logger;

_pxp.$pxpCartAmt;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutPayeeModel;

_fiMessages.$fiMessages;

_squid.formatCurrency;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$locale;

_squid.$renderContent;

_uiRouter.$state;

_angular.$registerDirective;

_angular.$rootScope;

_angular.$q;

_factory.$ShowMoreFiFactory;

_factory2.$PreferredCheckboxFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$SmartAuthFactory;

_factory5.$CurrencyConversionFactory;

_index3.$CreditSharedInfoModel;

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SmartAuthFactory', function () {

    var isAuthRequired = function isAuthRequired(fs) {
        return fs.constraint;
    };

    var getConstraintAmount = function getConstraintAmount(fs) {
        var constraint = fs.constraint;

        return (0, _squid.formatCurrency)(constraint.amount.value, constraint.amount.currency, false);
    };

    var disallowedManageLinkExp = function disallowedManageLinkExp() {
        return (0, _squid.$elmo)('xo_hermes_display_disallowed_fi', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermes_display_disallowed_fi_1').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        isAuthRequired: isAuthRequired,
        getConstraintAmount: getConstraintAmount,
        disallowedManageLinkExp: disallowedManageLinkExp
    };
});

_squid.formatCurrency;

_squid.$elmo;

_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/review-paywith", "../node_modules/xo-member-components/src/review-paywith/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-paywith/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView\" content>\n    <div class=\"trayInner trayInnerDefault\" ng-class=\"{installments:(checkoutSession.installments.length > 1)}\">\n        <div id=\"paymentMethod\">\n            <div ng-click=\"gotoWallet()\" ng-if=\"!showMultipleFi() && !isBillingNoCards()\" focusable=\"canChangeFI || selectedmethod\" ng-class=\"{editable:canChangeFI || selectedmethod}\" class=\"focusable singleFi\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"isPadToggleFeatureApplicable()\">\n                        {{ content('paymentMethod.payWith') }}\n                    </span>\n                    <span ng-if=\"!isPadToggleFeatureApplicable()\">\n                        <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                            <span ng-if=\"showPayMerchantWithPayPal\">\n                                {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                            </span>\n                            <span ng-if=\"showPayWithText\">\n                                {{ content('paymentMethod.payWith') }}\n                            </span>\n                        </span>\n                    </span>\n                </h2>\n                <experience flag='!cardart' class='noCardArt'>\n                    <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" data-test-id=\"listedFIElement\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                                <!-- xo-fi-icon fi=\"fs\" class-name=\"fsIcons\"></xo-fi-icon -->\n                                <span class=\"fsIcons\" ng-class=\"{'BILL_ME_LATER_DE': isDEInstallmentsFI(fs)}\" ng-if=\"!fs.is_pinless_debit\"></span>\n                                <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                                <span class=\"name\">\n                                    <span ng-if=\"fs.type === 'PPCREDIT'\">\n                                        {{ content('paymentMethod.billmelater') }}\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && !isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padFs', {bank: fs.name, date: fs.hop_date, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padToggleFs', {bank: fs.name, last4: fs.last4})\">\n                                    </span>\n                                    <span ng-if=\"fs.type === 'INCENTIVE'\">\n                                        {{ content('paymentMethod.msbOffer') }}\n                                    </span>\n                                    <span class=\"forceRTL\" data-test-id=\"balanceFI\" ng-if=\"fs.type === 'BALANCE'\">\n                                        {{ content('paymentMethod.paypalBalance') }}\n                                    </span>\n                                    <span ng-if=\"fs.type === 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        {{ content('fsMappings.PAYPAL_EXTRAS_MASTERCARD') }}\n                                    </span>\n                                    <span ng-if=\"fs.type !== 'PPCREDIT' && fs.type !== 'INCENTIVE' && fs.type !== 'BALANCE' && fs.sub_type !== 'DELAYED_TRANSFER' && fs.type !== 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                        <span class=\"fsNamePinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{ content('paymentMethod.pinlessDebit') }}\n                                        </span>\n                                        <span ng-if=\"isDEInstallmentsFI(fs)\">\n                                            {{ content('fsMappings.PAYPAL_INSTALLMENTS') }}\n                                        </span>\n                                        <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit && !isDEInstallmentsFI(fs)\">\n                                            {{fs.name}}\n                                        </span>\n                                        <div ng-if=\"showInstallmentDetailsSecondLine(fs)\" class=\"fsInstallmentDetails\">\n                                            {{ content('paymentMethod.installmentDetails',\n                                                    {\n                                                        amount: formatCurrency(installment.financing_details.total_cost, installment.financing_details.currency),\n                                                        term: installment.financing_details.term\n                                                    })\n                                            }}\n                                        </div>\n                                        <span ng-if=\"fs.type === 'ECHECK'\">{{ content('paymentMethod.eCheck') }}</span>\n                                        <span class=\"fsLastDigitsPinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                            {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                        </span>\n                                        <span ng-if=\"countryCode === 'DE'\">\n                                            <span ng-if=\"fs.sub_type === 'MEFT'\">\n                                                {{ content('paymentMethod.meft') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'IACH'\">\n                                                {{ content('paymentMethod.iach') }}\n                                            </span>\n                                            <span ng-if=\"fs.sub_type === 'INSTANT_TRANSFER' && fs.type === 'BANK'\">\n                                                {{ content('paymentMethod.instantTransfer') }}\n                                            </span>\n                                        </span>\n                                    </span>\n                                    <span ng-if=\"showPreferredLabelForSingleFi(fs)\" class=\"preferredLabel\">\n                                        <br>\n                                        {{ content('memberReview.preferred') }}\n                                    </span>\n                                    <div ng-if=\"fs.isBillingPreferred\" class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchant}) }}</div>\n                                    <span ng-if=\"fs.gotDeclined\" class=\"gotDeclinedMessage\">\n                                        {{ content('wallet.processorDeclinedCard') }}\n                                    </span>\n                                </span>\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext='true'/>\n                                </span>\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"mouseleave\" ng-click=\"$event.stopPropagation()\">\n                                    <div class=\"tip tipDesc\">\n                                        <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                        <div class=\"msbToolTipDescription\">\n                                            <p ng-if=\"fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount})\n                                                }}\n                                            </p>\n                                            <p ng-if=\"!fs.minPurchaseAmount\">\n                                                {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                            </p>\n                                            <p>\n                                            </p>\n                                        </div>\n                                    </div>\n                                </xo-tooltip>\n\n                                <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                            trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                    <div class=\"tipText tipHintText\">\n                                        <p class=\"padHeader\">\n                                            {{content('paymentMethod.padHelpTxt')}}\n                                        </p>\n                                        <ul class=\"bul\">\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                            </li>\n                                            <li>\n                                                <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                            </li>\n                                        </ul>\n                                        <p>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                        </p>\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                            <span ng-if=\"showAmt && !(checkoutSession.installments.length > 1) && !isDEInstallmentsFI(fs)\" class=\"methodAmount\">\n                                <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                            </span>\n                            <span ng-if=\"isDEInstallmentsFI(fs) && showInstallmentDetailsSecondLine(fs)\">\n                                <span class=\"monthlyAmountFormatted\"><format-currency code=\"installment.financing_details.currency\" amount=\"installment.financing_details.monthly_payment\"></format-currency></span>\n                                <span class=\"installmentsIntervalText\">{{content('paymentMethod.monthlyInterval')}}*</span>\n                            </span>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <li class=\"singleFiBackupComponent\" ng-if=\"showBackupPlan(checkoutSession.plan)\">\n                            <xo-backup-label plan=\"checkoutSession.plan\"></xo-backup-label>\n                        </li>\n                        <li ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"false\">\n                            </xo-preferred-checkbox>\n                        </li>\n                        <li stop-propagation\n                            ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\">\n                            <!-- Choice use case -->\n                            <xo-rewards-checkbox\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                selectedmethod= \"selectedmethod\"\n                                cardart=\"false\">\n                            </xo-rewards-checkbox>\n                        </li>\n                        <li ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\" ng-class=\"{getInstallmentsError: installmentNotSelected && !checkoutSession.selectedInstallmentData}\">\n                                <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                <span class=\"raq\"></span>\n                            </a>\n                        </li>\n                        <li ng-repeat=\"fs in checkoutSession.plan.sources track by $index\" class=\"clearfix\" ng-if=\"fs.sub_type === 'ECHECK' || (countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER')\">\n                            <span class=\"disclaimer\" ng-if=\"fs.sub_type === 'ECHECK'\">\n                                {{ content('paymentMethod.eCheckDescription') }}\n                            </span>\n                            <span class=\"disclaimer\" ng-if=\"countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER'\">\n                                <a id=\"pad_details\">{{ content('paymentMethod.payAfterDeliveryDetails') }}</a>\n                                <xo-tooltip trigger=\"#pad_details\" on-events=\"click\">\n                                    <div class=\"tip tipDesc\">\n                                        {{ content('paymentMethod.padHelpTxt', {date: fs.HOPDate}) }}\n                                        {{ content('paymentMethod.padHelpTxtList') }}\n                                    </div>\n                                </xo-tooltip>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>&rlm;:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && !isCountryHU\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n\n                              <!-- New compliance content for country Hungary (HU)  -->\n                            <div ng-if=\"checkoutSession.plan.conversion && isCountryHU\" class=\"compliance-container\">\n                                <div class=\"align-left\">\n                                    <p class=\"conversionRateLabel\" ng-class=\"{bold: complianceContent.fromPayPal}\" ng-if=\"complianceContent.conversionRateLabel\" ng-bind-html=\"complianceContent.conversionRateLabel\"></p>\n                                    <p class=\"conversionRate\" ng-if=\"complianceContent.conversionRate\">{{ complianceContent.conversionRate }}</p>\n                                    <a class=\"chooseLink\"\n                                        ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                        focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                        ng-bind=\"complianceContent.chooseLink\">\n                                    </a>\n                                </div>\n                                <div class=\"align-right\">\n                                    <strong ng-if=\"complianceContent.amount.value\">{{ complianceContent.amount.value }}</strong>\n                                    <span ng-if=\"complianceContent.amount.currencyCode\">{{ complianceContent.amount.currencyCode }}</span>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal && !isCountryHU\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable && !isCountryHU\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n\n                            <!-- 72 hours FX compliance content for AS1/AS2  -->\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && displayASContent\">\n                                <p class=\"foreignExchangeRate\">\n                                    {{content('currencyOptions.foreignExchangeRate')}}\n                                </p>\n                                <a class=\"why\" ng-click=\"isCollapsed = !isCollapsed\" role=\"button\">\n                                    {{content('currencyOptions.why72hours')}}\n                                    <span class=\"icon\" ng-class=\"{down: !isCollapsed, up: isCollapsed}\"></span>\n                                </a>\n                                <p class=\"reason\" ng-show=\"isCollapsed\">\n                                    {{content('currencyOptions.reason72hours')}}\n                                </p>\n                            </div>\n                            <div ng-if=\"setBufsDisclosureContent()\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                        </li>\n                    </ul>\n                </experience>\n\n                <experience flag='cardart' class='cardArt'>\n                    <div class=\"charges\">\n                        <li ng-repeat=\"fs in getPlanList() track by $index\" class=\"clearfix fs\" ng-if=\"fs.amount.doubleValue !== 0\">\n                            <xo-fi-panel fi=\"fs\"\n                                show-amount=\"showAmt && !(checkoutSession.installments.length > 1) && !balanceWithRewards(fs)\"\n                                name-override=\"fs.sub_type === 'DELAYED_TRANSFER' && getPadFsContent(fs)\"\n                                >\n                                <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(checkoutSession.plan)\">\n                                    <div ng-if=\"!isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).secondLineText\"></span>\n                                    </div>\n                                    <div ng-if=\"isSelected(checkoutSession.plan)\">\n                                        <span ng-bind-html=\"getRewardsContent(checkoutSession.plan).rewardsAvailble\"></span>\n                                    </div>\n                                </div>\n                                <span ng-if=\"showCreditPlacement(fs)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                </span>\n\n                                <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n                                    <a class=\"msbDetails\" id=\"msb_{{$index}}\" link-button>{{ content('paymentMethod.msbDetails')}}</a>\n                                </p>\n\n                                <xo-backup-label\n                                    ng-if=\"fs.type === 'BANK_ACCOUNT' && showBackupPlan(checkoutSession.plan)\"\n                                    plan=\"checkoutSession.plan\"\n                                    has-mask=\"true\"\n                                >\n                                </xo-backup-label>\n\n                                <div ng-if=\"fs.is_preferred && makeFiPreferred\">\n                                    <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                </div>\n                                <div ng-if=\"fs.gotDeclined\" class=\"gotDeclinedMessage\">\n                                    <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                </div>\n                            </xo-fi-panel>\n                            <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n                                <div class=\"tip tipDesc\">\n                                    <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                    <div class=\"msbToolTipDescription\">\n                                        <p ng-if=\"fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount}) }}\n                                        </p>\n                                        <p ng-if=\"!fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                        </p>\n                                        <p>\n                                        </p>\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n                            <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                        trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                <div class=\"tipText tipHintText\">\n                                    <p class=\"padHeader\">\n                                        {{content('paymentMethod.padHelpTxt')}}\n                                    </p>\n                                    <ul class=\"bul\">\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                        </li>\n                                    </ul>\n                                    <p>\n                                        <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                    </p>\n                                </div>\n                            </xo-tooltip>\n                            <div ng-if=\"smartAuthFactory.isAuthRequired(fs)\" class=\"smartauthbanner\">\n                                <div class=\"smartauthinfobanner\"><span class=\"smartauthinfologo\" ></span></div>\n                                <div class=\"smartauthtext\" ng-bind-html=\"htmlContent('billingAgreement.smartDollarAuthText', {amountInPayerCurrency: smartAuthFactory.getConstraintAmount(fs)})\"></div>\n                            </div>\n                        </li>\n                        <div ng-if=\"showSinglePreferred() && showPreferredCheckbox(checkoutSession.fundingOptions.plans[0])\" stop-propagation tabindex=\"-1\">\n                            <xo-preferred-checkbox\n                                make-fi-preferred=\"makeFiPreferred\"\n                                plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                cardart=\"true\">\n                            </xo-preferred-checkbox>\n                        </div>\n                        <xo-rewards-checkbox stop-propagation\n                                             ng-if=\"hasRewards(checkoutSession.fundingOptions.plans[0])\"\n                                             plan=\"checkoutSession.fundingOptions.plans[0]\"\n                                             selectedmethod= \"selectedmethod\"\n                                             cardart=\"true\">\n                        </xo-rewards-checkbox>\n                        <div ng-if=\"(checkoutSession.installments.length > 1)\" ng-click=\"$event.stopPropagation()\">\n                            <div ng-if=\"!installmentNotSelected || checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\">\n                                    <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                    <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"installmentNotSelected && !checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallmentsError btn btn-secondary\">\n                                    {{content('paymentMethod.changeInstallmentLink') }}\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                            <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals track by $index\" class=\"nbr-line fsicon-margin\">\n                            {{ content('memberReview.nbrPaypalCut') }}:\n                            <span class=\"nbr-amt ltrOverride\">\n                                <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                            </span>\n                        </li>\n                        <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div class=\"reviewEnterCvv\">\n                                <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                                <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                            </div>\n                        </li>\n\n                        <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && !isCountryHU\">\n                                <span class=\"conversionRateLabel\">{{content('currencyOptions.paypalRate')}}</span>\n                                <span class=\"conversionRate\">{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                            </div>\n\n                             <!-- New compliance content for country Hungary (HU)  -->\n                            <div ng-if=\"checkoutSession.plan.conversion && isCountryHU\" class=\"compliance-container\">\n                                <div class=\"align-left\">\n                                    <p class=\"conversionRateLabel\" ng-class=\"{bold: complianceContent.fromPayPal}\" ng-if=\"complianceContent.conversionRateLabel\" ng-bind-html=\"complianceContent.conversionRateLabel\"></p>\n                                    <p class=\"conversionRate\" ng-if=\"complianceContent.conversionRate\">{{ complianceContent.conversionRate }}</p>\n                                    <a class=\"chooseLink\"\n                                        ng-if=\"checkoutSession.plan.conversion.changeable\" ng-click=\"showConversionOptions()\"\n                                        focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                        ng-bind=\"complianceContent.chooseLink\">\n                                    </a>\n                                </div>\n                                <div class=\"align-right\">\n                                    <strong ng-if=\"complianceContent.amount.value\">{{ complianceContent.amount.value }}</strong>\n                                    <span ng-if=\"complianceContent.amount.currencyCode\">{{ complianceContent.amount.currencyCode }}</span>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"!checkoutSession.plan.conversion.paypal && !isCountryHU\" class=\"conversionIssuerDisclaimer\">\n                                {{content('currencyOptions.issuerFeesDisclaimer')}}\n                            </div>\n\n                            <a id=\"conversionLink\" ng-if=\"checkoutSession.plan.conversion.changeable && !isCountryHU\" ng-click=\"showConversionOptions()\"\n                                focus-when-state=\"checkout.review.sidebar.currencyConversion\" transitions-to=\"checkout.review\"\n                                ng-bind=\"content('currencyOptions.viewConversion')\">\n                            </a>\n\n                            <!-- 72 hours FX compliance content for AS1/AS2  -->\n                            <div ng-if=\"checkoutSession.plan.conversion.paypal && displayASContent\">\n                                <p class=\"foreignExchangeRate\">\n                                    {{content('currencyOptions.foreignExchangeRate')}}\n                                </p>\n                                <a class=\"why\" ng-click=\"isCollapsed = !isCollapsed\" role=\"button\">\n                                    {{content('currencyOptions.why72hours')}}\n                                    <span class=\"icon\" ng-class=\"{down: !isCollapsed, up: isCollapsed}\"></span>\n                                </a>\n                                <p class=\"reason\" ng-show=\"isCollapsed\">\n                                    {{content('currencyOptions.reason72hours')}}\n                                </p>\n                            </div>\n                            <div ng-if=\"setBufsDisclosureContent()\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                        </li>\n                    </div>\n                </experience>\n            </div>\n\n            <div ng-if=\"showMultipleFi()\" ng-class=\"{editable:canChangeFI}\" class=\"multipleFi focusable\">\n                <h2 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"checkoutSession.plan.isPAD() && !padToggleEnabled\">\n                        {{ content('paymentMethod.payAfter') }}\n                    </span>\n                    <span ng-if=\"!checkoutSession.plan.isPAD() || padToggleEnabled\">\n                        <span ng-if=\"showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                        </span>\n                        <span ng-if=\"showPayWithText\">\n                            {{ content('paymentMethod.payWith') }}\n                        </span>\n                    </span>\n                </h2>\n\n                <div ng-if=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\" class=\"msbOffer\">\n                    <xo-msb-offer msb=\"checkoutSession.fundingOptions.getMsbByPlanId(selectedmethod.planId)\"></xo-msb-offer>\n                </div>\n\n                <ul class=\"charges\" data-test-id=\"fundingInstruments\">\n                        <!--List of Plans-->\n                    <li ng-hide=\"showMoreFiFactory.shouldHideFiEntry($index)\" role=\"presentation\" class=\"fundingsource\" data-test-id=\"listedFIElement\" ng-repeat=\"plan in getSortedPlans() track by plan.planId\">\n                        <experience flag='!cardart'>\n                            <div class=\"row-fluid radioButton\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                    ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom multiFiLabelContainer\" for=\"{{plan.planId}}\">\n                                    <div ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length && plan.primaryFs.subtype !== 'PAD'\">\n                                        <div class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                            <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                            <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                            <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                            <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                                        </div>\n                                    </div>\n                                    <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name, {'BILL_ME_LATER_DE': isDEInstallmentsFI(plan)}]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                        <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                            <div ng-switch=\"plan.primaryFs.subtype\">\n                                                <div class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                    <div ng-if=\"!padToggleEnabled\">\n                                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span>\n                                                        <br>\n                                                    </div>\n                                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE\">{{content('fundingInstruments.iach')}}</div>\n                                                </div>\n                                                <div ng-switch-default>\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                    <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                                    <span class=\"fsName\" data-test-id=\"primaryFsName\" ng-if=\"!plan.primaryFs.isPinlessDebit && !isDEInstallmentsOrGplFI(plan)\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                    <span class=\"fsName\" data-test-id=\"gplPrimaryFsName\" ng-if=\"isGplFI(plan)\">{{content('paymentMethod.globalPayLater')}}</span>\n                                                    <span class=\"lastdigits\" data-test-id=\"primaryFsDigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</div>\n                                                    <div class=\"iachMeftLabel\" ng-if=\"isCountryDE && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</div>\n                                                    <span class=\"fsName\" ng-if=\"isDEInstallmentsFI(plan)\">{{content('fsMappings.PAYPAL_INSTALLMENTS')}}</span>\n                                                        <div class=\"method short\" ng-if=\"isDEInstallmentsFI(plan)\">\n                                                            <div class=\"fsInstallmentDetails\">\n                                                                <div>{{ content('paymentMethod.installmentDetails',\n                                                                        {\n                                                                        amount: formatCurrency(installment.financing_details.total_cost, installment.financing_details.currency),\n                                                                        term: installment.financing_details.term\n                                                                        })\n                                                                    }}\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                                    <div ng-if=\"plan.primaryFs.isBillingPreferred\" class=\"billingPreferredLabel\">{{ content('fundingInstruments.billingPreferredFi', {merchantName: merchantName}) }}</div>\n                                                </div>\n                                            </div>\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <div ng-if=\"showPreferredLabelForMultiFi(plan)\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                            </div>\n                                            <div class=\"padLabel\" ng-if=\"showPadLabelForPadEligibleCountries(plan)\">\n                                                <span ng-if=\"plan.planId !== selectedmethod.planId\">\n                                                    <span>{{content('memberReview.padLabel_2')}}</span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </label>\n                            </div>\n                            <div class=\"fsSubdetails\">\n                                <span ng-if=\"showCreditPlacement(plan)\">\n                                    <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                </span>\n                                <xo-preferred-checkbox\n                                    ng-if=\"showPreferredCheckboxForMultiFi(plan) && showPreferredCheckbox(plan)\"\n                                    make-fi-preferred=\"makeFiPreferred\"\n                                    plan=\"plan\"\n                                    cardart=\"false\">\n                                </xo-preferred-checkbox>\n                                <xo-rewards-checkbox\n                                    ng-if=\"hasRewards(plan)\"\n                                    plan=\"plan\"\n                                    selectedmethod= \"selectedmethod\"\n                                    cardart=\"false\">\n                                </xo-rewards-checkbox>\n                                <div class=\"multiFiBackupComponent\"\n                                    ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\">\n                                    <xo-backup-label\n                                        plan=\"plan\">\n                                    </xo-backup-label>\n                                </div>\n                                <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                    {{ content('paymentMethod.eCheckDescription') }}\n                                </div>\n\n                                <div class=\"padToggle padToggleMultiFi sCheckbox checkbox\" ng-if=\"showMultiFiPadToggle(plan)\">\n                                    <input type=\"checkbox\" ng-checked=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" ng-change=\"multiFiPadToggleCheckboxEvent(plan)\" ng-model=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" id=\"padToggle\" name=\"padToggle\"\n                                            ng-true-value=\"true\" ng-false-value=\"false\"/>\n                                            <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                                    <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.fundingOptions.getPadPlanHopDate(plan), lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip ng-if=\"padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                    <div class=\"padToggleSection\" ng-if=\"!padToggleFeature.multiFiCheckboxStates[plan.primaryFs.id]\">\n                                        <p class=\"padToggleSectionOffInfoText\">\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                                        </p>\n                                        <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                            <div class=\"padToggleHelpToolTip\">\n                                                <p class=\"padToggleHelpToolTipHeader\">\n                                                    {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                                                </p>\n                                                <p class=\"padToggleHelpToolTipText\">\n                                                    <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                                                </p>\n                                            </div>\n                                        </xo-tooltip>\n                                    </div>\n                                </div>\n                            </div>\n                        </experience>\n\n                        <experience flag='cardart'>\n                            <div class=\"row-fluid radioButton fsPanelRadioWrapper\">\n                                <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" data-test-id=\"selectFIRadioButton\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                                ng-keydown=\"showMoreFiFactory.selectFiOnKeyDown($event, $index)\" />\n                                <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                    <div class=\"positionDecoupler\">\n                                        <xo-fi-panel\n                                            fi=\"plan.primaryFs\"\n                                            name-override=\"isGplFI(plan) && content('paymentMethod.globalPayLater')\"\n                                            show-currency-code=\"plan.primaryFs.type === 'BALANCE' && hasMultipleBalances\"\n                                        >\n                                            <div class=\"rewardsAvailableLabel\" ng-if=\"hasRewards(plan)\">\n                                                <div ng-if=\"!isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).secondLineText\"></span>\n                                                </div>\n                                                <div ng-if=\"isSelected(plan)\">\n                                                    <span ng-bind-html=\"getRewardsContent(plan).rewardsAvailble\"></span>\n                                                </div>\n                                            </div>\n                                            <span ng-if=\"showCreditPlacement(plan)\">\n                                                <xo-credit-offer-banners token=\"token\" reusetext=\"true\"/>\n                                            </span>\n\n                                            <xo-backup-label\n                                                ng-if=\"plan.planId === selectedmethod.planId && showBackupPlan(plan)\"\n                                                plan=\"plan\"\n                                                has-mask=\"true\"\n                                                >\n                                            </xo-backup-label>\n\n                                            <xo-preferred-checkbox\n                                                ng-if=\"makeFiPreferred && plan.planId === selectedmethod.planId && showPreferredCheckbox(plan)\"\n                                                make-fi-preferred=\"makeFiPreferred\"\n                                                plan=\"plan\"\n                                                cardart=\"true\">\n                                            </xo-preferred-checkbox>\n\n                                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                                {{ content('paymentMethod.eCheckDescription') }}\n                                            </div>\n                                            <div ng-if=\"plan.primaryFs.isPreferred && makeFiPreferred\">\n                                                <span class=\"preferredLabel\">{{ content('memberReview.preferred') }}</span>\n                                            </div>\n                                            <div ng-if=\"plan.gotDeclined\" class=\"gotDeclinedMessage\">\n                                                <span>{{ content('wallet.processorDeclinedCard') }}</span>\n                                            </div>\n                                            <div>\n                                                <xo-rewards-checkbox\n                                                    ng-if=\"hasRewards(plan)\"\n                                                    plan=\"plan\"\n                                                    selectedmethod= \"selectedmethod\"\n                                                    cardart=\"true\">\n                                                </xo-rewards-checkbox>\n                                            </div>\n                                            <div ng-if=\"setSelectedFiBufsDisclosureContent(plan)\" class=\"bufs-disclosure\" ng-bind-html=\"bufsDisclosureText\"></div>\n                                        </xo-fi-panel>\n                                    </div>\n                                </label>\n                            </div>\n                        </experience>\n                    </li>\n                    <li role=\"presentation\" class=\"fundingsource\" ng-if=\"showPPCAcquisitionRadioButton()\" data-test-id=\"de-ppc-offer\">\n                        <div ng-show=\"ppcInstallmentContentReady()\">\n                            <h2 class=\"paymentsHeader zeta\" ng-bind-html=\"getInstallmentsFiTitle()\" data-test-id=\"showInstallmentFiTitle\"></h2>\n                            <div class=\"row-fluid radioButton\">\n                                <input type=\"radio\" id=\"applyForPPCRadio\" name=\"selectedFI\" value=\"applyForPPCRadio\" ng-click=\"selectApplyForPPC()\"/>\n                                <label class=\"noBottom\" for=\"applyForPPCRadio\">\n                                    <xo-credit-offer-banners token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                                        selectedmethod=\"selectedmethod\" radio=\"true\" parent-context=\"creditParentContext\">\n                                    </xo-credit-offer-banners>\n                                </label>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <xo-show-more-fi-link ng-if=\"showMoreFiFactory.isFiNeverExpanded()\"></xo-show-more-fi-link>\n\n            <div ng-if=\"checkoutSession.cardBackup.isAllowed()\">\n                <xo-card-backup token=\"token\" selectedmethod=\"selectedmethod\"></xo-card-backup>\n            </div>\n\n            <!-- Show billing address associated to the selected card-->\n            <div ng-if=\"showBillingAddress\" class=\"charges\" ng-model=\"checkoutSession\">\n                <div id=\"billingAddressDisplay\">\n                    <xo-billing-address token=\"token\" edit-uri=\"\"></xo-billing-address>\n                </div>\n            </div>\n\n            <div class=\"padToggle sCheckbox checkbox\" ng-if=\"showPadToggle() && !showMultipleFi()\">\n                <input type=\"checkbox\" ng-checked=\"getPadStatus()\" ng-change=\"padToggleCheckboxEvent()\" ng-model=\"padToggleFeature.checkboxEnabled\" id=\"padToggle\" name=\"padToggle\"\n                        ng-true-value=\"true\" ng-false-value=\"false\"/>\n                <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"getPadStatus()\">\n                    <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.plan.sources[0].hop_date, lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip ng-if=\"getPadStatus()\" trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                    <div class=\"padToggleSectionOnBalanceText\" ng-if=\"isSplitPaymentWithBalanceAndIachPlan\">\n                        <div>\n                            <span class=\"balanceMsgIcon\"/>\n                        </div>\n                        <div class=\"balanceMsg\">\n                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnBalanceText')\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"padToggleSection\" ng-if=\"!getPadStatus()\">\n                    <p class=\"padToggleSectionOffInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip trigger=\"#padToggleHelp strong\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                </div>\n            </div>\n\n            <div ng-if=\"getAddCardLink().show\" class=\"multipleFi addCard\">\n                <a track-link=\"add_card\" ui-sref=\"{{getAddCardLink().route}}\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{getAddCardLink().label}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For single step nmj, openup wallet page in the sidebar against the review page -->\n            <div ng-if=\"nmjExperience && !nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"view_wallet\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"addCardLink\" role=\"button\" data-test-id=\"walletLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <!-- For multi step nmj, openup add card page in the sidebar against the pay-with-card page -->\n            <div ng-if=\"nmjExperience && nmjExperience.multiPage\" class=\"multipleFi switchCard\">\n                <a track-link=\"add_card\" ui-sref=\"checkout.payWithCard.sidebar.sidebarAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\" data-test-id=\"addCardLink\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('addCard.switchCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <h2 class=\"noBottom paymentsHeader zeta\" ng-if=\"showEmptyPlanHeader\">\n                <span>\n                    {{ content('paymentMethod.emptyPlanHeader') }}\n                </span>\n            </h2>\n            <div ng-if=\"showBalanceComprehensionBanner\" data-test-id=\"ppBalanceBanner\" class=\"ppBalanceBanner\">\n                <xo-message message=\"balanceComprehensionBannerMessage\"></xo-message>\n            </div>\n            <div class=\"cibBillingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isCIB && !showRpBaText && !showSubscriptionsV1BaText && !isOptionalVaulting\">\n                <span class=\"cibTextBox\" id=\"cibConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant,\n                    partner: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\">\n                </span>\n                <span data-test-id=\"CIBShowMore\" ng-if=\"!isExpandedAgreementText\">...\n                <a href=\"javascript:void(0);\" class=\"textLink\"\n                    ng-click=\"showExpandedText()\"\n                    onclick=\"return false;\">{{content('billingAgreement.memberAgreementCibShowMore')}}</a>\n                    </span>\n            </div>\n\n            <p id=\"baAgreement\" data-test-id=\"baAgreement\"  class=\"billingTxt secondary\" test-data-id=\"baAgreement\" ng-if=\"showMibBAText()\">\n                <span id=\"mibConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"rpAgreement\" class=\"billingTxt secondary\" test-data-id=\"rpAgreement\" ng-if=\"checkoutCart.isBilling() && showRpBaText\">\n                <span id=\"rpConsent\" data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent(getRPContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n\t\t\t<p id=\"installmentPlan\" class=\"billingTxt secondary\" ng-if=\"showInstallmentPlanBaText\">\n                <span data-test-id=\"BAContent\" data-ng-bind-html=\"htmlContent('billingAgreement.memberAgreementInstallmentPlan', { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"subscriptionsV1Agreement\" class=\"billingTxt secondary\" test-data-id=\"subscriptionsV1Agreement\" ng-if=\"checkoutCart.isBilling() && showSubscriptionsV1BaText\">\n                <span id=\"subscriptionsV1Consent\" data-test-id=\"BAContent\"\n                      data-ng-bind-html=\"htmlContent(getSubscriptionsV1BaText(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <div class=\"payWithCredit\">\n                <xo-pay-with-credit token=\"token\"></xo-pay-with-credit>\n            </div>\n\n            <!-- AU only direct debit agreement message for a AU buyer with unconfirmed bank -->\n            <p bind-html-compile=\"htmlContent('paymentMethod.directDebitAgreement', { payButtonText: payButtonText })\" ng-if=\"showUachFeatureDiscalimer\"\n                class=\"disclaimer directDebitAgreement\"></p>\n\n            <a ng-if=\"showChangeFI()\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"edits changePayment\"\n                select-button aria-label=\"{{ content('paymentMethod.label') }}\" focus-when-state=\"checkout.review.sidebar.wallet\" transitions-to=\"checkout.review\">\n                {{ locale.country === 'BR' ? content('common.changePayment') : content('common.change') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <a ng-if=\"selectedmethod && !nmjExperience && !hideManageLink\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" class=\"edits changePayment\"\n                select-button focus-when-state=\"checkout.review.sidebar.sidebarManageWallet\" transitions-to=\"checkout.review\">\n                {{ content('asideHeader.manage') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <div class=\"installmentsFirstPaymentNotice\" ng-if=\"isDEInstallmentsOptionSelected() && installment.financing_details\">\n                <span>{{content('memberReview.bmlFirstPaymentDueText',{days: '30'})}}</span>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"bfx-overlay\">\n    <xo-currency-conversion-overlay token=\"token\" ng-if=\"checkoutSession.plan.conversion\" done-fn=\"onComplete\"></xo-currency-conversion-overlay>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/styles.less");

var _template = __webpack_require__("../node_modules/xo-member-components/src/review-topup/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoReviewTopup', {
    tag: 'xo-review-topup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        flags: {
            // flags.sepaAgree is set to true when the Sepa Mandate checkbox is checked by user
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();

            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()['catch'](_angular.noop),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    actions: {
        gotoTopupFunding: function gotoTopupFunding() {
            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
        },
        closeModal: function closeModal() {
            this.showSepaModal = false;
        },
        openModal: function openModal() {
            this.showSepaModal = true;
        },

        /**
         * This function is refered in the signupTerms.agreeSepaTermsV2 content which has a link to open the Sepa page.
         */
        openSepa: function openSepa() {
            var sepaModel = _fi.$SepaModel.instance();

            this.sepa = {};
            var that = this;

            sepaModel.action('sepaDirectMandate', {
                resultModel: this.sepa,
                data: {
                    bank: {
                        id: this.models.checkoutSession.sepa_mandate.bankId
                    }
                },
                success: function success() {
                    that.actions.openModal();
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.showSepaModal = false;
            this.formatCurrency = _squid.formatCurrency;
            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
        },
        populate: function populate() {
            var _this = this;

            /**
             * Identify the preferred fs from the matching instrument_id
             */
            this.identifyPreferred = function (preferred, userSelectedFundingSource, fundingSources) {
                if (!preferred || !preferred.instrument_id) {
                    // Preferred does not have an instrument_id, hence pick the userSelectedFundingSource
                    return userSelectedFundingSource;
                } else if (!preferred.name) {
                    // Preferred has an instrument_id but does not have the full details, so map the corresponding element
                    return _squid.$util.find(fundingSources, function (fs) {
                        return fs.instrument_id === preferred.instrument_id;
                    });
                }
                return preferred;
            };

            /**
             * PatchXO api call for tokenization flows
             */
            this.tokenizationPatchXO = function (instrumentId) {
                return _this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: instrumentId
                    }
                });
            };

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                walletPreferences = _models.walletPreferences,
                tokenizedFundingCapabilitiesModel = _models.tokenizedFundingCapabilitiesModel;
            var topupFundingSources = checkoutSession.topupFundingSources,
                futurePaymentInstruments = checkoutSession.futurePaymentInstruments;
            // Topup does not have userSelectedFundingSource during the initial CreateXO api call

            var userSelectedFundingSource = checkoutSession.userSelectedFundingSource || topupFundingSources && topupFundingSources[0] || {};

            // Set the FI preferred currency
            walletPreferences.currency = tokenizedFundingCapabilitiesModel.getCurrency();

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                // Reset the users walletPreferences.direct to an empty object in an Topup flow.
                walletPreferences.direct = {};
                // Identify the preferred topup instrument
                walletPreferences.topup.fundingSource = this.identifyPreferred(walletPreferences.topup.fundingSource, userSelectedFundingSource, topupFundingSources);

                // topup amount is fixed to single value
                walletPreferences.topup.amount = _squid.$config.topup.topupAmounts[0];
                walletPreferences.topup.currency = _squid.$config.topup.currency;
            } else if (tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()) {
                // Reset the users walletPreferences.topup to an empty object in an Direct funding flow.
                walletPreferences.topup = {};
                // futurePaymentInstruments could have balance in it
                walletPreferences.direct.fundingSource = this.identifyPreferred(walletPreferences.direct.fundingSource, userSelectedFundingSource, futurePaymentInstruments);
            }

            if (walletPreferences.getPreferred().instrument_id !== userSelectedFundingSource.instrument_id && userSelectedFundingSource.instrument_id !== null) {
                /**
                 * instrumet_id not in sync with XO, hence make a patchXO api call.
                 * Use Case:
                 * When there are 2 banks (B1, B2) in the user account, and the user had linked his PayPal account in his Google wallet, with B2 as the preferred instrument.
                 * User then tries to link his PayPal account in a different Google wallet.
                 * - PAPS CreateXO api always returns the 1st direct funding instrument (i.e. B1) as the userSelectedFundingSource, and the contingency would be resolved for it.
                 * - But wallet preference for the user will return B2.
                 * - Since we need to show B2 to the user, we will update PAPS with B2 using the PatchXO api call.
                 */
                this.tokenizationPatchXO(walletPreferences.getPreferred().instrument_id);
            }

            if (tokenizedFundingCapabilitiesModel.isTopupEnabled()) {
                this.fundingLabel = (0, _squid.$renderContent)('review.topupFundingLabel');
            } else {
                this.fundingLabel = (0, _squid.$renderContent)('review.paymentMethod');
            }

            /**
             * Checks whether Sepa manadate agreement needs to be shown to the user or not
             */
            this.isSepaMandateRequired = function () {
                if (this.models.checkoutSession.sepa_mandate) {
                    return true;
                }
            };
        }
    }
});


_angular.noop;

_uiRouter.$state;

_squid.$Component;

_squid.$config;

_squid.formatCurrency;

_squid.$util;

_squid.$renderContent;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_fi.$SepaModel;

_app.$TokenizedFundingCapabilitiesModel;

_auth.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/review-topup/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"reviewTopup\" ng-class=\"{reviewDirectFunding: models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()}\" content>\n    <div class=\"topupAmountContainer listItem\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled() && models.walletPreferences.topup.amount && models.walletPreferences.topup.currency\">\n        <span class=\"label\">{{content('review.topupAmountLabel')}}</span>\n        <format-currency class=\"listItemValue\" code=\"models.walletPreferences.topup.currency\"\n                         amount=\"models.walletPreferences.topup.amount\"\n                         currency-style=\"Currency\"></format-currency>\n    </div>\n    <div class=\"clearfix topupFundingContainer listItem\" ng-click=\"actions.gotoTopupFunding()\">\n        <div>\n            <span class=\"label\" >{{ fundingLabel }}</span>\n            <div class=\"listItemValue\">\n                <span class=\"walletIcons\" ng-class=\"[models.walletPreferences.getPreferred().type,\n                                                    instrumentIconId(models.walletPreferences.getPreferred().name),\n                                                    models.walletPreferences.getPreferred().card_type]\"></span>\n\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n                    <!-- Show the card name and last4 digits in the same line -->\n                    <span class=\"fsname\">{{models.walletPreferences.getPreferred().name}}</span>\n                    <span class=\"fsLast4\">&nbsp;x-{{models.walletPreferences.getPreferred().last4}}</span>\n                </span>\n                <span ng-if=\"models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled()\" class=\"fsname\">\n                    <!-- Show the bank name and last4 digits in different lines -->\n                    <div class=\"bankname\">{{models.walletPreferences.getPreferred().name}}</div>\n                    <div>••••{{models.walletPreferences.getPreferred().last4}}</div>\n                </span>\n\n                <a ui-sref=\"checkout.review.sidepage.topupFunding\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupFunding\" transitions-to=\"checkout.review\">\n                    <span class=\"frontArrow goTray\"></span>\n                </a>\n            </div>\n        </div>\n        <div class=\"listItemDisclaimer\" ng-if=\"models.tokenizedFundingCapabilitiesModel.isTopupEnabled()\">\n            <span class=\"disclaimer\">{{content('review.topupFundingSourceInfo')}}</span>\n        </div>\n    </div>\n    <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"isSepaMandateRequired()\">\n        <input ng-model=\"flags.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\"/>\n        <label class=\"noBottom agreeTerms\" for=\"sepaAgree\" bind-html-compile=\"htmlContent('sepa.agreeSepaTerms')\"></label>\n    </div>\n\n    <xo-modal show=showSepaModal show-close-button=\"true\" on-close=\"actions.closeModal\">\n        <section id=\"sepaMandateContingency\" class=\"sepaMandate\" content>\n            <div class=\"row-fluid\">\n                <div class=\"centerTray\">\n                    <div class=\"trayInner trayInnerDefault loggingIn\">\n                            <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                            <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                            <div class=\"row-fluid sepaInfo\">\n                                <div class=\"span\">\n                                    <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                                    <p>\n                                        <span>{{sepa.user.name}}</span>\n                                        <br/>{{sepa.user.address.line1}}\n                                        <br/>{{sepa.user.address.line2}}\n                                        <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                        <br/>{{sepa.user.address.country}}\n                                    </p>\n                                </div>\n                                <div class=\"span bankDetails\">\n                                    <p>\n                                        <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                                    </p>\n                                    {{sepa.bank.iban_number}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bank_name}}\n                                    <p class=\"marginTop\">\n                                        <strong>{{content('DEMemberGuest.bic')}}</strong>\n                                    </p>\n                                    {{sepa.bank.bic}}\n                                </div>\n                            </div>\n\n                            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content('header.close') }}\" class=\"btn full\" ng-click=\"actions.closeModal()\" />\n\n                            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n                    </div>\n                </div>\n            </div>\n        </section>\n    </xo-modal>\n</section>\n\n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// eslint-disable-line no-unused-vars
// for ui-validate directive
exports['default'] = _squid.$Component.extend({
    tag: 'xo-rewards-checkbox',
    template: _template2['default'],
    props: {
        selectedmethod: {
            type: 'var',
            required: false
        },
        plan: {
            type: 'var',
            required: false
        },
        cardart: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token)
            };
        }
    },
    actions: {
        open: function open() {
            this.rewards.interstitialValue = this.rewards.value; // Set initial value to be the same as regular
            this.showOverlay = true;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'prepare_update_rewards_amount',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        close: function close() {
            this.showOverlay = false;
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_cancellation',
                'rewards_type': this.contentkeys.issuerName,
                'fi_id': rewardsAssociatedIds.cardID
            });
        },
        toggle: function toggle() {
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};

            if (this.state.selected) {
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: true,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
                _logger.$logger.info('pay_with_rewards', {
                    'from': 'FUNDING_OPTION_SELECTION',
                    'to': 'process_funding_option_selection',
                    'rewards_type': this.contentkeys.issuerName,
                    'fi_id': rewardsAssociatedIds.cardID
                });
            } else {
                // set done to false if user disables checkbox
                this.done = false;
                _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                    selected: false,
                    plan: this.plan,
                    selectedmethod: this.selectedmethod,
                    isReplan: false
                });
            }
        },
        submit: function submit() {
            var _this = this;

            _logger.$logger.info('PayWithRewards_interstitial_submit');
            var loaded = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsAssociatedIds && this.rewards.value;

            if (!loaded) {
                // should not actually be needed
                return false;
            }

            if (!_factory.$RewardsCheckboxFactory.isRewardsTypeChangeable(this.rewards.rewardsPayload.issuerDetails.rewardsType)) {
                this.showOverlay = false;
                return;
            }

            var ctx = this.getContext();
            var rewardsAssociatedIds = this.rewards.rewardsPayload.rewardsAssociatedIds || {};
            var value = this.rewards.interstitialValue;

            _factory.$RewardsCheckboxFactory.submitRewards(this.models.checkoutSession, ctx.currency_code, rewardsAssociatedIds.planID, rewardsAssociatedIds.rewardsID, value).then(function (data) {
                var isFail = typeof data === 'boolean' && data === false;
                var iRewardsPlan = _this.models.checkoutSession.plan.sources.length > 1; // TODO: maybe a better way to de this check ?

                _this.state.selected = !isFail && iRewardsPlan;
                if (!isFail) {
                    _this.rewards.value = _this.rewards.interstitialValue;

                    _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                        selected: true,
                        plan: _this.plan,
                        selectedmethod: _this.selectedmethod,
                        isReplan: true
                    });
                    _logger.$logger.info('pay_with_rewards', {
                        'from': 'UPDATE_REWARDS_INTERSTITIAL',
                        'to': 'process_update_rewards_amount',
                        'rewards_type': ctx.issuerData.issuerName,
                        'rewards_amt': value,
                        'fi_id': rewardsAssociatedIds.cardID
                    });
                }
                _this.done = _this.done || !isFail; // TODO: check if already selected ?
            })['finally'](function () {
                // TODO: error handler
                _this.showOverlay = false;
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            this.state = {
                selected: false
            };
            this.done = false;
            this.rewards = this.rewards || {
                // TODO: remove after moving logic to use selectedmethod
                // as opposed to separate var
                // placeholder var until cleanup/removal
                value: '',
                interstitialValue: '',
                planid: '',
                rewardsPayload: {},
                type: ''
            };
            this.form_error = false;

            _factory.$RewardsCheckboxFactory.setCheckboxSelectionForPlan({
                selected: false,
                plan: this.plan,
                selectedmethod: this.selectedmethod,
                isReplan: false
            });
        },
        populate: function populate() {
            this.showOverlay = false;
            this.plan = this.plan || this.props.plan || this.models.checkoutSession.plan;
            // TODO: Consider a mapper of sorts here for the payload
            this.rewards.rewardsPayload = _factory.$RewardsCheckboxFactory.getRewardDetails(this.plan);
            this.contentkeys = _factory.$RewardsCheckboxFactory.getContentKeys(this.plan, this.rewards.rewardsPayload);
            this.rewards.type = this.contentkeys.type; // type is a predefined key // recheck later

            var rewardsPayload = this.rewards && this.rewards.rewardsPayload && this.rewards.rewardsPayload.rewardsPayload || {};

            this.rewards.value = this.rewards.interstitialValue = (0, _utils.getInitialRewardsValue)(this.models, rewardsPayload);
            this.fullOverlay = this.rewards.type === 'statement-credit';
        }
    },
    controller: ['$scope', function ($scope) {

        $scope.getContext = function () {
            var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // TODO: first destructor and then get rid of it
            // need to refactor base payload first
            var rewardsDetails = $scope.rewards && $scope.rewards.rewardsPayload || {};
            var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
            var constraint = rewardsDetails && rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.rewards_constraint;
            var currency_code = $scope.models.checkoutCart.purchase && $scope.models.checkoutCart.purchase.amounts && $scope.models.checkoutCart.purchase.amounts.total.currency_code;

            return _squid.$util.extend({
                issuerData: issuerData, constraint: constraint, currency_code: currency_code,
                rewards_type: issuerData.rewardsType,
                conversion_metadata: rewardsDetails.rewardsPayload && rewardsDetails.rewardsPayload.conversion_metadata
            }, ctx);
        };

        $scope.showCheckbox = function () {
            var result = _factory.$RewardsCheckboxFactory.showCheckbox($scope.plan, $scope.selectedmethod, $scope.models.choiceVariant);

            return result;
        };

        $scope.valueValidator = function (data) {
            /**
             * Cases:
             * 1) less than max usable
             * 2) less than equal to cart
             * 3) should be a number
             * 4) 2 digit decimal place
             * 5) should be greater than min value
             */
            var constraint = $scope.getContext().constraint;

            if (!constraint || !constraint.maximum_usable) {
                // safe check to see if constraint is populated
                return true;
            }
            var rawValue = data || $scope.rewards && $scope.rewards.interstitialValue;
            var value = (0, _utils.toNumber)(rawValue);
            var maxUsable = (0, _utils.toNumber)(constraint.maximum_usable.value);

            $scope.minAllowed = (0, _utils.toNumber)(constraint.minimum_spend.value);
            var cartAmount = (0, _utils.toNumber)($scope.models.checkoutCart.purchase.amounts.total.amount, 2);
            var exists = value && maxUsable;
            var hasMax2DigitDecimal = /^\d+(\.\d{1,2})?$/i;
            var errorMap = [['default', !exists], ['default', isNaN(value)], ['default', !hasMax2DigitDecimal.test(rawValue)], ['minimum', value < $scope.minAllowed], ['moreThanAvailable', value > maxUsable && value <= cartAmount], ['moreThanPurchase', value > cartAmount]];
            var errorList = errorMap.find(function (testcase) {
                return testcase[1];
            });

            if (errorList) {
                // TODO: Make into debug or remove once rewards is stable.
                _logger.$logger.info('PayWithRewards_client_validation_error_' + errorList[0]);
            }
            $scope.form_error = errorList && errorList[0] || false;
            return !$scope.form_error;
        };

        $scope.useAmountContent = function () {
            /**
             * Final interstitial value to checkbox.
             *
             * cashback : currency -> currency
             * points : currency -> reward(currency)
             * miles : currency -> reward(currency)
             * statement-credit : currency -> currency
             */
            var ctx = $scope.getContext();
            var currency_symbol = (0, _squid.getCurrencySymbol)(ctx.currency_code);

            // inputType === 'currency' (cashback, chase)
            var rewardAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                conversion_type: 'REWARDS_TO_AMOUNT'
            }));
            var currencyAmount = '';

            // inputType === 'rewards' (points, miles)
            if ((0, _utils.conversionDetails)(ctx.issuerData.rewardsType).inputType === 'rewards') {
                rewardAmount = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.value, ctx, true);
                currencyAmount = (0, _utils.toCommaSeparatedString)($scope.rewards.value, $scope.getContext({
                    conversion_type: 'REWARDS_TO_AMOUNT'
                }));
            }

            return (0, _squid.$renderContent)('rewards.useAmount.' + ctx.issuerData.contentKey, {
                rewardAmount: rewardAmount,
                currency_symbol: currency_symbol,
                currencyAmount: currencyAmount
            });
        };

        $scope.formOutputContent = function () {
            var ctx = $scope.getContext();
            var rewardPoints = (0, _utils.convert)('AMOUNT_TO_REWARDS', $scope.rewards.interstitialValue, ctx, true);

            return (0, _squid.$renderContent)('rewards.formResultLabel.' + ctx.issuerData.contentKey, {
                rewardPoints: rewardPoints
            });
        };
    }]
});


_squid.$Component;

_squid.$renderContent;

_squid.getCurrencySymbol;

_squid.$util;

_logger.$logger;

_angular.$rootScope;

_angular.noop;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_choice.$ChoiceEligibility;

_factory.$RewardsCheckboxFactory;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.getInitialRewardsValue;

_utils.convert;

_utils.conversionDetails;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 * TODO: Somehow try to move some of this constant
 * mapping logic to some facade layer.
 */
var REWARD_CODE_MAPPINGS = {
    'DLR': {
        issuerName: 'discover',
        rewardsType: 'cashback',
        contentKey: 'discover.cashback',
        rewardsEnabled: true
    },
    'MIL': {
        issuerName: 'discover',
        rewardsType: 'miles',
        contentKey: 'discover.miles',
        rewardsEnabled: true
    },
    'TYP': {
        issuerName: 'citi',
        rewardsType: 'points',
        contentKey: 'citi',
        rewardsEnabled: true
    },
    'LPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'WPTS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'USD': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'MLS': {
        issuerName: 'chase',
        rewardsType: 'statement-credit',
        contentKey: 'chase',
        rewardsEnabled: false
    },
    'AMEX': {
        issuerName: 'amex',
        rewardsType: 'points',
        contentKey: 'amex',
        rewardsEnabled: true
    },
    'DEFAULT': {
        // This should never really be used.
        issuerName: 'default',
        rewardsType: 'points',
        contentKey: 'default',
        rewardsEnabled: true
    }
};

/**
 *  Given a rewards instrument
 *  Returns all ids and keys we need to link rewards
 *  to different plans and instruments
 *
 * @param {*} instrument
 * @returns
 */
var rewardsAssociatedIds = function rewardsAssociatedIds(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var related_card = rewardsPayload && rewardsPayload.related_card;
    var cardID = related_card && related_card.id;
    var rewardsID = instrument.id;
    var planID = instrument.planId;

    return {
        rewardsID: rewardsID,
        cardID: cardID,
        planID: planID
    };
};

/**
 * Returns all issuer related info required to render
 * custom experience for different reward programs
 *
 * @param {*} instrument
 * @returns
 */
var issuerDetails = function issuerDetails(instrument) {
    var rewardsPayload = instrument.rewards || {};
    var available_incentive = rewardsPayload && rewardsPayload.available_incentive;
    var rewards_currency_code = available_incentive.rewards_code;

    // set `rewards_currency_code` to 'DEFAULT' if we don't get a supported `rewards_code`
    if (!rewards_currency_code || !Object.keys(REWARD_CODE_MAPPINGS).includes(rewards_currency_code)) {
        rewards_currency_code = 'DEFAULT';
        _logger.$logger.info('PayWithRewards_use_default_issuer_data');
    }

    // This is a temporary fix until a rewards currency code is returned for Amex.
    // `redemption_type` is the type of redemption for the rewards. For now, `STATEMENT_CREDIT_WITH_AMOUNT_CHOICE` will
    // only be returned for Amex, but in the future there might be other programs that use it as well.
    //
    // TODO: Use the Amex rewards_code when planning adds it in
    if (!rewards_currency_code && rewardsPayload.redemption_type === 'STATEMENT_CREDIT_WITH_AMOUNT_CHOICE') {
        rewards_currency_code = 'AMEX';
    }

    var issuerData = available_incentive && REWARD_CODE_MAPPINGS[rewards_currency_code];
    var issuerName = issuerData.issuerName,
        rewardsType = issuerData.rewardsType,
        contentKey = issuerData.contentKey;

    var rewardPoints = available_incentive && available_incentive.value;
    var rewardMonetaryValue = available_incentive && available_incentive.monetary_value && available_incentive.monetary_value.value;

    // Convert strings to numeric values
    rewardPoints = (0, _utils.toNumber)(rewardPoints);
    rewardMonetaryValue = (0, _utils.toNumber)(rewardMonetaryValue);

    return {
        rewards_currency_code: rewards_currency_code,
        rewardPoints: rewardPoints,
        rewardMonetaryValue: rewardMonetaryValue,
        rewardsType: rewardsType,
        issuerName: issuerName,
        contentKey: contentKey
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$RewardsCheckboxFactory', function () {

    var rewardsCache = {};
    var models = {};
    var cancelSessionWatcher = void 0; // holds the deactivator function

    var checkboxSelection = {
        planId: null,
        rewardsChosenPlan: null
    };

    var buildCache = function buildCache() {
        /**
         * TODO:
         * Consider developing a focus around fi as opposed to plans
         * once you proved stability in rewards move it out and expand to
         * all FI not just rewards. The case we need to confirm is plan refreshes.
         * 1) If we are starting a cache then how does cache management work with the
         * different plan refresh cases?
         * 2) How can we leverage the xo-models cache infrastructure ?
        */
        var isFeatureEnabled = (0, _squid.$feature)('payWithRewards');

        if (isFeatureEnabled && !cancelSessionWatcher) {
            cancelSessionWatcher = _squid.$event.on('checkoutSessionChange', function (event) {
                // For SNT in WPS there is a plan refresh upon RYI render.
                refreshCache();
            });
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token)
        }).then(function () {
            var _models$checkoutSessi = models.checkoutSession.fundingOptions.instruments,
                instruments = _models$checkoutSessi === undefined ? [] : _models$checkoutSessi;


            if (isFeatureEnabled) {
                _squid.$util.forEach(instruments, function (instrument) {
                    var payload = {};
                    var rewardsPayload = instrument.rewards || {};
                    var available_incentive = rewardsPayload && rewardsPayload.available_incentive || {};
                    var rewards_currency_code = available_incentive.rewards_code;

                    // only add FI to `rewardsCache` if it's of type `REWARDS`
                    // and we're supporting its `rewards_currency_code`
                    if (instrument.type === 'REWARDS' && Object.keys(REWARD_CODE_MAPPINGS).includes(rewards_currency_code) && REWARD_CODE_MAPPINGS[rewards_currency_code].rewardsEnabled) {
                        payload.rewardsAssociatedIds = rewardsAssociatedIds(instrument);
                        payload.issuerDetails = issuerDetails(instrument);
                        payload.rewardsPayload = rewardsPayload;
                        // TODO: DO we still need to hold on to raw payload ?
                        // move to store only whats needed approach
                        var cardID = payload.rewardsAssociatedIds.cardID; // set focus on card as opposed to rewards/plans

                        rewardsCache[cardID] = payload;
                        _logger.$logger.info('PayWithRewards_instrument_check', {
                            'fi_id': cardID
                        });
                    }
                });
            }
        })['finally'](function () {
            // instrumentation here
        });
    };

    var refreshCache = function refreshCache() {
        // TODO: Consider this when handling
        // plan refresh use case
        rewardsCache = {};
        buildCache();
    };

    var destroy = function destroy() {
        if (cancelSessionWatcher) {
            cancelSessionWatcher();
        }
    };

    /**
     * Checks to see if the current session
     * has any rewards FI in any plan.
     *
     * @returns Boolean
     */
    var rewardsFound = function rewardsFound() {
        return Object.keys(rewardsCache).length > 0;
    };

    /**
     * Returns a string representing rewards fi's
     * with issuer name.
     * Sample: "CC-T2RX5VBELRL7C_discover:CC-ZKQBGHWZQECYJ:chase"
     *
     * @returns String
     */
    var toString = function toString() {
        var result = '';

        _squid.$util.forEach(rewardsCache, function (instrument, instrument_id) {
            var issuerData = instrument.issuerDetails;
            var issuerName = issuerData.issuerName;

            if (instrument_id && issuerName) {
                result = result ? result + ':' + instrument_id + '_' + issuerName : instrument_id + '_' + issuerName;
            }
        });
        return result;
    };

    /**
     * Checks if the FI has a rewards
     * instrument attached
     *
     * @param {*} fi
     * @returns
     */
    var isRewardsFi = function isRewardsFi(fi) {
        // const isCard = fi.type === 'CARD';
        var result = Boolean(rewardsCache[fi.instrument_id]);

        return result;
    };

    /**
     * Checks if the primary FI associated
     * with the plan has rewards
     *
     * @param {*} plan
     * @returns
     */
    var isRewardsPlan = function isRewardsPlan(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var isBalanceSelected = (0, _utils.isPayPalBalanceSelected)(plan);
        var isRewards = isRewardsFi(fi);
        // balance and rewards are incompatible
        // if balance then do not use rewards
        // Should we check for balance as part of isRewards check
        // or separate?

        return isRewards && !isBalanceSelected;
    };

    /**
     * Returns if the rewards has a changeable amount, based on the provided type
     */
    var isRewardsTypeChangeable = function isRewardsTypeChangeable(type) {
        return type !== 'statement-credit';
    };

    var getRewardDetails = function getRewardDetails(plan) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var result = isRewardsFi(fi) && rewardsCache[fi.instrument_id];

        return result;
    };

    var getRewardsPlanFromFi = function getRewardsPlanFromFi(fi) {
        var fiDetails = rewardsCache[fi.instrument_id] || {};
        var planID = fiDetails.rewardsAssociatedIds && fiDetails.rewardsAssociatedIds.planID;

        return (0, _utils.getPlanFromId)(planID);
    };

    var ifRewardsThenUpdatePlan = function ifRewardsThenUpdatePlan(currentPlanId, selectedmethod, checkoutSession) {

        // Given an Id
        // get plan object.
        // check if plan object contains rewards

        // ------------------------------------
        // -----> handle these before the plan comes into this function
        // check if plan is selected (2 cases)
        // 1st check if plan is user selected
        // --- We need this to give precedence to checkbox which wont trigger replan
        // 2nd check if plan is session selected
        // -- if we have a replan or initial plan already selecting rewards then honor it.
        // ------------------------------------
        var isRewardsChosen = selectedmethod ? selectedmethod.rewardsChosenPlan : // multiple FI selection
        checkboxSelection.rewardsChosenPlan; // single FI selection
        var selectedPlan = (0, _utils.getPlanFromId)(checkoutSession, selectedmethod ? selectedmethod.planId : currentPlanId);
        var rewardsEligible = isRewardsPlan(selectedPlan);

        if (!rewardsEligible) {
            return currentPlanId;
        }

        var result = (0, _utils.matchPlanFromConstraints)({
            checkoutSession: checkoutSession,
            instrumentId: (0, _utils.getInstrumentID)(selectedPlan),
            // For now, we never want balance with this method.
            balance: false,
            rewards: isRewardsChosen
        });

        return result && (0, _utils.getPlanID)(result);
    };

    var showCheckbox = function showCheckbox(plan, fiSelectionContext, choiceVariant) {
        var isChoiceVariant = Boolean(choiceVariant === '6');
        var isMultiFi = Boolean(plan && plan.primaryFs); // TODO: fails for selectFI use case
        var usingPayPalBalance = Boolean(plan && plan.secondaryFIs);
        var uiSelectedPlanId = plan && (0, _utils.getPlanID)(plan);
        var clickSelectedPlanId = fiSelectionContext && fiSelectionContext.planId;
        // Differentiating between uiSelection vs clickSelection to avoid the case
        // when this function gets triggered due to digest while the user has clicked
        // on a different fi. Do not show checkbox for this case. Would cause flickering.
        var isRewards = isRewardsPlan(plan);
        var disregardClickSelection = isChoiceVariant || !isMultiFi;
        var isSelected = uiSelectedPlanId && uiSelectedPlanId === clickSelectedPlanId || disregardClickSelection;

        var result = isSelected && isRewards && !usingPayPalBalance;

        return result;
    };

    /**
     * When session has balance and
     * fi has rewards then hide amount.
     * TODO: consider removing this after PAPS fix
     *
     * @param {*} fi
     * @returns
     */
    var hideAmount = function hideAmount(fi) {

        if (!fi) {
            return false;
        }
        var isRewards = isRewardsFi(fi);

        return isRewards;

        /**
         * TODO commenting the below code as patch on changing the rewards amount
         * is not updating the amount getting charged from other funding source
         * until symphony fix this, hiding the amount
         */

        // const { checkoutSession = {} } = models;
        // const { instruments = [] } = checkoutSession.fundingOptions;
        // const sessionHasBalance = instruments.some(instrument => instrument.type === 'BALANCE');
        //
        // return (isRewards && sessionHasBalance);

        // end of TODO
    };

    var setCheckboxSelectionForPlan = function setCheckboxSelectionForPlan(_ref) {
        var selected = _ref.selected,
            plan = _ref.plan,
            selectedmethod = _ref.selectedmethod,
            isReplan = _ref.isReplan;

        if (selectedmethod) {
            if (selected) {
                (0, _utils.setSelectedPlan)(plan, selectedmethod, isReplan);
            } else {
                (0, _utils.clearSelectedPlan)(plan, selectedmethod);
            }
        } else {
            var planId = (0, _utils.getPlanID)(plan);

            checkboxSelection.planId = planId;
            checkboxSelection.rewardsChosenPlan = selected ? planId : null;
        }
    };

    var getContentKeys = function getContentKeys(plan, rewardsPayload) {
        var fi = (0, _utils.getPrimaryFI)(plan);
        var last4Digits = fi && fi.lastDigits;
        var rewardsDetails = rewardsPayload || getRewardDetails(plan);
        var issuerData = rewardsDetails && rewardsDetails.issuerDetails || {};
        var currency_code = fi && fi.amount && fi.amount.currency_code;
        var rewardPoints = (0, _utils.toCommaSeparatedString)(issuerData.rewardPoints, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'AMOUNT_TO_REWARDS',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var rewardMonetaryValue = (0, _utils.toCommaSeparatedString)(issuerData.rewardMonetaryValue, {
            conversion_metadata: rewardsDetails.conversion_metadata,
            conversion_type: 'REWARDS_TO_AMOUNT',
            rewards_type: issuerData.rewardsType,
            currency_code: currency_code
        });
        var currency_symbol = (0, _squid.getCurrencySymbol)(currency_code);
        var getString = function getString(key) {
            return (0, _squid.$renderContent)(key + '.' + issuerData.contentKey, {
                issuerName: issuerData.issuerName,
                last4Digits: last4Digits,
                rewardPoints: rewardPoints,
                rewardAmount: rewardMonetaryValue,
                currency_symbol: currency_symbol
            });
        };
        var map = {
            header: getString('rewards.header'),
            rewardsAvailble: getString('rewards.rewardsAvailble'),
            subText: getString('rewards.subText'),
            policy: getString('rewards.policy'),
            secondLineText: getString('rewards.secondLineText'),
            chargeAmount: getString('rewards.chargeAmount'),
            changeAmount: getString('rewards.changeAmount'),
            formInputLabel: getString('rewards.formInputLabel'),
            formResultLabel: getString('rewards.formResultLabel'),
            // TODO: use dynamic amount
            // useAmount:$renderContent(`rewards.useAmount.${issuerData.contentKey}`, {
            //     rewardAmount: '919191',
            //     currencyUnit: '$',
            //     currencyAmount: '9999'
            // }),
            enterValidAmount: (0, _squid.$renderContent)('rewards.enterValidAmount.default'),
            type: issuerData.rewardsType,
            overlayButton: (0, _squid.$renderContent)(isRewardsTypeChangeable(issuerData.rewardsType) ? 'common.save' : 'common.OK'),
            issuerName: issuerData.issuerName,
            value: {
                rewardPoints: rewardPoints, // Amount in rewards
                rewardAmount: rewardMonetaryValue // Amount in currency
            }
        };

        return map;
    };

    /**
     * Do a select call and an update call in sequence.
     * Consider batching this later
     *
     * @param {*} checkoutSession
     * @param {*} currency_code
     * @param {*} planID
     * @param {*} rewardsID
     * @param {*} value
     * @returns
     */
    var submitRewards = function submitRewards(checkoutSession, currency_code, planID, rewardsID, value) {
        var payload = {
            type: 'REWARDS',
            value: value,
            currency: currency_code,
            id: rewardsID
        };

        var errorHandler = function errorHandler(name, err, action, type) {
            // TODO: Get rid of this or discuss better handling with product
            // Do we really need 2 handlers? once we have decided the kind of errors
            // that get thrown then pick one type of handler contingency or error

            checkoutSession.message = {
                type: 'error',
                msgKeys: ['paymentMethod.cycoSsotWarning']
            };
            _logger.$logger.info('pay_with_rewards', {
                'from': 'UPDATE_REWARDS_INTERSTITIAL',
                'to': 'process_planning_response',
                'int_error_code': err,
                'int_error_description': action + '-' + type,
                'error_source': 'paymentapiplatformserv'
            });
            return _squid.$promise.reject(err);
        };

        return checkoutSession.fundingOptions.action('select', {
            resultModel: checkoutSession,
            data: {
                planId: planID
            },
            success: function success(result) {
                checkoutSession.populate(result);
            },
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return errorHandler(name, err, 'select', 'contingency');
                }
            },
            error: function error(name, err) {
                return errorHandler(name, err, 'select', 'error');
            }
        }).then(function () {
            return checkoutSession.fundingOptions.action('patch', {
                resultModel: checkoutSession,
                data: payload,
                success: function success(result) {
                    checkoutSession.message = {
                        type: 'success',
                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                    };
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        return errorHandler(name, err, 'patch', 'contingency');
                    }
                },
                error: function error(name, err) {
                    return errorHandler(name, err, 'patch', 'error');
                }

            });
        });
    };

    return {
        buildCache: buildCache,
        refreshCache: refreshCache,
        destroy: destroy,
        rewardsFound: rewardsFound,
        toString: toString,
        isRewardsPlan: isRewardsPlan,
        isRewardsFi: isRewardsFi,
        isRewardsTypeChangeable: isRewardsTypeChangeable,
        getRewardsPlanFromFi: getRewardsPlanFromFi,
        getRewardDetails: getRewardDetails,
        getContentKeys: getContentKeys,
        showCheckbox: showCheckbox,
        hideAmount: hideAmount,
        setCheckboxSelectionForPlan: setCheckboxSelectionForPlan,
        ifRewardsThenUpdatePlan: ifRewardsThenUpdatePlan,
        submitRewards: submitRewards
    };
});

_squid.$util;

_squid.$renderContent;

_squid.$populate;

_squid.$feature;

_squid.$promise;

_squid.$event;

_squid.getCurrencySymbol;

_angular.$rootScope;

_checkout.$CheckoutSessionModel;

_utils.getPlanID;

_utils.getInstrumentID;

_utils.getPrimaryFI;

_utils.getPlanFromId;

_utils.toNumber;

_utils.toCommaSeparatedString;

_utils.isPayPalBalanceSelected;

_utils.setSelectedPlan;

_utils.clearSelectedPlan;

_utils.matchPlanFromConstraints;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/rewards-checkbox", "../node_modules/xo-member-components/src/rewards-checkbox/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showCheckbox()\" class=\"sCheckbox checkbox\" content>\n    <div class=\"postSelection checkboxPayWithRewards\" ng-class=\"{cardart: cardart, singleFi: singleFi}\">\n        <input type=\"checkbox\" ng-model=\"state.selected\" name=\"rewardsSelection\" id=\"rewardsSelection\" ng-change=\"actions.toggle()\" data-test-id=\"rewards-checkbox\">\n        <label for=\"rewardsSelection\">\n            <span ng-bind-html=\"useAmountContent()\"></span>\n            <a ng-click=\"actions.open()\" link-button class=\"changeAmount\" data-test-id=\"rewards-change-amount\">\n                {{contentkeys.changeAmount}}\n            </a>\n        </label>\n        <div class=\"remainderDisclosure\" ng-if=\"(state.selected || done)\">\n            {{contentkeys.chargeAmount}}\n        </div>\n    </div>\n    <section class=\"rewards-overlay\" ng-class=\"{ 'full-overlay': fullOverlay }\">\n        <xo-modal show=\"showOverlay\"\n                on-close=\"actions.close\"\n                show-close-button=\"true\"\n                enable-close-on-escape=\"true\"\n                override-default-container=\"true\">\n            <div id=\"rewardsInterstitial\" data-test-id=\"rewards-overlay\">\n                <span ng-class=\"{chasePay: rewards.type==='statement-credit'}\">\n                    <h2 class=\"rewardsHeader alpha\">\n                        <span ng-bind-html=\"contentkeys.header\"></span>\n                    </h2>\n                    <div class=\"rewardsAvailble\">\n                        <span ng-bind-html=\"contentkeys.rewardsAvailble\"></span>\n                    </div>\n                </span>\n\n                <div class=\"rewardsForms\">\n                    <div ng-if=\"rewards.type && rewards.type!=='statement-credit'\"\n                        class=\"{{rewards.type}}\">\n                        <!-- TODO: find a better way instead of mapping type directly to class -->\n                        <!-- ng-class=\"{{rewards.type}}\" is not class=\"points\" -->\n\n                        <span class='leftSide'>\n                            <span class='currencyUnit' ng-bind-html=\"contentkeys.formInputLabel\"></span>\n                            <input class='Field' value=\"\"\n                                ng-model=\"rewards.interstitialValue\"\n                                ui-validate=\"'valueValidator($value)'\"\n                                data-test-id=\"rewards-change-input\"\n                                />\n                        </span>\n                        <span class='rightSide'>\n                            <span class='equalSign' ng-if=\"rewards.type!=='cashback'\">=</span>\n                            <span class='rewardUnit' ng-bind-html=\"formOutputContent()\"></span>\n                        </span>\n                    </div>\n                    <div class=\"formText\"\n                         ng-class=\"{subText: rewards.type!=='', fullText: rewards.type===''}\">\n                        <div ng-class=\"{formError: form_error}\"\n                            ng-switch=\"form_error\">\n                            <div ng-switch-when=\"false\"> {{contentkeys.subText}}</div>\n                            <div ng-switch-when=\"default\"> {{content('rewards.enterValidAmount.default')}}</div>\n                            <div ng-switch-when=\"minimum\"> {{content('rewards.enterValidAmount.minimum', { value: minAllowed })}}</div>\n                            <div ng-switch-when=\"moreThanAvailable\"> {{content('rewards.enterValidAmount.moreThanAvailable')}}</div>\n                            <div ng-switch-when=\"moreThanPurchase\"> {{content('rewards.enterValidAmount.moreThanPurchase')}}</div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"rewardsFooter\">\n                    <div class=\"disclaimer\">\n                        <span ng-bind-html=\"contentkeys.policy\"></span>\n                    </div>\n                    <div id=\"button\" class=\"buttons submit\">\n                        <input track-submit\n                            type=\"submit\"\n                            ng-value=\"contentkeys.overlayButton\"\n                            class=\"btn full confirmButton continueButton\"\n                            ng-disabled=\"form_error\"\n                            ng-click=\"actions.submit()\"\n                            data-test-id=\"rewards-change-submit\"\n                            />\n                    </div>\n                </div>\n            </div>\n        </xo-modal>\n    </section>\n</div>\n    \n"

/***/ }),

/***/ "../node_modules/xo-member-components/src/rewards-checkbox/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.matchPlanFromConstraints = exports.getSelectedPlan = exports.isPayPalBalanceSelected = exports.getInitialRewardsValue = exports.getPlanFromId = exports.getPrimaryFI = exports.clearSelectedPlan = exports.setSelectedPlan = exports.isPayNow = exports.convert = exports.convertValue = exports.toCommaSeparatedString = exports.toNumber = exports.sanitizeNumber = exports.conversionDetails = exports.getInstrumentID = exports.getPlanID = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

// eslint-disable-line no-unused-vars

/**
 *  fundingOptions has plan.planId
 *  checkoutSession has plan.id
 *
 * @param {*} plan
 */
var getPlanID = exports.getPlanID = function getPlanID(plan) {
    if (!plan) {
        return plan;
    }
    return plan.planId || plan.id;
};

/**
 * getInstrumentId
 * @param {Object} plan Any type of plan
 * @retursn {String} Instrument ID of primary fs
 */
var getInstrumentID = exports.getInstrumentID = function getInstrumentID(plan) {
    return plan.sources ? plan.sources[plan.sources.length - 1].instrument_id : plan.primaryFs.id;
};

/**
 * Returns an object containing input
 * and output details about the conversion
 *
 * @param {*} rewards_type
 * @param {*} conversion_type
 * @returns {}
 */
var conversionDetails = exports.conversionDetails = function conversionDetails(rewards_type, conversion_type) {
    var result = {};

    if (rewards_type) {
        var rewardsInCurrency = rewards_type === 'cashback'
        // TODO: Consider replacing rewardsInCurrency with monetary flag from PSS.
        // As of now not receiving it from PAPS.
        ;

        result.inputType = rewardsInCurrency ? 'currency' : 'rewards';
        if (conversion_type) {
            var useCurrency = conversion_type === 'REWARDS_TO_AMOUNT' || rewardsInCurrency && conversion_type === 'AMOUNT_TO_REWARDS';

            result.outputType = useCurrency ? 'currency' : 'rewards';
            result.skipConversion = result.inputType === result.outputType;
        }
    }
    return result;
};

/**
 * sanatizes undefined, NAN numbers
 * does rounding and limits
 *
 * @param {*} value
 * @param {*} limit
 * @param {*} rounding
 * @returns
 */
var sanitizeNumber = exports.sanitizeNumber = function sanitizeNumber(value, limit, rounding) {
    var isString = value && typeof value === 'string';
    var hasComma = isString && value.indexOf(',') >= 0;

    if (!value || hasComma) {
        /** 
         * Avoid accidental double sanitization
         * TODO: figure out how to prevent double 
         * sanitization in the first place
        */
        return !value ? '0' : value;
    }

    var num = Number(value);

    num = isNaN(num) || !num ? 0 : num;
    num = rounding === 1 ? Math.round(num) : num;
    num = limit ? num.toFixed(limit) : num;
    num = isString ? num : Number(num);
    /** 
     * if you get a string return a string
     * required for 1.20 or decimal/currency use case
     * since toFixed return a string
    */

    return num;
};

/**
 * Given a string return a number
 *
 * @param {*} str
 * @param {number} [limit=2]
 * @param {number} [rounding=0]
 * @returns
 */
var toNumber = exports.toNumber = function toNumber(value) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var rounding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var num = typeof value === 'string' ? parseFloat(value) : value;

    return sanitizeNumber(num, limit, rounding);
};

/**
 * extract the required decimal precision from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getPrecision = function getPrecision(conversion_metadata, key) {
    var decimal_precision = {};

    _squid.$util.forEach(conversion_metadata.decimal_precisions, function (ele) {
        decimal_precision[ele.conversion_type] = toNumber(ele.length, 0);
    });
    return decimal_precision[key] || 0;
};

/**
 * extract the required rounding details from rewards
 *
 * @param {*} conversion_metadata
 * @param {*} key
 * @returns
 */
var getRounding = function getRounding(conversion_metadata, key) {
    var rounding_modes = {};
    var mapper = {
        'UNNECESSARY': 0,
        'HALF_UP': 1
        // More may be added over time
    };

    _squid.$util.forEach(conversion_metadata.rounding_modes, function (ele) {
        rounding_modes[ele.conversion_type] = ele.value;
    });
    var value = rounding_modes[key] || 'UNNECESSARY';

    return mapper[value];
};

var toCommaSeparatedString = exports.toCommaSeparatedString = function toCommaSeparatedString(value) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!value) {
        return '';
    }
    var currency_code = ctx.currency_code,
        _ctx$conversion_metad = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad === undefined ? {} : _ctx$conversion_metad,
        conversion_type = ctx.conversion_type,
        rewards_type = ctx.rewards_type;

    var locale_code = _squid.$locale.lang + '-' + _squid.$locale.country;
    var useCurrency = conversionDetails(rewards_type, conversion_type).outputType === 'currency';
    var precision = getPrecision(conversion_metadata, conversion_type);
    var rounding = getRounding(conversion_metadata, conversion_type);
    var num = toNumber(value, '', rounding);
    var result = '';

    if (useCurrency) {
        result = (0, _squid.formatCurrency)(value, currency_code, false, 'AmountOnlyStyle');
        result = sanitizeNumber(result, 2, 0);
    } else {
        result = num.toLocaleString(locale_code, {
            useGrouping: true, // may only need for certain countries.
            minimumFractionDigits: precision
        });
        result = sanitizeNumber(result);
    }

    return result;
};

/**
 * Conversion math logic.
 * use precision and rounding from the rewards payload
 * to preform conversion to & from rewards
 *
 * @param {*} amount
 * @param {*} conversion_type
 * @param {*} conversionData
 * @returns
 */
var convertValue = exports.convertValue = function convertValue(amount, conversion_type, conversionData) {
    var result = '';

    if (!amount || !conversion_type || !conversionData) {
        return result;
    }
    var precision = getPrecision(conversionData, conversion_type);
    var rounding = getRounding(conversionData, conversion_type);
    // Use 4 decimal places or more for factor multiplication.
    // We need this to maintain decimal precision during calculation.
    var factor = toNumber(conversionData.conversion_factor, 4);

    // convert from rewards to points and vice-versa
    result = conversion_type === 'AMOUNT_TO_REWARDS' ? amount * 1.0 / factor : amount * factor;
    // Choose final precision based on downstream requirements
    var res = toNumber(result, precision, rounding);

    return res;
};

/**
 * Conversion business logic.
 * It decides when to convert and when not to and
 * finally returns the appropriate formated value.
 *
 * @param {*} conversion_type
 * @param {*} amount
 * @param {*} [ctx={}]
 * @returns
 */
var convert = exports.convert = function convert(conversion_type, amount) {
    var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!amount || !conversion_type) {
        return '';
    }
    var _ctx$conversion_metad2 = ctx.conversion_metadata,
        conversion_metadata = _ctx$conversion_metad2 === undefined ? {} : _ctx$conversion_metad2,
        _ctx$issuerData = ctx.issuerData,
        issuerData = _ctx$issuerData === undefined ? {} : _ctx$issuerData,
        currency_code = ctx.currency_code;

    var skip = !force && conversionDetails(issuerData.rewardsType, conversion_type).skipConversion;
    var converted = skip ? toNumber(amount) : convertValue(amount, conversion_type, conversion_metadata);

    converted = toCommaSeparatedString(converted, {
        rewards_type: issuerData.rewardsType,
        conversion_metadata: conversion_metadata,
        conversion_type: conversion_type,
        currency_code: currency_code
    });
    return converted;
};

/**
 * Checks for paynow vs continue usecase
 * TODO: expand and move logic to $CheckoutAppDataModel
 *
 * @param {*} checkoutAppData
 * @returns Boolean
 */
var isPayNow = exports.isPayNow = function isPayNow(checkoutAppData) {
    var isWPS = checkoutAppData.is_wps_flow();
    var userAction = checkoutAppData.useraction();

    return !!(!isWPS && userAction === 'commit');
};

/**
 * UI related operations to be performed on select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 * @param {*} isReplan
 */
var setSelectedPlan = exports.setSelectedPlan = function setSelectedPlan(plan, selectedmethod, isReplan) {
    // use applyAsync in order to wait for all plans to be updated and etc.
    // Wait for the radio buttons to have all the latest plan ids in its scope
    if (selectedmethod) {
        _angular.$rootScope.$applyAsync(function () {
            selectedmethod.planId = getPlanID(plan); // force UI selected method to use non-reward plan.
            selectedmethod.index = isReplan ? 0 : selectedmethod.index; // reset index on replan
            selectedmethod.rewardsChosenPlan = getPlanID(plan);
        });
    }
};

/**
 * UI related operations to be performed on de-select.
 *
 * @param {*} plan
 * @param {*} selectedmethod
 */
var clearSelectedPlan = exports.clearSelectedPlan = function clearSelectedPlan(plan, selectedmethod) {
    var hasPlanSelected = selectedmethod && selectedmethod.rewardsChosenPlan === getPlanID(plan);

    if (hasPlanSelected) {
        delete selectedmethod.rewardsChosenPlan;
    }
};

/**
 * Returns the primaryFI for multi-fi use case
 * else returns the first FI for single FI use case
 *
 * @param {*} plan
 * @returns {*} fiPayload
 */
var getPrimaryFI = exports.getPrimaryFI = function getPrimaryFI(plan) {
    // TODO: return '' instead of {}
    if (!plan || !getPlanID(plan)) {
        return {};
    }
    var firstPlanFi = plan && plan.sources && plan.sources[plan.sources.length - 1];
    var fi = plan && plan.primaryFs || firstPlanFi || {};

    fi.instrument_id = fi.instrument_id || fi.id;
    return fi;
};

/**
 *  Given a planId it returns a complete plan object
 *
 * @param {*} checkoutSession
 * @param {*} planId
 * @returns
 */
var getPlanFromId = exports.getPlanFromId = function getPlanFromId(checkoutSession, planId) {
    var matchingPlans = _squid.$util.filter(checkoutSession.fundingOptions.plans, function (plan) {
        if (getPlanID(plan) === planId) {
            return plan;
        }
    });

    return matchingPlans && matchingPlans.length > 0 ? matchingPlans[0] : '';
};

/**
 * Returns the initial value to use considering
 * cart amount and rewards availability
 *
 * @param {*} models
 * @param {*} rewardsPayload
 * @returns
 */
var getInitialRewardsValue = exports.getInitialRewardsValue = function getInitialRewardsValue(models, rewardsPayload) {
    // TODO: Consider relying only on PAPS amount for initial value.
    // It would help with page refresh use case.
    var constraint = rewardsPayload.rewards_constraint;
    var grossTotal = toNumber(models.checkoutCart.purchase.amounts.total.amount, 2);

    if (!constraint.maximum_usable) {
        return grossTotal;
    }
    var maximumUsuableRewards = toNumber(constraint.maximum_usable.value);
    var initialValue = grossTotal < maximumUsuableRewards ? grossTotal : maximumUsuableRewards;

    return initialValue;
};

/**
 *  Checks if the plan has PayPal balance in it
 *
 * @param {*} plan
 */
var isPayPalBalanceSelected = exports.isPayPalBalanceSelected = function isPayPalBalanceSelected() {
    var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // TODO: should default initialize to {} or error handle ?
    var sources = plan.sources || plan.secondaryFIs || [];

    return sources.some(function (source) {
        return source.type === 'BALANCE';
    });
};

/**
 * Return the current selected plan id.
 * Prioritize clickSelectedPlanID
 * over sessionSelectedPlanID
 *
 * @param {*} selectedmethod
 * @param {*} checkoutSession
 * @returns {*} planID
 */
var getSelectedPlan = exports.getSelectedPlan = function getSelectedPlan(selectedmethod, checkoutSession) {
    var clickSelectedPlanID = selectedmethod && selectedmethod.planId;
    var sessionSelectedPlan = checkoutSession && checkoutSession.plan || {};
    var sessionSelectedPlanID = getPlanID(sessionSelectedPlan);
    var selectionID = selectedmethod ? clickSelectedPlanID // Radio checkbox selection
    : sessionSelectedPlanID; // selectFI use-case, session selection

    return selectionID;
};

/**
 * Given some contraints and a checkoutSession, return the plan that matches exactly
 * TODO: HANDLE BALANCE PROPERLY
 * @param {String} instrumentId
 * @param {String} balance The currency code of the balance to be used
 * @param {Boolean} rewards Whether to use the rewards plan or not
 * @returns {String} planId of the plan to select
 */
var matchPlanFromConstraints = exports.matchPlanFromConstraints = function matchPlanFromConstraints(_ref) {
    var instrumentId = _ref.instrumentId,
        balance = _ref.balance,
        rewards = _ref.rewards,
        checkoutSession = _ref.checkoutSession;

    return checkoutSession.get('fundingOptions.plans', []).find(function (plan) {
        var idMatches = plan.primaryFs.id === instrumentId;
        var planHasBalance = plan.secondaryFIs && plan.secondaryFIs.length;
        var balanceMatches = balance && planHasBalance || !balance && !planHasBalance;
        var rewardsMatches = rewards && plan.rewards || !rewards && !plan.rewards;

        if (!idMatches || !balanceMatches || !rewardsMatches) {
            return false;
        }

        return plan;
    });
};

_angular.$rootScope;

_squid.$util;

_squid.$locale;

_squid.formatCurrency;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoShowMoreFiLink = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-ui-components/src/link/directive.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _template = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShowMoreFiLink = exports.$xoShowMoreFiLink = _squid.$Component.extend('$xoShowMoreFiLink', {
    tag: 'xo-show-more-fi-link',
    template: _template2['default'],
    actions: {
        showMore: function showMore() {
            _factory.$ShowMoreFiFactory.set({ isShowMoreBtnClicked: true });
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'process_3fi'
            });
        }
    },
    lifecycle: {
        enter: function enter() {}
    }
});

angular.value("$xoShowMoreFiLink", $xoShowMoreFiLink);
_squid.$Component;

_logger.$logger;

_factory.$ShowMoreFiFactory;

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _index = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$ShowMoreFiFactory', function () {
    var state = {
        isTooManyFi: false,
        isShowMoreBtnClicked: false,
        eligible: false
    };

    var get = function get() {
        return state;
    };
    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    // max number of FI to be shown by default
    // if user has <= 4 -- all 4 FI will be shown
    // if user has > 4 -- 3 FI will be shown
    var MAX_FI_NUMBER = 4;

    // condition to determine if there are too many FI's
    // to hide them and display "Show More" link
    var isTooManyFi = function isTooManyFi() {
        var planList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return planList.length > MAX_FI_NUMBER;
    };

    // when logout -> reset flag
    _angular.$rootScope.$on('logout', function (event, args) {
        state.isShowMoreBtnClicked = false;
    });

    // returns true if:
    // 1) there are too many FI's
    // 2) "Show more" link was not clicked yet
    var isFiNeverExpanded = function isFiNeverExpanded() {
        return !state.isShowMoreBtnClicked && state.isTooManyFi;
    };

    var init = function init(planList) {
        if (!state.eligible) {
            return;
        }
        state.isTooManyFi = isTooManyFi(planList);
        if (isFiNeverExpanded()) {
            _logger.$logger.info('checkout_fpti', {
                from: '3fi',
                to: 'prepare_3fi'
            });
        }
    };

    // eligible if:
    // 1. multi fi
    // 2. 3fi pxp returns treatment
    var decideEligibility = function decideEligibility(_ref) {
        var plans = _ref.plans;

        if (!isTooManyFi(plans)) {
            return;
        }

        return _index.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            if (multipleFiVariants.indexOf(variant) !== -1) {
                _logger.$logger.info('show_more_fi_true_choice_eligibility');
                state.eligible = true;
            }
        });
    };

    // used to show / hide individual fi entry of the plan list
    // index - selected radio box index starting from 0
    var shouldHideFiEntry = function shouldHideFiEntry(index) {
        return isFiNeverExpanded() && index + 1 > MAX_FI_NUMBER - 1;
    };

    // event handler for accessibility
    // if current index is 0 and user press UP - expand FI's
    // if current index is one which goes before the last visible one
    var selectFiOnKeyDown = function selectFiOnKeyDown(event, index) {
        if (index === 0 && event.keyCode === _ui.KEYS.UP || index + 1 >= MAX_FI_NUMBER - 2 && event.keyCode === _ui.KEYS.DOWN) {
            state.isShowMoreBtnClicked = true;
        }
    };

    return {
        get: get,
        set: set,
        init: init,
        isFiNeverExpanded: isFiNeverExpanded,
        decideEligibility: decideEligibility,
        shouldHideFiEntry: shouldHideFiEntry,
        selectFiOnKeyDown: selectFiOnKeyDown
    };
});

_angular.$rootScope;

_squid.$util;

_squid.$config;

_logger.$logger;

_ui.KEYS;

_index.$ChoiceEligibility;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-member-components/src/show-more-fi", "../node_modules/xo-member-components/src/show-more-fi/factory.js"))

/***/ }),

/***/ "../node_modules/xo-member-components/src/show-more-fi/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-link content label=\"{{ content('common.showMoreFi') }}\" on-click=\"actions.showMore\" left-icon=\"caret-down\"></xo-link>"

/***/ }),

/***/ "../node_modules/xo-member-components/src/vaulting/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.authorize = exports.checkVaultingEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

/**
 *  checks if the current user is eligible
 *  for vaulting based on PXP
 *
 * @returns {Promise} Represents current vaulting treatment
 */
var checkPxp = function checkPxp() {
    return (0, _squid.$elmo)('xo_hermes_vaulting', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermes_vaulting_1').then(function (result) {
        return result && result.treatment_name;
    });
};

/**
 *  Checks weather a specific set of use cases are enabled/disabled.
 *
 * @returns {Object} Represents list of eligibility flags
 */
// eslint-disable-line no-unused-vars
var getEligibility = function getEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _index.$CheckoutCartModel.instance(token),
        checkoutSession: _index.$CheckoutSessionModel.instance(token),
        checkoutAppData: _index.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var hasBackupFunding = models.checkoutSession.cardBackup && models.checkoutSession.cardBackup.getPlan() && models.checkoutSession.cardBackup.getPlan().planId;

        return {
            billing: models.checkoutCart.isBilling(),
            invoice: models.checkoutAppData.get('flags.is_invoice_flow'),
            upop: models.checkoutSession.unconfirmed_upop,
            walletTokenization: models.checkoutCart.isWalletTokenization(),
            threeDS: models.checkoutSession.resolve_3ds,
            sepa: models.checkoutSession.get('sepa_mandate.bankId'),
            negativeBalance: models.checkoutSession.negBals,
            poma: models.auth.password_less,
            isXoonUpopRedirect: _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon',
            miniBrowser: _angular.$rootScope.miniBrowser,
            secondButtonCredit: models.checkoutAppData.isSecondButton(),
            hasBackupFunding: hasBackupFunding
        };
    });
};

/**
 * Checks to see whether the current vaulting experience is eligible.
 * return  the current experience based flow and pxp
 *
 * @returns {Promise} Represents current vaulting experience
 */
var checkVaultingEligibility = exports.checkVaultingEligibility = function checkVaultingEligibility() {
    var isCorp = _squid.$meta.corp;
    var isVaultFlow = _squid.$util.param('vault');

    if (isCorp && isVaultFlow === 'true') {
        _logger.$logger.info('xo_hermes_vaulting_eligibility_forced', {
            isCorp: isCorp, isVaultFlow: isVaultFlow
        });
        return _squid.$promise.resolve(isVaultFlow);
    }
    return getEligibility().then(function (eligibility) {
        // Define an explicit check since it makes the eligibility more easier to reference
        var decision = !eligibility.billing && !eligibility.invoice && !eligibility.upop && !eligibility.walletTokenization && !eligibility.threeDS && !eligibility.sepa && !eligibility.negativeBalance && !eligibility.poma && !eligibility.isXoonUpopRedirect && !eligibility.miniBrowser && !eligibility.secondButtonCredit && !eligibility.hasBackupFunding;

        _logger.$logger.info('xo_hermes_vaulting_eligibility', {
            eligibility: eligibility,
            decision: decision
        });
        return decision ? checkPxp() : _squid.$promise.resolve('');
    });
};

/**
 * Given an error use cases handles logging
 * and functionality
 *
 * @param {*} name of error
 * @param {*} err Error object
 * @param {*} type 'contingency' or 'error'
 */
var errorHandler = function errorHandler(name, err, type) {
    _logger.$logger.info('xo_hermes_vaulting_authorize_' + type, { name: name });
    throw err;
};

/**
 * Performs an authorize on checkout and returns a response
 *
 * @param {*} checkoutSession
 * @param {*} checkoutAppData
 * @returns {String} Representing next state
 */
var authorize = exports.authorize = function authorize(checkoutSession, checkoutAppData) {
    _logger.$logger.info('xo_hermes_vaulting_authorize_attempt');
    _angular.$rootScope.$emit('loadingMessage', 'Vaulting through checkout.');
    var cardBackup = checkoutSession.cardBackup && checkoutSession.cardBackup.getPlan();

    return checkoutSession.action('authorize', {
        data: {
            alternateFundingOptionId: cardBackup && cardBackup.planId
        },
        success: function success(result) {
            _logger.$logger.info('xo_hermes_vaulting_authorize_success');
            if (!window.xchild && checkoutAppData.doec_on_approve()) {
                return 'checkout.pay';
            }
            return 'checkout.end';
        },
        contingencies: function contingencies(name, err) {
            return errorHandler(name, err, 'contingency');
        },
        error: function error(name, err) {
            return errorHandler(name, err, 'error');
        }
    });
};
_angular.$rootScope;

_logger.$logger;

_squid.$locale;

_squid.$util;

_squid.$elmo;

_squid.$promise;

_squid.$populate;

_squid.$meta;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPBlacklist = exports.$TokenizedWalletMsbOfferModel = exports.$TokenizedWalletPinModel = exports.$TokenizedFundingCapabilitiesModel = exports.$TokenizedWalletInfoModel = exports.$TokenizedWalletEligibilityModel = exports.$MessengerIntegrationDataModel = exports.$AppDataModel = exports.$LocaleConfigModel = exports.$PXPModel = exports.$TeslaFlowIdModel = undefined;

var _brandNames, _msbDisclaimerLinks;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $TeslaFlowIdModel = exports.$TeslaFlowIdModel = _squid.$Model.extend('$TeslaFlowIdModel', {
    api: new _squid.$Api({
        uri: '/api/teslaFlowId/:id'
    })
});

var $PXPModel = exports.$PXPModel = _squid.$Model.extend('$PXPModel', {
    api: new _squid.$Api({
        uri: '/api/pxp/:id'
    })
});

var $LocaleConfigModel = exports.$LocaleConfigModel = _squid.$Model.extend('$LocaleConfigModel', {
    api: new _squid.$Api({
        uri: '/api/localeConfig'
    })
});

var $AppDataModel = exports.$AppDataModel = _squid.$Model.extend('$AppDataModel', {
    api: new _squid.$Api({
        uri: '/api/app'
    }),

    isMobile: function isMobile() {
        return this.platform === 'mobile';
    }
});

var $MessengerIntegrationDataModel = exports.$MessengerIntegrationDataModel = _squid.$Model.extend('$MessengerIntegrationDataModel', {
    api: new _squid.$Api({
        uri: '/api/messenger'
    })
});

var $TokenizedWalletEligibilityModel = exports.$TokenizedWalletEligibilityModel = _squid.$Model.extend('$TokenizedWalletEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/eligibility/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    isEligible: function isEligible() {
        return this.eligible;
    }
});

var subjectTypes = {
    SAMSUNG_PAY: 'Samsung',
    ANDROID_PAY: 'google'
};

var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

/**
 * disclaimer links used on the *pay review page
 */
var disclaimerLinks = function disclaimerLinks(country) {
    var _ref;

    return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppsamsungpay-tnc', _ref[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppandroidpay-tnc', _ref;
};

// disclaimer links used on Msb offer popup
var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

/**
 * this model populates data from tokenized wallet mayfly object
 * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
 *
 * - wallet_id (used for both Samsung Pay and Android Pay)
 * - external_device_id (used for Samsung Pay only)
 * - subject (used for both Samsung Pay and Android Pay)
 *
 * Note: model is being populated in xo-preload on the server (see config.json)
 */

var $TokenizedWalletInfoModel = exports.$TokenizedWalletInfoModel = _squid.$Model.extend('$TokenizedWalletInfoModel', {

    api: new _squid.$Api({
        uri: '/api/info/tokenizedWallet/:id'
    }),

    isAndroidPay: function isAndroidPay() {
        return this.subject === subjectTypes.ANDROID_PAY;
    },

    isSamsungPay: function isSamsungPay() {
        return this.subject === subjectTypes.SAMSUNG_PAY;
    },

    getSubject: function getSubject() {
        return this.subject || subjectTypes.ANDROID_PAY;
    },

    // until we use mayfly for android pay - fallback to Android Pay
    brandName: function brandName() {
        return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
    },

    // until we use mayfly for android pay - fallback to Android Pay
    getDisclaimerLink: function getDisclaimerLink() {
        var country = _squid.$locale.country.toLowerCase();

        return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
    },

    // get Msb terms and conditions link based on the subject
    getMsbDisclaimerLink: function getMsbDisclaimerLink() {
        return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
    }
});

var $TokenizedFundingCapabilitiesModel = exports.$TokenizedFundingCapabilitiesModel = _squid.$Model.extend('$TokenizedFundingCapabilitiesModel', {
    api: new _squid.$Api({
        uri: '/api/capabilities/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true,

    isDirectFundingEnabled: function isDirectFundingEnabled() {
        return this.directFundingEnabled;
    },

    isTopupEnabled: function isTopupEnabled() {
        return this.topupFundingEnabled;
    },
    getProductName: function getProductName() {
        return this.name;
    },

    getCurrency: function getCurrency() {
        return this.issuingCurrency;
    },

    getContingencies: function getContingencies() {
        return this.contingencies;
    },

    getTopupAmountChoices: function getTopupAmountChoices() {
        return this.topUpAmountChoices;
    }
});

var $TokenizedWalletPinModel = exports.$TokenizedWalletPinModel = _squid.$Model.extend('$TokenizedWalletPinModel', {
    api: new _squid.$Api({
        uri: '/api/pin/tokenizedWallet/:id'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    getPinOrigin: function getPinOrigin() {
        return this.pinOrigin;
    },
    getSuggestedPin: function getSuggestedPin() {
        return this.suggestedPin;
    },
    getSuggestedKey: function getSuggestedKey() {
        return this.suggestedKey;
    },
    getPinId: function getPinId() {
        return this.pinId;
    },
    isPinIdPresent: function isPinIdPresent() {
        return !!this.pinId;
    },
    isSetupEligible: function isSetupEligible() {
        return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
    }
});

var $TokenizedWalletMsbOfferModel = exports.$TokenizedWalletMsbOfferModel = _squid.$Model.extend('$TokenizedWalletMsbOfferModel', {
    api: new _squid.$Api({
        uri: '/api/msb/tokenizedWallet/:id'
    }),
    invalidateOnLogout: true
});

var $PXPBlacklist = exports.$PXPBlacklist = {
    isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
        return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
    }
};

angular.value("$TeslaFlowIdModel", $TeslaFlowIdModel);
angular.value("$PXPModel", $PXPModel);
angular.value("$LocaleConfigModel", $LocaleConfigModel);
angular.value("$AppDataModel", $AppDataModel);
angular.value("$MessengerIntegrationDataModel", $MessengerIntegrationDataModel);
angular.value("$TokenizedWalletEligibilityModel", $TokenizedWalletEligibilityModel);
angular.value("$TokenizedWalletInfoModel", $TokenizedWalletInfoModel);
angular.value("$TokenizedFundingCapabilitiesModel", $TokenizedFundingCapabilitiesModel);
angular.value("$TokenizedWalletPinModel", $TokenizedWalletPinModel);
angular.value("$TokenizedWalletMsbOfferModel", $TokenizedWalletMsbOfferModel);
angular.value("$PXPBlacklist", $PXPBlacklist);
_squid.$config;

_squid.$locale;

_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    })
});

var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    loggedIn: function loggedIn() {
        return this.logged_in;
    },

    isOnetouchULRedirect: function isOnetouchULRedirect() {
        return this.is_onetouch_ul_redirect;
    },

    visitorId: function visitorId() {
        return this.visitor_id;
    },

    accessToken: function accessToken() {
        return this.access_token;
    },

    accessTokenPresent: function accessTokenPresent() {
        return this.access_token_present;
    },

    refreshToken: function refreshToken() {
        return this.refresh_token;
    },

    rememberedOT: function rememberedOT() {
        return this.remembered && this.remembered_device_token;
    },

    isSessionTimeout: function isSessionTimeout() {
        return this.meta && this.meta.invalidated;
    },

    clearCookies: function clearCookies() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.action('clearCookies', { data: data });
    },

    isFBSkipLogin: function isFBSkipLogin() {
        /* Facebook pass the code generated in checkout URL , check for to determine it as FB Skip Login
         * if both OneTouch cookie present and if code passed by FB, login usually happens using OneTouch
         * as both are having auth state as remembered, we may look for rememberedOT as it is having remembered_device_token
         * for OneTouch identifier to differentiate both logins
         * auth_claims for OneTouch is DEVICE_TOKEN
         */
        return this.remembered && _squid.$util.param('code') && !this.rememberedOT();
    },

    showNotYou: function showNotYou() {
        var isAuthApiCall = this.is_auth_api_call;
        var isConsumerApp = _squid.$util.param('source') === 'consumerApp';
        var redirectToHermesOn3DSDecline = _squid.$util.param('redirectToHermesOn3DSDecline');
        var isUlReturnLoggedIn = _squid.$util.param('ulReturn') && this.auth_state === 'LOGGEDIN';

        // for Tokenized Venice integraion (Google Pay Venice / Samsung Pay Venice) - `not you` link should be hidden.
        // `TokenizedWalletInfoModel` is always populated in xo-preload (even for error cases - it will be just empty)
        // so we don't need to retrieve the model
        var tokenizedWalletInfo = _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token);
        var isNotVeniceTokenizedIntegration = function isNotVeniceTokenizedIntegration() {
            return !tokenizedWalletInfo || tokenizedWalletInfo && !tokenizedWalletInfo.is_venice_integration;
        };
        var isGuestVenmoAcct = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token) && this.auth_state === 'IDENTIFIED';

        // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)
        return (isAuthApiCall || this.isFBSkipLogin()) && !isConsumerApp && !redirectToHermesOn3DSDecline && !isUlReturnLoggedIn && !this.disallow_login_switch && isNotVeniceTokenizedIntegration() && !isGuestVenmoAcct;
    },

    logout: function logout() {
        _squid.$Model.bulkInvalidate('invalidateOnLogout');
        _angular.$rootScope.$broadcast('logout');
        return this.action('logout');
    },

    /**
     * Perform a logout and then redirect.
     * @param reason - used to log reason why a redirect was trigged.
     */
    logoutAndRedirect: function logoutAndRedirect() {
        var _this = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'logout';

        var logoutFrom = this.get('tenant', 'PAYPAL');
        return this.logout().then(function () {
            return _this.redirectToLogin(reason, { logoutFrom: logoutFrom });
        });
    },

    // redirect to UL as landing through xo-landing-router
    // so first it hits hermes app and then redirects to UL
    redirectToLogin: function redirectToLogin(reason, ctx) {
        if (!reason) {
            return false;
        }
        // current query parameters
        var qs = _squid.$util.queryString() || '';
        var params = { 'ulClientRedirect': reason };

        params = _squid.$util.extend(params, ctx); // update params with context that may be sent

        // insert "ulClientRedirect" param and remove "ul", "ulReturn"
        var updatedQs = _squid.$util.queryStringSplice(qs, params, ['ul', 'ulReturn']);

        // base url should not be hardcoded to "/webapps/hermes" due to other use cases such as
        // 1. * Pay (Android Pay / Samsung Pay) -- uses /agreements/setup to exchange BA token to EC token
        var ulAsLandingUrl = _squid.$util.paypalURL('' + window.location.pathname + updatedQs);

        _logger.$logger.info('redirecting_to_ulAsLanding');
        return _squid.$util.redirect(ulAsLandingUrl);
    }

});

var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
    api: new _squid.$Api({
        uri: '/api/auth/ulogin',
        postAttempts: 1,
        cache: false
    })
});

angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_angular.$rootScope;

_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/bml/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$BMLApplicationModel = exports.$BMLModel = exports.$ApplyForBMLModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ApplyForBMLModel = exports.$ApplyForBMLModel = _squid.$Model.extend('$ApplyForBMLModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    personalInformation: {
        day: '',
        month: '',
        year: '',
        natId: '',
        phone: {
            telephone: '',
            phoneType: ''
        }
    },

    billingAdrress: {
        phoneType: '',
        phoneNumber: ''
    }
});

var $BMLModel = exports.$BMLModel = _squid.$Model.extend('$BMLModel', {
    api: new _squid.$Api({
        uri: '/api/bml',
        cache: false
    }),

    applicationStatus: function applicationStatus() {
        return this.application_status;
    },

    applicationId: function applicationId() {
        return this.application_id;
    }
});

var $BMLApplicationModel = exports.$BMLApplicationModel = _squid.$Model.extend('$BMLApplicationModel', {
    api: new _squid.$Api({
        uri: '/api/bml/:application_id',
        cache: false
    })
});

angular.value("$ApplyForBMLModel", $ApplyForBMLModel);
angular.value("$BMLModel", $BMLModel);
angular.value("$BMLApplicationModel", $BMLApplicationModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CheckoutSessionModel = exports.$CardBackupModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.serializeInstallmentsOptionsData = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _processorDecline = __webpack_require__("../node_modules/xo-models/src/processorDecline/index.js");

var _utils = __webpack_require__("../node_modules/xo-models/src/checkout/lib/utils.js");

var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    isPurchase: function isPurchase() {
        return Boolean(this.purchase);
    },

    getCartCurrencyCode: function getCartCurrencyCode() {
        return _squid.$util.getProperty(this, 'purchase.amounts.total.currency_code');
    },

    // NOTE returns undefined if this is not a purchase or there is some other error
    getPurchaseAmount: function getPurchaseAmount() {
        if (!this.isPurchase()) {
            return;
        }
        var purchaseAmount = _squid.$util.getProperty(this, 'purchase.amounts.total.amount');
        var purchaseAmountFloat = parseFloat(purchaseAmount);

        return purchaseAmountFloat || undefined;
    },

    isBilling: function isBilling() {
        return Boolean(this.billing);
    },

    isReferenceTransaction: function isReferenceTransaction() {
        if (this.isBilling() && this.billing.type) {
            var isChannelInitiatedBilling = this.billing.type === 'CHANNEL_INITIATED_BILLING';
            var isMerchantInitiatedBilling = this.billing.type === 'MERCHANT_INITIATED_BILLING';
            var isMerchantInitiatedSingleBilling = this.billing.type === 'MERCHANT_INITIATED_SINGLE_BILLING';

            // isReferenceTransaction() function will return true , if any of isChannelInitiatedBilling , isMerchantInitiatedBilling ,  isMerchantInitiatedSingleBilling is true
            return isChannelInitiatedBilling || isMerchantInitiatedBilling || isMerchantInitiatedSingleBilling;
        }
        return false;
    },

    isConsumerCountry: function isConsumerCountry(country) {
        return _squid.$locale.country === country;
    },

    isRecurringPayment: function isRecurringPayment() {
        if (this.isBilling() && this.billing.type) {
            return this.billing.type === 'RECURRING_PAYMENTS';
        }
        return false;
    },

    isChargePatternImmediateOrDeferred: function isChargePatternImmediateOrDeferred() {

        return ['IMMEDIATE', 'DEFERRED'].includes(this.billing.charge_pattern);
    },

    isSubscriptionsV1: function isSubscriptionsV1() {
        return this.isBilling() && this.billing.type === 'SUBSCRIPTIONS_V1';
    },

    getBaToken: function getBaToken() {
        return this.isBilling() && this.billing.ba_token;
    },

    isBillingPurchase: function isBillingPurchase() {
        return this.isPurchase() && this.isBilling();
    },

    isBillingNoPurchase: function isBillingNoPurchase() {
        return this.isBilling() && !this.isPurchase();
    },

    getBillingDescription: function getBillingDescription() {
        return this.billing && this.billing.description;
    },

    isMultiSellerPurchase: function isMultiSellerPurchase() {
        return this.purchaseUnits && this.purchaseUnits.length > 1;
    },

    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
        return this.isPurchase() && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
    },

    isWalletTokenization: function isWalletTokenization() {
        return this.isBilling() && this.billing.intent === 'TOKENIZED_WALLET';
    },

    getExternalCallbackOptions: function getExternalCallbackOptions() {
        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
    }
});

var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/appData'
    }),

    useraction: function useraction() {
        // user_action from session takes precedence over CGI param.
        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;

        return rest_integration || incontext_integration || _squid.$util.param('useraction');
    },

    is_wps_flow: function is_wps_flow() {
        return this.flags && this.flags.is_wps_flow;
    },

    isMerchantCountry: function isMerchantCountry(country) {
        return this.merchant.merchant_country === country;
    },

    is_snt_supported: function is_snt_supported() {
        return this.flags && this.flags.is_snt_supported;
    },

    doec_on_approve: function doec_on_approve() {
        return this.flags && this.flags.doec_on_approve;
    },

    is_wps_subscription_flow: function is_wps_subscription_flow() {
        return this.flags && this.flags.is_wps_subscription_flow;
    },

    isWpsAutobillingFlow: function isWpsAutobillingFlow() {
        return this.flags && this.flags.is_wps_autobilling_flow;
    },

    is_wps_installmentplan_flow: function is_wps_installmentplan_flow() {
        return this.flags && this.flags.is_wps_installmentplan_flow;
    },

    /*
     * Returns a string or undefined value
     * nonEmptyReturnValue - if true, then always return non empty string
     * isSentenceBeginning - if true, and merchant brand_name and merchant_name is undefined
     *              then returns 'The merchant'. If false, returns 'the merchant'
     * NOTE: We should not return merchant_email for any reason as it is a PII
     */
    getMerchantDisplayName: function getMerchantDisplayName() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            nonEmptyReturnValue = _ref.nonEmptyReturnValue,
            isSentenceBeginning = _ref.isSentenceBeginning,
            getContent = _ref.getContent;

        var merchantName = this.merchant.brand_name || this.merchant.merchant_name;

        if (nonEmptyReturnValue) {
            var contentKey = isSentenceBeginning ? 'common.Themerchant' : 'common.themerchant';
            var merchantAltName = getContent ? getContent(contentKey) : _squid.$locale.content.get(contentKey);

            return merchantName || merchantAltName;
        }

        return merchantName;
    },

    isInvoiceFlow: function isInvoiceFlow() {
        return Boolean(this.flags && this.flags.is_invoice_flow);
    },


    // Returns true if flow should be treated as a second button (PP Credit) transaction
    isSecondButton: function isSecondButton() {
        return this.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
    }
});

var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {

    formatLast4: function formatLast4() {
        var last4;

        if (this.last4) {
            last4 = this.last4;

            if (!this.parent.isAuthRequired) {
                last4 = 'x-' + last4;
            }
        }

        return last4;
    }
});

var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/fundingOptions',
        postAttempts: 2
    }),

    eachPlan: function eachPlan(method, context) {
        angular.forEach(this.plans, method, this);
    },

    hasECheck: function hasECheck() {
        var _instruments = this.instruments,
            instruments = _instruments === undefined ? [] : _instruments;


        return instruments.some(function (instr) {
            return instr.type === 'ECHECK' || instr.subtype === 'ECHECK';
        });
    },

    hasCredit: function hasCredit() {
        var _instruments2 = this.instruments,
            instruments = _instruments2 === undefined ? [] : _instruments2;


        return instruments.some(function (instrument) {
            return instrument.type === 'CREDIT';
        });
    },

    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
        });

        return fundingInstrument && fundingInstrument.planId;
    },

    // get IACH and PAD banks combined by plan.primaryFs.id
    // order matters, so if IACH comes first then PAD is filtered and vise versa
    getPadAndIachCombinedPlans: function getPadAndIachCombinedPlans() {
        var _this = this;

        var plans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.plans;

        if (!plans) {
            return [];
        }
        var planIds = {};

        plans.forEach(function (plan) {
            var planId = plan.planId,
                primaryFs = plan.primaryFs;


            if (_this.isIACH(plan) && !planIds[planId]) {
                planIds[primaryFs.padPlanId] = true;
            }
            if (_this.isPAD(plan) && !planIds[planId]) {
                planIds[primaryFs.iachPlanId] = true;
            }
        });

        return plans.filter(function (plan) {
            return !planIds[plan.planId];
        });
    },

    // get plan by planId
    getPlanByPlanId: function getPlanByPlanId(id) {
        var plan = _squid.$util.find(this.plans, function (p) {
            return p.primaryFs && p.planId === id;
        });

        return plan;
    },

    getPlanSubType: function getPlanSubType() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _plan$primaryFs = plan.primaryFs;
        _plan$primaryFs = _plan$primaryFs === undefined ? {} : _plan$primaryFs;
        var subtype = _plan$primaryFs.subtype;


        return subtype;
    },


    // is plan PAD bank (bank is charged after some delay)
    isPAD: function isPAD(plan) {
        return this.getPlanSubType(plan) === 'PAD';
    },


    // is plan IACH bank (instant transfer)
    isIACH: function isIACH(plan) {
        return this.getPlanSubType(plan) === 'IACH';
    },


    // is plan MEFT bank
    isMEFT: function isMEFT(plan) {
        return this.getPlanSubType(plan) === 'MEFT';
    },


    // is plan IACH bank (instant transfer)
    isIACHWithPad: function isIACHWithPad(plan) {
        return this.isIACH(plan) && plan.primaryFs.padPlanId;
    },

    // is plan PayPal Credit (a.k.a BILL_ME_LATER)
    isPayPalCredit: function isPayPalCredit(plan) {
        return plan && plan.primaryFs.type === 'CREDIT' && plan.primaryFs.name === 'BILL_ME_LATER';
    },


    // get PAD hop date (when bank will be charged) based on selected plan and PAD toggle state
    getPadPlanHopDate: function getPadPlanHopDate(plan) {
        if (this.isIACH(plan)) {
            var padPlan = this.getPlanByPlanId(plan.primaryFs.padPlanId);

            if (padPlan) {
                return padPlan.primaryFs.hop_date;
            }
        } else {
            return plan.primaryFs.hop_date;
        }
    },

    // get PAD or IACH plan id based on selected plan and PAD toggle state
    getPadOrIachPlanIdBySelectedPlan: function getPadOrIachPlanIdBySelectedPlan(_ref2) {
        var plan = _ref2.plan,
            isPadToggleSelected = _ref2.isPadToggleSelected;

        if (!plan || !plan.primaryFs) {
            return;
        }

        var _plan$primaryFs2 = plan.primaryFs,
            padPlanId = _plan$primaryFs2.padPlanId,
            iachPlanId = _plan$primaryFs2.iachPlanId,
            planId = plan.planId;


        if (isPadToggleSelected) {
            return this.isPAD(plan) ? planId : padPlanId;
        } else {
            return this.isIACH(plan) ? planId : iachPlanId;
        }
    },

    onPopulate: function onPopulate() {
        var self = this;

        angular.forEach(this.plans, function (plan) {
            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
                    enumerable: true,
                    configurable: false,
                    writeable: false,
                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
                });
            }
        });
    },

    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(fsId, fsSubtype) {
        var bankPadPlan = _squid.$util.find(this.plans, function () {
            var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _plan$primaryFs3 = plan.primaryFs;
            _plan$primaryFs3 = _plan$primaryFs3 === undefined ? {} : _plan$primaryFs3;
            var id = _plan$primaryFs3.id,
                type = _plan$primaryFs3.type,
                subtype = _plan$primaryFs3.subtype;


            return id === fsId && type === 'BANK' && subtype === fsSubtype;
        });

        if (!bankPadPlan) {
            return;
        }

        var _bankPadPlan$primaryF = bankPadPlan.primaryFs;
        _bankPadPlan$primaryF = _bankPadPlan$primaryF === undefined ? {} : _bankPadPlan$primaryF;
        var subtype = _bankPadPlan$primaryF.subtype,
            padPlanId = _bankPadPlan$primaryF.padPlanId,
            iachPlanId = _bankPadPlan$primaryF.iachPlanId;


        return subtype === 'IACH' ? padPlanId : iachPlanId;
    },


    isPadToggleApplicable: function isPadToggleApplicable() {
        var padToggleApplicable = false;

        this.eachPlan(function (plan) {
            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
                }
            }
        }, this);

        return padToggleApplicable;
    },

    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
        var padToggleApplicable = false;
        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
            return plan.planId === planId;
        });

        if (selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
            padToggleApplicable = true;
        }

        return padToggleApplicable;
    },

    getPreferred: function getPreferred() {
        var _this2 = this;

        return _squid.$util.find(this.plans, function (plan) {
            return _this2.isPreferred(plan);
        });
    },

    isPreferred: function isPreferred() {
        var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.isPAD(plan)) {
            // if the current plan is PAD -> find corresponding IACH plan to see if it's preferred
            var iachPlan = this.getPlanByPlanId(plan.primaryFs.iachPlanId) || {};
            var _iachPlan$primaryFs = iachPlan.primaryFs;
            _iachPlan$primaryFs = _iachPlan$primaryFs === undefined ? {} : _iachPlan$primaryFs;

            var _iachPlan$primaryFs$i = _iachPlan$primaryFs.isPreferred,
                _isPreferred = _iachPlan$primaryFs$i === undefined ? false : _iachPlan$primaryFs$i;

            return _isPreferred;
        }

        var _plan$primaryFs4 = plan.primaryFs;
        _plan$primaryFs4 = _plan$primaryFs4 === undefined ? {} : _plan$primaryFs4;
        var _plan$primaryFs4$isPr = _plan$primaryFs4.isPreferred,
            isPreferred = _plan$primaryFs4$isPr === undefined ? false : _plan$primaryFs4$isPr;


        return isPreferred;
    },

    // get Merchant specific balance by plan id
    getMsbByPlanId: function getMsbByPlanId(planId) {
        var plan = this.getPlanByPlanId(planId);

        return plan && plan.incentive;
    },

    /**
     * Avoid plans that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayPlans: function getDisplayPlans() {
        // return type should be undefined in no plans
        // for billing agreement use case
        return this.plans ? this.plans.filter(function (plan) {
            return !plan.rewards;
        }) : this.plans;
    },
    /**
     * Avoid instruments that are not meant for display on the UI.
     * - Hide Rewards
     */
    getDisplayInstruments: function getDisplayInstruments() {
        var _instruments3 = this.instruments,
            instruments = _instruments3 === undefined ? [] : _instruments3;


        return instruments.filter(function (instrument) {
            return instrument.type !== 'REWARDS';
        });
    }
});

// Map the data needed for the installmentsOptions endpoint
var serializeInstallmentsOptionsData = exports.serializeInstallmentsOptionsData = function serializeInstallmentsOptionsData(_ref3) {
    var merchant_country = _ref3.checkoutAppData.merchant.merchant_country,
        checkoutCart = _ref3.checkoutCart,
        country = _ref3.country,
        id = _ref3.payee.merchant.id,
        isMemberCredit = _ref3.isMemberCredit,
        cc = _ref3.cc;

    var payload = {
        checkoutAppData: {
            merchant: {
                merchant_country: merchant_country
            }
        },
        checkoutCart: {},
        country: country,
        payee: {
            merchant: {
                id: id
            }
        },
        isMemberCredit: isMemberCredit,
        cc: cc
    };

    if (checkoutCart.purchase && checkoutCart.purchase.amounts) {
        var _checkoutCart$purchas = checkoutCart.purchase.amounts.total,
            amount = _checkoutCart$purchas.amount,
            currency_code = _checkoutCart$purchas.currency_code;


        payload.checkoutCart.purchase = {
            amounts: {
                total: {
                    amount: amount,
                    currency_code: currency_code
                }
            }
        };
    }

    return payload;
};

var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    save: function save(options) {
        options.data = serializeInstallmentsOptionsData(options.data);

        return this._super.save.call(this, options);
    }
});

var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/flowEligibility'
    })
});

var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:parent.id/shipping/:id'
    })
});

var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping/add'
    }),

    serialize: function serialize() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            recipient_name: this.recipient_name,
            line1: this.line1,
            line2: this.line2,
            city: this.city,
            state: this.state,
            postal_code: this.postal_code,
            country: this.country
        };
    }
});

var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/payee'
    }),

    getId: function getId() {
        return this.merchant && this.merchant.id;
    },

    isGambling: function isGambling() {
        return this.merchant && this.merchant.isGambling;
    },

    isOnBaNoStickyList: function isOnBaNoStickyList() {
        var merchantId = this.getId();

        return merchantId && _squid.$config.disableMerchantForStickyBA && _squid.$config.disableMerchantForStickyBA.indexOf(merchantId) > -1;
    }
});

var creditOptionsModel = {
    largeEligibleAmount: {
        US: 99,
        GB: 150
    }
};

// keeping sacEligibleAmount available for backwards compat, largeEligibleAmount preferred
creditOptionsModel.sacEligibleAmount = creditOptionsModel.largeEligibleAmount;

var $CreditOptionsModel = exports.$CreditOptionsModel = creditOptionsModel;

var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
    },

    getPreferredShippingAddress: function getPreferredShippingAddress() {
        var preferredAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.preferred_address) {
                    preferredAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return preferredAddress;
    },

    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
        var primaryAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.primary_address) {
                    primaryAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return primaryAddress;
    }
});

var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {

    onPopulate: function onPopulate() {
        this.sources = this.children($FundingSourceModel, this.sources);
    },

    eachSource: function eachSource(method, context) {
        angular.forEach(this.sources, method, this);
    },

    hasFundingMethodType: function hasFundingMethodType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.sub_type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    isPAD: function isPAD() {
        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
    },

    isIACH: function isIACH() {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
                found = true;
            }
        }, this);

        return found;
    },

    isSplitBalance: function isSplitBalance() {
        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE');
    },

    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
        return this.isSplitBalance() && this.isIACH();
    },

    isMSB: function isMSB() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
    },

    isBalance: function isBalance() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
    },

    hasConversion: function hasConversion() {
        return this.conversion !== null && _typeof(this.conversion) === 'object';
    }
});

var $CardBackupModel = exports.$CardBackupModel = _squid.$Model.extend('$CardBackupModel', {
    onPopulate: function onPopulate() {
        if (!this.get('parent.meta.populated')) {
            return;
        }

        // If plan IDs change, we need to reevaluate the correct backup plan id
        this.resetIfDoesNotApply();
        this.reevaluateEligibility();
    },


    /**
     * getCardBackupInstrument
     * Get the user's last selection for card backup, if still eligible
     * @returns {Object|undefined} the plan of the user's last selection, or undefined otherwise
     */
    getPlan: function getPlan() {
        if (!this.isAllowed()) {
            return;
        }

        return this.plan;
    },


    /**
     * setCardBackupInstrument
     * Save the user's selection for backup. Tied to the currently selected plan
     * @param {Object} plan - the plan to use as the backup
     * @param {Object} [forPlan] - if needed, the plan to compare against. prefer not to pass it in
     */
    setPlan: function setPlan(plan, forPlan) {
        this.plan = plan;
        this.forPlan = forPlan || this.getCheckoutSessionPlan();
    },
    isAllowed: function isAllowed() {
        var _forPlan = this.forPlan;
        _forPlan = _forPlan === undefined ? {} : _forPlan;
        var _forPlan$primaryFs = _forPlan.primaryFs;
        _forPlan$primaryFs = _forPlan$primaryFs === undefined ? {} : _forPlan$primaryFs;
        var type = _forPlan$primaryFs.type,
            secondaryFIs = _forPlan.secondaryFIs;


        if (type !== 'CARD' || secondaryFIs !== false) {
            return false;
        }
        return this.allowCardBackup;
    },
    getCheckoutSessionPlan: function getCheckoutSessionPlan() {
        return this.get('parent.fundingOptions.plans.0');
    },
    reevaluateEligibility: function reevaluateEligibility() {
        var _this3 = this;

        (0, _processorDecline.getProcessorDeclineRetryEligibility)(this.id, this.parent).then(function (eligibility) {
            _this3.allowCardBackup = eligibility;

            return eligibility;
        });
    },
    reset: function reset(forPlan) {
        this.setPlan(undefined, forPlan);
    },

    /**
     * resetIfDoesNotApply
     * resets the selected backup for card if no longer valid based on user's choice
     * matches the plan ID if still valid but plan IDs change
     * @param {String} [plan] - current checkout session funding options plan user has selected
     */
    resetIfDoesNotApply: function resetIfDoesNotApply(plan) {
        if (!plan) {
            plan = this.getCheckoutSessionPlan();
        }

        var getKey = function getKey(p) {
            return p && p.primaryFs && p.primaryFs.id;
        };
        var planKey = getKey(plan);
        var forKey = getKey(this.forPlan);

        if (!planKey || planKey !== forKey) {
            return this.reset(plan);
        }

        // Since planIds may change, if backup is still valid then find the new plan
        var plans = this.get('parent.fundingOptions.plans') || [];
        var currentPlanKey = getKey(this.plan);
        var newPlan = currentPlanKey && plans.find(function (p) {
            return getKey(p) === currentPlanKey;
        });

        // If, for whatever reason, the old instrument isn't in the new plans, we'll reset
        if (currentPlanKey && !newPlan) {
            return this.reset(plan);
        }

        this.forPlan = plan;
        this.plan = newPlan;
    }
});

var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/session',
        postAttempts: 2
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    smartDollarAuthFailed: false, // initial value for smartDollar authorization check

    onPopulate: function onPopulate() {
        this.plan = new $CheckoutPlanModel(this.plan);
        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);

        // Reevaluate the eligibility for allowing backup with cards. This can
        // change when the checkout session is updated
        this.cardBackup = this.child($CardBackupModel, this.cardBackup || {});
        _squid.$event.emit('checkoutSessionChange'); // emit a session change event for apps to react accordingly
    },

    /**
     * Finds the plan in billing cases that the user is intending to use as the sticky FI.
     * @return {Object} the instrument representation from futurePaymentInstruments
     */
    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
        // This method doesn't apply for non-billing cases
        if (!this.futurePaymentInstruments) {
            return;
        }

        // For BA no purchase cases (no plan), use either
        // 1. selectedFuturePaymentInstrument (we've made and persisted a selection)
        // 2. first of futurePaymentInstruments (we haven't made a selection and need to save it later)
        if (!(this.plan && this.plan.sources)) {
            return this.selectedFuturePaymentInstrument || this.futurePaymentInstruments[0];
        }

        // Otherwise, if we have a plan list (ie. this is a purchase case),
        // we'll always want to take the currently selected plan,
        // as selectedFuturePaymentInstrument may not be updated to the user's current plan
        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
            return fi.instrument_id ? fi.instrument_id : undefined;
        });

        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
            return fi.instrument_id === selectedInstrumentId;
        });

        return stickyInstrument;
    },

    getPlanList: function getPlanList() {
        // Only show plans that need to be shown.
        return this.fundingOptions && this.fundingOptions.getDisplayPlans();
    },

    // returns true if more than one plan uses BALANCE as the primary FI
    isMultipleBalancePlan: function isMultipleBalancePlan() {
        var matchingBalancePlans = 0;

        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
            // if BALANCE is the primary FI...
            if (plan.primaryFs.name === 'BALANCE') {
                // increment number of balance plans found
                matchingBalancePlans++;
            }
            // exit once we have more than one balance plan
            return matchingBalancePlans > 1;
        });
    },

    getDisallowedInstruments: function getDisallowedInstruments() {
        if (this.fundingOptions && this.fundingOptions.disallowedInstruments && angular.isArray(this.fundingOptions.disallowedInstruments)) {
            var filteredDisallowedInstruments = this.fundingOptions.disallowedInstruments.filter(function (instrument) {
                if (instrument.type === 'CARD' && instrument.declineReason === 'unsupportedDueToExpiration') {
                    return (0, _utils.filterCardWithinLastNMonths)(instrument, (0, _squid.$feature)('expirePeriod'));
                }
                return true;
            });
            this.fundingOptions.disallowedInstruments = filteredDisallowedInstruments;
        }
        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
    },

    getDisallowedPreferred: function getDisallowedPreferred() {
        var disallowedInstrument = this.getDisallowedInstruments();

        // find only the disallowed instrument that has been marked as preferred.
        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
            return fi.isPreferred;
        });

        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
        // we do not show it in the disallowed section.
        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
            var instrumentID = plan.primaryFs && plan.primaryFs.id;

            if (instrumentID && disallowedInstrument.id) {
                return instrumentID === disallowedInstrument.id;
            } else {
                return false;
            }
        });

        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
    },

    expiredInstruments: function expiredInstruments() {
        var expiredInstruments = [];
        var disallowedPreferred = this.getDisallowedPreferred();
        var disallowedInstruments = this.getDisallowedInstruments();

        if (disallowedPreferred) {
            expiredInstruments.push(disallowedPreferred);
        }

        _squid.$util.forEach(disallowedInstruments, function (instrument) {
            if (instrument.type === 'CARD' && !instrument.isPreferred && instrument.declineReason === 'unsupportedDueToExpiration') {
                expiredInstruments.push(instrument);
            }
        });

        return expiredInstruments;
    },

    preferredExpiredInstruments: function preferredExpiredInstruments() {
        var disallowedPreferred = this.getDisallowedPreferred();

        if (disallowedPreferred && disallowedPreferred.type === 'CARD' && disallowedPreferred.isPreferred && disallowedPreferred.declineReason === 'unsupportedDueToExpiration') {
            return true;
        }

        return false;
    },

    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
        return {
            'line1': this.shipping.line1,
            'line2': this.shipping.line2,
            'city': this.shipping.city,
            'state': this.shipping.state,
            'postal_code': this.shipping.postal_code,
            'country_code': this.shipping.country
        };
    },

    getPPCconversionInfo: function getPPCconversionInfo() {
        var ppcFi = void 0;
        if (this.fundingOptions && this.fundingOptions.instruments) {
            ppcFi = this.fundingOptions.instruments.find(function (fi) {
                return fi.type === 'CREDIT' && fi.name === 'BILL_ME_LATER';
            });
        }
        if (ppcFi && ppcFi.currency_conversion) {
            return Object.assign({}, ppcFi.currency_conversion);
        }
        return null;
    }

});

angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("serializeInstallmentsOptionsData", serializeInstallmentsOptionsData);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CardBackupModel", $CardBackupModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Class;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$event;

_squid.$feature;

_processorDecline.getProcessorDeclineRetryEligibility;

_utils.filterCardWithinLastNMonths;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/lib/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
* @param {Date} d1
* @param {Date} d2
* @returns {number}
*/
var monthDiff = function monthDiff(d1, d2) {
    var months = void 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth() + 1;
    return months <= 0 ? 0 : months;
};

/**
* @param {Object} fi - A funding instrument
* @param {boolean} expiredPeriod - feature boolean flag from config.json
* @returns {boolean}
*/
var filterCardWithinLastNMonths = function filterCardWithinLastNMonths(fi, expirePeriod) {
    var expire_year = fi.expire_year,
        expire_month = fi.expire_month;


    var expiryDate = new Date(expire_year + '-' + expire_month + '-01');

    var monthDifference = monthDiff(expiryDate, new Date());

    return monthDifference !== 0 && monthDifference <= expirePeriod;
};

exports.filterCardWithinLastNMonths = filterCardWithinLastNMonths;

/***/ }),

/***/ "../node_modules/xo-models/src/choice/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ChoiceEligibility = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

// Variants:
// control
// 5 - If any choice treatment, do 5 unless 5 is ineligible
// 6 - If any choice treatment, do 6 if 5 is ineligible and 6 is eligible

var checkPPCInstallments = function checkPPCInstallments(token, _ref) {
    var checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel;

    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditInstallmentOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);

        return installmentOptions.save({
            cache: true, // Cache response for selectFi page or wherever needed
            data: {
                payee: checkoutPayeeModel,
                checkoutCart: checkoutCartModel,
                checkoutAppData: checkoutAppDataModel,
                isMemberCredit: true
            },
            success: function success(result) {
                var offers = result.installments && result.installments[0];
                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                var installmentOfferDetails = offers && offers.installment_options;

                var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                    return item.financingCode;
                }) : [];
                var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                    return threeMonthFinancingCodeArray.includes(value);
                }).length > 0);

                // For regular installments, we do not show choice. returns true;
                // For 3mo Installments, we want to show choice. return false;
                return hasInstallments && !hasThreeMonthInstallment;
            },
            contingencies: {
                DEFAULT: function DEFAULT(message) {
                    // Assume is eligible if contingency
                    _logger.$logger.info('installments_contingency', {
                        message: message
                    });
                    return false;
                }
            },
            error: function error(err) {
                _logger.$logger.info('installments_error', err);
                return false;
            }
        });
    } else {
        return _squid.$promise.resolve(false);
    }
};

// Main logic to decide choice eligibility
var decideEligibility = function decideEligibility(token, _ref2) {
    var authModel = _ref2.authModel,
        checkoutCartModel = _ref2.checkoutCartModel,
        checkoutSessionModel = _ref2.checkoutSessionModel,
        checkoutAppDataModel = _ref2.checkoutAppDataModel,
        checkoutPayeeModel = _ref2.checkoutPayeeModel;
    var fundingOptions = checkoutSessionModel.fundingOptions;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Reasons for a transaction to be ineligible:
    //  - is billing
    //  - is split balance
    //  - balance covers full transaction but does not have preferred set
    //  - has PAD
    //  - is second button (and not in 2nd button elmo)
    //  - is not US
    //  - has currency conversion
    //  - is not a merchant account
    //  - is a Third Party transaction (Venmo, Baidu, etc...)

    // Check to see if any plans include split balance
    var splitBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.secondaryFIs;
    });
    var billing = checkoutCartModel.isBilling();
    var PAD = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.subtype === 'PAD';
    });
    var secondButton = checkoutAppDataModel.is_second_button_txn;
    var hasMerchantCountryChoice = (0, _squid.$feature)('choiceExperiment', false, checkoutAppDataModel.merchant.merchant_country);
    var fullBalance = plans && plans.some(function (option) {
        return option.primaryFs && option.primaryFs.type === 'BALANCE';
    });
    var hasPreferred = fundingOptions && fundingOptions.getPreferred();
    var isNotMerchantAccount = authModel.account_type !== 2;
    var isNotAndroidPay = !checkoutCartModel.isWalletTokenization();
    var isNotFbBaFlow = !_squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
    var isThirdPartyWalletTransaction = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isNotGambling = !checkoutPayeeModel.isGambling();
    var isNotBaDisableStickyForMerchant = !(checkoutCartModel.isBillingNoPurchase() && checkoutPayeeModel.isOnBaNoStickyList());
    var involvedCurrencies = {};
    var currency_code = checkoutCartModel.get('purchase.amounts.total.currency_code');

    if (currency_code && plans) {
        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
        plans.forEach(function (option) {
            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
        });
    }

    var singleCurrency = Object.keys(involvedCurrencies).length <= 1;

    // checking if pad in funding plans
    var padToggleFeatureCheck = PAD ? Experiments.padToggleFeatureSupported() : _squid.$promise.resolve(false);

    // Check the choice variant.
    // User must be eligible to see a variant
    var _$config$choiceExperi = _squid.$config.choiceExperiment;
    _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
    var _$config$choiceExperi2 = _$config$choiceExperi.ignored;
    _$config$choiceExperi2 = _$config$choiceExperi2 === undefined ? {} : _$config$choiceExperi2;
    var _$config$choiceExperi3 = _$config$choiceExperi2.multipleFi,
        multipleFiIgnored = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3,
        _$config$choiceExperi4 = _$config$choiceExperi2.selectFi,
        selectFiIgnored = _$config$choiceExperi4 === undefined ? [] : _$config$choiceExperi4;


    var merchantCountry = checkoutAppDataModel.merchant && checkoutAppDataModel.merchant.merchant_country;

    var getUlTreatmentRegex = function getUlTreatmentRegex(country) {
        switch (country) {
            case 'US':
                return 'Trmt_xo_us_ppc_2nd_btn_choice_.';
            case 'GB':
                return 'Trmt_xo_gb_ppc_2nd_btn_choice_.';
            default:
                return '';
        }
    };

    var getElmo = function getElmo() {
        if (secondButton) {
            if (merchantCountry === 'US') {
                return 'already_ramped';
            }
            return (0, _squid.$elmo)('xo_ppc_2nd_btn_choice', { 'ctx.COUNTRY': merchantCountry }, getUlTreatmentRegex(merchantCountry), false, true);
        } else {
            return 'not_second_button';
        }
    };

    var logAndReturnChoice = function logAndReturnChoice() {
        _logger.$logger.info('choice_experiment_eligible', {
            variant: '5'
        });

        _logger.$logger.info('checkout_fpti', {
            from: 'CHOICE_ELG_CHK',
            to: 'process_choice_elg_chk',
            eligibility_reason: 'eligible'
        });

        return '5';
    };

    // hard code the isChoiceOnCAPECYCOReturn to false as this exp is no longer used and there in an issue of
    // delay in review page render
    return _squid.$promise.all([getElmo(), padToggleFeatureCheck, false]).then(function (_ref3) {
        var secondButtonChoiceVariant = _ref3[0],
            isPadToggleFeatureSupported = _ref3[1],
            isChoiceOnCAPECYCOReturn = _ref3[2];

        // Check transaction eligibility
        var eligibilityCriteria = {
            noBilling: !billing,
            noSplitBalance: !splitBalance,
            balanceWithPreferred: !(fullBalance && !hasPreferred),
            noPAD: !PAD || isPadToggleFeatureSupported,
            secondButtonVariant: secondButtonChoiceVariant,
            hasMerchantCountryChoice: hasMerchantCountryChoice,
            singleCurrency: singleCurrency,
            noMerchant: isNotMerchantAccount,
            noAndroidPay: isNotAndroidPay,
            isNotFbBaFlow: isNotFbBaFlow,
            noThirdPartyWalletTransactions: !isThirdPartyWalletTransaction,
            isNotGambling: isNotGambling,
            isNotBaDisableStickyForMerchant: isNotBaDisableStickyForMerchant
        };
        // First check to see if transaction is eligible for choice at all.
        // Base eligibility check follows the selectFi eligibility
        var choiceIneligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
            return selectFiIgnored.indexOf(key) === -1 && !eligibilityCriteria[key];
        });

        var transactionEligible = choiceIneligibleReasons.length === 0;

        if (!transactionEligible) {
            _logger.$logger.info('choice_experiment_ineligible', {
                failed: choiceIneligibleReasons.join()
            });

            _logger.$logger.info('checkout_fpti', {
                from: 'CHOICE_ELG_CHK',
                to: 'process_choice_elg_chk',
                eligibility_reason: 'ineligible-' + choiceIneligibleReasons.join()
            });

            return 'control';
        }

        if (isChoiceOnCAPECYCOReturn) {
            _logger.$logger.info('xo_ppc_choice_on_cape_cyco_return_treatment');
            return logAndReturnChoice();
        }

        // If eligible for choice, check if transaction is eligible for multipleFi variant
        return checkPPCInstallments(token, {
            checkoutCartModel: checkoutCartModel,
            checkoutSessionModel: checkoutSessionModel,
            checkoutAppDataModel: checkoutAppDataModel,
            checkoutPayeeModel: checkoutPayeeModel
        }).then(function (hasPPCInstallments) {
            var validCountryForMultipleFi =
            // IN requires CVV collection, multipleFi variant does not have yet
            _squid.$locale.country !== 'IN';
            var hasInstallments = plans && plans.some(function (plan) {
                return plan.installments;
            });

            /**
             * read the cvvData from checkoutSession to decide multiple FI variant
             * if we have cvvData make it as ineligible
             * Risk is going to throw cvv contingency for transaction for any country buyer
             * and CVV user input is not there in multiFI variant - resulted in buyer approve the FI
             * without entering CVV - make it as ineligible and singleFI experience asks for CVV
             */
            var cvvData = checkoutSessionModel.get('cvvData');
            var isCvvRequired = cvvData && Object.keys(cvvData).length > 0;

            var multipleFiEligibility = (0, _angular.extend)({
                // Have not built method to select PPC installments for multipleFi
                creditInstallments: !hasPPCInstallments,
                validCountryForMultipleFi: validCountryForMultipleFi,
                noInstallments: !hasInstallments,
                noCvvRequired: !isCvvRequired
            }, eligibilityCriteria);
            var multipleFiIneligibleReasons = Object.keys(multipleFiEligibility).filter(function (criteria) {
                return multipleFiIgnored.indexOf(criteria) === -1 && !multipleFiEligibility[criteria];
            }).join();
            var multipleFiEligible = multipleFiIneligibleReasons.length === 0;

            if (!multipleFiEligible) {
                _logger.$logger.info('choice_experiment_var5_ineligible', {
                    failed: multipleFiIneligibleReasons
                });

                _logger.$logger.info('checkout_fpti', {
                    from: 'CHOICE_ELG_CHK',
                    to: 'process_choice_elg_chk',
                    eligibility_reason: 'ineligible_6-' + multipleFiIneligibleReasons
                });

                return '6';
            }

            return logAndReturnChoice();
        });
    });
};

var promiseControl = _squid.$promise.resolve('control');

var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('choiceExperiment')) {
            return promiseControl;
        }
        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
        }).then(function () {
            // If user logged in is the same, we can skip the decision making logic
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.variant = decideEligibility(token, models);
            _this.buyerId = models.authModel.buyer_id;

            return _this.variant;
        });
    }
});

angular.value("$ChoiceEligibility", $ChoiceEligibility);
_angular.extend;

_squid.$Model;

_squid.$elmo;

_squid.$promise;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.$locale;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$InstallmentOptionsModel;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/credit/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditSharedInfoModel = exports.$CreditInstallmentOptionsModel = exports.$CreditInstallmentModel = exports.$CreditDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var $CreditDataModel = exports.$CreditDataModel = _squid.$Model.extend('$CreditDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            flow_type: _squid.$util.param('flow'),
            cape_key: _squid.$util.param('key'),
            cape_success: _squid.$util.param('success'),
            credit_signup: _squid.$util.param('creditSignup'),
            userAction: _squid.$util.param('action'),
            merchantAction: _squid.$util.param('merchantAction'),
            credit_login_failure: false,
            is_cross_border: false,
            has_selected_cyco: false,
            return_from_cape_complete: false,
            cape_service_error: _squid.$util.param('isInternalServiceError'),
            cape_redirect_uri: '',
            change_installment: _squid.$util.param('changeStatus'),
            nextState: '',
            cart_amount: null,
            cart_currency: null,
            installment_count: 0
        });
    },

    api: new _squid.$Api({
        uri: '/api/credit/:id/creditData',
        postAttempts: 2
    }),

    isCreditSignup: function isCreditSignup() {
        return this.credit_signup && this.credit_signup === 'true';
    },

    setCapeRedirectUri: function setCapeRedirectUri(input) {
        this.cape_redirect_uri = input;
    },

    getCapeRedirectUri: function getCapeRedirectUri() {
        return this.cape_redirect_uri;
    },

    getMerchantAction: function getMerchantAction() {
        return this.merchantAction || '';
    },

    setCreditSignup: function setCreditSignup(input) {
        this.credit_signup = input;
    },

    getCapeKey: function getCapeKey() {
        return this.cape_key;
    },

    getFlow: function getFlow() {
        if (this.userAction === 'addCredit') {
            return 'credit';
        }
        return this.flow_type;
    },
    setFlow: function setFlow(flowType) {
        this.flow_type = flowType;
    },

    setNextState: function setNextState(nextState) {
        this.nextState = nextState;
    },

    isCapeSuccess: function isCapeSuccess() {
        return this.cape_success && this.cape_success === 'true';
    },

    isCreditTxn: function isCreditTxn() {
        return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
    },

    setCreditLoginFailure: function setCreditLoginFailure(input) {
        this.credit_login_failure = input;
    },

    getCreditLoginFailure: function getCreditLoginFailure() {
        return this.credit_login_failure;
    },

    isCapeReturn: function isCapeReturn() {
        return this.flow_type && this.flow_type === 'capeReturn';
    },

    isCapeInternalServiceError: function isCapeInternalServiceError() {
        return this.cape_service_error && this.cape_service_error === 'true';
    },

    getNextState: function getNextState() {
        return this.nextState;
    },

    isChangeStatus: function isChangeStatus() {
        return this.change_installment === 'changeInstallment';
    },

    isRedirectFromCape: function isRedirectFromCape() {
        return Boolean(this.cape_key && this.cape_success === 'true' || _squid.$util.param('applyCredit'));
    },

    isReturnFromCapeComplete: function isReturnFromCapeComplete() {
        return this.return_from_cape_complete;
    },

    setReturnFromCapeComplete: function setReturnFromCapeComplete(returnFromCapeComplete) {
        this.return_from_cape_complete = returnFromCapeComplete;
    },

    // User has selected a financing offer on the CYCO page
    setSelectedCYCOOffer: function setSelectedCYCOOffer(hasOffer) {
        this.has_selected_cyco = hasOffer;
    },

    hasSelectedCYCOOffer: function hasSelectedCYCOOffer() {
        return this.has_selected_cyco;
    },

    // Cross border is when the merchant and buyer countries mismatch
    setCrossBorder: function setCrossBorder(value) {
        this.is_cross_border = value;
    },

    isCrossBorder: function isCrossBorder() {
        return this.is_cross_border;
    },

    // Cross currency: getCartAmountAndCurrency and setCartAmountAndCurrency
    getCartAmountAndCurrency: function getCartAmountAndCurrency() {
        if (this.cart_amount && this.cart_currency) {
            return {
                cart_amount: this.cart_amount,
                cart_currency: this.cart_currency
            };
        }
    },

    setCartAmountAndCurrency: function setCartAmountAndCurrency(cartData) {
        this.cart_amount = cartData && cartData.cart_amount;
        this.cart_currency = cartData && cartData.cart_currency;
    },

    getInstallmentCount: function getInstallmentCount() {
        return this.installment_count;
    },

    setInstallmentCount: function setInstallmentCount(count) {
        this.installment_count = count;
    }
});

var $CreditInstallmentModel = exports.$CreditInstallmentModel = _squid.$Model.extend('$CreditInstallmentModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/creditOptions/'
    })
});

var $CreditInstallmentOptionsModel = exports.$CreditInstallmentOptionsModel = _squid.$Model.extend('$CreditInstallmentOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    }),

    init: function init() {
        this.setProperties({
            installmentOffers: [],
            installmentCount: 0,
            installmentOptionsPresent: false,
            niOffer: [],
            niOfferPresent: false
        });
        this.meta = {
            populated: false
        };
    },

    onPopulate: function onPopulate() {
        if (this.installments && this.installments[0]) {
            this.storeInstallments();
        } else {
            _logger.$logger.log('No installments offer');
        }
    },

    storeInstallments: function storeInstallments() {

        this.installmentOffers = this.installments && this.installments[0];
        this.installmentCount = this.installmentOffers.installment_options && this.installmentOffers.installment_options.length;
        this.installmentOptionsPresent = this.installmentCount > 0;
        this.niOfferPresent = this.installmentOffers.sac_options && this.installmentOffers.sac_options.creditType;
        this.niOffer = this.niOfferPresent && this.installmentOffers.sac_options;
    },

    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },

    getInstallmentOptionsPresent: function getInstallmentOptionsPresent() {
        return this.installmentOptionsPresent;
    },

    getInstallmentOffers: function getInstallmentOffers(param) {
        if (typeof param === 'undefined') {
            return this.installmentOffers;
        } else {
            if (!this.installmentOffers || !this.installmentOffers.installment_options) {
                return;
            }
            if (typeof param === 'string') {
                switch (param) {
                    case 'APR_ASCE':
                        return this.installmentOffers.installment_options.sort(function (a, b) {
                            return +a.apr - +b.apr;
                        })[0];
                    case 'TERM_DESC':
                        return this.installmentOffers.installment_options.sort(function (a, b) {
                            return +b.term - +a.term;
                        })[0];
                    default:
                        return this.installmentOffers.installment_options[0];
                }
            } else {
                return this.installmentOffers.installment_options[param];
            }
        }
    },

    getInstallmentCount: function getInstallmentCount() {
        return this.installmentCount;
    },

    getNiOffer: function getNiOffer() {
        return this.niOffer;
    },

    getNiOfferPresent: function getNiOfferPresent() {
        return this.niOfferPresent;
    },

    serialize: function serialize() {
        var data = {
            payee: this.payee,
            checkoutCart: this.checkoutCart,
            checkoutAppData: this.checkoutAppData,
            isMemberCredit: true
        };

        return (0, _checkout.serializeInstallmentsOptionsData)(data);
    },
    save: function save(options) {
        options.data = this.serialize();

        return this._super.save.call(this, options);
    }
});

var $CreditSharedInfoModel = exports.$CreditSharedInfoModel = _squid.$Model.extend('$CreditSharedInfoModel', {

    init: function init() {
        this.setProperties({
            installmentOfferPresent: false,
            installmentOffer: null,
            installmentOfferFinancingDetails: null,
            showCreditExample: false,
            fiCount: 0,
            morsDiscoverMessageFPTIFired: false,
            cartAmountVisible: false,
            redirectToCapeCyco: false
        });
        this._super.init.apply(this);
    },
    setInstallmentOfferPresent: function setInstallmentOfferPresent(installmentOfferPresent) {
        this.installmentOfferPresent = installmentOfferPresent;
    },
    hasInstallmentOffers: function hasInstallmentOffers() {
        return this.installmentOfferPresent;
    },
    setInstallmentOffer: function setInstallmentOffer(installmentOffer) {
        this.installmentOffer = installmentOffer;
    },
    getInstallmentOffer: function getInstallmentOffer() {
        return this.installmentOffer;
    },
    setInstallmentOfferFinancingDetails: function setInstallmentOfferFinancingDetails(installmentOfferFinancingDetails) {
        this.installmentOfferFinancingDetails = installmentOfferFinancingDetails;
    },
    hasInstallmentOfferFinancingDetails: function hasInstallmentOfferFinancingDetails() {
        return !!this.installmentOfferFinancingDetails;
    },
    getInstallmentOfferFinancingDetails: function getInstallmentOfferFinancingDetails() {
        return this.installmentOfferFinancingDetails;
    },
    setShowCreditExample: function setShowCreditExample(shouldShowCreditExample) {
        this.showCreditExample = shouldShowCreditExample;
    },
    shouldShowCreditExample: function shouldShowCreditExample() {
        return this.showCreditExample;
    },
    setFiCount: function setFiCount(count) {
        this.fiCount = parseInt(count, 10);
    },
    getFiCount: function getFiCount() {
        return this.fiCount;
    },
    getMorsFptiFiredFlag: function getMorsFptiFiredFlag() {
        return this.morsDiscoverMessageFPTIFired;
    },
    setMorsFptiFiredFlag: function setMorsFptiFiredFlag(alreadyFired) {
        this.morsDiscoverMessageFPTIFired = alreadyFired;
    },
    getCartAmountVisible: function getCartAmountVisible() {
        return this.cartAmountVisible;
    },
    setCartAmountVisible: function setCartAmountVisible(visible) {
        this.cartAmountVisible = visible;
    },
    setRedirectToCapeCyco: function setRedirectToCapeCyco(flag) {
        this.redirectToCapeCyco = flag;
    },
    getRedirectToCapeCyco: function getRedirectToCapeCyco() {
        return this.redirectToCapeCyco;
    }
});

angular.value("$CreditDataModel", $CreditDataModel);
angular.value("$CreditInstallmentModel", $CreditInstallmentModel);
angular.value("$CreditInstallmentOptionsModel", $CreditInstallmentOptionsModel);
angular.value("$CreditSharedInfoModel", $CreditSharedInfoModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_logger.$logger;

_checkout.serializeInstallmentsOptionsData;

/***/ }),

/***/ "../node_modules/xo-models/src/donation/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GiveAtCheckoutModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $GiveAtCheckoutModel = exports.$GiveAtCheckoutModel = _squid.$Model.extend('$GiveAtCheckoutModel', {
    api: new _squid.$Api({
        uri: '/api/donation',
        postAttempts: 2
    })
});

angular.value("$GiveAtCheckoutModel", $GiveAtCheckoutModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/eligibility/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$stickyCTA = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var checkEligibility = function checkEligibility() {
    var token = _angular.$rootScope.token;
    var models = {};

    return _squid.$promise.all([(0, _squid.$populate)(models, {
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
        checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
    }), _gdprCookieBanner.$GDPRCookieBannerModel.instance().hasBanner()]).then(function () {
        // Device Checks
        var userAgent = _angular.$window.navigator.userAgent;
        var isIE = !!userAgent.match(/MSIE|trident|edge/i);
        var isMobile = _index.$DeviceInfo.isMobile();
        var miniBrowser = _angular.$rootScope.miniBrowser;
        var isValidTraffic = isMobile || miniBrowser;
        var isSmallScreen = _angular.$window.innerWidth <= 600;

        // Flow Checks
        var billing = models.checkoutCartModel.isBilling();
        var invoice = models.checkoutAppDataModel.get('flags.is_invoice_flow');
        var upop = models.checkoutSessionModel.unconfirmed_upop;
        var gpdr = _gdprCookieBanner.$GDPRCookieBannerModel.instance().shown();

        // Feature checks
        var eligibleCountry = (0, _squid.$feature)('stickyCTA');
        var ineligibilityConditions = {
            isIE: isIE,
            upop: upop,
            invoice: invoice,
            gpdr: gpdr,
            billing: billing,
            isNotSmallScreen: !isSmallScreen,
            isNotValidTraffic: !isValidTraffic,
            isNotEligibleCountry: !eligibleCountry
        };

        var decision = isValidTraffic && eligibleCountry && isSmallScreen && !billing && !invoice && !upop && !isIE && !gpdr;

        var ineligibilityReasons = Object.keys(ineligibilityConditions).filter(function (key) {
            return ineligibilityConditions[key];
        });
        var eligibility_reason = 'eligible';

        if (ineligibilityReasons.length > 0 || !decision) {
            eligibility_reason = 'ineligible-' + ineligibilityReasons.join(',');
        }
        _logger.$logger.info('checkout_fpti', {
            from: 'sticky_cta',
            to: 'process_eligibility_check',
            eligibility_reason: eligibility_reason
        });

        return decision;
    });
};

var checkPxp = function checkPxp() {
    var _$CheckoutAppDataMode = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        merchant = _$CheckoutAppDataMode.merchant;

    var country = merchant && merchant.merchant_country;

    return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_sticky_cta_(.*)', false, true).then(function (treatment) {
        if (treatment) {
            var test = /xo_hermesnode_sticky_cta_(.*)/g;
            var name = treatment && treatment.treatment_name;
            var treatmentTest = test.exec(name);
            var treatmentName = treatmentTest.length > 1 && treatmentTest[1];

            _logger.$logger.info('checkout_fpti', {
                from: 'sticky_cta',
                to: 'process_pxp_check',
                eligibility_reason: treatmentName
            });
            return treatmentName;
        }
        return '';
    });
};

var mapper = function mapper(eligibility, treatment) {
    var variant = {
        'treatmentA': 'bottom',
        'treatmentB': 'top',
        'control': '',
        'DEFAULT': ''
    };
    var result = variant[treatment] || variant.DEFAULT;

    _logger.$logger.info('checkout_fpti', {
        from: 'sticky_cta',
        to: 'process_variant_check',
        eligibility_reason: result || 'ineligible'
    });
    return result;
};

/**
 * To be replaced by $EligibilityClass.
 * Following new EligibilityClass pattern.
*/
var $stickyCTA = exports.$stickyCTA = _squid.$Model.extend('$stickyCTA', {
    getEligibility: function getEligibility() {
        return checkEligibility().then(function (eligibility) {
            if (eligibility) {
                return checkPxp().then(function (treatment) {
                    return mapper(eligibility, treatment);
                });
            } else {
                return '';
            }
        });
    }
});

angular.value("$stickyCTA", $stickyCTA);
_angular.$rootScope;

_angular.$window;

_logger.$logger;

_squid.$Model;

_squid.$populate;

_squid.$pxp;

_squid.$feature;

_squid.$promise;

_index.$DeviceInfo;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_gdprCookieBanner.$GDPRCookieBannerModel;

/***/ }),

/***/ "../node_modules/xo-models/src/experiments/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.baNoCardAddCardLinkExperiment = exports.balanceComprehensionBannerExperiment = exports.isBalanceComprehensionBannerExpEligible = exports.deInstallmentIsRamped = exports.padToggleWalletSupported = exports.padToggleFeatureSupported = exports.PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = exports.PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS = ['Trmt_xo_hermesnode_pad_2_ui'];
var PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = exports.PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES = ['AU', 'CA', 'GB', 'ES', 'FR', 'NL'];

/*
    * Returns the feature configuration
    *
    * If the country its part of the countries in the list of pxp enabled countries
    * we will check first if the treatment its enabled before calling the feature.
    *
    * if the treatment its not enabled we will return false for this feature.
    *
    * otherwise we will just return whatever is configured on the feature
*/
var _getPad2Feature = function _getPad2Feature(feature) {
    var country = _squid.$locale.country;


    if (PAD_CHECKBOX_SUPPORTED_ELMO_ENABLED_COUNTRIES.includes(country)) {
        // if the contry is any of the allowed countries we want to check that the experiment its enabled before returning the config values
        return (0, _squid.$elmo)('xo_hermesnode_pad_2_ui', { 'ctx.country': _squid.$locale.country, res: 'pad_2_ui' }, PAD_CHECKBOX_SUPPORTED_VALID_TREATMENTS.join('|')).then(function (elmoResponse) {
            // If the elmo has a valid treatment then enable based on the configs
            // this will enable to enable/disable the new pad experience with an experiment and configs
            if (elmoResponse) {
                return (0, _squid.$feature)(feature, false, country);
            }
            return false;
        });
    }
    return _squid.$promise.resolve((0, _squid.$feature)(feature, false, country));
};

var padToggleFeatureSupported = exports.padToggleFeatureSupported = function padToggleFeatureSupported() {
    return _getPad2Feature('padToggleFeatureSupported');
};

var padToggleWalletSupported = exports.padToggleWalletSupported = function padToggleWalletSupported() {
    return _getPad2Feature('padToggleWalletSupported');
};

var deInstallmentIsRamped = exports.deInstallmentIsRamped = function deInstallmentIsRamped() {
    return (0, _squid.$elmo)('xo_de_ppc_radio_banner', { 'ctx.COUNTRY': 'DE' }, 'Trmt_xo_de_ppc_radio_banner', false, true).then(function (res) {
        var treatmentName = res && res.treatment_name;
        return treatmentName === 'Trmt_xo_de_ppc_radio_banner';
    });
};

var balanceComprehensionBannerExperimentCalled = false;
var balanceComprehensionBannerDisplayed = false;
var isBalanceComprehensionBannerExpEligible = exports.isBalanceComprehensionBannerExpEligible = function isBalanceComprehensionBannerExpEligible(_ref) {
    var cart = _ref.cart,
        checkoutSession = _ref.checkoutSession,
        checkoutAppData = _ref.checkoutAppData;

    var expEligibleBillingTypes = ['MERCHANT_INITIATED_BILLING', 'MERCHANT_INITIATED_SINGLE_BILLING', 'CHANNEL_INITIATED_BILLING'];
    var isBillingNoPurchase = cart.isBillingNoPurchase();
    var isEmptyPlan = checkoutSession.futurePaymentInstruments && checkoutSession.futurePaymentInstruments.length === 0;
    var allowBaWithoutBufs = checkoutAppData.flags && checkoutAppData.flags.allow_billing_agreement_without_bufs;
    var isBANoCardFlow = isBillingNoPurchase && isEmptyPlan && allowBaWithoutBufs;
    var billingType = cart.billing && cart.billing.type;

    if (isBillingNoPurchase && !isBANoCardFlow && expEligibleBillingTypes.indexOf(billingType) > -1) {
        return _user.$UserEligibleToHoldBalanceModel.instance().retrieve().then(function (res) {
            var eligibleToHoldBalance = res && res.eligibleToHoldBalance;

            _logger.$logger.info('balanceComprehensionBannerExperiment_CIP_STATUS', { eligibleToHoldBalance: eligibleToHoldBalance });
            return eligibleToHoldBalance;
        })['catch'](function () {
            _logger.$logger.info('balanceComprehensionBannerExperiment_CIP_CHECK_ERROR');
            return false;
        });
    }
    return _angular.$q.when(false);
};
var balanceComprehensionBannerExperiment = exports.balanceComprehensionBannerExperiment = {
    getTreatment: function getTreatment(_ref2) {
        var page = _ref2.page,
            cart = _ref2.cart,
            checkoutAppData = _ref2.checkoutAppData,
            checkoutSession = _ref2.checkoutSession,
            payee = _ref2.payee;

        return isBalanceComprehensionBannerExpEligible({
            cart: cart,
            checkoutAppData: checkoutAppData,
            checkoutSession: checkoutSession
        }).then(function (eligible) {
            if (!eligible) {
                return _angular.$q.when();
            }
            var fiCount = checkoutSession.futurePaymentInstruments && checkoutSession.futurePaymentInstruments.length;

            if (page === 'review' && fiCount !== 1) {
                _logger.$logger.info('balanceComprehensionBannerExperiment_SKIP', { page: page, fiCount: fiCount });
                return _angular.$q.when();
            }
            balanceComprehensionBannerExperimentCalled = true;
            var billingType = cart.billing.type;
            var merchantId = payee.get('merchant.id');
            var merchantCountry = checkoutAppData.get('merchant.merchant_country');

            return (0, _squid.$elmo)('balance_banner_ramp_hermes', {
                'ctx.buyerCountry': _squid.$locale.country,
                'ctx.landingPage': page,
                'ctx.merchantId': merchantId,
                'ctx.merchantCountry': merchantCountry,
                'ctx.billingType': billingType,
                'ctx.fiCount': fiCount }, 'Trmt_balance_banner_ramp_hermes_.*', false, false).then(function (res) {
                balanceComprehensionBannerDisplayed = res && (res.treatment_name === 'Trmt_balance_banner_ramp_hermes_top' || res.treatment_name === 'Trmt_balance_banner_ramp_hermes_bottom');
                _logger.$logger.info('balanceComprehensionBannerExperiment', { treatment: res && res.treatment_name, page: page });
                return res;
            })['catch'](function (e) {
                _logger.$logger.info('balanceComprehensionBannerExperiment_ELMO_ERROR', { page: page });
                return _angular.$q.when();
            });
        })['catch'](function (e) {
            _logger.$logger.info('balanceComprehensionBannerExperiment_IS_ELIGIBLE_CHECK_ERROR', { page: page });
            return _angular.$q.when();
        });
    },
    experimentCalled: function experimentCalled() {
        return balanceComprehensionBannerExperimentCalled;
    },
    bannerDisplayed: function bannerDisplayed() {
        return balanceComprehensionBannerDisplayed;
    }
};

/*
 * Experimentation for showing add card link in Billing No Card Flows
 * ELMO: https://admin.paypalinc.com/elmo/experiment/101657
 */
var baNoCardAddCardLinkExpCalled = false;
var baNoCardAddCardLinkExperiment = exports.baNoCardAddCardLinkExperiment = {
    // Fetches the treatment response from ELMO for BA No Card Add Card Link experiment
    getTreatment: function getTreatment(_ref3) {
        var billingType = _ref3.billingType,
            merchantCountry = _ref3.merchantCountry,
            merchantId = _ref3.merchantId;

        baNoCardAddCardLinkExpCalled = true;
        return (0, _squid.$elmo)('rt_opt_banocard_addcard_link', {
            'ctx.buyerCountry': _squid.$locale.country,
            'ctx.billingType': billingType,
            'ctx.client': 'hermes',
            'ctx.merchantCountry': merchantCountry,
            'ctx.merchantId': merchantId
        }, 'Trmt_rt_opt_banocard_addcard_link', false, false).then(function (res) {
            _logger.$logger.info('baNoCardAddCardLinkExperiment', { treatment: res && res.treatment_name });
            return res;
        })['catch'](function (e) {
            _logger.$logger.info('baNoCardAddCardLinkExperiment_ELMO_ERROR');
            return _angular.$q.when();
        });
    },
    // Returns if the BA No Card Add Card Link experiment was already called in the flow
    experimentCalled: function experimentCalled() {
        return baNoCardAddCardLinkExpCalled;
    }
};

_squid.$feature;

_squid.$locale;

_squid.$promise;

_squid.$elmo;

_user.$UserEligibleToHoldBalanceModel;

_angular.$q;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardInfoModel = exports.$WalletInstrumentNameMapping = exports.$WalletPreferences = exports.$ResolveOTP = exports.$CardConfirmationModel = exports.$Resolve3DS = exports.$CardTypeFromBinModel = exports.$BillingAddressesModel = exports.$CurrencyConversionModel = exports.$BillingAddressModel = exports.$AddBillingAddressModel = exports.$DeleteCardModel = exports.$SepaModel = exports.$PreferredFi = exports.$AddBankModel = exports.$BankModel = exports.$CardTypesModel = exports.$UnavailableCardModel = exports.$AddCardModel = exports.$CardModel = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILLING_ADDRESS_FORMAT = {
    DEFAULT: {
        ',': ', ',
        ' ': ' '
    },
    IL: {
        he: {
            ',': '‏, ‏',
            ' ': '‏ ‏'
        }
    }
};

var $CardModel = exports.$CardModel = _squid.$Model.extend('$CardModel', {
    serialize: function serialize() {
        return {
            type: this.type,
            number: this.number.replace(/[^\d]+/g, ''),
            security_code: this.security_code,
            expiry_month: this.expiry_month && _squid.$util.pad(this.expiry_month, 2),
            expiry_year: this.expiry_year,
            issue_number: this.issue_number ? this.issue_number : undefined,
            start_month: this.start_month ? _squid.$util.pad(this.start_month, 2) : undefined,
            start_year: this.start_year ? this.start_year : undefined
        };
    },

    last4: function last4() {
        var cardNumber = this.number;

        return cardNumber.substr(cardNumber.length - 4);
    },

    isExisting: function isExisting() {
        return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
    }
});

var $AddCardModel = exports.$AddCardModel = _squid.$Model.extend('$AddCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id?'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.card = new $CardModel();
    },

    serialize: function serialize() {
        var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;

        return {
            cardType: this.cardType ? this.cardType : 'creditCard',
            sponsor_id: this.sponsor_id,
            preference: this.preference,
            user: this.user,
            card: this.card.serialize(),
            address: id ? {
                id: id
            } : this.address.serialize()
        };
    },

    clearId: function clearId() {
        delete this.id;
    }
});

var $UnavailableCardModel = exports.$UnavailableCardModel = _squid.$Model.extend('$UnavailableCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/unavailable/card?addFIContingency'
    })
});

var $CardTypesModel = exports.$CardTypesModel = _squid.$Model.extend('$CardTypesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/types?country=:country&token=:token'
    }),

    retrieve: function retrieve() {
        return this._super.retrieve.apply(this, arguments).then(function (result) {
            this.disallowedCards = (0, _squid.$feature)('disallowedCards', undefined, this.country);
            // override disallowed cards with card types config list based on country
            if (this.disallowedCards) {
                result.disallowed = this.disallowedCards.cardTypes;
            }
            return result;
        });
    },

    supportedNames: function supportedNames() {
        if (typeof this.allowed === 'undefined') {
            return;
        }

        return this.allowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    },

    unsupportedNames: function unsupportedNames() {
        if (typeof this.disallowed === 'undefined') {
            return;
        }

        return this.disallowed.map(function (type) {
            return _squid.$locale.content.cardTypes[type];
        });
    }
});

var $BankModel = exports.$BankModel = _squid.$Model.extend('$BankModel', {
    init: function init() {
        this._super.init.apply(this);
        this.bank_account_number = '';
        this.bank_routing_number = '';
        this.iban_number = '';
    },

    serialize: function serialize() {
        var data = {};

        if (this.bank_account_number) {
            data.bank_account_number = this.bank_account_number;
        }
        if (this.bank_routing_number) {
            data.bank_routing_number = this.bank_routing_number;
        }
        if (this.iban_number) {
            data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
        }
        return data;
    }
});

var $AddBankModel = exports.$AddBankModel = _squid.$Model.extend('$AddBankModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.user = this.user || {
            first_name: '',
            dob_day: '',
            dob_month: '',
            dob_year: '',
            currency_code: '',
            country: ''
        };
        this.bank = this.bank || new $BankModel();
        this.address = this.address || {};
        this.creditorDetails = this.creditorDetails || {};
        this.fiDetails = this.fiDetails || {};
    },

    getBankData: function getBankData() {
        var data = {};

        // Set user info
        data.user = this.user;

        // Set bank info
        var bank = {};

        this.bank = this.bank || {};

        if (this.candidate_id) {
            data.candidate_id = this.candidate_id;
        }

        if (this.bank.bank_account_number) {
            bank.bank_account_number = this.bank.bank_account_number;
        }

        if (this.bank.bank_routing_number) {
            bank.bank_routing_number = this.bank.bank_routing_number;
        }

        if (this.bank.iban_number) {
            bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
        }
        data.bank = bank;

        // Set address info
        if (this.address) {
            data.address = {
                line1: this.address.line1,
                line2: this.address.line2,
                city: this.address.city,
                country: this.address.country,
                postal_code: this.address.postal_code
            };
        }

        return data;
    }
});

var $PreferredFi = exports.$PreferredFi = _squid.$Model.extend('$PreferredFi', {
    api: new _squid.$Api({
        uri: '/api/fi/preferred'
    }),

    init: function init() {
        this._super.init.apply(this);

        // Get the type of device to send to FI for logging
        function getUiChannel() {
            var capabilities = _index.$DeviceInfo.getCapabilities();

            if (capabilities.isTablet) {
                return 'Tablet';
            } else if (capabilities.isMobile) {
                return 'Mobile';
            } else if (capabilities.isDesktop) {
                return 'Desktop';
            } else if (capabilities.isApp) {
                return 'App';
            } else {
                return null;
            }
        }

        this.uiChannel = getUiChannel();
    },

    serialize: function serialize() {
        return {
            preferred: this.preferred,
            uiChannel: this.uiChannel
        };
    }
});

var $SepaModel = exports.$SepaModel = _squid.$Model.extend('$SepaModel', {
    api: new _squid.$Api({
        uri: '/api/fi/bank'
    })
});

var $DeleteCardModel = exports.$DeleteCardModel = _squid.$Model.extend('$DeleteCardModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/delete'
    })
});

var $AddBillingAddressModel = exports.$AddBillingAddressModel = _squid.$Model.extend('$AddBillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/:instrumentid/addbillingaddress'
    })
});

var $BillingAddressModel = exports.$BillingAddressModel = _squid.$Model.extend('$BillingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress/validate'
    }),

    format: function format() {

        var langConfig = (BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};

        var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
        var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];

        return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
    },

    serialize: function serialize() {
        return {
            line1: this.line1 && this.line1.trim(),
            line2: this.line2 && this.line2.trim(),
            city: this.city && this.city.trim(),
            state: this.state && this.state.trim(),
            postal_code: this.postal_code && this.postal_code.trim(),
            normalization_status: this.normalization_status,
            country: this.country
        };
    }
});

var $CurrencyConversionModel = exports.$CurrencyConversionModel = _squid.$Model.extend('$CurrencyConversionModel', {
    api: new _squid.$Api({
        uri: '/api/fi/currencyConversion'
    })
});

var $BillingAddressesModel = exports.$BillingAddressesModel = _squid.$Model.extend('$BillingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/fi/billingaddress'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($BillingAddressModel, this.addresses);
    }
});

var $CardTypeFromBinModel = exports.$CardTypeFromBinModel = _squid.$Model.extend('$CardTypeFromBinModel', {
    api: new _squid.$Api({
        uri: '/api/fi/cardTypeFromBin'
    })
});

var $Resolve3DS = exports.$Resolve3DS = _squid.$Model.extend('$Resolve3DS', {
    api: new _squid.$Api({
        uri: '/api/fi/3ds/:id'
    })
});

var $CardConfirmationModel = exports.$CardConfirmationModel = _squid.$Model.extend('$CardConfirmationModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id/confirmations'
    })
});

var $ResolveOTP = exports.$ResolveOTP = _squid.$Model.extend('$ResolveOTP', {
    api: new _squid.$Api({
        uri: '/api/fi/otp/:id'
    })
});

var $WalletPreferences = exports.$WalletPreferences = _squid.$Model.extend('$WalletPreferences', {
    api: new _squid.$Api({
        uri: '/api/fi/wallet/preferences'
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    init: function init() {
        this._super.init.apply(this);
        this.topup = {};
        this.direct = {};
    },

    serialize: function serialize() {
        var data = {};

        if (this.topup.amount) {
            var _topup = this.topup,
                amount = _topup.amount,
                _topup$fundingSource = _topup.fundingSource;
            _topup$fundingSource = _topup$fundingSource === undefined ? {} : _topup$fundingSource;
            var instrument_id = _topup$fundingSource.instrument_id;

            // Set the Topup funding instrument in the wallet preference api, which will be used by future Topup transactions

            data.topup = {
                amount: amount,
                instrument_id: instrument_id,
                autoload_minimum_threshold: _squid.$config.topup.autoload_minimum_threshold
            };
        } else {
            var _direct$fundingSource = this.direct.fundingSource;
            _direct$fundingSource = _direct$fundingSource === undefined ? {} : _direct$fundingSource;
            var _instrument_id = _direct$fundingSource.instrument_id;

            // Set the Direct funding instrument in the wallet preference api, which will be used by future Direct funding transactions

            data.direct = {
                instrument_id: _instrument_id,
                currency_code: this.currency
            };
        }
        return data;
    },

    /**
        * Return the preferred topup/direct fundingsource.
        * Originally values of topup & direct are from the FI wallet preferences api, which gets assigned during the init() call.
        * Values can be changed in the Review and the Wallet pages.
        */
    getPreferred: function getPreferred() {
        if (this.topup.fundingSource && this.topup.fundingSource.instrument_id) {
            // xo-hermes-fi will always return topup.fundingSource even when there is no preferred topup instrument, hence making the additional check here.
            return this.topup.fundingSource;
        } else {
            return this.direct.fundingSource || {};
        }
    }
});

var $WalletInstrumentNameMapping = exports.$WalletInstrumentNameMapping = _squid.$Model.extend('$WalletInstrumentNameMapping', {
    init: function init() {
        this._super.init.apply(this);
        this.INSTRUMENT_MAP = {
            AMSOUTH: /AMSOUTH,/,
            BOFA: /BANK OF AMERICA/,
            CAPITAL: /CAPITAL/,
            CHASE: /CHASE/,
            CITI: /CITIBANK/,
            FIFTHTHIRD: /FIFTH THIRD BANK/,
            HUNTINGTON: /HUNTINGTON/,
            INGDIRECT: /ING DIRECT/,
            NATIONALCITY: /NATIONAL CITY/,
            PNC: /PNC/,
            REGIONS: /REGIONS/,
            SUNTRUST: /SUNTRUST/,
            TDWATERHOUSE: /TD WATERHOUSE/,
            USAA: /USAA/,
            USBANK: /US BANK/,
            VISA: /VISA/,
            WAMUTUAL: /WASHINGTON MUTUAL/,
            WELLSFARGO: /WELLS FARGO/
        };
        this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
    },

    getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
        var _this = this;

        if (!fsName) {
            return;
        }

        fsName = fsName.toUpperCase();

        return _squid.$util.find(this.INSTRUMENT_NAMES, function (instName) {
            if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
                return true;
            }
            return false;
        });
    }
});

var $CardInfoModel = exports.$CardInfoModel = _squid.$Model.extend('$CardInfoModel', {
    api: new _squid.$Api({
        uri: '/api/fi/card/:id'
    })
});

angular.value("$CardModel", $CardModel);
angular.value("$AddCardModel", $AddCardModel);
angular.value("$UnavailableCardModel", $UnavailableCardModel);
angular.value("$CardTypesModel", $CardTypesModel);
angular.value("$BankModel", $BankModel);
angular.value("$AddBankModel", $AddBankModel);
angular.value("$PreferredFi", $PreferredFi);
angular.value("$SepaModel", $SepaModel);
angular.value("$DeleteCardModel", $DeleteCardModel);
angular.value("$AddBillingAddressModel", $AddBillingAddressModel);
angular.value("$BillingAddressModel", $BillingAddressModel);
angular.value("$CurrencyConversionModel", $CurrencyConversionModel);
angular.value("$BillingAddressesModel", $BillingAddressesModel);
angular.value("$CardTypeFromBinModel", $CardTypeFromBinModel);
angular.value("$Resolve3DS", $Resolve3DS);
angular.value("$CardConfirmationModel", $CardConfirmationModel);
angular.value("$ResolveOTP", $ResolveOTP);
angular.value("$WalletPreferences", $WalletPreferences);
angular.value("$WalletInstrumentNameMapping", $WalletInstrumentNameMapping);
angular.value("$CardInfoModel", $CardInfoModel);
_index.$DeviceInfo;

_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

_squid.$feature;

_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var issuerDeclineExperimentMap = exports.issuerDeclineExperimentMap = {
    Trmt_xo_hermesnodeweb_issuer_decline_1: {
        memberPreferredIssuer: 'payment.processorDeclineBlacklistFIPreferredIssuer',
        memberPreferredNoIssuer: 'payment.processorDeclineBlacklistFIPreferredNoIssuer',
        memberNoPreferredIssuer: 'payment.processorDeclineBlacklistFINoPreferredIssuer',
        memberNoPreferredNoIssuer: 'payment.processorDeclineBlacklistFINoPreferredNoIssuer',
        memberNoFIPreferredIssuer: 'payment.processorDeclineBlacklistNoFIPreferredIssuer',
        memberNoFIPreferredNoIssuer: 'payment.processorDeclineBlacklistNoFIPreferredNoIssuer',
        memberNoFINoPreferredIssuer: 'payment.processorDeclineBlacklistNoFINoPreferredIssuer',
        memberNoFINoPreferredNoIssuer: 'payment.processorDeclineBlacklistNoFINoPreferredNoIssuer',
        type: 'info'
    }
};

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fiApis = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var $fiApis = exports.$fiApis = {
    patchCvv: function patchCvv(checkoutSession) {
        var cvvData = checkoutSession.get('cvvData');

        if (cvvData) {
            return checkoutSession.action('patchCvv', {
                data: {
                    id: cvvData.id,
                    cvv: cvvData.security_code,
                    type: cvvData.type,
                    number: cvvData.number
                }
            });
        }

        return _angular.$q.when();
    }
};

angular.value("$fiApis", $fiApis);
_angular.$q;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiMessages.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _constants = __webpack_require__("../node_modules/xo-models/src/fi/lib/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fiMessages', function () {
    function getContentKeys(hasFi) {
        if (hasFi) {
            return {
                member: 'payment.processorDeclineMember',
                generic: 'payment.processorDeclineMemberGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
            };
        } else {
            return {
                member: 'payment.processorDeclineMemberNoFI',
                generic: 'payment.processorDeclineMemberNoFIGeneric',
                buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
            };
        }
    }

    // Temporary solution until PAPS returns CCID in the declined instrument
    var getIssuerName = function getIssuerName(_ref) {
        var _ref$instrument = _ref.instrument,
            instrument = _ref$instrument === undefined ? {} : _ref$instrument,
            _ref$disallowedInstru = _ref.disallowedInstruments,
            disallowedInstruments = _ref$disallowedInstru === undefined ? [] : _ref$disallowedInstru,
            _ref$cardAccounts = _ref.cardAccounts,
            cardAccounts = _ref$cardAccounts === undefined ? [] : _ref$cardAccounts;

        var last4 = instrument && instrument.last4 ? instrument.last4 : '';
        var search = disallowedInstruments.find(function (disallowedInstrument) {
            return disallowedInstrument.lastDigits === last4;
        });

        if (search) {
            var id = search.id;

            var cardAccount = cardAccounts.find(function (card) {
                return card.id.replace('-', '') === id;
            });

            if (cardAccount) {
                // Will need to eventually deprecate to the Wallet Model to manage this
                var issuerName = cardAccount.issuer && cardAccount.issuer.filtered_issuer_name ? cardAccount.issuer.filtered_issuer_name : '';

                return issuerName;
            }
        }
        return '';
    };

    function isDeclinedCard(checkoutSession) {
        var planInstruments = checkoutSession.fundingOptions.plans;
        var declinedInstruments = checkoutSession.declinedInstruments;
        var fiInstruments = checkoutSession.fundingOptions.instruments;

        if (declinedInstruments && declinedInstruments.length === 1) {
            var singlePlan = checkoutSession.plan;

            planInstruments.forEach(function (plan) {
                if (plan.primaryFs.lastDigits === declinedInstruments[0].last4 && plan.primaryFs.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                    plan.gotDeclined = true;
                    plan.message = 'wallet.processorDeclinedCard';
                }
            });

            fiInstruments.forEach(function (fi) {
                if (fi.lastDigits === declinedInstruments[0].last4 && fi.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                    fi.gotDeclined = true;
                    fi.message = 'wallet.processorDeclinedCard';
                }
            });

            if (singlePlan && singlePlan.sources && singlePlan.sources.length === 1 && singlePlan.sources[0].last4 === declinedInstruments[0].last4) {
                checkoutSession.plan.sources[0].gotDeclined = true;
            }
        }
    }

    function preferredDeclined(checkoutSession, declinedInstruments) {
        var planInstruments = checkoutSession.fundingOptions.plans;
        var isPreferredDeclined = false;

        if (declinedInstruments) {
            planInstruments.forEach(function (plan) {
                if (plan.primaryFs.lastDigits === declinedInstruments.last4 && plan.primaryFs.isPreferred) {
                    isPreferredDeclined = true;
                }
            });
        }
        return isPreferredDeclined;
    }

    function noFIexperience(checkoutSession, declinedInstruments) {
        var plansLength = checkoutSession.fundingOptions.plans.length;
        var declinedLength = declinedInstruments.length;

        return plansLength === 1 && declinedLength === 1;
    }

    var ADD_CARD_URLS = {
        SIDEBAR_DEFAULT: {
            route: '#checkout/review/sidebar/sidebarAddCard/addCardFlow/addCard'
        }
    };

    function processorDeclinedMsg(checkoutSession, hasFi) {
        var experiment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var authSession = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var wallet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var informalName = arguments[5];

        var declinedInstruments = checkoutSession.get('declinedInstruments', []);

        if (_angular2['default'].isArray(declinedInstruments) && declinedInstruments.length) {
            var msg = void 0;
            var type = 'warning';
            var keepMsg = false;
            var instrument = declinedInstruments[0];
            var contentKeys = getContentKeys(hasFi);

            if (instrument.type === 'PAYMENT_CARD') {
                if (instrument.card_type && instrument.last4) {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'member' });
                    var experimentMap = _constants.issuerDeclineExperimentMap[experiment];

                    if (experimentMap && authSession && wallet) {
                        var card_accounts = wallet.card_accounts;

                        var preferredCard = preferredDeclined(checkoutSession, instrument);
                        var noFImessages = noFIexperience(checkoutSession, declinedInstruments);
                        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
                        var issuer = getIssuerName({
                            instrument: instrument,
                            disallowedInstruments: disallowedInstruments,
                            cardAccounts: card_accounts
                        });
                        var linkObj = ADD_CARD_URLS.SIDEBAR_DEFAULT;
                        var errorMsg = contentKeys.generic;

                        errorMsg = noFImessages && preferredCard && issuer ? experimentMap.memberNoFIPreferredIssuer : errorMsg;
                        errorMsg = noFImessages && preferredCard && !issuer ? experimentMap.memberNoFIPreferredNoIssuer : errorMsg;
                        errorMsg = noFImessages && !preferredCard && issuer ? experimentMap.memberNoFINoPreferredIssuer : errorMsg;
                        errorMsg = noFImessages && !preferredCard && !issuer ? experimentMap.memberNoFINoPreferredNoIssuer : errorMsg;
                        errorMsg = !noFImessages && preferredCard && issuer ? experimentMap.memberPreferredIssuer : errorMsg;
                        errorMsg = !noFImessages && preferredCard && !issuer ? experimentMap.memberPreferredNoIssuer : errorMsg;
                        errorMsg = !noFImessages && !preferredCard && issuer ? experimentMap.memberNoPreferredIssuer : errorMsg;
                        errorMsg = !noFImessages && !preferredCard && !issuer ? experimentMap.memberNoPreferredNoIssuer : errorMsg;

                        type = experimentMap.type;
                        msg = (0, _squid.$renderContent)(errorMsg, {
                            name: informalName,
                            type: instrument.card_type,
                            issuer: issuer,
                            addCardhref: linkObj.route,
                            number: instrument.last4
                        });
                        keepMsg = true;
                    } else {
                        msg = (0, _squid.$renderContent)(contentKeys.member, {
                            type: instrument.card_type,
                            number: instrument.last4
                        });
                        checkoutSession.set('declinedInstruments', null);
                    }
                } else {
                    _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });
                    msg = (0, _squid.$renderContent)(contentKeys.generic);
                    checkoutSession.set('declinedInstruments', null);
                }
            } else {
                _logger.$logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });
                msg = (0, _squid.$renderContent)(contentKeys.buyerCredit);
                checkoutSession.set('declinedInstruments', null);
            }

            return {
                type: type,
                msg: msg,
                keepMsg: keepMsg
            };
        }
    }

    function getXoonRedirectAddCardMsg(unavailableCard, message) {
        if (!unavailableCard) {
            _logger.$logger.info(message['msgKey'] + '_card_empty');
            return {
                type: 'info',
                msg: (0, _squid.$renderContent)('creditcard.noFIContingency')
            };
        }

        var msg = (0, _squid.$renderContent)(message['msgKey']);
        var type = message['type'];
        var showDetails = message['showDetails'];

        if (showDetails) {
            var cardType = (0, _squid.$renderContent)('cardTypes.' + unavailableCard.cardType);
            var lastDigits = unavailableCard.lastDigits;

            if (cardType && cardType.toString() && lastDigits) {
                msg = (0, _squid.$renderContent)(message['msgKey'], {
                    cardType: cardType,
                    last4: lastDigits
                });
            } else {
                msg = (0, _squid.$renderContent)('creditcard.noFIContingency');
                type = 'info';
                _logger.$logger.info(message['msgKey'] + '_detail_missing');
            }
        }

        _logger.$logger.info(message['msgKey'], { type: unavailableCard.cardType, msgType: type, msgRendered: msg ? true : false });
        return {
            type: type ? type : 'info',
            msg: msg ? msg : (0, _squid.$renderContent)('creditcard.noFIContingency')
        };
    }

    function getAddCardControlMsg(checkoutSession) {
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_control_msg'
            });
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_control_msg'
            });
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_disallowed_FI_addcard_control_msg'
            });
        }

        if (checkoutSession.isCreditDisallowedForMerchant) {
            return;
        }

        return {
            msg: (0, _squid.$renderContent)('creditcard.noFIContingency'),
            type: 'info'
        };
    }

    function getAddCardMsg(unavailableCard, _ref2, checkoutSession) {
        var retry = _ref2.retry,
            avsRetry = _ref2.avsRetry,
            redirectFromXoon = _ref2.redirectFromXoon;

        if (retry && redirectFromXoon) {
            var message = {
                msgKey: 'addFiError.declinedRetryWithCardDetails',
                type: 'warning',
                showDetails: true
            };
            return getXoonRedirectAddCardMsg(unavailableCard, message);
        } else if (redirectFromXoon && avsRetry) {
            var _message = {
                msgKey: 'addFiError.declinedWithBilling',
                type: 'warning',
                showDetails: true
            };
            return getXoonRedirectAddCardMsg(unavailableCard, _message);
        } else if (redirectFromXoon && !retry && !avsRetry) {
            var _message2 = {
                msgKey: 'creditcard.noFIContingency',
                type: 'info',
                showDetails: false
            };
            return getXoonRedirectAddCardMsg(unavailableCard, _message2);
        }
        return getAddCardControlMsg(checkoutSession);
    }

    function getAddCardTreatmentMsg(checkoutSession) {
        var msg = void 0;
        var type = void 0;
        var title = void 0;
        var cardList = void 0;
        var lastCard = void 0;
        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
        disallowedInstruments = disallowedInstruments.filter(function (instrument) {
            return instrument.type && instrument.type !== 'REWARDS' && instrument.type !== 'BALANCE';
        });

        if (disallowedInstruments && disallowedInstruments.length === 1) {
            cardList = disallowedInstruments[0].lastDigits ? disallowedInstruments[0].name + '-' + disallowedInstruments[0].lastDigits : disallowedInstruments[0].name;
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'single_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasSingleDisallowedFi', { cardList: cardList });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else if (disallowedInstruments && disallowedInstruments.length > 1) {
            cardList = '';

            for (var i = 0; i < disallowedInstruments.length; i++) {
                if (i === disallowedInstruments.length - 1) {
                    lastCard = disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else if (i === disallowedInstruments.length - 2) {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits : disallowedInstruments[i].name;
                } else {
                    cardList += disallowedInstruments[i].lastDigits ? disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits + ', ' : disallowedInstruments[i].name + ', ';
                }
            }

            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'multi_disallowed_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasMultipleDisallowedFi', { cardList: cardList, lastCard: lastCard });
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.hasDisallowedAddCardTitle');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'int_error_description': 'has_no_FI_addcard_msg'
            });
            msg = (0, _squid.$renderContent)('creditcard.hasNoDisallowedFi');
            type = 'normal';
            title = (0, _squid.$renderContent)('creditcard.noDisallowedAddCardTitle');
            if (checkoutSession.isCreditDisallowedForMerchant) {
                return;
            }
        }

        return {
            msg: msg,
            type: type,
            title: title
        };
    }

    // User with only banks in disallowed list with message indicating the same
    function getAddBankTreatmentMsg() {
        return {
            msg: (0, _squid.$renderContent)('bank.disallowedAddCard'),
            type: 'normal'
        };
    }

    // Add card contingency for the case where card fails preauth; Show message which indicates that card failed pre-auth
    function getPreAuthTreatmentMsg() {
        var preAuthDisallowed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var disallowedInstrument = preAuthDisallowed[0];


        return {
            msg: (0, _squid.$renderContent)('creditCard.preAuthNoIssuer', {
                cardType: disallowedInstrument && disallowedInstrument.name || '',
                last4: disallowedInstrument && disallowedInstrument.lastDigits || 'xxxx'
            }),
            type: 'info'
        };
    }

    function getGamblingMsg() {
        return {
            type: 'error',
            msg: (0, _squid.$renderContent)('genericError.creditCardIneligible')
        };
    }

    return {
        isDeclinedCard: isDeclinedCard,
        processorDeclinedMsg: processorDeclinedMsg,
        getGamblingMsg: getGamblingMsg,
        getAddCardTreatmentMsg: getAddCardTreatmentMsg,
        getAddCardControlMsg: getAddCardControlMsg,
        getAddCardMsg: getAddCardMsg,
        getAddBankTreatmentMsg: getAddBankTreatmentMsg,
        getPreAuthTreatmentMsg: getPreAuthTreatmentMsg
    };
});

_squid.$renderContent;

_logger.$logger;

_constants.issuerDeclineExperimentMap;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-models/src/fi/lib", "../node_modules/xo-models/src/fi/lib/fiMessages.js"))

/***/ }),

/***/ "../node_modules/xo-models/src/fiMeta/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

var _dist = __webpack_require__("../node_modules/squid/dist/index.js");

var PADSUBTYPE = 'DELAYED_TRANSFER';
var MEFTSUBTYPE = 'MEFT';
var IACHSUBTYPE = 'IACH';
var ECHECKSUBTYPE = 'ECHECK';

// any mappings to normalize fi name
var NAME_MAPPINGS = {
    'MERCHANT_SPECIFIC_BALANCE': 'INCENTIVE'
};

// eslint-disable-next-line no-confusing-arrow
var allFis = function allFis(plan) {
    return plan.secondaryFIs ? [plan.primaryFs].concat(plan.secondaryFIs) : [plan.primaryFs];
};

var isSubType = function isSubType(subtype) {
    return function (fi) {
        return fi.subtype === subtype || fi.sub_type === subtype;
    };
};

var capFirst = function capFirst(product) {
    return product && product.charAt(0).toUpperCase() + product.slice(1).toLowerCase();
};

exports['default'] = _squid.$Model.extend('$FiMetaModel', {
    invalidateOnLogout: true,

    onInvalidate: function onInvalidate() {
        if (this.session) {
            delete this.session;
        }
        if (this.wallet) {
            delete this.wallet;
        }
    },
    fetch: function fetch() {
        var _this = this;

        if (_squid.$config.disableCardArt) {
            return _squid.$promise.resolve(this);
        } else {
            return _squid.$promise.all({
                session: _checkout.$CheckoutSessionModel.instance(this.id).retrieve(),
                wallet: _wallet.$WalletModel.instance(this.id).retrieve()
            }).then(function (r) {
                return _squid.$util.extend(_this, r);
            });
        }
    },
    cardArtEnabled: function cardArtEnabled() {
        if ((0, _squid.$feature)('cardArtEnabled', false)) {
            // return true if feature config enabled for countries and have wallet
            return this.wallet && true;
        }

        return false;
    },
    getCardArt: function getCardArt(fi) {
        return this.wallet && this.cardArtEnabled() && this.wallet.getCardArt(fi);
    },
    plans: function plans() {
        return this.session.fundingOptions.plans;
    },
    hasPadPlan: function hasPadPlan() {
        return this.plans().map(allFis).some(function (fis) {
            return fis.some(isSubType(PADSUBTYPE));
        });
    },
    type: function type(fi) {
        if (fi.type === 'CREDIT' || fi.type === 'BILL_ME_LATER') {
            return 'CREDIT';
        } else {
            return fi.type;
        }
    },
    getName: function getName(fi) {
        if (fi.isPinlessDebit || fi.is_pinless_debit) {
            return (0, _dist.$renderContent)('fsMappings.PINLESSDEBIT');
        }

        // Normalize fs name for content key lookup
        var name = NAME_MAPPINGS[fi.name] || fi.name;

        return this.wallet && this.wallet.getCustomName(fi) || (0, _dist.$renderContent)('fsMappings.' + name).toString() || name;
    },
    getAmount: function getAmount(fi) {
        return fi.amount;
    },
    getCurrencyCode: function getCurrencyCode(fi) {
        return fi.amount.currency_code;
    },
    getAllCurrencyCodes: function getAllCurrencyCodes(plan) {
        return allFis(plan).map(this.getCurrencyCode);
    },
    getCardMask: function getCardMask(fi) {
        var mask = this.wallet && this.wallet.getCardMask(fi);

        if (!mask.before) {
            mask.before = capFirst(fi.productClass);
        }
        if (!mask.after) {
            mask.after = fi.lastDigits || fi.last4;
        }
        return mask;
    },
    isPinlessDebit: function isPinlessDebit(fi) {
        return fi.is_pinless_debit || fi.isPinlessDebit;
    },
    isPad: function isPad(fi) {
        return isSubType(PADSUBTYPE)(fi) || isSubType('PAD')(fi);
    },
    isMeft: function isMeft(fi) {
        return isSubType(MEFTSUBTYPE)(fi);
    },
    isIach: function isIach(fi) {
        return isSubType(IACHSUBTYPE)(fi);
    },
    isEcheck: function isEcheck(fi) {
        return isSubType(ECHECKSUBTYPE)(fi);
    },
    getEditDisallowedContentKey: function getEditDisallowedContentKey(fi) {
        if (!fi) {
            return;
        }
        if (fi.editDisallowedMsg) {
            return 'wallet.' + fi.editDisallowedMsg;
        } else if (this.wallet.isLinkedCard(fi)) {
            return 'wallet.editDisallowedPayment';
        }
    }
});


_squid.$Model;

_squid.$promise;

_squid.$util;

_squid.$config;

_squid.$feature;

_checkout.$CheckoutSessionModel;

_wallet.$WalletModel;

_dist.$renderContent;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-models/src/gdprCookieBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GDPRCookieBannerModel = exports.isGdprValid = exports.testGdprBannerCookie = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var testGdprBannerCookie = exports.testGdprBannerCookie = function testGdprBannerCookie(cookies) {
    return (/(^|;\s*)cookie_prefs=/.test(cookies)
    );
};

var isGdprValid = exports.isGdprValid = function isGdprValid() {
    if (_squid.$util.param('forceGDPR')) {
        return true;
    }

    var country = _squid.$locale.country;

    return _squid.$util.getProperty(_squid.$config, 'GDPR.cookieBanner', { 'default': false }) && _squid.$util.getProperty(_squid.$config, 'GDPR.countries', { 'default': [] }).indexOf(country) > -1;
};

var $GDPRCookieBannerModel = exports.$GDPRCookieBannerModel = _squid.$Model.extend('$GDPRCookieBannerModel', {
    api: new _squid.$Api({
        uri: '/api/cookieBanner'
    }),

    /**
     * Handles the logic for when to fetch the banner and when to return
     * Don't repeat the call for same country
     * Don't return the banner if not PXP check
     * @returns {Promise} resolves an object
     */
    getBanner: function getBanner() {
        var _this = this;

        // API is cached on country. Return current result if already present
        if (this.lastResult && this.lastCountry === _squid.$locale.country && this.lastLang === _squid.$locale.lang) {
            return this.lastResult;
        }

        // Invalidate the model to make a fresh call
        this.invalidate();

        // Log if the user has cookie indicating a previous interaction with the cookie banner
        if (testGdprBannerCookie(document.cookie)) {
            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_has_cookie'
            });
        }

        // Cache the result promise and params
        this.lastCountry = _squid.$locale.country;
        this.lastLang = _squid.$locale.lang;
        this.lastResult = this.retrieve().then(function (res) {
            var html = res.html,
                css = res.css,
                js = res.js;


            if (!html || !js || !css) {
                _logger.$logger.info('gdpr_response_missing_props', {
                    html: !!html,
                    js: !!js,
                    css: !!css
                });
                _this.reset();
                return;
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'GDPR_banner',
                to: 'GDPR_banner_shown'
            });

            return { html: html, css: css, js: js };
        });

        return this.lastResult;
    },
    reset: function reset() {
        this.html = '';
        this.css = '';
        this.js = '';
    },
    shown: function shown() {
        return !!this.html;
    },

    // Check if a banner was shown in the flow.
    // SOME EDGE CASES:
    //   Will not update when the user clicks to accept the banner, and it closes
    //   Will update if retrieve is called with a new country and blank data is returned
    hasBanner: function hasBanner() {
        var _this2 = this;

        // check config flag
        // check if already populated
        // make call again and let regular logic populate html
        // return boolean

        if (!isGdprValid()) {
            return _squid.$promise.resolve(false);
        }
        if (this.html) {
            return _squid.$promise.resolve(this.shown());
        }
        return this.getBanner().then(function () {
            return _this2.shown();
        });
    }
});

angular.value("testGdprBannerCookie", testGdprBannerCookie);
angular.value("isGdprValid", isGdprValid);
angular.value("$GDPRCookieBannerModel", $GDPRCookieBannerModel);
_squid.$Model;

_squid.$Api;

_squid.$locale;

_squid.$config;

_squid.$util;

_squid.$promise;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$InventoryModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
    api: new _squid.$Api({
        uri: '/api/catalog/:id/item/',
        postAttempts: 2,
        cache: true
    }),

    setInvetoryItems: function setInvetoryItems(inventoryItems) {
        this.inventoryItems = inventoryItems;
    },

    getInventoryItems: function getInventoryItems() {
        return this.inventoryItems;
    }
});

angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CreditOfferModel = exports.$MemberSegmentModel = exports.$fireMORSBeacon = exports.$MessageDiscoverModel = exports.$MarketingOfferModel = undefined;

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $MarketingOfferModel = exports.$MarketingOfferModel = _squid.$Model.extend('$MarketingOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/search-ads',
        postAttempts: 1,
        cache: true
    }),
    init: function init() {
        this.setProperties({ ads: [] });
        this.meta = { populated: false };
    },
    onPopulate: function onPopulate() {
        var _this = this;

        if (this.targetPlacements && this.targetPlacements[0]) {
            var targetAd = this.ads.find(function (ad) {
                return ad.valid && ad.campaign.adunit_id === _this.targetPlacements[0].placement_code;
            });

            this.ad = undefined;
            if (targetAd) {
                var ad = {};
                var nvpContent = targetAd && targetAd.content && targetAd.content.nvp;

                nvpContent.forEach(function (obj) {
                    ad[obj.name] = obj.value;
                });
                ad['impressionUrl'] = targetAd && targetAd.tracking && targetAd.tracking.impression_url;
                ad['clickUrl'] = targetAd && targetAd.tracking && targetAd.tracking.click_url;
                ad['campaignId'] = targetAd && targetAd.campaign && targetAd.campaign.campaign_id;
                ad['buyItemId'] = targetAd && targetAd.campaign && targetAd.campaign.buy_item_id;
                ad['placementCode'] = targetAd && targetAd.campaign && targetAd.campaign.adunit_id;
                this.ad = ad;
            }
        }
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.cacheParam) {
            this.cacheParam.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'site': this.site,
            'locale': this.locale,
            'si': this.si,
            'visit_id': _uuid2['default'].v4(),
            'page': this.page,
            'epu': this.payer,
            'pu_type': this.puType || 'ANONYMOUS',
            'country_code': this.countryCode,
            'payment_context': {
                'total_transaction_amount': this.totalTransactionAmount,
                'total_shipping_amount': this.totalShippingAmount,
                'business_case': 'NONE',
                'business_case_variation': '',
                'validate_existing_offer': 'false',
                'payment_units': [{
                    'transaction_amount': this.totalTransactionAmount,
                    'transaction_id': '',
                    'encrypted_transaction_id': '',
                    'activity_id': '',
                    'payee': {
                        'pu_type': 'BUSINESS',
                        'country_code': this.countryCode,
                        'epu': this.payee,
                        'pu': ''
                    }
                }]
            },
            'target_placements': this.targetPlacements,
            'wallet_instruments': this.walletInstruments,
            'addl_property_installments_not_allowed': this.installmentsNotAllowed
        };
    },
    getTargetAd: function getTargetAd() {
        return this.ad;
    },
    isAdFound: function isAdFound() {
        if (this.ad) {
            for (var property in this.ad) {
                if (this.ad.hasOwnProperty(property)) {
                    return true;
                }
            }
        }
        return false;
    }
});

var $MessageDiscoverModel = exports.$MessageDiscoverModel = _squid.$Model.extend('$MessageDiscoverModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offer/discover-messages',
        postAttempts: 1
    })
});

var $fireMORSBeacon = exports.$fireMORSBeacon = {
    fireBeacon: function fireBeacon(uri) {
        var img = document.createElement('img');

        img.setAttribute('src', uri);
        document.body.appendChild(img);
        return;
    }
};

var $MemberSegmentModel = exports.$MemberSegmentModel = _squid.$Model.extend('$MemberSegmentModel', {
    api: new _squid.$Api({
        uri: '/api/segment/memberSegment',
        postAttempts: 1
    }),
    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called
    getMemberSegment: function getMemberSegment() {
        return this.memberSegment;
    },
    getCreditOffer: function getCreditOffer() {
        return this.creditOffer;
    },
    isNewMember: function isNewMember() {
        return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
    },
    isExistingMember: function isExistingMember() {
        return this.memberSegment === 'EXISTING_MEMBER';
    },
    // Member Segments that are eligble for the New Experience
    isEligibleForExperimentation: function isEligibleForExperimentation() {
        var eligibleMemberSegments = _squid.$config.memberSegments;

        return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
    }
});

var $CreditOfferModel = exports.$CreditOfferModel = $MessageDiscoverModel.extend('$CreditOfferModel', {
    init: function init() {
        this.setProperties({
            bannerMessages: []
        });
    },
    populate: function populate(result) {
        var _this2 = this;

        if (result && result.touchpoint_messages) {
            var touchpoint_messages = result.touchpoint_messages.find(function (element) {
                return element.touchpoint_code === _this2.touchpoint;
            });

            this.storeMessages(touchpoint_messages);
        }
    },
    storeMessages: function storeMessages(touchpoint_messages) {
        if (touchpoint_messages) {
            this.viewName = touchpoint_messages.view_name;

            if (touchpoint_messages.messages) {
                var messages = touchpoint_messages.messages;

                for (var i = 0; i < touchpoint_messages.messages.length; i++) {
                    var presentmentType = messages[i].content.json.PresentmentType;

                    if (presentmentType === 'Banner') {
                        this.bannerMessages.push(messages[i]);
                    }
                }
            }
        }
    },
    getBannerCount: function getBannerCount() {
        return this.bannerMessages.length;
    },
    hasBannerMessage: function hasBannerMessage() {
        return this.getBannerCount() > 0;
    },
    getTouchpointCode: function getTouchpointCode() {
        return this.touchpoint;
    },
    getBannerMessage: function getBannerMessage(i) {
        i = !i ? 0 : i;

        if (this.getBannerCount() > i) {
            return this.bannerMessages[i];
        }
        return null;
    },
    getCacheKey: function getCacheKey() {
        var cacheKey = {};

        if (this.application_context) {
            this.application_context.forEach(function (element) {
                if (typeof element.value !== 'undefined') {
                    cacheKey[element.name] = element.value.toString();
                }
            });
        }
        return cacheKey;
    },
    serialize: function serialize() {
        return {
            'country_code': this.locale.country,
            'language': this.locale.lang + '_' + this.locale.country,
            'identity_context': [{
                'type': 'PAYER_ID',
                'value': this.payer
            }, {
                'type': 'MERCHANT_PAYER_ID',
                'value': this.payee
            }],
            'recommendation_context': {
                'view_names': this.view_names ? this.view_names : [],
                'touchpoint_details': [{
                    'code': this.touchpoint,
                    'message_count': this.message_count ? this.message_count : 1
                }]
            },
            'application_context': this.application_context
        };
    }
});

angular.value("$MarketingOfferModel", $MarketingOfferModel);
angular.value("$MessageDiscoverModel", $MessageDiscoverModel);
angular.value("$fireMORSBeacon", $fireMORSBeacon);
angular.value("$MemberSegmentModel", $MemberSegmentModel);
angular.value("$CreditOfferModel", $CreditOfferModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/newMember/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$NewMemberEligibility = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var control = 'control';
var ineligible = 'ineligible';
var one_page = 'one_page';
var design_2 = 'design_2';
var design_3 = 'design_3';

var TREATMENT_PATTERNS = {
    CONTROL: /xo_hermes_\w*_member_control/,
    ONE_PAGE: /xo_hermes_\w*_member_treatment_1/,
    DESIGN_2: /xo_hermes_\w*_member_treatment_3/,
    DESIGN_3: /xo_hermes_\w*_member_treatment_4/
};

var mapTreatment = function mapTreatment(treatment) {
    if (!treatment) {
        return;
    }

    if (TREATMENT_PATTERNS.ONE_PAGE.test(treatment)) {
        return one_page;
    }

    if (TREATMENT_PATTERNS.DESIGN_2.test(treatment)) {
        return design_2;
    }

    if (TREATMENT_PATTERNS.DESIGN_3.test(treatment)) {
        return design_3;
    }
};

var getSegmentParameters = function getSegmentParameters(token) {
    var models = {};

    return (0, _squid.$populate)(models, {
        checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
        checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
    }).then(function () {
        var data = {
            page: 'HERMES_RYI_PAGE',
            site: 'HERMES_RYI_PAGE',
            locale: _squid.$locale.lang + '_' + _squid.$locale.country,
            puType: 'PERSONAL',
            visit_id: token,
            si: token,
            payment_context: {
                business_case: 'NONE',
                business_case_variation: '',
                validate_existing_offer: 'false',
                total_transaction_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                },
                total_shipping_amount: {
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                    value: Math.round(models.checkoutCartModel.get('purchase.amounts.shipping.amount', 0) * 100)
                },
                payment_units: [{
                    transaction_amount: {
                        currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code', ''),
                        value: Math.round(models.checkoutCartModel.get('purchase.amounts.total.amount', 0) * 100)
                    },
                    transaction_id: '',
                    encrypted_transaction_id: '',
                    activity_id: '',
                    payee: {
                        pu_type: 'BUSINESS',
                        country_code: models.checkoutAppDataModel.get('merchant.merchant_country') || '',
                        epu: models.checkoutPayeeModel.merchant.id || '',
                        pu: ''
                    }
                }]
            },
            target_placements: [{
                placement_code: '210005',
                presentation_types: ['decision']
            }]
        };

        return data;
    });
};

var isMemberSegmentEligible = function isMemberSegmentEligible(token) {
    var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
    var memberSegment = memberSegmentModel.getMemberSegment();

    if (memberSegment !== undefined) {
        return _squid.$promise.resolve(memberSegmentModel.isEligibleForExperimentation());
    }

    return getSegmentParameters(token).then(function (data) {
        memberSegmentModel.invalidate();
        return memberSegmentModel.save({
            silent: true,
            data: data,
            contingencies: {
                DEFAULT: function DEFAULT(name, err) {
                    return;
                }
            }
        }).then(function () {
            return memberSegmentModel.isEligibleForExperimentation();
        })['catch'](function () {
            return false;
        });
    });
};

var eligibility = function eligibility(token, _ref) {
    var authModel = _ref.authModel,
        checkoutSessionModel = _ref.checkoutSessionModel,
        checkoutAppDataModel = _ref.checkoutAppDataModel,
        checkoutCartModel = _ref.checkoutCartModel,
        checkoutPayeeModel = _ref.checkoutPayeeModel,
        shippingRuleSummaryModel = _ref.shippingRuleSummaryModel;
    var plan = checkoutSessionModel.plan,
        negBalances = checkoutSessionModel.negBalances;

    var plans = checkoutSessionModel.get('fundingOptions.plans');

    // Ineligible reasons:
    // - multiple plans
    // - negative balance
    // - billing agreement
    // - third Party wallet (Baidu, Venmo, etc..)
    // - shipping and tax
    // - second button
    // - Android Pay
    // - Gambling
    // - Default funding source is not card
    var isMultiplePlans = plans && plans.length > 1;
    var isNegativeBalance = negBalances && negBalances.length !== 0;
    var isBilling = checkoutCartModel.isBilling();
    var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    var isShippingRulesEnabled = shippingRuleSummaryModel.isSnTEnabled;
    var isSecondButton = checkoutAppDataModel.is_second_button_txn;
    var isAPay = checkoutCartModel.isWalletTokenization();
    var isGambling = checkoutPayeeModel.isGambling();
    var isHideShipping = checkoutAppDataModel.flags.hide_shipping_address || !checkoutAppDataModel.flags.shipping_address_required;

    // Default funding source needs to be card for now.
    var isSupportedDefaultFundingSource = plan && plan.sources && plan.sources.length === 1 && plan.sources[0].type === 'PAYMENT_CARD';

    var eligibilityCriteria = {
        noMultiplePlans: !isMultiplePlans,
        noNegativeBalance: !isNegativeBalance,
        noBilling: !isBilling,
        noThirdParty: !isThirdParty,
        noSnT: !isShippingRulesEnabled,
        noSecondButton: !isSecondButton,
        noAPay: !isAPay,
        noGambling: !isGambling,
        noSupportedDefaultFundingSource: isSupportedDefaultFundingSource,
        noHideShipping: !isHideShipping
    };

    var ineligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
        return !eligibilityCriteria[key];
    });
    var transactionEligible = ineligibleReasons.length === 0;

    if (!transactionEligible) {
        var reasons = ineligibleReasons.join(':');

        _logger.$logger.info('checkout_ftpi', {
            from: 'new_member_eligibility',
            to: 'process_new_member_eligibility',
            eligibility_reason: reasons
        });
        for (var _iterator = ineligibleReasons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }

            var reason = _ref2;

            _logger.$logger.info('new_member_experience_ineligible_' + reason);
        }
        return _squid.$promise.resolve(ineligible);
    }

    // Check member segment
    return isMemberSegmentEligible(token).then(function (eligibleMember) {
        if (!eligibleMember) {
            _logger.$logger.info('new_member_experience_ineligible_member_segment');
            return ineligible;
        }

        // if merchant is on blacklist...
        if (_app.$PXPBlacklist.isMerchantBlacklisted(checkoutPayeeModel.get('merchant.id'))) {
            _logger.$logger.info('new_member_experience_ineligible_merchant_blacklisted');
            return control;
        }

        var memberSegmentModel = _marketingoffer.$MemberSegmentModel.instance();
        var memberSegment = memberSegmentModel.getMemberSegment();

        _logger.$logger.info('new_member_experience_eligible_' + memberSegment);

        return (0, _squid.$pxp)('xo_hermes_new_member_journey', {
            'uid': authModel.buyer_id,
            'ctx.COUNTRY': authModel.country,
            'ctx.SEGMENT': memberSegment }, 'xo_hermes_(\\w*)_member_treatment_(\\d)|xo_hermes_(\\w*)_member_control', false, true).then(function (t) {
            if (t) {
                var r = mapTreatment(t.treatment_name);

                return r || control;
            } else {
                return control;
            }
        });
    });
};

var snt = function snt(models, token) {
    if (_squid.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
        return (0, _squid.$populate)(models, {
            shippingRuleSummaryModel: _shippingMethod.$ShippingRuleSummaryModel.instance(token).retrieve({
                params: {
                    merchant_id: models.checkoutPayeeModel.get('merchant.id'),
                    currency_code: models.checkoutCartModel.get('purchase.amounts.total.currency_code')
                }
            })
        });
    } else {
        models.shippingRuleSummaryModel = {};
        return _squid.$promise.resolve();
    }
};

var $NewMemberEligibility = exports.$NewMemberEligibility = _squid.$Model.extend('$NewMemberEligibility', {
    getVariant: function getVariant(token) {
        var _this = this;

        if (!(0, _squid.$feature)('newMemberExperience')) {
            return _squid.$promise.resolve(ineligible);
        }

        if (_squid.$meta.corp) {
            var nmexp = _squid.$util.param('nmj_exp');

            if (nmexp === '1') {
                return _squid.$promise.resolve(one_page);
            } else if (nmexp === '2') {
                return _squid.$promise.resolve(design_2);
            } else if (nmexp === '3') {
                return _squid.$promise.resolve(design_3);
            } else if (nmexp === '0') {
                return _squid.$promise.resolve(control);
            }
        }

        var models = {};

        return (0, _squid.$populate)(models, {
            authModel: _auth.$AuthModel.instance(),
            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token),
            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token)
        }).then(function () {
            return snt(models, token);
        }).then(function () {
            // Rerun eligibility if user has changed.
            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
                return _this.variant;
            }

            _this.buyerId = models.authModel.buyer_id;
            return eligibility(token, models).then(function (variant) {
                _this.variant = variant;
                return variant;
            });
        });
    },

    isNmj: function isNmj(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    nmjShowGreyHeader: function nmjShowGreyHeader(token) {
        return this.getVariant(token).then(function (variant) {
            if (variant && (variant === 'design_2' || variant === 'design_3')) {
                return true;
            } else {
                return false;
            }
        });
    },

    getMemberSegmentParameters: function getMemberSegmentParameters(token) {
        return getSegmentParameters(token);
    }
});

angular.value("$NewMemberEligibility", $NewMemberEligibility);
_squid.$Model;

_squid.$promise;

_squid.$populate;

_squid.$feature;

_squid.$pxp;

_squid.$locale;

_squid.$meta;

_squid.$util;

_squid.$integration;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_shippingMethod.$ShippingRuleSummaryModel;

_app.$PXPBlacklist;

_marketingoffer.$MemberSegmentModel;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/processorDecline/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getProcessorDeclineRetryEligibility = getProcessorDeclineRetryEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var INELIGIBLE = _squid.$promise.resolve(false);
var lastBuyerId = null;

// Check eligibility for processor decline retry feature
// First checks if feature eligibility is met, then PXP eligibility is met
function getProcessorDeclineRetryEligibility(token, checkoutSession) {
    if (!(0, _squid.$feature)('cardBackup')) {
        return INELIGIBLE;
    }

    // TODO: Refactor the eligibility rules to a set of common rules
    var models = {};

    return (0, _squid.$populate)(models, {
        auth: _auth.$AuthModel.instance(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(token),
        checkoutPayee: _checkout.$CheckoutPayeeModel.instance(token),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token)
    }).then(function () {
        var checkoutCart = models.checkoutCart,
            checkoutPayee = models.checkoutPayee,
            checkoutAppData = models.checkoutAppData;

        var plans = checkoutSession.get('fundingOptions.plans', []);
        var moreThanOneCard = plans.filter(function (fi) {
            return fi.primaryFs.type === 'CARD';
        }).length < 2;

        // exclude rewards from the eligibility list
        var hasRewards = plans.filter(function (fi) {
            return fi && fi.rewards !== undefined;
        }).length > 0;

        // See https://engineering.paypalcorp.com/confluence/display/HellsKitchen/Hermes+Processor+Decline+Retry for eligibility reasons
        var isGambling = checkoutPayee.isGambling();
        var isBilling = checkoutCart.isBilling();
        // We're only sure that Sale transactions will go onto the new payments stack, for now
        var isNotSale = checkoutCart.get('payment_action') !== 'sale';
        var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
        // Exclude all WPS products
        var isWpsOrInvoice = checkoutAppData.get('flags.is_wps_flow') || checkoutAppData.get('flags.is_invoice_flow');
        // We will need to confirm functionality for this before we can enable for this feature
        var isMultiSellerPurchase = checkoutCart.isMultiSellerPurchase();
        var hasInstallments = checkoutSession.installments && checkoutSession.installments.length > 1;
        var involvedCurrencies = plans.reduce(function (currencies, plan) {
            currencies[plan.primaryFs.amount.currency_code] = 1;
            return currencies;
        }, {});
        // Buyer promo email routing through checkoutserv, downstream does not support
        var hasBuyerPromoEmail = checkoutAppData.get('flags.display_buyer_email_promotional_opt_in');

        if (checkoutCart.get('purchase.amounts.total.currency_code')) {
            involvedCurrencies[checkoutCart.purchase.amounts.total.currency_code] = 1;
        }

        var ineligibilityCriteria = {
            isGambling: isGambling,
            moreThanOneCard: moreThanOneCard,
            hasRewards: hasRewards,
            isBilling: isBilling,
            isNotSale: isNotSale,
            isThirdParty: isThirdParty,
            isWpsOrInvoice: isWpsOrInvoice,
            isMultiSellerPurchase: isMultiSellerPurchase,
            hasInstallments: hasInstallments,
            currencyConversion: Object.keys(involvedCurrencies).length > 1,
            hasBuyerPromoEmail: hasBuyerPromoEmail
        };
        var ineligibleReasons = Object.keys(ineligibilityCriteria).filter(function (key) {
            return ineligibilityCriteria[key];
        });
        var eligible = ineligibleReasons.length === 0;

        // Logging for FPTI
        _logger.$logger.info('checkout_fpti', {
            from: 'processor_decline_retry',
            // This logs whether user is eligible by Hermes criteria
            to: 'processor_decline_retry_' + (eligible ? 'eligible' : 'ineligible')
        });

        if (!eligible) {
            // This logs the overall result of the eligibility check
            _logger.$logger.info('processor_decline_retry_ineligible', {
                reasons: ineligibleReasons.join()
            });
        }

        return eligible;
    }).then(function (featureEligible) {
        // BuyerId is needed to make sure pxp is reloaded if a new user logs in.
        // Refactor: Make this a common pxp model that is invalidated on logout
        var buyerId = models.auth.buyerId;

        var sameBuyer = buyerId === lastBuyerId;

        lastBuyerId = buyerId;

        if (!featureEligible) {
            return false;
        }

        // Only run the PXP if the feature is eligible, as requested from analytics
        return (0, _squid.$pxp)('xo_hermes_processor_decline_retry', {}, 'xo_hermes_processor_decline_retry_treatment', sameBuyer ? false : true, true).then(function (pxpRes) {
            if (!pxpRes) {
                _logger.$logger.info('processor_decline_retry_ineligible', {
                    pxpIneligible: true
                });
            }

            return !!pxpRes;
        });
    }).then(function (eligibleWithPxp) {
        if (eligibleWithPxp) {
            _logger.$logger.info('processor_decline_retry_eligible');
        }
        return eligibleWithPxp;
    });
}

_squid.$feature;

_squid.$populate;

_squid.$promise;

_squid.$pxp;

_logger.$logger;

_thirdPartyInfo.thirdPartyExperience;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutAppDataModel;

_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MerchantPreferenceModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $MerchantPreferenceModel = exports.$MerchantPreferenceModel = _squid.$Model.extend('$MerchantPreferenceModel', {
    init: function init() {
        this._super.init.apply(this);

        this.setProperties({
            rm: _squid.$util.param('rm'), // Return Method
            return_url: _squid.$util.param('return'),
            auto_return: {
                enabled: false
            },
            pdt: {
                enabled: false
            }
        });
    },


    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/profilemanagement/:id/getMerchantPreferences'
    }),

    autoReturn: function autoReturn() {
        return this.auto_return.enabled;
    },
    pdtEnabled: function pdtEnabled() {
        return this.pdt && this.pdt.enabled;
    },
    returnUrl: function returnUrl() {
        return this.return_url || this.auto_return.url;
    },


    /**
     * 0 – redirect using GET method ( default behavior )
     * 1 – redirect using the GET method, but no payment variables are included
     * 2 – redirect using the POST method, and include all payment variables
     */
    returnMethod: function returnMethod() {
        if (this.rm === '2') {
            return this.pdtEnabled() ? 'GET' : 'POST';
        }

        return 'GET';
    },
    returnMethodSupported: function returnMethodSupported() {
        return this.returnMethod() === 'GET';
    },


    /**
     * Determines if payment details need to be sent back to the merchant.
     * @returns {boolean}
     */
    postPaymentData: function postPaymentData() {
        return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
    },


    // charset of merchant having in profile
    charSet: function charSet() {
        return this.charset;
    }
});

angular.value("$MerchantPreferenceModel", $MerchantPreferenceModel);
_squid.$Model;

_squid.$Api;

_squid.$config;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingRuleSummaryModel = exports.$ShippingMethodModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ShippingMethodModel = exports.$ShippingMethodModel = _squid.$Model.extend('$ShippingMethodModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/charges'
    }),

    getShippingMethodId: function getShippingMethodId(shippingMethodType) {
        var shippingMethodsMap = {
            DEFAULT: '0',
            AIR_SERVICE: '1',
            ECONOMY: '2',
            EXPEDITED_AIR_SERVICE: '3',
            EXPEDITED_FLAT_RATE_SHIPPING: '4',
            EXPRESS: '5',
            EXPRESS_DOMESTIC: '6',
            FREE_SHIPPING: '7',
            GROUND: '8',
            GLOBAL_PRIORITY: '9',
            INTERNATIONAL_ECONOMY: '10',
            INTERNATIONAL_EXPEDITED: '11',
            INTERNATIONAL_EXPRESS: '12',
            INTERNATIONAL_EXPRESS_AIR: '13',
            INTERNATIONAL_PRIORITY_AIR: '14',
            NEXT_DAY: '15',
            NEXT_DAY_AIR: '16',
            NEXT_DAY_AIR_ECONOMY: '17',
            ONE_DAY_SHIPPING: '18',
            OVERNIGHT: '19',
            OVERNIGHT_FLAT_RATE_SHIPPING: '20',
            PICKUP: '21',
            PRIORITY: '22',
            RUSH_DELIVERY: '23',
            STANDARD_DOMESTIC: '24',
            STANDARD_EXPEDITED: '25',
            STANDARD_FLAT_RATE_SHIPPING: '26',
            STANDARD_INTERNATIONAL: '27',
            STANDARD_SHIPPING: '28',
            STORE_PICKUP: '29',
            TWO_DAY_SHIPPING: '30',
            WORLDWIDE_SHIPPING: '31',
            TWO_DAY_AIR: '32'
        };

        return shippingMethodsMap[shippingMethodType];
    },

    isStorePickUp: function isStorePickUp(shipping_method_type) {
        return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
    }
});

var $ShippingRuleSummaryModel = exports.$ShippingRuleSummaryModel = _squid.$Model.extend('$ShippingRuleSummaryModel', {
    api: new _squid.$Api({
        uri: '/api/shippingtax/:id/rulesSummary'
    })
});

angular.value("$ShippingMethodModel", $ShippingMethodModel);
angular.value("$ShippingRuleSummaryModel", $ShippingRuleSummaryModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/subscription/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SubscriptionsV1Model = exports.$SubscriptionModel = exports.$CreateBAModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt',
        postAttempts: 3
    })
});

var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt/:id',
        postAttempts: 3,
        cache: true
    })
});

var $SubscriptionsV1Model = exports.$SubscriptionsV1Model = _squid.$Model.extend('$SubscriptionsV1Model', {
    api: new _squid.$Api({
        uri: '/api/billagmt/subscriptions/v1/:id',
        cache: true
    })
});

angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
angular.value("$SubscriptionsV1Model", $SubscriptionsV1Model);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/switchPaymentsApiServ/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$switch3DSAuthenticateModel = exports.$switch3DSLookUpModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $switch3DSLookUpModel = exports.$switch3DSLookUpModel = _squid.$Model.extend('$switch3DSLookUpModel', {
    api: new _squid.$Api({
        uri: '/api/switch/threeDSLookUp'
    })
});

var $switch3DSAuthenticateModel = exports.$switch3DSAuthenticateModel = _squid.$Model.extend('$switch3DSAuthenticateModel', {
    api: new _squid.$Api({
        uri: '/api/switch/threeDSAuthenticate'
    })
});

angular.value("$switch3DSLookUpModel", $switch3DSLookUpModel);
angular.value("$switch3DSAuthenticateModel", $switch3DSAuthenticateModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/threeDS/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThreeDSJWTModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $ThreeDSJWTModel = exports.$ThreeDSJWTModel = _squid.$Model.extend('$ThreeDSJWTModel', {
    api: new _squid.$Api({
        uri: '/api/fi/threeds'
    }),

    init: function init() {
        this._super.init.apply(this);
    },

    serialize: function serialize() {
        var data = {
            referenceId: this.referenceId,
            cardBin: this.cardBin,
            jwtIssuer: this.jwtInfo.jwtIssuer,
            jwtOrgUnitId: this.jwtInfo.jwtOrgUnitId,
            returnUrl: this.returnUrl,
            redirectUrl: this.redirectUrl,
            transactionId: this.transactionId,
            paymentAuthenticationRequest: this.paymentAuthenticationRequest
        };

        return data;
    }
});

angular.value("$ThreeDSJWTModel", $ThreeDSJWTModel);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UserEligibleToHoldBalanceModel = exports.$UserProductSubscriptionModel = exports.$AuthConsentModel = exports.$UserPhotoModel = exports.$EConsentModel = exports.$WaxUserModel = exports.$PatchPhoneModel = exports.$AddKYCModel = exports.$ValidatePhoneModel = exports.$UserInfoModel = exports.$CheckoutInputDataModel = exports.$CheckoutClientDataModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $CheckoutClientDataModel = exports.$CheckoutClientDataModel = _squid.$Model.extend('$CheckoutClientDataModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/clientData'
    }),

    merchantIdentityData: function merchantIdentityData() {
        return {
            email: this.email,
            brand_name: this.display_name,
            logo_uri: this.logo_uri,
            identity_uri: this.identity_uri
        };
    },

    validateClient: function validateClient() {
        if (this.partner_id && this.identity_uri) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_client'
            };
        }
    },
    validateRedirectUri: function validateRedirectUri(redirectUrl) {
        if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
            return {
                success: true
            };
        } else {
            return {
                success: false,
                error: 'invalid_redirect_url'
            };
        }
    }
});

var ACTION = {
    login: 'login',
    resolve: 'resolve',
    addCard: 'addCard',
    addBank: 'addBank',
    changeCurrencyConv: 'changeCurrencyConv',
    signup: 'signup',
    mandate: 'mandate',
    addCredit: 'addCredit',
    ulReturn: 'ulReturn',
    creditReturn: 'creditReturn',
    guestCurrencyConversion: 'guestCurrencyConversion',
    guestAuthentication: 'guestAuthentication',
    compliance: 'compliance'
};

var $CheckoutInputDataModel = exports.$CheckoutInputDataModel = _squid.$Model.extend('$CheckoutInputDataModel', {
    init: function init() {
        this._super.init.apply(this);
        this.setProperties({
            client_id: _squid.$util.param('client_id'),
            action: _squid.$util.param('action'),
            redirect_uri: _squid.$util.param('redirect_uri'),
            scope: _squid.$util.param('scope'),
            state: _squid.$util.param('state'),
            flow: _squid.$util.param('flow'),
            payer_id: _squid.$util.param('payer_id'),
            mandate_reference_number: _squid.$util.param('mandate_reference_number'),
            funding_option_id: _squid.$util.param('funding_option_id'),
            locale: _squid.$util.param('locale'),
            logout: _squid.$util.param('logout'),
            refresh_parent: _squid.$util.param('refresh_parent'),
            escape_hatch: _squid.$util.param('escape_hatch'),
            failedBecause: _squid.$util.param('failedBecause'),
            redirectReferrer: _squid.$util.param('redirectReferrer'),
            id_token: _squid.$util.param('prox_id'),
            nonce: _squid.$util.param('nonce'),
            hide_rm: _squid.$util.param('hideRM'),
            payloadEnc: _squid.$util.param('payloadEnc'),
            xcancel: _squid.$util.param('x-cancel'),
            xsuccess: _squid.$util.param('x-success')
        });
    },

    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: '/api/user/:id/payerId'
    }),

    isEbayTxn: function isEbayTxn() {
        return Boolean(this.client_id);
    },

    validAction: function validAction() {
        var actions = {
            login: 'login',
            resolve: 'resolve',
            addCard: 'addCard',
            addBank: 'addBank',
            changeCurrencyConv: 'changeCurrencyConv',
            signup: 'signup',
            mandate: 'mandate',
            addCredit: 'addCredit',
            ulReturn: 'ulReturn',
            creditReturn: 'creditReturn',
            guestCurrencyConversion: 'guestCurrencyConversion',
            guestAuthentication: 'guestAuthentication',
            compliance: 'compliance'
        };

        return actions.hasOwnProperty(this.action);
    },

    showRYP: function showRYP() {
        return !this.isEbayTxn();
    },

    requiresOAuth: function requiresOAuth() {
        return this.action === ACTION.login || this.action === ACTION.signup;
    },

    requiresRedirectUri: function requiresRedirectUri() {
        return this.action === ACTION.mandate || !this.requiresOAuth();
    },

    validRedirectUri: function validRedirectUri() {
        if (this.requiresRedirectUri()) {
            return Boolean(this.redirect_uri);
        }
        return true;
    },

    validate: function validate() {
        var error;
        var success = true;

        if (this.isEbayTxn()) {
            if (!this.validAction()) {
                success = false;
                error = 'invalid_action';
            } else if (!this.validRedirectUri()) {
                success = false;
                error = 'invalid_redirect_uri';
            }
        }

        return {
            success: success,
            error: error
        };
    },

    errorUrl: function errorUrl(err, errorDesc) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        if (err) {
            url += '&error=' + err;
        }
        if (errorDesc) {
            url += '&error_description=' + errorDesc;
        }

        return url;
    },

    successUrl: function successUrl(code) {
        var url = this.redirect_uri;

        url += url && url.indexOf('?') < 0 ? '?' : '&';
        url += 'state=' + encodeURIComponent(this.state);

        url += '&code=' + code;

        return url;
    },

    rmEnabled: function rmEnabled(featureEnabled) {
        return featureEnabled && this.action === ACTION.login;
    },

    hideRM: function hideRM() {
        return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
    }
});

var $UserInfoModel = exports.$UserInfoModel = _squid.$Model.extend('$UserInfoModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/session'
    })
});

var $ValidatePhoneModel = exports.$ValidatePhoneModel = _squid.$Model.extend('$ValidatePhoneModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/validatePhone',
        cache: false
    })
});

var $AddKYCModel = exports.$AddKYCModel = _squid.$Model.extend('$AddKYCModel', {
    api: new _squid.$Api({
        uri: '/api/user/:token/session/addKYC'
    })
});

var $PatchPhoneModel = exports.$PatchPhoneModel = _squid.$Model.extend('$PatchPhoneModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:token/session/patch',
        cache: false
    })
});

var $WaxUserModel = exports.$WaxUserModel = _squid.$Model.extend('$WaxUserModel', {
    api: new _squid.$Api({
        uri: '/api/user/:id/waxUser'
    })
});

var $EConsentModel = exports.$EConsentModel = _squid.$Model.extend('$EConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/eConsent'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $UserPhotoModel = exports.$UserPhotoModel = _squid.$Model.extend('$UserPhotoModel', {
    api: new _squid.$Api({
        baseURI: _squid.$config.urls.baseUrl,
        uri: 'api/user/photo'
    }),

    invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});

var $AuthConsentModel = exports.$AuthConsentModel = _squid.$Model.extend('$AuthConsentModel', {
    api: new _squid.$Api({
        uri: '/api/user/authConsent'
    })
});

var $UserProductSubscriptionModel = exports.$UserProductSubscriptionModel = _squid.$Model.extend('$UserProductSubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/user/productSubscription'
    })
});

var $UserEligibleToHoldBalanceModel = exports.$UserEligibleToHoldBalanceModel = _squid.$Model.extend('$UserEligibleToHoldBalanceModel', {
    api: new _squid.$Api({
        uri: '/api/user/eligibleToHoldBalance'
    })
});

angular.value("$CheckoutClientDataModel", $CheckoutClientDataModel);
angular.value("$CheckoutInputDataModel", $CheckoutInputDataModel);
angular.value("$UserInfoModel", $UserInfoModel);
angular.value("$ValidatePhoneModel", $ValidatePhoneModel);
angular.value("$AddKYCModel", $AddKYCModel);
angular.value("$PatchPhoneModel", $PatchPhoneModel);
angular.value("$WaxUserModel", $WaxUserModel);
angular.value("$EConsentModel", $EConsentModel);
angular.value("$UserPhotoModel", $UserPhotoModel);
angular.value("$AuthConsentModel", $AuthConsentModel);
angular.value("$UserProductSubscriptionModel", $UserProductSubscriptionModel);
angular.value("$UserEligibleToHoldBalanceModel", $UserEligibleToHoldBalanceModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$WalletModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _instrument = __webpack_require__("../node_modules/xo-models/src/wallet/instrument.js");

// ID https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data
var imageSizeId = '0';

var normalize = function normalize(instId) {
    return instId && instId.replace(/-/g, '');
};

var imageTypes = ['png', 'jpg', 'gif', 'bmp'];
var imageType = function imageType(mimeType) {
    return _squid.$util.find(imageTypes, function (t) {
        return mimeType.indexOf(t) !== -1;
    }) || 'png';
};

// Network types to check for linked cards
var NETWORK_TYPES = {
    CHASE: 'CHASENET'
};

function capFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function getLinkedCapability(cardData) {
    return cardData.fs.capabilities.find(function (cap) {
        return cap.name === 'TOKEN';
    });
}

var $WalletModel = exports.$WalletModel = _squid.$Model.extend('$WalletModel', {
    invalidateOnLogout: true,
    api: new _squid.$Api({
        uri: '/api/fi/wallet/wallet'
    }),

    getId: function getId(fs) {
        return normalize(fs.instrument_id || fs.id);
    },

    getCardMask: function getCardMask(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return { mask: true };
        }

        var selector = rep.type === 'card' ? 'product_class' : 'type';
        var renderedType = void 0;

        if (rep.fs[selector] === 'UNKNOWN' || !rep.fs[selector]) {
            renderedType = '';
        } else {
            renderedType = capFirst(rep.fs[selector]) + ' ';
        }

        return {
            before: renderedType,
            mask: true,
            after: rep.fs.last_nchars || rep.fs.last_nchars_card_number || ''
        };
    },

    /**
     * Returns the wallet API data for a FI given a funding source from the checkoutSession model
     * @returns {Instrument|BankInstrument|null}
     */
    getWalletRepresentation: function getWalletRepresentation(fs) {
        // Balance does not have an ID, so we search for this first
        if (fs.type === 'BALANCE') {
            var currency = fs.amount && fs.amount.currency_code;

            var bal = _squid.$util.find(this.balance_accounts, function (b) {
                return b.currency_code === currency;
            });

            return bal ? new _instrument.Instrument({
                type: 'balance',
                fs: bal
            }) : null;
        }

        // Otherwise, search other types that have IDs
        var id = this.getId(fs);

        return this.getById(id);
    },


    /**
     * Returns the wallet API data for a FI based on the id provided
     * @returns {Instrument|BankInstrument|null} - the model of the FI, if found
     */
    getById: function getById(id) {
        if (!id) {
            return null;
        }

        return this.getCardById(id) || this.getBankById(id) || null;
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCardById: function getCardById(id) {
        var card = _squid.$util.find(this.card_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return card && new _instrument.Instrument({
            type: 'card',
            fs: card
        });
    },


    /**
     * Return the wallet API data for a FI of a bank id provided
     * @returns {BankInstrument}
     */
    getBankById: function getBankById(id) {
        var bank = _squid.$util.find(this.bank_accounts, function (b) {
            return normalize(b.id) === id;
        });

        return bank && new _instrument.BankInstrument({
            type: 'bank',
            fs: bank
        });
    },


    getCustomName: function getCustomName(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return false;
        }

        return rep.type === 'card' && rep.fs.issuer && rep.fs.issuer.issuer_product_description;
    },

    getCardArt: function getCardArt(fs) {
        try {
            var cardId = this.getId(fs);
            var card = this.getCardById(cardId);
            var primary_content = card.fs.card_art_details.card_art.primary_content;

            var base = primary_content.base_cdn_link_path || primary_content.base_cdnlink_path;

            var path = base + imageSizeId + '.' + imageType(primary_content.original_mime_type);

            return path;
        } catch (e) {
            return null;
        }
    },

    /**
     * retrieve list of total balances (each currency is a separate balance account)
     * Notes:
     * 1. Skip balances with '0' amount
     * 2. Since wallet returns amount in "cents" - convert it to "dollars".
     *    For us it's safe to divide by 100 as PayPal doesn't support currencies with more than 2 decimal points.
     *    For those currencies with no decimal points - wallet adds two zeros, e.g
     *        in case of JPY - 1 JPY will be sent as 100 to the response
     */
    getAmountsOfBalances: function getAmountsOfBalances() {
        var balances = [];

        this.get('balance_accounts', []).forEach(function (balanceAccount) {
            var _balanceAccount$sub_b = balanceAccount.sub_balances.find(function (subBalance) {
                return subBalance.type === 'TOTAL_BALANCE';
            }),
                amount = _balanceAccount$sub_b.amount;

            if (amount.value !== '0') {
                balances.push({
                    value: Number(amount.value) / 100,
                    currency: amount.currency
                });
            }
        });

        return balances;
    },

    isLinkedCard: function isLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var hasLinkedCapability = card && !!getLinkedCapability(card);

        return hasLinkedCapability;
    },


    /**
     * Check if the given CI passed is a ChasePay linked card, which means it was added by linking to their Chase account
     */
    isChaseLinkedCard: function isChaseLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var linkedCapability = card && getLinkedCapability(card);

        if (!linkedCapability) {
            return false;
        }

        return linkedCapability.network_contingencies.some(function (networkInfo) {
            return networkInfo.network === NETWORK_TYPES.CHASE;
        });
    }
});

angular.value("$WalletModel", $WalletModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_instrument.Instrument;

_instrument.BankInstrument;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/instrument.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.BankInstrument = exports.Instrument = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

/*
 * Base model for wallet instrument data, to be used as a fallback if more specific
 * model does not exist
 */
var Instrument = exports.Instrument = _squid.$Class.extend('Instrument', {
    getName: _squid.$util.noop,
    getLastChars: _squid.$util.noop
});

var BankInstrument = exports.BankInstrument = Instrument.extend({
    getName: function getName() {
        return this.get('fs.issuer.name');
    },
    getLastChars: function getLastChars() {
        return this.get('fs.last_nchars');
    }
});

_squid.$util;

_squid.$Class;

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _wpsAutobilling = __webpack_require__("../node_modules/xo-page-components/src/constants/wpsAutobilling.js");

/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

function mapBaResponse(baResponseData) {
    var mappedAutobillingDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var payment_definition = plan && plan.payment_definitions && plan.payment_definitions[0];
    var mappedTerms = [];

    mappedAutobillingDetails.currencyCode = plan && plan.currency_code;

    if (payment_definition) {

        var eachMappedTerm = {
            amount: payment_definition.amount && payment_definition.amount.value / 100,
            billPeriod: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD,
            periodType: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE,
            billFrequency: _wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY,
            totalCycles: _wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE
        };

        if (!mappedAutobillingDetails.currencyCode) {
            mappedAutobillingDetails.currencyCode = payment_definition.amount && payment_definition.amount.currency;
        }

        mappedTerms.push(eachMappedTerm);
        mappedAutobillingDetails.autobillingTerms = mappedTerms;
    }

    return mappedAutobillingDetails;
}

/**
 * Prepare and return a autobilling terms
 * @param baResponseData
 * @returns {Object} Containing Autobilling Terms Text
 */
function getTermsText(baResponseData) {
    var autoBillingDetails = mapBaResponse(baResponseData);
    var termText = void 0;
    var templatePlaceholderData = {
        amount: getFormattedCurrency(+autoBillingDetails.autobillingTerms[0].amount, autoBillingDetails.currencyCode, false)
    };
    termText = _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData) && _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData).toString();
    return termText;
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];
    return itemDetails.options || [];
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;

    return name;
}

module.exports = {
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getTermsText: getTermsText
};

_squid.formatCurrency;

_squid.Content;

_wpsAutobilling.CONTENT_KEY;

_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD;

_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE;

_wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY;

_wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE;

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _autobillingTerms = __webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js");

var _autobillingTerms2 = _interopRequireDefault(_autobillingTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemOptions: _autobillingTerms2['default'].getItemOptions,
    getItemName: _autobillingTerms2['default'].getItemName,
    getTermsText: _autobillingTerms2['default'].getTermsText
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _autobillingTerms = __webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/index.js");

var _autobillingTerms2 = _interopRequireDefault(_autobillingTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$autobilling', {
    tag: 'autobilling',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                autobillingData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _autobillingTerms2['default'].getItemName(this.models.autobillingData);
            this.itemOptions = _autobillingTerms2['default'].getItemOptions(this.models.autobillingData);
            this.getTermsText = function () {
                return _autobillingTerms2['default'].getTermsText(_this.models.autobillingData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"autobillingTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"autobillingDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\" data-test-id=\"autobilling-minicart-itemname\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"autobill-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-termsTitle\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\" data-test-id=\"autobilling-minicart-termsText\">\n                <span class=\"term-line\" ng-bind-html=\"getTermsText()\"></span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('cartWrapper', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            showAmt: '=?',
            showArrow: '=?',
            token: '=?',
            baToken: '=?'
        },
        controller: ['$scope', function ($scope) {
            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
            }).then(function () {
                if ($scope.checkoutCart.isSubscriptionsV1()) {
                    $scope.showAmt = true;

                    (0, _squid.$populate)($scope, {
                        subscriptionsV1Data: _index2.$SubscriptionsV1Model.instance($scope.baToken)
                    }).then(function () {
                        var planReview = $scope.subscriptionsV1Data.planReview;

                        var plan = planReview.new_plan || planReview.current_plan;

                        $scope.subscriptionAmount = _subscriptionTerms2['default'].getFormattedAmount(_subscriptionTerms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value'));
                        $scope.currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');
                    })['catch'](_angular.noop);
                }

                if ($scope.checkoutCart.purchase) {
                    $scope.currencyCode = $scope.checkoutCart.purchase.amounts.total.currency_code;
                }

                $scope.getAmount = function () {
                    if ($scope.checkoutCart.isSubscriptionsV1()) {
                        return $scope.subscriptionAmount;
                    } else if ($scope.checkoutCart.purchase) {
                        return $scope.checkoutCart.purchase.amounts.total.amount;
                    }
                };
            });
        }]
    };
});

_angular.noop;

_squid.$populate;

_squid.$util;

_index.$CheckoutCartModel;

_index2.$SubscriptionsV1Model;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt && getAmount()\">\n            <format-currency class=\"formatCurrency\" code=\"currencyCode\"\n                             amount=\"getAmount()\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/directive.js");

var _showCartDecision = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/showCartDecision.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoCart', function () {
    return {
        template: _template2['default'],
        restrict: 'E',

        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            overrideShowDetails: '=?',
            detailsExpanded: '=?',
            token: '=?'
        },

        controller: ['$scope', function ($scope) {

            _squid.$util.assert($scope.token, 'Expected token');

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
                checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                payee: _index.$CheckoutPayeeModel.instance($scope.token)
            }).then(function loadCartData() {

                var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                var cartDesc = $scope.checkoutCart.get('purchase.description');

                $scope.note = $scope.checkoutCart.get('note');

                // resolve string in descriptions array since the only element may be `null`
                // TODO: fix backend to return a string, to avoid this conditional
                if (cartDesc && angular.isString(cartDesc[0])) {
                    cartDesc = cartDesc[0];
                } else {
                    cartDesc = '';
                }

                $scope.desc = cartDesc;
                $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
                var showCartDetails = !$scope.checkoutAppData.flags.hide_cart_details;
                var notMultiSellerPurchase = !$scope.checkoutCart.isMultiSellerPurchase();
                // Always Render minicart for wps subscription .
                var wpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
                var wpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
                var wpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();
                var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

                $scope.wpsSubscription = wpsSubscription;
                $scope.wpsInstallmentPlan = wpsInstallmentPlan;
                $scope.isSubscriptionsV1 = isSubscriptionsV1;
                $scope.wpsAutobilling = wpsAutobilling;

                // We need non empty value for merchantDisplayName in #merchant-name tag of installmentPlan	
                $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
                    nonEmptyReturnValue: true,
                    isSentenceBeginning: true
                });

                var wpsBillingFlow = wpsSubscription || wpsInstallmentPlan || isSubscriptionsV1 || wpsAutobilling;
                var cartDetails = showCartDetails && (cartDesc || $scope.overrideShowDetails || $scope.hasItems || $scope.note) && notMultiSellerPurchase;

                $scope.showArrow = wpsBillingFlow || cartDetails;

                // add details to render to the checkoutCart items
                $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                    item.details = {};

                    if (item.quantity > 1) {
                        item.details.price = item.price.amount;
                        item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
                    }

                    if (item.description) {
                        if (!item.name) {
                            item.name = item.description;
                        } else {
                            item.details.description = item.description;
                        }
                    }

                    // move options to detail section
                    if (item.item_option_selections) {
                        item.details.hasSelections = true;
                        item.details.item_option_selections = item.item_option_selections;
                    }

                    if (item.sku) {
                        item.details.sku = item.sku;
                    }

                    item.hasDetails = Object.keys(item.details).length > 0;
                    item.details.hasMore = item.hasDetails || item.details.hasSelections;
                });

                // Mapping of field name as recieved by API to corresponding property key
                $scope.amountHeaders = {
                    'total': 'header.total',
                    'subtotal': 'header.itemTotal',
                    'tax': 'header.tax',
                    'shipping': 'header.shipping',
                    'insurance': 'header.insurance',
                    'handling_fee': 'header.handling',
                    'shipping_discount': 'header.shippingDiscount',
                    'description': 'header.description',
                    'discount': 'header.discount',
                    'checkout': 'header.checkout'
                };

                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                // are not available and purchase amount is not zero.
                var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;

                var purchase = $scope.checkoutCart.purchase;
                var total = purchase && purchase.amounts && purchase.amounts.total;

                $scope.isCartTextTotalOrSubTotal = userAction === 'commit' || $scope.showCartTotal === true ? 'header.total' : 'header.subTotal';

                var isWPSBilling = $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1() || $scope.checkoutAppData.isWpsAutobillingFlow();

                return (0, _showCartDecision.showCartDecision)(isWPSBilling, total, $scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (result) {
                    $scope.showAmt = result.showAmt;
                    $scope.showCartSubTotal = result.showCartSubTotal;
                    $scope.showAmountInCartIcon = result.showAmountInCartIcon;
                });
            }).then(function handleCartOpenClose() {
                // the cart is only automatically open under the following criteria:
                // 1. the cart has a 'note to buyer' ($scope.note is defined)
                // 2. the cart was not previously automatically opened before
                // 3. the state has transitioned to checkout.review or checkout.guest
                // OR `detailsExpanded` is passed as true to the component
                function decideShowCart(currentState) {
                    var falsePositive = /^checkout\.(selectFi)$/.test(currentState) && /^checkout\.(review|guest)$/.test($scope.openedAlready);
                    var notOpened = !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState);
                    var canShow = notOpened || falsePositive;

                    if ($scope.note && canShow || $scope.detailsExpanded) {
                        $scope.openedAlready = currentState; // may have been undefined before
                        return true;
                    }

                    return false;
                }

                $scope.showCartItem = function (breakdown) {
                    return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
                };

                $scope.showCart = decideShowCart(_uiRouter.$state.current.name);

                // TODO: Must we really couple this so tightly with the state transition names?
                var openCartListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
                    $scope.showCart = decideShowCart(toState.name);
                });

                $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

                $scope.toggleCart = function ($event) {
                    $scope.showCart = !$scope.showCart;
                    $event.preventDefault();
                };

                $scope.closeCart = function ($event) {
                    $scope.showCart = false;
                    // for accessible autofocus on cart toggle link button
                    $scope.$broadcast('cart-closed');
                    if ($event) {
                        $event.preventDefault();
                    }
                };

                $scope.$on('clickBody', function ($event, target) {
                    if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
                        $scope.closeCart($event);
                        $scope.$apply();
                    }
                });

                // this listener / broadcast allows accessibility components to scan and focus inside the cart
                // when the cart is displayed
                $scope.$watch('showCart', function (showCart) {
                    if (showCart) {
                        $scope.$broadcast('cart-updated');
                    }
                });
            }).then(function handleEllipsisIssues() {
                // NOTE: the scattered broadcasts of "cart-updated" events are mostly
                // to allow the accessibility directives modal-box and focus-when to
                // know when to recalculate keyboard behavior / focus
                $scope.toolongTracker = {};

                // this function is invoked by the onEllipsis directive that tracks
                // if the item name won't fit within the restricted space.
                $scope.toolong = function (idx) {
                    $scope.toolongTracker[idx] = true;
                    $scope.$broadcast('cart-updated');
                };

                $scope.showMore = function (idx, type) {
                    // there are 2 types of more, "floating" when the name is too long
                    // and "inline" when the name can fit, but there are additional details.
                    //
                    // Show a more if the item
                    // 1. has an expanded state
                    // 2. is not already expanded
                    // 3. if it is appropriate to show that type.
                    var itemIsTooLong = $scope.toolongTracker[idx];
                    var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';

                    return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
                };

                $scope.expandedIndex = -1; // initially, none of the line items are expanded
                $scope.isExpanded = function isExpanded(idx) {
                    return idx === $scope.expandedIndex;
                };
                $scope.hasExpandedState = function hasExpandedState(idx) {
                    // A line item is exandable if
                    // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
                    // 2. there are details (attached to purchase.items in the cart)
                    // 3. there is item number (sku) in the item
                    var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
                    var nameTooLong = $scope.toolongTracker[idx];

                    return nameTooLong || item.hasDetails || item.sku;
                };
                $scope.expand = function expand(idx) {
                    $scope.expandedIndex = idx;
                    $scope.$broadcast('cart-updated');
                };
                $scope.collapse = function collapse() {
                    $scope.expandedIndex = -1;
                    $scope.$broadcast('cart-updated');
                };

                // Set default focus on cart first element "more" link
                $scope.focusElementCssSelector = 'a.more';

                // Change the focus element as user clicks on elements
                $scope.$watch('expandedIndex', function (expandedIndex) {
                    if (expandedIndex === -1) {
                        $scope.focusElementCssSelector = 'a.more';
                    } else {
                        // If any "more" link or item is clicked in cart, then
                        // set focus to itemNameContainer
                        $scope.focusElementCssSelector = '.itemNameContainer.expanded';
                    }
                });

                $scope.$emit('dataLoaded');
            });
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$util;

_squid.formatQuantity;

_uiRouter.$state;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_showCartDecision.showCartDecision;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _installmentplanTerms = __webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/index.js");

var _installmentplanTerms2 = _interopRequireDefault(_installmentplanTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$installmentplan', {
    tag: 'installmentplan',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        },
        merchantName: {
            type: 'var',
            optional: false
        }
    },

    resolve: {
        models: function models() {
            return {
                installmentPlanData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {

            var installmentData = _installmentplanTerms2['default'].getInstallmentPlanData(this.models.installmentPlanData);
            this.itemName = _installmentplanTerms2['default'].getItemName(this.models.installmentPlanData);
            this.total = installmentData.formattedTotalAmount;
            this.getFirstAmount = function () {
                return installmentData.formattedFirstAmount;
            };
            this.getTermsText = function () {
                return installmentData.termsText;
            };
            this.getAmountText = function () {
                return installmentData.amountText;
            };
            this.getDisplayTotal = function () {
                return installmentData.displayTotal;
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"installmentPlanTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"installmentPlanDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.installmentPlanDetails')}}:</h4>\n            <div class=\"content\">\n                <span class=\"item-name\">{{itemName}}</span>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.billCycle')}}:\n            </h4>\n            <div class=\"bill-cycle\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\" ng-repeat=\"amount in getAmountText() track by $index\">{{amount}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\" ng-if=\"getDisplayTotal()\">\n            <div class=\"display-total\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" >{{content('wpsInstallmentPlan.message.total')}}:</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\">{{total}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentPlanLegal\">\n            <div class=\"content\">\n                <div class=\"legal-text\">{{content('wpsInstallmentPlan.message.installmentPlanLegalText')}}</div>\n                <div class=\"legal-info\">{{content('wpsInstallmentPlan.message.installmentPlanLegalTextSuggestion', {merchantName})}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('itemDetails', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            details: '=?',
            sku: '=?',
            currencyCode: '=?',
            onClickLess: '&?'
        },
        controller: function controller() {/* dumb component */}
    };
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul focusable content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections track by $index\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n  </li>\n</ul>\n<a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {



/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */

exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports['default'] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
    // Escape opening tags on vulnerable tags
    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
    element.innerHTML = input;
    return element.textContent || element.innerText;
}

function decodeEntitiesAngularFilter() {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    // Retrieve the converter element rather than create one every
    // time. Angular may call this filter many times repeatedly and
    // we should make a small effort to optimize the process
    var converter = window[ENTITY_ELEM];

    /**
     * Takes a string with HTML entities within and renders it as the unicode
     * characters they represent. This is done by leveraging the browser to
     * perform this transformation internally. InnerText is chosen as the output
     * so as to kill any HTML itself that was supplied.
     *
     * @param {String} input a String containing HTML entities that need to be
     * decoded and HTML stripped.
     * @return {String} the same string with HTML tags removed and entities
     * decoded.
     */
    return decodeEntities.bind(null, converter);
}

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$pxpCartAmt', function () {
    return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
        if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
            var pageName = 'xo_hermes_no_line_item_details';
            var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
            var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';

            return _angular.$q.all([(0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtBlacklistTreatment, false, true), (0, _squid.$pxp)(pageName, {
                'ctx.merchantID': merchantId,
                uid: merchantId
            }, showAmtTreatment, false, true)]).then(function (results) {
                var showAmtBlacklist = results[0];
                var showAmt = results[1];

                if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
                    return true;
                }

                if (showAmt && showAmt.treatment_name === showAmtTreatment) {
                    return true;
                }

                return false; // default to hide
            });
        }

        return _angular.$q.when(!noLineItemDetails && isPurchase);
    };
});

_squid.$pxp;

_angular.$q;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/cart/lib", "../node_modules/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/showCartDecision.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.showCartDecision = showCartDecision;

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

function showCartDecision(isWps, total, merchantCountry, merchantId, noLineItemDetails, isPurchase) {
    return (0, _pxp.$pxpCartAmt)(merchantCountry, merchantId, noLineItemDetails, isPurchase).then(function (showAmount) {
        // Show cart subtotal if there is a total amount
        // Do not show subtotal for wps subscription flow.
        // Show amount in cart icon only if showAmount is truthy and total amount is not zero
        return {
            showAmt: showAmount,
            showCartSubTotal: showAmount && total && !isWps, //  checking for  isWpsSubscriptionFlow & isWpsInstallmentPlan & isWpsAutobillingFlow
            showAmountInCartIcon: showAmount && +total.amount !== 0
        };
    });
}

_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _decode_entities = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/decode_entities.js");

var _decode_entities2 = _interopRequireDefault(_decode_entities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
    var elemRect = elem.getBoundingClientRect();

    // cross browser, returns decimals for ultra-precision
    return elemRect.right - elemRect.left;
}

function getNaturalWidth(elem) {
    var old = {
        overflow: elem.style.overflow,
        width: elem.style.width,
        display: elem.style.display
    };
    var result = void 0;

    elem.style.overflow = 'visible';
    elem.style.width = 'auto';
    elem.style.display = 'inline-block';
    result = getVisibleWidth(elem);
    elem.style.overflow = old.overflow;
    elem.style.width = old.width;
    elem.style.display = old.display;

    return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ? function (elem, style) {
    return _angular.$window.getComputedStyle(elem)[style];
} // modern browsers
: function (elem, style) {
    return elem.currentStyle[style];
}; // IE

function hasEllipsis(elem) {
    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';

    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
        return getVisibleWidth(elem) < getNaturalWidth(elem);
    }

    return false;
}

(0, _squid.$registerDirective)('onEllipsis', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function invokeSubscriber() {
                (0, _angular.$parse)(attrs.onEllipsis)(scope);
                scope.$apply();
            }

            (0, _angular.$timeout)(function () {
                if (hasEllipsis(element[0])) {
                    invokeSubscriber();
                }
            });
        }
    };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _squid.$registerDirective)('dynamicMaxheight', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function resizeContainer() {
                var $element = (0, _jquery2['default'])(element);
                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
                var siblings = $element.siblings().filter(function () {
                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');

                    return pos !== 'fixed' && pos !== 'absolute';
                }).map(function getOuterHeights() {
                    return (0, _jquery2['default'])(this).outerHeight();
                });
                var siblingsHeight = 0;
                var i = void 0;

                for (i = 0; i < siblings.length; i += 1) {
                    siblingsHeight += siblings[i];
                }

                var spaceAvailable = parentHeight - siblingsHeight;

                if (!isNaN(spaceAvailable)) {
                    $element.css('max-height', spaceAvailable + 'px');
                }
            }

            // if an expression is provided, it is used as an event to listen for and recalculate the height
            if (attrs.dynamicMaxheight) {
                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
            }

            (0, _angular.$timeout)(resizeContainer);
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$filterProvider;

_angular.$window;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscription/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$subscription', {
    tag: 'subscription',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            this.itemName = _subscriptionTerms2['default'].getItemName(this.models.subscriptionData);
            this.itemOptions = _subscriptionTerms2['default'].getItemOptions(this.models.subscriptionData);

            this.getFirstAmount = function () {
                return _subscriptionTerms2['default'].getFormattedFirstAmount(_this.models.subscriptionData);
            };

            this.getTermsText = function () {
                return _subscriptionTerms2['default'].getTermsText(_this.models.subscriptionData);
            };
        }
    }
});


_angular.noop;

_squid.$Component;

_index.$SubscriptionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"subs-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\">\n                <span class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</span>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.firstAmount')}}</h4>\n            <div ng-bind-html=\"getFirstAmount()\" class=\"content\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var _subscriptionV1Terms = __webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/index.js");

var _subscriptionV1Terms2 = _interopRequireDefault(_subscriptionV1Terms);

var _template = __webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SubscriptionsV1', {
    tag: 'subscriptions-v1',
    template: _template2['default'],
    props: {
        baToken: {
            type: 'var',
            optional: false
        },
        merchantId: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                subscriptionData: _index.$SubscriptionsV1Model.instance(this.baToken).retrieve({
                    params: {
                        merchant_id: this.merchantId
                    }
                })['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _models$subscriptionD = this.models.subscriptionData,
                planReview = _models$subscriptionD.planReview,
                billingAgreementCart = _models$subscriptionD.billingAgreementCart;

            var plan = planReview.new_plan || planReview.current_plan;

            var itemAmount = _squid.$util.getProperty(plan, 'initial_payment_info.first_payment.value');
            var isItemAmountPresent = _subscriptionV1Terms2['default'].isNumericValue(itemAmount);
            var currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');

            this.termsText = _subscriptionV1Terms2['default'].getTermsText(plan);
            this.isAutoRenew = billingAgreementCart.auto_renewal !== 'false';
            this.startDate = billingAgreementCart.start_time_formatted;
            this.itemName = _squid.$util.getProperty(plan, 'plan.name');
            var taxPercentage = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.taxPercentage');
            var taxAmount = _squid.$util.getProperty(plan, 'initial_payment_info.tax_amount');
            var taxAmountFormatted = taxAmount && _subscriptionV1Terms2['default'].getFormattedAmount(taxAmount.value, taxAmount.currency_code);
            this.taxDisclaimer = _subscriptionV1Terms2['default'].getTaxDisclaimer(taxPercentage, taxAmountFormatted);
            this.itemPrice = isItemAmountPresent && _subscriptionV1Terms2['default'].getFormattedAmount(itemAmount, currencyCode);

            this.quantity = plan.plan.quantity_supported && billingAgreementCart.quantity;
            this.shipping = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.shipping_amount.value');
            this.shippingAmount = _subscriptionV1Terms2['default'].getFormattedAmount(this.shipping, currencyCode);
            this.setupFee = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.setup_fee.value');
            this.setupFeeAmount = _subscriptionV1Terms2['default'].getFormattedAmount(this.setupFee, currencyCode);

            var totalAmount = _subscriptionV1Terms2['default'].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value');
            this.totalAmount = _subscriptionV1Terms2['default'].getFormattedAmount(totalAmount, currencyCode);
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$util;

_index.$SubscriptionsV1Model;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <div class=\"item-option\">\n                    <div ng-repeat=\"terms in termsText track by $index\">\n                        {{terms}}\n                    </div>\n                    <div ng-if=\"isAutoRenew\" class=\"subscription-terms\">{{content('subscriptions.message.renewsUntilCancelled')}}</div>\n                    <div class=\"start-date\" ng-if=\"startDate\"> {{content('subscriptions.message.startDate')}} {{ startDate }}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"landing-page-item-details-container\">\n            <div class=\"item-details-row\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ itemName }} </div>\n                <div class=\"item-details-right\" ng-if=\"itemPrice\"> {{ itemPrice }}</div>\n            </div>\n            <div class=\"item-details-row label-color\" ng-if=\"quantity\">\n                <div class=\"item-details-left\">{{ content('header.quantity') }} {{ quantity }}</div>\n                <div class=\"item-details-right\"></div>\n            </div>\n            <div class=\"item-details-row\" ng-if=\"shipping\">\n                <div class=\"item-details-left\">{{ content('header.shipping') }}</div>\n                <div class=\"item-details-right\">{{ shippingAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row\" ng-if=\"setupFee\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ content('subscriptions.message.setupFee') }}</div>\n                <div class=\"item-details-right\">{{ setupFeeAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row margin-top-30\" ng-if=\"taxDisclaimer\">\n                <div class=\"item-details-left label-color tax-indicator-before\" data-test-id=\"tax-disclaimer\">\n                    {{ taxDisclaimer }}\n                </div>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\" >{{content('header.total')}}</h4>\n            <div class=\"content\">{{ totalAmount }}</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                          token=\"token\" ba-token=\"checkoutCart.getBaToken()\"\n            ></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" id=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"focusElementCssSelector\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h2 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h2>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <subscription ng-if=\"wpsSubscription\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </subscription>\n\n                <autobilling ng-if=\"wpsAutobilling\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </autobilling>\n\n                <installmentplan ng-if=\"wpsInstallmentPlan\"\n                              ba-token=\"checkoutCart.getBaToken()\" merchant-id=\"payee.getId()\" merchant-name=\"nonEmptyMerchantDisplayName\"></installmentplan>\n\n                <subscriptions-v1 ng-if=\"isSubscriptionsV1\"\n                                  ba-token=\"checkoutCart.getBaToken()\"\n                                  merchant-id=\"payee.getId()\">\n                </subscriptions-v1>\n\n                <div ng-if=\"!(wpsSubscription) \" dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <div ng-if=\"!(wpsInstallmentPlan)\">\n                        <div ng-if=\"!(autobilling)\">\n                            <ul class=\"detail-items\" ng-if=\"hasItems\">\n                                <li ng-repeat=\"item in checkoutCart.purchase.items track by $index\" class=\"items\">\n\n                                    <div focusable class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                        <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                        <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                                    </div>\n                                    <span class=\"itemPrice\">\n                                        <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                                    </span>\n                                    <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                                </li>\n                            </ul>\n\n                            <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                                <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                                    <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts track by $index\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                        <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                        <span class=\"itemPrice\">\n                                            <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                        </span>\n                                    </li>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"!(wpsInstallmentPlan)\">\n                <div class=\"subTotal\" ng-if=\"showCartSubTotal\">\n                    <span class=\"itemNameContainer\">{{ content(isCartTextTotalOrSubTotal) }}</span>\n                        <span class=\"itemPrice\">\n                            <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                            amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"(wpsInstallmentPlan && (showAmt && hasItems))\">\n                    <span class=\"itemNameContainer\">{{ content(amountHeaders['checkout']) }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {



/* Constants for FB messenger related components */
module.exports = {
    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
    MOBILE_CHANNEL: 'MOBILE',
    WEB_CHANNEL: 'WEB',
    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
    FB_PROD_APP_ID: '1084613224964631',
    FB_PROD_PAGE_ID: {
        US: '55982004572',
        AU: '171522459698178',
        CA: '164660263560926',
        GB: '167465479930420',
        HK: '575224445931086',
        JP: '252040838174046',
        NZ: '171522459698178',
        PH: '1895483750701842',
        SG: '1405303076421245',
        IL: '369238992488',
        CZ: '199396843578121',
        DE: '109838022384872',
        AT: '109838022384872',
        CH: '109838022384872',
        FR: '124143236317',
        IT: '198366693576785',
        BR: '170288122998781',
        ES: '244240615638886',
        MX: '42433532610',
        ZA: '388473619362',
        NL: '105370782861413',
        DK: '133211860117553',
        SE: '121404111292725',
        RU: '275216545856555',
        PL: '244706038980513',
        NO: '304581546592510',
        GR: '704200349634422',
        IN: '347199669139259',
        AE: '402374783229274',
        BH: '402374783229274',
        DZ: '402374783229274',
        EG: '402374783229274',
        JO: '402374783229274',
        KW: '402374783229274',
        MA: '402374783229274',
        OM: '402374783229274',
        QA: '402374783229274',
        SA: '402374783229274',
        TN: '402374783229274',
        YE: '402374783229274',
        AR: '474276366001351',
        CL: '474276366001351',
        CO: '474276366001351',
        CR: '474276366001351',
        DO: '474276366001351',
        EC: '474276366001351',
        PE: '474276366001351',
        UY: '474276366001351',
        VE: '474276366001351'
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/wpsAutobilling.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var CONTENT_KEY = exports.CONTENT_KEY = 'wpsSubscription.message.termsText';
var WPS_AUTOBILING_BILLING_PERIOD = exports.WPS_AUTOBILING_BILLING_PERIOD = 'MONTH';
var WPS_AUTOBILING_BILLING_PERIOD_TYPE = exports.WPS_AUTOBILING_BILLING_PERIOD_TYPE = 'REGULAR';
var WPS_AUTOBILING_BILLING_FREQUENCY = exports.WPS_AUTOBILING_BILLING_FREQUENCY = 1;
var WPS_AUTOBILING_BILLING_CYCLE = exports.WPS_AUTOBILING_BILLING_CYCLE = 'Infinity';

/***/ }),

/***/ "../node_modules/xo-page-components/src/cpa-disclaimer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCpaDisclaimerComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/cpa-disclaimer/template.html");

var _template2 = _interopRequireDefault(_template);

var _factory = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTH_TYPE = {
    PARTIAL: 'PARTIAL',
    FULL: 'FULL'
};

var $xoCpaDisclaimerComponent = exports.$xoCpaDisclaimerComponent = _squid.$Component.extend('$xoCpaDisclaimer', {
    tag: 'xo-cpa-disclaimer',
    template: _template2['default'],
    props: {
        selectedmethod: {
            type: 'var',
            required: false
        },
        primaryplan: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.showReviewLaterText = false;
        },
        populate: function populate() {
            var _this = this;

            var useraction = this.models.checkoutAppData.useraction() && this.models.checkoutAppData.useraction().toLowerCase();
            var buttonLabelIsPay = !!(useraction === 'commit' || _squid.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW'));
            var getPlanId = function getPlanId(obj) {
                return obj.planId || obj.id;
            };
            var getDefaultPlanId = function getDefaultPlanId() {
                return _this.models.checkoutSession.plan.id || [];
            };
            var getPlan = function getPlan(planId) {
                var plans = _this.models.checkoutSession.get('fundingOptions.plans') || [];
                var plan = plans.filter(function (p) {
                    return getPlanId(p) === planId;
                });
                return plan && plan.length > 0 ? plan[0] : null;
            };
            var resetContent = function resetContent() {
                _this.msg1 = '';
                _this.msg2 = '';
                _this.fullAuthMoreInfoLine1 = '';
                _this.fullAuthMoreInfoLine2 = '';
            };
            var decidePlanSelection = function decidePlanSelection() {
                var defaultPlan = _this.models.checkoutSession.get('plan.sources') && _this.models.checkoutSession.get('plan.sources')[0];
                var hasRewards = _factory.$RewardsCheckboxFactory.isRewardsPlan(_this.models.checkoutSession.plan);
                var selectedMethodPlanId = (0, _utils.getSelectedPlan)(_this.selectedmethod, _this.models.checkoutSession);

                if (!_this.selectedmethod && !hasRewards) {
                    return '';
                }

                selectedMethodPlanId = _factory.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, _this.selectedmethod, _this.models.checkoutSession);

                // If the plan is already selected, we don't need to duplicate the call
                if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                    return '';
                }

                // This is handled in onPay
                if (selectedMethodPlanId === 'applyForPPCRadio') {
                    return '';
                }
                return selectedMethodPlanId;
            };
            var updateContent = function updateContent(selectedPlan) {
                resetContent();
                // If User's selected FI is not available then we get the
                // default FI Plan to display content.
                selectedPlan = selectedPlan || getPlan(getDefaultPlanId());

                var pre_authorization_instruction = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.pre_authorization_instruction;

                if (pre_authorization_instruction && pre_authorization_instruction.amount) {
                    var type = pre_authorization_instruction.type,
                        _pre_authorization_in = pre_authorization_instruction.amount,
                        value = _pre_authorization_in.value,
                        currency_code = _pre_authorization_in.currency_code;


                    var oneDollarAuthContinue = type === AUTH_TYPE.PARTIAL && useraction !== 'commit';
                    var oneDollarPayNow = type === AUTH_TYPE.PARTIAL && useraction === 'commit';
                    var fullAuth = type === AUTH_TYPE.FULL && useraction !== 'commit';
                    var authAmount = value && (0, _squid.formatCurrency)(value, currency_code);
                    var merchantName = _this.models.checkoutAppData && _this.models.checkoutAppData.get('merchant.brand_name');
                    var _models$checkoutSessi = _this.models.checkoutSession.payer;
                    _models$checkoutSessi = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi;
                    var payerId = _models$checkoutSessi.id;

                    var msg_id = '';

                    if (fullAuth) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.fullAuthInformation';
                        _this.msg1 = !buttonLabelIsPay && (0, _squid.$renderContent)('disclaimer.reviewOrderBeforePurchaseWithMerchantName', {
                            merchantName: merchantName
                        });
                        _this.msg2 = !buttonLabelIsPay && (0, _squid.$renderContent)('disclaimer.fullAuthInformation', {
                            merchantName: merchantName,
                            amt: authAmount
                        });
                        _this.fullAuthMoreInfoLine1 = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine1', { merchantName: merchantName });
                        _this.fullAuthMoreInfoLine2 = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine2', { merchantName: merchantName });
                    }
                    if (oneDollarAuthContinue) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.oneDollarAuthRequired';
                        _this.msg1 = (0, _squid.$renderContent)('disclaimer.reviewOrderBeforePurchaseWithMerchantName', {
                            merchantName: merchantName
                        });
                        _this.msg2 = (0, _squid.$renderContent)('disclaimer.oneDollarAuthRequired', {
                            merchantName: merchantName,
                            amt: authAmount
                        });
                    }
                    if (oneDollarPayNow) {
                        msg_id = 'disclaimer.reviewOrderBeforePurchaseWithMerchantName, disclaimer.oneDollarAuthRequiredPayNow';
                        _this.msg1 = (0, _squid.$renderContent)('disclaimer.oneDollarAuthRequiredPayNow', {
                            amt: authAmount
                        });
                        _this.msg2 = undefined;
                    }
                    _this.showReviewLaterText = true;

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_review',
                        ryp_button_text: useraction === 'commit' ? 'PayNow' : 'Continue',
                        client_epoch_ts: Date.now(),
                        msg_id: msg_id,
                        amt: authAmount.split(/\s+/)[0],
                        currency_code: authAmount.split(/\s+/)[1],
                        auth_type: type,
                        buyer_id: payerId
                    });
                } else {
                    if (_this.models.checkoutCart.isSubscriptionsV1()) {
                        _this.showReviewLaterText = useraction !== 'commit';
                        return;
                    }
                    if (useraction !== 'commit' && !_squid.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && _this.models.checkoutCart.isBillingNoPurchase()) {
                        _logger.$logger.info('billing_no_purchase_use_case');
                        _this.showReviewLaterText = false;
                    }
                    if (_this.showReviewLaterText) {
                        _this.msg1 = buttonLabelIsPay ? '' : (0, _squid.$renderContent)('common.reviewLater');
                    }
                }
            };

            this.$watch('selectedmethod', function (newPlan) {
                if (!newPlan) {
                    return;
                }
                updateContent(newPlan);
            });

            updateContent(this.selectedmethod);

            this.$watch('selectedmethod.planId', function (newVal) {
                if (!newVal) {
                    return;
                }
                return updateContent(getPlan(decidePlanSelection()));
            });

            this.$watch('selectedmethod.rewardsChosenPlan', function () {
                return updateContent(getPlan(decidePlanSelection()));
            });

            this.$watch('primaryplan', function (newPlan) {
                if (!newPlan) {
                    return;
                }
                return updateContent(newPlan);
            });
        }
    }
});

angular.value("$xoCpaDisclaimerComponent", $xoCpaDisclaimerComponent);
_angular.$rootScope;

_angular.noop;

_squid.$Component;

_squid.formatCurrency;

_squid.$renderContent;

_squid.$integration;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;

_logger.$logger;

_factory.$RewardsCheckboxFactory;

_utils.getSelectedPlan;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cpa-disclaimer/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"showReviewLaterText\">\n    <p ng-if=\"msg1\">\n        <span>{{msg1}}</span>\n    </p>\n    <p ng-if=\"msg2\">\n        <span>{{msg2}}</span>\n    </p>\n    <div id=\"moreInfoContainer\" data-testid=\"disclaimer-more-info-container\" ng-show=\"fullAuthMoreInfoLine1 || fullAuthMoreInfoLine2 \">\n        <p>{{ fullAuthMoreInfoLine1 }} </p>\n        <p>{{ fullAuthMoreInfoLine2 }} </p>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoDeclineNotificationComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/decline-notification/template.html");

var _template2 = _interopRequireDefault(_template);

var _errorMap = __webpack_require__("../node_modules/xo-page-components/src/decline-notification/errorMap.js");

__webpack_require__("../node_modules/xo-page-components/src/decline-notification/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoDeclineNotificationComponent = exports.$xoDeclineNotificationComponent = _squid.$Component.extend('$xoDeclineNotification', {
    tag: 'xo-decline-notification',
    template: _template2['default'],
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            this.token = _angular.$rootScope.token;
            this.showDeclineNotification = false;
            this.formattedName = '';
            this.declinedFiType = '';
            this.showActionLink = false;
        },
        populate: function populate() {
            this.useraction = this.models.checkoutAppData.useraction() && this.models.checkoutAppData.useraction().toLowerCase();

            var formatType = function formatType(name, type) {
                if (type === 'CREDIT') {
                    // Unforunately, CREDIT is a type that is used for types that
                    // should not show marketing text, such as PAYPAL_SMART_CONNECT
                    if (name === 'PAYPAL_SMART_CONNECT') {
                        return null;
                    }
                }

                // All other known FIs have a second line that displays a type descriptor
                var secondLineDescriptor = (0, _squid.$renderContent)('fsMappings.' + type);

                if (secondLineDescriptor) {
                    return secondLineDescriptor;
                }
                // Unknown FI type, don't show type descriptor
                return null;
            };
            var declinedInstruments = this.models.checkoutSession.declinedInstruments;

            if (declinedInstruments && declinedInstruments.length) {
                this.declinedInstrument = declinedInstruments[0];
                var _declinedInstruments$ = declinedInstruments[0],
                    normalized_processor_response = _declinedInstruments$.normalized_processor_response,
                    id = _declinedInstruments$.id,
                    last4 = _declinedInstruments$.last4,
                    type = _declinedInstruments$.type,
                    card_type = _declinedInstruments$.card_type,
                    decline_type = _declinedInstruments$.decline_type;
                var _models$checkoutSessi = this.models.checkoutSession.payer;
                _models$checkoutSessi = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi;
                var payerId = _models$checkoutSessi.id;

                // only show the tile message if the decline type is PRE Auth

                if (decline_type === 'PREAUTH') {
                    var plans = this.models.checkoutSession.get('fundingOptions.plans', []);

                    this.declineContent = (0, _squid.$renderContent)((0, _errorMap.mapDeclineContent)(normalized_processor_response));
                    var declineActionLink = (0, _errorMap.mapDeclineAction)(normalized_processor_response);
                    var actionContentKey = void 0;
                    var linkAction = void 0;
                    var testId = void 0;

                    /* When the decline code is either of the following, that indicates updating the card number. So we show the update link.
                        'EXPIRED_CARD':
                        'INVALID_ACCOUNT':
                        'LOST_OR_STOLEN':
                        'HOLD_CALL_CENTER':
                        'PICKUP_CARD_SPECIAL_CONDITIONS':
                        'ACCOUNT_NOT_FOUND':
                        'INVALID_OR_RESTRICTED_CARD'
                     */

                    if (plans && plans.length > 0 && declineActionLink === _errorMap.DECLINE_ACTION.UPDATE) {
                        actionContentKey = 'issuerDecline.updateLink';
                        linkAction = this.actions.onUpdateClick.bind(this);
                        testId = '';
                        this.showActionLink = true;
                    } else if (declineActionLink === _errorMap.DECLINE_ACTION.RETRY) {
                        // Retry - When the card decline is actionable,
                        // like 'INSUFFICIENT_FUNDS'or 'AMOUNT_EXCEEDED', call issuer and resolve it,
                        // provide the user an option to retry card.
                        actionContentKey = 'issuerDecline.genericActionLink';
                        linkAction = this.actions.onRetryClick.bind(this);
                        testId = 'notification-retry-container';
                        this.showActionLink = true;
                    }

                    // For BAD_GAMING processor response we dont display Retry Link to user as there
                    // is no recovery availble.
                    // User story - https://rally1.rallydev.com/#/255547370892d/detail/userstory/331732135948
                    if (normalized_processor_response === 'BAD_GAMING') {
                        this.showActionLink = false;
                    }

                    this.declineAction = {
                        linkContent: (0, _squid.$renderContent)(actionContentKey),
                        linkAction: linkAction,
                        testId: testId
                    };

                    this.lastDigits = last4;
                    this.formattedName = (0, _squid.$renderContent)('fsMappings.' + card_type.toUpperCase());
                    this.declinedFiType = formatType(card_type, type);

                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'prepare_declined_fi',
                        buyer_id: payerId,
                        ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                        client_epoch_ts: Date.now(),
                        fi_id: id,
                        card_brand: card_type,
                        card_type: type,
                        user_action: normalized_processor_response === 'BAD_GAMING' ? 'NULL' : declineActionLink,
                        int_error_code: normalized_processor_response,
                        ext_error_desc: (0, _errorMap.mapDeclineContent)(normalized_processor_response)
                    });

                    this.showDeclineNotification = true;
                }
            }
        }
    },
    actions: {
        /* Handler, when user click update link
           we redirect to Add card sidebar screen.
        */
        onUpdateClick: function onUpdateClick(event) {
            if (event) {
                event.preventDefault();
            }
            var _models$checkoutSessi2 = this.models.checkoutSession.payer;
            _models$checkoutSessi2 = _models$checkoutSessi2 === undefined ? {} : _models$checkoutSessi2;
            var payerId = _models$checkoutSessi2.id;


            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW',
                to: 'process_declined_fi',
                buyer_id: payerId,
                ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                client_epoch_ts: Date.now(),
                fi_id: this.declinedInstrument.id,
                card_brand: this.declinedInstrument.card_type,
                card_type: this.declinedInstrument.type,
                user_action: _errorMap.DECLINE_ACTION.UPDATE,
                int_error_code: this.declinedInstrument.normalized_processor_response
            });

            // Remove this tile and redirect to Add Card Flow.
            this.showDeclineNotification = false;
            _uiRouter.$state.go('checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard', {
                doneUri: 'checkout.review',
                updateCardCPA: true
            });
        },


        /* Handler, when user click Retry link
           we make a PAPS call to Remove the funding constraints and get the checkoutSession,
           and redirect to review page.
        */
        onRetryClick: function onRetryClick(event) {
            var _this = this;

            if (event) {
                event.preventDefault();
            }
            var _models$checkoutSessi3 = this.models.checkoutSession.payer;
            _models$checkoutSessi3 = _models$checkoutSessi3 === undefined ? {} : _models$checkoutSessi3;
            var payerId = _models$checkoutSessi3.id;


            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW',
                to: 'process_declined_fi',
                buyer_id: payerId,
                ryp_button_text: this.useraction === 'commit' ? 'PayNow' : 'Continue',
                client_epoch_ts: Date.now(),
                fi_id: this.declinedInstrument.id,
                card_brand: this.declinedInstrument.card_type,
                card_type: this.declinedInstrument.type,
                user_action: _errorMap.DECLINE_ACTION.UPDATE,
                int_error_code: this.declinedInstrument.normalized_processor_response
            });

            this.models.checkoutSession.set('declinedInstruments', null);

            return this.models.checkoutSession.action('removeFundingConstraint', {
                data: {
                    id: this.declinedInstrument.id
                },
                success: function success(preAuthResponse) {
                    if (_this.$parent.cancelUpdateListener) {
                        _this.$parent.cancelUpdateListener();
                    }
                    _uiRouter.$state.go('checkout.review', {}, { reload: true });
                },
                contingencies: {
                    DEFAULT: function DEFAULT() {
                        var _this2 = this;

                        // Replan and reload XO-REVIEW
                        this.models.checkoutSession.invalidate();
                        this.models.checkoutSession.smartDollarAuthFailed = true;
                        if (this.models.checkoutSession.selectedFuturePaymentInstrument) {
                            // Invalidate the saved FI selection to avoid display of stale selection on review page.
                            delete this.models.checkoutSession.selectedFuturePaymentInstrument;
                        }
                        this.models.checkoutSession.retrieve({
                            success: function success() {
                                _this2.models.checkoutSession.smartDollarAuthFailed = false;
                                if (_this2.$parent.cancelUpdateListener) {
                                    _this2.$parent.cancelUpdateListener();
                                }
                                _uiRouter.$state.go('checkout.review', {}, { reload: true });
                            }
                        });
                    }
                }
            });
        }
    }

});

angular.value("$xoDeclineNotificationComponent", $xoDeclineNotificationComponent);
_uiRouter.$state;

_angular.$rootScope;

_angular.noop;

_squid.$Component;

_squid.$renderContent;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_logger.$logger;

_errorMap.mapDeclineAction;

_errorMap.mapDeclineContent;

_errorMap.DECLINE_ACTION;

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/errorMap.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var DECLINE_ACTION = exports.DECLINE_ACTION = {
    UPDATE: 'UPDATE',
    RETRY: 'RETRY'
};

var mapDeclineContent = exports.mapDeclineContent = function mapDeclineContent(normalizedResponse) {
    switch (normalizedResponse) {
        case 'INSUFFICIENT_FUNDS':
        case 'AMOUNT_EXCEEDED':
            return 'issuerDecline.insufficientFunds';
        case 'EXPIRED_CARD':
        case 'INVALID_ACCOUNT':
        case 'LOST_OR_STOLEN':
        case 'HOLD_CALL_CENTER':
        case 'PICKUP_CARD_SPECIAL_CONDITIONS':
        case 'ACCOUNT_NOT_FOUND':
        case 'INVALID_OR_RESTRICTED_CARD':
            return 'issuerDecline.expiredCard';
        case 'BAD_GAMING':
            return 'issuerDecline.internalDeclineReview';
        default:
            return 'issuerDecline.genericDecline';
    }
};

var mapDeclineAction = exports.mapDeclineAction = function mapDeclineAction(normalizedResponse) {
    switch (normalizedResponse) {
        case 'EXPIRED_CARD':
        case 'INVALID_ACCOUNT':
        case 'LOST_OR_STOLEN':
        case 'HOLD_CALL_CENTER':
        case 'PICKUP_CARD_SPECIAL_CONDITIONS':
        case 'ACCOUNT_NOT_FOUND':
        case 'INVALID_OR_RESTRICTED_CARD':
            return DECLINE_ACTION.UPDATE;
        case 'INSUFFICIENT_FUNDS':
        case 'AMOUNT_EXCEEDED':
        default:
            return DECLINE_ACTION.RETRY;
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/decline-notification/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"decline-notification-container\">\n    <div class=\"tile\" data-testid=\"declinedFi-notification-container\" ng-if=\"showDeclineNotification\">\n        <div class=\"header\">\n            <div class=\"iconContainer\">\n                <span class=\"infoIcon\" data-testid=\"declinedFi-notification-icon-container\"></span>\n            </div>\n            <div class=\"content\" data-testid=\"declinedFi-notification-content-container\">\n                {{declineContent}}\n            </div>\n            <div class=\"actionDecline\" data-testid=\"declinedFi-notification-action-container\">\n                <a ng-if=\"showActionLink\" class=\"link\" href=\"\" ng-click=declineAction.linkAction() data-testid=\"{{declineAction.testId}}\">\n                    <span class=\"textContent\">{{declineAction.linkContent}}</span>\n                </a>\n            </div>\n        </div>\n        <div class=\"fi\">\n            <div class=\"image\">\n                <xo-fi-icon fi=\"declinedInstrument\" class-name=\"fsIcon\"></xo-fi-icon>\n            </div>\n\n            <div class=\"content\" data-testid=\"declinedFi-content\">\n                <div class=\"description\">\n                    <span class=\"primary\">{{formattedName}}</span>\n                </div>\n                <div class=\"typeDisplay\">\n                    <p class=\"details\" data-testid=\"declinedFi-type\">\n                        &nbsp;{{declinedFiType}}\n                    </p>\n                    <span ng-if=\"lastDigits\" class=\"lastDigits\">\n                        &nbsp;&bull;&bull;&bull;&bull;&nbsp;{{lastDigits}}&nbsp;\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/cycoExitFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var POPUP_WIDTH = 560;
var POPUP_HEIGHT = 550;

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$cycoExitFactory', function () {
    // exported factory functions go in this object
    var factory = {};

    // state variables
    var onCycoPage = false;
    var shouldShowPopup = false;
    var cycoInitTime = Date.now();

    // This function should be called when we enter the cyco page.
    // It will make an elmo call, and set the `shouldShowPopup` variable based on
    // whether or not you are in the control or treatment experience. It will also
    // set the `onCycoPage` to true.
    factory.cycoEnter = function (merchantCountry) {
        onCycoPage = true;
        cycoInitTime = Date.now();
        return (0, _squid.$elmo)('xo_hermes_cyco_cancel_feedback', { 'ctx.COUNTRY': merchantCountry }, 'Trmt_xo_hermes_cyco_cancel_feedback_.*', false, true).then(function (res) {
            var treatmentName = res && res.treatment_name;
            _logger.$logger.info('checkout_fpti', {
                'xo_hermes_cyco_cancel_feedback': treatmentName ? treatmentName : 'Ctrl_xo_hermes_cyco_cancel_feedback'
            });
            shouldShowPopup = treatmentName ? true : false;
        })['catch'](_angular.noop);
    };

    // This function should be called when we exit the cyco page.
    // It will reset the `onCycoPage` and `shouldShowPopup` variables to false.
    factory.cycoExit = function () {
        onCycoPage = false;
        shouldShowPopup = false;
    };

    // We call this function in the footer, and on certain links on the
    // xo-credit-component CYCO page
    factory.showExitSurvey = function () {
        var exitSurveyShown = false;
        try {
            // we only show the opinionlab exit survey if we are on the cyco page, 
            // and in the correct treatment
            if (onCycoPage && shouldShowPopup) {
                var _sW = window.screen.width;
                var _sH = window.screen.height;
                var countryCode = ('' + _squid.$locale.country).toLowerCase();
                var languageCode = ('' + _squid.$locale.lang).toLowerCase();
                var userGuid = _squid.$util.getProperty(window.meta, 'userGuid') || 'Unknown';
                var customVars = {
                    guid: userGuid,
                    tealeafId: userGuid,
                    fptiPageGroup: 'main:ec:hermes::choose_credit_offer:member:hermes:',
                    fptiPagename: 'main:ec:hermes::choose_credit_offer:member:hermes:',
                    rlogId: _squid.$util.getProperty(window.meta, 'rlogId') || 'Unknown',
                    calc: _squid.$util.getProperty(window.meta, 'correlationId') || 'Unknown',
                    merchantId: _squid.$util.getProperty(window.meta, 'checkoutCTX.merchant_id') || 'Unknown',
                    token: _squid.$util.getProperty(window.meta, 'token') || 'Unknown',
                    countryCode: countryCode,
                    languageCode: languageCode
                };
                var showCycoOpinionUrl = _squid.$util.buildURL('https://secure.opinionlab.com/ccc01/comment_card.asp', {
                    width: _sW,
                    height: _sH,
                    referer: 'https://surveys.paypal.com/' + countryCode + '/' + languageCode + '/CycoPageExit',
                    prev: document.referrer,
                    time1: cycoInitTime,
                    time2: Date.now(),
                    currentURL: document.location.href,
                    type: 'Popup',
                    custom_var: userGuid,
                    customVars: JSON.stringify(customVars)
                });
                _logger.$logger.info('checkout_fpti', {
                    from: 'elmo_showCycoOpinionUrl',
                    to: showCycoOpinionUrl
                });
                window.open(showCycoOpinionUrl, 'comments', 'width=' + POPUP_WIDTH + ',height=' + POPUP_HEIGHT + ',screenX=' + (_sW - POPUP_WIDTH) / 2 + ',screenY=' + (_sH - POPUP_HEIGHT) / 2 + ',top=' + (_sH - POPUP_HEIGHT) / 2 + ',left=' + (_sW - POPUP_WIDTH) / 2 + ',resizable=yes,copyhistory=yes,scrollbars=no');
                exitSurveyShown = true;
            }
        } catch (err) {
            _logger.$logger.error('choose-credit-offer: showCycoOpinion error', { error: err });
        }
        return exitSurveyShown;
    };

    return factory;
});

_logger.$logger;

_squid.$locale;

_squid.$util;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/footer", "../node_modules/xo-page-components/src/footer/cycoExitFactory.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _footerMap = __webpack_require__("../node_modules/xo-page-components/src/footer/footerMap.js");

var _footerMap2 = _interopRequireDefault(_footerMap);

var _opinionlab = __webpack_require__("../node_modules/xo-page-components/src/footer/opinionlab.js");

var _opinionlab2 = _interopRequireDefault(_opinionlab);

var _template = __webpack_require__("../node_modules/xo-page-components/src/footer/template.html");

var _template2 = _interopRequireDefault(_template);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cycoExitFactory = __webpack_require__("../node_modules/xo-page-components/src/footer/cycoExitFactory.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFooter', function () {
    return {
        template: _template2['default'],
        restrict: 'EA',
        scope: {
            token: '=?',
            escapeHatchIncontext: '=?',
            cancel: '@?',
            merchant: '@?',
            languageSwitch: '=?',
            showVenmoLegalLinks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.isIFrame = _squid.$util.isIFrame();
            if ($scope.escapeHatchIncontext) {
                $scope.showEscapeHatch = $scope.isIFrame;
            }
            $scope.locale = _squid.$locale;
            $scope.proxSignUpFlow = _index4.$CheckoutInputDataModel.instance($scope.token).isEbayTxn();
            $scope.year = new Date().getFullYear();

            $scope.isApac = function () {
                return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf($scope.locale.country) > -1;
            };

            // Determine if country belongs to a region to serve correct footer links
            var getRegion = function getRegion(country) {
                var regions = _squid.$config.regions;
                for (var region in regions) {
                    if (regions[region].indexOf(country) > -1) {
                        return region;
                    }
                }
                return false;
            };

            function isDESecondButtonFlow() {
                return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
            }

            $scope.footerLinks = function () {
                if ($scope.isApac()) {
                    return _footerMap2['default'].APAC;
                }

                // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                // that were available in Aries
                if (isDESecondButtonFlow()) {
                    return _footerMap2['default']['DESecondButton'];
                }

                return _footerMap2['default'][$scope.locale.country] || _footerMap2['default'][getRegion($scope.locale.country)] || _footerMap2['default'].DEFAULT;
            };

            $scope.showPolicyInfo = function () {
                return $scope.isApac() || $scope.locale.country === 'AU';
            };

            $scope.cancelRedirect = function ($event) {
                $event.preventDefault();

                // if a user is on the CYCO page, we show an opinionlab exit survey based on
                // whether or not they are in the xo_hermes_cyco_cancel_feedback elmo treatment.
                var surveyShown = _cycoExitFactory.$cycoExitFactory.showExitSurvey();
                _logger.$logger.info('cyco_exit_surveyShown_' + Boolean(surveyShown));

                var cancelUri = $scope.cancel;
                var redirectUri = _squid.$util.param('redirect_uri');

                if (window.xprops && window.xprops.onCancel && !cancelUri) {
                    return window.xprops.onCancel({
                        orderID: $scope.token
                    });
                }

                // "redirect_uri" as a query param overrides the cancel url in the checkout session
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {

                    cancelUri = _squid.$util.buildURL(redirectUri, {
                        opType: 'cancel',
                        return_uri: $scope.cancel,
                        token: $scope.token
                    });
                }

                _index5.$ReturnToMerchant.goTo(cancelUri);
            };

            $scope.isIndiaLegalEntity = function () {
                // for PayPal India domestic launch legal entity should be 84
                // update footer with indian policy for this case
                return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84 || $scope.locale.country === 'IN';
            };

            if ($scope.token) {
                (0, _squid.$populate)($scope, {
                    checkoutAppData: _index3.$CheckoutAppDataModel.instance($scope.token),
                    checkoutPayee: _index3.$CheckoutPayeeModel.instance($scope.token),
                    checkoutCart: _index3.$CheckoutCartModel.instance($scope.token),
                    auth: _index2.$AuthModel.instance()
                }).then(function () {
                    var payee = $scope.checkoutPayee;

                    if (payee && payee.merchant && payee.merchant.id) {
                        var hcl = _squid.$config.hideCancelLinkForMerchant;

                        var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
                        if (shouldHide) {
                            $scope.hideCancel = true;
                        }
                    }
                    $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                    var billingData = $scope.checkoutCart.billing || {};
                    if (billingData.intent === 'VAULT') {
                        var originalCancelUrl = $scope.checkoutAppData.urls.original_urls.cancel_url;
                        var vaultCancelParams = {
                            approval_token_id: billingData.vault_approval_token_id,
                            approval_session_id: billingData.vault_approval_session_id
                        };
                        $scope.cancel = originalCancelUrl ? _squid.$util.buildURL(originalCancelUrl, vaultCancelParams) : originalCancelUrl;
                    }
                    $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
                });
            }

            var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, ctx) {
                var url = ctx && ctx.popupUrl;
                _logger.$logger.info('show_popup_modal', { url: url, ua: _angular.$window.navigator.userAgent });
                $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
                $scope.show = true;
                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
            });

            // for webkit webview (wkwebview) on ios devices, we need to open footer
            // policies/terms links in a modal window as wkwebview blocks anchor tags
            // with target _blank from loading
            $scope.openLinkInModalIfWebview = function (event) {
                // if webview then open the link in a modal window
                if (_index.$DeviceInfo.isWebView()) {
                    event.preventDefault();
                    var url = event.target.href;
                    _logger.$logger.info('show_popup_modal_footer_links', { url: url });
                    $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
                    // As this code is only for webviews, we are going fullscreen
                    // with css class - fullsize-modal
                    $scope.fullsizeModal = true;
                    $scope.show = true;
                }
            };

            $scope.hideModal = function () {
                _logger.$logger.info('hide_popup_modal');
                $scope.show = false;
                $scope.fullsizeModal = false;
            };

            $scope.$on('$destroy', cancelShowModal);

            $scope.showOL = function showOL(event) {
                event.preventDefault();

                var placeholder = 'main:ec:hermes';
                var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
                var data = {
                    opVars: {
                        rlogId: _angular.$window.meta.rlogId || '',
                        page: page || window.location.hash,
                        csci: 'Unknown',
                        calc: _angular.$window.meta.correlationId,
                        custId: 'Unknown',
                        merchantId: 'Unknown',
                        token: $scope.token || 'Unknown'
                    },
                    locale: {
                        country: _squid.$locale.country,
                        languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                    }
                };

                (0, _opinionlab2['default'])(data);
            };

            $scope.hideReturnCancelUrl = function () {
                if (window.xprops && window.xprops.onCancel) {
                    return false;
                }

                if (!$scope.cancel) {
                    return true;
                }

                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.done') {
                    return true;
                }

                return false;
            };

            $scope.showVenmoLinks = function () {
                // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !!$scope.showVenmoLegalLinks;
            };

            $scope.showPaypalLinks = function () {
                // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
                if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
                    return true;
                }
                return !$scope.showVenmoLegalLinks;
            };
        }]
    };
});

_uiRouter.$state;

_angular.$window;

_angular.$rootScope;

_angular.$sce;

_squid.$config;

_squid.$util;

_squid.$locale;

_squid.$populate;

_squid.$integration;

_index.$DeviceInfo;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index4.$CheckoutInputDataModel;

_index5.$ReturnToMerchant;

_logger.$logger;

_cycoExitFactory.$cycoExitFactory;

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {



!(module.exports = {
    CA: [{
        id: 'policy',
        content: 'footer.policiesCA'
    }, {
        id: 'terms',
        content: 'footer.termsCA'
    }, {
        id: 'privacy',
        content: 'footer.privacyCA'
    }],

    BE: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DE: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'legal',
        content: 'footer.DELegal'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }, {
        id: 'paymentdesc',
        content: 'footer.DEKeyPaymentDesc'
    }],

    ES: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    FR: [{
        id: 'legal',
        content: 'footer.FRLegal'
    }, {
        id: 'useragreement',
        content: 'footer.FRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.FRPrivacy'
    }],

    IT: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    NL: [{
        id: 'legal',
        content: 'footer.legal'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    IE: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    APAC: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EMEA: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    EM: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'useragreement',
        content: 'footer.userAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    LATAM: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    AU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    AT: [{
        id: 'imprint',
        content: 'footer.ATImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    CH: [{
        id: 'imprint',
        content: 'footer.CHImprint'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    DK: [{
        id: 'useragreement',
        content: 'footer.DKUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    SE: [{
        id: 'useragreement',
        content: 'footer.SEUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    PL: [{
        id: 'useragreement',
        content: 'footer.PLUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    NO: [{
        id: 'useragreement',
        content: 'footer.NOUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    TR: [{
        id: 'useragreement',
        content: 'footer.TRUserAgreement'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    BR: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    MX: [{
        id: 'help',
        content: 'footer.help'
    }, {
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],
    RU: [{
        id: 'terms',
        content: 'footer.terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy'
    }],

    DESecondButton: [{
        id: 'imprint',
        content: 'footer.DEImprint'
    }, {
        id: 'privacy',
        content: 'footer.DEPrivacy'
    }],

    DEFAULT: [{
        id: 'policy',
        content: 'footer.policies',
        venmoContent: 'footer.venmo_policies'
    }, {
        id: 'terms',
        content: 'footer.terms',
        venmoContent: 'footer.venmo_terms'
    }, {
        id: 'privacy',
        content: 'footer.privacy',
        venmoContent: 'footer.venmo_privacy'
    }]
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel || '#'}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\" ng-if=\"showPaypalLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <ul class=\"footerLinks\" ng-if=\"showVenmoLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options direction=\"top\" ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-if=\"isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.4plpolicyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreInfo\" ng-if=\"!isIndiaLegalEntity()\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal\n        ng-attr-id=\"{{(fullsizeModal ? 'fullsize' : 'responsive') + '-modal'}}\"\n        ng-if=\"show\" show=\"show\" enable-mobile-interstitial=\"true\"\n        show-close-button=\"true\" on-close=\"hideModal\" override-default-container=\"fullsizeModal\">\n        <div class=\"popupModalContainer\">\n            <iframe src=\"{{popupUrl}}\" class=\"popupModal\" frameborder=\"0\"></iframe>\n        </div>\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$gdprCookieBannerComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * General Data Protection Regulation (GDPR) defines standards on how personal data is collected, processed, transferred and disposed.
 * Affected Countries: All "GDPR" countries: Please check config.json for country list.
 * Wiki: https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki/GDPR:-Feature,-Integration-documentation
 */
var $gdprCookieBannerComponent = exports.$gdprCookieBannerComponent = _squid.$Component.extend('$gdprCookieBanner', {
    tag: 'xo-gdpr-cookie-banner',
    template: _template2['default'],
    actions: {
        // Fetch the GDPR banner, append to DOM if available
        refreshGDPR: function refreshGDPR() {
            var _this = this;

            var gdprModel = _gdprCookieBanner.$GDPRCookieBannerModel.instance();

            return gdprModel.getBanner().then(function () {
                var banner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                // Run cleanup once we know the result, to prevent screen flash
                _this.actions.cleanup();

                var html = banner.html,
                    css = banner.css,
                    js = banner.js;


                if (!html || !css || !js) {
                    return;
                }

                var div = angular.element(html);
                var style = angular.element(css);
                var script = angular.element(js);

                var el = _this.$element.find('#gdpr-cookie-banner-outerwrap');

                el.append(style);
                el.append(div);
                el.append(script);

                if (!(0, _angular.isFunction)(window.bindGdprEvents)) {
                    _logger.$logger.error('gdpr_banner_bindGdprEvents_not_defined');
                    return;
                }

                // TODO: Remove this class add when cookie banner script is fixed to add this class properly
                angular.element(document.body).addClass('gdprCookieBanner-acceptedAll');

                window.bindGdprEvents();
            });
        },

        // Clear out the banner container to remove the old elements
        cleanup: function cleanup() {
            var el = this.$element.find('#gdpr-cookie-banner-outerwrap');

            el.empty();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.actions.refreshGDPR();

            // On "localeChange" we are re-fetching data.
            this.$on('localeChange', function () {
                _this2.actions.refreshGDPR();
            });
        }
    }
});

angular.value("$gdprCookieBannerComponent", $gdprCookieBannerComponent);
_squid.$Component;

_angular.isFunction;

_gdprCookieBanner.$GDPRCookieBannerModel;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SetHeaderText = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/header/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/header/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoHeader', function () {
    return {
        template: _template2['default'],
        scope: {
            showCartTotal: '=?',
            renderCartContainer: '=?',
            token: '=?',
            isUnbranded: '=?',
            unbrandedTitle: '=?',
            unbrandedSubTitle: '=?',
            languageSwitch: '=?',
            redirectiframe: '=?',
            redirectLightbox: '=?',
            isVenmoFlow: '=?'
        },
        controller: ['$scope', function ($scope) {
            var _ref = window.xprops || {},
                _ref$experience = _ref.experience,
                experience = _ref$experience === undefined ? { facebook: false } : _ref$experience;

            // Callback-integrated merchants should have a breakdown available in their flow


            $scope.enableCartBreakdown = Boolean(window.xprops && window.xprops.onShippingChange);

            $scope.isFacebookBAIntegration = experience.facebook;
            $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            $scope.subTitle = (0, _squid.$renderContent)($scope.unbrandedSubTitle);
            $SetHeaderText.subscribe($scope, function (event, text) {
                $scope.unbrandedTitle = text;
                $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
            });
        }]
    };
});

var headerText = '';
var $SetHeaderText = exports.$SetHeaderText = {
    setText: function setText(text) {
        headerText = text;
        _angular.$rootScope.$emit('update_header_text', text);
    },
    getText: function getText() {
        return headerText;
    },
    subscribe: function subscribe($scope, callback) {
        var handler = _angular.$rootScope.$on('update_header_text', callback);
        $scope.$on('$destroy', handler);
    }
};

angular.value("$SetHeaderText", $SetHeaderText);
_angular.$rootScope;

_squid.$integration;

_squid.$renderContent;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\" disable-id=\"true\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isFacebookBAIntegration\" class=\"ng-scope facebookPayPalHeader\">\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/paypal_monogram_logo.png\" class=\"facebookPayPalHeader-logo\" alt=\"PayPal\">\n            <span class=\"facebookPayPalHeader-separator\"></span>\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/facebook_logo.svg\" class=\"facebookPayPalHeader-logo\" alt=\"Facebook\">\n        </div>\n        <div ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n\n        <xo-cart\n            token=\"token\"\n            override-show-details=\"enableCartBreakdown\"\n            show-cart-total=\"showCartTotal\"\n            render-cart-container=\"renderCartContainer\"\n        ></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _installmentPlanTerms = __webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js");

var _installmentPlanTerms2 = _interopRequireDefault(_installmentPlanTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemName: _installmentPlanTerms2['default'].getItemName,
    getInstallmentPlanData: _installmentPlanTerms2['default'].getInstallmentPlanData
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _require = __webpack_require__("../node_modules/lodash/index.js"),
    get = _require.get;

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var REGULAR_INSTALLMENTPLAN = 'REGULAR';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsInstallmentPlan.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    return (0, _squid.formatCurrency)(amount, currencyCode, false);
}

/**
 * Computes and returns content key for regular installmentPlan
 * There can be 5 variations of regular installmentPlan content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsInstallmentPlan.message
 */
function computeRegularInstallmentPlanKey(totalCycles, isTerms) {

    var key = 'regularInstallmentPlanPeriod';
    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += isTerms ? '.nonRecurring' : '.nonRecurringAmount';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += isTerms ? '.recurringInfinite' : '.recurringInfiniteAmount';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += isTerms ? '.recurring' : '.recurringAmount';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param installmentPlanTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermAmountText(installmentPlanTerms, index, currencyCode, isTerms) {

    var amount = +installmentPlanTerms[index].amount,
        billPeriod = installmentPlanTerms[index].billPeriod,
        periodType = installmentPlanTerms[index].periodType,
        billFrequency = +installmentPlanTerms[index].billFrequency,
        totalCycles = +installmentPlanTerms[index].totalCycles;
    var contentKey = void 0;

    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === REGULAR_INSTALLMENTPLAN) {
        contentKey = computeRegularInstallmentPlanKey(totalCycles, isTerms);
    }
    contentKey = 'wpsInstallmentPlan.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles

    };
    return localizedContent(contentKey, templatePlaceholderData);
}

function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;

    return name;
}

function getInstallmentPlanData(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var installmentPlanDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var effectiveDate = baResponseData && baResponseData.effective_date;
    var supplementaryData = get(baResponseData.plan.metadata, 'supplementary_data');
    var displayTotal = supplementaryData.find(function (item) {
        return item.name === 'display_total';
    });
    var currencyCode = plan && plan.currency_code;
    var firstAmount = allTerms[0].amount;
    var totalAmount = allTerms.reduce(function (accumulator, currentVal) {
        return accumulator + currentVal.amount * currentVal.totalCycles;
    }, 0);
    var formattedTotalAmount = (0, _squid.formatCurrency)(totalAmount, currencyCode, false);
    var formattedFirstAmount = (0, _squid.formatCurrency)(firstAmount, currencyCode, false);
    var termsText = [];
    for (var i = 0; i < allTerms.length; i++) {
        termsText.push(prepareIndividualTermAmountText(allTerms, i, currencyCode, true)); // Passing 'true' flag for Terms
    }
    var amountText = [];
    for (var _i = 0; _i < allTerms.length; _i++) {
        amountText.push(prepareIndividualTermAmountText(allTerms, _i, currencyCode, false)); // Passing 'false' flag for Amount
    }
    installmentPlanDetails.displayTotal = displayTotal.value === 'true';
    installmentPlanDetails.effectiveDate = effectiveDate;
    installmentPlanDetails.currencyCode = currencyCode;
    installmentPlanDetails.formattedTotalAmount = formattedTotalAmount;
    installmentPlanDetails.formattedFirstAmount = formattedFirstAmount;
    installmentPlanDetails.termsText = termsText;
    installmentPlanDetails.amountText = amountText;
    return installmentPlanDetails;
}

module.exports = {
    getItemName: getItemName,
    getInstallmentPlanData: getInstallmentPlanData
};

_squid.formatCurrency;

_squid.Content;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/marketingOffers/template.html");

var _template2 = _interopRequireDefault(_template);

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoMarketingOffers', function () {
    return {
        template: _template2['default'],
        scope: {
            placementCode: '=?',
            titleTxtProperty: '=?',
            subtitleProperty: '=?',
            token: '=?',
            pageName: '=?',
            backgroundImage: '=?',
            xoTitleTag: '@?',
            xoTitleClass: '@?'
        },
        controller: ['$scope', '$element', '$sce', function ($scope, $element, $sce) {
            var morsOfferFlag = $scope.placementCode === '202003' && (0, _squid.$feature)('morsValuePropOffers');
            var populateObj = void 0;

            if (morsOfferFlag) {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
                    checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
                    payee: _index.$CheckoutPayeeModel.instance($scope.token),
                    auth: _auth.$AuthModel.instance()
                };
            } else {
                populateObj = {
                    checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
                };
            }
            (0, _squid.$populate)($scope, populateObj).then(function () {
                $scope.locale = _squid.$locale;
                $scope.token = _angular.$rootScope.token;
                function setDefaultValues() {
                    $scope.ad = {
                        Title: (0, _squid.$renderContent)($scope.titleTxtProperty),
                        Body: (0, _squid.$renderContent)($scope.subtitleProperty),
                        backgroundImage: $scope.backgroundImage
                    };
                }

                $scope.$watch('ad.backgroundImage', function (imageUrl) {
                    if (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element($element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina && url) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    }
                });

                if ($scope.placementCode === '202002') {
                    $scope.pu_type = 'ANONYMOUS';
                    $scope.presentation_types = ['CompositeText'];
                } else if ($scope.placementCode === '202003') {
                    $scope.className = 'props';
                    $scope.pu_type = 'PERSONAL';
                    $scope.presentation_types = ['GenericComposite'];
                    $scope.chooseAd = true;
                } else {
                    setDefaultValues();
                }

                //  serve ads only if country is US and lang is en and based on placementcode
                if ($scope.chooseAd && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && $scope.placementCode && (0, _squid.$feature)('morsValuePropOffers')) {
                    $scope.marketingOfferData = new _marketingoffer.$MarketingOfferModel({
                        countryCode: $scope.locale.country,
                        page: $scope.pageName,
                        puType: $scope.pu_type,
                        locale: _squid.$locale.lang + '_' + _squid.$locale.country,
                        totalTransactionAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
                        },
                        totalShippingAmount: {
                            'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                            // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                            // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                            'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
                        },
                        payee: morsOfferFlag ? $scope.payee.merchant.id : '',
                        payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
                        si: morsOfferFlag ? $scope.checkoutSession.id : '',
                        visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
                        targetPlacements: [{
                            'placement_code': $scope.placementCode,
                            'presentation_types': $scope.presentation_types
                        }]
                    });

                    return _marketingoffer.$MarketingOfferModel.instance($scope.token).save({
                        silent: true,
                        data: $scope.marketingOfferData.serialize(),
                        // Ignore all errors from this api, by passing transientError as true
                        transientError: true,
                        success: function success(result) {
                            var ads_arr = result && result.ads || [];
                            var adFound = false;

                            // MORS could serve multiple ads for a given page. Iterate to get the
                            // correct one based on the ad placement_id
                            ads_arr.forEach(function (ad) {
                                var adunit_id = ad.campaign.adunit_id;

                                if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                    adFound = true;
                                    $scope.ad = {};
                                    var content = ad.content.nvp;
                                    content.forEach(function (obj) {
                                        $scope.ad[obj.name] = obj.value;
                                    });
                                    $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                    $scope.ad['clickUrl'] = ad.tracking.click_url;
                                }
                            });

                            if (adFound) {
                                $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                                // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                                // and 202003 placement_ids as this will already be assigned.

                                // notify MORS of successful rendering by firing the impressionurl
                                // beacon and by setting the click url to be fired for future
                                // conversion.
                                // setting the placement_id helps to differentiate between multiple ads
                                // displayed on the same page

                                _logger.$logger.info('MORS_ad_displayed');
                                _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                _angular.$rootScope.$broadcast('MORSDisplayed', {
                                    clickUrl: $scope.ad.clickUrl,
                                    placementId: $scope.placementCode
                                });
                            } else {
                                _logger.$logger.info('MORS_ad_not_found');
                                setDefaultValues();
                                _angular.$rootScope.$broadcast('MORSNotDisplayed');
                            }
                        },

                        error: function error(err) {
                            setDefaultValues();
                            _logger.$logger.error('MORS_api_failure', { error: err });
                        }
                    });
                } else {
                    setDefaultValues();
                    _angular.$rootScope.$broadcast('MORSNotDisplayed');
                }
                $scope.$on('localeChange', function () {
                    setDefaultValues();
                });
            });
        }]
    };
});

_angular.$rootScope;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_marketingoffer.$MarketingOfferModel;

_marketingoffer.$fireMORSBeacon;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/merchant-header/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
    tag: 'xo-merchant-header',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        merchant: {
            type: 'var',
            required: false
        },
        disableId: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            if (this.props.token) {
                return {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
                };
            }
        }
    },
    lifecycle: {
        populate: function populate() {
            var _ref = this.models || {},
                checkoutAppData = _ref.checkoutAppData;

            if (checkoutAppData) {
                // get Merchant display name - can be undefined in which case we have an empty header
                this.merchantDisplayName = checkoutAppData.getMerchantDisplayName();

                if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
                    this.merchant = checkoutAppData.merchant;
                }
            }
        }
    }
});


(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.bind('load', function () {
                var MAX_WIDTH = 780;
                var MAX_HEIGHT = 90;

                if (this.width > MAX_WIDTH) {
                    var ratio = MAX_WIDTH / this.width;
                    var height = this.height * ratio;

                    this.width = MAX_WIDTH;
                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
                }
            });
        }
    };
});

_angular.noop;

_squid.$Component;

_squid.$registerDirective;

_index.$CheckoutAppDataModel;

_index2.$CheckoutInputDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

module.exports = "<header role=\"banner\">\n    <div ng-attr-id=\"{{ props.disableId ? '' : 'header' }}\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchantDisplayName || merchant.brand_name\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n                {{ merchantDisplayName || merchant.brand_name }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchantDisplayName || merchant.brand_name}}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/template.html");

var _template2 = _interopRequireDefault(_template);

var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {
    tag: 'xo-messenger-plugin',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        pluginType: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()['catch'](_angular.noop)
            };
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
            var lang = _squid.$locale.lang,
                country = _squid.$locale.country;
            var _props = this.props,
                pluginType = _props.pluginType,
                token = _props.token;
            var _models = this.models,
                _models$checkoutSessi = _models.checkoutSession,
                checkoutSession = _models$checkoutSessi === undefined ? {} : _models$checkoutSessi,
                _models$messengerInte = _models.messengerIntegration,
                messengerIntegration = _models$messengerInte === undefined ? {} : _models$messengerInte;

            // BA was offered to user or not

            var fbBAShownFlag = _squid.$util.localStorageEnabled() && window.localStorage.getItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG);

            // Added following flags to override usual behaviour to enable internal testing by FB and PYPL teams

            var _ref = window.xprops || {},
                _ref$experience = _ref.experience;

            _ref$experience = _ref$experience === undefined ? {} : _ref$experience;
            var override_fbpp_repeat = _ref$experience.override_fbpp_repeat;

            var overrideRepeatUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_REPEAT_FLAG) || override_fbpp_repeat;

            var isChatEnabled = messengerIntegration.isChatEnabled,
                emailHash = messengerIntegration.emailHash,
                nameHash = messengerIntegration.nameHash,
                dataRefJWT = messengerIntegration.dataRefJWT;
            var _checkoutSession$paye = checkoutSession.payer;
            _checkoutSession$paye = _checkoutSession$paye === undefined ? {} : _checkoutSession$paye;
            var payerId = _checkoutSession$paye.id,
                _checkoutSession$tran = checkoutSession.transactionDetails,
                transactionDetails = _checkoutSession$tran === undefined ? {} : _checkoutSession$tran;

            var txnId = transactionDetails.receipt_id || transactionDetails.id || '';

            _logger.$logger.info('Messenger_plugin_props', { pluginType: pluginType, isMobile: isMobile });
            _logger.$logger.info('Messenger_plugin_data', messengerIntegration);

            // if 'isChatEnabled' variable is enabled, it means that user has already onboarded to
            // the messenger feature, so don't trigger messenger onboarding for that user again
            if (!overrideRepeatUserFlag && (isChatEnabled || fbBAShownFlag === 'true' && pluginType === 'STM')) {
                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
                _logger.$logger.info('checkout_fpti', {
                    buyer_country: country,
                    buyer_id: payerId,
                    design: 'fbmessenger',
                    from: 'XO_REVIEW',
                    to: 'process_XO_success',
                    eligibility_reason: 'chat_pref_enabled'
                });
                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                (0, _jquery2['default'])('#stm-upsell-content').hide();
                return;
            }

            // set all the needed props for the template to render (basically anything attached to `this`)
            // Messenger plugin – comparare this user ID hash with FB user
            this.identityMatchVal = JSON.stringify({
                email_hash: emailHash,
                name_hash: nameHash
            });
            this.dataRefVal = dataRefJWT + '_txnID_' + txnId + '_plugin_' + pluginType + '_token_' + token + '_locale_' + lang + '_' + country;
            this.originVal = window.location.origin;
            this.pageIdVal = _squid.$config.deploy.isLive() ? _fbMessenger2['default'].FB_PROD_PAGE_ID[country] : _fbMessenger2['default'].FB_TEST_PAGE_ID;

            if (pluginType === 'CHECKBOX') {
                this.uuidVal = payerId + '_' + _uuid2['default'].v1(); // the `user_ref`, which includes the user's payer ID

                if (_squid.$util.sessionStorageEnabled()) {
                    window.sessionStorage.setItem('checkboxUUIDVal', this.uuidVal);
                }
            }

            // load the correct SDK based on the user's locale
            // it'll fallback to en_US if the locale isn't supported by facebook
            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/fbjs/' + lang + '_' + country + '/sdk.js').then(function () {
                if (window.FB) {
                    _this.fbAsyncInit();

                    // NOTE: uncomment to test on stage and localhost
                    // this.cbSTMPlugin({
                    //     event: 'identity_match',
                    //     ref: this.dataRefVal,
                    //     result: 'match'
                    // });
                }
            })['catch'](function (err) {
                // just log that script is not loaded
                // messenger is an optional service which should not block payment done page rendering
                return _logger.$logger.info('fb_messenger_load_script_error', { error: err && err.message });
            });

            this.cbSTMPlugin = function (evt) {
                if (pluginType === 'STM') {
                    if (evt.event === 'rendered') {
                        _logger.$logger.info('STM_plugin_rendered');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_rendering_plugin',
                            eligibility_reason: 'plugin_rendered'
                        });
                    }

                    if (evt.event === 'identity_match' && evt.result === 'match') {
                        _logger.$logger.info('FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_identity_matching',
                            eligibility_reason: 'identity_matched'
                        });

                        _this.dataRefVal = evt.ref;

                        _jquery2['default'].ajax({
                            url: isMobile ? _fbMessenger2['default'].FB_USER_API_MOBILE_URL : _fbMessenger2['default'].FB_USER_API_URL,
                            xhrFields: { withCredentials: true }
                        }).always(function () {
                            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                _ref2$responseText = _ref2.responseText,
                                responseText = _ref2$responseText === undefined ? '' : _ref2$responseText;

                            var json = responseText.substring(responseText.indexOf('{'));
                            var data = JSON.parse(json);

                            _logger.$logger.info('callFBToGetBAToken_call', data);
                            messengerIntegration.action('callFBToGetBAToken', {
                                data: { userIdentifier: data.user_identifier },
                                success: function success() {
                                    var getBAResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                    var isSuccessful = getBAResponse.success,
                                        batoken = getBAResponse.batoken;

                                    if (isSuccessful) {
                                        _logger.$logger.info('BAToken_from_FB', {
                                            batoken: batoken
                                        });

                                        var fbBAToken = batoken;
                                        var xoJSData = void 0;

                                        if (_squid.$config.deploy.isLocal()) {
                                            xoJSData = {
                                                'data-env': 'local',
                                                'data-stage': 'msmaster',
                                                'data-no-bridge': ''
                                            };

                                            // Generate new FB Channel BA and update while testing, BA gets invalidated in few hours
                                            fbBAToken = 'BA-5UD039368V581733E';
                                        } else if (_squid.$config.deploy.isStage() || _squid.$config.deploy.isSandbox()) {
                                            xoJSData = {
                                                'data-env': 'sandbox',
                                                'data-no-bridge': ''
                                            };
                                        } else {
                                            xoJSData = {
                                                'data-env': 'production',
                                                'data-no-bridge': ''
                                            };
                                        }

                                        var launchBAFlow = function launchBAFlow() {
                                            _logger.$logger.info('Launch_BA_flow_with_token', { fbBAToken: fbBAToken });
                                            _logger.$logger.info('checkout_fpti', {
                                                buyer_country: country,
                                                buyer_id: payerId,
                                                design: 'fbmessenger',
                                                from: 'XO_REVIEW',
                                                to: 'prepare_billing_agreement',
                                                eligibility_reason: 'identity_matched',
                                                click_source: 'pay_now',
                                                ba_token: fbBAToken
                                            });

                                            window.paypal.Checkout.contexts.iframe = true;
                                            if (_squid.$util.localStorageEnabled()) {
                                                window.localStorage.setItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG, 'true');
                                            }
                                            window.paypal.Checkout.render({
                                                experience: {
                                                    messenger: true,
                                                    override_fbpp_repeat: overrideRepeatUserFlag
                                                },
                                                payment: function payment() {
                                                    return fbBAToken;
                                                },

                                                onAuthorize: function onAuthorize() {
                                                    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                                                        baToken = _ref3.billingToken;

                                                    _logger.$logger.info('User_accepted_FB_BA');

                                                    var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';
                                                    var eligibility_reason = isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked';
                                                    if (isUnchecked) {
                                                        _logger.$logger.info('user_not_accepted_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#ba-integration-content').show();
                                                    } else {
                                                        _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
                                                        (0, _jquery2['default'])('.fb-send-to-messenger').hide();
                                                        (0, _jquery2['default'])('#stm-upsell-content').hide();
                                                        (0, _jquery2['default'])('#messenger-ba-integration-content').show();
                                                    }
                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'process_billing_agreement',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'agree_continue',
                                                        ba_token: fbBAToken
                                                    });

                                                    _this.confirmCheckboxPluginOptIn();
                                                    messengerIntegration.action('notifyFBOntBAAuthorize', {
                                                        data: { baToken: baToken },
                                                        success: function success() {
                                                            var authorizeResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                                                            if (authorizeResponse.success) {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
                                                            } else {
                                                                _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
                                                                _logger.$logger.info('checkout_fpti', {
                                                                    buyer_country: country,
                                                                    buyer_id: payerId,
                                                                    design: 'fbmessenger',
                                                                    int_error_code: '500',
                                                                    int_error_description: JSON.stringify(authorizeResponse),
                                                                    error_type: 'failure',
                                                                    error_source: 'notifyFBOntBAAuthorize'
                                                                });
                                                            }
                                                        }
                                                    });

                                                    _logger.$logger.info('checkout_fpti', {
                                                        buyer_country: country,
                                                        buyer_id: payerId,
                                                        design: 'fbmessenger',
                                                        from: 'BILLING_AGREEMENT',
                                                        to: 'prepare_billing_agreement_success',
                                                        eligibility_reason: eligibility_reason,
                                                        click_source: 'return_to_merchant',
                                                        ba_token: fbBAToken
                                                    });
                                                }
                                            });
                                        };
                                        if (window.paypal) {
                                            _logger.$logger.info('xo_JS_is_already_present');
                                            launchBAFlow();
                                        } else {
                                            _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/checkout.js', 0, xoJSData).then(function () {
                                                _logger.$logger.info('xo_JS_got_loaded');
                                                launchBAFlow();
                                            });
                                        }
                                    } else {
                                        _logger.$logger.info('callFBToGetBAToken_call_failure!');
                                        _logger.$logger.info('checkout_fpti', {
                                            buyer_country: country,
                                            buyer_id: payerId,
                                            design: 'fbmessenger',
                                            int_error_code: '500',
                                            int_error_description: JSON.stringify(getBAResponse),
                                            error_type: 'failure',
                                            error_source: 'callFBToGetBAToken'
                                        });
                                    }
                                }
                            });
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_match') {
                        _logger.$logger.info('No_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'identity_not_matched',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user') {
                        _logger.$logger.info('No_loggedin_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            from: 'XO_REVIEW',
                            to: 'process_XO_success',
                            eligibility_reason: 'logged_out',
                            click_source: 'pay_now'
                        });
                    } else if (evt.event === 'identity_match' && evt.result === 'failure') {
                        _logger.$logger.info('Fail_FBPP_ID_match');
                        _logger.$logger.info('checkout_fpti', {
                            buyer_country: country,
                            buyer_id: payerId,
                            design: 'fbmessenger',
                            int_error_code: '500',
                            int_error_description: JSON.stringify(evt),
                            error_type: 'failure',
                            error_source: 'identity_match'
                        });
                    } else if (evt.event === 'clicked') {
                        _logger.$logger.info('user_accepted_STM_messenger_notifications');
                    }
                }
            };

            this.fbAsyncInit = function () {
                _logger.$logger.info('Initializing_FB_scripts');
                window.FB.init({
                    appId: _fbMessenger2['default'].FB_PROD_APP_ID,
                    xfbml: true,
                    version: 'v7.0'
                });

                // Subscribe to STM
                window.FB.Event.subscribe('send_to_messenger', _this.cbSTMPlugin);

                // Subscribe to CHECKBOX
                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
                    _logger.$logger.info('messenger_checkbox_event', evt);
                    if (evt.event === 'checkbox') {
                        if (_squid.$util.sessionStorageEnabled()) {
                            window.sessionStorage.setItem('checkboxPluginState', evt.state);
                        }
                        _logger.$logger.info('checkbox_plugin_state_' + evt.state);
                    }
                });
            };

            this.confirmCheckboxPluginOptIn = function () {
                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
                    uuidVal: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || '',
                    pageIdVal: _this.pageIdVal,
                    dataRefVal: _this.dataRefVal
                });
                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                    page_id: _this.pageIdVal,
                    app_id: _fbMessenger2['default'].FB_PROD_APP_ID,
                    ref: _this.dataRefVal,
                    user_ref: _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxUUIDVal') || ''
                });
            };
        },
        exit: function exit() {
            _logger.$logger.info('Messenger_plugin_EXIT_event');
        }
    }
});


_angular.noop;

_logger.$logger;

_squid.$Component;

_squid.$dom;

_squid.$util;

_squid.$config;

_squid.$locale;

_index.$DeviceInfo;

_index2.$CheckoutSessionModel;

_index3.$MessengerIntegrationDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-page-components/src/messenger-plugin/template.html":
/***/ (function(module, exports) {

module.exports = "<messenger-plugin content>\n  <div id=\"messenger-plugin\" ng-value=\"props.pluginType\">\n    <div\n      class=\"fb-send-to-messenger\"\n      origin=\"{{originVal}}\"\n      identity_match=\"{{identityMatchVal}}\"\n      messenger_app_id=\"1084613224964631\"\n      page_id=\"{{pageIdVal}}\"\n      data-ref=\"{{dataRefVal}}\"\n      color=\"blue\"\n      size=\"xlarge\"\n      ng-if=\"(props.pluginType == 'STM')\"\n    ></div>\n\n    <div\n      class=\"fb-messenger-checkbox\"\n      origin=\"{{originVal}}\"\n      page_id=\"{{pageIdVal}}\"\n      messenger_app_id=\"1084613224964631\"\n      pixel_id=\"329481497393670\"\n      ref=\"{{dataRefVal}}\"\n      user_ref=\"{{uuidVal}}\"\n      allow_login=\"true\"\n      size=\"xlarge\"\n      ng-if=\"(props.pluginType == 'CHECKBOX')\"\n    ></div>\n  </div>\n</messenger-plugin>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoNotYouComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _template = __webpack_require__("../node_modules/xo-page-components/src/notYou/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/notYou/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNotYouComponent = exports.$xoNotYouComponent = _squid.$Component.extend('$xoNotYou', {
    tag: 'xo-not-you',
    template: _template2['default'],
    resolve: {
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                appData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
                venmoTransactionElig: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },
    actions: {
        onClick: function onClick() {
            this.actions.logout();
        },
        logout: function logout() {
            var _this = this;

            _logger.$logger.info('not_you_logout');
            if (window.xchild && _squid.$util.isIFrame() && window.paypal && !window.paypal.isWebView()) {
                window.xchild.hide();

                var url = window.location.href.split('#')[0];
                var xprops = _squid.$util.extend({}, window.xprops);

                xprops.url = url;
                xprops.payment = function () {
                    return _this.models.auth.logout().then(function () {
                        return _angular.$rootScope.token;
                    });
                };

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            this.models.auth.logoutAndRedirect('NOT_YOU');
        },
        getMessage: function getMessage() {
            // if Venmo Eligible and not currently Venmo flow...
            if (this.models.venmoTransactionElig.venmo && !this.isVenmoExperience) {
                // do you prefer Venmo?
                return _squid.$locale.content.get('memberReview.preferToPayWithVenmo');
            }

            // if there's a Paypal One Touch cookie present and we're currently in a venmo flow
            if (this.models.auth.refresh_token && this.isVenmoExperience) {
                // do you prefer Paypal?
                return _squid.$locale.content.get('memberReview.preferToPayWithPaypal');
            }

            // not you?
            return _squid.$locale.content.get('memberReview.notYou');
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            this.token = _angular.$rootScope.token;
            this.isVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(this.token) === 'VENMO_EXPERIENCE';
            this.message = this.actions.getMessage();

            // if we reload page because of locale change, reload the content using updated locale
            this.$on('localeChange', function () {
                _this2.message = _this2.actions.getMessage();
            });
        }
    }
});

angular.value("$xoNotYouComponent", $xoNotYouComponent);
_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$util;

_squid.$locale;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_venmoModels.$VenmoTransactionEligibility;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/notYou/template.html":
/***/ (function(module, exports) {

module.exports = "<a content track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.onClick()\">{{ this.message }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {



var addValidParam = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js").addValidParam;

function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
    var params = {};
    var customData = checkoutCart.get('purchase.custom');

    if (returnToMerchantMethod === 'POST') {
        // TODO: find out why we get postbackData as undefined
        // UPDATE: couldn't reproduce an issue on the stage for now
        if (checkoutSession.postbackData) {
            params = checkoutSession.postbackData;
        }
    } else {
        var transactionDetail = checkoutSession.transactionDetails;

        if (transactionDetail) {
            addValidParam(params, 'tx', transactionDetail.id);
            addValidParam(params, 'st', transactionDetail.state);

            if (transactionDetail.amount) {
                addValidParam(params, 'amt', transactionDetail.amount.total);
                addValidParam(params, 'cc', transactionDetail.amount.currency);
            }
        }

        // Cart uploads can have more than one item so we don't add any in return URL
        if (!is_cart_upload_flow) {
            var itemDetail = checkoutSession.get('itemsList.0');
            if (itemDetail) {
                addValidParam(params, 'item_name', itemDetail.name);
                addValidParam(params, 'item_number', itemDetail.sku);
            }
        }

        addValidParam(params, 'cm', customData);
    }
    return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
 * to know more details about post back data

 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
        if (feature === 'WPS') {
            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
        }
        return {};
    }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionTerms = __webpack_require__("../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js");

var _subscriptionTerms2 = _interopRequireDefault(_subscriptionTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFirstAmount: _subscriptionTerms2['default'].getFirstAmount,
    getFormattedFirstAmount: _subscriptionTerms2['default'].getFormattedFirstAmount,
    getFormattedAmount: _subscriptionTerms2['default'].getFormattedAmount,
    getItemOptions: _subscriptionTerms2['default'].getItemOptions,
    getItemName: _subscriptionTerms2['default'].getItemName,
    getCurrencyCode: _subscriptionTerms2['default'].getCurrencyCode,
    getTermsText: _subscriptionTerms2['default'].getTermsText,
    getEffectiveDate: _subscriptionTerms2['default'].getEffectiveDate,
    getNumericValueNonZero: _subscriptionTerms2['default'].getNumericValueNonZero,
    isNumericValue: _subscriptionTerms2['default'].isNumericValue
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var BILL_PERIOD_YEAR = 'YEAR';
var TRIAL_SUBSCRIPTION = 'TRIAL';
var REGULAR_SUBSCRIPTION = 'REGULAR';
var INFINITE_CYCLES = 'INFINITE';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Wrapper for calling formatCurrent fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
    var timeUnit = void 0;

    switch (billPeriod) {
        case BILL_PERIOD_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case BILL_PERIOD_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case BILL_PERIOD_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case BILL_PERIOD_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
        default:
            timeUnit = '';
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
    if (amount === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return getFormattedCurrency(amount, currencyCode, false);
    }
}

/**
 * This method computes first trial key
 * @returns {string} Content Key for 1st trial, which must be prepended by wpsSubscription.message
 */
function computeFirstTrialKey() {
    if (pluralTimeUnit) {
        // {amount} for the first {timePeriod} {timeUnit}
        return 'firstTrialPeriod.plural';
    } else {
        // {amount} for the first {timeUnit}
        return 'firstTrialPeriod.singular';
    }
}

/**
 * This method computes content key for 2nd trial
 * @returns {string} Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeSecondTrialKey() {
    if (pluralTimeUnit) {
        // Then {amount} for the next {timePeriod} {timeUnit}
        return 'secondTrialPeriod.plural';
    } else {
        // Then {amount} for the next {timeUnit}
        return 'secondTrialPeriod.singular';
    }
}

/**
 * Computes and returns content key for regular subscription
 * There can be 12 variations of regular subscription content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeRegularSubscriptionKey(totalCycles) {
    var key = 'regularSubscriptionPeriod';

    if (hasPriorTerm) {
        // Content starts with Then {amount} for ......
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        key += '.noPriorTerms';
    }

    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
        case 1:
            // Text will look like $20.00 USD for the next 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        case Infinity:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param subscriptionTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermText(subscriptionTerms, index, currencyCode) {
    var amount = +subscriptionTerms[index].amount,
        billPeriod = subscriptionTerms[index].billPeriod,
        periodType = subscriptionTerms[index].periodType,
        billFrequency = +subscriptionTerms[index].billFrequency,
        totalCycles = +subscriptionTerms[index].totalCycles;
    var contentKey = void 0;
    hasPriorTerm = index > 0;
    pluralTimeUnit = billFrequency > 1;

    if (periodType === TRIAL_SUBSCRIPTION) {
        if (index === 0) {
            // First Trial
            contentKey = computeFirstTrialKey();
        } else if (index === 1) {
            // Second Trial
            contentKey = computeSecondTrialKey();
        }
    } else if (periodType === REGULAR_SUBSCRIPTION) {
        contentKey = computeRegularSubscriptionKey(totalCycles);
    }
    contentKey = 'wpsSubscription.message.' + contentKey;
    var templatePlaceholderData = {
        amount: computeAmount(amount, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

function mapBaResponse(baResponseData) {
    var mappedSubscriptionDetails = {};
    var plan = baResponseData && baResponseData.plan;
    var allTerms = plan && plan.payment_definitions;
    var mappedTerms = [];
    var firstTrialAmount = null;
    var regularAmount = void 0;
    mappedSubscriptionDetails.currencyCode = plan && plan.currency_code;

    if (allTerms) {
        allTerms.forEach(function (eachTerm) {
            var totalCycles = eachTerm.duration === INFINITE_CYCLES ? Infinity : eachTerm.cycles;
            var eachMappedTerm = {
                amount: eachTerm.amount && eachTerm.amount.value / 100,
                billPeriod: eachTerm.frequency,
                periodType: eachTerm.type,
                billFrequency: eachTerm.frequency_interval,
                totalCycles: totalCycles
            };

            if (!mappedSubscriptionDetails.currencyCode) {
                // V1 Subscriptions: Pick currency code from any of the amounts.
                mappedSubscriptionDetails.currencyCode = eachTerm.amount && eachTerm.amount.currency_code;
            }

            if (eachTerm.type === TRIAL_SUBSCRIPTION && eachTerm.index === '1') {
                firstTrialAmount = eachMappedTerm.amount;
            } else if (eachTerm.type === REGULAR_SUBSCRIPTION) {
                regularAmount = eachMappedTerm.amount;
            }
            mappedTerms.push(eachMappedTerm);
        });

        // firstTrialAmount can be zero for free trial, null for no trial
        // and valid value if there is trial amount
        mappedSubscriptionDetails.firstAmount = firstTrialAmount !== null ? firstTrialAmount : regularAmount;
        mappedSubscriptionDetails.subscriptionTerms = mappedTerms;
    }

    return mappedSubscriptionDetails;
}

/**
 * Prepare and return a subscription terms
 * @param baResponseData
 * @returns {Object} Containing Subscription Terms Text
 */
function getTermsText(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);
    var subscriptionTerms = subscriptionDetails.subscriptionTerms;
    var currencyCode = subscriptionDetails.currencyCode;
    var termTextList = [];

    for (var i = 0, len = subscriptionTerms.length; i < len; i++) {
        termTextList.push(prepareIndividualTermText(subscriptionTerms, i, currencyCode));
    }
    return termTextList;
}

/**
 * Returns a un formatted first amount from ba response
 */
function getFirstAmount(baResponseData) {
    var subscriptionDetails = mapBaResponse(baResponseData);

    return subscriptionDetails.firstAmount;
}

/**
 * Returns the currency code
 */
function getCurrencyCode(baResponseData) {
    var plan = baResponseData && baResponseData.plan;

    return plan && plan.currency_code;
}

/**
 * Returns a formatted first amount from ba response data
 */
function getFormattedFirstAmount(baResponseData) {
    var amount = getFirstAmount(baResponseData);
    var currencyCode = getCurrencyCode(baResponseData);

    return getFormattedCurrency(amount, currencyCode, false);
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
    var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];

    return itemDetails.options;
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
    if (!baResponseData) {
        return;
    }
    var _baResponseData$items = baResponseData.items;
    _baResponseData$items = _baResponseData$items === undefined ? [] : _baResponseData$items;
    var _baResponseData$items2 = _baResponseData$items[0];
    _baResponseData$items2 = _baResponseData$items2 === undefined ? {} : _baResponseData$items2;
    var name = _baResponseData$items2.name;

    return name;
}

function getEffectiveDate(baResponseData) {
    return baResponseData && baResponseData.effective_date;
}

function getFormattedAmount(amount, currencyCode) {
    var formattedAmount = amount / 100;

    return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}

function getNumericValueNonZero(obj, path) {
    var data = parseFloat(_squid.$util.getProperty(obj, path));
    return !isNaN(data) && data > 0 && data;
}

function isNumericValue(value) {
    var data = parseInt(value, 10);
    return !isNaN(data) && data >= 0;
}

module.exports = {
    getFirstAmount: getFirstAmount,
    getFormattedFirstAmount: getFormattedFirstAmount,
    getFormattedAmount: getFormattedAmount,
    getItemOptions: getItemOptions,
    getItemName: getItemName,
    getCurrencyCode: getCurrencyCode,
    getTermsText: getTermsText,
    getEffectiveDate: getEffectiveDate,
    getNumericValueNonZero: getNumericValueNonZero,
    isNumericValue: isNumericValue
};

_squid.formatCurrency;

_squid.Content;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionV1Terms = __webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js");

var _subscriptionV1Terms2 = _interopRequireDefault(_subscriptionV1Terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFormattedAmount: _subscriptionV1Terms2['default'].getFormattedAmount,
    getTermsText: _subscriptionV1Terms2['default'].getTermsText,
    getNumericValueNonZero: _subscriptionV1Terms2['default'].getNumericValueNonZero,
    isNumericValue: _subscriptionV1Terms2['default'].isNumericValue,
    getTaxDisclaimer: _subscriptionV1Terms2['default'].getTaxDisclaimer
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getTermsText = getTermsText;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var INTERVAL_UNIT_DAY = 'DAY'; /**
                                * This file contains the computation of terms from billing cycles object in planReview data
                                */

var INTERVAL_UNIT_WEEK = 'WEEK';
var INTERVAL_UNIT_MONTH = 'MONTH';
var INTERVAL_UNIT_YEAR = 'YEAR';

/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
    arguments[0] = arguments[0].toFixed(2);
    return _squid.formatCurrency.apply(undefined, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
    return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @param pluralTimeUnit
 * @returns {string}
 */
function computeTimeUnit(billPeriod, pluralTimeUnit) {

    var timeUnit = void 0;

    // eslint-disable-next-line default-case
    switch (billPeriod) {
        case INTERVAL_UNIT_DAY:
            timeUnit = pluralTimeUnit ? 'days' : 'day';
            break;
        case INTERVAL_UNIT_WEEK:
            timeUnit = pluralTimeUnit ? 'weeks' : 'week';
            break;
        case INTERVAL_UNIT_MONTH:
            timeUnit = pluralTimeUnit ? 'months' : 'month';
            break;
        case INTERVAL_UNIT_YEAR:
            timeUnit = pluralTimeUnit ? 'years' : 'year';
            break;
    }

    return localizedContent('wpsSubscription.label.' + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amountValue, currencyCode) {
    if (amountValue === 0) {
        return localizedContent('wpsSubscription.label.free');
    } else {
        return getFormattedCurrency(amountValue, currencyCode, false);
    }
}

/**
 * Computes and returns content key for subscription terms
 * There can be 12 variations of subscription content
 * @param totalCycles
 * @param hasPriorTerm
 * @param pluralTimeUnit
 * @returns {string}  Content Key which must be prepended by wpsSubscription.message
 */
function computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit) {

    var key = 'regularSubscriptionPeriod';

    /**
     * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
     * @type {boolean}
     */
    if (hasPriorTerm) {
        // Content starts with Then, e.g. Then 2$ for next 4 months
        key += '.withPriorTerms';
    } else {
        // Content does NOT starts with Then
        // Content looks like 2$ for next 4 months
        key += '.noPriorTerms';
    }

    /**
     * Plural time unit
     * @type {boolean}
     */
    if (pluralTimeUnit) {
        // Content has: {amount} for each 2 days/weeks/months/years
        key += '.plural';
    } else {
        // Content has: {amount} for each day/week/month/year
        key += '.singular';
    }

    switch (+totalCycles) {
        case 0:
            // Content ends with: for each 2 months OR for each month
            // Content will look like $30.00 USD for each week
            key += '.recurringInfinite';
            break;
        case 1:
            // Text will look like $20.00 USD for 2 months
            // Content does NOT end with: for 3 installments
            key += '.nonRecurring';
            break;
        default:
            // Content ends with: for 3 installments
            // Content will look like $100.00 USD for each 2 months, for 3 installments
            key += '.recurring';
    }
    return key;
}

/**
 * Prepares and returns an individual term text string
 * @param billingCycle
 * @param index
 * @returns {string}
 */
function prepareIndividualTermText(billingCycle, index) {
    var amount = billingCycle.pricing_scheme.fixed_price;
    var amountValue = amount.value / 100;
    var currencyCode = amount.currency_code;
    var billPeriod = billingCycle.frequency.interval_unit;
    var billFrequency = billingCycle.frequency.interval_count;
    var totalCycles = billingCycle.total_cycles;

    var pluralTimeUnit = billFrequency > 1;
    var hasPriorTerm = index > 0;

    var computedContentKey = computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit);
    var contentKey = 'wpsSubscription.message.' + computedContentKey;

    var templatePlaceholderData = {
        amount: computeAmount(amountValue, currencyCode),
        timePeriod: billFrequency,
        timeUnit: computeTimeUnit(billPeriod, pluralTimeUnit),
        installmentCount: totalCycles
    };

    return localizedContent(contentKey, templatePlaceholderData);
}

/**
 * Prepare and return a subscription terms
 * @param plan data from planReview
 * @returns {Array} Subscription Terms Text
 */
function getTermsText(planResponse) {
    var termTextList = [];
    var billingCycles = _squid.$util.getProperty(planResponse, 'plan.billing_cycles');

    billingCycles.forEach(function (billingCycle, index) {
        termTextList.push(prepareIndividualTermText(billingCycle, index));
    });
    return termTextList;
}

function getFormattedAmount(amount, currencyCode) {
    var formattedAmount = amount / 100;

    return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}

function getNumericValueNonZero(obj, path) {
    var data = parseFloat(_squid.$util.getProperty(obj, path));

    return !isNaN(data) && data > 0 && data;
}

function isNumericValue(value) {
    var data = parseInt(value, 10);

    return !isNaN(data) && data >= 0;
}

function getTaxDisclaimer(taxPercentage, taxAmount) {
    if (taxPercentage) {
        return localizedContent('subscriptions.message.includesTax', { tax: taxPercentage });
    } else if (taxAmount) {
        return localizedContent('subscriptions.message.includesTaxAmount', { tax: taxAmount });
    }
    return '';
}

module.exports = {
    getFormattedAmount: getFormattedAmount,
    getTermsText: getTermsText,
    getNumericValueNonZero: getNumericValueNonZero,
    isNumericValue: isNumericValue,
    getTaxDisclaimer: getTaxDisclaimer
};

_squid.formatCurrency;

_squid.Content;

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _fbMessenger = __webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js");

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    /**
     * add non empty key, value to the object
     * @param {Object} object where to add new key, value
     * @param {String} key
     * @param {Any type} value, can not be empty
     * @returns {void}
     */
    addValidParam: function addValidParam(obj, key, val) {
        if (!obj) {
            return;
        }
        if (typeof key === 'string' && key && val !== undefined && val !== null) {
            obj[key] = val;
        }
    },

    // Get PXP context for Messenger feature
    getMessengerPXPContext: function getMessengerPXPContext() {
        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
        var pxpContext = {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
        };

        return pxpContext;
    },

    isDolphinEligibleOnWpsDone: function isDolphinEligibleOnWpsDone(stateName) {
        return (/checkout\.done/.test(stateName) && !!_squid.$util.param('ulToastWpsDone')
        );
    }
}; /* eslint-disable angular/typecheck-string */


_squid.$util;

_squid.$locale;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                type: '@?',
                title: '@?',
                text: '@?',
                textContent: '@?',
                imageUrl: '@?'
            },
            link: function link(scope, element, attrs) {
                if (angular.isString(attrs.imageUrl)) {
                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
                    // to standard size i.e. 150X150 pixels.
                    attrs.$observe('imageUrl', function (imageUrl) {
                        var url = imageUrl;
                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                        if (isRetina) {
                            var index = url.lastIndexOf('.'); // index at which file extension start
                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'background-size': '150px 150px',
                                'margin-top': '0px'
                            });
                        } else {
                            propImg.css({
                                'background-image': 'url(' + url + ')',
                                'height': '150px',
                                'margin-top': '0px'
                            });
                        }
                    });
                }
            }
        };
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/formatReturnContent.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;

function formatReturnContent($renderContent, merchantName) {
    if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
        return $renderContent('common.returnToMerchant', { merchantName: merchantName });
    }

    return $renderContent('common.returnToDefaultMerchant');
}

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

Object.defineProperty(exports, '$ReturnToMerchant', {
  enumerable: true,
  get: function get() {
    return _util.$ReturnToMerchant;
  }
});

var _formatReturnContent = __webpack_require__("../node_modules/xo-return-to-merchant/dist/formatReturnContent.js");

Object.defineProperty(exports, 'formatReturnContent', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.formatReturnContent;
  }
});
Object.defineProperty(exports, 'MAX_MERCHANT_NAME_LENGTH', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;
  }
});

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReturnToMerchant = undefined;
exports.goTo = goTo;
exports.postToMerchant = postToMerchant;
exports.postTo = postTo;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goTo(url, forceRedirect) {
    _logger.$logger.info('goTo', { url: url, forceRedirect: forceRedirect });

    if (!url) {
        return;
    }

    _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
        url: url
    });

    // if V4 in-context integration, we'll terminate and call the close handler.
    if (window.xchild) {
        _logger.$logger.done();
        _angular.$rootScope.$emit('loading');

        var _paymentToken = _angular.$rootScope.token;
        var cart = _index2.$CheckoutCartModel.instance(_paymentToken);
        var appData = _index2.$CheckoutAppDataModel.instance(_paymentToken);
        var orderID = _paymentToken;
        var intent = cart.payment_action;
        var billingToken = cart.billing && cart.billing.ba_token;
        var paymentID = appData.payment_id;
        var cancelUrl = url;

        return window.xprops.onCancel({
            paymentToken: _paymentToken,
            billingToken: billingToken,
            orderID: orderID,
            paymentID: paymentID,
            intent: intent,
            cancelUrl: cancelUrl
        });
    }

    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
    var isNativeXo = _squid.$util.param('native_xo') && _squid.$util.param('native_xo') === '1';
    // if isDevice, NOT an HTTP url, and NOT a Native Checkout Transaction
    var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl && !isNativeXo);

    _logger.$logger.info('showPaymentSuccess', {
        isDevice: _index.$DeviceInfo.isDevice(),
        isHTTPUrl: isHTTPUrl,
        isNativeXo: isNativeXo
    });

    if (showPaymentSuccess) {
        _logger.$logger.info('showPaymentSuccessRedirect', {
            url: url
        });

        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
        };

        // wait until state change is done and then redirect
        // for some reason, in case of webview (invoice flow) and code split
        // when user is redirecting to the return url - dynamic chunk fails to load
        // which triggers reload of the previous page
        return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS',
            returnUrl: url
        })['catch'](function (err) {
            _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                error: err && err.message
            });
        })['finally'](function () {
            _angular.$window.location = url;
        });
    }

    if (forceRedirect) {
        _logger.$logger.info('forceRedirect', {
            url: url
        });

        _squid.$util.redirect(url);
    } else {
        var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();

        if (isVZeroIframe) {
            _logger.$logger.info('VZeroIframeRedirect');
            _squid.$util.redirect(url, { redirectImmediateParent: true });
        }

        // If we are not in minibrowser, do a hard redirect
        else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
                _logger.$logger.info('redirectFlowType', {
                    partnerIntegration: _angular.$rootScope.partnerIntegration,
                    miniBrower: _angular.$rootScope.miniBrowser,
                    iframe: _squid.$util.isIFrame()
                });

                _squid.$util.redirect(url);
            } else {

                // Construct a message to send to the parent
                var result = this.postToMerchant({
                    operation: 'return_to_merchant',
                    returnUrl: url,
                    updateParent: true
                });

                // Otherwise we have no choice but to return to the merchant
                if (!result) {
                    _logger.$logger.info('postFalseHardRedirect');
                    _squid.$util.redirect(url);
                }
            }
    }

    var paymentToken = _angular.$rootScope.token;
    var payee = _index2.$CheckoutPayeeModel.instance(paymentToken);
    var merchantId = payee.get('merchant.id');

    var userStatus = function userStatus() {
        _logger.$logger.info('redirected_user_still_on_page_second_checkpoint', { merchantId: merchantId });

        if (!_squid.$config.deploy.isLocal()) {
            // If user is still present on this screen, redirect buyer to generic message page when merchant is whitelisted.
            // some merchants want the spinner to be displayed until they take necessary action at their end.
            // These merchants can be put in black list and we can do ramp as well for rest of the merchants if PO wants it.
            (0, _squid.$elmo)('show_end_of_flow', { uid: merchantId }, 'Trmt_show_end_of_flow').then(function (elmoResult) {
                if (elmoResult && elmoResult.treatment_name) {
                    _angular.$rootScope.allowStateChangeAfterRedirect = true;
                    _angular.$rootScope.$emit('loaded');
                    _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
                    };

                    return _uiRouter.$state.go('checkout.genericMessage', {
                        code: 'PAYMENT_SUCCESS_REDIRECT_FAILED',
                        returnUrl: url
                    })['catch'](function (err) {
                        _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
                            error: err && err.message
                        });
                    });
                }
            })['catch'](function (err) {
                // In case elmo call fails, just log and do not do any action.
                _logger.$logger.error('elmo_call_failed', {
                    error: err.stack || err.toString()
                });
            });
        }
    };

    var timeout = _squid.$config.idleTimeoutPostRedirectSuccess;

    (0, _angular.$timeout)(function () {
        _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
        (0, _angular.$timeout)(userStatus, timeout);
    }, timeout);
}

function postToMerchant(msg) {

    try {
        msg = _angular2['default'].toJson(msg, 0);

        // If we are not in IE, attempt to send a postMessage
        if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
            _angular.$window.opener.postMessage(msg, '*');
            _logger.$logger.info('minibrowser_postmessage');
            return true;
        }
        // Otherwise, attempt to send a message through the iframe bridge
        var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;

        if (bridge && bridge.returnToParent) {
            bridge.returnToParent(msg);
            _logger.$logger.info('minibrowser_bridgemessage');
            return true;
        }

        _logger.$logger.warn('minibrowser_nopostback');
    } catch (err) {
        _logger.$logger.error('minibrowser_postback_error', {
            error: err.stack || err.toString()
        });
    }

    return false;
}

function postTo(url, msg) {
    var form = document.createElement('form');

    form.method = 'POST';
    form.action = url;
    form.className = 'hide';

    for (var key in msg) {
        var input = document.createElement('input');

        input.name = key;
        input.value = msg[key];
        form.appendChild(input);
    }

    _angular.$window.document.body.appendChild(form);
    form.submit();
    _logger.$logger.info('web_postmessage');
    return true;
}

var $ReturnToMerchant = exports.$ReturnToMerchant = {
    goTo: goTo,
    postToMerchant: postToMerchant,
    postTo: postTo
};

_angular2['default'].value("goTo", goTo);
_angular2['default'].value("postToMerchant", postToMerchant);
_angular2['default'].value("postTo", postTo);
_angular2['default'].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_squid.$util;

_squid.$config;

_squid.$elmo;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/factory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingChangeFactory = $ShippingChangeFactory;

var _util = __webpack_require__("../node_modules/xo-shipping-change/src/util.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $ShippingChangeFactory(_ref) {
    var checkoutAppData = _ref.checkoutAppData,
        checkoutCart = _ref.checkoutCart;

    return {
        getCartTotal: function getCartTotal() {
            return (0, _util.getCartTotal)(checkoutCart);
        },
        getPayload: function getPayload(shippingAddress) {
            var paymentID = checkoutAppData.get('payment_id');
            var orderID = checkoutAppData.get('id');

            return (0, _util.getPayload)({ orderID: orderID, paymentID: paymentID, shippingAddress: shippingAddress, checkoutCart: checkoutCart });
        },
        updateCart: function updateCart() {
            return (0, _util.updateCart)(checkoutCart);
        },
        callOnShippingChange: function callOnShippingChange(payload) {
            var allowChangeShipping = checkoutAppData.get('flags.allow_change_shipping', false);

            if (!allowChangeShipping) {
                return (0, _squid.$promise)({
                    cartHasChanged: false,
                    rejected: false
                });
            }

            return (0, _util.callOnShippingChange)({ payload: payload, checkoutCart: checkoutCart });
        }
    };
}

angular.value("$ShippingChangeFactory", $ShippingChangeFactory);
_util.getCartTotal;

_util.getPayload;

_util.updateCart;

_util.callOnShippingChange;

_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.payloadOutputMapper = exports.amountOutputMapper = exports.breakdownOutputMapper = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var breakdownOutputMapper = exports.breakdownOutputMapper = function breakdownOutputMapper() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        subtotal = _ref.subtotal,
        item_total = _ref.item_total,
        shipping = _ref.shipping,
        handling = _ref.handling,
        tax = _ref.tax,
        tax_total = _ref.tax_total,
        insurance = _ref.insurance,
        shipping_discount = _ref.shipping_discount,
        discount = _ref.discount;

    var breakdown = {
        item_total: subtotal || item_total,
        tax_total: tax || tax_total,
        handling: handling,
        shipping: shipping,
        insurance: insurance,
        discount: discount,
        shipping_discount: shipping_discount
    };

    return Object.keys(breakdown).reduce(function (newBreakdown, item) {
        var _$util$extend;

        if (!breakdown[item]) {
            return newBreakdown;
        }

        return _squid.$util.extend(newBreakdown, (_$util$extend = {}, _$util$extend[item] = amountOutputMapper(breakdown[item]), _$util$extend));
    }, {});
};

var amountOutputMapper = exports.amountOutputMapper = function amountOutputMapper() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        amount = _ref2.amount,
        value = _ref2.value,
        currency = _ref2.currency,
        currency_code = _ref2.currency_code,
        breakdown = _ref2.breakdown;

    var fullAmount = {
        value: amount || value,
        currency_code: currency || currency_code
    };

    return breakdown ? _squid.$util.extend(fullAmount, {
        breakdown: breakdownOutputMapper(breakdown)
    }) : fullAmount;
};

var shippingAddressMapper = function shippingAddressMapper() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        city = _ref3.city,
        state = _ref3.state,
        country_code = _ref3.country_code,
        postal_code = _ref3.postal_code;

    return {
        city: city,
        state: state,
        country_code: country_code,
        postal_code: postal_code
    };
};

var shippingOptionMapper = function shippingOptionMapper() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref4.id,
        label = _ref4.label,
        type = _ref4.type,
        amount = _ref4.amount,
        selected = _ref4.selected;

    if (!id) {
        return undefined;
    }
    return {
        id: id,
        type: type,
        label: label,
        amount: amountOutputMapper(amount),
        selected: selected
    };
};

var payloadOutputMapper = exports.payloadOutputMapper = function payloadOutputMapper(_ref5) {
    var orderID = _ref5.orderID,
        paymentID = _ref5.paymentID,
        shipping_address = _ref5.shipping_address,
        amount = _ref5.amount,
        selected_shipping_option = _ref5.selected_shipping_option;
    return {
        orderID: orderID,
        paymentID: paymentID,
        paymentToken: orderID,
        selected_shipping_option: shippingOptionMapper(selected_shipping_option),
        shipping_address: shippingAddressMapper(shipping_address),
        amount: amountOutputMapper(amount)
    };
};

_squid.$util;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getCartTotal = getCartTotal;
exports.getPayload = getPayload;
exports.updateCart = updateCart;
exports.callOnShippingChange = callOnShippingChange;

var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");

var _outputMapper = __webpack_require__("../node_modules/xo-shipping-change/src/outputMapper.js");

function getCartTotal(cart) {
    var isPurchaseTransaction = cart && cart.get('purchase');

    if (isPurchaseTransaction) {
        var breakdown = Object.keys(cart.get('purchase.amounts')).reduce(function (acc, value) {
            if (value !== 'total') {
                acc[value] = (0, _outputMapper.amountOutputMapper)(cart.get('purchase.amounts.' + value));
            }

            return acc;
        }, {});

        return {
            currency_code: cart.get('purchase.amounts.total.currency_code'),
            value: cart.get('purchase.amounts.total.amount'),
            breakdown: breakdown
        };
    }

    return {
        currency_code: '',
        value: '0.00',
        breakdown: {}
    };
}

function getPayload() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderID = _ref.orderID,
        paymentID = _ref.paymentID,
        _ref$shippingAddress = _ref.shippingAddress,
        shippingAddress = _ref$shippingAddress === undefined ? {} : _ref$shippingAddress,
        checkoutCart = _ref.checkoutCart;

    var city = shippingAddress.city,
        state = shippingAddress.state,
        country = shippingAddress.country,
        postal_code = shippingAddress.postal_code;

    var amount = checkoutCart ? getCartTotal(checkoutCart) : {};

    var shippingChangePayload = {
        orderID: orderID,
        paymentID: paymentID,
        shipping_address: {
            city: city,
            state: state,
            country_code: country,
            postal_code: postal_code
        },
        selected_shipping_option: undefined,
        amount: amount
    };

    return (0, _xoShippingOptions.getSelectedShippingOption)(orderID).then(function (option) {
        shippingChangePayload.selected_shipping_option = option;
    }).then(function () {
        return (0, _outputMapper.payloadOutputMapper)(shippingChangePayload);
    });
}

function updateCart(cart) {
    cart.invalidate();
    cart.api.cache = false;

    return cart.reload().then(function () {
        return getCartTotal(cart);
    });
}

function callOnShippingChange() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref2.payload,
        checkoutCart = _ref2.checkoutCart;

    var rejected = false;
    var shippingOptionsChanged = false;
    var shippingOptions = void 0;

    var shippingChangeActions = {
        reject: function reject() {
            rejected = true;
        }
    };

    var cartTotal = getCartTotal(checkoutCart);

    var changedShippingOptions = function changedShippingOptions() {
        var oldOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var newOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (oldOptions.length !== newOptions.length) {
            return true;
        }

        return Boolean(newOptions.filter(function (key) {
            return JSON.stringify(newOptions[key]) !== JSON.stringify(oldOptions[key]);
        }).length);
    };

    return (0, _xoShippingOptions.getShippingOptions)(payload.orderID).then(function (options) {
        return shippingOptions = options;
    }).then(function () {
        return window.xprops.onShippingChange((0, _outputMapper.payloadOutputMapper)(payload), shippingChangeActions);
    }).then(function () {
        return (0, _xoShippingOptions.getShippingOptions)(payload.orderID);
    }).then(function (options) {
        shippingOptionsChanged = changedShippingOptions(shippingOptions, options);
    }).then(function () {
        return updateCart(checkoutCart);
    }).then(function (total) {
        var newCartTotal = getCartTotal(checkoutCart);
        var cartHasChanged = cartTotal.currency_code !== newCartTotal.currency_code || cartTotal.value !== newCartTotal.value;

        return {
            cartHasChanged: cartHasChanged || shippingOptionsChanged,
            rejected: rejected
        };
    });
}

_xoShippingOptions.getSelectedShippingOption;

_xoShippingOptions.getShippingOptions;

_outputMapper.amountOutputMapper;

_outputMapper.payloadOutputMapper;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _TYPE_CONTENT_MAPPING, _TAB_CONTENT_MAPPING;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/tabs/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/select-simple/directive.js");

var _template = __webpack_require__("../node_modules/xo-shipping-options/src/component/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-shipping-options/src/component/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHIPPING_TYPE = {
    SHIPPING: 'SHIPPING',
    PICKUP: 'PICKUP'
};

var TYPE_CONTENT_MAPPING = (_TYPE_CONTENT_MAPPING = {}, _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipHome', _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.shipStore', _TYPE_CONTENT_MAPPING);

var TAB_CONTENT_MAPPING = (_TAB_CONTENT_MAPPING = {}, _TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipItTab', _TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.pickItUp', _TAB_CONTENT_MAPPING);

exports['default'] = _squid.$Component.extend('$xoShippingOptionsComponent', {
    tag: 'xo-shipping-options',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        methods: {
            type: 'var',
            required: true
        },
        selectedMethod: {
            type: 'var',
            required: false
        },
        onSelect: {
            type: 'var',
            required: false
        },
        onClickEdit: {
            type: 'var',
            required: false
        },
        updateFinished: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },

    actions: {
        // Takes the buyer to the change-shipping page
        gotoShipping: function gotoShipping() {
            if (!this.canChangeShipping) {
                return;
            }

            if (typeof this.onClickEdit === 'function') {
                return this.onClickEdit();
            }

            _uiRouter.$state.go('checkout.review.sidebar.shipping');
        },
        setTab: function setTab(tab) {
            this.actions.setStateTo(tab.id);
        },
        getTabs: function getTabs() {
            if (!this.methods || !this.methods.length) {
                return [];
            }

            var hasShipping = Boolean(this.methods.filter(function (method) {
                return method.type === SHIPPING_TYPE.SHIPPING;
            }).length);
            var hasPickup = Boolean(this.methods.filter(function (method) {
                return method.type === SHIPPING_TYPE.PICKUP;
            }).length);

            var shippingTab = {
                id: SHIPPING_TYPE.SHIPPING,
                label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString()
            };

            var pickupTab = {
                id: SHIPPING_TYPE.PICKUP,
                label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString()
            };

            return [hasShipping && shippingTab, hasPickup && pickupTab].filter(function (tab) {
                return tab;
            });
        },


        // Switches the active tab (pickup or shipping)
        // Auto-selects method if it's the only item, or auto-selects if it was pre-selected
        // Will not auto-select if second param is false
        setStateTo: function setStateTo(state) {
            var _this = this;

            var autoSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            this.state = state;

            var getSelectedTab = function getSelectedTab() {
                return _this.tabs.filter(function (tab) {
                    return tab.id === _this.state;
                }).pop();
            };

            this.selectedTab = getSelectedTab();

            if (!this.methods || !this.methods.length || !this.selectedTab || !autoSelect) {
                return;
            }

            var hasMultiShippingMethods = this.shippingMethods && this.shippingMethods.length > 1;
            var hasMultiPickupMethods = this.pickupMethods && this.pickupMethods.length > 1;

            if (state === SHIPPING_TYPE.SHIPPING) {
                // adding the check for this.selectedMethod ensures that if this.selectedShippingMethod
                // is stale it doesn't continue.
                if (this.selectedShippingMethod && this.selectedMethod) {
                    _logger.$logger.info('selected_shipping_method', {
                        shippingMethod: this.selectedShippingMethod,
                        selectedMethod: this.selectedMethod
                    });
                    return this.actions.selectShippingMethod(this.selectedShippingMethod);
                } else if (hasMultiShippingMethods) {
                    this.showMissingShippingOptionMessage = true;
                    this.showMissingPickupOptionMessage = true;
                    this.missingShippingOptionMessage = {
                        msgKeys: ['shippingMethod.shippingMethodWarning'],
                        type: 'warning'
                    };

                    // the second two parameters of onSelect only apply to hermes and trigger a change
                    // in the application to stop the payNow function

                    this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
                }

                if (this.shippingMethods && this.shippingMethods.length === 1) {
                    return this.actions.selectShippingMethod(this.shippingMethods[0]);
                }
            }

            if (state === SHIPPING_TYPE.PICKUP) {
                // adding the check for this.selectedMethod ensures that if this.selectedPickupMethod
                // is stale it doesn't continue.
                if (this.selectedPickupMethod && this.selectedMethod) {
                    _logger.$logger.info('selected_pickup_method', {
                        shippingMethod: this.selectedPickupMethod,
                        selectedMethod: this.selectedMethod
                    });
                    return this.actions.selectShippingMethod(this.selectedPickupMethod);
                } else if (hasMultiPickupMethods) {
                    this.showMissingPickupOptionMessage = true;
                    this.showMissingShippingOptionMessage = true;
                    this.missingPickupOptionMessage = {
                        msgKeys: ['shippingMethod.pickupMethodWarning'],
                        type: 'warning'
                    };

                    // the second two parameters of onSelect only apply to hermes and trigger a change
                    // in the application to stop the payNow function

                    this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
                }

                if (this.pickupMethods && this.pickupMethods.length === 1) {
                    return this.actions.selectShippingMethod(this.pickupMethods[0]);
                }
            }
        },


        // Set the local selected pickup/shipping method, then call the
        // callback passed via props with the method
        selectShippingMethod: function selectShippingMethod(selected) {
            var _this2 = this;

            var callCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            var getShippingMethodByID = function getShippingMethodByID(id) {
                if (!id) {
                    return false;
                }

                return _this2.methods.find(function (method) {
                    return method.id === id;
                });
            };

            var shippingMethod = getShippingMethodByID(selected && selected.id);

            if (shippingMethod === undefined) {
                this.selectedPickupMethod = false;
                this.selectedShippingMethod = false;
                return this.onSelect(null);
            }

            this.selectedMethod = shippingMethod;

            if (!this.state !== selected.type) {
                this.actions.setStateTo(SHIPPING_TYPE[selected.type], false);
            }

            if (shippingMethod.type === SHIPPING_TYPE.SHIPPING) {
                this.showMissingShippingOptionMessage = false;
                this.showMissingPickupOptionMessage = false;
                this.selectedShippingMethod = this.formatShippingMethod(shippingMethod);
            } else if (shippingMethod.type === SHIPPING_TYPE.PICKUP) {
                this.showMissingShippingOptionMessage = false;
                this.showMissingPickupOptionMessage = false;
                this.selectedPickupMethod = this.formatShippingMethod(shippingMethod);
            } else {
                this.state = SHIPPING_TYPE.SHIPPING;
            }

            if (callCallback) {
                this.onSelect((0, _angular.extend)({}, shippingMethod), this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
            } else {
                this.onSelect(null, false, false);
            }
        },


        // Helper to map shipping methods passed by the props and
        // select only the ones that fit the 'type'.
        mapShippingMethodsByType: function mapShippingMethodsByType() {
            var _this3 = this;

            var shippingMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var type = arguments[1];

            return shippingMethods.filter(function (shippingMethod) {
                return SHIPPING_TYPE[shippingMethod.type] === type;
            }).map(function (shippingMethod) {
                return _this3.formatShippingMethod(shippingMethod);
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.formatShippingMethod = function (method) {
                if (!method || (0, _angular.equals)(method, {})) {
                    return false;
                }

                var getFormattedLabel = function getFormattedLabel() {
                    if (!method.amount || parseFloat(method.amount.value) <= 0) {
                        return method.label;
                    }

                    var amountFormatted = (0, _squid.formatCurrency)(method.amount.value, method.amount.currency_code || method.amount.currency);

                    return (0, _squid.$renderContent)('shipping.customLabelAndAmount', {
                        amount: amountFormatted,
                        label: method.label
                    }).toString();
                };

                return (0, _angular.extend)({}, method, {
                    label: getFormattedLabel()
                });
            };

            // Dropdown active flag
            this.isPickupDropdownActive = false;
            this.isShippingDropdownActive = false;

            // Initiate the shipWarning messages
            this.showMissingPickupOptionMessage = false;
            this.showMissingShippingOptionMessage = false;

            this.isPickup = function () {
                return _this4.state === SHIPPING_TYPE.PICKUP;
            };
            this.isShipping = function () {
                return _this4.state === SHIPPING_TYPE.SHIPPING;
            };

            this.pickupLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString();
            this.shippingLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString();

            this.selectedPickupMethod = false; // eslint-disable-line no-unused-expressions
            this.selectedShippingMethod = false; // eslint-disable-line no-unused-expressions


            this.formatShippingMethods = function () {

                if (!_this4.methods) {
                    return;
                }

                _logger.$logger.info('new_shipping_methods_propagated', {
                    'new_shipping_methods': _this4.methods
                });

                var relaventSelected = !_this4.selectedMethod || !_this4.selectedMethod.label ? false : !!_this4.methods.find(function (option) {
                    return option.label === _this4.selectedMethod.label && option.id === _this4.selectedMethod.id;
                });

                if (!relaventSelected) {
                    _this4.selectedMethod = null;
                }

                _this4.pickupMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.PICKUP);
                _this4.shippingMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.SHIPPING);

                _this4.tabs = _this4.actions.getTabs();

                // We'll render dual tabs ONLY when there are TWO Shipping types sent by the merchant
                _this4.renderTabs = Boolean(_this4.tabs.length > 1);

                if (_this4.selectedMethod) {
                    _this4.actions.selectShippingMethod(_this4.selectedMethod, false);
                    _this4.selectedMethod = null;
                } else if (_this4.methods && _this4.methods.length) {
                    var assigned = _this4.methods.find(function (_ref) {
                        var selected = _ref.selected;
                        return selected;
                    });

                    if (!assigned) {
                        _this4.state = _this4.shippingMethods.length ? SHIPPING_TYPE.SHIPPING : SHIPPING_TYPE.PICKUP;
                    } else {
                        _this4.actions.setStateTo(assigned.type);
                        if (!_this4.selectedMethod) {
                            _this4.actions.selectShippingMethod(assigned, false);
                        }
                    }
                }

                if (typeof _this4.updateFinished === 'function') {
                    _this4.updateFinished(_this4.methods);
                }
            };

            // this.formatShippingMethods();

            this.$watch('methods', function () {
                _this4.formatShippingMethods();
            });

            // when clicking outside the dropdown
            this.$on('clickBody', function () {
                _this4.isPickupDropdownActive = false;
                _this4.isShippingDropdownActive = false;
            });
        },
        populate: function populate() {
            var allowChangeShipping = this.models.checkoutAppData.get('flags.allow_change_shipping');

            // Only allow buyer to change shipping address if allowed
            this.canChangeShipping = typeof this.onClickEdit === 'function' || allowChangeShipping;
            this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutSession && this.models.checkoutSession.shipping);
        }
    }
});


_angular.noop;

_angular.extend;

_angular.equals;

_uiRouter.$state;

_squid.$Component;

_squid.$renderContent;

_squid.formatCurrency;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingOptionsForm\" content>\n    <xo-ui-tabs\n        ng-if=\"renderTabs\"\n        on-select=\"actions.setTab\"\n        selected-tab=\"selectedTab\"\n        tabs=\"tabs\"\n    ></xo-ui-tabs>\n\n    <!-- Shipping Tab -->\n    <div ng-if=\"isShipping()\">\n\n        <!--Address display section-->\n        <div\n            ng-if=\"showShippingAddress\"\n            id=\"shippingAddress\"\n            class=\"address focusable\"\n            ng-class=\"{ noTop: !renderTabs, editable:canChangeShipping}\"\n            focusable=\"canChangeShipping\"\n            select-button ng-click=\"actions.gotoShipping()\">\n            <span class=\"given-name\">{{models.checkoutSession.shipping.name}}</span>\n            <xo-address-display\n                token=\"token\"\n                address=\"models.checkoutSession.shipping\"\n            ></xo-address-display>\n            <a\n                ng-if=\"canChangeShipping\"\n                class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\"\n                data-test-id=\"shipToChangeLink\"\n                select-button focusable=\"!cannotChangeShippingInfoMessages\"\n                ng-click=\"actions.gotoShipping()\"\n                aria-label=\"{{ content('shippingAddress.label') }}\"\n                focus-when-state=\"checkout.review.sidebar.shipping\"\n                transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n\n        <div ng-if=\"!models.checkoutSession.shipping\">\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message ng-if=\"showMissingShippingOptionMessage\" message=\"missingShippingOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"shippingMethods.length > 1\"\n            default-text=\"content('shipping.selectShippingMethod').toString()\"\n            label=\"shippingLabel\"\n            options=\"shippingMethods\"\n            selected-option=\"selectedShippingMethod\"\n            on-select=\"actions.selectShippingMethod\"\n        ></xo-ui-select-simple>\n\n        <div ng-if=\"shippingMethods.length === 1 && selectedShippingMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedShippingMethod.label\">\n        </div>\n    </div>\n\n    <!-- Pick Up Tab -->\n    <div ng-if=\"isPickup()\" class=\"pickupSelection\">\n\n        <div>\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message class=\"missing-message\" ng-if=\"showMissingPickupOptionMessage\" message=\"missingPickupOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"pickupMethods.length > 1\"\n            default-text=\"content('shipping.selectPickUpLocation').toString()\"\n            label=\"pickupLabel\"\n            options=\"pickupMethods\"\n            selected-option=\"selectedPickupMethod\"\n            on-select=\"actions.selectShippingMethod\">\n        </xo-ui-select-simple>\n\n        <div ng-if=\"pickupMethods.length === 1 && selectedPickupMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedPickupMethod.label\">\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _directive = __webpack_require__("../node_modules/xo-shipping-options/src/component/directive.js");

Object.defineProperty(exports, '$xoShippingOptions', {
  enumerable: true,
  get: function get() {
    return _directive.$xoShippingOptions;
  }
});

var _lib = __webpack_require__("../node_modules/xo-shipping-options/src/lib/index.js");

Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lib[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.selectShippingOption = exports.getSelectedShippingOption = exports.getShippingOptions = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

/*
    Shipping Option API

    For now, this is strictly client-side and comes from the
    incontext flow.
*/

var getShippingOptions = exports.getShippingOptions = function getShippingOptions(token) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);

    return checkoutCart.reload().then(function () {
        var shippingOptions = checkoutCart.get('purchaseUnits.0.item_list.shipping_options');

        if (shippingOptions && shippingOptions.length) {
            _logger.$logger.info('shipping_options_from_cart', shippingOptions);
        } else {
            _logger.$logger.info('no_shipping_options_from_cart');
            return;
        }

        return shippingOptions.map(function (options) {
            return {
                id: options.id,
                type: options.type,
                amount: options.amount,
                label: options.label,
                selected: options.selected
            };
        });
    });
};

var getSelectedShippingOption = exports.getSelectedShippingOption = function getSelectedShippingOption(token) {
    return getShippingOptions(token).then(function (shippingOptions) {
        if (!shippingOptions || !shippingOptions.length) {
            return undefined;
        }

        var selectedShippingOption = shippingOptions.filter(function (option) {
            return option.selected;
        }).pop();

        if (selectedShippingOption) {
            _logger.$logger.info('selected_shipping_option_from_cart', selectedShippingOption);
            return selectedShippingOption;
        } else {
            _logger.$logger.info('no_shipping_option_from_cart');
        }
    });
};

var buildAmountPatchEntity = function buildAmountPatchEntity(amount, token) {
    return {
        field: 'purchaseAmount',
        value: (0, _cart.retotalCart)(token, !!amount && !!amount.value ? amount.value : '0.00')
    };
};

var selectShippingOption = exports.selectShippingOption = function selectShippingOption(token, option) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
    var checkoutSession = _checkout.$CheckoutSessionModel.instance(token);

    return checkoutCart.retrieve().then(function () {
        return getShippingOptions(token);
    }).then(function (shippingOptions) {

        var newShippingOptions = shippingOptions.map(function (newOption) {
            return _squid.$util.extend(newOption, {
                selected: option.id === newOption.id
            });
        });

        var shippingOptionsPatch = {
            field: 'shippingOptions',
            value: newShippingOptions
        };

        var cartAmountPatch = buildAmountPatchEntity(option.amount, token);

        // add cartAmountPatch to the patchEntities array if option.amount is not null
        return checkoutCart.action('patchCartData', {
            data: {
                id: token,
                patchEntities: [shippingOptionsPatch, cartAmountPatch]
            }
        }).then(function (result) {
            return checkoutSession.reload().then(function () {
                return result;
            });
        });
    });
};

_squid.$util;

_logger.$logger;

_cart.retotalCart;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/cart.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.retotalCart = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

// Re-totals the cart with new shipping costs.
//
// @param token: PAY token/Cart ID
// @param shippingAmount: String float amount (Ex: '15.00')
// @returns amount: Amount object with new total and breakdown

var retotalCart = exports.retotalCart = function retotalCart(token, shippingAmount) {
    var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
    var currencyCode = checkoutCart.grossTotalAmount.currency;
    var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
    var decimalDigits = isNaN(currencyDigits && currencyDigits[currencyCode]) ? 2 : currencyDigits && currencyDigits[currencyCode];

    // Takes an integer/string and formats as a float
    var formatAmount = function formatAmount(amount) {
        return parseFloat(amount).toFixed(decimalDigits);
    };

    // Sums all of the arguments
    var sumAmounts = function sumAmounts() {
        for (var _len = arguments.length, amounts = Array(_len), _key = 0; _key < _len; _key++) {
            amounts[_key] = arguments[_key];
        }

        return amounts.reduce(function (total, amount) {
            return formatAmount(parseFloat(total) + parseFloat(amount));
        }, '0');
    };

    // Sums up all of the amount details (except the total)
    var sumDetails = function sumDetails(details) {
        var blacklist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        return Object.keys(details).reduce(function (value, detail) {
            var detailValue = details[detail];

            if (blacklist.indexOf(detail) !== -1) {
                return value;
            }
            switch (detail) {
                case 'shipping_discount':
                case 'discount':
                    return sumAmounts(formatAmount(parseFloat(detailValue) * -1), value);
                default:
                    return sumAmounts(details[detail], value);
            }
        }, '0');
    };

    // Simplifies the checkout cart amounts with just a simple key-value { detail: cost } format
    var oldTotal = checkoutCart.get('purchase.amounts.total.amount', formatAmount(0));

    var oldDetails = Object.keys(checkoutCart.get('purchase.amounts', {})).reduce(function (details, name) {
        var _extend;

        var amount = checkoutCart.get('purchase.amounts.' + name + '.amount', formatAmount(0));

        return name === 'total' ? details : (0, _angular.extend)({}, details, (_extend = {}, _extend[name] = amount, _extend));
    }, {});

    // Create a new amount details object with new shipping cost, and subtotal (if it was left out)
    var newDetails = (0, _angular.extend)({}, oldDetails, {
        shipping: formatAmount(shippingAmount),
        subtotal: formatAmount(parseFloat(oldTotal) - parseFloat(sumDetails(oldDetails, ['subtotal', 'total'])))
    });

    // Sum up all of the new amount details for the new total
    var newTotal = sumDetails(newDetails, ['total']);

    return {
        currency: currencyCode,
        total: newTotal,
        details: newDetails
    };
};

_squid.$locale;

_angular.extend;

_checkout.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _api = __webpack_require__("../node_modules/xo-shipping-options/src/lib/api.js");

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");

Object.keys(_cart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cart[key];
    }
  });
});

/***/ }),

/***/ "../node_modules/xo-styles/dist/lib/toggle.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoReviewPayWithBaiduComponent', {
    tag: 'xo-review-paywith-baidu',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var checkoutSession = this.models.checkoutSession;


            this.showAmt = true;
            this.defaultFs = checkoutSession.get('plan.sources');
        }
    }
});


_angular.noop;

_squid.$Component;

_checkout.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-baidu/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwBaidu\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <div class=\"charges\">\n                <div ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'EXTERNAL_WALLET']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                         <span class=\"name\" ng-if=\"fs.type === 'EXTERNAL_WALLET'\">\n                             {{ content('paymentMethod.baiduWallet') }}\n                         </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-review-paywith-venmo',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            optional: false
        }
    },
    resolve: {
        models: function models() {
            var _this = this;

            return _auth.$AuthModel.instance().retrieve().then(function (auth) {

                if (auth.get('tenant') === 'VENMO') {
                    return {
                        venmoUser: _venmoModels.$VenmoUserModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutCart: _checkout.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _checkout.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                } else {
                    return {
                        venmo: _venmoModels.$VenmoOnboardModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutSession: _checkout.$CheckoutSessionModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        checkoutCart: _checkout.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _checkout.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                }
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this2 = this;

            var _models = this.models,
                payee = _models.payee,
                venmo = _models.venmo,
                venmoUser = _models.venmoUser,
                checkoutCart = _models.checkoutCart,
                checkoutAppData = _models.checkoutAppData,
                checkoutSession = _models.checkoutSession;

            this.isBillingAgreementsEnabled = Boolean(checkoutCart.get('billing'));
            this.merchantName = checkoutAppData.get('merchant.brand_name') || checkoutAppData.get('merchant.merchant_name') || 'the merchant';
            this.intentNotSale = checkoutCart.get('payment_action') !== 'sale';
            var getAmount = function getAmount() {
                return checkoutSession.get('plan.sources.0.amount');
            };
            var mapperFS = {
                BALANCE: function BALANCE(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        amount: getAmount()
                    };
                },
                PAYMENT_CARD: function PAYMENT_CARD(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        card_type: fs.payment_card && fs.payment_card.type || fs.fundingName,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.payment_card && fs.payment_card.type || fs.fundingName,
                        last4: fs.payment_card && fs.payment_card.number || fs.fundingNumber,
                        amount: getAmount()
                    };
                },
                BANK_ACCOUNT: function BANK_ACCOUNT(fs) {
                    return {
                        type: fs.funding_mode || fs.fundingMode,
                        sub_type: 'INSTANT_TRANSFER',
                        name: fs.bank_account && fs.bank_account.bank_name || fs.fundingName,
                        last4: fs.bank_account && fs.bank_account.account_number || fs.fundingNumber,
                        amount: getAmount()
                    };
                }
            };

            function determineShowAmt() {
                var userAction = checkoutAppData.useraction();
                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && checkoutCart.get('purchase.items.length') === 0;

                return (0, _pxp.$pxpCartAmt)(checkoutAppData.get('merchant.merchant_country'), payee.get('merchant.id'), noLineItemDetails, checkoutCart.isPurchase()).then(function (showAmount) {
                    return checkoutCart.get('payment_action') !== 'authorize' && showAmount;
                });
            }

            function getPlanList() {
                var defaultFS = venmo && venmo.get('funding_sources.default_option') || venmoUser && venmoUser.get('funding_sources.defaultOption');
                var defaultFundingMode = defaultFS && (defaultFS.funding_mode || defaultFS.fundingMode);

                if (defaultFundingMode && mapperFS[defaultFundingMode]) {
                    return [mapperFS[defaultFundingMode](defaultFS)];
                } else {
                    return checkoutSession.get('plan.sources');
                }
            }

            function getBackup() {
                var backup = venmo && venmo.get('funding_sources.alternate_option') || venmoUser && venmoUser.get('funding_sources.alternateOption');
                var backupFundingMode = backup && (backup.funding_mode || backup.fundingMode);

                if (backupFundingMode && mapperFS[backupFundingMode]) {
                    return mapperFS[backupFundingMode](backup);
                }
            }

            this.venmoUser = '@' + (venmo && venmo.get('username') || venmoUser && venmoUser.get('username'));
            determineShowAmt().then(function (shouldShowAmt) {
                _this2.showAmt = shouldShowAmt;
            });
            this.defaultFs = getPlanList();
            this.backupFs = getBackup();
        }
    }
});


_angular.noop;

_squid.$Component;

_venmoModels.$VenmoOnboardModel;

_venmoModels.$VenmoUserModel;

_pxp.$pxpCartAmt;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_auth.$AuthModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/review-paywith-venmo/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"paywith asideView pwVenmo\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <ul class=\"charges\">\n                <li ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', 'BALANCE']\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                        <span class=\"name\" ng-if=\"fs.type === 'BALANCE'\">\n                             {{ content('paymentMethod.venmoBalance') }}\n                         </span>\n                        <span class=\"name\" ng-if=\"fs.type !== 'BALANCE'\">\n                            <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.name}}\n                            </span>\n                            <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                            </span>\n                        </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                    <span class=\"venmoUsername\">\n                        {{venmoUser}}\n                    </span>\n                </li>\n            </ul>\n\n            <div ng-if=\"isBillingAgreementsEnabled\">\n                <div class=\"backup\">\n                    <p bind-html-compile=\"htmlContent('paymentMethod.venmoBillingAgreement', {merchant: merchantName})\"></p>\n                </div>\n            </div>\n\n            <div ng-if=\"!isBillingAgreementsEnabled\">\n\n                <div class=\"backup\">\n                    <p bind-html-compile=\"htmlContent('paymentMethod.venmoAbrigedLearnMore')\"></p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.thirdPartyExperience = exports.venmoExperience = exports.thirdPartyInfo = undefined;
exports.redirect = redirect;
exports.getUserAgent = getUserAgent;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _sessionStorage = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js");

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var BA = 'BILLING_AGREEMENT';

var cancelLogoutEventListener = _angular.$rootScope.$on('logout', function (event, args) {

    // disable venmo models when ready
    var token = _angular.$rootScope.token;

    _venmoModels.$VenmoUserModel.instance(token).invalidate();
    _venmoModels.$VenmoOnboardModel.instance(token).invalidate();
    thirdPartyExperience.resetThirdPartyExperience();
});

_angular.$rootScope.$on('$destroy', cancelLogoutEventListener);

var readCookie = function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0, len = ca.length; i < len; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

var thirdPartyInfo = exports.thirdPartyInfo = {
    /**
     * @name isThirdPartyEligible
     * @returns {Promise}
     */
    isThirdPartyEligible: function isThirdPartyEligible() {
        var _this = this;

        return this.isBaiduEligible().then(function (baiduEligibility) {
            return _this.isVenmoEligible() || baiduEligibility;
        });
    },


    /**
     * @name isBaiduEligible
     * @returns {Promise}
     */
    isBaiduEligible: function isBaiduEligible() {
        return _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token, {
            params: {
                geolocation: _squid.$meta.geolocation
            }
        }).retrieve().then(function (eligibility) {
            _logger.$logger.info('baidu_eligibility', eligibility);
            return eligibility.baiduWallet;
        });
    },


    /**
     * @name isVenmoEligible
     * @description Handler to call to determine if user can use Venmo
     * @returns {Boolean}
     */
    isVenmoEligible: function isVenmoEligible() {
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        var isBillingAgreement = cart.isBilling();
        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookie = this.isVenmoCookiePresent();
        var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
        var isMSPTransaction = cart.isMultiSellerPurchase();
        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookie: isVenmoCookie,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US',
            isNotSFAuthenticationSession: !isSFAuthenticationSession,
            isNotMSPTransaction: !isMSPTransaction
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookie ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },


    /**
     * @name isVenmoCookiePresent
     * @returns {Boolean}
     */
    isVenmoCookiePresent: function isVenmoCookiePresent() {
        var cookieValue = readCookie(PWV_COOKIE);

        return Boolean(cookieValue);
    },


    /**
     * @name buildVenmoURL
     * @description Build the venmo URL scheme
     * @returns {String}
     */
    buildVenmoURL: function buildVenmoURL() {
        // SCHEME needs to change according to old or new experience
        // const linkType = venmoUrlSchemeType();
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var token = void 0;
        var total = void 0;
        var currency = void 0;
        var intent = void 0;

        // Send BA token when it's BA without Purchase
        if (cartModel.get('billing.ba_token') && cartModel.get('purchase.amounts.total.amount', '0') === '0') {
            token = cartModel.get('billing.ba_token');
        } else {
            // Send EC token when it's BA without purchase.
            token = _angular.$rootScope.token;
        }

        // For BA: setting billing agreement as payment_action explicitly, not relying on payment action returned in cart
        intent = cartModel.billing ? BA : cartModel.payment_action;

        // total cannot be undefined, outdated venmo app clients will crash otherwise
        total = cartModel.get('purchase.amounts.total.amount', '0');
        currency = cartModel.get('purchase.amounts.total.currency_code', 'none');

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': token,
            total: total,
            currency: currency, // can be undefined for BA w/o purchase
            intent: intent
        });

        return SCHEME + '?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

var allowedThirdPartyExperiences = {
    VENMO: 'VENMO_EXPERIENCE',
    BAIDU: 'BAIDU_EXPERIENCE'
};

var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';

var thirdPartyExperience = exports.thirdPartyExperience = {
    setAsVenmoExperience: function setAsVenmoExperience(token) {
        var _JSON$stringify;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    setAsBaiduExperience: function setAsBaiduExperience(token) {
        var _JSON$stringify2;

        var sessionStorage = (0, _sessionStorage2['default'])();
        var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    isThirdPartyExperience: function isThirdPartyExperience(token) {
        var availableExperiences = [];

        for (var key in allowedThirdPartyExperiences) {
            availableExperiences.push(allowedThirdPartyExperiences[key]);
        }

        var currentExperience = this.getExperience(token);

        return Boolean(availableExperiences.indexOf(currentExperience) > -1);
    },
    getExperience: function getExperience(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        // if logged in, and guest, we return the experience if any
        if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
            var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');

            return payload && payload[token] || 'MEMBER_EXPERIENCE';
        } else if (auth.logged_in && auth.tenant === 'VENMO') {
            return allowedThirdPartyExperiences['VENMO'];
        } else {
            // If not logged in, we reset the third party experience
            this.resetThirdPartyExperience();
            return 'MEMBER_EXPERIENCE';
        }
    },
    resetThirdPartyExperience: function resetThirdPartyExperience() {
        var sessionStorage = (0, _sessionStorage2['default'])();

        sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
    }
};

// used to trigger app switches and flush the logs before doing so
function redirect(url) {
    return _logger.$logger.flush().then(function () {
        _angular.$window.location.replace(url);
    });
}

// fetching browser's user agent.
function getUserAgent() {
    return _angular.$window.navigator.userAgent;
}

_squid.$config;

_squid.$util;

_squid.$meta;

_logger.$logger;

_auth.$AuthModel;

_index.$DeviceInfo;

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

_venmoModels.$VenmoOnboardModel;

_venmoModels.$VenmoUserModel;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports['default'] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
    try {

        window['sessionStorage'].setItem('__feature_test__', '0');
        window['sessionStorage'].removeItem('__feature_test__');
        return window.sessionStorage;
    } catch (err) {
        return {
            getItem: function getItem(key) {
                if (arguments < 1) {
                    throw new Error('1 argument required');
                }
                return store[key];
            },
            setItem: function setItem(key, val) {
                if (arguments < 2) {
                    throw new Error('2 arguments required');
                }
                store[key] = val;
            },
            removeItem: function removeItem(key) {

                delete store[key];
            }
        };
    }
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-models/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoTransactionEligibility = exports.$VenmoSupplementaryInfo = exports.$VenmoUserModel = exports.$VenmoOnboardModel = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/onboard'
    })
});

var $VenmoUserModel = exports.$VenmoUserModel = _squid.$Model.extend('$VenmoUserModel', {
    api: new _squid.$Api({
        uri: '/api/venmo/user'
    })
});

var $VenmoSupplementaryInfo = exports.$VenmoSupplementaryInfo = _squid.$Model.extend('$VenmoSupplementaryInfo', {
    api: new _squid.$Api({
        uri: '/api/venmo/address'
    }),

    serialize: function serialize() {

        return {
            user: {
                first_name: this.user && this.user.first_name && this.user.first_name.trim(),
                last_name: this.user && this.user.last_name && this.user.last_name.trim()
            },
            billing: {
                line1: this.billing && this.billing.line1 && this.billing.line1.trim(),
                line2: this.billing && this.billing.line2 && this.billing.line2.trim(),
                city: this.billing && this.billing.city && this.billing.city.trim(),
                state: this.billing && this.billing.state && this.billing.state.trim(),
                postal_code: this.billing && this.billing.postal_code && this.billing.postal_code.trim(),
                normalization_status: this.billing && this.billing.normalization_status && this.billing.normalization_status.trim(),
                country: this.billing && this.billing.country && this.billing.country.trim()
            },
            shipping: {
                line1: this.shipping && this.shipping.line1 && this.shipping.line1.trim(),
                line2: this.shipping && this.shipping.line2 && this.shipping.line2.trim(),
                city: this.shipping && this.shipping.city && this.shipping.city.trim(),
                state: this.shipping && this.shipping.state && this.shipping.state.trim(),
                postal_code: this.shipping && this.shipping.postal_code && this.shipping.postal_code.trim(),
                normalization_status: this.shipping && this.shipping.normalization_status && this.shipping.normalization_status.trim(),
                country: this.shipping && this.shipping.country && this.shipping.country.trim()
            },
            shipToBilling: this.shipToBilling
        };
    }
});

var $VenmoTransactionEligibility = exports.$VenmoTransactionEligibility = _squid.$Model.extend('$VenmoTransactionEligibility', {
    api: new _squid.$Api({
        uri: '/api/venmo/:id/eligibility'
    })
});

angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
angular.value("$VenmoUserModel", $VenmoUserModel);
angular.value("$VenmoSupplementaryInfo", $VenmoSupplementaryInfo);
angular.value("$VenmoTransactionEligibility", $VenmoTransactionEligibility);
_squid.$Model;

_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/styles.less");

var _template = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoVenmoStepUpOverlay', {
    tag: 'xo-venmo-stepup-overlay',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        stateInfo: {
            type: 'var',
            required: false
        },
        modalCallback: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var _this = this;

            return _auth.$AuthModel.instance().retrieve().then(function (auth) {
                if (auth.get('tenant') === 'VENMO') {
                    return {
                        auth: _auth.$AuthModel.instance().retrieve()['catch'](_angular.noop),
                        venmoUser: _venmoModels.$VenmoUserModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        payee: _index.$CheckoutPayeeModel.instance(_this.token).retrieve()['catch'](_angular.noop),
                        cart: _index.$CheckoutCartModel.instance(_this.token).retrieve()['catch'](_angular.noop)
                    };
                } else {
                    return {};
                }
            });
        }
    },

    actions: {
        logCancel: function logCancel() {
            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'process_user_cancel'
            });
        },
        hideOverlay: function hideOverlay() {
            (0, _jquery2['default'])('#wrapper #spinner').attr('style', '');
            this.$element.removeClass('overlayOpen');
            var self = this;
            return (0, _angular.$timeout)(function () {
                self.showOverlay = false;
            }, 300);
        },
        hideModal: function hideModal(event) {
            event.preventDefault();
            this.actions.logCancel();
            this.actions.hideOverlay();
            _uiRouter.$state.go(this.stateInfo.oldState);
        },
        triggerModal: function triggerModal(event, data) {

            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'prepare_venmo_step_up',
                challenge_reason: 'add-shipping'
            });

            _logger.$logger.debug('doVenmoRiskyAppSwitchModal');
            this.showOverlay = true;

            this.stateInfo = data;

            if (this.stateInfo.newState === 'checkout.review.sidebar.addShipping') {
                this.contingencyReason = 'ADD_SHIPPING';
            } else {
                this.contingencyReason = 'PAYMENT_VERIFICATION_REQUIRED';
            }

            (0, _jquery2['default'])('#wrapper #spinner').hide();

            var $element = this.$element;

            (0, _angular.$timeout)(function () {
                $element.addClass('overlayOpen');
                _angular.$rootScope.$emit('allLoaded');
            });
        },
        continueWithVenmo: function continueWithVenmo() {
            var _models = this.models,
                venmoUser = _models.venmoUser,
                payee = _models.payee,
                cart = _models.cart;

            var ext_id = venmoUser.get('externalId');
            var reason = this.contingencyReason;
            var token = cart.get('billing.ba_token') ? cart.get('billing.ba_token') : this.token;
            var intent = cart.billing ? 'BILLING_AGREEMENT' : cart.payment_action;
            var total = cart.get('purchase.amounts.total.amount', '0');
            var currency = cart.get('purchase.amounts.total.currency_code', 'none');

            var NEW_STATE = this.stateInfo.newState;

            var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
            var LANDING_ROUTE = '#/checkout/venmoAuth?nextState=' + NEW_STATE;
            var ERROR_ROUTE = '#/checkout/login?venmoError=true';

            var params = (0, _angular.$httpParamSerializer)({
                'x-success': _angular.$location.absUrl().replace(/#.*$/, LANDING_ROUTE),
                'x-failure': _angular.$location.absUrl().replace(/#.*$/, ERROR_ROUTE),
                ua: (0, _thirdPartyInfo.getUserAgent)(),
                merchant_id: payee.getId(),
                token: token,
                intent: intent,
                total: total,
                currency: currency,
                ext_id: ext_id,
                reason: reason
            });

            this.actions.hideOverlay();

            _logger.$logger.info('venmo-stepUp-appswitch', { url: SCHEME + '?' + params });

            _logger.$logger.info('checkout_fpti', {
                from: 'VENMO_STEP_UP_AUTH',
                to: 'process_user_appswitch'
            });

            // app-switching
            (0, _thirdPartyInfo.redirect)(SCHEME + '?' + params);
        }
    },

    lifecycle: {
        populate: function populate() {

            var cancelInsufficientPermission = _angular.$rootScope.$on('$insufficientPermissionVenmoOT', this.actions.triggerModal);

            this.$on('$destroy', cancelInsufficientPermission);
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_angular.$httpParamSerializer;

_angular.$location;

_angular.noop;

_squid.$config;

_squid.$Component;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_venmoModels.$VenmoUserModel;

_thirdPartyInfo.redirect;

_thirdPartyInfo.getUserAgent;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-stepUp/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\" content>\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <section class=\"login\" id=\"stepUp\">\n                    <span class=\"venmoLogo\"></span>\n                    <p class=\"statement\" ng-bind-html=\"htmlContent('memberReview.stepUpStatement')\">Log in to your Venmo account</p> <!-- Action to be taken -->\n                    <p class=\"userTask\" ng-if=\"contingencyReason === 'ADD_SHIPPING'\" ng-bind-html=\"htmlContent('memberReview.stepUpAddAddress')\"></p> <!-- To accomplish what? -->\n                    <p class=\"userTask\" ng-if=\"contingencyReason !== 'ADD_SHIPPING'\" ng-bind-html=\"htmlContent('memberReview.stepUpGeneral')\"></p>\n                    <a track-link=\"choose_venmo_stepup\" id=\"proceedStepUp\" class=\"btn venmoBtn full\" link-button ng-click=\"actions.continueWithVenmo()\">{{content('landing.venmoButton')}}</a>\n\n                    <div class=\"cancel\" ng-if=\"contingencyReason === 'ADD_SHIPPING'\">\n                        <a href=\"#\" id=\"cancelStepUp\" ng-click=\"actions.hideModal($event)\" track-link=\"choose_cancel_stepup\" ng-bind-html=\"htmlContent('buttons.cancel')\"></a>\n                    </div>\n                </section>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _template = __webpack_require__("../node_modules/xo-title/dist/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoTitle', [function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            titleTxt: '@?',
            className: '@?',
            tagName: '@?'
        },
        link: function link($scope, $element) {
            if ($scope.tagName) {
                var newEl = document.createElement($scope.tagName || 'h1');

                newEl.className = $scope.className || 'alpha';
                newEl.textContent = '{{ titleTxt }}';
                (0, _angular.$compile)(newEl)($scope);
                $element.empty().append(newEl);
            }
        }
    };
}]);

/***/ }),

/***/ "../node_modules/xo-title/dist/template.html":
/***/ (function(module, exports) {

module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "../node_modules/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$FptiBuilder', function () {
    /**
     *  Build the front-end FPTI event from three data sources
     *      1. the per-product configuration
     *      2. the buzname defined per-route
     *      3. the additional attributes that only available at a specific checkpoint
     *
     */

    return _squid.$Class.extend('FptiBuilder', {

        resolvePageQualifier: function resolvePageQualifier(trackingData) {
            // The pages can populated pageQualifier to override the default one
            this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
            // because 'fullpage' has been widely embedded into routes
            // we had better to keep it as a place holder
            : 'fullpage'; // update later if it's in-context
        },

        build: function build() {

            if (!this.trackingData && !this.error) {
                // do nothing if neither page nor error tracking
                return this;
            }

            this.resolvePageQualifier(this.trackingData);

            this._dataObj = new _model.$FptiDataModel().decorate('base', this.baseData).decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', (0, _squid.$getLatestCorrelationID)()).decorate('uuid', _model.$CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);

            return this;
        },

        toString: function toString() {
            var dataAry = [];

            _angular2['default'].forEach(this._dataObj, function (v, k) {
                dataAry.push(k + '=' + v);
            });

            return dataAry.join('&');
        }
    });
});

_squid.$getLatestCorrelationID;

_squid.$Class;

_model.$FptiDataModel;

_model.$CalDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$ButtonTrackingService', function () {
    var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
    var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
    var _alreadyFired = false;

    function _strToElements(str) {
        var elements = {};

        if (str && str.length) {
            str.split('&').forEach(function (param) {
                var nvp = param.split('=');

                elements[nvp[0]] = nvp[1];
            });
        }
        return elements;
    }

    function _fireButtonTrackingBeacon(elements) {
        var url = _beaconUrl;
        var xoData = {};

        function buildParam(param, value) {
            var p = '&' + param + '=' + (value ? value : 'null');

            return p;
        }

        function getGUIID(ts) {
            return _strToElements(ts).vr;
        }

        function addToDocument(uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);
        }

        // Get some params from FPTI data.
        _beaconParams.forEach(function (param) {
            url += buildParam(param, elements[param]);
        });

        // Build the rest of the params.
        url += buildParam('fpti', getGUIID(_squid.$cookies && _squid.$cookies.ts));
        url += buildParam('WWW_AKA_MVT_BUTTONS', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_BUTTONS);
        url += buildParam('WWW_AKA_MVT_ID', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_ID);
        url += buildParam('ip', _squid.$meta && _squid.$meta.ipaddress);

        if (_angular.$rootScope.token) {
            (0, _squid.$populate)(xoData, {
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                appData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                url += buildParam('mrid', xoData.payee && xoData.payee.getId());
                url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
                addToDocument(url);
            });
        } else {
            url += buildParam('mrid', null);
            url += buildParam('calf', null);
            addToDocument(url);
        }
    }

    return {
        fireBeacon: function fireBeacon(fptiData) {
            if (!_alreadyFired && fptiData) {
                var elements = _strToElements(fptiData);

                // Fire the beacon if this is a page render.
                if (elements.page) {
                    _alreadyFired = true;
                    return _fireButtonTrackingBeacon(elements);
                }
            }
        },
        resetAlreadyFired: function resetAlreadyFired() {
            _alreadyFired = false;
        }
    };
});

_angular.$rootScope;

_squid.$meta;

_squid.$cookies;

_squid.$populate;

_index.$CheckoutAppDataModel;

_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/button.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module('tracking.directive', ['ui.router']).directive('trackSubmit', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var transition = attr && attr.trackSubmit;
                var trackSubmit = {
                    currentRoute: _uiRouter.$state.current,
                    transition: transition,
                    errors: []
                };

                _angular2['default'].forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                    var elem = $(el);
                    var elementId = elem.attr('id');
                    var elementName = elem.attr('name');
                    var errorKey = elem.attr('data-error-key');
                    var errorText = elem.has('required') ? 'required' : 'no error key';
                    var fieldName = elementId ? elementId : elementName;

                    if (!fieldName) {
                        var elementModel = elem.attr('ng-model');

                        fieldName = elementModel ? elementModel : 'unnamed-field';
                    }

                    trackSubmit.errors.push({
                        fieldName: fieldName,
                        errorMessage: errorKey ? errorKey : errorText
                    });
                });

                _angular.$rootScope.$broadcast('trackSubmit', trackSubmit);
            });
        }
    };
}).directive('trackLink', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('mousedown', function (event) {
                var state = attr && attr.trackLink;

                if (state) {
                    var trackLink = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };

                    _angular.$rootScope.$broadcast('trackLink', trackLink);
                }
            });
        }
    };
}).directive('trackClick', function () {
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = attr && attr.trackClick;

                if (state) {
                    var trackClick = {
                        currentRoute: _uiRouter.$state.current,
                        transition: state
                    };
                    _angular.$rootScope.$broadcast('trackClick', trackClick);
                }
            });
        }
    };
}).directive('trackInput', function () {
    /*
    * Track an input tag with track-input attribute
    * you can use the value of track-input attribute as
    * a tracking attr Eg.: track-input="xo_guest_yes"
    */
    return {
        restrict: 'AE',
        link: function link($scope, element, attr) {
            element.on('click', function (event) {
                var state = void 0;

                if (event.target.type === 'checkbox') {
                    if (event.target.checked) {
                        state = attr && attr.trackInput + '_CHECKED';
                    } else {
                        state = attr && attr.trackInput + '_UNCHECKED';
                    }
                } else {
                    state = attr && attr.trackInput;
                }

                var trackInput = {
                    currentRoute: _uiRouter.$state.current,
                    page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                };

                if (state) {
                    trackInput.transition = state;
                }

                _angular.$rootScope.$broadcast('trackInput', trackInput);
            });
        }
    };
});

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fpti', function () {
    var _beaconUrl = void 0;

    // Logic to switch between production/staging urls. This way we don't pollute live logs,
    // and we are able to test on stage using the fpti log viewing tool.
    if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
        _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
    } else {
        _beaconUrl = _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    return {
        // Get all the tracking data defined at the page level
        getPageTrackingData: function getPageTrackingData(route) {
            route = route || {};

            var trackingData = route.trackingData || {};
            var routeParent = route.parent;

            trackingData.token = _angular.$rootScope.token;

            while (routeParent) {
                trackingData = _angular2['default'].merge({}, routeParent.trackingData || {}, trackingData);
                routeParent = routeParent.parent;
            }
            return trackingData;
        },

        setupDataString: function setupDataString(route, err, data) {
            var trackingData = this.getPageTrackingData(route);
            var PAYPAL = window && window.PAYPAL;

            var fptiData = void 0;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                var payload = {
                    baseData: window.meta.fpti,
                    trackingData: trackingData,
                    error: err,
                    isInContext: _angular.$rootScope.miniBrowser
                };

                _angular2['default'].extend(payload, data || {});
                fptiData = new _builder.$FptiBuilder(payload).build().toString();

                // FPTI client side tracking only if we have template
                if (route && route.template && _angular2['default'].isFunction(PAYPAL.analytics.setup)) {
                    PAYPAL.core.pta = PAYPAL.analytics.setup({
                        data: fptiData,
                        url: _beaconUrl
                    });
                }
            }
            return fptiData;
        }
    };
}).factory('$fptiError', function () {
    function stringifyErrorMessage(msg) {
        return encodeURIComponent(_angular2['default'].isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
        : (_angular2['default'].toJson(msg) || 'undefined').substring(0, 128));
    }

    return _squid.$Error.extend({
        construct: function construct(err) {
            if (!err) {
                return;
            }
            this.type = err.type;
            this.field = err.field;
            this.msg = stringifyErrorMessage(err.message || err.error);
            this.code = err.code || err.cause;
        }
    });
});

_squid.$config;

_squid.$Error;

_builder.$FptiBuilder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-tracking/dist/listener.js"), __webpack_require__("../node_modules/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {

    // Declare the dependency to register the listeners
    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");

var _button = __webpack_require__("../node_modules/xo-tracking/dist/button.js");

var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // eslint-disable-line max-statements
    var token = window.meta.token;
    // logAppName is the appname from meta.js. if the logAppName is not defined, default it to 'appNameNotDefined'.
    var appName = _squid.$meta.logAppName || 'appNameNotDefined';
    var addTrackingData = function addTrackingData(object) {
        return _squid.$util.extend(object, {
            dc: _squid.$meta.dc,
            az: _squid.$meta.az,
            cust: _index.$AuthModel.instance().buyer_id || '',
            comp: appName
        });
    };
    var cplSettings = _squid.$config.enableCPL;
    var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || (0, _squid.$experiment)('cpl_tracking', cplSettings.throttle, token));
    var cplEnabled = passesCplThrottle || _squid.$util.params().forceEnableCPL;

    function logTransition(state) {
        return !(state.trackingData && state.trackingData.suppressTransitionLog);
    }

    function logStateExit(state) {
        return state.trackingData && state.trackingData.trackStateExit;
    }

    function getBeaconUrl() {
        // Logic to switch between production/staging urls. This way we don't pollute live logs,
        // and we are able to test on stage using the fpti log viewing tool.
        return _squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
        : _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
    }

    /*
    * Triggers pa.js recordClick with custom parameters
    */
    function fptiCustomRecordClick(route, customData) {
        var analyticsInstance, fptiData, fptiDataObj;
        var PAYPAL = window.PAYPAL;

        if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
            PAYPAL.core = PAYPAL.core || {};

            analyticsInstance = new PAYPAL.analytics.Analytics();

            fptiData = new _builder.$FptiBuilder({
                trackingData: route.trackingData,
                isInContext: _angular.$rootScope.miniBrowser,
                comp: appName
                // ... Other flow data pass-in here to resolve page qualifier
            }).build();

            // Grab the fpti data object and extend with custom params
            // The fpti data obj should include pxp params as well
            fptiDataObj = fptiData._dataObj;
            $.extend(fptiDataObj, customData);

            analyticsInstance.setRequestData(fptiDataObj);
            analyticsInstance.recordClick({
                url: getBeaconUrl()
            });
        }
    }

    _angular.$rootScope.$on('trackInput', function (event, trackInput) {
        if (!trackInput) {
            return;
        }
        var customData = {
            link: trackInput && trackInput.transition,
            page: trackInput && trackInput.page
        };

        fptiCustomRecordClick(trackInput.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackClick', function (event, trackClick) {
        if (!trackClick) {
            return;
        }
        var customData = {
            link: trackClick && trackClick.transition
        };

        fptiCustomRecordClick(trackClick.currentRoute, customData);
    });

    _angular.$rootScope.$on('trackSubmit', function (event, trackSubmit) {
        if (!trackSubmit) {
            return;
        }
        var currentRoute = trackSubmit && trackSubmit.currentRoute;
        var routeName = currentRoute ? currentRoute.name : 'noRoute';

        _logger.$logger.info('track_submit', {
            route_name: routeName
            // ID stuff here later
        });

        if (logTransition(currentRoute)) {
            routeName = routeName.replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
            var transition = trackSubmit.transition || state;

            _logger.$logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: transition
            });
        }

        if (trackSubmit.errors && trackSubmit.errors.length) {
            var fptiFieldErrors = JSON.stringify(trackSubmit.errors);

            _logger.$logger.info('checkout_fpti', {
                form_field_errors: fptiFieldErrors
            });
        }

        var errors = trackSubmit.errors;

        if (_angular2['default'].isArray(errors)) {
            errors.forEach(function (err) {
                _logger.$logger.debug('track_submit_error', err);
                if (_fpti.$fpti) {
                    _fpti.$fpti.setupDataString(currentRoute, new _fpti.$fptiError({
                        type: 'fieldError',
                        field: err.fieldName,
                        code: err.errorMessage
                    }));
                }
            });

            if (errors.length) {
                _logger.$logger.flush(true);
            }
        }
    });

    _angular.$rootScope.$on('unhandled_error', function (event, exception) {
        if (_fpti.$fpti) {
            _fpti.$fpti.setupDataString(exception.currentRoute, new _fpti.$fptiError({
                type: 'pageError',
                message: exception.message,
                code: exception.cause
            }));
        }
    });

    _angular.$rootScope.$on('trackLink', function (event, trackLink) {
        if (!trackLink) {
            return;
        }

        var currentRoute = trackLink.currentRoute;
        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

        _logger.$logger.info(routeName + '_exit', {
            fptiState: state,
            fptiTransition: trackLink.transition
        });
    });

    _angular.$rootScope.$on('$transition', function (event, data) {
        (0, _angular.$timeout)(function () {
            if (_fpti.$fpti) {
                var fptiData = _fpti.$fpti.setupDataString(data.toState, null, addTrackingData({
                    transition_time: data.duration
                }));

                // This seems to conflict with CPL data, so don't fire if CPL
                if (!cplEnabled) {
                    // Fire and forget button tracking beacon.
                    _button.$ButtonTrackingService.fireBeacon(fptiData);
                }
            }
        });
    });

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        var from = fromState && fromState.name.replace(/\./g, '_');
        var to = toState && toState.name.replace(/\./g, '_');

        if (from && logTransition(fromState) && logStateExit(fromState)) {
            var trackingData = fromState.trackingData && fromState.trackingData || {};

            _logger.$logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
        }

        _logger.$logger.info('state_change', {
            from: from || 'start',
            to: to || 'end'
        });

        // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
        if (toState.template) {
            _model.$CalDataModel.generateMetaIds();
        }

        _angular.$rootScope.currentState = to;

        if (to && logTransition(toState)) {
            _logger.$logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
        }
    });

    _angular.$rootScope.$on('page_loaded', function (event, from, to) {
        if (from !== 'checkout_init') {
            return;
        }
        var key = _model.$FptiConstants.stateName[to] || 'review';
        var landing_page = _model.$FptiConstants.landing_page[key];

        _logger.$logger.info('landing_page', {
            'from': landing_page,
            'to': 'process_page_loaded',
            fpti_landing_page: landing_page
        });
    });

    _angular.$rootScope.$on('page_reloaded', function () {
        _logger.$logger.flush(true);
        _model.$CalDataModel.generateMetaIds();
    });

    _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
        var to = toState.name.replace(/\./g, '_');

        if (toState.hasResolver && to) {
            _logger.$logger.info(to + '_load');
        } else if (to) {
            _logger.$logger.info(to + '_rendering');
        }
    });

    _angular.$rootScope.$on('addrDiff', function (event, addrDiff) {
        if (!addrDiff) {
            return;
        }
        _logger.$logger.info('checkout_fpti' + addrDiff);
    });

    function getHash(url) {
        if (!url || !~url.indexOf('#')) {
            // eslint-disable-line no-bitwise
            return;
        }

        url = url.split('#');
        return url[url.length - 1];
    }

    var oldHash = window.location.hash;

    window.addEventListener('hashchange', function (event) {
        _logger.$logger.info('hashchange', {
            from: getHash(event.oldURL || oldHash),
            to: getHash(event.newURL || window.location.hash)
        });

        if (!_squid.$loader.isLoading()) {
            _logger.$logger.flush();
        }

        oldHash = window.location.hash;
    });

    $(document).on('click', function (event) {
        if (event && event.target && event.target.tagName) {
            var name = event.target.tagName.toLowerCase();

            if (event.target.id) {
                name += '#' + event.target.id;
            } else if (event.target.attributes && event.target.attributes['ng-model']) {
                name += ':' + event.target.attributes['ng-model'].value;
            } else if (event.target.className) {
                name += '.' + event.target.className.split(' ').join('.');
            }

            _logger.$logger.info('click', { el: name });
        }
    });

    if (cplEnabled) {
        window.fptiserverurl = getBeaconUrl();

        var firstInvocation = true;
        var trackPageStart = function trackPageStart() {
            if (firstInvocation) {
                firstInvocation = false;
                return;
            }
            try {
                window.PAYPAL.analytics.startCPLTracking();
            } catch (e) {
                console.log('error starting cpl tracking ' + e);
            }
        };

        var firstDone = true;
        var trackDone = function trackDone(beaconData) {
            window.PAYPAL.analytics.endCPLTracking({
                pageData: addTrackingData(beaconData),
                inferStart: firstDone
            });
            firstDone = false;
        };

        var currentRoute = null;

        _angular.$rootScope.$on('startLoad', function () {
            return trackPageStart();
        });
        _angular.$rootScope.$on('$stateChangeSuccess', function (e, route) {
            currentRoute = route;
        });

        _angular.$rootScope.$on('allLoaded', function () {
            try {
                var buildParams = {
                    productOverride: window.fptiProductOverride,
                    trackingData: _fpti.$fpti.getPageTrackingData(currentRoute)
                };
                var legacyFptiData = new _builder.$FptiBuilder(buildParams).build()._dataObj;
                var product = window.fptiProductOverride || 'ec';

                legacyFptiData.pgrp = 'main:' + product + ':hermes';
                legacyFptiData.flid = token;
                trackDone(legacyFptiData);
            } catch (e) {
                console.log('error tracking CPL data ' + e);
            }
        });
    }
});

_index.$AuthModel;

_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$experiment;

_squid.$loader;

_logger.$logger;

_model.$CalDataModel;

_model.$FptiConstants;

_builder.$FptiBuilder;

_button.$ButtonTrackingService;

_fpti.$fpti;

_fpti.$fptiError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uuid = __webpack_require__("../node_modules/node-uuid/uuid.js");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular); /* eslint-disable angular/di */


_angular2['default'].module().constant('$FptiConstants', {
    // The prototype of buzname data object
    buznameMap: {
        flowgatename: {
            placeHolder: '',
            fptiKey: 'fltp'
        },
        'flowname': {
            placeHolder: 'ec:hermes:',
            fptiKey: 'flnm'
        },
        'hier1': {
            placeHolder: 'main_ec_hermes_',
            fptiKey: 'shir'
        },
        'inout': {
            placeHolder: 'inout',
            fptiKey: 'lgin'
        },
        'pagename': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'pgrp'
        },
        'pagename2': {
            placeHolder: 'main:ec:hermes',
            fptiKey: 'page'
        },
        'version': {
            placeHolder: 'hermes',
            fptiKey: 'vers'
        }
    },
    // Full list of FPTI keys indexed by readable names
    // This mapping can also be served as default decorator
    fptiKeys: {
        'businessType': 'bztp',
        'correlationId': 'calc', // CalDataModel
        'cust': 'cust',
        'errorCode': 'eccd',
        'fieldError': 'erfd',
        'flowgatename': 'fltp', // buzname
        'flowname': 'flnm', // buzname
        'loggedIn': 'lgin', // buzname
        'merchantId': 'mrid',
        'merchantType': 'mbtp',
        'pageError': 'erpg',
        'pageGoal': 'goal', // route
        'pageGroup': 'pgrp', // buzname
        'pageName': 'page', // buzname
        'pageQualifer': 'qual', // buzname
        'pageStartTime': 'pgst', // FptiBuilder
        'pageTechnologyFlag': 'pgtf', // productConfig
        'paymentFlowId': 'pfid',
        'rLogId': 'teal',
        'sessionId': 'fpti',
        'siteHierarchy': 'shir', // buzname
        'sourceCi': 's', // productConfig
        'tealeaf': 'teal',
        'templateName': 'tmpl', // route
        'transition_time': 'transition_time',
        'uuid': 'csci', // CalDataModel
        'version': 'vers', // buzname
        'visitorId': 'vid',
        'ecToken': 'fltk', // metadata
        'pxpExpSelected': 'xe',
        'pxpTreatementSelected': 'xt',
        'pxpQualifiedTreatment': 'qt',
        'pxpContextId': 'qc',
        'dc': 'dc',
        'az': 'az',
        'comp': 'comp'
    },
    landing_page: {
        login: 'LOGIN',
        econsent: 'eConsent',
        review: 'Review',
        error_page: 'error_page',
        add_card: 'add_card',
        add_bank: 'add_bank',
        billing: 'billing',
        done_page: 'done_page',
        shoppingCart: 'shoppingCart',
        emptyCart: 'emptyCart',
        soldout: 'soldout',
        openButton: 'openButton'
    },
    stateName: {
        checkout_login: 'login',
        checkout_genericError: 'error_page',
        checkout_fastlogin: 'login',
        checkout_econsent: 'econsent',
        checkout_review: 'review',
        checkout_pageAddCard_addCardFlow_addCard: 'add_card',
        checkout_updateCard_addCardFlow_addCard: 'add_card',
        checkout_pageAddFi_bank_add: 'add_bank',
        guest: 'billing',
        checkout_done: 'done_page',
        checkout_guest: 'billing',
        checkout_signup: 'billing',
        guestupgrade_genericError: 'error_page',
        checkout_multistepsignup_multistepsignupaddcard: 'billing',
        checkout_shoppingCart: 'shoppingCart',
        checkout_emptyCart: 'emptyCart',
        checkout_soldout: 'soldout',
        checkout_openButton: 'openButton'
    }
}).factory('$FptiDataModel', ['$FptiConstants', function ($FptiConstants) {
    var productConfig = {};

    // TODO to read from config.json
    productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
    productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

    /**
     * Utilizing Decorator pattern to allow defining additional logic for specific keys
     */
    return _squid.$Class.extend('FptiDataModel', {
        init: function init() {
            this._dataObj = _angular2['default'].extend({}, productConfig);
            this._decoratorList = [];
        },
        decorators: {
            buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
                if (!trackingData) {
                    return;
                }

                var buzname = trackingData.buzname;

                if (!buzname) {
                    return;
                }

                var buznameDiff = buzname[pageQualifier];

                if (!buznameDiff) {
                    return;
                }

                var dataObj = this._dataObj;
                var buznameMap = $FptiConstants.buznameMap;
                // read app specific place holder from config
                var placeHolderConfig = _squid.$config && _squid.$config.fpti && _squid.$config.fpti.buznameEntryPlaceHolder;

                Object.keys(buznameMap).forEach(function (key) {
                    var buznameEntry = buznameMap[key];
                    var fptiKey = buznameEntry.fptiKey;
                    var placeHolder = buznameEntry.placeHolder;

                    if (buznameDiff[key]) {
                        if (placeHolderConfig && placeHolderConfig[key]) {
                            placeHolder = placeHolderConfig[key];
                        }

                        if (productOverride) {
                            var _placeHolder$split = placeHolder.split(':'),
                                main = _placeHolder$split[0],
                                hermes = _placeHolder$split[2];

                            placeHolder = main + ':' + productOverride + ':' + hermes;
                        }

                        dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
                    } else {
                        dataObj[fptiKey] = placeHolder;
                    }
                });
                dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
            },

            base: function base(_base) {
                if (_base) {
                    for (var key in _base) {
                        if (!this._dataObj[key]) {
                            this._dataObj[key] = _base[key];
                        }
                    }
                }
            },

            locale: function locale(_locale) {
                if (_locale && _locale.country) {
                    this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
                }
            },

            pxptrackingdata: function pxptrackingdata(pxpData) {
                var qt = [];
                var qc = [];
                var xe = [];
                var xt = [];

                _squid.$util.some(pxpData, function (trackInfo) {
                    var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');

                    if (match) {
                        qt.push(match[1]);
                    }

                    match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
                    if (match) {
                        qc.push(match[1]);
                    }

                    _squid.$util.some(trackInfo.treatments, function (treatment) {
                        xe.push(treatment.experiment_id);
                        xt.push(treatment.treatment_id);
                    });
                });

                this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
                this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
            },

            templateName: function templateName(trackingData, pageQualifier, isInContext) {
                if (trackingData && trackingData.templateName) {
                    var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');

                    this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
                }
            },

            fieldError: function fieldError(err) {
                if (err && err.type === 'fieldError') {
                    this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            },

            pageError: function pageError(err) {
                if (err && err.type === 'pageError') {

                    this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
                    this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
                }
            }

        },
        decorate: function decorate(name) {
            this._decoratorList.push({
                name: name,
                params: Array.prototype.slice.call(arguments, 1)
            });
            return this;
        },
        getDataObject: function getDataObject(isInContext) {
            var i;
            var decorator;

            for (i = 0; i < this._decoratorList.length; i++) {
                decorator = this._decoratorList[i];
                if (!decorator) {
                    continue;
                }
                var name = decorator.name;
                var params = decorator.params;

                if (_angular2['default'].isFunction(this.decorators[name])) {
                    // Invoke the decorator and pass in the parameter list
                    this.decorators[name].apply(this, params);
                } else {
                    var fptiKey = $FptiConstants.fptiKeys[name];

                    // If the fptiKey is defined and value is present, add the k-v pair
                    if (fptiKey && params && params.length > 0) {
                        this._dataObj[fptiKey] = params[0];
                    }
                }
            }

            // 'fullpage' was widely used as default key in page routs definition
            // finally replace it here if it's incontext
            var dataObj = this._dataObj;

            if (isInContext) {
                Object.keys(dataObj).forEach(function (k) {
                    if (_angular2['default'].isString(dataObj[k])) {
                        // some values can be number
                        dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
                    }
                });
            }

            return this._dataObj;
        }
    });
}]).factory('$CalDataModel', function () {
    var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';

    function _generateCorrelationId() {
        var uidRandomArr = (_uuid2['default'].v4() || uuid_v4_mask).split('-');
        var uidTime = (_uuid2['default'].v1() || uuid_v1_mask).split('-');

        return uidTime[0] + uidRandomArr[0].substr(0, 5);
    }

    function _generateUUID() {
        return (_uuid2['default'].v4() || uuid_v4_mask).replace(/-/g, '');
    }

    var CalModel = _squid.$Model.extend({
        _calCorrId: _generateCorrelationId(),
        _uuid: _generateUUID(),

        generateCalCorrId: function generateCalCorrId() {
            this._calCorrId = _generateCorrelationId();
        },
        generateUUID: function generateUUID() {
            this._uuid = _generateUUID();
        },
        generateMetaIds: function generateMetaIds() {
            this.generateCalCorrId();
            this.generateUUID();
        },

        getCalCorrId: function getCalCorrId() {
            return this._calCorrId;
        },

        getUUID: function getUUID() {
            return this._uuid;
        }
    });

    return new CalModel();
});

_squid.$Model;

_squid.$Class;

_squid.$util;

_squid.$config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/model.js"))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adds role='button' and tabindex='0' to anchor elements
// so that it is keyboard navigable and recognized by screen
// readers as a button.
//
// As anchors without href do not fire their click event
// automatically on a Space or ENTER key, this directive forces
// that functionality.
//
// If something is assigned to the link-button attribute, then
// it is used as an aria-label.
(0, _squid.$registerDirective)('link-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
            var $element = (0, _jquery2['default'])(element);

            $element.attr('role', 'button');
            $element.attr('tabindex', '0');
            if (ariaLabel) {
                $element.attr('aria-label', ariaLabel);
            }
            $element.on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive gives an element characteristics of a native
// select element in terms of keyboard navigation. It becomes reachable
// via the tab key, reflects screenreader characteristics and
// can be activated by any of the DOWN, SPACE or ENTER KEYS.
(0, _squid.$registerDirective)('select-button', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var $element = (0, _jquery2['default'])(element);
            if (!attrs.hasOwnProperty('disableRole')) {
                $element.attr('role', 'button');
            }

            $element.attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
                // do nothing if there is an alt or ctrl key as well
                if (!(event.altKey || event.ctrlKey)) {
                    switch (event.keyCode) {
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            element[0].click();
                            return false;
                        default:
                            break;
                    }
                }
                return true;
            });
        }
    };
});

// this directive makes a container with links act as if it were a select dropdown
// in terms of keyboard accessibility. The following characteristics are implemented:
//
// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
// * ESC cancels and closes the dropdown
// * SPACE or ENTER select an option
// * You cannot TAB out of a dropdown until you select or cancel
//
// in addition, the following extra characteristics are implemented
//
// * The TAB (and SHIFT-TAB) key will also function to move between options
// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
//
// How to use:
// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
//    The expression is run whenever the ESC key is pressed.
// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
//    tabs to escape the select-box element.
(0, _squid.$registerDirective)('select-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);

            function escapeToggle() {
                if (attrs.selectCancel) {
                    (0, _angular.$parse)(attrs.selectCancel)(scope);
                    scope.$apply();
                }
            }

            element.attr('role', 'menu');

            element.on('keydown.selectBox', function (event) {
                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                var $origin = (0, _jquery2['default'])(event.target);

                if (!(event.altKey || event.ctrlKey)) {
                    var index = $allTabbable.index($origin);

                    switch (event.keyCode) {
                        case _ui.KEYS.TAB:
                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
                                // Enable default behavior to escape select-box
                                escapeToggle();
                                break;
                            } else if (event.shiftKey) {
                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            } else {
                                index = (index + 1) % $allTabbable.length;
                            }
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.DOWN:
                        case _ui.KEYS.RIGHT:
                            index = (index + 1) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.UP:
                        case _ui.KEYS.LEFT:
                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
                            $allTabbable.eq(index).focus();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.SPACE:
                        case _ui.KEYS.ENTER:
                            $origin.click();
                            event.preventDefault();
                            break;
                        case _ui.KEYS.ESC:
                            escapeToggle();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
});

// similar to select-box, this directive restrains tabbing within a container
// to the container itself.
//
// 1. modal-cancel is the equivalent of select-cancel from select-box, and
// should define a cancellation / ESC function.
(0, _squid.$registerDirective)('modal-box', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function escapeToggle() {
                (0, _angular.$parse)(attrs.modalCancel)(scope);
                scope.$apply();
            }

            // Gets the index of the element that should be focused after pressing Tab
            function getNextIndex($element, $elements, shift) {
                if (shift) {
                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
                } else {
                    return ($elements.index($element) + 1) % $elements.length;
                }
            }

            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
                element.on('keydown.modalBox', function (event) {
                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
                    var $origin = (0, _jquery2['default'])(event.target);

                    if (!(event.altKey || event.ctrlKey)) {
                        switch (event.keyCode) {
                            case _ui.KEYS.TAB:
                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
                                $allTabbable.eq(index).focus();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            case _ui.KEYS.ESC:
                                escapeToggle();
                                event.preventDefault();
                                event.stopPropagation();
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
    };
});

// A simple version of modal that doesn't rely on controlling keyboard behavior
// as strictly. Should be used in cases where tab items are not as easily accessible
// via JS (ie. iframes)
// Redirects focus to container when focusin event fired on element not in container
(0, _squid.$registerDirective)('simple-modal', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.attr('tabindex', '-1');

            var cancelFn;
            if (attrs.modalCancel) {
                cancelFn = function cancelFn() {
                    (0, _angular.$parse)(attrs.modalCancel)(scope);
                    scope.$apply();
                };
            }

            function registerModal() {
                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
                    if (!element[0].contains(event.target)) {
                        event.stopPropagation();
                        element.focus();
                    }
                });
                if (cancelFn) {
                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
                        if (!element[0].contains(event.target)) {
                            deregisterModal();
                            cancelFn();
                        }
                    });
                }
            }

            function deregisterModal() {
                (0, _jquery2['default'])(document).off('focusin.simple-modal');
                (0, _jquery2['default'])(document).off('click.simple-modal');
            }

            // Watch the expression provided to simpleModal and add modal behavior when
            // expression result changes to truthy
            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
                scope.$watch(attrs['simpleModal'], function (newVal) {
                    if (newVal) {
                        registerModal();
                    } else {
                        deregisterModal();
                    }
                });
            } else {
                registerModal();
            }

            scope.$on('$destroy', deregisterModal);
        }
    };
});

// this directive gives an element characteristics of a native
// option element in terms of aria attributes. It must be used
// as a child of a selectBox for proper keyboard behavior as it
// disables default tabbing behavior.
//
// The expression provided to the directive is used to set the
// aria-selected attribute when the expression evaluates to true.
(0, _squid.$registerDirective)('select-option', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            (0, _jquery2['default'])(element).attr('role', 'menuitem');
            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
            }
        }
    };
});

// adapted from http://stackoverflow.com/a/24416690
// This directive makes the element focused when the expression
// provided _changes_ to true.
//
// In order to avoid conflicts with autofocus when a page first loads,
// adding the focused-once-before attribute will enable the expression
// only if it has been focused on before.
//
// * if the element itself is not focusable, then it will locate the first focusable
// element within it.
// * if the additional attribute focus-element is provided, it is wrapped
// as a jQuery element (could be selector string or actual element) and focused on
// it will be parsed when the focus-when attribute is true
// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
// the directive listens to the event specified by focus-on
(0, _squid.$registerDirective)('focus-when', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            function locateAndFocus(active) {
                (0, _angular.$timeout)(function () {
                    if (active) {
                        // deal with figuring out which element to focus on
                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);

                        // this works by fallthrough. it will try each one
                        // in succession until an element is found
                        if (attrs.focusElement) {
                            // scenario 1 - specific element provided
                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
                        }

                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
                            // scenario 2 - element with directive is not focusable
                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
                        }

                        // default / scenario 3 - no valid targets specified or found
                        if ($elementToFocus.length === 0) {
                            $elementToFocus = (0, _jquery2['default'])(element);
                        }

                        $elementToFocus.first().focus();
                    }
                });
            }

            var active = true;

            if ('focusedOnceBefore' in attrs) {
                active = false;
                (0, _jquery2['default'])(element).on('focus', function () {
                    active = true;
                });
            }

            if (attrs.focusRefreshOn) {
                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
                    locateAndFocus(active);
                });
            } else {
                scope.$watch(attrs.focusWhen, function (val) {
                    locateAndFocus(active && val);
                });
            }
        }
    };
});

// angularUI router specific - listens to a specific transition
// defined in two attributes, focusWhenState (this directive) and TransitionsTo
var FOCUS_EVENT_NAME = 'accessible-focus';
(0, _squid.$registerDirective)('focus-when-state', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var startState = attrs.focusWhenState;
            var endState = attrs.transitionsTo;
            var transitionMessage = startState + ' > ' + endState;
            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (fromState.name === startState && toState.name === endState) {
                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
                }
            });

            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
                if (message === transitionMessage) {
                    (0, _angular.$timeout)(function () {
                        return element[0].focus();
                    });
                }
            });

            // see http://stackoverflow.com/a/27016855
            scope.$on('$destroy', unregisterEventFn);
        }
    };
});

// Listens for the next state transition and focuses an element provided by selector
// Use with links where focus is needed to return to a specific element after the transition
(0, _squid.$registerDirective)('focus-after-transition', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            element.on('click', function () {
                var focusSelector = attrs['focusAfterTransition'];
                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    cancel();
                    (0, _angular.$timeout)(function () {
                        (0, _jquery2['default'])(focusSelector).focus();
                    });
                });
            });
        }
    };
});

// focuses on the first focusable element on a container containing form elements
(0, _squid.$registerDirective)('form-autofocus', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // wait for the entire DOM to settle down first
            (0, _angular.$timeout)(function () {
                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
                if ($allFocusable.length > 0) {
                    $allFocusable.first().focus();
                }
            });
        }
    };
});

// Change element to be focusable and tabbable or unfocusable if it is
// not typically a focusable element by removing the tabindex attribute.
(0, _squid.$registerDirective)('focusable', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            function setFocusable(value) {
                if (value) {
                    element.attr('tabindex', 0);
                } else {
                    element.removeAttr('tabindex');
                }
            }

            if (attrs.focusable) {
                scope.$watch(attrs.focusable, function (newVal) {
                    if (newVal) {
                        setFocusable(true);
                    } else {
                        setFocusable(false);
                    }
                });
            } else {
                setFocusable(true);
            }
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$timeout;

_angular.$rootScope;

_angular.isDefined;

_ui.KEYS;

_ui.focusable;

_ui.tabbable;

_ui.findAll;

_ui.filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var KEYS = {
    TAB: 0x09,
    ENTER: 0x0D,
    ESC: 0x1B,
    SPACE: 0x20,
    LEFT: 0x25,
    UP: 0x26,
    RIGHT: 0x27,
    DOWN: 0x28
};

function visible(element) {
    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
        return _jquery2['default'].css(this, 'visibility') === 'hidden';
    }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
    var map;
    var mapName;
    var img;

    if (nodeName === 'area') {
        map = element.parentNode;
        mapName = map.name;
        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
            return false;
        }
        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
        return !!img && visible(img);
    }
    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
    // the element and all of its ancestors must be visible
    visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
    var isTabIndexNaN = isNaN(tabIndex);

    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}

function filterAll(elements, filterFn) {
    return (0, _jquery2['default'])(elements).filter(function () {
        return filterFn(this);
    });
}

function findAll(container, filterFn) {
    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
}

exports.KEYS = KEYS;
exports.visible = visible;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.findAll = findAll;
exports.filterAll = filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoBanner', {
    tag: 'xo-banner',
    template: _template2['default'],
    transclude: true,
    props: {
        isNmj: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        // Need buyer_id from $AuthModel first to get the URL for the user profile photo
        models: function models() {
            return {
                auth: _auth.$AuthModel.instance().retrieve()
            };
        },
        userPhoto: function userPhoto(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    photoData: _index.$UserPhotoModel.instance(models.auth.buyer_id).retrieve({
                        params: {
                            'min_size': 45
                        }
                    })['catch'](function (error) {
                        _logger.$logger.info('error_retrieve_user_photo');
                        return {};
                    })
                };
            });
        }
    },
    lifecycle: {
        populate: function populate() {
            var avatarElement = this.$element.find('#banner-picture');
            var auth = this.models.auth;
            var photoData = this.userPhoto.photoData;

            // Currently only showing initials for New Member Journey
            var showInitials = auth.first_name && auth.last_name && this.props.isNmj;

            if (avatarElement && auth.buyer_id) {
                // The "phantom" avatar image is displayed by default via CSS
                // background-image property. If the request for a user's
                // profile photo returns a URL, the background-image property
                // is replaced with that URL.

                // Show user photo for avatar
                if (photoData && photoData.photo_url) {
                    avatarElement.css('background-image', 'url("' + photoData.photo_url + '")');
                    _logger.$logger.info('xoBanner_user');
                }

                // No user photo: show user initials instead of phantom image
                if (!photoData.photo_url && showInitials) {
                    avatarElement.addClass('initials');
                    this.initials = '' + auth.first_name[0] + auth.last_name[0];
                    _logger.$logger.info('xoBanner_initials');
                }
            } else {
                // Leave the phantom avatar as the background image
                _logger.$logger.info('xoBanner_default');
            }
        }
    }
});


_squid.$Component;

_auth.$AuthModel;

_index.$UserPhotoModel;

_logger.$logger;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/styles.less");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/card-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
    tag: 'xo-card-loader',
    template: _template2['default'],
    props: {
        message: {
            type: 'str',
            required: false
        },
        state: {
            type: 'var',
            required: false
        },
        auth: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            this.ellipsis = function () {
                var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                var MAX_EMAIL_LEN = 30;
                var MAX_DOMAIN_LEN = 20;
                var MAX_USERNAME_LEN = MAX_EMAIL_LEN - MAX_DOMAIN_LEN;

                if (email.length <= MAX_EMAIL_LEN) {
                    return email;
                }

                var userNameLength = email.indexOf('@');
                var domainLength = email.length - userNameLength;

                if (userNameLength > MAX_USERNAME_LEN && domainLength > MAX_DOMAIN_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_USERNAME_LEN - 3) + '}).*(@.{' + (MAX_DOMAIN_LEN - 4) + '}).*'), '$1...$2...');
                } else if (userNameLength > MAX_USERNAME_LEN) {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - domainLength - 3) + '}).*(@.*)'), '$1...$2');
                } else {
                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - 3) + '}).*'), '$1...');
                }
            };
        }
    }
});

angular.value("$xoCardLoader", $xoCardLoader);
_squid.$Component;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/card-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div class=\"card_user\" ng-if=\"auth.loggedIn()\">{{ellipsis(auth.email)}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoFiIcon = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index2 = _interopRequireDefault(_index);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/cardicon/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFiIcon = exports.$xoFiIcon = _squid.$Component.extend('xoFiIcon', {
    tag: 'xo-fi-icon',
    wrapperType: 'span',
    template: _template2['default'],
    transclude: true,
    props: {
        fi: {
            type: 'var',
            required: false
        },
        className: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            var updateCardArt = function updateCardArt() {
                _this.retrievedCardArt = _this.models.fiMeta.getCardArt(_this.props.fi);

                if (_this.retrievedCardArt) {
                    _this.cardStyle = {
                        'background-image': 'url(' + _this.retrievedCardArt + ')',
                        'background-size': 'contain',
                        'background-position': 'initial'
                    };
                }
            };

            this.$watch('props.fi', updateCardArt);
        }
    }
});

angular.value("$xoFiIcon", $xoFiIcon);
_squid.$Component;

_angular.$rootScope;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/cardicon/template.html":
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"retrievedCardArt\">\n    <span class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"className\" ng-style=\"cardStyle\"></span>\n</span>\n<span ng-if=\"!retrievedCardArt\">\n    <div ng-if=\"models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon pinlessGlyphIcon icon icon-card-half-solid\"></div>\n    <div ng-if=\"!models.fiMeta.isPinlessDebit(fi)\" class=\"standardCardIcon fsIcon fsIcons img-retina\" ng-class=\"[fi.type, fi.card_type, fi.name, className]\" ng-transclude>\n    </div>\n</span>\n\n\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/styles.less");

/**
 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
 *
 * Add directionality to the container html div element of a input field.
 * <div directionality><input type=text ng-model="user.name"></div>
 */
(0, _squid.$registerDirective)('directionality', function () {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            var currentWatchDeregister = void 0;
            var input = element.find('input');

            if (!input.length) {
                listenForInputRendered();
                return;
            }

            // If the input has not yet been rendered inside the container, listen for dom node inserted
            // then, if the node inserted is an input, we will use that element and init the directionality
            // listeners. The first input rendered is the one that will be captured by this directive.
            function listenForInputRendered() {
                element.bind('DOMNodeInserted', checkDOMNodeInserted);

                function checkDOMNodeInserted(event) {
                    if (event && event.target && event.target.tagName === 'INPUT') {
                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
                        input = angular.element(event.target);
                        init();
                    }
                }
            }

            function setDirectionality(value) {
                if (value) {
                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
                } else {
                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
                }
            }

            function jqueryOnKeyupHandler(event) {
                setDirectionality(event.target.value);
            }

            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
            function resetDirectionalityListener() {
                // remove directionality listeners that were set on prior locale
                input.unbind('keyup', jqueryOnKeyupHandler);
                if (currentWatchDeregister) {
                    currentWatchDeregister();
                }

                // set new directionality listeners for the current locale if 'rtl'
                if (document.documentElement.getAttribute('dir') === 'rtl') {
                    (0, _angular.$timeout)(function () {
                        // Watch ng-model on input to set directionality if it contains RTL char
                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
                            setDirectionality(value);
                        });
                        // jQuery listener for cases where ng-model is not populated until post validation
                        input.on('keyup', jqueryOnKeyupHandler);
                    });
                }
            }

            function init() {
                resetDirectionalityListener();
                scope.$on('localeChange', function () {
                    resetDirectionalityListener();
                });
            }

            init();
        }
    };
});

/**
 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
 * or dir="ltr" attribute to the html element.
 *
 * Add directionality-text="<<model>>" to the div or span or any element containing text.
 * <span directionality-text="user.name"><{{user.name}}</span>
 */
(0, _squid.$registerDirective)('directionality-text', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            if (document.documentElement.getAttribute('dir') === 'rtl') {
                var $element = $(element);

                (0, _angular.$timeout)(function () {
                    if (attrs.directionalityText) {
                        scope.$watch(attrs.directionalityText, function () {
                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
                        });
                    } else {
                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
                    }
                });
            }
        }
    };
});

_squid.$util;

_squid.$registerDirective;

_angular.$document;

_angular.$parse;

_angular.$timeout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angularAria = __webpack_require__("../node_modules/angular-aria/angular-aria.min.js");

// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
    bindRoleForClick: false,

    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
    // These attributes should only be set once the form is submitted, to match what
    // visually what we display
    ariaInvalid: false,
    ariaRequired: false,
    // Removing aria-hidden attribute for hidden elements
    ariaHidden: false
});

(0, _squid.$registerDirective)('xo-error-tooltip', function () {
    return {
        restrict: 'A',
        require: ['?^form', '?ngModel'],
        link: function link(scope, element, attrs, ctrls) {
            var formCtrl = ctrls[0],
                modelCtrl = ctrls[1];


            function shouldBeRequired() {
                if (formCtrl) {
                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
                    // adopt error-key in all input tags
                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));

                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
                } else {
                    return modelCtrl.$error.required;
                }
            }

            function shouldBeInvalid() {
                if (formCtrl) {
                    return formCtrl.$submitted && modelCtrl.$invalid;
                } else {
                    return modelCtrl.$invalid;
                }
            }

            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
            function formatSpaceSplitString(str, id, add) {
                var strArray = void 0;

                if (str) {
                    strArray = str.split(' ');
                } else {
                    strArray = [];
                }

                var idIndex = strArray.indexOf(id);

                if (~idIndex && !add) {
                    strArray.splice(idIndex, 1);
                } else if (!~idIndex && add) {
                    strArray.push(id);
                }

                return strArray.join(' ');
            }

            // Add tooltip behavior after DOM settles
            (0, _angular.$timeout)(function () {
                var generateId = function generateId() {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
                };
                var requiredId = generateId();
                var invalidId = generateId();
                var requiredError = void 0;
                var invalidError = void 0;

                if (attrs.errorKey) {
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
                    element.after(invalidError);
                } else if (attrs.errorText) {
                    // errorText if case is for backward compatibility, we can get rid of this once
                    // all teams adopt error-key in all input tags for tooltip message display
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
                    element.after(invalidError);
                }

                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
                    element.addClass('hasErrorTooltipRequired');
                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
                    element.after(requiredError);
                    element.removeAttr('aria-required');
                }

                function setAriaAttributes() {
                    var addTooltips = {
                        required: false,
                        invalid: false
                    };

                    // Do not associate "Required" error with aria-describedby
                    // because this should already be read out either by "required"
                    // attribute or "aria-required"=true, and only associate "Invalid"
                    // error if "Required" is not showing to match visuals
                    if (shouldBeRequired()) {
                        addTooltips.required = true;
                    } else if (shouldBeInvalid()) {
                        addTooltips.invalid = true;
                    }

                    var describedby = element.attr('aria-describedby');

                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
                    element.attr('aria-describedby', describedby);
                }

                scope.$watch(shouldBeRequired, function (newVal) {
                    setAriaAttributes();
                });
                scope.$watch(shouldBeInvalid, function (newVal) {
                    element.attr('aria-invalid', newVal);
                    setAriaAttributes();
                });

                // Set scroll so that the error message is in view when element receives focus
                element.on('focus', function (event) {
                    var windowBot = $(window).scrollTop() + $(window).height();
                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;

                    if (windowBot < Math.max(requiredBot, invalidBot)) {
                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
                    }
                });
            });
        }
    };
});

_squid.$registerDirective;

_angular.$parse;

_angular.$compile;

_angular.$timeout;

_angularAria.$ariaProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("../node_modules/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', [function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                redirectiframe: '=?',
                redirectLightbox: '=?'
            },

            controller: ['$scope', '$rootScope', '$populate', '$CheckoutInputDataModel', '$window', '$CheckoutAppDataModel', '$util', '$injector', '$logger', function ($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
                    $scope.isIFrame = $util.isIFrame();

                    $scope.closeFrame = function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.xchild) {
                            if (window.xprops.onCancel) {
                                return window.xprops.onCancel({
                                    token: $scope.token,
                                    cancelUrl: cancel_url
                                });
                            } else {
                                return window.xchild.close();
                            }
                        }

                        if ($scope.redirectLightbox) {
                            var result = _index.$ReturnToMerchant.postToMerchant({
                                operation: 'return_to_merchant',
                                returnUrl: cancel_url,
                                updateParent: true
                            });

                            // Otherwise we have no choice but to return to the merchant
                            if (!result) {
                                $util.redirect(cancel_url);
                            }

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else if ($scope.redirectiframe) {
                            $window.location.replace(cancel_url);

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else {

                            var iFrameFlow = $injector.get('$IFrameFlow');

                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');

                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');

                            if ($scope.auth && $scope.auth.code) {
                                url += '&code=' + $scope.auth.code;
                            }

                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
                        }
                        $scope.$emit('exitFrame');
                    };
                });
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

_index.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {

    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', [function () {
        return {
            template: template,

            restrict: 'E',

            controller: ['$scope', '$rootScope', '$window', '$util', '$logger', function ($scope, $rootScope, $window, $util, $logger) {
                $scope.isIFrame = $util.isIFrame();
                $scope.closeFrame = function (event) {
                    var url = $window.location.href && $window.location.href.split('#')[0] || '';

                    if (url.indexOf('proxflow') > -1) {
                        url = url.replace('proxflow', 'webapps/helios');
                    }

                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';

                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
                    } else {
                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
                    }

                    $window.top.location = url;
                    $scope.$emit('exitFrame');
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ExperienceComponent = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/experience/template.html");

var _template2 = _interopRequireDefault(_template);

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ExperienceComponent = exports.$ExperienceComponent = _squid.$Component.extend('ExperienceComponent', {
    tag: 'experience',
    template: _template2['default'],
    transclude: true,
    props: {
        flag: {
            type: 'str',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                // temporary until experience layer develops, which should do all of this logic via flag config (something like `experienceConfig.get('flag')`)
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var negate = this.props.flag[0] === '!';
            var fiMeta = this.models.fiMeta;

            // lies

            this.renderExperience = fiMeta && fiMeta.cardArtEnabled();

            if (negate) {
                this.renderExperience = !this.renderExperience;
            }
        }
    }
});

angular.value("$ExperienceComponent", $ExperienceComponent);
_squid.$Component;

_angular.$rootScope;

_angular.noop;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/experience/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-style=\"style\">\n    <ng-transclude ng-if=\"renderExperience\"></ng-transclude>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/expired-message/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredMessage', {
    tag: 'xo-expired-message',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
        // TODO: currently `xo_hermes_preferred_expired_msg_review_page` pxp has been turned off
        // however, AuthRate team plans to turn back this experiment after moratorium
        // Also, please see uncomment similar logic from Hermesnodeweb (public/pages/xo-review)
        // experiments() {
        //     return {
        //         showPreferredExpiredMsg: $ExpiredMsgFactory.getPreferredExpiredPxpResult()
        //     };
        // }

    },
    actions: {
        goToManageWallet: function goToManageWallet(fiID) {
            if (fiID) {
                _logger.$logger.info('update_expired_preferred');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard', {
                    planId: fiID,
                    doneUri: 'checkout.review'
                });
            } else {
                _logger.$logger.info('manage_expired_cards');
                _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
            }
        }
    },

    lifecycle: {
        populate: function populate() {
            // if (this.experiments.showPreferredExpiredMsg === 'xo_hermes_preferred_expired_msg_review_page_treatment') {
            //     this.preferredExpired = this.models.checkoutSession.getDisallowedPreferred();
            // }
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/expired-message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"preferredExpired\" id=\"notifications\" content>\n    <div class=\"msgPage msg-info\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li>\n                <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                    preferredExpired.lastDigits})\" ></span><span>\n                    <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                       ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fiMeta = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/fi-panel/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/fi-panel/styles.less");

__webpack_require__("../node_modules/xo-ui-components/src/cardicon/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Pulling out props to iterate over keys
var PROPS = {
    fi: {
        required: false,
        type: 'var'
    },
    plan: {
        required: false,
        type: 'var'
    },
    // Specifically override name
    nameOverride: {
        required: false,
        type: 'var'
    },
    // Ignore different rendering for PAD
    ignorePad: {
        required: false,
        type: 'var'
    },
    // Dont render extra details
    sparse: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showAmount: {
        required: false,
        type: 'var'
    },
    // Requires fi to be passed in
    showCurrencyCode: {
        required: false,
        type: 'var'
    },
    // Requires plan to be passed in
    showAllCurrencyCodes: {
        required: false,
        type: 'var'
    }
};

exports['default'] = _squid.$Component.extend('xoFiPanel', {
    tag: 'xo-fi-panel',
    template: _template2['default'],
    transclude: true,
    props: PROPS,
    resolve: {
        models: function models() {
            return {
                fiMeta: _fiMeta2['default'].instance(_angular.$rootScope.token).fetch(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },
    lifecycle: {
        populate: function populate() {
            var _this = this;

            render.call(this);
            // Props on scope is not iterable, so creating a group to watch from the definition
            this.$watchGroup(Object.keys(PROPS).map(function (p) {
                return 'props.' + p;
            }), function () {
                return render.call(_this);
            });
        }
    }
});

// TODO: figure out pad rendering

function render() {
    var _props = this.props,
        fi = _props.fi,
        plan = _props.plan,
        sparse = _props.sparse,
        showAmount = _props.showAmount,
        showCurrencyCode = _props.showCurrencyCode,
        showAllCurrencyCodes = _props.showAllCurrencyCodes,
        nameOverride = _props.nameOverride,
        ignorePad = _props.ignorePad;
    var _models = this.models,
        fiMeta = _models.fiMeta,
        checkoutAppData = _models.checkoutAppData;

    var merchant = checkoutAppData && checkoutAppData.merchant;
    merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

    this.name = nameOverride || fiMeta.getName(fi);

    var amount = void 0;
    var currencyCodes = void 0;
    var sld = {};
    var secondLineType = void 0;

    if (showAmount) {
        amount = fiMeta.getAmount(fi);
    } else if (showAllCurrencyCodes) {
        currencyCodes = fiMeta.getAllCurrencyCodes(plan).join(', ');
    } else if (showCurrencyCode) {
        currencyCodes = fiMeta.getCurrencyCode(fi);
    }

    if (!nameOverride && fiMeta.isPad(fi) && !ignorePad) {
        secondLineType = 'pad';

        var mask = fiMeta.getCardMask(fi);

        _squid.$util.extend(sld, mask);
    } else if (fi) {
        // Try to render a card mask
        var _mask = fiMeta.getCardMask(fi);

        if (_mask.before || _mask.after) {
            secondLineType = 'mask';
            _squid.$util.extend(sld, _mask);

            if (!sparse) {
                // MEFT/IACH info is only relevant in DE
                if (_squid.$locale.country === 'DE' && fiMeta.isMeft(fi)) {
                    sld.meft = true;
                } else if (_squid.$locale.country === 'DE' && (
                // HACK: when ignorePad name, pretend this is Iach
                fiMeta.isIach(fi) || ignorePad)) {
                    sld.iach = true;
                } else if (fiMeta.isEcheck(fi)) {
                    sld.echeck = true;
                } else if (fiMeta.wallet.isChaseLinkedCard(fi)) {
                    sld.chasePay = true;
                }
            }
        }
    }

    _squid.$util.extend(this, {
        amount: amount,
        currencyCodes: currencyCodes,
        secondLineData: sld,
        secondLineType: secondLineType,
        merchant: merchant
    });
}

_angular.$rootScope;

_squid.$Component;

_squid.$util;

_squid.$locale;

_checkout.$CheckoutAppDataModel;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/fi-panel/template.html":
/***/ (function(module, exports) {

module.exports = "<div angular class=\"fsPanel\" content ng-class=\"[fi.type]\">\n    <div class=\"fsdetails fsPanelLeft\">\n        <xo-fi-icon fi=\"fi\" class-name=\"fsIcon\"></xo-fi-icon>\n    </div>\n    <div class=\"fsPanelRight\">\n        <div ng-class=\"{doubleheight: !secondLineType}\">\n            <span ng-if=\"secondLineType === 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\">{{content('fundingInstruments.pad')}}</span>\n            <span ng-if=\"secondLineType !== 'pad'\" class=\"fsPanelName\" data-test-id=\"fiName\" ng-bind-html=\"name\"></span>&rlm; <span ng-if=\"currencyCodes\">({{currencyCodes}})</span>\n            <span ng-if=\"amount\" class=\"methodAmount\">\n                <span class=\"amountFormatted\">\n                    <format-currency\n                    code=\"amount.currency_code\"\n                    amount=\"amount.amount\"></format-currency>\n                </span>\n            </span>\n        </div>\n        <div ng-if=\"secondLineType\" class=\"fsPanelSecondLine\">\n            <div ng-switch=\"secondLineType\">\n                <div ng-switch-when=\"pad\">\n                    {{name}}\n                    <span class=\"cardMask\"><span/><span/><span/><span/></span>\n                    {{secondLineData.after}}\n                </div>\n                <div ng-switch-when=\"mask\">\n                    <span ng-if=\"secondLineData.chasePay\" class=\"chasePayLogo\">\n                        <span class=\"fsIcon CHASEPAY\"><span class=\"accessAid\">Chase Pay</span></span> |\n                    </span>\n                    {{secondLineData.before}}\n                    <span class=\"cardMask\"><span/><span/><span/><span/></span>{{secondLineData.after}}\n\n                    <span ng-if=\"secondLineData.meft\">\n                        {{content('fundingInstruments.meft')}}\n                    </span>\n                    <span ng-if=\"secondLineData.iach\">\n                        {{content('fundingInstruments.iach')}}\n                    </span>\n                    <span ng-if=\"secondLineData.echeck\">\n                        {{content('fundingInstruments.eCheck')}}\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div class=\"fsPanelIsBillingPreferred\" ng-if=\"fi.isBillingPreferred\">{{content('fundingInstruments.billingPreferredFi', { merchantName: merchant })}}</div>\n        <div class=\"fsPanelChildren\" ng-transclude></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/link/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/link/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoLink', {
    tag: 'xo-link',
    template: _template2['default'],
    props: {
        onClick: {
            type: 'var',
            required: false
        },
        leftIcon: {
            type: 'str',
            required: false
        },
        rightIcon: {
            type: 'str',
            required: false
        },
        goTo: {
            type: 'str',
            required: false
        },
        label: {
            type: 'str',
            required: false
        }
    },

    actions: {
        onClick: function onClick(event) {
            var _props = this.props,
                onClick = _props.onClick,
                goTo = _props.goTo;


            if (onClick) {
                onClick(event);
            }

            if (goTo) {
                _uiRouter.$state.go(goTo);
            }
        }
    }
});


_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/link/template.html":
/***/ (function(module, exports) {

module.exports = "<a class=\"common-link\" ng-click=\"actions.onClick($event)\" href='' role=\"button\">\n    <span ng-if=\"props.leftIcon\" class=\"icon left-icon {{props.leftIcon}}\"></span><span>{{props.label}}</span><span ng-if=\"props.rightIcon\" class=\"icon right-icon {{props.rightIcon}}\"></span>\n</a>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
    squid.module('xo-message.directive', ['squid']).directive('xoMessage', ['$timeout', '$loader', '$rootScope', function ($timeout, $loader, $rootScope) {
        return {
            scope: {
                message: '=?', // Expected type - {msgs: [], type: "info|error|success|warning"}
                isgreyheader: '=?'
            },
            template: template,
            link: function link(scope, element, attrs) {

                // Hide and show the alerts so that messages can be registered by
                // screen reader even if they are repeats. Uses $timeout to
                // wait for DOM before showing alerts again.
                var toggleAlert = function toggleAlert() {
                    var $alert = element.find('ul');
                    $alert.detach();
                    $timeout(function () {
                        element.find('#pageLevelErrors').append($alert);
                    });
                };

                // Toggle the alert whenever message changes by removing it and reappending it
                // to the DOM. Should fire even if message
                // is changed to the same, as assumes that the message should be reapplied.
                var cancel;
                scope.$watchCollection('message', function () {
                    if ($loader.isLoading() && !cancel) {
                        // If loading, toggle the alert after all loading calls have been made.
                        // This is so that the alert can be read by screen reader after focus
                        cancel = $rootScope.$on('allLoaded', function () {
                            cancel();
                            toggleAlert();

                            cancel = null;
                        });
                    } else {
                        toggleAlert();
                    }
                });

                scope.$on('$destroy', function () {
                    if (cancel) {
                        cancel();
                    }
                });
            }
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/modal/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            show: '=?',
            showCloseButton: '=?',
            enableCloseOnEscape: '=?',
            onClose: '=?',
            enableMobileInterstitial: '@?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },
        controller: ['$scope', function ($scope) {
            $scope.animate = false; // Don't animate until triggered
            $scope.showOverlay = $scope.show;

            var escapeKeyHandler = function escapeKeyHandler($event) {
                if ($event.keyCode === 27) {
                    // Escape key maps to keycode 27
                    $scope.hideModal();
                }
            };

            if ($scope.enableCloseOnEscape) {
                // Handle escape button as close button click
                $(document).bind('keyup', escapeKeyHandler);
            }

            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;
                $(document).unbind('keyup', escapeKeyHandler);
                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        }],

        link: function link($scope, elem, attrs) {
            // HACK: without this check, the modal slides down/fades out upon it being rendered
            $scope.$watch('show', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    // When the show prop changes
                    $scope.animate = true; // Ensure the modal is animated
                }
            });
        }
    };
});

_squid.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-wrapper\" ng-class=\"{'animate': animate}\" ng-show='show' content>\n\t<div class=\"modal-overlay\"></div>\n\t<div class=\"modal-dialog\" ng-class=\"{'mobile-interstitial': enableMobileInterstitial}\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/popup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid) {

    squid.module('xo-popup.directive', ['squid']).directive('xoPopup', ['$window', '$util', function ($window, $util) {
        return {
            restrict: 'A',

            link: function link(scope, element, attr) {

                element.on('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var config = {
                        popupUrl: attr.href,
                        popupWindowName: 'popup',
                        width: 835,
                        height: 500,

                        popupWindowFeatures: {
                            location: 1,
                            status: 1,
                            scrollbars: 1,
                            resizable: 1,
                            toolbar: 0,
                            menubar: 0
                        }
                    };

                    scope.trackExternalLink(attr.id || 'external_link');

                    var isOneTouch = $util.param('isOneTouch');

                    if (/PLAYSTATION|iPadApp/i.test($window.navigator.userAgent) && isOneTouch !== '1') {
                        scope.$emit('showModal', config);
                        return false;
                    }

                    if ($(element).hasClass('smallPopup')) {
                        config.width = 385;
                    }

                    var left = 0;
                    var top = 0;

                    if (window.outerWidth) {
                        left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
                        top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
                    } else if (window.screen.width) {
                        left = Math.round((window.screen.width - config.width) / 2);
                        top = Math.round((window.screen.height - config.height) / 2);
                    }

                    var features = Object.keys(config.popupWindowFeatures).map(function (k) {
                        return k + '=' + config.popupWindowFeatures[k];
                    }).join(',');

                    // put together WindowFeatures, since, window.open needs it as a string
                    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;

                    var popup = $window.open(config.popupUrl, config.popupWindowName, features);

                    if (popup.focus) {
                        popup.focus();
                    }
                });
            },

            controller: ['$scope', '$logger', function ($scope, $logger) {
                $scope.trackExternalLink = function (linkName) {
                    $logger.info(linkName);
                };
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/select-simple/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/select-simple/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * xo-ui-select-simple
 * Full directive/template for the dropdown UI component (http://paypal-ui/components/forms/dropdowns)
 *
 * props:
 *  - options: Array<Option> ([{id: 1, label: 'Foo'}, {id: 2, label: 'Bar'}])
 *  - onSelect: Function, gets called when an option is selected
 *  - selectedOption: Option ({id: 1, label: 'Red'})
 *  - label: String, will add a floating label to the text box if passed
 *  - defaultText: String, placeholder text before an option is selected
*/

exports['default'] = _squid.$Component.extend('$xoUiSelectSimpleComponent', {
    tag: 'xo-ui-select-simple',
    template: _template2['default'],
    props: {
        options: {
            type: 'var',
            required: true
        },
        selectedOption: {
            type: 'var',
            required: false
        },
        label: {
            type: 'var',
            required: false
        },
        defaultText: {
            type: 'var',
            required: false
        },
        onSelect: {
            type: 'var',
            required: false
        }
    },
    actions: {
        selectOption: function selectOption(option) {
            var hasOnSelectedCallback = typeof this.onSelect === 'function';
            var isNotSelected = !this.checkSameOption(this.selectedOption, option);

            if (hasOnSelectedCallback && isNotSelected) {
                this.onSelect(option);
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.focused = false;

            this.checkSameOption = function () {
                var option1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var option2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                return option1.id === option2.id && option1.label === option2.label;
            };

            var isValidSelected = function isValidSelected() {
                var inOptions = function inOptions() {
                    return Boolean(_this.options.filter(function (option) {
                        return _this.checkSameOption(_this.selectedOption, option);
                    }).length);
                };

                return _this.selectedOption && inOptions();
            };

            var updateComputedOption = function updateComputedOption() {
                _this.hasLabel = Boolean(_this.label && _this.label.length && _this.selectedOption);

                if (isValidSelected()) {
                    _this.compSelectedOption = (0, _angular.extend)({}, _this.selectedOption);
                    return;
                } else {
                    _this.compSelectedOption = undefined;
                    _this.actions.selectOption(_this.compSelectedOption);
                }
            };

            this.$watch('selectedOption', updateComputedOption);
        }
    }
});


_squid.$Component;

_angular.extend;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n    ng-class=\"{ floatingLabel: hasLabel }\"\n    class=\"uiSelectSimple dropdown inputField\"\n    ng-mouseenter=\"active = true\"\n    ng-mouseleave=\"active = false\">\n    <div class=\"custom-select-container\">\n        <select\n            ng-model=\"compSelectedOption\"\n            ng-click=\"focused = !focused\"\n            ng-change=\"actions.selectOption(compSelectedOption)\"\n            ng-options=\"option.label for option in options track by option.id\"\n            ng-class=\"{ focused: focused || selectedOption }\"\n            class=\"replaced\">\n            <option value=\"\" disabled selected>{{ defaultText }}</option>\n        </select>\n        <span\n            ng-class=\"{ active: active }\"\n            class=\"custom-select\" aria-hidden=\"true\">\n            <span><span>{{ compSelectedOption ? compSelectedOption.label : '' }}</span></span>\n        </span>\n        <label ng-if=\"(label && selectedOption)\" class=\"floatingLabelLabel\">{{ label }}</label>\n        <label ng-if=\"!selectedOption\" class=\"defaultTextLabel\">{{ defaultText }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {
    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', [function () {
        return {
            scope: {},
            template: template,
            controller: ['$scope', '$element', '$rootScope', '$locale', '$logger', '$loader', '$timeout', function ($scope, $element, $rootScope, $locale, $logger, $loader, $timeout) {
                var $body = angular.element(document.getElementsByTagName('body'));
                var $priorActiveElement = $();
                var $capturedElement = $();
                var $header = $('header');
                var $slidingArea = $('#main');
                var $footer = $('footer');

                /**
                 * This hides page content from any screen readers.
                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
                 *
                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
                 * At the very least, let's cache these selectors :|
                 */
                function hidePageContentFromScreenReader(toggle) {
                    $body.attr('aria-busy', toggle);
                    $header.attr('aria-busy', toggle);
                    $slidingArea.attr('aria-busy', toggle);
                    $footer.attr('aria-busy', toggle);
                }

                function preventDefault(event) {
                    var _event$target = event.target;
                    _event$target = _event$target === undefined ? {} : _event$target;
                    var targetId = _event$target.id;

                    // Only call preventDefault if the target is not a captcha input.
                    // If the target is a captcha input we don't want to prevent the
                    // user from entering the captcha code.

                    if (targetId !== 'captchaCode') {
                        event.preventDefault();
                    }
                }

                function captureFocus(event) {
                    if (!$element.has(event.target).length) {
                        $capturedElement = $(event.target);
                    }
                }

                function setLoadingMessage(message) {
                    if (angular.isObject(message)) {
                        $scope.message = message.heading;
                        $scope.subMessage = message.subHeading;
                        $('#spinnerMessage').css('font-size', '17.5px');
                        $('#spinnerMessage').html(message.heading);
                        $('#spinnerSubHeading').html(message.subHeading);
                    } else {
                        $scope.message = message;
                        $scope.subMessage = null;
                        $('#spinnerMessage').html(message);
                    }
                }

                function showSpinner() {
                    $scope.loading = true;
                    $logger.info('show_loading_spinner');
                    $body.addClass('loading');

                    // remember what was previously focused
                    $priorActiveElement = $(':focus');

                    $(':input, a').blur();

                    hidePageContentFromScreenReader(true);

                    if ($loader.firstLoad()) {
                        setLoadingMessage($locale.content.get('base.processing'));
                    }

                    // focus on the message so that screen readers will let the user know the page is loading
                    $(document).on('keydown', preventDefault);
                    $(document).on('focusin', captureFocus);
                    $timeout(function () {
                        $('#spinner-message').focus().attr('alt', $scope.message || $locale.content.get('base.processing'));
                    });
                }

                function hideSpinner() {
                    $scope.loading = false;
                    $logger.info('hide_loading_spinner');
                    $('#preloaderSpinner').hide();
                    $body.removeClass('loading');
                    $(document).off('keydown', preventDefault);
                    $(document).off('focusin', captureFocus);

                    hidePageContentFromScreenReader(false);

                    // Focus captured element if focus was given to an element while spinner was active.
                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
                        $capturedElement.focus();
                        // Focus element that had focus before if it is still within the document
                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
                        $priorActiveElement.focus();
                    } else {
                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
                        // the element last clicked, rather than top of page.
                        $slidingArea.focus();
                    }
                    $priorActiveElement = $();
                    $capturedElement = $();
                }

                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);

                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
                    setLoadingMessage(text);
                });

                $scope.$on('$destroy', function () {
                    hideSpinner();
                    cancelStartLoad();
                    cancelAllLoaded();
                    cancelSetLoadingMessage();
                });

                if ($loader.isLoading()) {
                    showSpinner();
                }
            }]
        };
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/styles.less");

var _utils = __webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoStickyCta', {
    tag: 'xo-sticky-cta',
    template: _template2['default'],
    transclude: true,
    props: {
        eligibility: {
            type: 'var',
            required: false
        }
    },
    resolve: {},
    lifecycle: {
        populate: function populate() {
            _logger.$logger.info('xoStickyCta_populate_' + this.eligibility);
            if (!this.eligibility) {
                return;
            }
            var position = this.eligibility;
            var stickyContent = document.getElementById('sticky-content');
            var stickyPlaceholder = document.getElementById('sticky-placeholder-' + position);
            var foundContentDom = Boolean(stickyContent);
            var placeholderIsVisible = (0, _utils.isInViewport)(stickyPlaceholder);

            angular.element(stickyContent).addClass('sticky-' + position + '-off');

            _logger.$logger.info('xoStickyCta_init', {
                foundContentDom: foundContentDom,
                placeholderIsVisible: placeholderIsVisible,
                position: position
            });

            /**
             * TODO: Replace sticky logic with 'position:sticky' only when
             * there is greater browser compatibility. It is more seamless.
             * When using 'position:sticky' revert 'overflow:hidden' else sticky is not possible.
             * angular.element(document.getElementById('sliding-area')).css('overflow', 'inherit');
            */

            /**
             * Current Logic: if the stickyContent DOM is found in html then
             * - if placeholder is visible on screen -> fix the DOM position to its regular position
             * - if placeholder is not visible on screen -> we make the DOM float
            */

            var isFloating = false;

            var bindHandler = function bindHandler(event) {
                isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                    isFloating: isFloating,
                    position: position,
                    currentState: _angular.$rootScope.currentState
                });
            };

            var stateHandler = function stateHandler(event, toState, toParams, fromState) {
                /**
                 * TODO:
                 * try to use something like .trayOpen -> great grand child .sticky via css
                 * this is required for cases when overlay or sidebar is opened.
                */
                var review = 'checkout.review';
                var to = toState && toState.name;
                var from = fromState && fromState.name;

                var conflict = from === to;
                var leaving = !conflict && from === review;
                var entering = !conflict && to === review;

                if (leaving) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        force: 'off',
                        position: position
                    });
                }
                if (entering) {
                    isFloating = (0, _utils.stickyHandler)(stickyPlaceholder, stickyContent, {
                        isFloating: isFloating,
                        position: position,
                        currentState: _angular.$rootScope.currentState
                    });
                }

                _logger.$logger.info('xoStickyCta_stateChangeSuccess', { to: to, from: from, isFloating: isFloating });
            };

            angular.element(_angular.$window).bind('scroll', bindHandler).bind('resize', bindHandler);
            // .bind('orientationchange', bindHandler); // TODO

            var stateChangeListener = _angular.$rootScope.$on('$stateChangeSuccess', stateHandler);

            this.$on('$destroy', function () {
                _logger.$logger.info('xoStickyCta_destroy');
                angular.element(_angular.$window).unbind('scroll', bindHandler) // remove only the handlers used in this element
                // .bind('orientationchange', bindHandler) // TODO
                .unbind('resize', bindHandler); // remove only the handlers used in this element
                stateChangeListener();
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_angular.$window;

_angular.$rootScope;

_utils.isInViewport;

_utils.stickyHandler;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"sticky-wrapper\">\n    <div id=\"sticky-placeholder-top\"></div>\n    <div id=\"sticky-content\" ng-transclude></div>\n    <div id=\"sticky-placeholder-bottom\"></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/sticky-cta/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
/**
 * Checks if provided element is currently visible.
 * 
 * @param {any} element: Reference to DOM object
 * @returns {Boolean}
 */
var isInViewport = exports.isInViewport = function isInViewport(element) {
    var bounding = element.getBoundingClientRect();

    return (
        // check if element is bellow top most pixel
        // check if element is on the right of left most pixel
        // check if element is above the lowest pixel on screen
        // check if element is on the left of the right most pixel
        bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * Make the element provided sticky
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var makeSticky = exports.makeSticky = function makeSticky(placeholder, element, position) {
    var elementHeight = element.offsetHeight;

    angular.element(element).addClass('sticky').addClass('sticky-' + position).removeClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', elementHeight);
    return true;
};

/**
 * Make the element provided fixed to regular location
 * 
 * @param {any} placeholder: Reference to placeholder DOM object
 * @param {any} element: Reference to DOM object
 * @param {string} position: where the element is located ('top', 'bottom').
 */
var removeSticky = exports.removeSticky = function removeSticky(placeholder, element, position) {
    angular.element(element).removeClass('sticky').removeClass('sticky-' + position).addClass('sticky-' + position + '-off');
    angular.element(placeholder).css('height', '');
    return false;
};

/**
 * Decides when to enable or disable sticky effect on DOM
 * 
 * @param {any} stickyPlaceholder: Reference to DOM object
 * @param {any} stickyContent: Reference to DOM object 
 * @param {any} context: context related to current state of DOM
 * @returns {Boolean}: Updated state of DOM
 */
var stickyHandler = exports.stickyHandler = function stickyHandler(stickyPlaceholder, stickyContent, context) {
    var position = context.position,
        force = context.force,
        currentState = context.currentState,
        isFloating = context.isFloating;


    if (force === 'off') {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    }

    var alreadyFloating = isInViewport(stickyPlaceholder) && isFloating;
    var canEnable = !isInViewport(stickyPlaceholder) && !isFloating && currentState === 'checkout_review';

    if (alreadyFloating) {
        return removeSticky(stickyPlaceholder, stickyContent, position);
    } else if (canEnable) {
        return makeSticky(stickyPlaceholder, stickyContent, position);
    } else {
        return isFloating;
    }
};

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tabs/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/tabs/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * THIS IS A WIP
 * At this point, only pass 2 tabs!
 *
 * xo-ui-tabs
 * props:
 *  - tabs: Array<Tab> ([{id: 1, label: content('string')}, {id: 2, label: content('otherString')}])
 *  - onSelect: Function, gets called when a tab is selected
 *  - selectedTab: Tab ({id: 1, label: content('string')})
 */

exports['default'] = _squid.$Component.extend('$xoUiTabsComponent', {
    tag: 'xo-ui-tabs',
    template: _template2['default'],
    props: {
        tabs: {
            type: 'var',
            required: true
        },
        onSelect: {
            type: 'var',
            required: false
        },
        selectedTab: {
            type: 'var',
            required: false
        }
    },
    actions: {
        getTabIsActive: function getTabIsActive(tab) {
            return this.compSelectedTab && tab.id === this.compSelectedTab.id;
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var isValidSelected = function isValidSelected() {
                var inTabs = function inTabs() {
                    return Boolean(_this.tabs.filter(function (tab) {
                        return _this.selectedTab.id === tab.id && _this.selectedTab.label === tab.label;
                    }).length);
                };

                return _this.selectedTab && inTabs();
            };

            var updateComputedSelected = function updateComputedSelected() {
                if (_this.tabs.length <= 1) {
                    return;
                }

                if (isValidSelected()) {
                    _this.compSelectedTab = (0, _angular.extend)({}, _this.selectedTab);
                    return;
                } else {
                    _this.compSelectedTab = (0, _angular.extend)({}, _this.tabs[0]);
                    _this.onSelect(_this.compSelectedTab);
                }
            };

            this.$watch('selectedTab', updateComputedSelected);
        }
    }
});


_squid.$Component;

_angular.extend;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"tabs.length > 1\" class=\"tabContainer\">\n    <div class=\"tab\"\n        ng-repeat=\"tab in tabs\"\n        ng-class=\"{ active: actions.getTabIsActive(tab) }\"\n        ng-click=\"!actions.getTabIsActive(tab) && onSelect(tab)\"\n        ng-bind-html=\"tab.label\"></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-ui-components/src/tooltip/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDefaultShowEvent($el) {
    return $el.is('a') || $el.is('button') ? 'click' : 'focus';
}

// Modify the aria-describedby property to include the id when showing the element so contents are properly read
function addDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') ? $el.attr('aria-describedby').split(' ') : [];

    if (!~describedByIds.indexOf(id)) {
        describedByIds.push(id);
    }

    $el.attr('aria-describedby', describedByIds.join(' '));
}

// Modify the aria-describedby attribute to remove the id when hiding the element so contents are no longer read
function removeDescribedById($el, id) {
    var describedByIds = $el.attr('aria-describedby') || '';

    $el.attr('aria-describedby', describedByIds.split(' ').filter(function (existingId) {
        return existingId !== id;
    }).join(' '));
}

var isMouseTypeEvent = function isMouseTypeEvent(type) {
    return (/mouse/.test(type)
    );
};

function debounceOnMouseTrigger(type, fn) {
    var isMouseType = isMouseTypeEvent(type);

    return function () {
        var _arguments = arguments;

        if (isMouseType) {
            (0, _angular.$timeout)(function () {
                return fn.apply(null, _arguments);
            }, 250);
        } else {
            fn.apply(null, arguments);
        }
    };
}

exports['default'] = _squid.$Component.extend('xoTooltip', {
    tag: 'xo-tooltip',
    template: _template2['default'],
    transclude: true,
    props: {
        trigger: {
            type: 'str',
            required: false
        },
        showEvent: {
            type: 'str',
            required: false
        },
        hideEvent: {
            type: 'str',
            required: false
        },
        displayInline: {
            type: 'var',
            required: false
        },
        align: {
            type: 'str',
            required: false
        }
    },
    lifecycle: {
        populate: function populate() {
            var $element = this.$element,
                trigger = this.trigger;

            var $trigger = $(trigger);
            var toolTip = $element.find('.toolTip');
            var toolTipID = this.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
            var isMouseOver = false;

            /**
             * Toggle the show/hide state of the tooltip
             */
            var toggle = function toggle(event) {
                if (toolTip.length && toolTip.is(':visible')) {
                    close(event);
                } else {
                    show(event);
                }
            };

            /**
             * Show the tooltip, if not already shown.
             */
            var show = function show(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                addDescribedById($trigger, toolTipID);

                // Show the tooltip and position the page scroll to include the element on page
                $element.show();
                toolTip.slideDown({
                    progress: function progress() {
                        var windowBot = $(window).scrollTop() + $(window).height();
                        var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
                        if (toolTipBot > windowBot) {
                            $(window).scrollTop(toolTipBot - $(window).height());
                        }
                    }
                });
            };

            /**
             * Hide the tooltip
             */
            var close = function close(event) {
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }

                if (!isMouseOver) {
                    if (toolTip.length && toolTip.is(':visible')) {
                        toolTip.slideUp(100, function () {
                            $element.hide();
                        });
                    } else {
                        $element.hide();
                    }

                    removeDescribedById($trigger, toolTipID);
                }
            };

            /**
             * Setting up the DOM behavior for this component
             */
            // Set defaults for showEvent and hideEvent if not provided
            this.showEvent = this.showEvent || getDefaultShowEvent($element);
            this.hideEvent = this.hideEvent || 'blur';

            var SHOW_EVENT = this.showEvent + '.toolTip';
            var HIDE_EVENT = this.hideEvent + '.toolTip';

            // Initially hide the tooltip
            $element.hide();

            // If tooltip is clicked, don't bubble up and trigger parent handlers
            $element.on('click', function (event) {
                return event.stopPropagation();
            });

            // If the tooltip contains an element with a "close" class, treat it as a close button
            $element.on('click', '.close', close);

            // Track whether the mouse is on the tooltip or not
            $element.on('mouseover', function () {
                isMouseOver = true;
            });
            $element.on('mouseleave', function () {
                isMouseOver = false;
            });

            // Clicking anywhere on the document not on the tooltip will close the tooltip.
            // Event is not passed so that other actions are not prevented
            $(document).on('click.toolTip', function (e) {
                // Needed because when the trigger is clicked, this click handler will also be fired.
                // So without this check the tooltip will open due to the trigger click and then this
                // document event handler would immediately close it
                if (!$trigger.is(e.target)) {
                    close();
                } else {
                    show();
                }
            });

            // Register the handlers to show and hide the tooltip
            if (this.showEvent === this.hideEvent) {
                $trigger.on(SHOW_EVENT, toggle);
                $element.on(SHOW_EVENT, toggle);
            } else {
                $trigger.on(SHOW_EVENT, show);
                $trigger.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
                // Also allow close event to happen on the tooltip itself, for mouse type events
                $element.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
            }

            // Clean up external listeners on exit
            this.$on('$destroy', function () {
                $(document).off('click.toolTip');
                $trigger.off(SHOW_EVENT);
                $trigger.off(HIDE_EVENT);
                close();
            });
        }
    }
});


_angular.$timeout;

_squid.$Component;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCardLoader = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _popupHandler = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js");

var _popupHandler2 = _interopRequireDefault(_popupHandler);

var _template = __webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoAssistBanner', {
    tag: 'xo-assist-banner',
    template: _template2['default'],
    props: {
        header: {
            type: 'var',
            required: false
        },
        body: {
            type: 'var',
            required: false
        },
        hideHighlight: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            _logger.$logger.info('xo-assist-banner_enter');
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xo-assist-banner:controller');
        $scope.token = _angular.$rootScope.token;
        $scope.showFeedback = function () {
            return !_index.$DeviceInfo.isDevice();
        };
        $scope.showOL = function (event) {
            event.preventDefault();
            var placeholder = 'main:ec:hermes';
            var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
            var data = {
                opVars: {
                    rlogId: _angular.$window.meta.rlogId || '',
                    page: page || window.location.hash,
                    csci: 'Unknown',
                    calc: _angular.$window.meta.correlationId,
                    custId: 'Unknown',
                    merchantId: 'Unknown',
                    token: $scope.token || 'Unknown'
                },
                locale: {
                    country: _squid.$locale.country,
                    languageCode: _squid.$locale.lang + '_' + _squid.$locale.country
                }
            };

            (0, _popupHandler2['default'])(data);
        };
    }]
});

angular.value("$xoCardLoader", $xoCardLoader);
_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_angular.$rootScope;

_angular.$window;

_logger.$logger;

_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/popupHandler.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var _doc = document;
    var _w = window;
    var _tm = new Date().getTime();
    var _sH = screen.height;
    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
    var _sW = screen.width;

    function popUp(opinionlabURL) {
        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
    }

    function updateCustomVars(data) {

        var opVars = data.opVars;
        var locale = data.locale;

        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
        return customVar;
    }

    function _fC(_u) {
        var _sp = '%3A\\/\\/';
        var _rp = '%3A//';
        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
        var _aA = _aT.split(',');

        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
        }
        return _u;
    }

    return function (locale) {

        var custom_var = updateCustomVars(locale);

        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
        popUp(opinionlabURL);
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/user-assist-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"assist-banner-wrapper\">\n    <div ng-if=\"!hideHighlight\" class=\"banner-highlight-bar\"></div>\n    <div class=\"banner-header\">\n        <p>{{header}}</p>\n    </div>\n    <div class=\"banner-body\">\n        <p ng-bind-html=\"body\"></p>\n    </div>\n    <div class=\"banner-feedback\" ng-if=\"showFeedback()\">\n         <span>{{ content('common.haveFeedback') }}</span>\n         <a href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('common.letUsKnow') }}</a>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().directive('xoValidation', function () {
    return {
        template: '',
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attr, ngModel) {
            var validationUtil = {
                // because IE8 doesnt have String.prototype.trim()
                trim: function trim(value) {
                    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

                    return value.replace(rtrim, '');
                },


                /**
                 * Generic function that runs a given input against
                 * a given regular expression
                 *
                 * @param {String} value input to test
                 * @param {String/RegExp} regex Regular expression to test against
                 * @returns {Boolean} matches or does not match given pattern
                 */
                valid: function valid(value, regex) {
                    if (this.empty(value)) {
                        return false;
                    }

                    if (_angular2['default'].isString(regex)) {
                        regex = new RegExp(regex);
                    }

                    return regex ? regex.test(value) : true;
                },


                // returns whether empty or not
                empty: function empty(value) {
                    if (!value) {
                        return true;
                    }

                    // IE8 and below doesn't have native .trim()
                    return !this.trim(value);
                },


                // returns whether alphabetic or not
                alphabetic: function alphabetic(value) {
                    return this.valid(value, /[A-Za-z]+$/);
                },


                // returns whether numeric or not
                numeric: function numeric(value) {
                    var NUMERIC_REGEX = new RegExp('^[0-9]+$');

                    return this.valid(value, NUMERIC_REGEX);
                },
                validBankAccount: function validBankAccount(value) {
                    if (!scope.showIBAN) {
                        return this.numeric(value);
                    }

                    return true;
                },
                validRouting: function validRouting(value) {
                    if (!scope.showIBAN) {
                        return this.valid(value, /^\d{8}$/);
                    }
                    return true;
                },
                validIBANCode: function validIBANCode(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
                    }
                    return true;
                },
                validIBAN: function validIBAN(value) {
                    if (scope.showIBAN) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^DE\d{20}$/);
                    }

                    return true;
                },
                validIBANCountry: function validIBANCountry(value) {
                    value = value && value.replace(/ +/g, '');
                    return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
                },


                // @Deprecated: This function is deprecated.
                // first two letters are the country code the rest are the bank account numbers max length 32
                validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
                    value = value && value.replace(/ +/g, '');
                    return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
                },
                validLast4: function validLast4(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex

                    return this.valid(value, LAST_4);
                },
                validStreet: function validStreet(value) {
                    return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
                },


                // Validating phone format with metadata from griffin
                validPhone: function validPhone(value) {
                    var regex = scope.pattern;

                    /*
                        * User can enter phone format in various manner according to griffin mask
                        * (00) 0000-0000
                        * 00 000 0000
                        * Since the griffin pattern only validates against numbers, need to trim the input
                        * to only validate the numbers
                        */
                    value = value && value.replace(/[^0-9]/gi, '');
                    return this.valid(value, regex);
                },
                validDobYear: function validDobYear(value) {
                    return value !== 'YYYY';
                },
                validDobDay: function validDobDay(value) {
                    return value !== 'DD';
                },
                validDobMonth: function validDobMonth(value) {
                    return value !== 'MM';
                },
                validPoBox: function validPoBox(value) {
                    // @TODO - Unsafe regular expression, need to fix.
                    var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

                    if (boxRE.test(value)) {
                        return true;
                    }

                    return false;
                },
                validAddressSansPoBox: function validAddressSansPoBox(value) {
                    var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
                    var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;

                    if (boxRE.test(value) || cassRE.test(value)) {
                        return false;
                    }
                    return true;
                },
                validEmailOrPhone: function validEmailOrPhone(value) {
                    if (!value) {
                        return false;
                    }

                    return this.validEmail(value) || this.validPhone(value);
                },
                validEmail: function validEmail(value) {
                    if (!value) {
                        return false;
                    }
                    var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
                    // @TODO - Unsafe regular expression, need to fix.
                    var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

                    return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
                },
                highAscii: function highAscii(value) {
                    var trimmedValue = this.trim(value);
                    // @TODO - Unsafe regular expression, need to fix.
                    var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

                    return this.valid(trimmedValue, HIGH_ASCII_REGEX);
                },


                // expected format: MM/DD/YYYY
                validDate: function validDate(value) {
                    var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                    var dArr = value.split('/');
                    var d = new Date(value);
                    var isValid = false;

                    if (re.test(value)) {
                        isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
                    }

                    return isValid;
                },


                /* Expects value and state. state can be "past" or "future".
                    NOTE: This function validates only month and year, not day!
                    Please use validDate() if you need to validate the whole date. */
                validDateWithoutDay: function validDateWithoutDay(value, options) {
                    // eslint-disable-line max-statements
                    var state = options.state;

                    value = value.replace(/\s/g, '');

                    if (value === '') {
                        return true;
                    }

                    var split = value.split('/');
                    var month = split[0];
                    var year = split[1];
                    var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
                    var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
                    var validYear = true;
                    var validMonth = true;

                    if (value.length < 5) {
                        return false;
                    }

                    if (!this.validDobMonth(month)) {
                        return false;
                    }

                    month = parseInt(month, 10);
                    year = parseInt(year, 10);

                    if (state === 'past') {
                        validYear = year <= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month <= currentMonth;
                        }
                    } else if (state === 'future') {
                        validYear = year >= currentYear;
                        if (!validYear) {
                            return false;
                        }
                        if (year === currentYear) {
                            validMonth = month >= currentMonth;
                        }
                    }

                    if (!validYear || !validMonth) {
                        return false;
                    }

                    return true;
                },


                // formats to MM/DD/YYYY
                mmddyyyy: function mmddyyyy(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
                },


                // formats to YY-MMM-DDDD
                yyyymmdd: function yyyymmdd(day, month, year) {
                    if (year.length < 4) {
                        year = '20' + year;
                    }

                    return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
                },


                // pads a number to two digits
                twoDigits: function twoDigits(value) {
                    return value < 10 ? '0' + value : '' + value;
                },


                // expects YYYY-MM-DD
                legalAge: function legalAge(value) {
                    if (this.empty(value)) {
                        return false;
                    }

                    var dateParts = value.split('-'); // expecting YYYY-MM-DD
                    var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                    var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
                    var validBD = new Date(new Date() - 18 * yr);

                    return validBD >= birthDate;
                },
                validZip: function validZip(value, options) {

                    var postalCodeRegex = {
                        // TODO: Once this is removed from the xo-add-address template, we can remove it...
                        GB: /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
                        /**
                         * Note: These are "nice to have".
                         * Once we add support for these countries, we can remove these.
                         */
                        BA: /^\d{5}$/,
                        CY: /^\d{4}$/,
                        EE: /^\d{5}$/,
                        HR: /^\d{5}$/,
                        LU: /^\d{4}$/,
                        LV: /^\d{4}$/,
                        MT: /^\d{3,4}$/,
                        SI: /^\d{4}$/,
                        SK: /^[0-9]{3}[\s][0-9]{2}$/,
                        NZ: /^\d{4}$/,
                        LT: /^\d{5}$/,
                        BG: /^\d{4}$/,
                        CZ: /^\d{5}$/,
                        GR: /^\d{3}[\s]\d{2}$/,
                        HU: /^\d{4}$/,
                        MX: /^\d{5}$/
                    };

                    var country = options && options.country;
                    var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
                    var isRequired = scope.zipEntry && scope.zipEntry.required;

                    if (!isRequired && this.empty(value)) {
                        return true;
                    }

                    // If there is no regex, or it's not populated yet...
                    if (!regex || _angular2['default'].isString(regex) && regex.indexOf('validationPattern') > -1) {
                        return !this.empty(value);
                    }

                    value = value && value.toUpperCase();

                    if (_angular2['default'].isString(regex)) {
                        if (regex.charAt(0) !== '^') {
                            regex = '^' + regex;
                        }
                        if (regex.charAt(regex.length - 1) !== '$') {
                            regex += '$';
                        }
                    }

                    return this.valid(value, regex);
                },
                validExpiry: function validExpiry(value, options) {
                    var $monthEl = (0, _jquery2['default'])('[ng-model="card.expiry_month"]');
                    var $yearEl = (0, _jquery2['default'])('[ng-model="card.expiry_year"]');
                    var month = $monthEl.val();
                    var year = $yearEl.val();
                    var isValid = false;
                    var monthElName = 'card.expiry_month';
                    var yearElName = 'card.expiry_year';
                    var cardType = options.cardType;

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    if (month && year) {
                        isValid = this.validExpires(month, year);
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];
                    var monthFieldName = monthElName;
                    var yearFieldName = yearElName;

                    if (monthFieldName.indexOf('.') !== -1) {
                        monthFieldName = monthFieldName.split('.')[1];
                    }

                    if (yearFieldName.indexOf('.') !== -1) {
                        yearFieldName = yearFieldName.split('.')[1];
                    }

                    var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                    if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
                        isValid = true;
                    }

                    if (form) {
                        form[monthFieldName].$setValidity('validExpiry', isValid);
                        form[yearFieldName].$setValidity('validExpiry', isValid);
                    }

                    return isValid;
                },
                validExpires: function validExpires(month, year) {
                    var date = new Date();
                    var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
                    var currentMonth;

                    if (year < currentYear) {
                        return false;
                    } else if (year > currentYear) {
                        return this.validDobMonth(month);
                    }

                    // account for display date vs. system date
                    currentMonth = date.getMonth() + 1;
                    return this.validDobMonth(month) && month >= currentMonth;
                },
                startDate: function startDate(value, options) {
                    var valueOptions = {
                        cardType: scope.card.type
                    };

                    valueOptions[elem.attr('id')] = value;

                    return this.setStartDateValidity(valueOptions);
                },


                setExpiryValidity: function setExpiryValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var expiryValidity = this.validExpiry(null, {
                        cardType: cardType
                    });

                    return expiryValidity;
                },

                // start date validation for Maestro card
                setStartDateValidity: function setStartDateValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var cardType = options.cardType || '';
                    var startDateValidity = true;
                    var $monthEl = (0, _jquery2['default'])('#startmonth');
                    var $yearEl = (0, _jquery2['default'])('#startyear');
                    var month = $monthEl.val();
                    var year = $yearEl.val();

                    if (cardType === 'MAESTRO') {
                        if (!month || !year) {
                            startDateValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id'),
                        form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.startmonth.$setValidity('startDate', startDateValidity);
                        form.startyear.$setValidity('startDate', startDateValidity);
                    }

                    return startDateValidity;
                },
                dobField: function dobField(value, options) {
                    var valueOptions = {};
                    var fieldMap = {
                        dobDayCC: 'day',
                        dobMonthCC: 'month',
                        dobYearCC: 'year'
                    };

                    valueOptions.cardType = scope.card.type;
                    valueOptions[fieldMap[elem.attr('id')]] = value;

                    return this.setDOBValidity(valueOptions);
                },
                setDOBValidity: function setDOBValidity(options) {
                    if (!options) {
                        return true;
                    }

                    var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
                    var dobValidity = true;

                    var $monthEl = (0, _jquery2['default'])('#dobMonthCC');
                    var $dayEl = (0, _jquery2['default'])('#dobDayCC');
                    var $yearEl = (0, _jquery2['default'])('#dobYearCC');

                    var month = options.month || $monthEl.val();
                    var year = options.year || $yearEl.val();
                    var day = options.day || $dayEl.val();

                    if (month) {
                        month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                    }

                    if (day) {
                        day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
                    }

                    if (year) {
                        year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                    }

                    var cardType = options.cardType;

                    if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
                        if (!month || !year || !day) {
                            dobValidity = false;
                            // invalidate if < 18 y/o.
                        } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
                            dobValidity = false;
                        } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
                            dobValidity = false;
                        }
                    }

                    var formName = $monthEl.closest('form').attr('id');
                    var form = scope[formName] || scope.$parent[formName];

                    if (form) {
                        form.dobMonthCC.$setValidity('dobField', dobValidity);
                        form.dobDayCC.$setValidity('dobField', dobValidity);
                        form.dobYearCC.$setValidity('dobField', dobValidity);
                    }

                    return dobValidity;
                },
                validName: function validName(value) {
                    return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
                },
                isChecked: function isChecked(value, options) {
                    // $.is does not exist in $
                    // eslint-disable-line angular/ng_angularelement
                    var $el = (0, _jquery2['default'])(options.el);

                    return $el.is(':checked');
                },
                validRUPassport: function validRUPassport(value, options) {
                    if (scope.user.countryOfResidence === 'RU') {
                        return this.valid(value, /^\d{10}$/);
                    }
                    return true;
                }
            };

            var customValidator = function customValidator(value) {
                var ruleJson = _angular2['default'].fromJson(elem.attr('xo-validation'));
                var validator = ruleJson.validator;
                var options = ruleJson.options;

                ngModel.$setValidity(validator, validationUtil[validator](value, options));

                return value;
            };

            ngModel.$parsers.unshift(customValidator);
            ngModel.$formatters.unshift(customValidator);
        }
    };
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/3ds/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xo3ds', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            data: '=?',
            onComplete3dsHandler: '=?'
        },
        controller: ['$scope', function ($scope) {
            var resolve3DS = _index2.$Resolve3DS.instance($scope.token);
            var checkoutAppData = _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
            var _$locale$country = _squid.$locale.country,
                country = _$locale$country === undefined ? 'DEFAULT' : _$locale$country;

            var isIos = _dist.$DeviceInfo.getiOSVersion();
            var timeout3DSConfig = _squid.$config.timeout3DS || { 'DEFAULT': 30000 };
            var lightBoxTimeout = isIos && country === 'IN' ? 0 : timeout3DSConfig[country] || timeout3DSConfig['DEFAULT'];

            $scope.termUrl = '' + window.location.origin + _squid.$config.urls.baseUrl + '/process3DS';
            $scope.data = $scope.data || {};

            function show3DSLightBox() {
                if ($scope.show3DS) {
                    var lightbox = angular.element(document.getElementById('light-box'));
                    lightbox.addClass('open');
                    $scope.show3DS = false;
                    _angular.$rootScope.$emit('loaded');
                }
            }

            function shouldUpdatePaymentExperience() {
                var merchantCountry = checkoutAppData.get('merchant.merchant_country', 'US');
                return !(_squid.$config.features[country] && _squid.$config.features[country].mandatory3dsWithMerchantCountries && _squid.$config.features[country].mandatory3dsWithMerchantCountries.includes(merchantCountry));
            }

            function handleInitFailure(message) {
                // Since init3DS call failed. We disable the feature and proceed to checkout.
                var updateAction = shouldUpdatePaymentExperience() ? checkoutAppData.action('updatePaymentExperience', {
                    data: {
                        payment_experience: 'HERMESNODE',
                        '3d_secure_authentication_supported': false
                    },
                    silent: true,
                    transientError: true
                }) : _squid.$promise.resolve();
                updateAction.then(function () {
                    _logger.$logger.info('checkout_fpti', {
                        from: '3DS_CHALLENGE',
                        to: 'process_3ds_challenge',
                        'int_error_description': message,
                        'error_type': 'soft_decline',
                        'error_source': 'fiLifecycle'
                    });
                    $scope.onComplete3dsHandler('success');
                });
            }

            function init3DSApi() {
                _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));

                //  3DS - New values to support latest PG
                var _$scope$data = $scope.data,
                    cardVerificationCode = _$scope$data.card_verification_code,
                    supportedPaymentExperiences = _$scope$data.paymentExperience,
                    channelType = _$scope$data.channelType,
                    isMiniBrowser = _$scope$data.isMiniBrowser,
                    isRedirectTreatment = _$scope$data.isRedirectTreatment,
                    process3dsReturnQueryParams = _$scope$data.process3dsReturnQueryParams;


                return resolve3DS.action('init3DS', {
                    data: {
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id,
                        merchant_id: $scope.data.merchant_id,
                        merchant_country: $scope.data.merchant_country_code,
                        currency: $scope.data.transaction_amount_currency,
                        transaction_amount: $scope.data.transaction_amount_value,
                        channel: channelType,
                        card_verification_code: cardVerificationCode,
                        supported_payment_experiences: supportedPaymentExperiences,
                        isMiniBrowser: isMiniBrowser
                    },
                    success: function success(response) {
                        if (response.status === 'SUCCESS' && response.acsUrl) {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'prepare_3ds_challenge'
                            });
                            $scope.acsUrl = response.acsUrl;
                            $scope.acsMethod = response.acsMethod || 'POST';
                            $scope.acsPaReq = response.acsPaReq;
                            $scope.redirectRequestParameters = response.redirectRequestParameters;

                            $scope.paymentExperience = response.paymentExperience || (isRedirectTreatment ? 'REDIRECT' : 'IFRAME');

                            var target = 'threeDSFrame';
                            if ($scope.paymentExperience === 'REDIRECT') {
                                var complete3DSQuery = process3dsReturnQueryParams;
                                $scope.termUrl = '' + window.location.origin + _squid.$config.urls.baseUrl + '/process3DSRedirect?' + complete3DSQuery;
                                target = '_self';
                            }

                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_PAYMENT_EXPERIENCE',
                                to: 'prepare_paymentExperience_' + $scope.paymentExperience
                            });

                            _logger.$logger.info('3DS_PAYMENT_EXPERIENCE_' + $scope.paymentExperience, {
                                response_paymentExperience: response.paymentExperience,
                                elmo_isRedirectTreatment: isRedirectTreatment,
                                paymentExperience: $scope.paymentExperience
                            });

                            var form = $('<form/>', {
                                action: $scope.acsUrl,
                                method: $scope.acsMethod,
                                id: 'iFrameForm',
                                target: target
                            });

                            if ($scope.redirectRequestParameters && $scope.redirectRequestParameters.length > 0) {
                                $scope.redirectRequestParameters.forEach(function (item) {
                                    form.append($('<input/>', {
                                        type: 'hidden',
                                        name: item.key,
                                        value: item.value === 'PAYPAL_RETURN_URL' ? $scope.termUrl : item.value
                                    }));
                                });
                            } else if ($scope.acsPaReq) {
                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'TermUrl',
                                    value: $scope.termUrl
                                }));
                                form.append($('<input/>', {
                                    type: 'hidden',
                                    name: 'PaReq',
                                    value: $scope.acsPaReq
                                }));
                            }

                            $('#lightBoxAcsWrapper').append(form);
                            $('#iFrameForm').submit();

                            // wait for 3DS page to load with a timeout

                            // The $scope.show3DS in the line below is set true when the 3DS modal is eligible to be shown to user when the
                            // bank page loads in its iframe, i.e., after init3DS success
                            $scope.show3DS = true;
                            _angular.$rootScope.$emit('loading');
                            _angular.$rootScope.$emit('loadingMessage', _squid.$locale.content.get('threeDS.processing'));
                            (0, _angular.$timeout)(function () {
                                if ($scope.show3DS) {
                                    _logger.$logger.info('checkout_fpti', {
                                        from: '3DS_CHALLENGE',
                                        to: '3DS_CHALLENGE',
                                        'int_error_description': 'load_3ds_issuer_page_content_timeout',
                                        'error_type': 'soft_decline',
                                        'error_source': 'fiLifecycle'
                                    });
                                }
                                show3DSLightBox();
                            }, lightBoxTimeout);
                        } else {
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'acsUrl_not_presented_on_init',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });

                            // When there is no 3DS challenge page to be shown, we return success to the caller
                            $scope.onComplete3dsHandler('success');
                        }
                    },
                    error: function error() {
                        handleInitFailure('unknown_error_on_init3DS');
                    },
                    validation: function validation() {
                        handleInitFailure('validation_error_on_init3DS');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT() {
                            handleInitFailure('contingency_presented_on_init3DS');
                        }
                    }
                });
            }

            function complete3DSApi(paRes) {
                return resolve3DS.action('complete3DS', {
                    data: {
                        third_party_response: paRes,
                        cc_id: $scope.data.cc_id,
                        flow_id: $scope.data.flow_id
                    },
                    success: function success(response) {
                        var status = void 0;

                        if (response.status === 'SUCCESS') {
                            status = 'success';

                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge'
                            });
                        } else {
                            status = 'decline';
                            _logger.$logger.info('checkout_fpti', {
                                from: '3DS_CHALLENGE',
                                to: 'process_3ds_challenge',
                                'int_error_description': 'complete3DS_decline',
                                'error_type': 'soft_decline',
                                'error_source': 'fiLifecycle'
                            });
                        }
                        $scope.onComplete3dsHandler(status);
                    }
                });
            }

            $scope.close3DSFrame = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: '3DS_CHALLENGE',
                    to: 'process_user_close'
                });
                _logger.$logger.flush();

                var lightbox = angular.element(document.getElementById('light-box'));
                lightbox.removeClass('open');

                (0, _angular.$timeout)(function () {
                    var lightboxMask = angular.element(document.getElementById('mask'));

                    lightboxMask.remove();
                    $scope.onComplete3dsHandler('close');
                }, 200);
            };

            init3DSApi();

            $scope.complete3DS = function (paRes) {
                complete3DSApi(paRes);
            };

            _angular.$window.complete3DSFrame = function (paRes) {
                $scope.complete3DS(paRes);
            };

            $scope.on3DSPageLoad = show3DSLightBox;
            _angular.$window.on3DSPageLoad = $scope.on3DSPageLoad;

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.close3DSFrame();
                }
            });
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_squid.$config;

_squid.$locale;

_squid.$promise;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$Resolve3DS;

_dist.$DeviceInfo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\" onload=\"window.on3DSPageLoad && on3DSPageLoad()\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFactory', function () {
    var shouldDisplayAddressBox = function shouldDisplayAddressBox(isNmjDesign1, cardModel, invalidfield) {
        var avsRetry = _squid.$util.param('avsRetry') || invalidfield;
        var redirectFromXoon = _squid.$util.param('redirectToHermes') ? '1' : '0';
        if (!cardModel || !cardModel.address) {
            return _squid.$promise.resolve(false);
        }
        if (isNmjDesign1) {
            return _squid.$promise.resolve(true);
        }
        if (avsRetry) {
            return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': _squid.$locale.country, 'ctx.XOON_REDIRECT': redirectFromXoon, 'ctx.AVS': avsRetry }, 'xo_hermes_addcard_msg_xoon_redirect_avs_address_box', false, true).then(function (result) {
                return result && result.treatment_name;
            });
        }
        return _squid.$promise.resolve(false);
    };

    var getCheckoutIncentivePxpResult = function getCheckoutIncentivePxpResult() {
        return (0, _squid.$pxp)('xo_hermes_checkout_incentive', {}, '(xo_hermes_checkout_incentive_)(.*)', false, true).then(function (result) {
            return result && result.treatment_name;
        });
    };

    var getIssuerDeclineElmoResult = function getIssuerDeclineElmoResult() {
        return (0, _squid.$elmo)('xo_hermesnodeweb_issuer_decline', { 'ctx.country': _squid.$locale.country }, 'Trmt_xo_hermesnodeweb_issuer_decline_1').then(function (result) {
            return result && result.treatment_name;
        });
    };

    return {
        shouldDisplayAddressBox: shouldDisplayAddressBox,
        getCheckoutIncentivePxpResult: getCheckoutIncentivePxpResult,
        getIssuerDeclineElmoResult: getIssuerDeclineElmoResult
    };
});

_squid.$locale;

_squid.$promise;

_squid.$pxp;

_squid.$util;

_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CardMetaData = undefined;

var _LIBRARY_TO_TYPE_MAP;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _creditCardType = __webpack_require__("../node_modules/credit-card-type/dist/index.js");

var _creditCardType2 = _interopRequireDefault(_creditCardType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_TYPE = {
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16],
    niceType: 'Unknown',
    patterns: [],
    type: 'DEFAULT'
};

// Add additional supported card types
// TODO: Provide patterns for these types
_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    niceType: 'Carte Bancaire',
    patterns: [],
    type: 'cb-nationale'
});

_creditCardType2['default'].addCard({
    code: {
        name: 'CVV',
        size: 3
    },
    gaps: [4, 8, 12, 16],
    lengths: [19],
    niceType: 'Carte Aurore',
    patterns: [],
    type: 'cetelem'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8, 12, 16],
    lengths: [17],
    niceType: 'Cofinoga ou Privilège',
    patterns: [],
    type: 'cofinoga'
});

_creditCardType2['default'].addCard({
    code: {
        name: '',
        size: 0
    },
    gaps: [4, 8],
    lengths: [8, 9],
    niceType: '4 étoiles',
    patterns: [],
    type: 'cofidis'
});

var LIBRARY_TO_TYPE_MAP = (_LIBRARY_TO_TYPE_MAP = {}, _LIBRARY_TO_TYPE_MAP[_creditCardType.types.AMERICAN_EXPRESS] = 'AMEX', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DINERS_CLUB] = 'DINERSCLUB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.DISCOVER] = 'DISCOVER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.ELO] = 'ELO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPER] = 'HIPER', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.HIPERCARD] = 'HIPERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.JCB] = 'JCB', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MASTERCARD] = 'MASTERCARD', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.MAESTRO] = 'MAESTRO', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.UNIONPAY] = 'CUP', _LIBRARY_TO_TYPE_MAP[_creditCardType.types.VISA] = 'VISA', _LIBRARY_TO_TYPE_MAP['cb-nationale'] = 'CBNATIONALE', _LIBRARY_TO_TYPE_MAP.cetelem = 'CETELEM', _LIBRARY_TO_TYPE_MAP.cofidis = 'COFIDIS', _LIBRARY_TO_TYPE_MAP.cofinoga = 'COFINOGA', _LIBRARY_TO_TYPE_MAP);

// Invert LIBRARY_TO_TYPE_MAP to enable to opposite lookup in constant time
var TYPE_TO_LIBRARY_MAP = Object.entries(LIBRARY_TO_TYPE_MAP).reduce(function (inverted, pair) {
    inverted[pair[1]] = pair[0];
    return inverted;
}, {});

/**
 * Detect the card type of the passed partial or full card number.
 * Returns null (no match) if the detected card type is not in allowedTypes.
 * 
 * @param {Array} allowedTypes Array of allowed card types
 * @param {String} number Partial or full card number
 */
function detectCardType(allowedTypes, number) {
    var matches = (0, _creditCardType2['default'])(number);
    var metadata = _angular2['default'].isArray(matches) && matches[0];

    if (metadata) {
        var cardType = LIBRARY_TO_TYPE_MAP[metadata.type];

        if (allowedTypes.indexOf(cardType) > -1) {
            return cardType;
        }
    }

    return null;
}

/**
 * Determine the input fields to show for the passed cardType.
 * 
 * @param {String} cardType The card type (e.g. VISA, AMEX, or MASTERCARD)
 * @param {String} productType The card product type (e.g. 'DEBIT' or 'CREDIT')
 * @param {String} country The user's country code
 */
function getCardFields(cardType, productType, country) {
    var isDebit = ['DEBIT', 'DEBITCARD'].indexOf(productType) > -1;
    var isCupC2 = cardType === 'CUP' && country === 'C2';
    var isCupC2Debit = isCupC2 && isDebit;

    return {
        issue: cardType === 'SWITCH',
        expiry: ['PLCC', 'COFIDIS'].indexOf(cardType) === -1 && !isCupC2Debit,
        cvv: ['PLCC', 'COFIDIS', 'COFINOGA'].indexOf(cardType) === -1 && !isCupC2Debit,
        dob: ['CETELEM', 'COFIDIS', 'COFINOGA'].indexOf(cardType) > -1,
        phone: isCupC2,
        address: !(cardType === 'PLCC' || isCupC2)
    };
}

var $CardMetaData = exports.$CardMetaData = {
    /**
     * Get part of the card type metadata for a particular card.
     * 
     * This function is now essentially a shim between the old hardcoded
     * card metadata object and the credit-card-type library. Field lookups
     * could be more efficient, but this maintains the existing API.
     * 
     * @param {Object} card Card object
     * @param {String} field Requested field (e.g. 'luhn' or 'fields.cvv')
     * @param {String} country The user's country code
     */
    getMetaData: function getMetaData(card, field, country) {
        var tokens = field.split('.');
        var prop = tokens[0];
        var attr = tokens[1];

        if (prop === 'phoneType') {
            // This was always 'Mobile' in the old metadata object
            return 'Mobile';
        }

        // Some cards can run on two networks, e.g. Visa + UnionPay
        var cardType = card && card.type;
        var dualType = card && card.dualType;

        if (prop === 'luhn') {
            // Cofidis cards do not use the Luhn check
            return cardType !== 'COFIDIS';
        }

        if (prop === 'fields') {
            var cardFields = getCardFields(cardType, card.productType, country);

            // Return only the requested field
            return attr ? cardFields[attr] : cardFields;
        }

        // For dual-brand cards, the card number will conform to the cobranded
        // network's format instead of the UnionPay format
        var cardFormatType = dualType && dualType !== 'CUP' ? dualType : cardType;
        var mapped = TYPE_TO_LIBRARY_MAP[cardFormatType];
        var metadata = mapped ? (0, _creditCardType.getTypeInfo)(mapped) : DEFAULT_TYPE;

        if (prop === 'spaces') {
            return attr ? metadata.gaps[attr] : metadata.gaps;
        }

        if (prop === 'length') {
            var lengths = {
                cvv: metadata.code && metadata.code.size,
                min: Math.min.apply(null, metadata.lengths),
                max: Math.max.apply(null, metadata.lengths)
            };

            // Return only the requested field
            return attr ? lengths[attr] : lengths;
        }

        // Unknown field
        return null;
    },


    /**
     * Get the card type of the passed partial or full card number.
     * 
     * @param {Array} allowedTypes Array of allowed card types
     * @param {String} number Partial or full card number
     */
    getCardType: function getCardType(allowedTypes, number) {
        var cardType = {};
        if (_angular2['default'].isArray(allowedTypes) && number) {
            cardType.type = detectCardType(allowedTypes, number);
        }
        return cardType;
    }
};

_angular2['default'].value("$CardMetaData", $CardMetaData);

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCvvDirective = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
    tag: 'xo-cvv',
    template: _template2['default'],

    props: {
        card: {
            type: 'var',
            required: false
        },
        showLabel: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            // A boolean message to update the masking property of cvv when the pre-filling happens
            this.$on('maskCVV', function ($event, isMasked) {
                _this.maskCVV = isMasked;
            });
            this.onCVVClick = function () {
                _logger.$logger.info('checkout_fpti', {
                    from: 'REVIEW',
                    to: 'process_cvv_clicked',
                    message: 'CVV Field Clicked'
                });
                _logger.$logger.flush();
            };
            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
            this.cvvLength = function () {
                // passing country to differentiate CUP for C2 and ROW
                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv', _squid.$locale.country);
            };
            this.cvvRequired = function () {
                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
            };
            this.onCVVChange = function ($event) {
                /**
                 * Focus the call to action (CTA) button.
                 * Useful when it is getting hidden/overlapped in the smaller devices. 
                 */

                var cvvLength = _this.cvvLength();
                var security_code = _this.props.card.security_code;


                if (security_code && security_code.length === cvvLength) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'REVIEW',
                        to: 'process_cvv_changed',
                        message: 'Focus the continue button on valid CVV field'
                    });
                    // Focus the CTA button.
                    $('form #confirmButtonTop').focus();
                }
            };
        }
    }
});

angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;

_logger.$logger;

_cardMetaData.$CardMetaData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\" directionality>\n    <label ng-if=\"showLabel\" class=\"cvv nolap\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n\n    <div class=\"cvvSecurityCode inputField\" directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" data-test-id=\"ccCvvInput\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-keyup=\"onCVVChange($event)\"\n               ng-click=\"onCVVClick()\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-text=\"{{content('validation.validCSC')}}\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");

var _factory = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion/factory.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionOverlayDirective', {
    tag: 'xo-currency-conversion-overlay',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutInputDataModel: _index2.$CheckoutInputDataModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                checkoutInputData = _models.checkoutInputData,
                ppconversion = _models.ppconversion;

            var fundingOptionId = checkoutInputData && checkoutInputData.funding_option_id;
            var plan = checkoutSession.plan;


            this.showOverlay = false;
            var _conversion = this.conversion,
                from_code = _conversion.from_code,
                to_code = _conversion.to_code,
                paypal = _conversion.paypal;

            var selectedConversionType = (0, _utils.mapConversionType)(ppconversion);
            var planConversionType = (0, _utils.mapConversionType)(paypal);

            if (selectedConversionType === planConversionType) {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: from_code,
                        currency_conversion_to_curr: to_code
                    } });
                // stop
                return;
            }

            var data = {
                conversionType: selectedConversionType,
                planId: fundingOptionId || plan.id
            };

            if (data.planId) {
                checkoutSession.fundingOptions.action('updateConversion', {
                    data: data,
                    success: function success(result) {
                        if (data.planId !== plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return _this.props.doneFn(result);
                        }

                        (0, _utils.logCurrencyConversion)({ options: {
                                to: 'process_currency_conversion',
                                currency_conversion_type: selectedConversionType,
                                is_conversion_shown: 1,
                                currency_conversion_from_curr: _this.conversion.from_code,
                                currency_conversion_to_curr: _this.conversion.to_code
                            } });

                        return checkoutSession.reload({
                            success: function success() {
                                // Conversion object needs to be mapped again as checkoutSession is reloaded
                                var _ref = checkoutSession || {},
                                    _ref$plan = _ref.plan,
                                    plan = _ref$plan === undefined ? {} : _ref$plan; // eslint-disable-line no-shadow
                                // Using let here since the conversion object may get reassigned at line 86 due to certain conditions


                                var _plan$conversion = plan.conversion,
                                    conversion = _plan$conversion === undefined ? {} : _plan$conversion;

                                _this.conversion = conversion;

                                if (!ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored');
                                    } else {
                                        // To avoid a situation if the conversion object is not returned in the response
                                        conversion = plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };
                                    }

                                    if (!conversion.from || !conversion.to) {
                                        _logger.$logger.info('currency_conversion_rate_missing');
                                    }
                                }

                                return _this.props.doneFn(result);
                            }
                        })['catch'](function () {
                            _logger.$logger.error('checkout_session_reload_failed');
                        });
                    }
                })['catch'](function () {
                    _logger.$logger.error('update_conversion_failed');
                });
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.showOverlay = false;

            // Close overlay function
            this.closeOverlay = function () {
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'cancel_currency_conversion',
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = false;
            };

            // Event listener to open the overlay
            var showConversionOverlay = _angular.$rootScope.$on('$showConversionOverlay', function () {
                _this2.isConversionOverlayRateContent = _factory.$CurrencyConversionFactory.isConversionOverlayRateContent();
                (0, _utils.logCurrencyConversion)({ options: {
                        to: 'prepare_currency_conversion',
                        currency_conversion_type: _this2.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                        is_conversion_shown: 1,
                        currency_conversion_from_curr: _this2.conversion.from_code,
                        currency_conversion_to_curr: _this2.conversion.to_code
                    } });
                _this2.showOverlay = true;
            });

            this.$on('$destroy', showConversionOverlay);
        },
        populate: function populate() {
            var _models2 = this.models,
                checkoutSession = _models2.checkoutSession,
                cart = _models2.cart;

            this.conversion = checkoutSession.plan.conversion;
            // If there is conversion, populate scope with properties that will be rendered in UI
            if (this.conversion) {
                var conversion = this.conversion;
                this.isConversionOverlayRateContent = false;
                this.models.ppconversion = !!conversion.paypal;
                this.cartAmount = cart.purchase && cart.purchase.amounts.total.amount_formatted_currency;
                this.payPalAmount = conversion.total_converted_amount;
                this.toTargetCurrency = conversion.to_amount_forex + ' ' + conversion.to_code;
                this.fromUnitCurrency = '1 ' + checkoutSession.plan.conversion.from_code;
            }
        }
    }
});


_squid.$Component;

_angular.$rootScope;

_angular.noop;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;

_logger.$logger;

_utils.mapConversionType;

_utils.logCurrencyConversion;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-modal show=\"showOverlay\" on-close=\"closeOverlay\" show-close-button=\"true\" enable-close-on-escape=\"true\" enable-mobile-interstitial=\"true\" override-default-container=\"true\">\n        <div class=\"logo\"></div>\n        <!-- Rate variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderRateInterstitial')}}</h3>\n            <div class=\"radioButton rate\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{content('currencyOptions.bfxConversionPayPalLabelRate')}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{content('currencyOptions.bfxConversionIssuerLabelRate')}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.continuetext')}}\n            </button>\n        </div>\n\n        <!-- Currency variation overlay template  -->\n        <div id=\"conversion-overlay\" content ng-if=\"!isConversionOverlayRateContent\">\n            <h3>{{content('currencyOptions.bfxConversionHeaderCurrency')}}</h3>\n            <div class=\"radioButton currency\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"paypal-conversion\" ng-value=\"true\"/>\n                <label for=\"paypal-conversion\" class=\"text-label left-label\">{{conversion.from_code}}</label>\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"conversion\" id=\"vendor-conversion\" ng-value=\"false\"/>\n                <label for=\"vendor-conversion\" class=\"text-label right-label\">{{conversion.to_code}}</label>\n            </div>\n            <div class=\"total-amount\" ng-if=\"models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionPayPalTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{payPalAmount}}</span>\n            </div>\n            <div class=\"total-amount\" ng-if=\"!models.ppconversion\">\n                <span>{{content('currencyOptions.bfxConversionIssuerTotal')}}</span>\n                <br>\n                <span class=\"amount\">{{cartAmount}}</span>\n            </div>\n            <div class=\"paypal-conversion-msg\" ng-if=\"models.ppconversion\">\n                <p class=\"conversion-rate\">\n                    <b>\n                        {{content('currencyOptions.bfxConversionPayPalRate') + ' '}}\n                        <span>{{content('paymentMethod.conversionRate', {currencyFrom: fromUnitCurrency, currencyTo: toTargetCurrency})}}</span>\n                    </b>\n                </p>\n                <p class=\"conversion-text\">{{content('currencyOptions.bfxConversionPayPalSpreadDisclosureMember')}}</p>\n            </div>\n            <div class=\"vendor-conversion-msg\" ng-if=\"!models.ppconversion\">\n                <p>{{content('currencyOptions.bfxConversionIssuerDisclosure')}}</p>\n            </div>\n            <button type=\"button\" class=\"btn full\" ng-click=\"actions.onSubmit()\">\n                {{content('common.payInCurrencyLabel', {currency: models.ppconversion ? conversion.from_code : conversion.to_code})}}\n            </button>\n        </div>\n    </xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-overlay/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.logCurrencyConversion = exports.mapConversionType = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var DEFAULT_LOGGING_OPTIONS = {
    from: 'CURRENCY_CONVERSION'
};

var mapConversionType = exports.mapConversionType = function mapConversionType(type) {
    return type ? 'PAYPAL' : 'VENDOR';
};

var logCurrencyConversion = exports.logCurrencyConversion = function logCurrencyConversion(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? 'currency_conversion' : _ref$name,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? {} : _ref$options;

    // ES lint does not support the spread operator syntax which throws parsing error on its encounter
    var logOptions = Object.assign({}, DEFAULT_LOGGING_OPTIONS, options);
    _logger.$logger.info(name, logOptions);
};
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CurrencyConversionFactory', function () {
    var showConversionOverlay = false; // Phase 2 flag that determines to show overlay or sidebar for currency conversion selection
    var showConversionOverlayRateContent = false; // Phase 2 flag that determines rate or currency variant for currency conversion overlay content

    /**
     * get content data for card issuer radio box container
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @param {Object} cartModel - $CheckoutCartModel model
     */
    var getCardIssuerData = function getCardIssuerData(checkoutSession, conversion, cart) {
        var plan = checkoutSession.plan;
        var isSplitBalance = plan.isSplitBalance();
        var showConvertIssuerSplitBalContent = false;
        var disclaimer = void 0;
        var label = void 0;

        if (isSplitBalance) {
            // if there is BALANCE source with the same "currency_code" as "cart total amount"
            // then we should NOT show Split balance content because Planning will not exclude this Balance from the plan after replan
            showConvertIssuerSplitBalContent = !plan.sources.some(function (source) {
                return source.get('type') === 'BALANCE' && source.get('amount.currency_code') === cart.get('purchase.amounts.total.currency_code');
            });
        }

        if (showConvertIssuerSplitBalContent) {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuerSplitBal');
            disclaimer = (0, _squid.$renderContent)('currencyOptions.issuerFinalAmountSplitBal', {
                amt: cart.get('purchase.amounts.total.amount_formatted_currency')
            });
        } else {
            label = (0, _squid.$renderContent)('currencyOptions.convertIssuer');
            disclaimer = '<b>' + (0, _squid.$renderContent)('currencyOptions.amount') + '</b> ' + (0, _squid.$renderContent)('currencyOptions.issuerFinalAmount');
        }

        return {
            label: label,
            disclaimer: disclaimer
        };
    };

    /**
     * Calculate conversion total only when:
     * 1. for PayPal rate
     * 2. there is only one plan source available (for multi source use cases, e.g Card + Balance we don't want to calc total for now)
     *
     * @param {Object} checkoutSession - $CheckoutSessionModel model
     * @param {Object} conversion - $CheckoutSessionModel conversion obj
     * @returns {String} Returns total formatted amount
     */
    var getPayPalConversionTotal = function getPayPalConversionTotal(checkoutSession, conversion) {
        var sources = checkoutSession.get('plan.sources');

        if (!conversion.paypal || sources && sources.length > 1) {
            return;
        }

        return checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
    };

    /**
     * @returns {Boolean} - Flag that confirms config enabled for overlay
     */
    var getConversionOverlayFlag = function getConversionOverlayFlag() {
        if ((0, _squid.$feature)('showConversionOverlay', false)) {
            showConversionOverlay = true;
        }

        return showConversionOverlay;
    };

    /**
     * Get the currency conversion overlay content flag to determinte to render right content
     * @returns {Boolean} - Flag that confirms PXP treatment to show currency conversion overlay
     */
    var isConversionOverlayRateContent = function isConversionOverlayRateContent() {
        return showConversionOverlayRateContent;
    };

    return {
        getCardIssuerData: getCardIssuerData,
        getPayPalConversionTotal: getPayPalConversionTotal,
        getConversionOverlayFlag: getConversionOverlayFlag,
        isConversionOverlayRateContent: isConversionOverlayRateContent
    };
});

_squid.$renderContent;

_squid.$feature;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/currency-conversion", "../node_modules/xo-wallet-components/src/currency-conversion/factory.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoFiLogos', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?'
        },
        controller: ['$scope', function ($scope) {
            (0, _squid.$populate)($scope, {
                cardTypes: _fi.$CardTypesModel.instance($scope.token + ':' + _squid.$locale.country, {
                    token: $scope.token,
                    country: _squid.$locale.country
                })
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_fi.$CardTypesModel;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-logos/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed track by $index\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThreeDsDdcDirective', {
    tag: 'xo-three-ds-ddc',
    template: _template2['default'],
    props: {
        jwt: {
            type: 'var',
            required: true
        },
        ddcUrl: {
            type: 'var',
            required: true
        },
        doneCallback: {
            type: 'var',
            required: true
        }
    },
    resolve: {
        experiments: function experiments() {
            return {
                ddcTreatment: (0, _squid.$elmo)('three_ds_ddc', { 'ctx.COUNTRY': _squid.$locale.country }, 'three_ds_ddc_trmt(.*)')
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            _squid.$config.cardinalcommerce = _squid.$config.cardinalcommerce || {};
        },
        populate: function populate() {
            var _this = this;

            var startTime = Date.now();

            var ddcCompleted = function ddcCompleted() {
                var elapsedMs = Date.now() - startTime;

                _logger.$logger.info('threeds_v2', {
                    from: '3DS_DDC',
                    to: '3DS_DDC_DONE',
                    duration: elapsedMs,
                    ddc_end_time: Date.now(),
                    context_id: _angular.$rootScope.token
                });

                _this.doneCallback();
            };

            function fireAndForget() {
                // no wait
                return ddcCompleted();
            }

            function waitDdcForFixedTime() {
                // Prioritize app config over hardcoded value for timeout
                (0, _angular.$timeout)(function () {
                    return ddcCompleted();
                }, _squid.$config.cardinalcommerce.ddcShortCircuitTime || 1000);
            }

            function waitDdcResponse() {
                window.addEventListener('message', function (event) {
                    // add ddcOrigin - "https://centinelapisbox.cardinalcommerce.com:50486/"" into app config.json
                    // This domain changes with every environment. This origin value will be the CentinelAPI domain
                    // event message sample
                    // {MessageType:  "profile.completed",   SessionId : "0_57f063fd-659a-4779-b45b-9e456fdb7935", Status: true}
                    _logger.$logger.info('3DS_DDC_MESSAGE_EVENT_LISTENER_TRIGGERED');
                    if (event.origin === _squid.$config.cardinalcommerce.ddcOrigin) {
                        var data = JSON.parse(event.data);

                        if (data !== undefined && data.Status) {
                            return ddcCompleted();
                        }
                    }
                }, false);
            }

            _logger.$logger.info('3DS_INIT_DDC_TRIGGERED');

            $('#threedsDdcIframeForm').submit();

            var ddcTreatmentName = this.experiments && this.experiments.ddcTreatment && this.experiments.ddcTreatment.treatment_name;

            if (!ddcTreatmentName) {
                // default
                _logger.$logger.info('3DS_DDC_FIRE_FORGET_EMPTY_TRMT');
                return fireAndForget();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt1') {
                _logger.$logger.info('3DS_DDC_TRMT1');
                return fireAndForget();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt2') {
                _logger.$logger.info('3DS_DDC_TRMT2');
                return waitDdcForFixedTime();
            }

            if (ddcTreatmentName === 'three_ds_ddc_trmt3') {
                _logger.$logger.info('3DS_DDC_TRMT3');
                return waitDdcResponse();
            }
        }
    },
    actions: {
        trustSrc: function trustSrc(url) {
            return _angular.$sce.trustAsResourceUrl(url);
        }
    }
});


_angular.$sce;

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$Component;

_squid.$elmo;

_squid.$locale;

_logger.$logger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"ddcUrl && jwt\">\n    <!-- this form uses iframe to post data because of target attribute -->\n    <form id=\"threedsDdcIframeForm\" name=\"threedsDdcIframeForm\" action=\"{{actions.trustSrc(ddcUrl)}}\" target=\"threedsDdcIframe\" method=\"post\">\n        <input type=\"hidden\" name=\"JWT\" value=\"{{jwt}}\" />\n    </form>\n    <!-- sandbox is appSec recommendation to grant limited permissions to cardinal -->\n    <iframe name=\"threedsDdcIframe\" height=\"1\" width=\"1\" style=\"display:none\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\">\n    </iframe>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/apis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.authenticate3DS = exports.initThreeds = exports.getJwt = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _index = __webpack_require__("../node_modules/xo-models/src/threeDS/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/switchPaymentsApiServ/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var getJwt = function getJwt(payload) {

    var threeDSJWTModel = new _index.$ThreeDSJWTModel(payload);

    return threeDSJWTModel.action('jwt', {
        // hide the loading spinner
        silent: true,
        data: threeDSJWTModel.serialize(),
        success: function success(result) {
            _logger.$logger.info('3DS_JWT_SUCCESS');
            return result;
        },
        validation: function validation() {
            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'JWT_SERVICE_VALIDATION_ERROR'
            });
        },
        error: function error() {
            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'JWT_SERVICE_ERROR'
            });
        }
    });
};

var initThreeds = function initThreeds(integrationType, fundingId, payload, callback) {
    var request = {
        data: payload,
        resultModel: {},
        success: function success(result) {
            callback(_constants.STATUS_SUCCESS, result);
        },
        error: function error(err) {
            _logger.$logger.warn('INIT_3DS_UKNOWN_ERROR', {
                reason: 'init 3ds unknown error',
                error: err
            });

            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'INIT_3DS_UNKNOW_ERROR'
            });

            callback(_constants.STATUS_API_ERROR, err);
        },
        contingencies: {
            DEFAULT: function DEFAULT(contingency) {
                _logger.$logger.warn('INIT_3DS_UKNOWN_CONTIGENCY', {
                    reason: 'init 3ds unknown contingency',
                    error: contingency
                });

                _logger.$logger.info('threeds_v2', {
                    context_id: _angular.$rootScope.token,
                    int_error_description: 'INIT_3DS_ERROR'
                });

                callback(_constants.STATUS_API_ERROR, contingency);
            }
        }
    };

    // hide the loading spinner
    request.silent = true;
    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        var cardConfirmationModel = new _index2.$CardConfirmationModel({ id: fundingId });

        delete request.data.fundingId;
        return cardConfirmationModel.save(request);
    } else {
        return _index3.$switch3DSLookUpModel.instance().save(request);
    }
};

var completeThreeds = function completeThreeds(integrationType, fundingId, request) {
    // hide the loading spinner
    request.silent = true;

    _logger.$logger.info('3DS_TRIGGER_AUTHENTICATE_CALL_' + integrationType + '_INTEGRATION');

    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        var cardConfirmationModel = new _index2.$CardConfirmationModel({ id: fundingId });

        return cardConfirmationModel.action('update', request);
    } else {
        return _index3.$switch3DSAuthenticateModel.instance().save(request);
    }
};

var authenticate3DS = function authenticate3DS(intType, request, onComplete, initThreedsResponse) {
    var fundingId = request.initThreedsData && request.initThreedsData.fundingId;

    return completeThreeds(intType, fundingId, {
        data: request,
        success: function success(response) {
            var status = _constants.RESPONSE_STATUS_MAPPER[response.status || response.threeDSStatus];
            var onCompleteData = {
                threeDSTransactionId: response.threeDSTransactionId,
                enrollmentStatus: response.enrollmentStatus,
                lookup: initThreedsResponse,
                threeDSStatus: response.threeDSStatus,
                threeDSEcommerceIndicator: response.threeDSEcommerceIndicator,
                signatureVerificationStatus: response.signatureVerificationStatus,
                cavv: response.cavv,
                liabilityShift: response.liabilityShift,
                threeDSVersion: response.threeDSVersion,
                threeDSUcafIndicator: response.threeDSUcafIndicator,
                authenticationThreeDSStatus: response.authenticationThreeDSStatus,
                threeDsAuthenticationReason: response.threeDsAuthenticationReason,
                cardBrandProcessed: response.cardBrandProcessed
            };

            _logger.$logger.info('3DS_AUTHENTICATE_API_SUCCESS');
            if (status === 'FAILED') {
                _logger.$logger.info('threeds_v2', {
                    context_id: _angular.$rootScope.token,
                    int_error_description: 'AUTHENTICATE_3DS_STATUS_DECLINE'
                });
            }
            // Send the status and response data with threeDSTransactionId as separate params, Similar to init api calls
            // what are all the possible status's retuned by Switch?
            // can we assume status is success when status is decline?
            onComplete(status === 'FAILED' ? _constants.STATUS_DECLINE : status, onCompleteData);
        },
        error: function error(err) {
            _logger.$logger.info('3DS_AUTHENTICATE_ERROR', err);
            _logger.$logger.info('threeds_v2', {
                context_id: _angular.$rootScope.token,
                int_error_description: 'AUTHENTICATE_3DS_ERROR'
            });
            onComplete(_constants.STATUS_API_ERROR);
        },
        contingencies: {
            DEFAULT: function DEFAULT(contingency) {
                _logger.$logger.info('threeds_addcard_update_confirmation_contingency', contingency);
                _logger.$logger.info('threeds_v2', {
                    context_id: _angular.$rootScope.token,
                    int_error_description: 'AUTHENTICATE_3DS_ERROR'
                });
                onComplete(_constants.STATUS_API_ERROR);
            }
        }
    });
};

exports.getJwt = getJwt;
exports.initThreeds = initThreeds;
exports.authenticate3DS = authenticate3DS;


_angular.$rootScope;

_index.$ThreeDSJWTModel;

_index2.$CardConfirmationModel;

_index3.$switch3DSLookUpModel;

_index3.$switch3DSAuthenticateModel;

_logger.$logger;

_constants.RESPONSE_STATUS_MAPPER;

_constants.ADD_CARD_INTEGRATION;

_constants.STATUS_API_ERROR;

_constants.STATUS_SUCCESS;

_constants.STATUS_DECLINE;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var ADD_CARD_INTEGRATION = 'ADD_CARD';
var TRANSACTION_INTEGRATION = 'TRANSACTION';
var INIT_3DS_RESPONSE_STATUS = ['FAILED', 'SUCCESS', 'CHALLENGE_REQUIRED', 'DECLINED'];

var RESPONSE_STATUS_MAPPER = {
    CHALLENGE_REQUIRED: 'STEPUP',
    FAILED: 'FAILED',
    SUCCESS: 'SUCCESS',
    DECLINED: 'FAILED',
    STEPUP: 'STEPUP'
};

var STATUS_SUCCESS = 'SUCCESS';
// API errors like 500, api not found etc.
var STATUS_API_ERROR = 'FAILURE';
// API responds with 200 but the status is set to FAILURE in response
var STATUS_DECLINE = 'DECLINE';

var CARD_TYPE_TO_NETWORK_LOGO = {
    AMEX: 'https://pics.paypal.com/00/p/NTk0ZGE4MTUtMzk5Ni00OTQ3LTlkMjctNjY5ZWY3MTBlYTEz/image_',
    VISA: 'https://pics.paypal.com/00/p/NmE4M2FmNWItODBlYi00MWIwLTgxODEtZDU3ZjAzZDI1NmJm/image_',
    MASTERCARD: 'https://pics.paypal.com/00/p/OGIxNWYzYzktMjEyMC00ZDBkLWE0YWUtOWQyMTRjNTM5ZTE2/image_'
};

var getWindowSizeMapping = function getWindowSizeMapping() {
    var returnObj = {};

    returnObj[ADD_CARD_INTEGRATION] = {
        MOBILE: '250X400',
        COMPUTER: '500X600',
        TABLET: '500X600',
        UNKNOWN: '500X600'
    };

    returnObj[TRANSACTION_INTEGRATION] = {
        MOBILE: '_250_x_400',
        COMPUTER: '_500_x_600',
        TABLET: '_500_x_600',
        UNKNOWN: '_500_x_600'
    };

    return returnObj;
};

var WINDOW_SIZE = getWindowSizeMapping();

exports.ADD_CARD_INTEGRATION = ADD_CARD_INTEGRATION;
exports.CARD_TYPE_TO_NETWORK_LOGO = CARD_TYPE_TO_NETWORK_LOGO;
exports.TRANSACTION_INTEGRATION = TRANSACTION_INTEGRATION;
exports.INIT_3DS_RESPONSE_STATUS = INIT_3DS_RESPONSE_STATUS;
exports.RESPONSE_STATUS_MAPPER = RESPONSE_STATUS_MAPPER;
exports.STATUS_API_ERROR = STATUS_API_ERROR;
exports.STATUS_SUCCESS = STATUS_SUCCESS;
exports.STATUS_DECLINE = STATUS_DECLINE;
exports.WINDOW_SIZE = WINDOW_SIZE;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/styles.less");

var _template = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/template.html");

var _template2 = _interopRequireDefault(_template);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");

var _outputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/outputMapper.js");

var _inputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/inputMapper.js");

var _apis = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/apis.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThreeDs', {
    tag: 'xo-three-ds',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        referenceId: {
            type: 'var',
            required: true
        },
        jwtInfo: {
            type: 'var',
            required: true
        },
        networkLogo: {
            type: 'var',
            required: true
        },
        cardBin: {
            type: 'var',
            required: true
        },
        ddcUrl: {
            type: 'var',
            required: true
        },
        // Default value is zero
        networkLogoSizeId: {
            type: 'var',
            required: false
        },
        integrationType: {
            type: 'var',
            required: false
        },
        initThreedsData: {
            type: 'var',
            required: false
        },
        onComplete: {
            type: 'var',
            required: false
        },
        cardBrand: {
            type: 'var',
            required: false
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.networkLogoSizeId = this.networkLogoSizeId || 0;
            this.challengeOn = false;
            this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)();

            this.networkLogo = this.networkLogo || {};

            // networkLogo information is available even before this
            // this directive render is triggered, so lets get it ready in enter fn
            var imageExtension = (this.networkLogo.original_mime_type || 'image/png').split('/')[1];

            // data validation
            if (!this.jwtInfo.jwtIssuer || !this.jwtInfo.jwtOrgUnitId) {
                _logger.$logger.error('3DS_JWTINFO_INVALID', this.jwtInfo);
                return this.onComplete(_constants.STATUS_API_ERROR);
            }

            // If network logo is missing in api response then load it from static urls
            if (!this.networkLogo.base_cdn_link_path) {
                _logger.$logger.info('3DS_NETWORK_LOGO_MISSING_IN_CONTINGENCY_DATA', {
                    cardBrand: this.cardBrand
                });
                this.networkLogo = {
                    base_cdn_link_path: _constants.CARD_TYPE_TO_NETWORK_LOGO[this.cardBrand] || ''
                };
            }

            _logger.$logger.info('3DS_NETWORK_LOGO_DISPLAY_PARAMS', {
                baseCdnLinkPath: this.networkLogo.base_cdn_link_path,
                imageExtension: imageExtension,
                networkLogoSizeId: this.networkLogoSizeId
            });

            this.networkLogoBackgroundStyle = {
                'background-image': 'url("' + this.networkLogo.base_cdn_link_path + this.networkLogoSizeId + '.' + imageExtension + '")'
            };
            this.showNetworkLogo = !!this.networkLogo.base_cdn_link_path;

            // Spinner messages
            var index = 0;
            var loadMessages = function loadMessages() {
                // keep the index to last message 'threeDS.preLoadCaution' so that after
                // cardinal iframe is hidden, we show a generic message to user
                if (index > 2) {
                    index = 2;
                    _angular.$interval.cancel(_this.loaderInterval);
                }
                _this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)(index);
                index++;
            };

            // loading spinner message changes every 3 seconds and then sticks to the last message
            this.loaderInterval = (0, _angular.$interval)(function () {
                loadMessages(index);
            }, 3000);

            // Setup a callback function on window object
            // This fn is called when cardinal returns to our app after successful OTP validation
            // cardinalToken is the ecToken we have in the url
            _angular.$window.completeThreedsFrame = function (cardinalResponse) {
                var cardinalTransactionId = void 0;

                // cardinalResponse.MD is also available which nothing but EC/WPS token
                cardinalTransactionId = cardinalResponse.TransactionId;
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_CHALLENGE',
                    to: '3DS_CHALLENGE_END',
                    challenge_end_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this.referenceId,
                    '3ds_authenticate_id': cardinalTransactionId
                });
                // call onComplete with failure status if transactionId is missing in
                // cardinal response before/after stepup iframe is shown to user
                // NOTE: if invalid data is passed to cardinal iframe, then cardinal
                // calls returnUrl without showing the OTP screen
                if (!cardinalTransactionId) {
                    _this.challengeOn = false;
                    _this.onComplete(_constants.STATUS_DECLINE);
                    // no need to call authenticate in case of failure
                    return;
                }

                _this.challengeOn = false;

                // FI Request
                var fiReq = {
                    token: _angular.$rootScope.token,
                    referenceId: _this.referenceId,
                    initThreedsData: _this.initThreedsData,
                    initThreedsResponse: _this.initThreedsResponse,
                    transactionId: cardinalTransactionId,
                    confirmationId: _this.initThreedsResponse.confirmationId,
                    confirmationStatus: 'CONFIRMED',
                    confirmationMethod: _this.initThreedsData.confirmationMethod,
                    cvv: _this.initThreedsData.cvv
                };
                // Switch Request
                var switchReq = {
                    threeDsServerTransactionId: cardinalTransactionId,
                    authenticatePayload: _this.lookUpPayload,
                    amount: _this.amount,
                    paymentAuthenticationRequest: _this.initThreedsResponse.payload,
                    productDetails: _this.initThreedsData.productDetails
                };

                var request = _this.integrationType === _constants.ADD_CARD_INTEGRATION ? fiReq : switchReq;

                (0, _apis.authenticate3DS)(_this.integrationType, request, _this.onComplete, _this.initThreedsResponse);
            };

            // watch for id "threedsIframeForm" to be present in dom to trigger
            // cardinal iframe display
            this.$watch(function () {
                return $('#threedsIframeForm').length;
            }, function (newVal) {
                if (_this.challengeOn && newVal === 1) {
                    $('#threedsIframeForm').submit();
                }
            });
        },
        populate: function populate() {
            var _this2 = this;

            // Show challenge iframe
            this.showChallengeIframe = function (stepupUrl, stepupJwt) {
                // set all variables required for challenge iframe
                _this2.stepupUrl = stepupUrl;
                _this2.stepupJwt = stepupJwt;

                _logger.$logger.info('CARDINAL_IFRAME_PARAMS');

                // render challenge page
                _this2.showNetworkLogo = false;
                _this2.challengeOn = true;
            };

            return (0, _apis.getJwt)({
                referenceId: this.referenceId,
                cardBin: this.cardBin,
                jwtInfo: this.jwtInfo
            }).then(function (result) {
                _logger.$logger.info('threeds_v2', {
                    from: '3DS_DDC',
                    to: '3DS_DDC_START',
                    ddc_start_time: Date.now(),
                    context_id: _angular.$rootScope.token,
                    '3ds_ref_id': _this2.referenceId
                });

                // set jwt and triggerDDC before showing the networkLogo modal window
                _this2.jwt = result;
                _this2.triggerDDC = true;
            })['catch'](function (err) {
                _logger.$logger.warn('3DS_GET_JWT_ERROR', { message: err.message, stack: err.stack });
                _this2.actions.ddcDoneCallback();
            });
        }
    },
    actions: {
        ddcDoneCallback: function ddcDoneCallback() {
            var request = (0, _inputMapper.get3DSLooksRequest)(this.integrationType, this.initThreedsData);
            // Need this variable to send in switch authenticate call

            this.lookUpPayload = request.lookUpPayload;
            this.amount = request.amount;

            _logger.$logger.info('threeds_v2', {
                from: '3DS_LOOKUP',
                to: '3DS_LOOKUP_START',
                lookup_start_time: Date.now(),
                context_id: _angular.$rootScope.token,
                '3ds_ref_id': this.referenceId
            });

            // upon completion, initThreedsCallback is called
            (0, _apis.initThreeds)(this.integrationType, this.initThreedsData.fundingId, request, this.actions.initThreedsCallback);
        },
        initThreedsCallback: function initThreedsCallback(status, response) {
            var _this3 = this;

            if (status === _constants.STATUS_API_ERROR) {
                _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK');
                _logger.$logger.flush(true);
                this.onComplete(_constants.STATUS_API_ERROR);
                return;
            }
            this.initThreedsResponse = (0, _outputMapper.initThreedsResponseMapper)(response, this.integrationType);
            // load the iframe when stepUpUrl and status is STEPUP
            if (this.initThreedsResponse.status === 'STEPUP' && this.initThreedsResponse.stepUpUrl) {
                var jwtreq = (0, _inputMapper.challengeJwtInputMapper)(this.referenceId, this.jwtInfo, this.initThreedsResponse);

                var stepUpUrl = this.initThreedsResponse.stepUpUrl;

                (0, _apis.getJwt)(jwtreq).then(function (jwtResponse) {
                    _logger.$logger.info('threeds_v2', {
                        from: '3DS_CHALLENGE',
                        to: '3DS_CHALLENGE_START',
                        challenge_start_time: Date.now(),
                        context_id: _angular.$rootScope.token,
                        '3ds_ref_id': _this3.referenceId
                    });
                    _logger.$logger.info('SHOW_IFRAME_STEPUP_URL_AND_JWT_CARDINAL_REQUEST', {
                        'stepupUrl': stepUpUrl,
                        'jwtResponse': jwtResponse
                    });
                    _logger.$logger.flush(true);
                    _this3.showChallengeIframe(stepUpUrl, jwtResponse);
                })['catch'](function (err) {
                    // todo: do we need to decline for getJwt call?
                    _logger.$logger.warn('GET_JWT_STEPUP_UNKNOWN_ERROR', {
                        reason: 'get jwt failed before loading stepupurl',
                        error: err
                    });
                    _this3.onComplete(_constants.STATUS_API_ERROR);
                });
            } else if (this.initThreedsResponse.status === 'SUCCESS') {
                _logger.$logger.info('INIT_3DS_STATUS_SUCCESS_NO_ACS_URL');
                var threedsResponse = {
                    threeDSTransactionId: this.initThreedsResponse.threeDSTransactionId,
                    lookup: this.initThreedsResponse
                };

                this.onComplete(_constants.STATUS_SUCCESS, threedsResponse);
            } else if (this.initThreedsResponse.status === 'FAILED') {
                _logger.$logger.info('INIT_3DS_STATUS_FAILED');
                this.onComplete(_constants.STATUS_DECLINE);
            } else {
                // all other cases
                delete response.cavv; // do not log cavv
                _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK', { response: response });
                this.onComplete(_constants.STATUS_API_ERROR);
            }
        },
        trustSrc: function trustSrc(url) {
            return _angular.$sce.trustAsResourceUrl(url);
        }
    }
});


_angular.$sce;

_angular.$window;

_angular.$interval;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_utils.getLoadingSpinnerMessageKey;

_outputMapper.initThreedsResponseMapper;

_inputMapper.get3DSLooksRequest;

_inputMapper.challengeJwtInputMapper;

_apis.getJwt;

_apis.initThreeds;

_apis.authenticate3DS;

_constants.ADD_CARD_INTEGRATION;

_constants.CARD_TYPE_TO_NETWORK_LOGO;

_constants.STATUS_API_ERROR;

_constants.STATUS_SUCCESS;

_constants.STATUS_DECLINE;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/inputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.challengeJwtInputMapper = exports.get3DSLooksRequest = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");

var get3DSLooksRequest = function get3DSLooksRequest(integrationType, payLoad) {

    if (integrationType === 'ADD_CARD') {
        var request = Object.assign({}, payLoad);

        delete request.fundingId;
        request.senderContext = (0, _utils.getSenderContext)();
        return request;
    }

    var browserInfo = (0, _utils.getBrowserDetails)(integrationType);

    var threeDSContingencySource = payLoad.threeDSContingencySource,
        threeDSContingencyReason = payLoad.threeDSContingencyReason,
        merchantCategoryCode = payLoad.merchant_category_code;


    var billingAddress = Object.assign({}, payLoad.billing_address);

    billingAddress.country = payLoad.billing_address.country_code;
    billingAddress.postalCode = payLoad.billing_address.postal_code;

    // xobuyernodeserv doesn't like these variables. since schema doesnt support them.
    delete billingAddress.country_code;
    delete billingAddress.postal_code;
    delete billingAddress.is_partial;

    var lookUpPayload = {
        threeDSReferenceId: payLoad.referenceId,
        flowId: 'HERMES',
        billingAddress: billingAddress,
        encryptedCardNumber: payLoad.number_encrypted,
        creditCardId: payLoad.creditCardId,
        cardUsage: payLoad.card_product_class,
        expirationMonth: payLoad.expire_month,
        expirationYear: payLoad.expire_year,
        cardTransactionCharacteristics: 'PRE_AUTH',
        threeDSContingencySource: threeDSContingencySource,
        threeDSContingencyReason: threeDSContingencyReason,
        merchantCategoryCode: merchantCategoryCode,
        unbrandedPaymentIndicator: payLoad.unbrandedPaymentIndicator
    };

    if (!billingAddress.country) {
        // don't send billingAddress without country
        delete lookUpPayload.billingAddress;
    }

    return {
        lookUpPayload: lookUpPayload,
        amount: payLoad.amount,
        browserInfo: browserInfo,
        productDetails: payLoad.productDetails,
        partnerDetails: payLoad.partnerDetails
    };
};

var challengeJwtInputMapper = function challengeJwtInputMapper(referenceId, jwtInfo, initThreedsResponse) {
    return {
        jwtInfo: jwtInfo,
        referenceId: referenceId,
        returnUrl: _angular.$window.location.origin + _squid.$config.urls.baseUrl + '/processThreedsConfirmation',
        redirectUrl: initThreedsResponse.redirectUrl,
        /**
         * for switch api call  we need to read the processor trace number and to get used in challenge jwt
         * for FI api we need to use transaction id, but transaction id is returned from both the apis
         * so look for processor trace number in response , if exists use that  if not go for transaction id
         * so that it will not break FI api call and switch api is also happy.
         */
        transactionId: initThreedsResponse.threeDsProcessorTraceNumber || initThreedsResponse.threeDSTransactionId,
        paymentAuthenticationRequest: initThreedsResponse.payload
    };
};

exports.get3DSLooksRequest = get3DSLooksRequest;
exports.challengeJwtInputMapper = challengeJwtInputMapper;


_squid.$config;

_angular.$window;

_utils.getSenderContext;

_utils.getBrowserDetails;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.initThreedsResponseMapper = undefined;

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var initThreedsResponseMapper = function initThreedsResponseMapper(response, integrationType) {
    // FI response mapper
    if (integrationType === _constants.ADD_CARD_INTEGRATION) {
        // possible response.status values - STEPUP FAILED SUCCESS
        return {
            status: _constants.RESPONSE_STATUS_MAPPER[response.status],
            redirectUrl: response.redirectUrl && response.redirectUrl.href, // acs is redirect url - which needs to be in jwt payload
            stepUpUrl: response.stepUpUrl && response.stepUpUrl.href, // redirect is step up which is used for loading iframe
            threeDSTransactionId: response.transactionId,
            payload: response.payload,
            confirmationId: response.confirmationId
        };
    }

    // switch response mapper
    if (_constants.INIT_3DS_RESPONSE_STATUS.indexOf(response.threeDSStatus) > -1) {
        return {
            status: _constants.RESPONSE_STATUS_MAPPER[response.threeDSStatus],
            redirectUrl: response.acsURL && response.acsURL.href, // acs is redirect url - which needs to be in jwt payload
            stepUpUrl: response.redirectURL && response.redirectURL.href, // redirect is step up which is used for loading iframe
            threeDSTransactionId: response.transactionId,
            payload: response.paymentAuthenticationRequest,
            confirmationId: response.threeDsServerTransactionId,
            threeDsProcessorTraceNumber: response.threeDsProcessorTraceNumber,
            liabilityShift: response.liabilityShift,
            signatureVerificationStatus: response.signatureVerificationStatus,
            cardBrandProcessed: response.cardBrandProcessed,
            threeDSEcommerceIndicator: response.threeDSEcommerceIndicator,
            threeDSUcafIndicator: response.threeDSUcafIndicator,
            cavv: response.cavv,
            enrollmentStatus: response.enrollmentStatus,
            authenticationThreeDSStatus: response.authenticationThreeDSStatus,
            threeDsAuthenticationReason: response.threeDsAuthenticationReason
        };
    }

    return {};
};

exports.initThreedsResponseMapper = initThreedsResponseMapper;


_constants.ADD_CARD_INTEGRATION;

_constants.INIT_3DS_RESPONSE_STATUS;

_constants.RESPONSE_STATUS_MAPPER;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"threeDSContainer\" content>\n    <div class=\"threeDSModalContainer\" id=\"iframeContainer\">\n        <div class=\"logo\"></div>\n        <div ng-class=\"{ 'showNetworkLogo': showNetworkLogo }\" ng-if=\"!challengeOn\">\n            <div class=\"staticSpinner\">\n                <div class=\"spinWrap\">\n                    <p class=\"spinnerImage\"></p>\n                    <p class=\"loader\"></p>\n                </div>\n                <p class=\"loadingMessage\">\n                    <span  ng-bind-html=\"htmlContent(spinnerMessageKey)\"></span>...\n                </p>\n            </div>\n            <div class=\"networkLogo\">\n                <span class=\"{{'sizeId_' + networkLogoSizeId}}\" ng-style=\"networkLogoBackgroundStyle\"></span>\n            </div>\n        </div>\n        <div class=\"cardinalIframeContainer\" ng-if=\"challengeOn\">\n            <h3 class=\"infoHeader\" ng-bind-html=\"htmlContent('threeDS.iFrameTitle')\"></h3>\n            <!-- this form uses iframe to post data because of target attribute -->\n            <form id=\"threedsIframeForm\" name=\"threedsIframeForm\" action=\"{{actions.trustSrc(stepupUrl)}}\" target=\"threedsIframeV2\" method=\"post\">\n                <input type=\"hidden\" name=\"JWT\" value=\"{{stepupJwt}}\" />\n                <input type=\"hidden\" name=\"MD\" value=\"{{token}}\" />\n            </form>\n            <!-- sandbox is appSec recommendation to grant limited permissions to cardinal -->\n            <iframe id=\"threedsIframeV2\" name=\"threedsIframeV2\" frameborder=\"0\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\"></iframe>\n        </div>\n    </div>\n    <xo-three-ds-ddc\n        ng-if=\"triggerDDC\"\n        jwt=\"jwt\"\n        ddc-url=\"ddcUrl\"\n        done-callback=\"actions.ddcDoneCallback\">\n    </xo-three-ds-ddc>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getLoadingSpinnerMessageKey = exports.getBrowserDetails = exports.getSenderContext = undefined;

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var getPaymentMode = function getPaymentMode(capabilities) {
    var mode = 'UNKNOWN';

    if (capabilities.isDesktop) {
        mode = 'COMPUTER';
    } else if (capabilities.isTablet) {
        mode = 'TABLET';
    } else if (capabilities.isMobile) {
        mode = 'MOBILE';
    }
    return mode;
};

var getBrowserDetails = function getBrowserDetails() {
    var integrationType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.ADD_CARD_INTEGRATION;

    var paymentMode = getPaymentMode(_index.$DeviceInfo.getCapabilities());
    var windowSize = void 0;

    // TODO: revisit this code once cardinal fix their code to make sure
    // the iframe content is responsive
    // Mobile - for all mobile devices hardcode size to smallest one
    // Desktop - hardcode size to 500x600 as our modal window is 560x600
    // NOTE: with cardinal fix, mobile will be FULL_PAGE and
    //       other devices will be 500x600
    windowSize = _constants.WINDOW_SIZE[integrationType] && _constants.WINDOW_SIZE[integrationType][paymentMode];

    _logger.$logger.info('3DS_V2_WINDOW_SIZE_' + windowSize);

    return {
        windowSize: windowSize || 'FULL_PAGE',
        javaEnabled: window.navigator && window.navigator.javaEnabled(),
        language: window.navigator && window.navigator.language && angular.isString(window.navigator.language) && window.navigator.language.split('-')[0],
        colorDepth: window.screen && window.screen.colorDepth,
        screenHeight: window.innerHeight,
        screenWidth: window.innerWidth,
        timeZoneOffset: new Date().getTimezoneOffset()
    };
};

var getSenderContext = function getSenderContext() {
    var senderContext = {
        browserDetails: getBrowserDetails(),
        paymentMode: getPaymentMode(_index.$DeviceInfo.getCapabilities()),
        deviceChannel: 'BROWSER'
    };

    return senderContext;
};

var getLoadingSpinnerMessageKey = function getLoadingSpinnerMessageKey(index) {
    var messageKeys = ['threeDS.preLoadContactIssuer', 'threeDS.preLoadWaitMessage', 'threeDS.preLoadCaution'];

    // if index === 0 then the default return statement
    // returns messageKeys[0]
    if (index && index > 0 && index < messageKeys.length) {
        return messageKeys[index];
    }

    return messageKeys[0];
};

exports.getSenderContext = getSenderContext;
exports.getBrowserDetails = getBrowserDetails;
exports.getLoadingSpinnerMessageKey = getLoadingSpinnerMessageKey;


_index.$DeviceInfo;

_constants.ADD_CARD_INTEGRATION;

_constants.WINDOW_SIZE;

_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-webpack-config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

// array
__webpack_require__("../node_modules/core-js/fn/array/find.js");
__webpack_require__("../node_modules/core-js/fn/array/includes.js");

// string
__webpack_require__("../node_modules/core-js/fn/string/includes.js");


// object
__webpack_require__("../node_modules/core-js/fn/object/entries.js");
__webpack_require__("../node_modules/core-js/fn/object/values.js");
__webpack_require__("../node_modules/core-js/fn/object/assign.js");




/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {



var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

var _route = __webpack_require__("./pages/xo-checkout/route.js");

var _route2 = _interopRequireDefault(_route);

__webpack_require__("./css/app.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_logger.$logger.info('app_bootstrap', {
    hash: window.location.hash
});

var xoCheckoutRoute = new _route2['default']();

xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);

window.bootstrap = true;

_logger.$logger;

_middleware.$Middleware;

/***/ }),

/***/ "./js/bootstrap.js":
/***/ (function(module, exports, __webpack_require__) {



var _constants = __webpack_require__("./js/lib/constants.js");

// set public path for chunks on the fly
// more details - https://webpack.js.org/guides/public-path/#on-the-fly
// without it - webpack doesn't know how to resolve path for assets stored in webpack -> output (.build/js)
// in development: staticUrl will be /webapps/hermes/static in case of Hermes
// in production: staticUrl will be pointing to CDN, e.g https://www.paypalobjects.com/web/res/6e6/9af00bdfc93477f08ba3fe44e9589
__webpack_require__.p = window.meta.staticUrl + '/'; // eslint-disable-line no-undef


window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
// http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', '$compileProvider', function ($locationProvider, $compileProvider) {
    $locationProvider.hashPrefix('');

    // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1767
    // If you want to debug an application with angular related information in
    // production environemnt, simply open up your console, and type `angular.reloadWithDebugInfo()`
    // and waits for your current page to reload
    if (true) {
        $compileProvider.debugInfoEnabled(false);
    }
    $compileProvider.aHrefSanitizationWhitelist(_constants.constants.regex.protocolsWithDeeplink);
    $compileProvider.cssClassDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1892
    $compileProvider.commentDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1863
}]);

if (!window.prefetch) {
    window.beacon('info', ['angular_bootstrap_start']);
    angular.bootstrap(document.getElementById('angular_app_container'), ['app']);
    window.beacon('info', ['angular_bootstrap_end']);
    if (window.appPerformanceEvents) {
        // TimeToFrameworkEnd: The moment client has finished bootstrapping framework.
        window.appPerformanceEvents.TimeToFrameworkEnd = parseInt(window.performance.now(), 10);
        window.beacon('info', ['APP_PERFORMANCE_EVENTS'], window.appPerformanceEvents);
    }
    __webpack_require__("./js/app.js");
}

_constants.constants;

/***/ }),

/***/ "./js/lib/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var constants = exports.constants = {
    regex: {
        safeProtocols: '^\s*(https?|s?ftp|mailto|tel|file):',
        protocolsWithDeeplink: '^\s*(https?|s?ftp|mailto|tel|file|com\.[a-z]+(\.[a-z]+)*):'
    }
};

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$contingencyHandler', function () {
    function showGenericError(code) {
        return function () {
            var encoded = code ? window.btoa(code) : code;
            // initiate a treatment only when code is PAYER_CANNOT_PAY
            // need to set within here so elmo function can handle async results
            if (code === 'PAYER_CANNOT_PAY') {
                (0, _squid.$elmo)('xo_hermesnodeweb_restrictions_page', {}, 'Trmt_xo_hermesnodeweb_restrictions_page_treatment').then(function (result) {
                    var resultCode = void 0;
                    // we pass PAYER_CANNOT_MAKE_PAYMENT in place of PAYER_CANNOT_PAY for treatment group
                    if (result && result.treatment_name) {
                        resultCode = window.btoa('PAYER_CANNOT_MAKE_PAYMENT');
                    } else {
                        resultCode = encoded;
                    }
                    _uiRouter.$state.go('checkout.genericError', {
                        code: resultCode
                    });
                });
            } else {
                _uiRouter.$state.go('checkout.genericError', {
                    code: encoded
                });
            }
        };
    }

    function route(path) {
        return function () {
            _uiRouter.$state.go(path, { message: arguments[0] });
        };
    }

    function forbidden(err) {
        throw new _squid.$Forbidden(err);
    }

    function fallback(product) {
        return function (err) {
            throw new _squid.$FallbackError({
                reason: err,
                product: product
            });
        };
    }

    function addMissingTokens(urlQuery) {
        var payload = {
            'token': _angular.$rootScope.token || _squid.$meta.token
        };

        if (_squid.$meta.baToken) {
            payload.ba_token = _squid.$meta.baToken;
        }
        return _squid.$util.queryStringSplice(urlQuery, payload);
    }

    function handleStepupAuth(code, authModel, step_up_context) {
        authModel.stepupAuthRequired = true;
        var areCookiesDisabled = !_squid.$util.cookiesEnabled();

        var reasons = {
            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
        };

        // if stepup context from planning
        if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
            // just a log statement
            if (authModel.remembered) {
                _logger.$logger.debug('PLANNING_STEP_UP_REMEMBERED_USER');
            } else {
                _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER');
            }

            var authChallengeNodeUrl = void 0;
            var authParams = {
                stepupContext: step_up_context,
                stsReturnUrl: _squid.$config.ulMeta.stsReturnUrl,
                returnUri: _squid.$config.ulMeta.authChallengeReturnUri + addMissingTokens(_angular.$window.location.search) + '&atoSuccess',
                locale: _squid.$locale.lang,
                flowId: 'xo',
                flowContext: 'funding'
            };

            // if cookies are disabled, we'll redirect to /hermes/stepup along with cookies and step up parameters and
            // internally redirect to ANW
            if (areCookiesDisabled) {
                _logger.$logger.info('STEP_UP_COOKIES_DISABLED');

                var xcookies = JSON.stringify(_squid.$meta.headers['x-cookies']);

                authChallengeNodeUrl = _squid.$config.urls.stepUpAuth;
                authParams.acnw_dep = 'xo';

                // since cookies are disabled, we'll encode them as part of the query params for memcookies to handle
                authParams.meta = JSON.stringify({
                    'x-cookies': xcookies,
                    'x-cookies-hash': _squid.$meta.headers['x-cookies-hash']
                });

                authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, authParams);

                _squid.$util.redirect(authChallengeNodeUrl);
                return;
            }

            // app config to control the auth flow redirection
            // migrate from authchallengenodeweb to authnodeweb
            if (_squid.$config.migrateAuthFlowToANW) {
                _logger.$logger.debug('AUTHFLOW_REDIRECTION_TO_ANW');
                authChallengeNodeUrl = _squid.$config.urls.authNodeWebUrl;
                // need to send one additional param for ANW migration used to ramp at auth app level
                authParams.acnw_dep = 'xo';
            } else {
                _logger.$logger.debug('AUTHFLOW_REDIRECTION_TO_ACNW');
                authChallengeNodeUrl = _squid.$config.urls.authChallengeNodeWebUrl;
            }

            authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, authParams);

            if (authChallengeNodeUrl) {
                _squid.$util.redirect(authChallengeNodeUrl);
            }
        } else {
            _logger.$logger.debug('PLANNING_STEP_UP_WITHOUT_CONTEXT');
            throw new _squid.$FallbackError({
                reason: reasons[code],
                product: 'ux'
            });
        }
    }

    return function (contingency) {
        // Leave a footprint here. The subsequent state where log how it goes..
        _logger.$logger.warn('contingency_handler', contingency);

        return contingency.handle({
            // Route
            ECONSENT_REQUIRED: route('checkout.econsent'),
            TRAVEL_RULE_ID_REQUIRED: route('checkout.travelRule'),
            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
            ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
            EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
            PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
            SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
            TAX_ID_REQUIRED: route('checkout.addTaxId'),
            NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),

            NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),

            PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
                });
            },

            // Generic Error Pages
            RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
            PAYER_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
            PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
            PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
            DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
            PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
            PAYEE_ACCOUNT_RESTRICTED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
            EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
            PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
            TRANSACTION_RECEIVING_LIMIT_EXCEEDED: showGenericError('PAYER_CANNOT_PAY'),
            PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
            PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
            PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
            PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
            GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
            COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
            DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
            INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
            NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
            ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
            BAD_RESPONSE: showGenericError('DEFAULT'),
            TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
            RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
            UNSUPPORTED_COUNTRY: showGenericError('UNSUPPORTED_COUNTRY'),
            AGREEMENT_ALREADY_CREATED: showGenericError('AGREEMENT_ALREADY_CREATED'),
            PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
            PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
            WALLET_PREFERENCE_SET_ERROR: showGenericError('DEFAULT'),
            ISSUANCE_PIN_SERVICE_ERROR: showGenericError('DEFAULT'),
            SENDING_LIMIT_EXCEEDED: showGenericError('SENDING_LIMIT_EXCEEDED'),
            PAYEE_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            UNSUPPORTED_PAYEE_CURRENCY: showGenericError('UNSUPPORTED_PAYEE_CURRENCY'),
            PAYMENT_CANNOT_BE_INITIATED: showGenericError('DEFAULT'),
            PERMISSION_DENIED: showGenericError('DEFAULT'),
            INVALID_TOKEN: showGenericError('DEFAULT'),
            INVALID_FUNDING_OPTION: showGenericError('DEFAULT'),
            VALIDATION_ERROR: showGenericError('DEFAULT'),
            SHIPPING_ADDRESS_INVALID: showGenericError('DEFAULT'),
            INVALID_ARGUMENT: showGenericError('DEFAULT'),
            CREDIT_PAYMENT_NOT_ALLOWED: showGenericError('DEFAULT'),
            MALFORMED_REQUEST: showGenericError('DEFAULT'),
            TWOFA_INACTIVE: showGenericError('DEFAULT'),
            ERROR: showGenericError('DEFAULT'),
            ISSUER_DECLINE: showGenericError('DEFAULT'),
            UNSUPPORTED_CUP_SECURECARD: showGenericError('DEFAULT'),
            STUDENT_ACCOUNT: showGenericError('STUDENT_ACCOUNT'),
            UAL_ISSUANCE_UPDATE_SCOPE_ERROR: showGenericError('DEFAULT'),
            // Forbidden
            BUYER_NOT_SET: forbidden,

            // Other
            TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'TRANSACTION_REFUSED'
                    });
                }

                // always go to generic error page, even if logout fails
                _index.$AuthModel.instance().logout()['finally'](showGenericError('TRANSACTION_REFUSED'));
            },

            PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
                // Payer is not same payer checkout session was created for.
                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go('checkout.login', {}, {
                        reload: true
                    });
                });
            },

            CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
                _index.$AuthModel.instance().meta.selfPay = true;
                _angular.$rootScope.contingency = {};
                _angular.$rootScope.contingency.message = 'CANNOT_PAY_SELF';

                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go(_uiRouter.$state.current, {}, {
                        reload: true
                    });
                });
            },

            VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'VERIFY_USER_IDENTITY'
                    });
                }

                return handleStepupAuth('VERIFY_USER_IDENTITY', _index.$AuthModel.instance(), data.step_up_context);
            },

            LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
                }

                return fallback('ux');
            },

            DEFAULT: function logUnhandledContingency() {
                _logger.$logger.warn('ui_unhandled_contingency_' + this.message);
                throw new _squid.$FallbackError({
                    reason: 'unhandled_contingency',
                    product: 'ux'
                });
            }
        });
    };
});

_uiRouter.$state;

_logger.$logger;

_squid.$config;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$locale;

_squid.$meta;

_squid.$util;

_squid.$elmo;

_integration.$integration;

_miniBrowser.$miniBrowser;

_index.$AuthModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ }),

/***/ "./js/lib/cplIntegration.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

try {
    var token = window.meta.token;

    _angular.$q.all([_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve()]).then(function (_ref) {
        var appData = _ref[0],
            cart = _ref[1];

        if (appData.is_wps_flow()) {
            window.fptiProductOverride = 'wps';
        } else if (cart.isBilling()) {
            window.fptiProductOverride = 'billing';
        }
    })['catch'](function (e) {
        console.error(e);
    });
} catch (e) {
    console.error(e);
}

_angular.$q;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fallback = __webpack_require__("./js/lib/fallback.js");

var _contingency = __webpack_require__("./js/lib/contingency.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

// ui-router rejects $state.go promises if the navigation is cancelled.
var uiRouterTransitionErrors = ['transition prevented', 'transition aborted', 'transition superseded'];

function canBeSafelyIgnored(err) {
    return err instanceof _squid.$ShortCircuit || uiRouterTransitionErrors.includes(err.message);
}

function constructEventName(toState, fromState) {
    var from = fromState.name.replace(/\./g, '_') || 'start';
    var to = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + from + '_to_' + to;
}

function constructErrorPayload(_ref) {
    var err = _ref.err,
        message = _ref.message,
        cause = _ref.cause;

    var payload = {
        error: err.stack || err.toString(),
        message: message || err.message,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: window.location.toString()
    };

    angular.extend(payload, err.payload || {});

    return payload;
}

function $forbiddenHandler(err) {
    _logger.$logger.warn('forbidden_handler');
    if (!err.transient) {
        _index.$AuthModel.instance().invalidate();

        if (_angular.$rootScope.paymentComplete) {
            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
        }

        _uiRouter.$state.go('checkout.login');
    }
}

function handleThirdPartyErrors(err, cause) {
    var errType = (err && err.constructor && err.constructor.name || 'error').toLowerCase();
    var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
    var errName = 'ui_' + experience.toLowerCase() + '_' + errType;
    var payload = constructErrorPayload({ err: err, cause: cause });

    _logger.$logger.error(errName, payload);
    _index.$AuthModel.instance().logout();
    _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience();

    if (experience === 'VENMO_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { venmoError: true });
    }

    if (experience === 'BAIDU_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { baiduError: true });
    }
}

function isThirdPartyFlow() {
    return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
}

var ERROR_HANDLERS = [{
    type: _squid.$FallbackError,
    handler: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Contingency,
    handler: _contingency.$contingencyHandler
}, {
    type: _squid.$Forbidden,
    handler: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {
    if (canBeSafelyIgnored(err)) {
        if (err.message) {
            _logger.$logger.info(err.message);
        }
        return true;
    }

    if (_angular.$rootScope.ERROR_STATE) {
        if (_angular.$rootScope.ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    if (isThirdPartyFlow()) {
        if (err instanceof _squid.$Forbidden) {
            // forbidden errors should take you to login page
            return $forbiddenHandler(err);
        } else {
            return handleThirdPartyErrors(err, cause);
        }
    }

    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
        if (err instanceof errorHandler.type) {
            errorHandler.handler(err);

            return true;
        }
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        _angular.$rootScope.ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/)) {
        errName = 'ui_unhandled_' + errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    if (err.transient) {
        errName += '_transient';
    }

    var payload = constructErrorPayload({ err: err, message: errMsg, cause: cause });

    _logger.$logger.error(errName, payload);
    _logger.$logger.error('build_' + _squid.$meta.buildId + '_' + errName, payload); // release vs live traffic separation

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        err: err,
        route: (_uiRouter.$state || {}).current,
        message: payload.error,
        code: payload.cause
    });

    if (event.defaultPrevented) {
        _angular.$rootScope.ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});

_angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        unique: true
    });
});

angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_index.$AuthModel;

_squid.$util;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$ShortCircuit;

_squid.$Contingency;

_squid.$meta;

_fallback.$fallbackErrorHandler;

_contingency.$contingencyHandler;

_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _icFallback = __webpack_require__("./js/lib/icFallback.js");

var _integration = __webpack_require__("./js/lib/integration.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function () {
    return function (err) {
        var reason = err && err.reason;
        var entry_point = err && err.entryPoint;
        var params = err && err.params;
        var model = {};
        var product = err && err.product;
        var isWpsSubscription = void 0;
        var isWpsInstallmentPlan = void 0;

        function getFallbackUrl(urlParams, waType) {
            if (_angular.$rootScope.wps || _angular.$rootScope.invoice) {
                return (0, _squid.$populate)(model, {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = _squid.$config.urls.fallbackUrl['buyNow'];

                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
                        base = _squid.$config.urls.fallbackUrl['cartUpload'];
                    }

                    if (model.checkoutAppData.flags.is_invoice_flow) {
                        urlParams.id = model.checkoutAppData.invoice_id;
                        base = _squid.$config.urls.fallbackUrl['invoice'];
                    }

                    if (isWpsSubscription) {
                        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                    }

                    if (isWpsInstallmentPlan) {
                        base = _squid.$config.urls.fallbackUrl['wpsInstallmentPlan'];
                    }

                    return _squid.$util.paypalURL(base, urlParams);
                });
            } else {
                return _angular.$q.when().then(function () {
                    var base = _squid.$config.urls.fallbackUrl[product];

                    return _squid.$util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if (_angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;

            code = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: code
            });
        }

        function handleFallbackRedirect(url, wpsParams) {
            if (!_squid.$config.fallbackEnabled && !entry_point) {
                return _logger.$log.warn('Fallback inhibited by config', url);
            }

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _logger.$log.warn('Fallback inhibited in local mode.', url);
            }

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point,
                error_desc: reason,
                from: _angular.$rootScope.currentState || 'fallback',
                to: product ? 'process_fallback_' + product : 'process_fallback'
            });

            _logger.$logger.info('fallback_reason_' + reason, {
                reason: reason
            });
            _logger.$logger.info('build_' + _squid.$meta.buildId + '_fallback_reason_' + reason); // release vs live traffic separation

            if (window.xchild) {
                if (window.opener) {
                    return (0, _icFallback.$incontextFallback)(window, url);
                }

                return _uiRouter.$state.go('checkout.framebust', { action: 'fallback', url: url });
            }

            _angular.$rootScope.$emit('loading');

            if (product === 'ux') {
                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return _angular.$rootScope.wps && !_angular.$rootScope.invoice ? _util.$ReturnToMerchant.postTo(url, wpsParams) : _util.$ReturnToMerchant.goTo(url);
            }

            // Safe to always return to Aries
            return _squid.$util.redirect(url);
        }

        function doFallback() {
            _squid.$util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: _squid.$meta.token,
                fallback: 1,
                reason: reason,
                landing: entry_point,
                useraction: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).useraction()
            });

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;

            if (_angular.$rootScope.wps) {
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                _logger.$logger.info('wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
                _logger.$logger.info('build_' + _squid.$meta.buildId + '_wps_fallback_reason_' + reason); // release vs live traffic separation
            }

            var waType = wpsParams && wpsParams.wa_type;

            return getFallbackUrl(urlParams, waType).then(function (url) {
                // Fallback whitelist error reason in config to determine if we should fallback or instead redirect to generic error page.
                var fallbackWhitelist = _squid.$config.fallbackWhitelist;
                var whitelist = fallbackWhitelist && fallbackWhitelist.whitelisted || [];

                // if error reason not in fallback whitelist, try auto-retry
                if (whitelist && whitelist.indexOf(reason) === -1) {
                    var AUTORELOAD_LIMIT = 1; // can be increased later
                    // get auto reload count from params - if present
                    var autoReloadCount = parseInt(_squid.$util.param('arc'), 10);

                    // if falsy (NaN or 0)...
                    if (!autoReloadCount) {
                        // start at zero
                        autoReloadCount = 0;
                    }
                    // if we haven't reloaded _enough_ yet...
                    if (autoReloadCount < AUTORELOAD_LIMIT) {
                        // bump count
                        autoReloadCount++;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': 'restart_hermes_app',
                            'int_error_code': reason
                        });

                        // pass params, so url is augmented
                        _squid.$util.replace({ arc: autoReloadCount });
                    } else {
                        // If auto reload didn't fix the error - redirect to error page with retry option
                        var RETRY_KEY = 'retry_page_shown';
                        var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                        var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                        var destination = 'RETRY';
                        var transition_name = 'show_retry_page';

                        // Reset if there's an invalid value for timesSeen for some reason
                        if (!timesSeen || timesSeen < 0) {
                            timesSeen = 0;
                        }

                        // Only try to go to retry page if we're within retry attempts
                        if (timesSeen < RETRY_PAGE_LIMIT) {
                            timesSeen++;
                            sessionStorage.setItem(RETRY_KEY, timesSeen);
                        } else {
                            destination = 'DEFAULT';
                            transition_name = 'show_error_page';
                        }

                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': transition_name,
                            'enable_refresh_prompt': reason,
                            'int_error_code': reason
                        });
                        return showGenericErrorPage(destination);
                    }
                } else {
                    _logger.$logger.info('fallback_reason_whitelisted', {
                        reason: reason,
                        product: product
                    });
                    handleFallbackRedirect(url, wpsParams);
                }
            });
        }

        if (product === 'error') {
            _logger.$logger.error(reason, {
                url: window.location.href
            });

            var _$config$urls = _squid.$config.urls,
                baseUrl = _$config$urls.baseUrl,
                errorUrl = _$config$urls.errorUrl;


            return _squid.$util.redirect(baseUrl + errorUrl);
        }

        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = _squid.$meta.baToken && beamPattern.test(_squid.$meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test(_squid.$meta.token);

        if (cartExchangeFailed) {
            product = 'ux';
        }

        // For Beam Integration - always show generic Error when cart exchange fails.
        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
            return showGenericErrorPage();
        }

        return (0, _squid.$populate)(model, {
            checkoutCart: _index.$CheckoutCartModel.instance(_squid.$meta.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
        }).then(function () {
            isWpsSubscription = model.checkoutAppData.is_wps_subscription_flow();
            isWpsInstallmentPlan = model.checkoutAppData.is_wps_installmentplan_flow();
            var merchantCountry = model.checkoutAppData.merchant.merchant_country;
            var isSecondButtonTxn = model.checkoutAppData.is_second_button_txn;

            // No fallback for Tokenized_Wallet usecases
            if (model.checkoutCart.isWalletTokenization()) {
                return showGenericErrorPage();
            }

            // No fallback for DE second button transactions
            if (merchantCountry === 'DE' && isSecondButtonTxn) {
                return showGenericErrorPage();
            }

            // Do not fallback if appdata flag dictates no fallback
            if (model.checkoutAppData.flags.disable_legacy_fallback) {
                _logger.$logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            }

            // V.zero - fallback resize before do actual fallback
            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // default do fallback (not actually fallback) - check doFallback() to understand it better
            return doFallback();
        })['catch'](showGenericErrorPage);
    };
});

_uiRouter.$state;

_logger.$log;

_logger.$logger;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$ReturnToMerchant;

_icFallback.$incontextFallback;

_integration.$integration;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ }),

/***/ "./js/lib/icFallback.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$incontextFallback = $incontextFallback;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

function $incontextFallback(win, url) {
    _angular.$rootScope.$emit('loading');
    window.onbeforeunload = function () {};
    window.onunload = function () {};

    var parent = window.opener || window.parent;

    if (!window.xprops || !window.xprops.fallback) {
        parent.location = url;
        win.close();
        return;
    }

    try {
        var frame = void 0;

        try {
            if (typeof parent.onLegacyFallback === 'function') {
                frame = parent;
            }
        } catch (err) {
            // pass
        }

        if (!frame) {
            for (var i = 0, ii = parent.frames.length; i < ii; i++) {
                try {
                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
                        frame = parent.frames[i];
                        break;
                    }
                } catch (err) {
                    // pass
                }
            }
        }

        if (!frame) {
            parent.location = url;
            win.close();
            return;
        }

        frame.onLegacyFallback(win);

        window.addEventListener('unload', function () {
            var width = 970;
            var height = 900;
            var left = void 0;
            var top = void 0;

            if (window.outerWidth) {
                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
            } else if (window.screen.width) {
                left = Math.round((window.screen.width - width) / 2);
                top = Math.round((window.screen.height - height) / 2);
            }

            window.resizeTo(width, height);
            window.moveTo(left, top);
        });

        win.location = url;
    } catch (err) {
        parent.location = url;
        win.close();
    }

    window.xprops.fallback(url);
}

angular.value("$incontextFallback", $incontextFallback);
_angular.$rootScope;

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _error = __webpack_require__("./js/lib/error.js");

Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _error[key];
    }
  });
});

var _fallback = __webpack_require__("./js/lib/fallback.js");

Object.keys(_fallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fallback[key];
    }
  });
});

var _contingency = __webpack_require__("./js/lib/contingency.js");

Object.keys(_contingency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contingency[key];
    }
  });
});

var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");

Object.keys(_metaBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _metaBuilder[key];
    }
  });
});

var _middleware = __webpack_require__("./js/lib/middleware.js");

Object.keys(_middleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _middleware[key];
    }
  });
});

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

Object.keys(_miniBrowser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _miniBrowser[key];
    }
  });
});

var _security = __webpack_require__("./js/lib/security.js");

Object.keys(_security).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _security[key];
    }
  });
});

var _stateChangeListener = __webpack_require__("./js/lib/stateChangeListener.js");

Object.keys(_stateChangeListener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _stateChangeListener[key];
    }
  });
});

var _cplIntegration = __webpack_require__("./js/lib/cplIntegration.js");

Object.keys(_cplIntegration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cplIntegration[key];
    }
  });
});

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {

    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Incontext lightbox flow
    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',

    // Incontext popup flow
    INCONTEXT_POPUP: 'INCONTEXT_POPUP',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',

    // Messenger Integration flow
    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION',

    // WPS flow
    WPS: 'WPS',

    // WPS Subscription flow
    WPS_SUBSCRIPTION: 'WPS_SUBSCRIPTION',

    // WPS Autobilling flow
    WPS_AUTOBILLING: 'WPS_AUTOBILLING',

    //  WPS INSTALLMENTPLAN
    WPS_INSTALLMENTPLAN: 'WPS_INSTALLMENTPLAN'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,
    ALLOW_PAYER_ID_RETURN_PARAM: true,
    DONE_PAGE: false,
    FALLBACK: true,
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.PARTNER] = {

    FALLBACK: false,
    REDIRECT_TOP: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {

    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {

    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.WPS] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: true,
    ERROR_AFTER_PAYMENT: true,
    POPULATE_MERCHANT_PREFERENCES: true,
    RETURN_METHOD_BASED_ON_MERCHANT_PREFS: true,
    RETURN_URL_FROM_MERCHANT_PREFS: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: true
}, _$DEFAULT[$FLOWS.WPS_SUBSCRIPTION] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT[$FLOWS.WPS_AUTOBILLING] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT[$FLOWS.WPS_INSTALLMENTPLAN] = {
    ALLOW_PAYER_ID_RETURN_PARAM: false,
    DONE_PAGE: false,
    ERROR_AFTER_PAYMENT: true,
    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
    SHOW_SHIPPING_METHOD: false
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {

    CAN_FRAMEBUST: false,
    CAN_FALLBACK_TO_POPUP: false,
    CAN_CLOSE_SELF: false

}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE[$FLOWS.PARTNER] = {
    REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {

    ALLOW_AUTH: false,
    ALLOW_COLLECT_DATA: false,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false,

    RETURN_FROM_DATA_COLLECTION_POPUP: false,

    REDIRECT_TOP: false

}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {

    IS_MESSENGER_BA_INTEGRATION: true

}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    CAN_FALLBACK_TO_POPUP: false,
    POST_MESSAGE_PARENT: false
}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false
}, _$integration$init));

angular.value("$FLOWS", $FLOWS);
_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$metaBuilder = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function buildMeta() {
    return {
        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
        calc: _model.$CalDataModel.getCalCorrId(),
        csci: _model.$CalDataModel.getUUID(),
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        },
        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
        app_name: 'hermesnodeweb',
        baToken: _squid.$meta.baToken
    };
}

function buildContext() {
    return {
        locale: {
            country: _squid.$locale && _squid.$locale.country,
            language: _squid.$locale && _squid.$locale.lang
        }
    };
}

_squid.$Api.registerMetaBuilder(buildMeta);

var $metaBuilder = exports.$metaBuilder = {
    build: buildMeta,
    buildContext: buildContext
};

angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;

_model.$CalDataModel;

_squid.$util;

_squid.$meta;

_squid.$Api;

_squid.$locale;

_squid.$config;

/***/ }),

/***/ "./js/lib/metadata.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getClientMetadataID = getClientMetadataID;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function getClientMetadataID(defaultID) {
    if (window.xprops && window.xprops.clientMetadataID) {
        return window.xprops.clientMetadataID;
    } else if (_squid.$util.param('client-metadata-id')) {
        return _squid.$util.param('client-metadata-id');
    } else {
        return defaultID;
    }
}

_squid.$util;

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _constants = __webpack_require__("./js/lib/constants.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("./js/lib/stateChangeListener.js");

var _metadata = __webpack_require__("./js/lib/metadata.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var getDeviceAndNetworkInfo = function getDeviceAndNetworkInfo() {
    var netInfo = navigator && navigator.connection || {};
    var memory = navigator && navigator.deviceMemory;
    return {
        type: netInfo.type, // Network type that browser uses
        effectiveType: netInfo.effectiveType, // 2g, 3g, wifi , etc
        downlink: netInfo.downlink, // Effective bandwidth estimate
        downlinkMax: netInfo.downlinkMax, // Upper bound on the downlink speed of the first network hop
        roundTripTime: netInfo.rtt, // Effective round-trip time estimate
        saveData: netInfo.saveData, // user has requested a reduced data usage mode,
        memory: memory // .5= 512Mib, 1=1024Mib, ...
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$Middleware', function () {
    return [function angularDebug() {
        window.root = _angular.$rootScope;
        window.injector = _angular2['default'].element(document.body).injector();

        /**
         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
         * Bug described here: https://github.com/angular/angular.js/issues/10083
         *
         * Can remove as a config option if this is a stable change
         */
        if (_squid.$config.safeApply) {
            _logger.$logger.info('overwriting_angular_apply');
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(_angular.$rootScope);

            if (!proto) {
                _logger.$logger.warn('overwriting_angular_apply_failed', {
                    reason: 'failed_to_get_prototype'
                });
            } else {
                var originalApply = proto.$apply;
                // If this gets used so many times, something is probably wrong so use original apply instead
                var skipAttempts = 10;

                proto.$apply = function (fn) {
                    if (skipAttempts && (_angular.$rootScope.$$phase === '$digest' || _angular.$rootScope.$$phase === '$apply')) {
                        skipAttempts--;

                        _logger.$logger.warn('inprog_error_skipped', {
                            stack: new Error().stack
                        });

                        this.$eval(fn);
                    } else {
                        originalApply.call(this, fn);
                    }
                };
            }
        }
    }, function waitForToken() {
        if (_squid.$util.isIFrame() && !_squid.$util.param('token') && !_squid.$meta.token) {
            return (0, _angular.$q)(function (resolve, reject) {
                _logger.$logger.info('await_token');

                window.addEventListener('message', function (event) {
                    var message = JSON.parse(event.data);

                    if (message.operation !== 'pass_token') {
                        return;
                    }

                    var token = message.token;

                    _logger.$logger.info('passed_token', { token: token });
                    _squid.$meta.token = token;

                    var $preloadApi = new _squid.$Api({ uri: 'preload' });

                    $preloadApi.retrieve({
                        params: { token: token }
                    }).then(function (response) {
                        $preloadApi.setTransientCache(response.data);
                        resolve();
                    })['catch'](reject);
                }, false);
            });
        }
    }, function checkToken() {
        var pattern = /^EC-[0-9A-Z]{17}$/;
        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        // wps token are not preceeded with 'EC-'
        var wpsPattern = /^[0-9A-Z]{17}$/;
        var urlToken = (_squid.$util.param('token') || '').trim().slice(0, 20);
        var bodyToken = (_squid.$meta.token || '').trim().slice(0, 20);

        if (pattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
        } else if (pattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
        } else if (wpsPattern.test(urlToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = urlToken;
        } else if (wpsPattern.test(bodyToken)) {
            _logger.$logger.info('isWpsPattern');
            _angular.$rootScope.token = bodyToken;
        } else if (beamPattern.test(urlToken)) {
            _angular.$rootScope.token = urlToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else if (beamPattern.test(bodyToken)) {
            _angular.$rootScope.token = bodyToken;
            _logger.$logger.info('cart_exchange_failed', {
                token: _angular.$rootScope.token
            });
        } else {
            return _angular.$q.reject(new _squid.$FallbackError({
                reason: 'no_token',
                product: 'error'
            }));
        }
    },

    // Hermes does not handle paylater buttons; if one gets to this point on the client-side, we want treat it as a credit second button
    // Replace window.xprops.fundingSource with 'credit' so that the rest of the client-side treats it as a credit second button transaction
    function remapPaylaterButtonToCredit() {
        if (window.xprops && window.xprops.fundingSource === 'paylater') {
            window.xprops.originFundingSource = 'paylater';
            window.xprops.fundingSource = 'credit';
        }
    }, function resolveLocale() {
        var models = {};

        return (0, _squid.$populate)(models, {
            appData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            cart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token)
        })['finally'](function () {
            return _squid.$locale.retrieve({
                params: {
                    ipCountry: _squid.$meta.ipcountry,
                    localeTestUrlParam: _squid.$util.param('locale.test'),
                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
                    merchantCountry: models.appData.get('merchant.merchant_country'),
                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
                    countryParam: _squid.$util.param('country.x'),
                    localeParam: _squid.$util.param('locale.x')
                }
            });
        });
    }, function fraudentInit() {
        return _fn.$fn.init();
    }, function setupIntegration() {
        return _miniBrowser.$miniBrowser.init(_angular.$rootScope.token);
    }, function frameBust() {

        if (!_integration.$integration.getConfig('CAN_FRAMEBUST')) {
            return;
        }

        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return;
        }

        return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
    }, function tokenExchange() {

        _logger.$logger.info('tokenExchange', {
            allow_onetouch_token_exchange: _integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE'),
            isPartnerIntegration: _angular.$rootScope.isPartnerIntegration,
            isIFrame: _squid.$util.isIFrame()
        });

        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
            return;
        }

        if (_angular.$rootScope.isPartnerIntegration || !_squid.$util.isIFrame()) {
            return;
        }

        var auth = _index2.$AuthModel.instance();

        return auth.retrieve().then(function () {

            _logger.$logger.info('tokenExchange_auth', {
                logged_in: auth.logged_in,
                remembered: auth.remembered,
                refresh_token: auth.refresh_token,
                isOneTouchRequired: auth.logged_in || auth.remembered || !auth.refresh_token
            });

            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
                return;
            }

            return auth.action('onetouch');
        });
    }, function xcomponent() {
        if (window.xchild) {
            window.paypalCheckout = window.xchild;
        }

        if (window.xprops && window.xprops.init) {
            return _angular.$q.all([_index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
                var checkoutAppData = _ref[0],
                    checkoutPayee = _ref[1];

                return window.xprops.init({
                    paymentToken: _angular.$rootScope.token,
                    merchantID: checkoutPayee.merchant.id,
                    cancelUrl: checkoutAppData.urls.cancel_url
                });
            });
        }
    }, function xcomponentAuth() {
        if (window.xprops && window.xprops.onAuth) {
            var auth = _index2.$AuthModel.instance();

            return auth.retrieve().then(function () {
                if (auth.access_token && (auth.logged_in || auth.remembered)) {
                    return window.xprops.onAuth({
                        accessToken: auth.access_token
                    });
                }
            });
        }
    }, function logPage() {
        _logger.$logger.info('featureConfigTestValue-' + _squid.$meta.featureConfigTestValue);
        _logger.$logger.info('href', {
            href: window.location.href,
            windowName: _angular.$window.name && _angular.$window.name.slice(0, 100)
        });

        var match = document.cookie.toString().match(/ectoken=([^;]+)/);

        if (match && match[1] === _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_same_token');
        } else if (match && match[1] !== _angular.$rootScope.token) {
            _logger.$logger.info('returning_user_diff_token');
        } else {
            _logger.$logger.info('non_returning_user');
        }

        document.cookie = 'ectoken=' + _angular.$rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';

        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
            var navigationType = {
                0: 'regular',
                1: 'reload',
                2: 'back_forward'
            }[window.performance.navigation.type];

            if (navigationType) {
                _logger.$logger.info('navigation_' + navigationType);
            }
        }
    }, function handleTagManager() {
        // ****** Tag Manager Code Start Here ***********
        window.dataLayer = {
            // Two letter country code of the current page's content
            contentCountry: _squid.$locale.country.toLowerCase(),
            // Two letter locale
            contentLanguage: _squid.$locale.lang.toLowerCase()
        };

        var tagManagerUrl = _squid.$config.urls.tagProdUrl;

        // Based on the environment, Tag Manager end point can be changed.
        // For now the local and stage end points are same.
        if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
            tagManagerUrl = _squid.$config.urls.tagStageUrl;
        }

        // Load bootstrap.js asynchronously
        (function (i, s, o, g, r, a, m) {
            i['tagManagerObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            };
            i[r].l = 1 * new Date();
            a = s.createElement(o);
            m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', tagManagerUrl, 'tagManager');
    }, function logoutGuest() {
        var appData = _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token);

        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            // For DE 2nd button transactions, guest accounts are allowed on return flow
            if (appData.get('merchant.merchant_country') === 'DE' && (appData.get('is_second_button_txn') || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit')) {
                if (_credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey()) {
                    return;
                } else {
                    return auth.action('logout');
                }
            }

            // if venmo transaction, we'll log the buyer back in by sending them back to the venmo app
            if (_thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token)) {
                _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience(); // removing token from experience flag
                _logger.$logger.info('venmo_login_retry');
            }

            if (auth.guest) {
                _logger.$logger.info('guest_logout');
                return auth.logoutAndRedirect('guest_logout');
            }
        });
    }, function checkProcessorDecline() {
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            if (appData.flags.processor_declined) {
                _logger.$logger.info('processor_decline_transaction');
                var authModel = _index2.$AuthModel.instance();

                if (authModel.auth_state === 'IDENTIFIED' && !_squid.$util.param('redirectToHermes')) {
                    // guest
                    return (0, _squid.$dispatch)('xoon', {
                        token: _angular.$rootScope.token,
                        hermesXoonRedirect: true
                    }, {
                        fromState: 'checkout_init',
                        toState: 'guest',
                        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
                        'country.x': _squid.$locale.country
                    });
                }

                return;
            }
        });
    }, function logStart() {
        var networkAndDeviceData = getDeviceAndNetworkInfo();

        return _squid.$promise.hash({
            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration(_angular.$rootScope.token),
            isIframe: _miniBrowser.$miniBrowser.isFramed()
        }).then(function (flags) {
            var app_int_type = _index.$DeviceInfo.getAppIntegrationType();

            _logger.$logger.info('app_start_design', {
                'from': 'client_middleware',
                'to': 'process_app_start_design',
                is_directintegration: flags.isDirectIntegration ? 1 : 0,
                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
                app_int_type: app_int_type,
                'screen_width': _angular.$window.innerWidth,
                'screen_height': _angular.$window.innerHeight,
                'device_memory': networkAndDeviceData.memory,
                'network_type': networkAndDeviceData.type,
                'network_effectiveType': networkAndDeviceData.effectiveType,
                'network_downlink': networkAndDeviceData.downlink,
                'network_downlinkMax': networkAndDeviceData.downlinkMax,
                'network_roundTripTime': networkAndDeviceData.roundTripTime,
                'network_saveData': networkAndDeviceData.saveData
            });
        });
    }, function logPerformance() {
        if (window.enablePerformance) {
            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
            var timing = {};

            _angular2['default'].forEach(keys, function (key) {
                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
            });

            var offset = timing.connectEnd - timing.navigationStart;

            if (timing.connectEnd && window.clientStartTime) {
                _angular2['default'].forEach(timing, function (time, name) {
                    if (time && _angular2['default'].isNumber(time)) {
                        _logger.$logger.info('timing_' + name, {
                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
                            req_elapsed: time - timing.connectEnd
                        });
                    }
                });
            }

            _logger.$logger.info('timing', timing);

            if (window.performance.memory) {
                _logger.$logger.info('memory', window.performance.memory);
            }

            if (window.performance.navigation) {
                _logger.$logger.info('navigation', window.performance.navigation);
            }

            if (window.performance.getEntries) {
                var logged = [];
                var logResources = function logResources() {
                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
                        if (!resource || !resource.name) {
                            return;
                        }

                        if (logged.indexOf(resource.name) === -1) {
                            logged.push(resource.name);
                        } else {
                            return;
                        }

                        if (resource.initiatorType) {
                            _logger.$logger.info(resource.initiatorType, resource);
                        }
                    });
                };

                logResources();
                setInterval(logResources, 500);
            }

            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
                _logger.$logger.info('js_init', {
                    client_elapsed: 0,
                    req_elapsed: window.clientStartTime - offset
                });
            }
        } else {
            _logger.$logger.info('no_performance_data');
        }
    }, function logAuthState() {
        return _index2.$AuthModel.instance().retrieve().then(function (auth) {
            if (auth.logged_in) {
                _logger.$logger.info('user_logged_in');
            } else if (auth.remembered) {
                _logger.$logger.info('user_remembered');
            } else {
                _logger.$logger.info('user_not_logged_in');
            }
        });
    },

    // check for access token in the hash.
    function checkAccessToken() {
        if (window.xprops && window.xprops.accessToken) {
            return window.xprops.accessToken().then(function (accessToken) {
                _squid.$Api.addHeader('x-paypal-internal-euat', accessToken);
                return _index2.$AuthModel.instance().reload();
            });
        }

        var euat = _squid.$util.param('euat');

        if (euat) {
            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;

            if (accessToken) {
                _logger.$logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
                    access_token: accessToken
                });

                /* if (euat === '1') {
                    window.location.hash = '';
                } */

                var authModel = _index2.$AuthModel.instance();

                authModel.access_token = accessToken;

                if (window.xprops && window.xprops.onAuth) {
                    window.xprops.onAuth({ accessToken: accessToken });
                }
            }
        }
    },

    // check for FraudNet for Mobile View
    function enableFraudNetForMobileWebView() {
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.info('force_fraudnet_for_mobile_webview');
            _angular.$window.enableFraudNetForMobileWebView = true;
        }
    },

    // Logs if service workers are enabled
    function isServiceWorkerSupported() {
        if ('serviceWorker' in navigator) {
            _logger.$logger.info('service_worker_supported');
        } else {
            _logger.$logger.info('service_worker_not_supported');
        }
    }, function forceCookiesDisabled() {
        if (_index.$DeviceInfo.isApp()) {
            return _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve().then(function (payee) {
                if (~_squid.$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
                    _logger.$logger.info('force_cookies_disabled');
                    _squid.$Api.forceCookiesDisabled = true;
                }
            });
        }
    }, function checkFramed() {
        if (_squid.$util.isIFrame()) {
            // Set this as "framed" mode (X icon, escape hatch, etc.)
            document.documentElement.className += ' framed';
        }
    }, function loginViaEuat() {
        // log in user via euat prior to rendering login screen.
        if (_squid.$util.param('euat') === '1') {
            var auth = _index2.$AuthModel.instance();

            if (auth.accessToken() && !auth.loggedIn()) {
                return auth.reload({
                    headers: {
                        'x-paypal-internal-euat': auth.accessToken()
                    },
                    resultModel: auth,
                    success: function success() {
                        return delete auth.access_token;
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            }
        }
    }, function checkForSDK() {
        var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');

        var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();

        if (isSDKintegration && !sdkLoaded) {
            throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
        }
    }, function setFraudnetID() {
        _angular.$rootScope.fraudNetId = (0, _metadata.getClientMetadataID)(_angular.$rootScope.fraudNetId);
    }, function urlFormatCheck() {
        // To verify the kind of urls being used for cancel and return.
        // Deeplink and universal urls have potential to affect integration
        // we need to log the use cases to keep track.
        return _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
            var urls = appData.urls || {};
            // 'regular' being false implies we have a non-standard format.
            var regular = new RegExp(_constants.constants.regex.safeProtocols, 'g');
            // 'modifed' is to check whether our new regex can catch all use cases.
            var modifed = new RegExp(_constants.constants.regex.protocolsWithDeeplink, 'g');
            _logger.$logger.info('url_pattern_test', {
                cancel_url: {
                    regular: regular.test(urls.cancel_url),
                    modifed: modifed.test(urls.cancel_url)
                },
                return_url: {
                    regular: regular.test(urls.return_url),
                    modifed: modifed.test(urls.return_url)
                }
            });
        });
    }];
});

_logger.$logger;

_integration.$integration;

_miniBrowser.$miniBrowser;

_constants.constants;

_squid.$Api;

_squid.$Class;

_squid.$config;

_squid.$dispatch;

_squid.$FallbackError;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$promise;

_squid.$util;

_index.$DeviceInfo;

_fn.$fn;

_index2.$AuthModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutCartModel;

_index3.$CheckoutPayeeModel;

_credit.$CreditDataModel;

_thirdPartyInfo.thirdPartyExperience;

_metadata.getClientMetadataID;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$miniBrowser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _error = __webpack_require__("./js/lib/error.js");

var _$stateGo = _uiRouter.$state.go;

var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
    var name = _ref.name,
        _ref$logName = _ref.logName,
        logName = _ref$logName === undefined ? '' : _ref$logName;

    _logger.$logger.error('state_not_found' + logName, {
        name: name,
        hash: window.location.hash
    });
    throw new Error('state_not_found' + logName + ': ' + name);
};

_uiRouter.$state.go = function (name, params) {
    var _this = this,
        _arguments = arguments;

    var stateObj = _uiRouter.$state.get(name);

    var stateGo = function stateGo(state) {
        if (!window.xchild) {
            return _$stateGo.apply(_this, _arguments);
        }

        if (!state.loginRequired) {
            return _$stateGo.apply(_this, _arguments);
        }

        // If we're allowed to collect data in this integration, we don't need this functionality
        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return _$stateGo.apply(_this, _arguments);
        }

        var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

        if (forceIframe) {
            return _$stateGo.apply(_this, _arguments);
        }

        // First check our integration supports falling back to a popup
        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
            throw _integration.$integration.error('Can not fallback to popup for data collection');
        }

        window.xchild.hide();

        var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
        var xprops = _extends({}, window.xprops);

        xprops.url = url;

        window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops)['catch'](function (err) {

            if (window.ppxo.PopupOpenError && err instanceof window.ppxo.PopupOpenError) {
                window.xchild.show();

                _logger.$logger.warn('framebust_from_' + name.replace(/[^a-zA-Z0-9]+/g, '_'));

                return _$stateGo.call(_this, 'checkout.framebust', { action: 'open', url: url });
            }

            (0, _error.$exceptionHandler)(err);
        });
    };

    if (stateObj) {
        return stateGo(stateObj);
    } else if (_squid.$meta.codeSplitting) {
        // in case of code split - attempt to load route and then change the state
        return (0, _squid.lazyLoadRoute)(name, params, false)['catch'](function () {
            logStateNotFoundAndThrow({ name: name, logName: '_lazy_loading' });
        }).then(function () {
            stateObj = _uiRouter.$state.get(name);
            return stateGo(stateObj);
        });
    } else {
        logStateNotFoundAndThrow({ name: name });
    }
};

var $miniBrowser = exports.$miniBrowser = {
    flags: {},
    config: {},
    isMiniBrowser: function isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
    },
    isFramed: function isFramed() {
        return _squid.$util.isIFrame();
    },
    getPartnerIntegration: function getPartnerIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
                return true;
            }
            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
                return Boolean(cart.partnerIntegration);
            });
        });
    },
    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('native_xo') === '1') {
                return true;
            }
            return false;
        });
    },
    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
        return _squid.$promise.call(function () {
            if (window.xprops && window.xprops.experience && window.xprops.experience.messenger) {
                _logger.$logger.info('getMessengerBAIntegration == true');
                return true;
            }
            return false;
        });
    },
    getDirectIntegration: function getDirectIntegration(token) {
        return _squid.$promise.call(function () {
            if (_squid.$util.param('incontext')) {
                return true;
            }

            if (this.isMiniBrowser() || this.isFramed()) {
                return true;
            }

            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
                return true;
            }

            return this.getPartnerIntegration(token);
        }.bind(this));
    },
    getWPSIntegration: function getWPSIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            var isWPS = appData.is_wps_flow();

            // TODO: remove these, we should not use $rootScope
            _angular.$rootScope.invoice = appData.flags.is_invoice_flow;
            _angular.$rootScope.wps = isWPS;

            if (isWPS) {
                _logger.$logger.info('hermes_wps_flow', {
                    token: _angular.$rootScope.token
                });
            } else {
                _logger.$logger.info('hermes_xo_order_flow', {
                    token: _angular.$rootScope.token
                });
            }
            return isWPS;
        });
    },

    getWpsSubscriptionIntegration: function getWpsSubscriptionIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_subscription_flow();
        });
    },

    getWpsAutobillingIntegration: function getWpsAutobillingIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.isWpsAutobillingFlow();
        });
    },

    getWpsInstallmentPlanIntegration: function getWpsInstallmentPlanIntegration(token) {
        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
            return appData.is_wps_installmentplan_flow();
        });
    },

    getFlags: function getFlags(token) {
        _logger.$logger.info('miniBrowser_getFlags');
        return _squid.$promise.hash({
            isMiniBrowser: this.isMiniBrowser(),
            isFramed: this.isFramed(),
            isPartnerIntegration: this.getPartnerIntegration(token),
            isDirectIntegration: this.getDirectIntegration(token),
            isNativeCheckout: this.getNativeCheckoutIntegration(token),
            isMessengerBAIntegration: this.getMessengerBAIntegration(token),
            isWPSIntegration: this.getWPSIntegration(token),
            isWpsSubscription: this.getWpsSubscriptionIntegration(token),
            isWpsAutobilling: this.getWpsAutobillingIntegration(token),
            isWpsInstallmentPlan: this.getWpsInstallmentPlanIntegration(token)
        }).then(function (flags) {

            // TODO: Remove these, we should not use $rootScope
            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;

            if (flags.isPartnerIntegration && !window.xchild) {
                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            } else if (flags.isFramed) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
                if (flags.isMessengerBAIntegration) {
                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
                }
            } else if (flags.isMiniBrowser) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
            } else if (flags.isNativeCheckout) {
                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            } else if (flags.isWpsSubscription) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_SUBSCRIPTION);
            } else if (flags.isWpsAutobilling) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_AUTOBILLING);
            } else if (flags.isWpsInstallmentPlan) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS_INSTALLMENTPLAN);
            } else if (flags.isWPSIntegration) {
                _integration.$integration.setFlow(_integration.$FLOWS.WPS);
            } else {
                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
            }

            return flags;
        });
    },
    init: function init(token) {
        var _this2 = this;

        _logger.$logger.info('miniBrowser_init');
        return _squid.$promise.sequential([function () {
            return _this2.enableAutoResize();
        }, function () {
            return _this2.getFlags(token);
        }, function () {
            return _this2.logIntegration(token);
        }, function () {
            return _this2.sendPostMessage(token);
        }, function () {
            return _this2.handleWindowOpenerClose();
        }]);
    },
    enableAutoResize: function enableAutoResize() {
        _angular.$rootScope.$on('allLoaded', function () {
            if (window.xchild && window.xchild.enableAutoResize) {
                window.xchild.enableAutoResize();
            }
        });
    },
    logIntegration: function logIntegration(token) {
        _logger.$logger.info('miniBrowser_logIntegration');
        return this.getFlags(token).then(function (flags) {
            var match = window.name.match(/PPFrame(\w+)/);
            var guid = match && match[1];

            if (guid) {
                _logger.$logger.info('integration_guid', {
                    guid: guid
                });
            }

            if (window.xchild || guid) {
                var beacon = new Image();

                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.xprops ? window.xprops.uid : guid) + '&token=' + token;
            }

            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
        });
    },

    handleWindowOpenerClose: function handleWindowOpenerClose() {
        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
            var interval = setInterval(function () {
                try {
                    if (!window.opener || window.opener.closed) {
                        clearInterval(interval);
                        _logger.$logger.info('window_opener_closed');
                        // TODO: close this window if opener closed?
                    }
                } catch (err) {
                    // pass
                }
            }, 50);
        }
    },

    sendPostMessage: function sendPostMessage(token) {
        if (window.xchild) {
            return;
        }

        return _squid.$promise.hash({
            isPartnerIntegration: this.getPartnerIntegration(token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function (data) {
            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
                return;
            }

            var msg = void 0;

            try {
                msg = {
                    operation: 'init',
                    cancelUrl: data.checkoutAppData.urls.cancel_url,
                    landingUrl: window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (err) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', {
                    error: err
                });
            }

            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }
        });
    },
    frameBust: function frameBust(token) {
        return _squid.$promise.hash({
            isFramed: this.isFramed()
        }).then(function (flags) {
            if (!flags.isFramed) {
                return;
            }

            var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();

            if (forceIframe) {
                return;
            }

            if (window.xchild) {
                _logger.$logger.info('frame_bust_xchild');
                _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
            } else {
                _logger.$logger.info('frame_bust');
                _squid.$util.redirect(window.location.href, { frameBust: true });
            }
        });
    }
};

angular.value("$miniBrowser", $miniBrowser);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$promise;

_squid.$util;

_squid.$locale;

_squid.$meta;

_squid.lazyLoadRoute;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_util.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_integration.$CONTEXT;

_error.$exceptionHandler;

/***/ }),

/***/ "./js/lib/security.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    var errorCount = 0;

    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var auth = _index.$AuthModel.instance();

        if (toState.auth !== false && !auth.logged_in) {
            errorCount += 1;
            if (errorCount === 10) {
                _logger.$logger.error('max_state_requires_auth');
            }
            if (errorCount >= 10) {
                return;
            }
            _logger.$logger.warn('state_requires_auth', {
                stateName: toState.name
            });
            event.preventDefault();
            throw new _squid.$Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
        }
    });

    (0, _angular.$interval)(function () {
        var auth = _index.$AuthModel.instance();

        if (auth.logged_in) {
            // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper) and prevent user to be logged out
            // instead we should show error page
            if (auth.disallow_login_switch) {
                _uiRouter.$state.go('checkout.genericError', {
                    code: 'DEFAULT_TOKENIZED_WALLET_ERROR'
                });
                return;
            }

            auth.reload({ silent: true }).then(function () {
                if (_uiRouter.$state.current.auth !== false && !auth.logged_in) {
                    errorCount += 1;
                    if (errorCount === 10) {
                        _logger.$logger.error('max_state_requires_auth');
                    }
                    if (errorCount >= 10) {
                        return;
                    }
                    _logger.$logger.info('idle_timeout');
                    _logger.$logger.warn('state_requires_auth', {
                        stateName: _uiRouter.$state.current.name
                    });
                    errorCount += 1;
                    throw new _squid.$Forbidden();
                }
            });
        }
    }, 30 * 60 * 1000);

    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_uiRouter.$state;

_squid.$Forbidden;

_squid.$util;

_logger.$logger;

_index.$AuthModel;

/***/ }),

/***/ "./js/lib/stateChangeListener.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    // Decorate the current state with the transition params
    _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        _uiRouter.$state.toState = toState;
        _uiRouter.$state.toParams = toParams;
        _uiRouter.$state.fromState = fromState;
        _uiRouter.$state.fromParams = fromParams;
    });
});

_uiRouter.$state;

/***/ }),

/***/ "./pages/services/balance/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceEligibilityFactory', ['$rootScope', '$q', function ($rootScope, $q) {
    var state = {
        eligibility: null
    };
    var get = function get() {
        _logger.$logger.info('$BalanceEligibilityFactory_get');
        return state;
    };
    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Promise<Object>} Returns the current $BalanceEligibilityFactory state
     */
    var init = function init() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$checkoutSession = _ref.checkoutSession,
            checkoutSession = _ref$checkoutSession === undefined ? _checkout.$CheckoutSessionModel.instance($rootScope.token) : _ref$checkoutSession;

        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
        var hasBalanceInstrument = disallowedInstruments.length && disallowedInstruments.find(function (fi) {
            return fi.declineReason === 'CIP_INCOMPLETE' && fi.type === 'BALANCE';
        });
        if (hasBalanceInstrument) {
            var currentState = get();
            currentState.eligibility = false;
        }
        _logger.$logger.info('$BalanceEligibilityFactory_init', get());
        return $q.resolve(get());
    };
    // Expose public $BalanceEligibilityFactory APIs
    return {
        get: get,
        init: init
    };
}]);

_logger.$logger;

_checkout.$CheckoutSessionModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/balance", "pages/services/balance/index.js"))

/***/ }),

/***/ "./pages/services/cardart-instrument/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");

/**
 * $CardartInstrument is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 *
 * Currently, $CardardInstrument is being used at:
 * - xo-review
 * - xo-select-fi
 * - xo-sidebar-manage-wallet
 * - xo-wallet
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$CardArtInstrument', function () {
    var CARD = 'CARD';
    var BALANCE = 'BALANCE';
    var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

    var isCardArtEnable = function isCardArtEnable(fiMeta) {
        return fiMeta && fiMeta.cardArtEnabled();
    };

    /**
     * @param {Ojbect} instrument A future payment instrument
     * @returns {Object}
     */
    var normalizeFutureInstrument = function normalizeFutureInstrument(instrument) {
        return {
            id: instrument.instrument_id,
            type: instrument.type,
            cardArtUrl: wallet.getCardArt(instrument)
        };
    };

    /**
     * @param {Object} options
     * @param {Object} otpions.primaryFs A primaryFs funding options
     * @returns {Object}
     */
    var normalizeFundingOptions = function normalizeFundingOptions(_ref) {
        var primaryFs = _ref.primaryFs;

        if (!primaryFs) {
            return {};
        }

        return {
            id: primaryFs.id,
            type: primaryFs.type,
            cardArtUrl: wallet.getCardArt(primaryFs)
        };
    };

    /**
     * @typedef {Object} FI
     * @property {String} fi_id
     * @property {String} fi_type
     * @property {String} is_cardart_shown
     * @property {String} eligible
     *
     * @typedef {Object} CardartInstrumentation
     * @property {Array<FI>} fi
     *
     * @param {Object} options
     * @param {Array} options.plans An array of fundingOptions plans or future payment instruments
     * @returns {Object<CardartInstrumentation>}
     */
    var normalizePayload = function normalizePayload(_ref2) {
        var _ref2$plans = _ref2.plans,
            plans = _ref2$plans === undefined ? [] : _ref2$plans;
        return {
            fi: plans.filter(function (plan, index, arr) {
                var id = arr.map(function (item) {
                    return item.id;
                });

                return index === id.indexOf(plan.id) && plan.type !== BALANCE;
            }).map(function (_ref3) {
                var id = _ref3.id,
                    type = _ref3.type,
                    cardArtUrl = _ref3.cardArtUrl;
                return {
                    fi_id: id,
                    fi_type: 'fi_' + (type && type.toLowerCase()),
                    is_cardart_shown: type === CARD && cardArtUrl ? '1' : '0',
                    eligible: type === CARD && cardArtUrl ? 'cardart' : null
                };
            })
        };
    };

    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Array}
     */
    var getSelectedInstrument = function getSelectedInstrument(_ref4) {
        var checkoutSession = _ref4.checkoutSession;

        return checkoutSession.getSelectedStickyInstrument() ? [checkoutSession.getSelectedStickyInstrument()].map(normalizeFutureInstrument) : [];
    };

    /**
     * CreatePayload creates cardart instrumentation based on the following criteria:
     *
     * - showMultipleFiVariants pxp
     * - showMultipleFiVariants + 3FI pxp
     * - singleFI pxp
     *
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @param {Boolean} options.isBillingNoPurchase $CheckoutCartModel.isBillingNoPurchase()
     * @param {Boolean} options.stickyEligible Default to be false
     * @param {Boolean} options.renderMultipleFi Determines whether to render multiple FIs or not
     * @param {Boolean} options.renderSingleFi Determines whether to render single FI or not
     * @param {Object} options.showMoreFiState ShowMoreFiState to determine whether we renders `Show More` expereience or not.
     * See $ShowMoreFiFactory.get() for details implementation
     * @returns {Object<CardartInstrumentation>}
     */
    var createPayload = function createPayload(_ref5) {
        var checkoutSession = _ref5.checkoutSession,
            isBillingNoPurchase = _ref5.isBillingNoPurchase,
            _ref5$stickyEligible = _ref5.stickyEligible,
            stickyEligible = _ref5$stickyEligible === undefined ? false : _ref5$stickyEligible,
            _ref5$renderMultipleF = _ref5.renderMultipleFi,
            renderMultipleFi = _ref5$renderMultipleF === undefined ? false : _ref5$renderMultipleF,
            _ref5$renderSingleFi = _ref5.renderSingleFi,
            renderSingleFi = _ref5$renderSingleFi === undefined ? false : _ref5$renderSingleFi,
            _ref5$showMoreFiState = _ref5.showMoreFiState,
            showMoreFiState = _ref5$showMoreFiState === undefined ? {
            eligible: false,
            isTooManyFi: false,
            isShowMoreBtnClicked: false
        } : _ref5$showMoreFiState;
        var eligible = showMoreFiState.eligible,
            isTooManyFi = showMoreFiState.isTooManyFi,
            isShowMoreBtnClicked = showMoreFiState.isShowMoreBtnClicked;

        var plans = isBillingNoPurchase ? checkoutSession.get('futurePaymentInstruments', []).map(normalizeFutureInstrument) : (checkoutSession.getPlanList() || []).map(normalizeFundingOptions);

        // when we do decide to render multiple FIs experience
        if (renderMultipleFi) {
            plans = eligible && isTooManyFi // eslint-disable-line no-nested-ternary
            ? isShowMoreBtnClicked ? plans.slice(0) // If `addMore` action has been triggered, we log all FIs
            : plans.slice(0, 3) // otherwise, we only log the first 3FIs
            : plans;
        } else if (renderSingleFi) {
            // Or, render a single FI experience
            // ensure we check if we have a sticky plan
            if (stickyEligible) {
                plans = getSelectedInstrument({ checkoutSession: checkoutSession });
            } else {
                plans = plans.slice(0, 1);
            }
        }

        return normalizePayload({ plans: plans });
    };

    return {
        createPayload: createPayload,
        isCardArtEnable: isCardArtEnable
    };
});

_squid.$meta;

_wallet.$WalletModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/cardart-instrument", "pages/services/cardart-instrument/index.js"))

/***/ }),

/***/ "./pages/services/shared-util/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var DECLINE_TYPE = {
    PRE_AUTH: 'PREAUTH'
};

/**
 * $SharedUtil is a resuable Angular factory service.
 * It intends to abstract away common functionalities that are
 * being used in multiple pages or components.
 */

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SharedUtil', function () {

    /**
     * checks at least one FI in the plan has cpa information
     * might not be required just having for now
     */
    var isAuthRequiredInAnyFI = function isAuthRequiredInAnyFI(checkoutSession) {
        var isAuthRequired = false;
        var plans = checkoutSession && checkoutSession.getPlanList();

        // Check if any existing plans has pre auth data.
        if (plans && plans.length) {
            isAuthRequired = plans.some(function (plan) {
                return plan.primaryFs && plan.primaryFs.pre_authorization_instruction;
            });
        }

        _logger.$logger.info('is_auth_required_fi', {
            isAuthRequired: isAuthRequired
        });

        return isAuthRequired;
    };

    var isSelectedPlanRequiresAuth = function isSelectedPlanRequiresAuth(plan) {
        var isPlanRequireAuth = plan && plan.primaryFs && plan.primaryFs.pre_authorization_instruction;

        _logger.$logger.info('is_plan_require_auth', {
            isPlanRequireAuth: isPlanRequireAuth
        });

        return isPlanRequireAuth;
    };

    /*
     * check the declined instrument is for reason auth decline
     */
    var isAuthDeclinedInstrument = function isAuthDeclinedInstrument(checkoutSession) {
        var isDeclinedInstrument = false;

        var declinedInstruments = checkoutSession.declinedInstruments || [];

        // if yes, then we make elmo call, otherwise not.
        if (declinedInstruments && declinedInstruments.length) {
            isDeclinedInstrument = declinedInstruments.some(function (instrument) {
                return instrument.decline_type === DECLINE_TYPE.PRE_AUTH;
            });
        }

        _logger.$logger.info('is_auth_declined_instrument', {
            isDeclinedInstrument: isDeclinedInstrument
        });

        return isDeclinedInstrument;
    };

    var isBoolean = function isBoolean(value) {
        return Object.prototype.toString.call(value) === '[object Boolean]';
    };

    return {
        isAuthRequiredInAnyFI: isAuthRequiredInAnyFI,
        isSelectedPlanRequiresAuth: isSelectedPlanRequiresAuth,
        isAuthDeclinedInstrument: isAuthDeclinedInstrument,
        isBoolean: isBoolean
    };
});

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/services/shared-util", "pages/services/shared-util/index.js"))

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");

var _dist = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _fn = __webpack_require__("../node_modules/xo-login-components/src/login/fn.js");

var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");

__webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/merchant-header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/header/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/footer/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");

__webpack_require__("../node_modules/xo-validation/dist/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login-overlay/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/venmo-stepUp/directive.js");

var _template = __webpack_require__("./pages/xo-checkout/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
    tag: 'xo-checkout',
    template: _template2['default'],
    controller: function controller() {
        if (_angular.$location.path() === '/checkout') {
            _uiRouter.$state.go('checkout.review');
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            if (window.appPerformanceEvents) {
                // TimeToFirstIntractableElement: The moment client is ready to receive its first user interaction.
                // Should be the before the first promise on the page
                // If the cancel button is ready then the page is
                // ready for some user interaction
                window.appPerformanceEvents.TimeToFirstIntractableElement = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.token = _angular.$rootScope.token;
            this.locale = _squid.$locale;
            this.redirectiframe = _angular.$rootScope.partnerIntegration;
            this.redirectLightbox = true;
            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
            this.displayHeader = true;

            this.reviewUrl = 'checkout.review';
            this.isApp = _dist.$DeviceInfo.isApp();

            this.isDolphinEligible = false;

            _angular.$document.bind('click', function (event) {
                _this.$broadcast('clickBody', event.target);
            });

            function rtl() {
                if ((0, _squid.$feature)('rtl')) {
                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
                }
            }

            this.$on('metadataChange', rtl);
            rtl();

            _fn.$fn.trigger();

            this.isGdprValid = _gdprCookieBanner.isGdprValid;
        },
        populate: function populate() {
            var _this2 = this;

            function requiresRiskyLogin(state) {
                var auth = _auth.$AuthModel.instance();

                if (auth.remembered) {
                    // riskyLogin if new state requires full auth login
                    // ignore if we're in crucial venmo Step Up states
                    return state.loginRequired && !(state.name === 'checkout.venmoAuth' || state.name === 'checkout.venmo');
                }

                return false;
            }

            function displayRiskyLogin(oldState, newState, newParams) {
                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                    _logger.$logger.info('login_overlay_suppressed');
                    return;
                }

                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);

                if (isUserinitiated) {
                    var stateName = newState && newState.name;
                    var subFlowName = stateName && stateName.replace(/^.*\./, '');

                    if (subFlowName === 'sepaAgreement') {
                        _uiRouter.$state.go('checkout.review');
                    }

                    var insufficientPermissionEvent = _thirdPartyInfo.thirdPartyExperience.getExperience(this.token) === 'VENMO_EXPERIENCE' ? '$insufficientPermissionVenmoOT' : '$insufficientPermission';

                    _angular.$rootScope.$broadcast(insufficientPermissionEvent, {
                        oldState: oldState.name,
                        newState: newState.name,
                        pageOnOverlay: newState.pageOnOverlay
                    });
                } else {
                    var auth = _auth.$AuthModel.instance();
                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');

                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);

                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';

                    _uiRouter.$state.go(transition, {
                        targetPage: cause,
                        showNotYou: true
                    });
                }
                return false;
            }

            function displayHeader(stateName) {
                // We'll be hiding the header during the third party wallet flow, since the third Party will brand the flow from their end
                return !(stateName === 'checkout.thirdPartyWalletFlow');
            }

            var checkDolphinEligibility = function checkDolphinEligibility(stateName) {
                return (0, _utils.getDolphinEligibility)(stateName).then(function (eligibility) {
                    _this2.isDolphinEligible = eligibility;
                });
            };

            function determineOneTouchExperience() {
                var auth = _auth.$AuthModel.instance();
                var isVenmoOT = auth.get('tenant') === 'VENMO' && auth.get('remembered');
                var isPaypalOT = auth.get('tenant') !== 'VENMO' && auth.get('remembered');

                if (isVenmoOT) {
                    return 'venmo';
                } else if (isPaypalOT) {
                    return 'paypal';
                }

                return 'none';
            }

            // Check dolphin eligibility for explicit page reload
            checkDolphinEligibility(_uiRouter.$state.current && _uiRouter.$state.current.name);

            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
                // venmo flag
                _this2.showVenmoExperience = _thirdPartyInfo.thirdPartyExperience.getExperience(_this2.token) === 'VENMO_EXPERIENCE';

                _logger.$logger.info('checkout_fpti', {
                    'is_venmo_branding': _this2.showVenmoExperience ? '1' : '0',
                    'is_onetouch_enabled': determineOneTouchExperience()
                });

                _this2.displayHeader = displayHeader(newState && newState.name);

                if (requiresRiskyLogin(newState)) {
                    event.preventDefault();
                    displayRiskyLogin(oldState, newState, newParams);
                }
                checkDolphinEligibility(newState && newState.name);
            });

            this.$on('$destroy', cancelStateChangeEventListener);

            if (requiresRiskyLogin(_uiRouter.$state.current)) {
                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
            }
        }
    }
});


_uiRouter.$state;

_logger.$logger;

_integration.$integration;

_angular.$rootScope;

_angular.$document;

_angular.$location;

_squid.$Component;

_squid.$feature;

_squid.$locale;

_auth.$AuthModel;

_gdprCookieBanner.isGdprValid;

_dist.$DeviceInfo;

_thirdPartyInfo.thirdPartyExperience;

_fn.$fn;

_utils.getDolphinEligibility;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");

__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");

__webpack_require__("./js/lib/index.js");

__webpack_require__("../node_modules/xo-tracking/dist/index.js");

var _index = __webpack_require__("../node_modules/squid/dist/index.js");

var _middleware = __webpack_require__("./js/lib/middleware.js");

__webpack_require__("./pages/xo-landing/route.js");

__webpack_require__("./pages/xo-login/route.js");

__webpack_require__("./pages/xo-review/route.js");

__webpack_require__("./pages/xo-end/route.js");

__webpack_require__("./pages/xo-checkout/directive.js");

exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$PayWithSelectionRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "./pages/xo-pay-with-selection/route.js"));
        },
        slug: 'payWithSelection'
    }, {
        name: '$VenmoRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "./pages/xo-venmo/route.js"));
        },
        slug: 'venmo'
    }, {
        name: '$VenmoAuthRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "./pages/xo-venmoAuth/route.js"));
        },
        slug: 'venmoAuth'
    }, {
        name: '$ThirdPartyWalletFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "./pages/xo-third-party-wallet/route.js"));
        },
        slug: 'thirdPartyWalletFlow'
    }, {
        name: '$ThirdPartyInfoCollectFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "./pages/xo-third-party-info/route.js"));
        },
        slug: 'thirdPartyInfoCollectFlow'
    }, {
        name: '$GenericErrorRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "./pages/xo-generic-error/route.js"));
        },
        slug: 'genericError'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "../node_modules/xo-credit-components/src/choose-credit-offer/route.js"));
        },
        slug: 'chooseCreditOffer'
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "../node_modules/xo-credit-components/src/redirect-to-cape/route.js"));
        },
        slug: 'redirectToCape'
    }, {
        name: '$GenericMessageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-generic-message/route.js"));
        },
        slug: 'genericMessage'
    }, {
        name: '$FullpageOnetouchUpsellRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "../node_modules/xo-login-components/src/fullpage-onetouch-upsell/route.js"));
        },
        slug: 'FullpageOnetouchUpsell'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "../node_modules/xo-login-components/src/onetouch-interstitial/route.js"));
        },
        slug: 'oneTouchUpsell'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-select-fi/route.js"));
        },
        slug: 'selectFi'
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "./pages/xo-authorization-message/route.js"));
        },
        slug: 'authorizationmessage'
    }, {
        name: '$AddPhoneRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "../node_modules/xo-form-components/src/phone/route.js"));
        },
        slug: 'addPhone'
    }, {
        name: '$AddCardPageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-add-card/route.js"));
        },
        slug: 'pageAddCard'
    }, {
        name: '$AddFiPageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "./pages/xo-add-fi/route.js"));
        },
        slug: 'pageAddFi'
    }, {
        name: '$xoTokenizationInfoPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "./pages/xo-tokenization-info/route.js"));
        },
        slug: 'tokenizationInfo'
    }, {
        name: '$xoPinSetupPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "./pages/xo-pin-setup/route.js"));
        },
        slug: 'pinSetup'
    }, {
        name: '$AddCardMeftRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "./pages/xo-add-card-meft/route.js"));
        },
        slug: 'pageAddCardMeft'
    }, {
        name: '$AddTaxIdRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "./pages/xo-add-tax-id/route.js"));
        },
        slug: 'addTaxId'
    }, {
        name: '$TravelRuleRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "./pages/xo-travel-rule/route.js"));
        },
        slug: 'travelRule'
    }, {
        name: '$AddNationalIdRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "./pages/xo-add-national-id/route.js"));
        },
        slug: 'addNationalId'
    }, {
        name: '$UpdateCardPageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "./pages/xo-update-card/route.js"));
        },
        slug: 'updateCard'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "./pages/xo-add-shipping/route.js"));
        },
        slug: 'pageAddShipping'
    }, {
        name: '$xoSoldOutPageRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "./pages/xo-inventory-soldout/route.js"));
        },
        slug: 'soldout'
    }, {
        name: '$xoEConsentPageRoute',
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "./pages/xo-eConsent/route.js"));
        },
        slug: 'econsent'

    }, {
        name: '$xoNbrDEPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "./pages/xo-nbr/route.js"));
        },
        slug: 'negativeBalanceRecovery'

    }, {
        name: '$xoFrameBustRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "./pages/xo-framebust/route.js"));
        },
        slug: 'framebust'
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "./pages/xo-sepa/route.js"));
        },
        slug: 'sepapage'
    }, {
        name: '$PayRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-pay/route.js"));
        },
        slug: 'pay'
    }, {
        name: '$EndRoute',
        slug: 'end'
    }, {
        name: '$xoDeGuest',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "./pages/xo-de-guest/route.js"));
        },
        slug: 'xoDeGuest'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "../node_modules/xo-credit-components/src/bml-display/route.js"));
        },
        slug: 'bmldisplay'
    }, {
        name: '$DoneRoute',
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "../node_modules/xo-page-components/src/done/route.js"));
        },
        slug: 'done'
    }, {
        name: '$xoPageCreatePasswordRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "./pages/xo-create-password/route.js"));
        },
        slug: 'createPassword'
    }, {
        name: '$xoCIPVerficationPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "./pages/xo-cip-verification/route.js"));
        },
        slug: 'cipverification'

    }]
});


_index.$Route;

_middleware.$Middleware;
module.exports = exports['default'];

/***/ }),

/***/ "./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\" >\n    <xo-dolphin ng-if=\"isDolphinEligible\"></xo-dolphin>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-merchant-header ng-if=\"!isMessengerBAIntegration\" token=\"token\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\" role=\"main\" tabindex=\"-1\">\n                <xo-header ng-if=\"displayHeader\" is-venmo-flow=\"showVenmoExperience\" token=\"token\" redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-header>\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-footer ng-if=\"!isMessengerBAIntegration\" token=\"token\" escape-hatch-incontext=\"escapeHatchInContext\" show-venmo-legal-links=\"showVenmoExperience\"></xo-footer>\n    <xo-login-overlay  token=\"token\"></xo-login-overlay>\n    <xo-venmo-stepup-overlay token=\"token\"></xo-venmo-stepup-overlay>\n</div>\n<xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n"

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$EndRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

var _returnParams = __webpack_require__("../node_modules/xo-page-components/src/returnParams/index.js");

var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");

var _subscription = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'end',
    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },
    resolve: {
        action: function action() {

            function returnMethod(merchantPreferences) {
                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data) {
                var clientConfiguration = subscriptionV1Data && subscriptionV1Data.billingAgreementCart.client_configuration;
                var isRestRpMigrated = clientConfiguration && clientConfiguration.api === 'RECURRING_PAYMENTS_V1';

                return checkoutCart.isSubscriptionsV1() && !isRestRpMigrated;
            }

            function returnUrl(checkoutAppData, merchantPreferences, checkoutCart, subscriptionV1Data) {
                var return_uri = checkoutAppData.urls && checkoutAppData.urls.return_url;
                var billing = checkoutCart.billing || {};
                if (billing.intent === 'VAULT') {
                    var originalReturnUrl = checkoutAppData.urls && checkoutAppData.urls.original_urls && checkoutAppData.urls.original_urls.return_url;
                    return_uri = originalReturnUrl ? originalReturnUrl : return_uri;
                }

                if (checkoutAppData.is_wps_subscription_flow()) {
                    return _squid.$config.urls.wpsSubscriptionReturnUrl;
                }

                if (checkoutAppData.is_wps_installmentplan_flow()) {
                    return _squid.$config.urls.wpsInstallmentPlanReturnUrl;
                }

                if (checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$config.urls.wpsAutobillingReturnUrl;
                }

                if (shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data)) {
                    return _squid.$config.urls.subscriptionsV1ReturnUrl;
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    return _squid.$util.param('redirect_uri');
                }

                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return return_uri || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return return_uri;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, subscriptionV1Data, returnToMerchantMethod) {
                var billingData = checkoutCart.billing || {};
                var paramsForWPSBillingFlows = {
                    token: _squid.$meta.token,
                    mfid: _squid.$meta.mfid,
                    sdkMeta: _squid.$meta.sdkMeta,
                    mode: 'member',
                    'country.x': _squid.$locale.country,
                    'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country
                };
                var paramsForVault = {
                    approval_token_id: billingData.vault_approval_token_id,
                    approval_session_id: billingData.vault_approval_session_id
                };

                if (billingData.intent === 'VAULT') {
                    return paramsForVault;
                }

                if (checkoutAppData.is_wps_subscription_flow() || checkoutAppData.is_wps_installmentplan_flow() || checkoutAppData.isWpsAutobillingFlow()) {
                    return paramsForWPSBillingFlows;
                }

                var params = {};

                if (shouldRedirectToSubscriptionsV1Done(checkoutCart, subscriptionV1Data)) {
                    params = _extends({}, paramsForWPSBillingFlows);
                }

                // Don't post PayerID for RT without purchase
                if (_squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                if (billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if (_squid.$integration.isFlow('WPS')) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;

                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    if (checkoutAppData.urls.return_url) {
                        params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);
                    }

                    // Add these params after building `return_uri` to ensure they are not added into the final url
                    params.intent = checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.paymentId = checkoutAppData.payment_id;
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            function getSubscriptionV1Data(models) {
                var baToken = models.checkoutCart.getBaToken();
                if (baToken && models.checkoutCart.isSubscriptionsV1()) {
                    return (0, _squid.$populate)(models, {
                        subscriptionV1Data: _subscription.$SubscriptionsV1Model.instance(models.checkoutCart.getBaToken())
                    });
                }
                return _angular.$q.when();
            }

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return _angular.$q.all([getMerchantPreferences(models), getSubscriptionV1Data(models)]);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences, models.checkoutCart, models.subscriptionV1Data);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, models.subscriptionV1Data, returnToMerchantMethod);
                _logger.$logger.info('checkout_fpti', {
                    'from': 'BACK_TO_MERCHANT',
                    'to': 'prepare_bk_to_merchant',
                    'redirect_url': url,
                    'client_epoch_ts': Date.now()
                });

                if (models.checkoutAppData.is_wps_subscription_flow() || shouldRedirectToSubscriptionsV1Done(models.checkoutCart, models.subscriptionV1Data) || models.checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }
                if (models.checkoutAppData.is_wps_installmentplan_flow()) {
                    _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }

                // if V4 in-context integration, we'll call the onAuthorize handler.
                if (window.xprops && window.xprops.onAuthorize) {
                    _logger.$logger.info('xprops_onauthorize');
                    _logger.$logger.flush();
                    _angular.$rootScope.$emit('loading');

                    var xparams = {
                        paymentToken: _angular.$rootScope.token,
                        orderID: _angular.$rootScope.token,
                        billingToken: params['ba_token'],
                        payerID: params['PayerID'],
                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
                        intent: models.checkoutCart.payment_action
                    };

                    if (url) {
                        xparams.returnUrl = _squid.$util.buildURL(url, params);
                    }

                    if (window.xprops && window.xprops.getConnectURL) {
                        _logger.$logger.info('xprops_connect_redirect');

                        return window.xprops.getConnectURL({ payerID: xparams.payerID }).then(function (connectURL) {
                            return _squid.$util.redirect(connectURL);
                        })['catch'](function (err) {
                            _logger.$logger.info('xprops_connect_redirect_error', {
                                err: err.stack || err.toString()
                            });
                            return window.xprops.onAuthorize(xparams);
                        });
                    }

                    return window.xprops.onAuthorize(xparams);
                }

                if (returnToMerchantMethod === 'POST') {
                    _logger.$logger.info('post_redirect');
                    _logger.$logger.flush();
                    _util.$ReturnToMerchant.postTo(url, params);
                } else {
                    _logger.$logger.info('standard_redirect');
                    _logger.$logger.flush();
                    // if PDT is disabled don't send params in the url
                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                        return _util.$ReturnToMerchant.goTo(url);
                    }
                    _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                }

                return _squid.$unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_squid.$meta;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$unresolved;

_squid.$integration;

_squid.$ComponentRoute;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_util.$ReturnToMerchant;

_returnParams.$returnParams;

_profilemanagement.$MerchantPreferenceModel;

_subscription.$SubscriptionsV1Model;

/***/ }),

/***/ "./pages/xo-landing/ppcRoute.js":
/***/ (function(module, exports) {



exports.__esModule = true;
var getPPCRoute = exports.getPPCRoute = function getPPCRoute($logger, _ref) {
    var showCYCOInCAPE = _ref.showCYCOInCAPE,
        hasInstallmentOptions = _ref.hasInstallmentOptions,
        hasThreeMonthInstallment = _ref.hasThreeMonthInstallment,
        isCapeReturnKey = _ref.isCapeReturnKey,
        isInstallmentEligible = _ref.isInstallmentEligible,
        isUserLoggedIn = _ref.isUserLoggedIn,
        merchantCountry = _ref.merchantCountry;

    if (isCapeReturnKey) {
        $logger.info('ppc_return_flow');
        if (merchantCountry === 'DE') {
            return 'checkout.xoDeGuest';
        } else {
            return 'checkout.login';
        }
    } else if (merchantCountry === 'US' || merchantCountry === 'GB' || merchantCountry === 'LU') {
        // Swapping CYCO and UL - adding LU for eBay support
        if (isUserLoggedIn) {
            $logger.info('ppc_second_btn_ul_treatment_loggedin');
            // We're redirect to login because it contains logic to redirect to xo-eConsent if needed (same as 1st button)
            return 'checkout.login';
        } else {
            $logger.info('ppc_second_btn_ul_treatment_not_loggedin');
            if (isInstallmentEligible && hasInstallmentOptions) {
                $logger.info('ppc_second_btn_ul_treatment_has_installments');
                if (showCYCOInCAPE) {
                    $logger.info('ppc_second_btn_cape_cyco_treatment');

                    return {
                        to: 'checkout.redirectToCape',
                        params: {
                            showCapeCyco: true
                        }
                    };
                } else if (hasThreeMonthInstallment) {
                    $logger.info('ppc_second_btn_has_three_month_installment_no_cyco_cape_redirect');
                    return 'checkout.redirectToCape';
                } else {
                    return 'checkout.chooseCreditOffer';
                }
            } else {
                return 'checkout.redirectToCape';
            }
        }
    } else {
        // bypass CYCO if no installments
        if (hasInstallmentOptions && (merchantCountry === 'US' && isInstallmentEligible || merchantCountry !== 'US')) {
            // eslint-disable-line
            if (showCYCOInCAPE) {
                $logger.info('ppc_second_btn_cape_cyco_treatment');
                return {
                    to: 'checkout.redirectToCape',
                    params: { showCapeCyco: true }
                };
            }
            $logger.info('ppc_second_btn_cyco');
            return 'checkout.chooseCreditOffer';
        } else if (merchantCountry === 'DE') {
            return {
                to: 'checkout.genericError',
                params: {
                    code: 'BLOCK_PPC_INELIGIBLE_USER'
                }
            };
        } else {
            $logger.info('ppc_second_btn_no_installments');
            return 'checkout.login';
        }
    }
};

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _inventory = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");

var _ppcRoute = __webpack_require__("./pages/xo-landing/ppcRoute.js");

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
    path: 'landing',
    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },
    auth: false,
    resolve: {

        action: function action() {
            var models = {};
            var isPayPalCredit = void 0;

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                auth: _auth.$AuthModel.instance(),
                checkoutPayeeModel: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                flowEligibility: _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                isPayPalCredit = models.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');

                if (isPayPalCredit) {
                    return _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*|Trmt_xo_de_ppc_cape_cyco_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_merchant_country_override', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_merchant_country_override_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_cape_cyco', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': models.checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_cape_cyco', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0],
                            merchantOverride = _ref[1],
                            redirectToCapeCyco = _ref[2];
                        return {
                            ppcEZPRes: ppcEZPRes,
                            merchantOverride: merchantOverride,
                            redirectToCapeCyco: redirectToCapeCyco
                        };
                    });
                } else {
                    return {};
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes,
                    merchantOverride = _ref2.merchantOverride,
                    redirectToCapeCyco = _ref2.redirectToCapeCyco;

                var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var previousMerchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                var buyerCountry = _squid.$locale.country;
                var prevBuyerCountry = _squid.$locale.country;
                var prevBuyerLanguage = _squid.$locale.lang;

                var shouldOverrideLocale =
                // Only do this for PPC 2nd button
                isPayPalCredit && !models.auth.loggedIn();

                // Override buyer country to match merchant country for PPC 2nd button
                // https://engineering.paypalcorp.com/confluence/display/MICA/Locale+Issues+on+2nd+Button
                if (shouldOverrideLocale) {

                    if (merchantOverride) {
                        _logger.$logger.info('landing_overriding_merchant_country');
                        merchantCountry = 'GB';
                    }

                    if (
                    // Check that the merchant country is supported
                    merchantCountry && _squid.$config.supportedCountries[merchantCountry] && _squid.$config.creditEligibleCountries.indexOf(merchantCountry) !== -1) {
                        buyerCountry = merchantCountry;
                    } else if (
                    // Check that the buyer country is supported - no need to override if so
                    _squid.$config.supportedCountries[buyerCountry] && _squid.$config.creditEligibleCountries.indexOf(buyerCountry) !== -1) {
                        _logger.$logger.info('landing_overriding_locale_unsupported_merchant', {
                            buyerCountry: buyerCountry,
                            merchantCountry: merchantCountry
                        });
                    } else {
                        // Fallback to US because no supported country can be determined
                        _logger.$logger.warn('landing_overriding_locale_fallback', {
                            buyerCountry: prevBuyerCountry,
                            buyerLanguage: prevBuyerLanguage,
                            merchantCountry: merchantCountry
                        });
                        buyerCountry = 'US';
                    }

                    var supportedLanguages = _squid.$config.supportedCountries[buyerCountry];
                    var lang = void 0;

                    // If the buyer's language exists in the merchant's country, use that, otherwise use default
                    if (supportedLanguages.indexOf(prevBuyerLanguage) !== -1) {
                        lang = prevBuyerLanguage;
                    } else {
                        lang = supportedLanguages[0];
                    }

                    _logger.$logger.info('landing_overriding_locale_success', {
                        prevBuyerCountry: prevBuyerCountry,
                        prevBuyerLanguage: prevBuyerLanguage,
                        newBuyerCountry: buyerCountry,
                        newBuyerLanguage: lang,
                        merchantCountry: merchantCountry,
                        previousMerchantCountry: previousMerchantCountry
                    });

                    // Calling .change here instead of .chooseCountry because we don't want to store the
                    // locale - we want to persist the locale through to the login page, where the locale
                    // can be chosen after the user logs in
                    if (merchantCountry) {
                        _squid.$locale.change(merchantCountry, lang);
                    }
                }

                return {
                    ppcEZPRes: ppcEZPRes, redirectToCapeCyco: redirectToCapeCyco
                };
            }).then(function (_ref3) {
                var ppcEZPRes = _ref3.ppcEZPRes,
                    redirectToCapeCyco = _ref3.redirectToCapeCyco;

                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;

                _logger.$logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });

                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
                    var supportBlockNonDomesticShipping = (0, _squid.$feature)('supportBlockNonDomesticShipping', false, merchantCountry);
                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');
                    var isVenmoOneTouch = models.auth.get('tenant') === 'VENMO' && models.auth.get('logged_in');

                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
                        _logger.$logger.info('block_non_domestic_shipping', {
                            block_non_domestic_shipping: blockNonDomesticShipping,
                            allow_change_shipping: allowChangeShipping,
                            setec_shipping_country_code: prefillShippingAddress
                        });
                    }

                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';

                    if (shouldBlockBuyer) {
                        return {
                            to: 'checkout.genericError',
                            params: {
                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
                            }
                        };
                    }

                    if (isPayPalCredit) {
                        var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;
                        var redirectToCapeCycoTreatment = redirectToCapeCyco && redirectToCapeCyco.treatment_name;

                        _logger.$logger.info('checkout_fpti', {
                            'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_ezp'
                        });
                        _logger.$logger.info('checkout_fpti', {
                            'xo_gb_ppc_cape_cyco': redirectToCapeCycoTreatment ? redirectToCapeCycoTreatment : 'Ctrl_xo_gb_ppc_cape_cyco'
                        });

                        var creditDataModel = _credit.$CreditDataModel.instance(_angular.$rootScope.token);
                        var isCapeReturnKey = creditDataModel.getCapeKey();
                        var offers = new _index2.$CreditInstallmentOptionsModel({
                            id: _angular.$rootScope.token,
                            payee: models.checkoutPayeeModel,
                            checkoutCart: models.checkoutCart,
                            checkoutAppData: models.checkoutAppData,
                            isMemberCredit: true
                        });
                        var isInstallmentEligible = models.flowEligibility && models.flowEligibility.installment;

                        return offers.save({
                            cache: true,
                            success: function success(result) {
                                var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                                var installmentOfferDetails = offers.getInstallmentOffers();

                                installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                                if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                                    _logger.$logger.info('xo_landing_ppc_conversion_info_present');
                                    creditDataModel.setCartAmountAndCurrency({
                                        cart_amount: result.conversion_info.converted_transaction_amount.value,
                                        cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                                    });
                                }
                                // Unified login treatment + create account flow (user not logged in)
                                var isUserLoggedIn = models.auth.loggedIn();

                                var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                                var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                    return item.financingCode;
                                }) : [];
                                var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                    return threeMonthFinancingCodeArray.includes(value);
                                }).length > 0);
                                var showCYCOInCAPE = Boolean(ppcEZPTreatment) || Boolean(redirectToCapeCycoTreatment);

                                return (0, _ppcRoute.getPPCRoute)(_logger.$logger, {
                                    showCYCOInCAPE: showCYCOInCAPE,
                                    hasInstallmentOptions: hasInstallmentOptions,
                                    hasThreeMonthInstallment: hasThreeMonthInstallment,
                                    isCapeReturnKey: isCapeReturnKey,
                                    isInstallmentEligible: isInstallmentEligible,
                                    merchantCountry: merchantCountry,
                                    isUserLoggedIn: isUserLoggedIn
                                });
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT(name, err) {
                                    // Check error message === currencyNotCompatible
                                    return 'checkout.login';
                                }
                            }
                        });
                    }

                    if (isVenmoOneTouch) {

                        return 'checkout.venmoAuth';
                    }

                    return 'checkout.login';
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _inventory.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };

                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_auth.$AuthModel;

_squid.$Class;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_squid.$elmo;

_squid.$util;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$FlowEligibilityModel;

_index.$CheckoutAppDataModel;

_index2.$CreditInstallmentOptionsModel;

_credit.$CreditDataModel;

_inventory.$InventoryModel;

_ppcRoute.getPPCRoute;

/***/ }),

/***/ "./pages/xo-login/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoLoginPageComponent = undefined;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index4 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index5 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");

var _index6 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/login/handler/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-login-components/src/unified-login/directive.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/vaulting/utils.js");

var _loginEligibility = __webpack_require__("./pages/xo-login/loginEligibility.js");

__webpack_require__("./pages/xo-login/onboarding/directive.js");

var _template = __webpack_require__("./pages/xo-login/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("./pages/xo-login/tokenized-wallet-loader/directive.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

var _util = __webpack_require__("./pages/xo-login/util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
    tag: 'xo-login-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(this.props.token);
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('login_controller');

        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        var memberSegmentMapper = {
            NEW_MEMBER: 'NEW_XO_MEMBER',
            YOUNG_MEMBER: 'YOUNG_XO_MEMBER',
            EXISTING_MEMBER: 'EXISTING_XO_MEMBER'
        };

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.ulEligibility = false;
        $scope.isWalletTokenization = false;

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */

        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;
        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }

            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _index4.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _index2.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.userProductSubscription = _index3.$UserProductSubscriptionModel.instance();
        $scope.tokenizedWalletPin = _index2.$TokenizedWalletPinModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletMsbOffer = _index2.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token);
        $scope.walletPreferences = _index5.$WalletPreferences.instance(_angular.$rootScope.token);
        $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();
        $scope.dependencyEligibility = true;

        var isValidGamingContingencies = function isValidGamingContingencies(err) {
            // Map usRMG specific error cause to EOL message.
            var endOfLineErrorList = ['GAMER_INELIGIBLE', 'GAMER_FI_INELIGIBLE', 'GAMER_FI_UNCONFIRMED', 'GAMER_ACCOUNT_UNVERIFIED', 'GAMER_INVALID_ACCOUNT_TYPE', 'GAMER_LOGIN_OUT_OF_COUNTRY', 'GAMING_INVALID_PAYMENT_FLOW', 'GAMER_RESIDENCE_OUT_OF_COUNTRY', 'GAMER_NO_VALID_FUNDING_INSTRUMENT'];

            return err && err.cause && endOfLineErrorList.indexOf(err.cause) > -1;
        };

        var isUSGambling = function isUSGambling(_ref) {
            var err = _ref.err;

            var isUSBuyer = _squid.$locale.country === 'US';
            var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';

            return isUSBuyer && isUSmerchant && $scope.checkoutPayeeModel.isGambling() && isValidGamingContingencies(err);
        };

        // preloading most popular routes where after setbuyer
        // we should keep the balance here to prevent over loading non needed javascript
        // basically the most popular routes should be added here
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                Promise.all([__webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-select-fi/route.js")), __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-add-card/route.js"))])['catch'](function (err) {
                    _logger.$logger.info('code_split_setbuyer_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                _logger.$logger.info('[xo login handleContingency]', {
                    name: name,
                    err: err
                });

                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);

                // NOTE: curently `GAMER_INELIGIBLE` is only designed for DE gambling
                // however, this new Contingency is expected to expand to all gambling
                // countries moving forward.
                if (isUSGambling({ err: err }) || errorCode === 'GAMER_INELIGIBLE') {
                    // US gambling buyer & merchant should get EOL
                    // for certain compliance Contingencies
                    return _uiRouter.$state.go('checkout.genericError', {
                        code: errorCode
                    });
                }

                if (name !== 'NEED_AUTHENTICATED_CARD') {
                    throw err;
                }

                // come from guest or have alternate FI options, go to review
                if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                    _uiRouter.$state.go('checkout.review');
                } else {
                    // else go to addCard
                    _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                }
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.isWalletTokenization) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);
                    $scope.checkoutSession.contingency = name;

                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.isWalletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.isWalletTokenization) {
                _angular.$rootScope.$emit('allLoaded');
            }

            $scope.eConsent.retrieve({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.isWalletTokenization,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if ($scope.isWalletTokenization) {
                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _$scope$tokenizedWall = $scope.tokenizedWalletInfoModel,
                    wallet_id = _$scope$tokenizedWall.wallet_id,
                    external_device_id = _$scope$tokenizedWall.external_device_id,
                    tr_client_id = _$scope$tokenizedWall.tr_client_id,
                    product_name = _$scope$tokenizedWall.product_name;

                var subject = $scope.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.retrieve({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                var code = void 0;

                                fptiData.int_error_code = result.reason;
                                fptiData.error_source = 'paymenttokenserv';
                                fptiData.error_type = 'hard_decline';
                                _logger.$logger.info('checkout_fpti', fptiData);

                                switch (result.reason) {
                                    case 'WALLET_ID_ALREADY_PROVISIONED':
                                        code = 'ANDROID_PAY_ALREADY_PROVISIONED';
                                        break;

                                    case 'COUNTRY_NOT_SUPPORTED':
                                        code = 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED';
                                        break;

                                    default:
                                        code = 'ANDROID_PAY_ELIGIBILITY_ERROR';
                                        break;
                                }
                                code = window.btoa(code);

                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            }
                        }
                    }
                });

                // check we have product provision subscribed by buyer
                // if not subscribed redirect to splash screen of subscription upsell
                $scope.userProductSubscription.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'userProductSubscription',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent', 'tokenizedWalletLightEligibility']
                    },

                    success: function success(result) {
                        // result is going to an object of { applicable: true, subscribed: true, reason: 'PAYPAL_CASH' }
                        if (result.applicable && !result.subscribed) {
                            _logger.$logger.info('product_subscription_enabled_not_subscribed');
                            $scope.dependencyEligibility = false;
                            _uiRouter.$state.go('checkout.cipverification');
                        }
                    }
                });

                $scope.tokenizedWalletPin.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletPin',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', {
                                pinOrigin: result.pinOrigin,
                                pinId: result.pinId
                            });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set', {
                                pinKey: result.suggestedKey ? result.suggestedKey : 'unavailable'
                            });
                        }
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                            return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    }
                });

                $scope.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletMsbOffer',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                });
            }

            if (_squid.$config.enableNewMemberDecisioning) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'CEP_decisioning',
                    to: 'prepare_cep_descisioning'
                });

                $scope.memberSegment.save({
                    data: $scope.memberSegmentData,
                    batch: {
                        name: 'setbuyer',
                        id: 'memberSegment',
                        silent: true,
                        dependencies: $scope.ulEligibility ? ['securityCtx'] : []
                    },
                    success: function success(result) {
                        var memberSegment = memberSegmentMapper[result.memberSegment] || result.memberSegment;

                        _logger.$logger.info('cep_member_decisioning_success', {
                            segment: memberSegment,
                            creditOffer: result.creditOffer
                        });
                        _logger.$logger.info('checkout_fpti', {
                            from: 'CEP_decisioning',
                            to: 'process_cep_descisioning',
                            cep_response: memberSegment + ':' + result.creditOffer
                        });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('cep_member_decisioning_failed');
                            _logger.$logger.info('checkout_fpti', {
                                from: 'CEP_decisioning',
                                to: 'process_cep_descisioning',
                                int_error_code: 'SERVICE_ERROR',
                                error_source: 'marketingofferreadserv',
                                error_type: 'soft_decline'
                            });
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.isSecondButton();

            $scope.checkoutSession.action('create', {
                data: {
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    // user_selected_funding_source is referenced by xo-hermes-checkout, where it retrieves the product_name in it and passes it to the CreateXO api.
                    user_selected_funding_source: $scope.userSelectedFundingSource,
                    clear_installments: true
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.isWalletTokenization,
                    dependencies: !$scope.isWalletTokenization ? ['eConsent'] : ['eConsent', 'tokenizedWalletLightEligibility', 'userProductSubscription', 'tokenizedWalletPin', 'tokenizedWalletMsbOffer']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    if ($scope.isWalletTokenization) {
                        // no need to check upsell for wallet tokenization flows
                        // just set planDone prop for "<tokenized-wallet-loader>" component
                        $scope.planDone = true;
                        return;
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (eligibility) {
                        var isEligible = eligibility && eligibility.interstitial ? eligibility.interstitial : {};

                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            _logger.$logger.info('ryi_optin', {
                                'from': 'OT_Toggle',
                                'to': 'prepare_inter_optin'
                            });
                            return _uiRouter.$state.go('checkout.oneTouchUpsell', { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        } else {
                            (0, _utils.checkVaultingEligibility)().then(function (eligible) {
                                if (eligible) {
                                    (0, _utils.authorize)($scope.checkoutSession, $scope.checkoutAppData).then(function (authorizePage) {
                                        return _uiRouter.$state.go(authorizePage);
                                    })['catch'](function (err) {
                                        // eslint-disable-line handle-callback-err
                                        _uiRouter.$state.go('checkout.review');
                                    });
                                } else {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete $scope.checkoutSession.selectedInstallmentData;
            });

            preloadCodeSplitRoutes();
        };

        /**
         * This call is made after the buyer is logged in, and before the CreateXO api call.
         * So that we can retrieve the tokenized funding capabilities for the buyer country.
         */
        $scope.getTokenizedFundingCapabilities = function () {
            return _index2.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                    country: $scope.auth.country
                }
            }).then(function (result) {
                if (result.isDirectFundingEnabled()) {
                    $scope.userSelectedFundingSource = {
                        product_name: result.getProductName()
                    };
                }
            });
        };

        $scope.preSetBuyerCalls = function () {
            var apiCalls = [];

            if ($scope.checkoutCart.isWalletTokenization()) {
                apiCalls.push($scope.getTokenizedFundingCapabilities());
            }
            return _angular.$q.all(apiCalls);
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            if ($scope.ulEligibility) {
                // For UL, batch up eConsent, xoSession
                $scope.preSetBuyerCalls().then(function () {
                    return $scope.setBuyer();
                });
            }
        };

        $scope.onSuccess = function () {
            if ($scope.ulEligibility) {
                // If the experiment is enabled, we already have what we need, so /quit.
                return;
            }
            $scope.preSetBuyerCalls().then(function () {
                return $scope.setBuyer();
            });
        };

        (0, _squid.$populate)($scope, {
            flowEligibility: _index4.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country // We need this till we completely migrate to server side locale resolution
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index4.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutPayeeModel: _index4.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
            tokenizedWalletInfoModel: _index2.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
            venmoEligibility: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve({
                params: {
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource'),
                    localeCountry: _squid.$locale.country,
                    venmoOverride: _squid.$util.param('venmoOverride'),
                    native_xo: _squid.$util.param('native_xo')
                }
            })
        }).then(function () {
            return _newMember.$NewMemberEligibility.instance().getMemberSegmentParameters(_angular.$rootScope.token).then(function (data) {
                $scope.memberSegmentData = data;
                // Set flag to indicate all data is loaded
                $scope.populateComplete = true;
                return;
            });
        }).then(function () {
            // If the refresh token is present, the one touch experience must be preserved and the user must not
            // be presented with the venmo experience
            if (!$scope.auth.refresh_token) {
                var merchant_name = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name || $scope.checkoutAppData.merchant.merchant_email;

                $scope.infoVenmo = {
                    msgs: [(0, _squid.$renderContent)('landing.venmoAvailableSoon', { 'merchant': merchant_name })],
                    type: 'info'
                };

                var venmoPayloadID = window.xprops && window.xprops.venmoPayloadID;

                // if nativeSDK and SPB prop for payload_id exists, we go directly to venmo directive
                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo && venmoPayloadID) {

                    return _uiRouter.$state.go('checkout.venmo', { payload_id: venmoPayloadID });
                }

                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo) {
                    return _uiRouter.$state.go('checkout.payWithSelection');
                } else if (!_uiRouter.$stateParams.venmoError && _thirdPartyInfo.thirdPartyInfo.isVenmoCookiePresent()) {
                    $scope.showVenmoAvailableSoonMsg = true;
                }

                if (_uiRouter.$stateParams.venmoError && _squid.$util.param('marketplaces_venmo_client') === '1') {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    _index6.$ReturnToMerchant.goTo(cancel_url);
                }

                // Baidu eligibility checks. Pending pxp throttle
                return _thirdPartyInfo.thirdPartyInfo.isBaiduEligible().then(function (baiduEligible) {
                    if (!_uiRouter.$stateParams.baiduError && baiduEligible) {
                        return (0, _squid.$pxp)('xo_hermesnode_baidu', {
                            'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                            'uid': $scope.checkoutPayeeModel.getId()
                        }, '(xo_hermesnodeweb_baidu)(.*)').then(function (result) {
                            if (result && result.treatment_name === 'xo_hermesnodeweb_baidu_treatment_4660') {
                                return _uiRouter.$state.go('checkout.payWithSelection');
                            }
                        });
                    }
                });
            }
            if ($scope.flowEligibility.guest) {
                return;
            }

            $('.paypalHeaderWrapper').removeClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            var initKmliAndDeleteAT = function initKmliAndDeleteAT() {
                delete $scope.auth.access_token;
                _kmliUpsell.$KmliUpsell.init({});
            };

            // reload auth model for use cases where user is not logged in and access_token is in the hash
            // happens already in the middleware
            // basically if there is a param "euat" - there will be access token in the hash
            // otherwise I don't think we need to reload Auth model if user is logged in already
            if ($scope.auth.accessToken() && !$scope.auth.loggedIn()) {
                return $scope.auth.reload({
                    headers: {
                        'x-paypal-internal-euat': $scope.auth.accessToken()
                    },
                    resultModel: $scope.auth,
                    success: function success() {
                        initKmliAndDeleteAT();
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            } else if ($scope.auth.loggedIn()) {
                initKmliAndDeleteAT();
            }
        }).then(function () {
            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logoutAndRedirect('NOT_YOU');
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_miniBrowser.$miniBrowser;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_kmliUpsell.$KmliUpsell;

_index2.$TokenizedFundingCapabilitiesModel;

_index2.$TokenizedWalletEligibilityModel;

_index2.$TokenizedWalletInfoModel;

_index2.$TokenizedWalletMsbOfferModel;

_index2.$TokenizedWalletPinModel;

_index3.$UserProductSubscriptionModel;

_auth.$AuthModel;

_index4.$CheckoutAppDataModel;

_index4.$CheckoutCartModel;

_index4.$CheckoutPayeeModel;

_index4.$CheckoutSessionModel;

_index4.$FlowEligibilityModel;

_index5.$WalletPreferences;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_user.$EConsentModel;

_venmoModels.$VenmoTransactionEligibility;

_index6.$ReturnToMerchant;

_thirdPartyInfo.thirdPartyInfo;

_utils.checkVaultingEligibility;

_utils.authorize;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_util.$capeRedirectUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/guestThrottle.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

function $guestThrottle(flowName, token, lang, country, mfid) {

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country,
            mfid: mfid
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function isGuestFlowEnabled() {
        return _angular.$q.resolve(true);
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$q;

_logger.$logger;

_squid.$dispatch;

_squid.$FallbackError;

/***/ }),

/***/ "./pages/xo-login/loginEligibility.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$forceLoginExperience = $forceLoginExperience;
exports.$loginEligibility = $loginEligibility;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _index3 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

function $forceLoginExperience(auth, merchant_country, forcedLogin) {
    var ULParam = _squid.$util.param('ul');

    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
        var ulReturn = _squid.$util.param('ulReturn');

        return {
            experience: 'apsIntegration',
            reason: ulReturn ? 'ulReturn' : 'sessionActive'
        };
    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
        return {
            experience: 'apsIntegration',
            reason: 'ulParamDisabled'
        };
    } else if (ULParam && ULParam.match(/[12]/)) {
        return {
            experience: 'unifiedLogin',
            reason: 'ulParam'
        };
    } else if (ULParam === '3') {
        return {
            experience: 'apsIntegrationRM',
            reason: 'ulParamApsRM'
        };
    } else if (auth.refreshToken()) {
        return {
            experience: 'unifiedLogin',
            reason: 'rememberedUser'
        };
    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
        return {
            experience: 'unifiedLogin',
            reason: 'internalIP'
        };
    }
}

function $loginEligibility(token, forcedLogin) {
    var $scope = {};

    $scope.token = token;

    var routingReason = void 0;

    return (0, _squid.$populate)($scope, {
        auth: _index2.$AuthModel.instance(),
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
    }).then(function () {
        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
        var isIneligible = angular.isDefined(forceLoginExperience);

        // Check login param for hercules, otherwise, always using UL
        if (isIneligible) {
            routingReason = forceLoginExperience.reason;
            return forceLoginExperience.experience;
        } else {
            return 'unifiedLogin';
        }
    }).then(function (finalLoginExperience) {
        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
            userGroup: [routingReason],
            routing_reason: routingReason
        });

        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();

        _logger.$logger.info('checkout_fpti', {
            'from': 'UL_ELG_CHK',
            'to': 'process_ul_elg_chk',
            'routing_reason': routingReason,
            'app_int_type': app_int_type
        });

        return finalLoginExperience;
    });
}

angular.value("$forceLoginExperience", $forceLoginExperience);
angular.value("$loginEligibility", $loginEligibility);
_squid.$util;

_squid.$meta;

_squid.$config;

_squid.$feature;

_squid.$populate;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index2.$AuthModel;

_index3.$DeviceInfo;

/***/ }),

/***/ "./pages/xo-login/onboarding/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _guestThrottle = __webpack_require__("./pages/xo-login/guestThrottle.js");

var _paypalplus = __webpack_require__("./pages/xo-login/paypalplus.js");

__webpack_require__("../node_modules/xo-wallet-components/src/fi-logos/directive.js");

var _template = __webpack_require__("./pages/xo-login/onboarding/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    controller: ['$scope', function ($scope) {
        function throttleOnboardingFlow(flow) {
            return (0, _guestThrottle.$guestThrottle)(flow, $scope.token, _squid.$locale.lang, _squid.$locale.country, _squid.$meta.mfid);
        }

        $scope.signupThrottle = function () {
            if ($scope.forceCAPESignup) {
                _logger.$logger.info('redirecting_to_cape_acq_signup_throttle', {
                    showCapeCyco: $scope.showCapeCyco
                });

                return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: $scope.showCapeCyco });
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        function getFlowEligibility() {
            return _checkout.$FlowEligibilityModel.instance($scope.token).retrieve({
                params: {
                    'localeCountry': _squid.$locale.country
                }
            }).then(function (flowEligibility) {
                $scope.flowEligibility = flowEligibility;
            });
        }

        function getButtonLabelTreatment() {
            $scope.newUserVariant = false;
            $scope.newUserVariantWithText = false;

            return (0, _squid.$pxp)('xo_hermes_new_user', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_new_user_treatment_(a|b)', false, true).then(function (t) {
                if (t) {
                    $scope.newUserVariant = true;
                    if (t.treatment_name === 'xo_hermes_new_user_treatment_b') {
                        $scope.newUserVariantWithText = true;
                    }
                }
            });
        }

        function getPPCEZPTreatment() {
            $scope.showCapeCyco = false;

            return (0, _squid.$elmo)('xo_us_ppc_ezp', {
                'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                'ctx.merchantID': $scope.payee.get('merchant.id')
            }, 'Trmt_xo_us_ppc_.*', false, true).then(function (t) {
                if (t) {
                    if (t && t.treatment_name) {
                        $scope.showCapeCyco = true;
                    }
                }
            });
        }

        (0, _squid.$populate)($scope, {
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            return getFlowEligibility();
        }).then(function () {
            return getPPCEZPTreatment();
        }).then(function () {
            return getButtonLabelTreatment();
        }).then(function () {
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            $scope.forceCAPESignup = isPayPalCredit && !$scope.creditDataModel.payInFull;

            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && guest;
            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }]
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_uiRouter.$state;

_credit.$CreditDataModel;

_squid.$Class;

_squid.$Component;

_squid.$elmo;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_logger.$logger;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$FlowEligibilityModel;

_guestThrottle.$guestThrottle;

_paypalplus.$isPayPalPlus;

/***/ }),

/***/ "./pages/xo-login/onboarding/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"onboardingSection\" id=\"onboardingSection\" content>\n    <div class=\"guestHeading\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <xo-title title-txt=\"{{content('login.guestTitle')}}\"></xo-title>\n        <xo-language-options class=\"span7\"></xo-language-options>\n    </div>\n\n    <div class=\"orSeparator\" ng-if=\"!hideOrSeparator\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n\n    <a link-button track-link=\"guest\" class=\"btn btn-secondary full submit\" id=\"checkoutAsAGuestBtn\" ng-if=\"showGuestBtn\" ng-click=\"guestThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.guestLinkBtn') }}\n    </a>\n\n    <a link-button track-link=\"signup\" class=\"btn btn-secondary full submit\" id=\"signupBtn\" ng-if=\"showSignupBtn\" ng-click=\"signupThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.createAccount') }}\n    </a>\n\n    <div class=\"inline-prop\" ng-if=\"newUserVariantWithText\" ng-bind-html=\"content('login.guestProp')\"></div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/paypalplus.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$isPayPalPlus = $isPayPalPlus;

var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

function $isPayPalPlus(token) {
    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
    return experienceInitiator === 'PAYPAL_PLUS';
}

angular.value("$isPayPalPlus", $isPayPalPlus);
_index.$CheckoutAppDataModel;

/***/ }),

/***/ "./pages/xo-login/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LoginRoute = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

__webpack_require__("./pages/xo-login/directive.js");

var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {
    path: 'login',
    directive: 'xo-login-page',
    query: ['venmoError'],
    params: {
        targetPage: null,
        source: null,
        showNotYou: null
    },
    auth: false,
    titleContent: 'base.logIn',
    trackingData: {
        fptiState: 'login',
        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
        templateName: 'login.dust',
        pageGoal: 'Payment Start',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-login',
                'pagename2': '%::fullpage-login:member:hermes:',
                'version': 'member:%:'
            },
            'ulLogin': {
                'pagename': '%::fullpage-ullogin',
                'pagename2': '%::fullpage-ullogin:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: []
});

angular.value("$LoginRoute", $LoginRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "./pages/xo-login/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"login\"\n         id=\"login\" content>\n    <xo-message ng-if=\"showVenmoAvailableSoonMsg\" message=\"infoVenmo\"></xo-message>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n\n            <!--\n                SetBuyer Batch call is dependent on data from various models such as CheckoutCartDataModel etc.\n                Use of populateComplete flag ensures that the directive doesn't fire off until the required data is available.\n                Note that the flow works even without this flag in most cases since the code has failsafe paths\n                [ though they may be getting triggered due to insufficient and not the right data ]\n            -->\n\n            <xo-login-handler ng-if=\"populateComplete\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                              contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                              aps-integration=\"apsIntegration\" batch=\"batch\"\n                              login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\"></xo-login-handler>\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n            <xo-onboarding-section token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n\n    <xo-tokenized-wallet-loader\n        ng-if='isWalletTokenization'\n        plan-done='planDone'\n    >\n    </xo-tokenized-wallet-loader>\n</section>\n"

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoTokenizedWalletLoader = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _factory = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/factory.js");

__webpack_require__("../node_modules/xo-ui-components/src/card-loader/directive.js");

var _template = __webpack_require__("./pages/xo-login/tokenized-wallet-loader/template.html");

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ANIMATION_STATUSES = {
    NOT_STARTED: 'notStarted',
    PENDING: 'pending',
    COMPLETED: 'completed'
};

// card loader component - used only in tokenized wallet flows.
var $xoTokenizedWalletLoader = exports.$xoTokenizedWalletLoader = _squid.$Component.extend('$xoTokenizedWalletLoader', {
    tag: 'xo-tokenized-wallet-loader',
    template: _template2['default'],
    props: {
        planDone: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve()['catch'](_angular.noop)
            };
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.auth = _auth.$AuthModel.instance();
            // start animation of the card
            this.setbuyerProgress = ANIMATION_STATUSES.NOT_STARTED;
            _logger.$logger.info('tokenized_wallet', {
                from: 'adding_pp_ap_animation',
                to: 'prepare_adding_pp_ap_animation',
                context_id: _angular.$rootScope.token,
                context_type: 'EC-Token',
                billing_token: _squid.$meta.baToken
            });

            // sets animation state to 80%
            (0, _angular.$timeout)(function () {
                _this.setbuyerProgress = ANIMATION_STATUSES.PENDING;
                _logger.$logger.info('tokenized_wallet', {
                    from: 'adding_pp_ap_animation',
                    to: 'process_adding_pp_ap_animation',
                    context_id: _angular.$rootScope.token,
                    context_type: 'EC-Token',
                    billing_token: _squid.$meta.baToken
                });
            }, 300);

            // watch when planning is completed in xo-login/directive
            // to redirect to "checkout.tokenizationInfo" page
            this.$watch('planDone', function (planDone) {
                if (planDone) {
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                }
            });
        },
        populate: function populate() {
            this.cardLoaderMessage = _factory.$TokenizedWalledLoaderFactory.getCardLoaderMessage(this.models.tokenizedWalletInfoModel);
            this.logoClass = this.models.tokenizedWalletInfoModel.getSubject();
        }
    }
});

angular.value("$xoTokenizedWalletLoader", $xoTokenizedWalletLoader);
_squid.$Component;

_squid.$meta;

_logger.$logger;

_angular.$timeout;

_angular.$rootScope;

_angular.noop;

_auth.$AuthModel;

_app.$TokenizedWalletInfoModel;

_factory.$TokenizedWalledLoaderFactory;

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedWalledLoaderFactory', function () {
    var goToTokenizationInfoPage = function goToTokenizationInfoPage() {
        _logger.$logger.info('tokenized_wallet', {
            'from': 'PP_AndroidPay_Info',
            'to': 'prepare_PP_AndroidPay_Info',
            'context_id': _angular.$rootScope.token,
            'context_type': 'EC-Token',
            'billing_token': _squid.$meta.baToken
        });
        $('#outerWrapper').addClass('tokenization');
        _uiRouter.$state.go('checkout.tokenizationInfo');
    };

    var getCardLoaderMessage = function getCardLoaderMessage(tokenizedWalletInfoModel) {
        return (0, _squid.$renderContent)('topup.commonAdding', {
            type: tokenizedWalletInfoModel.brandName()
        }).toString();
    };

    return {
        goToTokenizationInfoPage: goToTokenizationInfoPage,
        getCardLoaderMessage: getCardLoaderMessage
    };
});

_uiRouter.$state;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login/tokenized-wallet-loader", "pages/xo-login/tokenized-wallet-loader/factory.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "./pages/xo-login/tokenized-wallet-loader/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"infoLoader\">\n    <div class='logo_wrapper'>\n        <div class='partner_logo' ng-class=\"[logoClass]\"></div>\n    </div>\n    <div class=\"loader\">\n        <xo-card-loader\n            state=\"setbuyerProgress\"\n            auth=\"auth\"\n            message=\"{{cardLoaderMessage}}\"\n        ></xo-card-loader>\n    </div>\n</div>\n"

/***/ }),

/***/ "./pages/xo-login/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$capeRedirectUtil', function () {
    return {
        handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
            var checkoutAppData = _checkout.$CheckoutAppDataModel.instance(token);
            var checkoutCartModel = _checkout.$CheckoutCartModel.instance(token);
            var checkoutPayeeModel = _checkout.$CheckoutPayeeModel.instance(token);
            var creditDataModel = _credit.$CreditDataModel.instance(token);
            var selectedInstallmentModel = _credit.$CreditInstallmentModel.instance(token); // Only tracks selected financing option
            var merchantCountry = checkoutAppData.get('merchant.merchant_country');

            (0, _angular.$q)(function (resolve, reject) {
                if (checkoutAppData.isSecondButton()) {

                    _angular.$q.all([(0, _squid.$elmo)('xo_us_ppc_ezp', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': checkoutPayeeModel.getId()
                    }, 'Trmt_xo_us_ppc_.*', false, true), (0, _squid.$elmo)('xo_gb_ppc_cape_cyco', {
                        'ctx.COUNTRY': merchantCountry,
                        'ctx.merchantID': checkoutPayeeModel.getId()
                    }, 'Trmt_xo_gb_ppc_cape_cyco', false, true)]).then(function (_ref) {
                        var ppcEZPRes = _ref[0],
                            redirectToCape = _ref[1];

                        resolve({ ppcEZPRes: ppcEZPRes, redirectToCape: redirectToCape });
                    })['catch'](function (err) {
                        reject(err);
                    });
                } else {
                    resolve();
                }
            }).then(function (_ref2) {
                var ppcEZPRes = _ref2.ppcEZPRes,
                    redirectToCape = _ref2.redirectToCape;

                var fundingInstruments = void 0;
                var isCreditInWallet = void 0;

                var redirectToCapeCyco = redirectToCape || ppcEZPRes;
                var ppcEZPTreatment = ppcEZPRes && ppcEZPRes.treatment_name;
                var redirectToCapeCycoTreatment = redirectToCape && redirectToCape.treatment_name;

                _logger.$logger.info('checkout_fpti', {
                    'xo_us_ppc_ezp': ppcEZPTreatment ? ppcEZPTreatment : 'Ctrl_xo_us_ppc_cape_cyco'
                });

                _logger.$logger.info('checkout_fpti', {
                    'xo_gb_ppc_cape_cyco': redirectToCapeCycoTreatment ? redirectToCapeCycoTreatment : 'Ctrl_xo_gb_ppc_cape_cyco'
                });

                if (checkoutCart.isBillingNoPurchase()) {
                    fundingInstruments = checkoutSession.futurePaymentInstruments;
                    isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
                } else {
                    fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                    isCreditInWallet = fundingInstruments && _squid.$util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });
                }

                var isCapeReturnKey = creditDataModel.getCapeKey();
                var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');
                var isPPCEligible = checkoutSession.creditOffer;

                if (_squid.$locale.country !== checkoutAppData.get('merchant.merchant_country')) {
                    creditDataModel.setCrossBorder(true);
                }

                function handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment) {
                    // User does not have any FI in wallet but they choose to pay in full.
                    // Show add card contingency page instead of redirecting to CAPE.
                    if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
                        return _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                    }

                    // Handle return from CAPE
                    else if (isCapeReturn || creditDataModel.payInFull) {
                            return _uiRouter.$state.go('checkout.review');
                        }

                        // CYCO and Login swap
                        else if (!redirectToCapeCyco && checkoutAppData.isSecondButton() && hasInstallmentOptions && !hasThreeMonthInstallment) {
                                // Redirect to CYCO for reuse & acq 2nd button
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            }

                            // CYCO and Login swap
                            else if (checkoutAppData.isSecondButton() && hasInstallmentOptions) {
                                    // Redirect to CYCO for reuse & acq 2nd button with installments
                                    if (!redirectToCapeCyco && !hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_cyco_2nd_button');
                                        return _uiRouter.$state.go('checkout.chooseCreditOffer');
                                    } else if (isCreditInWallet && !redirectToCapeCyco && hasThreeMonthInstallment) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    } else {
                                        var showCapeCyco = Boolean(redirectToCapeCyco);

                                        _logger.$logger.info('redirecting_to_cape_cyco_2nd_button', {
                                            showCapeCyco: showCapeCyco,
                                            hasThreeMonthInstallment: hasThreeMonthInstallment
                                        });

                                        return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: showCapeCyco });
                                    }
                                }

                                // Reuse scenario
                                else if (isCreditInWallet) {
                                        _logger.$logger.info('redirecting_to_review_reuse_2nd_button');
                                        return _uiRouter.$state.go('checkout.review');
                                    }

                                    // Acquisition scenario
                                    else if (isPPCEligible) {
                                            var _showCapeCyco = Boolean(redirectToCapeCyco) && hasInstallmentOptions;

                                            _logger.$logger.info('redirecting_to_cape_acq_2nd_button', {
                                                showCapeCyco: _showCapeCyco,
                                                hasThreeMonthInstallment: hasThreeMonthInstallment,
                                                hasInstallmentOptions: hasInstallmentOptions
                                            });

                                            return _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: _showCapeCyco });
                                        } else {
                                            // show error message
                                            return _uiRouter.$state.go('checkout.review');
                                        }
                }

                // 2nd button, cross border, installment offer selected in API -- we cannot honor any offer the user chose, so must clear offer
                if (checkoutAppData.isSecondButton() && creditDataModel.isCrossBorder() && selectedInstallmentModel.get('meta.populated')) {
                    selectedInstallmentModel.action('delete', {
                        success: function success(result) {
                            _logger.$logger.info('patch_cart_installment_success');
                            _credit.$CreditInstallmentModel.create(token); // Clear cache for this token
                            handleRedirect(false, false);
                        },
                        error: function error(err) {
                            _logger.$logger.error('patch_cart_installment_fail', err);
                            _uiRouter.$state.go('checkout.genericError', {
                                code: 'DELETE_CREDIT_OPTION_ERROR'
                            });
                        }
                    });
                } else {
                    var offers = new _credit.$CreditInstallmentOptionsModel({
                        id: token,
                        payee: checkoutPayeeModel,
                        checkoutCart: checkoutCartModel,
                        checkoutAppData: checkoutAppData,
                        isMemberCredit: true
                    });

                    return offers.save({
                        cache: true,
                        success: function success(result) {
                            var hasInstallmentOptions = offers.getInstallmentOptionsPresent();
                            var installmentOfferDetails = offers.getInstallmentOffers();

                            installmentOfferDetails = installmentOfferDetails && installmentOfferDetails.installment_options;

                            var threeMonthFinancingCodeArray = (0, _squid.$feature)('threeMonthFinancingCode') ? (0, _squid.$feature)('threeMonthFinancingCode').toString().split(',') : [];
                            var installmentOfferDetailsArray = installmentOfferDetails ? installmentOfferDetails.map(function (item) {
                                return item.financingCode;
                            }) : [];
                            var hasThreeMonthInstallment = Boolean(installmentOfferDetailsArray.filter(function (value) {
                                return threeMonthFinancingCodeArray.includes(value);
                            }).length > 0);

                            handleRedirect(hasInstallmentOptions, hasThreeMonthInstallment);
                        }
                    });
                }
            });
        }
    };
});

_angular.$q;

_squid.$util;

_squid.$locale;

_squid.$elmo;

_squid.$feature;

_uiRouter.$state;

_logger.$logger;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditInstallmentOptionsModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login", "pages/xo-login/util.js"))

/***/ }),

/***/ "./pages/xo-review/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__("../node_modules/jquery/dist/jquery.min.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _index = __webpack_require__("./js/lib/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _integration = __webpack_require__("./js/lib/integration.js");

var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");

var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");

var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");

var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _kmliUpsell = __webpack_require__("../node_modules/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");

var _utils = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/utils.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _fiApis = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");

var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");

var _index3 = __webpack_require__("../node_modules/xo-models/src/fiMeta/index.js");

var _index4 = _interopRequireDefault(_index3);

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _fiMessages = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiMessages.js");

var _donation = __webpack_require__("../node_modules/xo-models/src/donation/index.js");

var _bml = __webpack_require__("../node_modules/xo-models/src/bml/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _experiments = __webpack_require__("../node_modules/xo-models/src/experiments/index.js");

var Experiments = _interopRequireWildcard(_experiments);

var _marketingoffer2 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");

var _newMember = __webpack_require__("../node_modules/xo-models/src/newMember/index.js");

var _shippingMethod = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _factory = __webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/factory.js");

var _factory2 = __webpack_require__("../node_modules/xo-member-components/src/no-balance/factory.js");

var _factory3 = __webpack_require__("../node_modules/xo-member-components/src/rewards-checkbox/factory.js");

var _factory4 = __webpack_require__("../node_modules/xo-member-components/src/show-more-fi/factory.js");

var _factory5 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/factory.js");

var _factory6 = __webpack_require__("../node_modules/xo-address-components/src/address-normalization-edit/factory.js");

__webpack_require__("../node_modules/xo-title/dist/directive.js");

__webpack_require__("../node_modules/xo-styles/dist/lib/toggle.less");

__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");

__webpack_require__("../node_modules/xo-wallet-components/src/3ds/directive.js");

__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/directive.js");

__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");

__webpack_require__("../node_modules/xo-form-components/src/select-shipping-method/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-offer-top-banner/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/bml-display/xo-bml-popup/directive.js");

__webpack_require__("../node_modules/xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/no-balance/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-topup/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-address/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/review-paywith/directive.js");

__webpack_require__("../node_modules/xo-member-components/src/give-at-checkout/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/notYou/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/messenger-plugin/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-baidu/directive.js");

__webpack_require__("../node_modules/xo-third-party-components/src/review-paywith-venmo/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/sticky-cta/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/expired-message/directive.js");

__webpack_require__("../node_modules/xo-ui-components/src/user-assist-banner/directive.js");

var _cardartInstrument = __webpack_require__("./pages/services/cardart-instrument/index.js");

var _factory7 = __webpack_require__("./pages/xo-select-fi/factory.js");

var _factory8 = __webpack_require__("./pages/xo-review/factory.js");

var _tokenizedFactory = __webpack_require__("./pages/xo-review/tokenizedFactory.js");

var _shippingChangeFeature = __webpack_require__("./pages/xo-review/lib/shippingChangeFeature.js");

var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");

var _template = __webpack_require__("./pages/xo-review/template.html");

var _template2 = _interopRequireDefault(_template);

__webpack_require__("../node_modules/xo-page-components/src/cpa-disclaimer/directive.js");

__webpack_require__("../node_modules/xo-page-components/src/decline-notification/directive.js");

__webpack_require__("./pages/xo-review/styles.less");

var _sharedUtil = __webpack_require__("./pages/services/shared-util/index.js");

var _balance = __webpack_require__("./pages/services/balance/index.js");

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Create payload that contains relevant data about the checkout state at review page
function createReviewFptiPayload(_ref) {
    var checkoutSession = _ref.checkoutSession,
        _ref$isProcessTransit = _ref.isProcessTransition,
        isProcessTransition = _ref$isProcessTransit === undefined ? false : _ref$isProcessTransit;

    var payload = {
        shipping_address_id: checkoutSession.get('shipping.id')
    };

    if (checkoutSession.get('plan.conversion') && !isProcessTransition) {
        payload.currency_conversion_type = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.is_conversion_shown = checkoutSession.get('plan.conversion.changeable') ? 1 : 0;
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    } else if (checkoutSession.get('plan.conversion') && isProcessTransition) {
        payload.currency_conversion_selected = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    }
    if (_factory3.$RewardsCheckboxFactory.rewardsFound()) {
        var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(checkoutSession.plan);

        payload.fi_id = (0, _utils.getInstrumentID)(checkoutSession.plan);
        payload.rewards_type = contentKeys.issuerName;
        payload.rewards_amt = contentKeys.value.rewardAmount; // monetary amount
        if (!isProcessTransition) {
            payload.rewards_fi = _factory3.$RewardsCheckboxFactory.toString();
        }
    }
    if (checkoutSession.plan.sources && checkoutSession.plan.sources[0].isBillingPreferred) {
        payload.default_funding_option = checkoutSession.plan.sources[0].instrument_id;
    }
    payload.chosen_funding_option = checkoutSession.plan.primaryFs || checkoutSession.plan.sources ? (0, _utils.getInstrumentID)(checkoutSession.plan) : '';
    return payload;
}

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {
        redirectiframe: '=?',
        redirectLightbox: '=?'
    },
    actions: {
        handleCancelApplicationModalClick: function handleCancelApplicationModalClick(event) {
            // if click anywhere else except X button on modal, do nothing
            if (event.target.className !== 'close ng-scope') {
                event.preventDefault();
            }
        },
        closeCancelApplicationModal: function closeCancelApplicationModal() {
            this.showCancelApplicationModal = false;
        },
        openCancelApplicationModal: function openCancelApplicationModal() {
            this.showCancelApplicationModal = true;
        },
        updatePreferredFi: function updatePreferredFi(logger) {
            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
                var PreferredFi = new _fi.$PreferredFi({
                    preferred: [this.makeFiPreferred.fiId]
                });

                logger.info('checkout_fpti', { 'pref_fi_set': '1' });
                return PreferredFi.save({
                    transientError: true,
                    contingencies: {
                        DEFAULT: function DEFAULT() {}
                    }
                });
            }

            logger.info('checkout_fpti', { 'pref_fi_set': '0' });

            return _angular.$q.when();
        },
        onThreedsModalClose: function onThreedsModalClose() {
            this.showThreedsPopup = false;
        }
    },
    resolve: {},
    lifecycle: {
        reenter: function reenter() {
            var _this = this;

            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }

            // Reset the selectedmethod indicator and state change listener
            if (this.setupMultipleFi) {
                this.setupMultipleFi();
            }

            var instrumentId = this.checkoutSession.get('fundingOptions.plans.0.primaryFs.id');

            // For CPA, if we reenter, e.g. from sidebar, into review page, we need to send the fundingOption plan
            // so the CPA disclaimer can be refreshed if plan changes. e.g. 2 page variant in PP Balance scenario.
            this.primaryplan = this.checkoutSession.get('fundingOptions.plans.0');

            // If FS has changed due to an update, reset the preferred FI checkbox
            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== instrumentId) {
                _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
                this.makeFiPreferred.selected = false;
            }

            this.topupError = false; // set default value to false (hide error when enter)

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: this.checkoutSession })));

            // TODO: turn off `xo_hermes_preferred_expired_msg_review_page` since currently
            // it's not running. However, AuthRate team will be running this experiement again
            // this.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg(
            //     this.isNmj,
            //     this.checkoutSession
            // );

            // if (this.showExpiredMsg) {
            //     $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
            //         this.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
            //         this.preferredExpired = this.checkoutSession.getDisallowedPreferred();
            //     });
            // }
            (0, _xoShippingOptions.getShippingOptions)(this.token).then(function (shippingOptions) {
                _this.shippingOptions = shippingOptions;
            });

            // On re-enter to review page once after payment Method updated, forced to reset the cvv fields.
            if (msgKeys.indexOf('paymentMethod.paymentMethodUpdated') !== -1) {
                this.resetCVVContigency({ flow: 'page_refresh' });
            }

            _balance.$BalanceEligibilityFactory.init({ checkoutSession: this.checkoutSession }).then(function (currentState) {
                var eligibility = currentState.eligibility;

                if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                    _this.checkoutSession.message = {
                        type: 'info',
                        msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                    };
                    _logger.$logger.info('reivew_page_reenter_render_cip_incomplete_message');
                }
            });
        },
        populate: function populate() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('#outerWrapper').addClass('tokenization topup');
                var windowHeight = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
                var footerHeaderHeight = document.querySelector('xo-header .paypalHeader').clientHeight + document.querySelector('xo-footer .footer').clientHeight;

                document.querySelector('.review .reviewTopup').style.minHeight = windowHeight - footerHeaderHeight - 5 + 'px'; // 5px for header/footer alignment
            }

            if (_squid.$locale.country === 'DE' && this.checkoutSession.creditOffer) {
                this.installment.showPPCAcquisitionRadioButton = true;
            }
        },
        exit: function exit() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('.tokenization').removeClass('topup');
            }
            _factory3.$RewardsCheckboxFactory.destroy();
        }
    },
    controller: ['$scope', '$element', function ($scope, $element) {
        // storing the buyer language on entry to review page
        // this is getting used when there is a language toggle for RTR (some other flows in future)
        $scope.buyerProfileLanguage = _squid.$locale.lang;
        $scope.choiceBalanceCheckboxState = _factory7.$BalanceFactory.get();
        $scope.tokenizedFactoryState = _tokenizedFactory.$TokenizedFactory.get();
        $scope.noBalanceFactoryState = _factory2.$NoBalanceFactory.get();
        $scope.vault = { checked: true };

        $scope.creditSharedInfo = _credit.$CreditSharedInfoModel.instance();

        $scope.isThirdPartyWalletExperience = function () {
            var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);

            return experience === 'BAIDU_EXPERIENCE' || experience === 'VENMO_EXPERIENCE';
        };

        $scope.determineThirdPartyWalletExperience = function () {
            return _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
        };

        $scope.creditParentContext = {
            populated: false,
            newMember: {},
            showCreditOffer: true // Flag for experimenting with display of the Credit Offer based on CEP
        };

        $scope.showCreditDisallowedMessage = function () {
            var isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;
            return isCreditDisallowedForMerchant && !_angular.$rootScope.showFiSelectPage;
        };

        $scope.creditDisallowedMessage = {
            type: 'info',
            msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
        };

        $scope.memberSegment = _marketingoffer2.$MemberSegmentModel.instance();

        $scope.isPPCReuseAndNotSelected = function () {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && !fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };
        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

        $scope.isDEInstallmentsApproved = function () {
            var deInstallmentsPlanSelected = false;
            if (_squid.$locale.country === 'DE') {
                var plans = $scope.checkoutSession.getPlanList();
                if (plans) {
                    deInstallmentsPlanSelected = plans.filter(function (p) {
                        return p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'BILL_ME_LATER' && p.selected;
                    }).length > 0;
                }
            }
            // User got approved in CAPE if the DE installments plan is selected - return true
            if (deInstallmentsPlanSelected) {
                return true;
            }
            return false;
        };

        $scope.showCreditPlacement = function () {
            // for xo-offer handling
            $scope.creditParentContext.newMember.creditOffer = $scope.memberSegment && $scope.memberSegment.creditOffer;

            var show = !$scope.isThirdPartyWalletExperience() && $scope.creditParentContext.populated && $scope.creditParentContext.showCreditOffer && !_angular.$rootScope.showFiSelectPage && ($scope.checkoutSession.creditOffer || $scope.isPPCReuseAndNotSelected()) && !$scope.isMessengerBAIntegration && _squid.$locale.country !== 'DE' && !isUSCrossCurrency();

            return show;
        };

        $scope.showRepresentativeExample = function () {
            function isPPCNotSelected() {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                var selectedFi = plans && plans.find(function (fi) {
                    return fi.selected;
                });

                return !(selectedFi && selectedFi.name === 'BILL_ME_LATER');
            }

            return _squid.$locale.country === 'GB' && !(_angular.$rootScope.showFiSelectPage && isPPCNotSelected()) && $scope.creditSharedInfo.shouldShowCreditExample();
        };

        $scope.isProcessorDeclineExperiment = false;

        var applyNewMemberVariant = function applyNewMemberVariant() {
            return _newMember.$NewMemberEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // feature flag for one page nmj experience
                var isNmjDesign1 = $scope.isNmjDesign1 = variant === 'one_page';
                // feature flag for one page nmj design 2 experience
                var isNmjDesign2 = $scope.isNmjDesign2 = variant === 'design_2';
                // feature flag for one page nmj design 3 experience
                var isNmjDesign3 = $scope.isNmjDesign3 = variant === 'design_3';
                // umbrella flag for nmj experience
                var isNmj = $scope.isNmj = isNmjDesign1 || isNmjDesign2 || isNmjDesign3;

                $scope.showViewYourPaymentRights = (isNmjDesign2 || isNmjDesign3) && _squid.$locale.country === 'US';
                $scope.showGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;
                $scope.nmjExperience = {
                    one_page: $scope.isNmjDesign1,
                    design_2: $scope.isNmjDesign2,
                    design_3: $scope.isNmjDesign3
                };

                // set assist-banner content based on type of nmj flow - if any
                var isPayNow = $scope.useraction === 'commit';
                var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                if (isNmjDesign1) {
                    $scope.assistBannerHeader = _squid.$locale.content.get('memberReview.assistHeader_1page');
                    $scope.assistBannerBody = _squid.$locale.content.get(isPayNow ? 'memberReview.assistBody_paynow_1page' : 'memberReview.assistBody_continue_1page');
                } else if ($scope.showGreyHeader) {
                    if (isPayNow) {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgPayNow', { userName: userName });
                    } else {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgContinue', { userName: userName });
                    }
                }
                $scope.creditParentContext.newMember.variant = variant;
                $scope.creditParentContext.newMember.useCEPDecision = isNmj;
                $scope.creditParentContext.populated = true;
                $scope.showPaypalPolicy = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && !$scope.showViewYourPaymentRights;
                $scope.showPaymentRights = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && $scope.showViewYourPaymentRights;
                _logger.$logger.info('member_ryi_variant_' + (variant || 'unknown'), {
                    isNmj: isNmj,
                    variant: variant
                });
                triggerPersonalizedBanner();
            });
        };

        var triggerPersonalizedBanner = function triggerPersonalizedBanner() {
            $scope.personalizedBanner.trigger();
        };

        if ($scope.isThirdPartyWalletExperience()) {
            // log buyer type for third Party usecases
            _logger.$logger.info('buyer_info', {
                fpti_buyer_type: $scope.determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE' ? 'Guestuser_venmo' : 'nonloginmember_benteley'
            });
        } else {
            // log existing buyer
            _logger.$logger.info('buyer_info', { fpti_buyer_type: 'Existinguser' });
        }

        // ----------------- OUTRO PXP VARS - START -------------------- //
        // NOTES: `xo_hermes_exit_msg` pxp has ramped to 100% and will always
        // return `xo_hermes_exit_msg_option5` treatment.
        // See: https://engineering.paypalcorp.com/pxptool/configuration?exptId=2609&version=9
        var pxpMerchNameLimit = 20; // max length of the merchant name
        var pxpMerchName = void 0; // the brand or merchant name - resolved after retrieving appdata

        // ----------------- OUTRO PXP VARS - END -------------------- //
        $scope.token = _angular.$rootScope.token;
        $scope.backUri = 'checkout.review';
        $scope.installmentNotSelected = false;
        $scope.installment = {
            showBanner: false,
            showCYCO: false,
            showCreditExample: false,
            financing_details: null
        };

        // PAD Toggle feature
        $scope.padToggleFeature = {
            applicable: false,
            checkboxEnabled: false,
            showCheckbox: false,
            defaultPlan: false,
            pxpControlEnabled: false,
            fptiLogged: false,
            multiFiCheckboxStates: {}
        };

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };
        $scope.isGCcountry = (_squid.$config.giftCardSupportedCountries || '').indexOf(_squid.$locale.country) > -1;
        $scope.showPaypalPolicies = (0, _squid.$featureCountries)('showPaypalPolicies').indexOf(_squid.$locale.country) > -1;
        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };
        $scope.showPolicyAgreement = (0, _squid.$feature)('showPolicyAgreement');

        var _ref2 = window.xprops || {},
            _ref2$experience = _ref2.experience,
            experience = _ref2$experience === undefined ? { facebook: false, autoBA: false } : _ref2$experience;

        $scope.isFacebookBAIntegration = experience.facebook;

        $scope.personalizedBanner = {
            show: false,

            trigger: function trigger() {
                var isOneTouchBanner = $scope.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
                var newMemberDesign1 = $scope.isNmjDesign1;

                $scope.personalizedBanner.show = newMemberDesign1 || isOneTouchBanner || $scope.auth.isFBSkipLogin();

                // for Facebook skip login set isFBSkipLogin as true to modify the skip login content
                $scope.personalizedBanner.isFBSkipLogin = $scope.auth.isFBSkipLogin();

                // FPTI payload to track FB Login
                if ($scope.auth.isFBSkipLogin()) {
                    _logger.$logger.info('checkout_fpti', {
                        'design': 'facebook_onetouch'
                    });
                }
            }
        };

        $scope.optin_toggle = {
            isEnabled: false,
            value: false,
            showExpandedTerms: true,
            setValue: function setValue(val) {
                this.value = val;
                // this.showExpandedTerms = false; // hide terms upon user interaction
                _logger.$logger.debug('ryi_optin_toggle_setValue', {
                    value: this.value,
                    showExpandedTerms: this.showExpandedTerms
                });
            }
        };
        _logger.$logger.debug('kmliUpsell review: init');
        _kmliUpsell.$KmliUpsell.init(_angular.$rootScope.token, false, true);
        var creditBannerRegister = _angular.$rootScope.$on('allLoaded', function () {
            _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T1' });
            creditBannerRegister();
        });
        _angular.$rootScope.$on('$destroy', creditBannerRegister);

        function optInUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optin'
            });
            $scope.optin_toggle.setValue(true);
            var optinSource = 'checkoutToggle';
            var silentSpinner = true;

            return _ul.$ul.optInToOneTouch(_angular.$rootScope.token, _squid.$locale.country, _squid.$locale.lang, silentSpinner, {
                'stateName': 'OT_Toggle',
                'transInfix': 'process_optin'
            }, optinSource).then(function (res) {
                _logger.$logger.debug('ryi_optin_toggle_process_optin');
            })['catch'](function (err) {
                // eslint-disable-line handle-callback-err
                _logger.$logger.debug('ryi_optin_toggle_process_optin_Error', {
                    'int_error_description': err && err.message
                });
            });
        }

        function optOutUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optout'
            });
            return $scope.auth.action('optout', { silent: true }).then(function (res) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout'
                });
                $scope.$applyAsync(function () {
                    var bannerElement = $element.find('.oneTouchBanner');

                    bannerElement.addClass('leave_animation');
                    _logger.$logger.debug('ryi_optin bannerElement animate');
                    (0, _angular.$timeout)(function () {
                        $scope.optin_toggle.setValue(false);
                        $scope.optin_toggle.isEnabled = false;
                    }, 1400);
                });
            })['catch'](function (err) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout',
                    'error_source': 'identityauthorizationserv',
                    'int_error_code': 'optout_failure',
                    'int_error_description': err && err.message
                });
            });
        }

        $scope.onTouchToggle = function (value) {
            _logger.$logger.debug('optin_toggle_change_attempt', {
                'ryi_optin': $scope.optin_toggle,
                'remembered': $scope.auth.remembered,
                'value': value
            });
            if ($scope.optin_toggle.isEnabled) {
                if (value) {
                    optInUser();
                } else {
                    optOutUser();
                }
            }
        };

        $scope.tagFamilyComputer = function () {
            // creates a log to tag device as family computer.
            // if we can distinguish between single user, family computer and shared computer
            // we may be able to offer a way to switch accounts
            var buyer_id = $scope.auth.buyer_id;
            var logPayload = {
                localStorageEnabled: false,
                isMobile: _index2.$DeviceInfo.isMobile()
            };

            if (_squid.$util.localStorageEnabled()) {
                var family_device_key = 'family_device_test';
                var public_device_key = 'public_device_test';

                logPayload.localStorageEnabled = true;

                var objStr = localStorage.getItem(family_device_key);
                var publicDeviceTest = localStorage.getItem(public_device_key);

                if (publicDeviceTest === 'true') {
                    // dont overuse localStorage there is a size limit
                    localStorage.removeItem(family_device_key);
                    logPayload.isPublicDevice = true;
                } else {
                    var buyerList = objStr ? JSON.parse(objStr) : [];

                    if (buyerList.indexOf(buyer_id) === -1) {
                        buyerList.push(buyer_id);
                    }
                    // assuming 5 or less users on a device as family computer
                    logPayload.isFamilyDevice = Boolean(buyerList.length > 1 && buyerList.length < 6);
                    logPayload.isPublicDevice = Boolean(buyerList.length > 20);
                    logPayload.userCount = buyerList.length;
                    objStr = JSON.stringify(buyerList);
                    localStorage.setItem(family_device_key, objStr);
                    localStorage.setItem(public_device_key, logPayload.isPublicDevice.toString());
                }
            }
            var eligibility_reason = 'localStorage:' + logPayload.localStorageEnabled + '_isPublicDevice:' + logPayload.isPublicDevice + '_isFamilyDevice:' + logPayload.isFamilyDevice + '_userCount:' + logPayload.userCount;

            _logger.$logger.debug('family_device_test', logPayload);
            _logger.$logger.info('checkout_fpti', {
                'from': 'family_device_test',
                'to': 'process_elg_chk',
                'eligibility_reason': eligibility_reason
            });
        };

        function stickyCTA() {
            return _eligibility.$stickyCTA.instance().getEligibility().then(function (eligibility) {
                $scope.stickyEligibility = eligibility;
            });
        }

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function donationAuthorize() {
            var _$GiveAtCheckoutFacto = _factory.$GiveAtCheckoutFactory.get(),
                donateCheckboxSelected = _$GiveAtCheckoutFacto.donateCheckboxSelected,
                charity = _$GiveAtCheckoutFacto.charity,
                tracking = _$GiveAtCheckoutFacto.tracking;

            if (donateCheckboxSelected) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'GIVE_AT_CHECKOUT',
                    to: 'process_give_at_checkout',
                    gac_model: charity.model_id,
                    gac_npid: charity.nonprofit_id
                });

                if (tracking && tracking.click_url) {
                    _marketingoffer.$fireMORSBeacon.fireBeacon(tracking.click_url);
                }

                return _donation.$GiveAtCheckoutModel.instance().action('donationAuthorize', {
                    data: {
                        'ec_token': _angular.$rootScope.token,
                        'nonprofit_id': charity.nonprofit_id,
                        'charity_name': charity.name,
                        'money': {
                            'value': charity.amount,
                            'currency_code': charity.currency
                        }
                    },
                    success: function success() {
                        return _logger.$logger.info('donation_authorize_success', {});
                    },
                    error: function error() {
                        return _logger.$logger.error('donation_authorize_failure');
                    }
                });
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                _logger.$logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                _logger.$logger.info('makeAddrPreferred.selected', {});
                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }
            return _angular.$q.when();
        }

        function setStickyInstrument() {
            if (!_squid.$config.features.DEFAULT.enableStickyFunding) {
                return _angular.$q.when();
            }

            // If the currently selected plan is not saved in the checkoutSession, make the call to save it.
            // For BA no purchase cases, the only way we track it is in the checkout session, so it should already be saved (selected id will equal sticky id).
            // For all other purchase cases, we need to look at the first in fundingOptions and match it to futurePaymentInstruments
            var savedSticky = $scope.checkoutSession.selectedFuturePaymentInstrument;
            var selectedSticky = $scope.checkoutSession.getSelectedStickyInstrument();

            // selectedSticky will not be populated if this isn't a billing case.
            if (!selectedSticky) {
                return _angular.$q.when();
            }

            // If we haven't saved the selected sticky instrument yet,
            // make the API call to save it
            if (!savedSticky || savedSticky.instrument_id !== selectedSticky.instrument_id) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: selectedSticky.instrument_id
                    }
                });
            }
            return _angular.$q.when();
        }

        function linkAuthConsent() {
            /* Check if its BA flow and we have merchant consent code */
            if ($scope.checkoutCart.isBilling() && $scope.checkoutCart.billing) {
                // Getting merchant account's billing consent code i.e. legal_text_code
                var billingConsentCode = $scope.checkoutCart.billing.consent_code;
                var FB_CONSENT_CODE = 'facebookp2p';
                var authConsentModel = _user.$AuthConsentModel.instance();

                if (billingConsentCode === FB_CONSENT_CODE) {
                    return authConsentModel.action('link', {
                        data: {
                            'ba_token': _squid.$meta.baToken
                        },
                        success: function success() {
                            return _logger.$logger.info('link_authconsent_success', {});
                        }
                    });
                }
            }
        }

        function setWalletTopupPreferences() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                $scope.walletPreferences = _fi.$WalletPreferences.instance(_angular.$rootScope.token);
                return $scope.walletPreferences.save();
            }
        }

        function isValidPinSetup() {
            if ($scope.walletPinModel && $scope.walletPinModel.isSetupEligible()) {
                if (!$scope.walletPinModel.userPin) {
                    return false;
                }
            }
            return true;
        }

        function prepareTokenizedWallet() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                return (0, _squid.$populate)($scope, {
                    walletPreferences: _fi.$WalletPreferences.instance(_angular.$rootScope.token),
                    walletPinModel: _app.$TokenizedWalletPinModel.instance(_angular.$rootScope.token),
                    tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                        params: {
                            tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                            country: $scope.auth.country
                        }
                    })
                }).then(function (result) {
                    var fundingInstrument = $scope.walletPreferences.getPreferred();
                    var instrument_id = fundingInstrument.instrument_id;
                    var defaultTopupFI = _squid.$util.find($scope.checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var defaultDirectFI = _squid.$util.find($scope.checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var pinStatus = 'default_pin_unavailable';

                    if ($scope.walletPinModel.isPinIdPresent()) {
                        pinStatus = 'already_exist';
                    } else if ($scope.walletPinModel.getPinOrigin() !== 'UNSET') {
                        pinStatus = 'pin_error';
                    } else if ($scope.walletPinModel.getSuggestedPin()) {
                        pinStatus = 'default_pin_available';
                    }

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'TopUp_REVIEW',
                        'to': 'prepare_review',
                        'context_id': $scope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken,
                        'default_topup_fi': defaultTopupFI.type,
                        'default_direct_fi': defaultDirectFI.type,
                        'pin': pinStatus,
                        'flag': $scope.checkoutSession.get('sepa_mandate.bankId') ? 'sepa' : undefined
                    });
                });
            }
            return _angular.$q.when();
        }

        $scope.hasShippingOptions = function () {
            return Boolean($scope.shippingOptions && $scope.shippingOptions.length);
        };

        function checkJSV4PaymentDetails() {
            // Pass through if there are no shipping methods to choose from.
            if (!$scope.hasShippingOptions()) {
                return _angular.$q.when();
            }

            // Otherwise, if there are shipping methods but no selected method... Fail!
            if (!$scope.selectedShippingOption) {
                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['shipping.bopisErrorMessage']
                };

                throw new Error('IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION');
            }
        }

        /**
         * To resetCVVContingency once the page refresh/back happen.
         *
         * case1. browser_back:
         *          Reset the hash value in the url with '#', no page load occurs.
         *          once browser back click the cache clean and cvv text box will show.
         * case2. page_refresh:
         *          reset the lastAddedCard to false
         *          every page refresh the cvv text box will display.
         */
        $scope.resetCVVContigency = function (_ref3) {
            var flow = _ref3.flow;


            var isResolve3ds = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;
            var isReviewPage = _uiRouter.$state.current.name === 'checkout.review';

            if (isResolve3ds && isReviewPage && checkResetCvvAllowed()) {
                _logger.$logger.info('checkout_fpti', { from: 'resetCVVContigency_' + flow, to: 'process_resetCVVContigency_' + flow });
                var ccId = isResolve3ds.ccId,
                    type = isResolve3ds.type,
                    number = isResolve3ds.number;


                switch (flow) {
                    case 'page_refresh':
                        $scope.checkoutSession.set('cvvData', Object.assign({}, { type: type, number: number, ccId: ccId, id: ccId, lastAddedCard: false }));
                        break;
                    case 'browser_back':
                        _angular.$window.location.hash = '#';
                        break;
                    default:
                        break;
                }
            }
        };

        /**
         * Parse the queryString
         * - set the required scopes for init3DS paymentExperience
         * - set return query while return to merchaant
         */
        var parseQueryStringForExperience = function parseQueryStringForExperience() {
            var isDoEcEnabled = !window.xchild && $scope.checkoutAppData.doec_on_approve() ? 1 : 0;

            var searchParams = (0, _qs.parse)(_angular.$window.location.search.split('?')[1]);
            searchParams = Object.assign({}, searchParams, { isDoEcEnabled: isDoEcEnabled, hermes: '1', token: $scope.token });
            delete searchParams.cmd;
            $scope.process3dsReturnQueryParams = (0, _qs.stringify)(searchParams);
            var searchParamThreeDSexp = searchParams['threeDSexp'];

            if (searchParamThreeDSexp === 'redirect' || searchParamThreeDSexp === 'iframe') {
                $scope.isRedirectTreatment = searchParamThreeDSexp === 'redirect';
                _logger.$logger.info('checkout_fpti', { from: '3ds_exp_queryString_' + $scope.isRedirectTreatment, to: 'process_3ds_exp__queryString_' + $scope.isRedirectTreatment });
            }
        };

        /**
         * Get paymentExperience from URL for experiemenation
         *
         * @return {Array}
         */
        function getPaymentExperience() {
            var paymentExperience = void 0;

            $scope.threeDSexp = $scope.isRedirectTreatment ? 'REDIRECT' : 'IFRAME';
            $scope.channelType = $scope.threeDSexp === 'REDIRECT' ? 'MOBILE_APP' : 'WEB';
            paymentExperience = [$scope.threeDSexp];

            //  if the merchant integrated with incontext experience then we need to send 'IFRAME' as experience
            if (_index.$miniBrowser.isMiniBrowser()) {
                $scope.isMiniBrowser = _index.$miniBrowser.isMiniBrowser();
                _logger.$logger.info('checkout_fpti', { from: 'override_as_iframe', to: 'process_override_as_iframe' });
                $scope.channelType = 'WEB';
                $scope.isRedirectTreatment = false;
                paymentExperience = ['IFRAME'];
            }
            return paymentExperience;
        }

        /**
         * To check the elmo treatment for the 3ds experience
         *
         * return {Boolean}
         */
        var checkExperienceElmoTreatment = function checkExperienceElmoTreatment() {
            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
            var payerId = _$scope$checkoutSessi.id;
            var _$config$pxpExperimen = _squid.$config.pxpExperiments.hermesElmo3dsExperience,
                id = _$config$pxpExperimen.id,
                testTreatmentName = _$config$pxpExperimen.testTreatmentName;

            var merchantCountryCode = $scope.checkoutAppData.get('merchant.merchant_country');

            if (!(0, _squid.$feature)('callElmoForPaymentExperience')) {
                parseQueryStringForExperience();
                return;
            }

            (0, _squid.$elmo)(id, { 'filters.Country': _squid.$locale.country, 'uid': payerId, 'filters.MerchantCountry': merchantCountryCode }, testTreatmentName, false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                if (treatmentName) {
                    _logger.$logger.info('treatmentName_exist', treatmentName);
                    $scope.isRedirectTreatment = true;
                }

                _logger.$logger.info('checkout_fpti', {
                    from: 'isRedirectTreatment',
                    to: 'process_3ds_isRedirectTreatment',
                    data: { isRedirectTreatment: $scope.isRedirectTreatment }
                });
            })['finally'](function () {
                parseQueryStringForExperience();
            });
        };

        /**
         * Get Security code from cvvData
         */
        function getSecurityCode() {
            if (checkResetCvvAllowed()) {
                return _angular.$rootScope.cvvData && _angular.$rootScope.cvvData.security_code;
            }
        }

        /**
         * Set CVV data from CheckoutSessionModel
         */
        function setCvvData() {
            if (checkResetCvvAllowed()) {
                _angular.$rootScope.cvvData = $scope.checkoutSession.get('cvvData') ? $scope.checkoutSession.get('cvvData') : _angular.$rootScope.cvvData;
            }
        }

        /**
         * check whether to allow reset cvv based on country
         * - reset CVV value
         * - show cvv text box
         */
        function checkResetCvvAllowed() {
            var resetCVVAllowedCountries = ['IN'];
            _logger.$logger.info('checkout_fpti', {
                from: 'checkResetCvvAllowed',
                to: 'process_checkResetCvvAllowed',
                resetCVVAllowedCountries: resetCVVAllowedCountries
            });
            return resetCVVAllowedCountries.includes(_squid.$locale.country);
        }

        function show3DSLightbox() {
            $scope.resolve_3ds_data = set3DSv1ScopeVariable();

            $scope.launch3DSResolver = true;
        }

        // 3DS V2 device data collection - group it together with V1 for easy reference
        function show3dsDDCLightBox() {
            $scope.threedsData = set3DSv2ScopeVariable();
            $scope.showThreedsPopup = true;
        }

        function setProcessorDeclineMessage(checkoutSession) {
            var declinedInstruments = checkoutSession.declinedInstruments;

            // For CPA scenario, when pre auth decline, we reload the review page and for that we would have
            // decline instrument but we dont want to show existing Processor Decline Message. Instead CPA message
            // would be shown on review page (we have separate component 'decline-notification' for displaying CPA Message.
            // So filtering the below logic, if user is not CPA Eligible.
            if (declinedInstruments && declinedInstruments.length > 0 && !$scope.isCPAEligible) {
                _factory5.$AddCardFactory.getIssuerDeclineElmoResult().then(function (result) {
                    // reset the checkoutSession.message;
                    checkoutSession.message = null;

                    var planInstruments = checkoutSession.fundingOptions.plans || [];
                    var treatmentPAPS = null;

                    planInstruments.forEach(function (plan) {
                        if (plan.primaryFs.lastDigits === declinedInstruments[0].last4 && plan.primaryFs.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                            treatmentPAPS = 'Trmt_xo_hermesnodeweb_issuer_decline_1';
                            $scope.isProcessorDeclineExperiment = true;
                        }
                    });

                    var processorDeclinedMsg = _fiMessages.$fiMessages.processorDeclinedMsg($scope.checkoutSession, true, treatmentPAPS, $scope.auth, $scope.fiMeta.wallet, $scope.formattedNameInformal);

                    if (processorDeclinedMsg) {
                        $scope.checkoutSession.message = {
                            type: processorDeclinedMsg.type,
                            msgs: [processorDeclinedMsg.msg],
                            keepMsg: processorDeclinedMsg.keepMsg
                        };
                    }
                });
            }
        }

        function getPadToggleStatus() {
            var toggleStatus = 'NA'; // NOT APPLICABLE status

            if (_factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled)) {
                if ($scope.padToggleFeature.checkboxEnabled) {
                    toggleStatus = 'ON';
                } else {
                    toggleStatus = 'OFF';
                }
            }
            return toggleStatus;
        }

        // method to extract information for 3DSv1.0
        function set3DSv1ScopeVariable() {
            // for v2 resolve_3ds is null, pass it from V2 mapping to get amount and currency
            var cc_id = $scope.checkoutSession.get('resolve_3ds.ccId');
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;

            return {
                cc_id: cc_id,
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: plan && plan.currency_code || null,
                transaction_amount_value: plan && plan.amount || null,
                merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                card_verification_code: getSecurityCode(),
                paymentExperience: getPaymentExperience(),
                channelType: $scope.channelType,
                isMiniBrowser: $scope.isMiniBrowser,
                isRedirectTreatment: $scope.isRedirectTreatment,
                process3dsReturnQueryParams: $scope.process3dsReturnQueryParams
            };
        }

        function getProductDetails() {
            // default to express checkout
            var productDetails = {
                productCode: 'EXPRESS_CHECKOUT',
                productFlow: 'HERMES'

            };

            var isWPSFlow = $scope.checkoutAppData.is_wps_flow();
            var isBillingWithoutPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBillingWithPurchase = $scope.checkoutCart.isBillingPurchase();
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();

            if (isWPSFlow) {
                productDetails.productCode = 'WEBSITE_PAYMENT_STANDARD';
            } else if (isBillingWithoutPurchase || isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENTS';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_CREATE';
            } else if (isWPSSubscriptionFlow) {
                productDetails.productCode = 'BILLING_SUBSCRIPTIONS';
                productDetails.productFlow = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE';
            } else if (isWPSAutobilling) {
                productDetails.productCode = 'BILLING_AUTOBILLING';
                productDetails.productFlow = 'BUYER_APPROVAL_AUTOBILLING_CREATE';
            } else if (isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENT';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE';
            }

            return productDetails;
        }

        function isBillingFlow() {
            return $scope.checkoutCart.isBilling() || $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.isWpsAutobillingFlow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1();
        }

        // method to extract information for 3DSv2.0
        function set3DSv2ScopeVariable() {
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref4 = threeDSResolutionData.resolutions || [],
                resolutions = _ref4[0];

            var _ref5 = resolutions || {},
                _ref5$funding_instrum = _ref5.funding_instrument_details;

            _ref5$funding_instrum = _ref5$funding_instrum === undefined ? {} : _ref5$funding_instrum;
            var _ref5$funding_instrum2 = _ref5$funding_instrum.payment_card,
                payment_card = _ref5$funding_instrum2 === undefined ? {} : _ref5$funding_instrum2,
                _ref5$funding_instrum3 = _ref5$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref5$funding_instrum3 === undefined ? {} : _ref5$funding_instrum3;

            // logo image url

            var networkLogo = $scope.fiMeta.wallet.getCardArt(payment_card);
            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;
            var amount = {
                currencyCode: plan && plan.currency_code,
                currencyValue: plan && plan.amount
            };

            var jwtInfo = {
                jwtIssuer: three_ds_contingency_context.auth_specification.issuer,
                jwtOrgUnitId: three_ds_contingency_context.auth_specification.org_unit_id,
                jwtDuration: three_ds_contingency_context.auth_specification.validity_duration
            };

            var threeDSContingencySource = three_ds_contingency_context.source,
                threeDSContingencyReason = three_ds_contingency_context.reason;
            var id = payment_card.id,
                bank_identification_number = payment_card.bank_identification_number,
                billing_address = payment_card.billing_address,
                number_encrypted = payment_card.number_encrypted,
                card_product_class = payment_card.card_product_class,
                expire_month = payment_card.expire_month,
                expire_year = payment_card.expire_year,
                currency_code = payment_card.currency_code,
                type = payment_card.type;


            if (isBillingFlow()) {
                amount.currencyValue = '0.00';
                amount.currencyCode = currency_code;
            }
            return {
                cardBin: bank_identification_number, // Needed for JWT
                ddcUrl: three_ds_contingency_context.device_data_collection_url,
                jwtInfo: jwtInfo, // Needed for JWT
                referenceId: three_ds_contingency_context.reference_id,
                integrationType: 'TRANSACTION',
                networkLogo: networkLogo,
                cardBrand: type,
                initThreedsData: {
                    referenceId: three_ds_contingency_context.reference_id,
                    creditCardId: id,
                    billing_address: billing_address,
                    number_encrypted: number_encrypted,
                    card_product_class: card_product_class,
                    expire_month: expire_month,
                    expire_year: expire_year,
                    amount: amount,
                    threeDSContingencySource: threeDSContingencySource,
                    threeDSContingencyReason: threeDSContingencyReason,
                    merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                    productDetails: getProductDetails()
                }
            };
        }

        /**
         * `Exit message` feature is currently only applied to:
         * 1) Only in US
         * 2) user action **not** "commit"
         * 3) not a billing agreement
         * 4) `DONE_PAGE` integration is false
         * @returns {boolean}
         */
        var applyExitMessage = function applyExitMessage() {
            return _squid.$locale.country === 'US' && $scope.useraction !== 'commit' && !$scope.checkoutCart.isBilling() && !_integration.$integration.getConfig('DONE_PAGE');
        };

        var getPlanId = function getPlanId(obj) {
            return obj.planId || obj.id;
        };

        var getPlan = function getPlan(planId) {
            var planList = $scope.checkoutSession.get('fundingOptions.plans') || [];
            var selectedPlan = void 0;

            angular.forEach(planList, function (plan) {
                if (getPlanId(plan) === planId) {
                    selectedPlan = plan;
                }
            });
            return selectedPlan;
        };
        var getDefaultPlanId = function getDefaultPlanId() {
            return $scope.checkoutSession.plan.id || [];
        };

        var getSpinnerContentTest = function getSpinnerContentTest() {
            return (0, _squid.$elmo)('xo_hermesnodeweb_cpa_spinner', { 'ctx.country': _squid.$locale.country }, 'xo_hermesnodeweb_cpa_spinner_trmt(_[0-9]+)?').then(function (result) {
                return result && result.treatment_name;
            });
        };

        /* Function for Pre auth API - "/v2/payments/authorizations"
           Pre auth call would be invoked if the user is CPA Eligible and selected (or default, if user did not select)
           plan has pre auth data. otherwise we will skip and move forward with approve call.
         */
        var preAuthorize = function preAuthorize() {
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var preAuthorizationData = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.pre_authorization_instruction;
            var _$scope$checkoutSessi2 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi2 = _$scope$checkoutSessi2 === undefined ? {} : _$scope$checkoutSessi2;
            var payerId = _$scope$checkoutSessi2.id;

            var preAuthorizationRequired = false;
            var authAmount = void 0;

            if (preAuthorizationData) {
                var authType = preAuthorizationData.type;

                authAmount = preAuthorizationData.amount;
                preAuthorizationRequired = authType === 'FULL' || authType === 'PARTIAL';
            }

            if (preAuthorizationRequired) {
                var fptiData = {
                    fi_id: selectedPlan.primaryFs.id,
                    plan_id: selectedPlanId,
                    auth_type: preAuthorizationData.type,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue'
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CREATE_FI_AUTH',
                    to: 'prepare_fi_auth',
                    client_epoch_ts: Date.now()
                }, fptiData));

                getSpinnerContentTest().then(function (treatment) {
                    if (treatment) {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - treatment');

                        var loadingMessage = void 0;
                        var loadingSubMessage = void 0;
                        switch (treatment) {
                            case 'xo_hermesnodeweb_cpa_spinner_trmt':
                                loadingMessage = (0, _squid.$renderContent)('spinner.authFlowContinue', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine2', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_2':
                                loadingMessage = (0, _squid.$renderContent)('spinner.preAuthCard').toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_3':
                                loadingMessage = (0, _squid.$renderContent)('spinner.completePayment', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            default:
                                loadingMessage = '';
                                loadingSubMessage = '';
                        }

                        _squid.$event.emit('loading');
                        _squid.$event.emit('loadingMessage', {
                            heading: loadingMessage,
                            subHeading: loadingSubMessage
                        });
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');
                            var spinnerSubMessageEl = (0, _jquery2['default'])('#spinner-submessage');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '150%',
                                    marginLeft: '-55px'
                                });
                            }
                            if (spinnerSubMessageEl) {
                                spinnerSubMessageEl = spinnerSubMessageEl.css({
                                    width: '168%',
                                    marginLeft: '-75px',
                                    marginTop: '20px'
                                });
                            }
                        }, 1);
                    } else {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - control');
                    }
                });

                return $scope.checkoutSession.action('preAuthorize', {
                    data: {
                        authAmount: authAmount,
                        planId: selectedPlanId
                    },
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', _extends({
                            from: 'CREATE_FI_AUTH',
                            to: 'process_fi_auth',
                            client_epoch_ts: Date.now()
                        }, fptiData));

                        return _angular.$q.when();
                    },
                    contingencies: {
                        CC_AUTHORIZATION_DECLINED: function CC_AUTHORIZATION_DECLINED() {
                            // For CC_AUTHORIZATION_DECLINED contingency retrieve the checkout session and
                            // 1. For Multi FI - Reload the xo-review page.
                            // 2. For Single FI - Redirect to Add Card contingency page.

                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: 'CC_AUTHORIZATION_DECLINED'
                            }, fptiData));

                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }

                            // Retrieve the checkout session before reloading the xo-review Page.
                            // as we need to get latest declineInstument in the session.
                            return $scope.checkoutSession.retrieve({
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    if ($scope.cancelUpdateListener) {
                                        $scope.cancelUpdateListener();
                                    }

                                    if (!$scope.selectFiVariant) {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                        return _squid.$promise.shortCircuit();
                                    }

                                    // Check that there is more than one plan to choose from, or that plan is not preferred
                                    var plans = $scope.checkoutSession.get('fundingOptions.plans');
                                    var isPreferredDefault = $scope.skipSelectFiVariants.indexOf($scope.choiceVariant) > -1 && plans && plans[0].primaryFs.isPreferred;
                                    var stickyPlans = $scope.checkoutSession.futurePaymentInstruments;
                                    var hasManyPlans = plans && plans.length > 1;
                                    var hasStickyPlans = stickyPlans && stickyPlans.length > 1;

                                    if (!isPreferredDefault && (hasManyPlans || hasStickyPlans)) {
                                        _uiRouter.$state.go('checkout.selectFi', { newState: true }, { reload: true });
                                    } else {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                    }
                                    return _squid.$promise.shortCircuit();
                                },
                                contingencies: {
                                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                        // for single FI scenario, if preAuth fails, we would need to redirect to
                                        // Add Credit card contingency page.
                                        _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                                        return _squid.$promise.shortCircuit();
                                    }
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name) {
                            // For any error / contingency other than CC_AUTHORIZATION_DECLINED, bypass it and move forward
                            // with Approve call.
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: name
                            }, fptiData));
                            return _angular.$q.when();
                        }
                    }
                });
            } else {
                return _angular.$q.when();
            }
        };

        function authorize() {

            // making it as internal function to prevent calling directly
            function internalAuthorize() {
                return $scope.checkoutSession.action('authorize', {
                    batch: isGoogleAccountLinking && _tokenizedFactory.$TokenizedFactory.getAuthorizeBatch(),
                    data: {
                        alternateFundingOptionId: cardBackup && cardBackup.planId
                    },
                    success: function success() {
                        if ($scope.checkoutSession.get('plan.paypal_credit')) {
                            _logger.$logger.info('checkout_fpti', { 'ppc_reuse_status': 'success' });

                            // for PPC reuse radio banner testing we want to indicate whether the user selected PPC via radio button or banner.

                            _logger.$logger.info('checkout_fpti', {
                                from: 'clickPPCReuse',
                                to: 'radio_click'
                            });
                        }

                        var padToggleStatus = getPadToggleStatus();

                        if (padToggleStatus === 'ON') {
                            _logger.$logger.info('checkout_fpti', {
                                'pad_toggle_status': 'padToggleOnSuccess'
                            });
                        } else if (padToggleStatus === 'OFF') {
                            _logger.$logger.info('checkout_fpti', {
                                'pad_toggle_status': 'padToggleOffSuccess'
                            });
                        }

                        // for all tokenized flows except google account linking - log FPTI in authorize sucess callback
                        if (!isGoogleAccountLinking && $scope.checkoutCart.isWalletTokenization()) {
                            _tokenizedFactory.$TokenizedFactory.logProcessReviewToFPTI();
                        }

                        // Just in case, cancel the state change listener checking if updateFs needs to be called
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
                            return _uiRouter.$state.go('checkout.sepapage');
                        }

                        // xchild = V4 Incontext Integration. Do not initiate Payment.
                        if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                            return _uiRouter.$state.go('checkout.pay');
                        }

                        // for all flows except google account linking - go to end of checkout
                        // for google account linking - redirect happens in "updateIssuanceScope" call (see tokenizedFactory)
                        if (!isGoogleAccountLinking) {
                            return _uiRouter.$state.go('checkout.end');
                        }
                    },
                    contingencies: {
                        // Smart $x authorization check on the card fails
                        CREDIT_CARD_AUTH_FAILED: function CREDIT_CARD_AUTH_FAILED() {
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'REVIEW',
                                to: 'process_review_err',
                                int_error_code: 'CREDIT_CARD_AUTH_FAILED'
                            }, cpaFptiData));
                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }
                            return $scope.checkoutSession.action('create', {
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    $scope.errorHandlerHelper.addPageError('payment.authFailureMultipleFIs');
                                    return _uiRouter.$state.go('checkout.review', { message: 'CREDIT_CARD_AUTH_FAILED' });
                                }
                            });
                        }
                    }
                });
            }

            // 3DS 1.0 FI route to resolve
            if ($scope.checkoutSession.resolve_3ds) {
                _logger.$logger.info('3DS_v1_contingency_thrown');

                return show3DSLightbox();
            } else if ($scope.checkoutSession.threeDSResolutionData) {
                // 3DS ACE route data (call it as 3DSv2.0)
                // this is completely different set of APIs and data needs to be passed
                // grab them all from different source
                _logger.$logger.info('3DS_v2_contingency_thrown');
                return show3dsDDCLightBox();
            }

            function isXoonUpopRedirect() {
                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
                    return false;
                }

                return _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
            }

            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
                var card = void 0;

                if ($scope.checkoutSession.unconfirmed_upop) {
                    card = $scope.checkoutSession.unconfirmed_upop;
                } else {
                    card = $scope.checkoutSession.errorData.resolution.data;
                }

                $scope.cardModel = new _fi.$AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new _fi.$CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });
                _uiRouter.$state.go('.confirmUpop');
                return;
            }

            // Currently, exit message will only be applicable to US. If we'd like
            // to expand exit message feature to other countries, we will need
            // translation from other countries.
            if (applyExitMessage()) {
                // HACK - REMOVE and REFACTOR ONCE DONE
                // overload base.processing in strings
                // since quid is hardcoded to use string each time
                // required only for testing - remove and refactor,
                // to properly allow for dynamic spinner messages

                // resolve merchant name
                var merchantName = pxpMerchName;
                // flag when name is missing or longer than 20 chars
                var badMerchantName = !merchantName || merchantName.length > pxpMerchNameLimit;
                var outroMsg = badMerchantName ? 'We’re sending you back to the merchant to complete this purchase.' : 'We\u2019re sending you back to <strong style="white-space:nowrap">' + merchantName + '</strong> to complete this purchase.';

                // capture current route
                var reviewRoute = _uiRouter.$state.current;

                // listen to !startLoad
                // this is the only way we can then manipulate the spinner
                var cancelOutroOverride = _angular.$rootScope.$on('startLoad', function () {
                    // if this is the review route...
                    // this is needed, in case the session has ended
                    // at this point, we need this listener to do nothing
                    if (_uiRouter.$state.current === reviewRoute) {
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '130%',
                                    marginLeft: '-15%'
                                });
                                if (spinnerMessageEl) {
                                    // setting here, since `ng-bind-html` didn't work in spinner directive
                                    spinnerMessageEl.html(outroMsg);
                                }
                            }
                        }, 1);
                    } else {
                        // (otherwise) when no longer the review route...
                        // this means something happened before redirect
                        // likely an expired session
                        // In that case we'll remove this listener
                        // It will just be re-added, in the next redirect attempt
                        cancelOutroOverride();
                    }
                });

                _angular.$rootScope.$on('$destroy', cancelOutroOverride);
            }

            var cardBackup = $scope.checkoutSession.cardBackup.getPlan();

            _logger.$logger.info('checkout_fpti', {
                from: 'processor_decline_retry',
                to: 'processor_decline_retry_eligibility',
                'is_bkp_funding_chosen': cardBackup && cardBackup.planId ? 1 : 0
            });

            var isGoogleAccountLinking = _tokenizedFactory.$TokenizedFactory.isGoogleAccountLinking();

            // for Google account linking - make a batch call which includes "authorize" call first call
            // and updateIssuaceScope as second
            if (isGoogleAccountLinking) {
                _tokenizedFactory.$TokenizedFactory.updateIssuanceScope();
            }

            /**
             * now we have cleared all contingencies / error in  FI,
             * check for any pre-authorization required
             * possible usecases are CPA (Customer Present Auth)
             * and multi shipment payments (AS2 and BA flows), nothing to do anything with
             * shipping address / shipping amount , multi shipment means , multiple transaction allowed
             * using OrderId or Billing Agrement Id
             */
            var cpaFptiData = {};
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var _$scope$checkoutSessi3 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi3 = _$scope$checkoutSessi3 === undefined ? {} : _$scope$checkoutSessi3;
            var payerId = _$scope$checkoutSessi3.id;
            // if the selected or default plan requires auth

            if (_sharedUtil.$SharedUtil.isSelectedPlanRequiresAuth(selectedPlan)) {
                cpaFptiData = {
                    fi_id: selectedPlan && selectedPlan.primaryFs ? selectedPlan.primaryFs.id : '',
                    plan_id: selectedPlanId,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue',
                    client_epoch_ts: Date.now()
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'REVIEW',
                    to: 'process_review'
                }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession, isProcessTransition: true }), cpaFptiData));

                // ok, we need to do preauthorize now, before making actual authorize
                return preAuthorize().then(function () {
                    return internalAuthorize();
                });
            } else {
                // if plan  doesn't require any auth - continue with auth
                return internalAuthorize();
            }
        }

        function setShowShippingMethodProperty() {
            return (0, _squid.$populate)($scope, {
                shippingRulesSummary: _shippingMethod.$ShippingRuleSummaryModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled || $scope.isInstantUpdateAPIFlow;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            // Instrument number of available plans for 3DS decline case.
            var numberOfPlans = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : 0;

            _logger.$logger.info('3DS_decline_plan_count', { 'plans': numberOfPlans });

            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            // extract card information from 3DS V1 contingency context
            var card = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;

            // extract card information from 3DS V2 contingency context
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref6 = threeDSResolutionData && threeDSResolutionData.resolutions || [],
                resolutions = _ref6[0];

            var _ref7 = resolutions || {},
                _ref7$funding_instrum = _ref7.funding_instrument_details;

            _ref7$funding_instrum = _ref7$funding_instrum === undefined ? {} : _ref7$funding_instrum;
            var _ref7$funding_instrum2 = _ref7$funding_instrum.payment_card,
                payment_card = _ref7$funding_instrum2 === undefined ? {} : _ref7$funding_instrum2;

            // consider V1 or V2 card data

            var cardInformation = card || payment_card;

            if (cardInformation) {
                var msg = (0, _squid.$renderContent)(key, {
                    cardType: cardInformation.type,
                    last4: cardInformation.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            _logger.$logger.info('3DS_v1_clear_contingency');
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.resolve_3ds) {
                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        /*
         * call to update the three ds status into checkout session
         * unlike 3DS V1 , we need to update the status with reference Id
         * 3DS reference id, and lookup or authenticaton id needs to passed
         * at the time of fulfillment
         */
        function updatethreedsStatus(status, threeDSTransactionId) {
            _logger.$logger.info('3DS_v2_clear_contingency');

            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref8 = threeDSResolutionData.resolutions || [],
                resolutions = _ref8[0];

            var _ref9 = resolutions || {},
                _ref9$funding_instrum = _ref9.funding_instrument_details;

            _ref9$funding_instrum = _ref9$funding_instrum === undefined ? {} : _ref9$funding_instrum;
            var _ref9$funding_instrum2 = _ref9$funding_instrum.payment_card,
                payment_card = _ref9$funding_instrum2 === undefined ? {} : _ref9$funding_instrum2,
                _ref9$funding_instrum3 = _ref9$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref9$funding_instrum3 === undefined ? {} : _ref9$funding_instrum3;

            // pass below information to blacklist if any of the 3DS resolution failed

            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var card_number = payment_card.number;
            var card_type = payment_card.type;
            var referenceId = three_ds_contingency_context.reference_id;

            return $scope.checkoutSession.action('clear3DSContingency', {
                resultModel: $scope.checkoutSession,
                data: {
                    ccId: cc_id,
                    status: status !== 'SUCCESS' ? 'FAILURE' : status,
                    authId: threeDSTransactionId,
                    referenceId: referenceId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.threeDSResolutionData && status === 'SUCCESS') {
                        // if checkout session not having contingency and if 3DS success, continue with authorize
                        return authorize();
                    } else {
                        // Symphony might blacklist the earlier failed instrument
                        // inform about this with a error message
                        _logger.$logger.info('3DS_v1_black_listed_instrument');
                        var key = 'threeDS.memberDecline';

                        if (card_number) {
                            var msg = (0, _squid.$renderContent)(key, {
                                cardType: card_type,
                                last4: card_number
                            });

                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.isOptionalVaulting = function () {
            var optionalVaulting = false;
            if ($scope.checkoutCart.billing && $scope.checkoutCart.billing.save_paypal_as_option && _squid.$config.baOptOutEnabledCountries.indexOf(_squid.$locale.country) > -1) {
                optionalVaulting = true;
            }
            return optionalVaulting;
        };

        $scope.getOptInContent = function () {
            var key = 'billingAgreement.bal' + ($scope.eligibleToHoldBalance ? 'Eligible' : 'Ineligible') + 'Vault' + ($scope.vault.checked ? 'Optin' : 'Optout');
            return (0, _squid.$renderContent)(key, { merchantName: $scope.merchantName, country: _squid.$locale.country, lang: _squid.$locale.lang });
        };

        $scope.changeVaultSelection = function () {
            _logger.$logger.info('optional_vault_user_selection_' + $scope.vault.checked);
        };

        $scope.onCompletethreedsHandler = function (status, transactionId) {
            $scope.showThreedsPopup = false;
            // safely convert the status
            if (status.toLowerCase() === 'success') {
                return updatethreedsStatus(status, transactionId.threeDSTransactionId);
            } else {
                // display 3DS decline message
                show3DSDeclineMsg();
            }
        };

        $scope.upopCallbacks = {
            onConfirmUpopSuccess: function onConfirmUpopSuccess() {
                _uiRouter.$state.go('checkout.review');
                return $scope.checkoutSession.action('clearContingency', {
                    data: {
                        contingency: 'UNCONFIRMED_UPOP',
                        ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
                    },
                    success: function success() {
                        if (!$scope.checkoutSession.unconfirmed_upop) {
                            return authorize();
                        } else {
                            $scope.checkoutSession.message = {
                                type: 'warning',
                                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                            };
                        }
                    }
                });
            },
            onConfirmUpopCancel: function onConfirmUpopCancel() {
                _uiRouter.$state.go('checkout.review');
                $scope.showUnconfirmedUpopMsg = false;
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                };
            }
        };

        $scope.errorHandlerHelper = {};
        $scope.errorHandlerHelper.addPageError = function (contentKey, dynamicValuesInContent) {
            var messages = [];
            var msg = void 0;

            if (dynamicValuesInContent) {
                msg = (0, _squid.$renderContent)(contentKey, dynamicValuesInContent);
            } else {
                msg = _squid.$locale.content.get(contentKey);
            }

            messages.push(msg);
            $scope.checkoutSession.message = {
                msgs: messages,
                type: 'error'
            };
        };

        $scope.errorHandlerHelper.clearPageErrors = function () {
            $scope.checkoutSession.message = '';
        };

        $scope.returnFromCape = function (isCapeReturnKey) {

            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {
                    // if CAPE includes this field inside the mayfly payload, we will show-up a warning message
                    // on the top of the page ('offers.bmlInWalletDeniedMsg') regarding the declined credit application
                    if (res.show_cape_declined_msg) {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['offers.bmlInWalletDeniedMsg']
                        };
                    }
                    // TODO: We want to remove this condition and make the two calls in parallel.
                    if (res.financial_instrument_id) {
                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;

                        if (res.financial_instrument_details) {
                            return $scope.creditOptions.action('select', {
                                data: Object.assign({}, res.financial_instrument_details, { nominal_rate: undefined }),
                                success: function success() {
                                    $scope.installment.financing_details = res.financial_instrument_details;
                                    $scope.installment.showCYCO = false;

                                    if (_squid.$locale.country === 'DE' && res.credit_account_id) {
                                        return $scope.checkoutSession.fundingOptions.action('add', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                financialInstrumentID: financial_instrument_id,
                                                creditAccountID: res.credit_account_id,
                                                creditProductType: 'BILL_ME_LATER'
                                            },
                                            success: function success(result) {
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    } else {
                                        return $scope.checkoutSession.fundingOptions.action('update', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                planId: financial_instrument_id
                                            },
                                            success: function success(result) {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                                if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                                    $scope.checkoutSession.message = {
                                                        type: 'success',
                                                        msgKeys: ['offers.bmlInWalletSuccessMsg']
                                                    };
                                                }
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        } else {
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                data: {
                                    planId: financial_instrument_id
                                },
                                success: function success(result) {
                                    if ($scope.creditOptions.creditType === 'INST' && $scope.creditOptions.paypalSubsidy && (_squid.$locale.country === 'US' || _squid.$locale.country === 'GB')) {
                                        // This will prevent users from seeing GPL RYI details when PPC FI is selected, this issue was being caused by GPL in-house installments
                                        delete $scope.creditOptions.creditType;
                                    }
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                    if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                        $scope.checkoutSession.message = {
                                            type: 'success',
                                            msgKeys: ['offers.bmlInWalletSuccessMsg']
                                        };
                                    }
                                    if ($scope.setupMultipleFi) {
                                        $scope.setupMultipleFi();
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        }
                    } else {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        // User does not have any FI in wallet and they choose to pay in full.
                        if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return _angular.$q.when();
                        } else {
                            return _angular.$q.when();
                        }
                    }
                },
                error: function error() {
                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        _logger.$logger.info('read_cape_key_failure');
                        return _angular.$q.when();
                    }
                }
            });
        };

        var ifPadThenUpdatePlan = function ifPadThenUpdatePlan(selectedMethodPlanId) {
            // For pad toggle feature with Choice Multi FI experience, we look up the plan ID here
            var padOrIachPlanId = _factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled) && _factory8.$PADFactory.getPadOrIachBankPlanId({
                selectedMethodPlanId: selectedMethodPlanId,
                fundingOptions: $scope.checkoutSession.fundingOptions,
                multiFiCheckboxStates: $scope.padToggleFeature.multiFiCheckboxStates
            });

            return padOrIachPlanId ? padOrIachPlanId : selectedMethodPlanId;
        };

        /**
         *  Decides the plan to use based on
         *  Pad, Credit, Rewards and any other
         *  bussiness logic
         *
         * @returns planID
         */
        var decidePlanSelection = function decidePlanSelection() {
            // TODO: Consider moving this to a generic wallet/plan factory
            // this will avoid repetition in RYI, SelectFI and PayWith
            var defaultPlan = $scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.get('plan.sources')[0];
            var hasRewards = _factory3.$RewardsCheckboxFactory.isRewardsPlan($scope.checkoutSession.plan);
            var selectedMethodPlanId = (0, _utils.getSelectedPlan)($scope.selectedmethod, $scope.checkoutSession);

            if (!$scope.selectedmethod && !hasRewards) {
                return '';
            }

            selectedMethodPlanId = ifPadThenUpdatePlan(selectedMethodPlanId);
            selectedMethodPlanId = _factory3.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, $scope.selectedmethod, $scope.checkoutSession);

            // If the plan is already selected, we don't need to duplicate the call
            if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                return '';
            }

            // This is handled in onPay
            if (selectedMethodPlanId === 'applyForPPCRadio') {
                return '';
            }
            return selectedMethodPlanId;
        };

        /**
         *  Given a plan id perform a selection
         *  and handle any errors/contingencies
         *
         * @returns planID
         */
        var doPlanSelection = function doPlanSelection(selectedMethodPlanId) {
            return $scope.checkoutSession.fundingOptions.action('select', {
                data: {
                    planId: selectedMethodPlanId
                },
                success: function success(result) {
                    $scope.checkoutSession.populate(result);

                    // for multi fi use case after replan we need to reset index to 0
                    // since selected instrument will always be first
                    if ($scope.selectedmethod) {
                        $scope.selectedmethod.index = 0;
                    }

                    // Double check on PayPal balance eligibility after CheckoutSession re-plan
                    return _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                        return shouldEnableBalance(currentState);
                    });
                },
                contingencies: {
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                        // Route to the Confirm Upop page
                        if (result && result.resolution) {
                            var card = result.resolution.data;

                            if (card.fundingId && card.fi && card.fi.type) {
                                $scope.cardModel = new _fi.$AddCardModel();
                                $scope.cardModel.id = card.fundingId;
                                $scope.cardModel.card = new _fi.$CardModel({
                                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                    type: card.fi.type.toUpperCase(),
                                    productType: card.fi.productType
                                });
                            }
                        }

                        // Before routing to confirm Upop route, we cancel the state change listener so that we don't call updateFS. At this point, the user has already made their selection, so this is unneeded.
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Route to the Confirm Upop page. We'll hold on to this deferred promise until the confirmation flow is finished, so we can then continue the chain or cancel out
                        var upopResult = _angular.$q.defer();

                        // Create the handlers for Upop, specifically for this flow. They will act on the deferred promise when the flow is completed
                        $scope.upopCallbacks.isOnUpdate = true;
                        $scope.upopCallbacks.onUpdateSuccess = function () {
                            // On confirmed, update the checkout session then continue
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                silent: true,
                                data: {
                                    planId: $scope.cardModel.id
                                },
                                success: function success() {
                                    if ($scope.checkoutSession.cvvData) {
                                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardModel.get('card.security_code'));
                                    }

                                    // Reset the callback flag
                                    $scope.upopCallbacks.isOnUpdate = false;
                                    $scope.setupMultipleFi();
                                    // Return to this route, resolve the promise
                                    _uiRouter.$state.go('checkout.review');
                                    upopResult.resolve();
                                }
                            });
                        };
                        $scope.upopCallbacks.onUpdateCancel = function () {
                            // Break the promise chain and return to the review page
                            $scope.upopCallbacks.isOnUpdate = false;
                            $scope.setupMultipleFi();
                            upopResult.reject();
                            $scope.upopCallbacks.onConfirmUpopCancel();
                        };

                        _uiRouter.$state.go('.confirmUpop');
                        return upopResult.promise;
                    }
                }
            });
        };

        // For the multiple FI variant of the choice experiment:
        // Update the funding option in the plan based on the user's stored selection
        var updateFS = function updateFS() {
            // Decide plan to select based on priority and bussness logic
            var selectedMethodPlanId = decidePlanSelection();

            // Perform a selection only if required
            return selectedMethodPlanId ? doPlanSelection(selectedMethodPlanId) : _angular.$q.when();
        };

        var getBalanceEligibility = function getBalanceEligibility() {
            return _user.$UserEligibleToHoldBalanceModel.instance().retrieve().then(function (res) {
                var eligibleToHoldBalance = res && res.eligibleToHoldBalance;
                _logger.$logger.info('balance_eligibility_STATUS', { eligibleToHoldBalance: eligibleToHoldBalance });
                return eligibleToHoldBalance;
            })['catch'](function () {
                _logger.$logger.info('balance_eligibility_STATUS_CHECK_ERROR');
                return false;
            });
        };

        // The following functions are all used in the `$q.all` promise chain below
        var populateScope = function populateScope() {
            return (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                fiMeta: _index4['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            }).then(function () {
                // set the cpa eligible to get used  in review page to display CPA  error message and etc
                $scope.isCPAEligible = _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI($scope.checkoutSession) || _sharedUtil.$SharedUtil.isAuthDeclinedInstrument($scope.checkoutSession);
            }).then(function () {
                return $scope.isOptionalVaulting() && getBalanceEligibility().then(function (eligibleToHoldBalance) {
                    $scope.eligibleToHoldBalance = eligibleToHoldBalance;
                });
            });
        };

        /* Flag to determine whether merchant supports callback shipping options for given address
         1. Default : true
         2. shippingRegionSupported : false -> Show shipping region not supported error in review page and do not allow Pay
         */
        $scope.instantUpdateFeature = {
            shippingRegionSupported: true
        };
        $scope.shippingChangeFeature = {};

        var initAndCallOnShippingChange = function initAndCallOnShippingChange() {
            $scope.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
                orderID: $scope.token,
                checkoutCart: $scope.checkoutCart,
                checkoutSession: $scope.checkoutSession,
                checkoutAppData: $scope.checkoutAppData,
                callbackFn: function callbackFn() {
                    /*
                      This function gets called after the onShippingChange
                      function is called on the merchant's page.
                    */
                    $scope.checkoutSession.reload().then(function () {
                        return $scope.checkForShippingOptions();
                    });
                }
            });

            $scope.shippingChangeFeature.callOnShippingChange();
        };

        var initializePadToggleSupport = function initializePadToggleSupport() {
            if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                return Experiments.padToggleFeatureSupported().then(function (result) {
                    $scope.isPadToggleEnabled = result;
                });
            } else {
                return _angular.$q.when($scope.isPadToggleEnabled = false);
            }
        };

        var applyChoiceExperimentVariant = function applyChoiceExperimentVariant() {
            $scope.tagFamilyComputer();
            // Get the choice experiment variant to determine what needs to be shown in the UI
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                $scope.choiceVariant = variant;
                var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
                var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
                var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                $scope.skipSelectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.skipSelectFi || [];

                if (checkboxVariants.indexOf(variant) !== -1 && !$scope.checkoutCart.isBilling() && !$scope.checkoutCart.referenceCheckout) {
                    // Do setup for preferred checkbox
                    $scope.makeFiPreferred = {
                        selected: false
                    };
                }

                $scope.showMultipleFiVariants = multipleFiVariants.indexOf(variant) !== -1;

                if ($scope.showMultipleFiVariants) {
                    // Do the setup for the multipleFiVariant
                    $scope.setupMultipleFi = function () {
                        var planList = $scope.checkoutSession.get('plan.sources');
                        var defaultPlanId = planList && planList[0] && planList[0].id;
                        $scope.selectedmethod = {
                            index: 0,
                            planId: defaultPlanId
                        };

                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Before changing state, persist the change that the user selected
                        var stateChangeListener = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                            $scope.cancelUpdateListener();

                            // ensure we only listen to state changes initiated from the review page
                            if (_uiRouter.$state.fromState.name !== 'checkout.review') {
                                return;
                            }

                            // ignore if the FI selection hasn't been updated
                            if (defaultPlanId === $scope.selectedmethod && $scope.selectedmethod.planId) {
                                return;
                            }

                            event.preventDefault();
                            updateFS().then(function () {
                                return _uiRouter.$state.go(toState, toParams);
                            });
                        });

                        // If the checkout session changes, also change the planId according to the selected index in case plan ids were changed. Save the listener to destroy the handler when changing routes or re-calling setupMultipleFi
                        var fundingOptionsListener = $scope.$watch('checkoutSession.fundingOptions', function (newVal, oldVal) {
                            if (!newVal) {
                                return;
                            }

                            $scope.selectedmethod.planId = newVal.get('plans.' + $scope.selectedmethod.index + '.planId');
                        });

                        $scope.cancelUpdateListener = function () {
                            stateChangeListener();
                            fundingOptionsListener();
                        };

                        $scope.$on('$destroy', $scope.cancelUpdateListener);
                    };

                    $scope.setupMultipleFi();
                }

                $scope.selectFiVariant = selectFiVariants.indexOf(variant) !== -1;

                if ($scope.isProcessorDeclineExperiment && $scope.selectFiVariant) {
                    $scope.hideBlacklistMsg = true;
                }
                // If there are decline instrument and customer is eligible for CPA, we dont want to show any existing message to user.
                // instead CPA message would be shown. A separate component 'decline-notification' has been created for this.
                if ($scope.isCPAEligible && $scope.checkoutSession.declinedInstruments && $scope.checkoutSession.declinedInstruments.length) {
                    $scope.hideBlacklistMsg = true;
                }
            })['catch'](function (err) {
                // TODO: Check what happens to PXP errors
                _logger.$logger.error('choice_eligibility_error', err);
            });
        };

        var applyMerchantName = function applyMerchantName() {
            // resolve merchant name now, just in case we're in a matching treatment
            pxpMerchName = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name;
        };

        // Set the checks to allow the checkout button to be clicked
        $scope.showMissingShippingOptionMessage = false;
        $scope.showMissingPickupOptionMessage = false;

        // if IXO is providing shipping methods, we'll send them to xo-shipping-options component
        $scope.checkForShippingOptions = function () {
            return (0, _xoShippingOptions.getShippingOptions)($scope.token).then(function (options) {
                _logger.$logger.info('new_options_loaded', { options: options });
                $scope.shippingOptions = options;
            }).then(function () {
                return (0, _xoShippingOptions.getSelectedShippingOption)($scope.token);
            }).then(function (selectedOption) {
                _logger.$logger.info('new_option_selected', { selectedOption: selectedOption });
                $scope.selectedShippingOption = selectedOption;
            });
        };

        $scope.selectShippingOption = function (option, checkShippingWarn, checkPickupWarn) {
            $scope.showMissingPickupOptionMessage = checkPickupWarn;
            $scope.showMissingShippingOptionMessage = checkShippingWarn;

            if (!option) {
                return;
            }

            return (0, _xoShippingOptions.selectShippingOption)($scope.token, option).then(function () {

                // If the merchant is integrated with
                // the Callback API, let's call it and then
                // replan through that flow

                if ((0, _shippingChangeFeature.hasOnShippingChangeCallback)()) {
                    return $scope.shippingChangeFeature.callOnShippingChange();
                }

                return _angular.$q.when();
            });
        };

        /**
         * Set up $watch for if `showMore` button has been clicked.
         * When `showMore` button has been clicked, we also need to
         * log all FIs that has a cardart FI
         */
        $scope.$watch(function () {
            return _factory4.$ShowMoreFiFactory.get().isShowMoreBtnClicked;
        }, function (clickedMore) {
            // ensure `showMore` button has been clicked for 3FIs pxp
            if (clickedMore) {
                logSessionDetails();
            }
        });

        var showGAC = function showGAC() {
            _factory.$GiveAtCheckoutFactory.decideEligibility().then(function (result) {
                $scope.isDonation = _factory.$GiveAtCheckoutFactory.get().eligible;
                var charity = _factory.$GiveAtCheckoutFactory.get().charity;

                if (_factory.$GiveAtCheckoutFactory.get().eligible) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'GIVE_AT_CHECKOUT',
                        to: 'prepare_give_at_checkout',
                        gac_model: charity.model_id,
                        gac_npid: charity.nonprofit_id
                    });
                }
            });
        };

        /**
         * Cardart instrumentation for review page comes in a few variations, and
         * it all depends on the pxp result. Following logSessionDetails()
         * logs cardart instrumentation based on:
         *
         * - showMultipleFiVariants pxp
         * - showMultipleFiVariants + 3FI pxp
         * - singleFI pxp
         *
         * See $CardArtInstrument.createPayload() for detailed implementation & explanation
         */
        var logSessionDetails = function logSessionDetails() {
            var isCardArtExp = _cardartInstrument.$CardArtInstrument.isCardArtEnable($scope.fiMeta) && !$scope.isThirdPartyWalletExperience();
            var renderMultipleFi = $scope.showMultipleFiVariants;
            var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBilling = $scope.checkoutCart.isBilling();
            var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.get('merchant.id')) > -1;
            var stickyEligible = isBilling && !disableStickyForMerchant;

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession }), isCardArtExp ? _cardartInstrument.$CardArtInstrument.createPayload({
                stickyEligible: stickyEligible,
                isBillingNoPurchase: isBillingNoPurchase,
                renderMultipleFi: renderMultipleFi,
                checkoutSession: $scope.checkoutSession,
                renderSingleFi: !$scope.showMultipleFiVariants,
                showMoreFiState: _factory4.$ShowMoreFiFactory.get()
            }) : null));
            // Log details about checkout session
        };

        // Reg E - Regulation E compliance guide mandates invoicing payers see a disclaimer message during payment review when RTR is present.
        // The Remittance Transfer Rule (RTR) is a rule published by the Consumer Financial Protection Bureau.
        // It applies to companies processing remittance transfers of more than $15 USD from a US-based consumer (Sender) to a foreign-based receiver (Recipient).
        var applyInvoicingRegEDetails = function applyInvoicingRegEDetails() {
            // Show invoicing RegE compliance message if its invoicing flow only and if RTR is present
            $scope.showInvoicingRegEMsg = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            _logger.$logger.info('show_invoicing_regE_msg', $scope.showInvoicingRegEMsg);

            if ($scope.showInvoicingRegEMsg) {
                var totalAmount = $scope.checkoutCart.purchase.amounts.total.amount_formatted_currency;
                var merchantName = $scope.checkoutAppData.merchant.brand_name;

                // The RegE message differs for cases with and without currency conversion
                if ($scope.checkoutSession.plan.hasConversion()) {
                    var total = 0;
                    var planSources = $scope.checkoutSession.get('plan.sources');
                    var currencyCode = planSources[0].amount.currency_code;

                    planSources.forEach(function (source) {
                        if (currencyCode !== source.amount.currency_code) {
                            $scope.showInvoicingRegEMsg = false;
                            return;
                        }

                        total = total + Number(source.amount.amount);
                    });

                    var totalInvoicePaymentAmount = (0, _squid.formatCurrency)(total, currencyCode);

                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsgWithCurrConv', {
                        merchantName: merchantName,
                        amountInPayerCurrency: totalInvoicePaymentAmount,
                        amountInInvCurrency: totalAmount
                    });
                } else {
                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsg', {
                        merchantName: merchantName,
                        amount: totalAmount
                    });
                }
            }
        };

        // method to decide to show RTR language toggle
        var showLanguageToggleForRTR = function showLanguageToggleForRTR() {
            // get details about invoice and RTR decision
            var isRTRFlow = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            if (isRTRFlow) {
                if ($scope.checkoutSession.plan.hasConversion()) {
                    /**
                     * if RTR flow - compliance ask is to show a language toggle to switch
                     * between english and buyer's profile language (if both are english ignore showing this toggle)
                     */
                    var languageIgnoreToggle = 'en';
                    if (_squid.$locale.lang !== languageIgnoreToggle) {
                        _logger.$logger.info('show_invoicing_language_toggle', $scope.showInvoicingRegEMsg);
                        $scope.showRTRLanguageToggle = true;
                        $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                            language: (0, _squid.$renderContent)('languages.' + languageIgnoreToggle).toString()
                        });
                    }
                }
            }
        };

        // method to reload the page with selected locale
        $scope.reloadPageLanguageToggle = function () {
            if (_squid.$locale.lang === 'en') {
                _logger.$logger.info('rtr_toggle_to_' + $scope.buyerProfileLanguage);
                _squid.$locale.change(_squid.$locale.country, $scope.buyerProfileLanguage);
                applyInvoicingRegEDetails();
            } else {
                _logger.$logger.info('rtr_toggle_to_en');
                _squid.$locale.change(_squid.$locale.country, 'en');
                applyInvoicingRegEDetails();
            }
        };

        // method to change the RTR localized content - call for every locale change
        function changeRTRContent() {
            if (_squid.$locale.lang === 'en') {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.' + $scope.buyerProfileLanguage).toString()
                });
            } else {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.en').toString()
                });
            }
        }
        $scope.$on('localeChange', changeRTRContent);

        var applyKmliUpsellEligibility = function applyKmliUpsellEligibility() {
            if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon') {
                var fiModel = $scope.checkoutSession.get('plan.sources');

                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
                    $scope.checkoutSession.message = {
                        msgKeys: ['confirmUpop.confirmUpopToPay'],
                        type: 'warning'
                    };
                }
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                eligibility.interstitial = eligibility.interstitial ? eligibility.interstitial : {};
                $scope.optin_toggle.isEnabled = eligibility.banner;
                $scope.optin_toggle.value = $scope.auth.rememberedOT() // came in as OneTouch user
                || $scope.auth.isKmliSet // used to set toggle value via interstial
                || $scope.auth.loggedIn() && $scope.auth.refreshToken(); // FirstTime OT (check this for webview case)
                delete $scope.auth.isKmliSet;

                $scope.optin_toggle.showExpandedTerms = false; // collapse by default;
                var cookiePayload = {};

                if (eligibility.interstitial.eligible) {
                    // show optin interstitial only once per user per version
                    cookiePayload.ot_inter_shown = eligibility.interstitial.pxpVersion; // cookieList.push({ name: 'ot_inter_shown', value: eligibility.interstitial.pxpVersion });
                }
                if (Object.keys(cookiePayload).length > 0) {
                    $scope.auth.action('updateAuthExperience', {
                        silent: true,
                        data: cookiePayload
                    }).then(function (res) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_success', res);
                    })['catch'](function (err) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_err', err);
                    });
                }
                _logger.$logger.info('optin_toggle_init', $scope.optin_toggle);
            });

            $scope.personalizedBanner.trigger();
            $scope.showRemittanceDisclosure = _index2.$DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
        };

        // applyCreditOptions could potentially redirect out of the RYI.
        var applyCreditOptions = function applyCreditOptions() {
            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');

            // value of success url param is true indicates user was approved
            $scope.isCapeReturnApproval = isCapeReturnKey && _squid.$util.param('success') === 'true';

            if (isChangeInstallments) {
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            }
            if (isCapeReturn) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if (((0, _squid.$feature)('creditInstallmentOffers') || _squid.$locale.country === 'DE') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = _credit.$CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve().then(function () {
                    if ($scope.creditOptions.totalPayment) {
                        $scope.installment.financing_details = {
                            apr: $scope.creditOptions.apr,
                            credit_type: $scope.creditOptions.creditType,
                            monthly_payment: $scope.creditOptions.monthlyPayment,
                            term: $scope.creditOptions.term,
                            total_cost: $scope.creditOptions.totalPayment,
                            total_interest: $scope.creditOptions.totalInterest,
                            currency: $scope.cartCurrency
                        };
                    }
                    $scope.creditOptions.apr = String($scope.creditOptions.apr);
                });
            }

            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');

            // this function returns true if plan sources contains exactly PPCredit & Incentive
            $scope.isCreditIncentiveOption = function () {
                var plans = $scope.checkoutSession.get('plan.sources', null);

                if (plans && plans.length === 2 && plans.filter(function (fi) {
                    return fi.type === 'BILL_ME_LATER';
                }).length === 1 && plans.filter(function (fi) {
                    return fi.type === 'INCENTIVE';
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.isPPCReuseAndNotSelected = function () {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                if (plans && plans.filter(function (fi) {
                    return fi.name === 'BILL_ME_LATER' && !fi.selected;
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            // Tracking customers preferences for using PPC if it is a preferred FI
            var preferred_plan = $scope.checkoutSession.fundingOptions.getPreferred();
            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW_PREFERRED_FI',
                pref_fi_option_shown: preferred_plan && preferred_plan.primaryFs && preferred_plan.primaryFs.name
            });

            // if PPCredit & Incentive are showing in the page together with installments we will hide installment details
            $scope.showInstallmentOptionWithoutIncentives = function () {
                if ($scope.creditOptions.creditType === 'INST') {
                    if (!$scope.isCreditIncentiveOption()) {
                        $scope.creditOptions.apr = String($scope.creditOptions.apr);
                        return true;
                    }
                }
                return false;
            };

            $scope.showChange = function () {
                var cartAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');

                if (cartAmount >= 99) {
                    return true;
                }
                return false;
            };

            $scope.showInstallmentOption = function () {
                if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {

                    if ($scope.creditOptions.creditType === 'INST') {
                        $scope.installmentInfo = {
                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
                        };
                    }
                    return true;
                } else {
                    return false;
                }
            };

            // if PPCredit & Incentive are showing in the page together with installments, we will:
            // 1. add a warning message in the top of the page as the installment option selected in cyco page
            //    is not available with PayPal incentives balance.
            // 2. hide installment options (see above method showInstallmentOptionWithoutIncentives())
            if ($scope.showInstallmentOption() && $scope.creditOptions.creditType === 'INST' && $scope.isCreditIncentiveOption()) {
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['offers.bmlInWalletInvalidInstallmentsMsg']
                };
            } else if ($scope.checkoutSession.message && $scope.checkoutSession.message.msgKeys && $scope.checkoutSession.message.msgKeys[0] === 'offers.bmlInWalletInvalidInstallmentsMsg') {
                // Remove error message in review page if was showing before changing payment method
                $scope.checkoutSession.message = null;
            }

            $scope.showCYCO = function () {
                $scope.checkoutSession.message = null;
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            };

            if (_angular.$window.location.search.search('atoSuccess') !== -1) {
                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = _squid.$locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            if (_squid.$util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            if ($scope.showAuthMsg) {
                /*
                    new compliance message for AS1 / AS2 is not for US which displays LearnMore Link
                    have this scope variable set based on country
                */
                $scope.showAuthMsgLearnMore = _squid.$locale.country !== 'US' ? true : false;
            }

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments', []);
            var isCreditInWallet = false;

            if ($scope.checkoutCart.isBillingNoPurchase()) {
                isCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                isCreditInWallet = fundingInstruments.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var isPPCEligible = $scope.checkoutSession && $scope.checkoutSession.creditOffer;
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            _logger.$logger.debug('creditInstallmentOffer ' + $scope.checkoutSession.creditInstallmentOffer + ', ' + 'creditOffer ' + $scope.checkoutSession.creditOffer + ', ' + isCreditInWallet + ', ' + isPayPalCredit);

            if ($scope.checkoutSession.creditOffer) {
                if (!_angular.$rootScope.bml) {
                    _angular.$rootScope.bml = new _bml.$BMLModel();
                }
                _angular.$rootScope.bmlApply = new _bml.$ApplyForBMLModel();
            }
            // the second button user is ineligible for PPC and has not selected to "pay with paypal"
            else if (isPayPalCredit && !isPPCEligible && !$scope.creditDataModel.payInFull && !isCapeReturn) {
                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country');

                    // no credit in wallet
                    if (!isCreditInWallet) {
                        $scope.checkoutSession.message = {
                            type: 'info',
                            msgKeys: ['offers.bmlIneligibleHeader', 'offers.bmlIneligibleContent']
                        };

                        _logger.$logger.info('checkout_fpti', {
                            from: 'Login',
                            to: 'Review',
                            error_type: 'second_btn_ineligible'
                        });
                    }
                    // 2nd button, cross border, user saw CYCO page -- we cannot honor any offer the user chose
                    // for LU merchants, don't show banners for eBayRM for connect scenario
                    else if ($scope.creditDataModel.isCrossBorder() && merchantCountry !== 'LU' && $scope.creditDataModel.hasSelectedCYCOOffer()) {
                            var msg = (0, _squid.$renderContent)('offers.bmlCrossBorderIneligibleContent', {
                                merchantCountry: merchantCountry
                            });
                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                }

            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;

            return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        };

        var checkIfSkipReview = function checkIfSkipReview() {

            var skipReviewFlag = _squid.$util.param('skip-review'),
                oneClickEligible = $scope.checkoutSession.oneClickEligible,
                merchantId = $scope.payee.get('merchant.id'),
                merchantIds = _squid.$config.skipReviewWhitelistedMerchants || [],
                deviceMobile = _index2.$DeviceInfo.isMobile();

            if (skipReviewFlag && oneClickEligible && merchantIds.some(function (id) {
                return id === merchantId;
            }) && deviceMobile) {

                _logger.$logger.info('review_skipped');
                $scope.onPay();
            }
        };

        var shouldEnableBalance = function shouldEnableBalance(currentState) {
            var eligibility = currentState.eligibility;

            // initial eligibilty is set to null so it's essential to
            // explicitly check current eligibility is not null

            if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                };
                _logger.$logger.info('review_page_controller_render_cip_incomplete_message');
            }
        };

        var applyNegativeBalanceStatus = function applyNegativeBalanceStatus() {
            var checkoutSession = $scope.checkoutSession;
            var negBals = checkoutSession.negBals;
            var nbrMsgContentKey = void 0;
            var tokenHash = void 0;

            if (negBals) {
                nbrMsgContentKey = 'memberReview.nbrMsg';
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
                };

                if (negBals.length > 1) {
                    nbrMsgContentKey += 'Plural';
                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
                }

                checkoutSession.message = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)(nbrMsgContentKey, tokenHash)]
                };
            }
        };

        var applyBrPxp = function applyBrPxp() {
            if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
                var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                return (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        };

        var applyShowShippingMethod = function applyShowShippingMethod() {
            $scope.isInstantUpdateAPIFlow = $scope.checkoutCart && $scope.checkoutCart.get('instantUpdateIntegration');
            $scope.showShippingMethod = $scope.isInstantUpdateAPIFlow ? true : false;
            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
                return setShowShippingMethodProperty();
            }
        };

        $scope.policyContentKey = function () {
            var policyContentKey = 'memberReview.viewPaypalPolicies';
            var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;
            if (buyerOptOut) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptOut';
            } else if ($scope.isOptionalVaulting()) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptIn';
            }
            _logger.$logger.info('resolved_policy_content_key_' + policyContentKey);
            return policyContentKey;
        };

        var isPPCReuseAndSelected = function isPPCReuseAndSelected() {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);

            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };

        var applyPayButtonOption = function applyPayButtonOption() {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            var isBilling = $scope.checkoutCart.isBilling();
            var merchant = $scope.checkoutAppData.merchant;
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutoBillingFlow = $scope.checkoutAppData.isWpsAutobillingFlow();
            var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

            $scope.merchantName = merchant.brand_name || merchant.merchant_name;

            // Determine whether the button type is a Pay button or Continue button
            $scope.buttonLabelIsPay = $scope.useraction === 'commit' || _integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW');

            // if the user has credit selected the button label should be not be 'pay now'
            if (isPPCReuseAndSelected()) {
                $scope.buttonLabelIsPay = undefined;
            }

            // log paybuttonText as paynow or continue
            // irrespective of PAD, credit, etc
            _logger.$logger.info('checkout_fpti', {
                'ryp_button_text': $scope.buttonLabelIsPay ? 'paynnow_y' : 'paynnow_n'
            });

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {
                var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;

                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if (_squid.$locale.country === 'DE') {
                        return _squid.$locale.content.get('memberReview.bmlContinueToApplication');
                    }
                    return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
                }

                if ($scope.isDEInstallmentsApproved()) {
                    return _squid.$locale.content.get('memberReview.bmlBindingApply');
                }

                if (isBilling && !buyerOptOut) {
                    if ($scope.buttonLabelIsPay) {
                        if (isWPSSubscriptionFlow || isSubscriptionsV1 || isWPSAutoBillingFlow) {
                            return _squid.$locale.content.get('memberReview.agreeAndSubscribeLabel');
                        }
                        return _squid.$locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        return _squid.$locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (getPadToggleStatus() === 'ON') {
                    return _squid.$locale.content.get('memberReview.padLabel');
                } else if ($scope.buttonLabelIsPay) {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return _squid.$locale.content.get('memberReview.pay');
                    } else {
                        $scope.payButton = 'paynnow_y';
                        return _squid.$locale.content.get('memberReview.payLabel');
                    }
                } else {
                    $scope.payButton = 'paynnow_n';
                    return _squid.$locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new _squid.$FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage($scope.checkoutSession);

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession && $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onFBBANotNow = function () {
                var _$scope$checkoutSessi4 = $scope.checkoutSession.payer;
                _$scope$checkoutSessi4 = _$scope$checkoutSessi4 === undefined ? {} : _$scope$checkoutSessi4;
                var payerId = _$scope$checkoutSessi4.id;

                var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';

                _logger.$logger.info('checkout_fpti', {
                    buyer_country: _squid.$locale.country,
                    buyer_id: payerId,
                    context_id: $scope.token,
                    design: 'fbmessenger',
                    from: 'BILLING_AGREEMENT',
                    to: 'process_billing_agreement',
                    eligibility_reason: isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked',
                    click_source: 'not_now'
                });

                window.xchild.close();

                if (experience.autoBA) {
                    window.top.location.replace('fbiab://paypal/abort');
                }
            };

            $scope.onPay = function (result) {

                _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T4' });

                // If back clicked in browser and lands on review, we need to do the clear cvv contigency
                $scope.resetCVVContigency({ flow: 'browser_back' });

                // Track NMJ variations.
                var payEventName = void 0;

                if ($scope.isNmjDesign1) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design1_page';
                } else if ($scope.isNmjDesign2) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design2_page';
                } else if ($scope.isNmjDesign3) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design3_page';
                } else {
                    payEventName = 'member_ryi_onPayVariant_control';
                }

                _logger.$logger.info(payEventName);

                if ($scope.showMissingPickupOptionMessage || $scope.showMissingShippingOptionMessage) {
                    return;
                }

                if (!isValidPinSetup()) {
                    $scope.topupError = true;
                    _logger.$logger.debug('pin_missing');
                    _uiRouter.$state.go('checkout.pinSetup');
                    return;
                }

                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                if ($scope.isInstantUpdateAPIFlow && !$scope.instantUpdateFeature.shippingRegionSupported) {
                    return;
                }

                // Determine whether or not to prevent going forward based on the status of the onShippingChange callback
                if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.status) {
                    switch ($scope.shippingChangeFeature.status) {
                        case $scope.shippingChangeFeature.enums.LOADING:
                        case $scope.shippingChangeFeature.enums.REJECTED:
                        case $scope.shippingChangeFeature.enums.FAILED:
                            return;
                        default:
                    }
                }

                if ((0, _squid.$feature)('creditInstallmentOffers') && isPPCReuseAndSelected() && !($scope.creditOptions && $scope.creditOptions.creditType) && $scope.creditSharedInfo.hasInstallmentOffers()) {
                    // customer is elgibile for installments and not selected an offer yet.
                    // if they fall under the treatment and they are no a return back from cape they will see the new cyco page
                    // else they will go to the CYCO page in hermes
                    return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
                // "Paying" by applying for PPC
                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.installment && $scope.installment.installmentOptionsPresent) {
                        return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else if (_squid.$locale.country === 'DE' && $scope.creditSharedInfo.hasInstallmentOffers() && $scope.creditSharedInfo.hasInstallmentOfferFinancingDetails()) {
                        return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: $scope.creditSharedInfo.getInstallmentOfferFinancingDetails() });
                    } else {
                        return _uiRouter.$state.go('checkout.redirectToCape');
                    }
                }

                // users are able to trigger multiple preAuthorize calls, disabling the button after first click to prevent that
                $scope.onPayButtonDisabled = true;
                return checkForAddressNormalization()['catch'](function (error) {
                    if (error instanceof _squid.$ShortCircuit) {
                        throw error;
                    }

                    _logger.$logger.error('checkForAddressNormalization_error', error);
                }).then(function () {
                    var padToggleStatus = getPadToggleStatus();

                    if (padToggleStatus === 'ON') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOnSubmit'
                        });
                    } else if (padToggleStatus === 'OFF') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOffSubmit'
                        });
                    }

                    /**
                     * Call updateFS so that if user has made a change in the multiple FI on RYI variant, we select their instrument before doing other logic
                     * Call patchCvv first, if error, need buyers to input again
                     * Call to set Sticky Funding Instrument for Billing Agreement.
                     * We have to ensure the sticky call happens before authorize due to symphony spec.
                     * We need to wait for the response from updateAddressAsPreferred before calling authorize                 */

                    var tokenizationPreAuthorizeError = void 0;

                    return updateFS()
                    // Make PAPS patch calls sequentially. Concurrent patch calls are currently not supported
                    .then(function () {
                        return checkJSV4PaymentDetails();
                    }).then(function () {
                        return _tokenizedFactory.$TokenizedFactory.tokenizedOnPayCalls($scope.checkoutCart, $scope.checkoutSession, $scope.tokenizedWalletInfoModel, $scope.walletPinModel);
                    }).then(function () {
                        setCvvData();
                        return _fiApis.$fiApis.patchCvv($scope.checkoutSession);
                    }).then(function () {
                        return setStickyInstrument();
                    })
                    // Other calls that won't affect the checkout session. Multiple patch calls to PAPS should not be made here
                    .then(function () {
                        return _angular.$q.all([updateAddressAsPreferred(), // This is a patch call to PAPS
                        setWalletTopupPreferences(), linkAuthConsent(), $scope.actions.updatePreferredFi(_logger.$logger), donationAuthorize()])['catch'](function (err) {
                            // should we have more elaborate error handling here?
                            if ($scope.checkoutCart.isWalletTokenization()) {
                                if (err && err.message === 'WALLET_PREFERENCE_SET_ERROR') {
                                    tokenizationPreAuthorizeError = err;
                                }
                            }
                            _logger.$logger.error('onPay() error', err);
                        })['finally'](function () {
                            if (tokenizationPreAuthorizeError) {
                                var code = 'ANDROID_PAY_SET_WALLET_PREFERENCE_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            } else {
                                return authorize();
                            }
                        });
                    }, function (err) {
                        if ($scope.hasShippingOptions() && err.message === 'IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION') {
                            return;
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            if (err && err.message === 'ISSUANCE_PIN_SERVICE_ERROR') {
                                var code = 'ANDROID_PAY_SET_PIN_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                                return;
                            }
                        }
                        _logger.$logger.error('onPay() patchCvv error', err);
                    })['finally'](function () {
                        $scope.onPayButtonDisabled = false;
                    });
                });
            };

            $scope.cancelCreditApplication = function () {
                var baseUrl = window.location.href.split('?')[0];
                var params = _squid.$util.params();

                // Remove CAPE return parameters as the user has
                delete params.success;
                delete params.key;

                _squid.$util.redirect(_squid.$util.buildURL(baseUrl, params));
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;
            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };
            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        };

        var checkForAddressNormalization = function checkForAddressNormalization() {
            // before any address normalization action , check whether it is required to do so
            // if buyer country and shipping address country different , then don't try to normalize that
            // address normalization enabled for BR and US buyers and now force only if shipping address also matches
            $scope.shippingAddress = $scope.checkoutSession.get('shipping');
            var country = $scope.shippingAddress && $scope.shippingAddress.country;
            if (_squid.$locale.country === country) {
                if (!$scope.AddressNormzalizationDone && $scope.checkoutAppData.get('flags.allow_change_shipping', false) && (0, _squid.$feature)('shippingAddressNormalization')) {
                    if ((0, _squid.$feature)('addressNormalizationEdit') && $scope.shippingAddress) {
                        return _factory6.$AddressNormalizationFactory.getAddressNormalizationElmoResult(country).then(function (treatment) {
                            if (treatment && $scope.shippingAddress.normalization_status === 'UNKNOWN') {
                                $scope.strictAddressNormalization = false;
                                _uiRouter.$state.go('checkout.review.sidebar.addressNormalizationEdit');
                                return _squid.$promise.shortCircuit();
                            } else {
                                return _angular.$q.when();
                            }
                        });
                    } else if ($scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {
                        _uiRouter.$state.go('checkout.review.sidebar.updateShipping');
                        return _squid.$promise.shortCircuit();
                    }
                }
            }
            return _angular.$q.when();
        };

        // This function is sent to Address Normalziation process as callback
        // when Address normalization proccess finishes it'll redirect back to
        // here, review page.
        $scope.onAddressNormalized = function () {
            _uiRouter.$state.go('checkout.review').then(function () {
                $scope.AddressNormzalizationDone = true;
                $scope.onPay();
            });
        };

        var checkForReviewLaterText = function checkForReviewLaterText() {
            $scope.showReviewLaterText = true;

            if ($scope.checkoutCart.isSubscriptionsV1()) {
                $scope.showReviewLaterText = $scope.useraction === 'commit' ? false : true;
                return;
            }
            // only get pxp if buttonlabel is not pay and for billingWithOutPurchase
            if ($scope.useraction !== 'commit' && !_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && $scope.checkoutCart.isBillingNoPurchase()) {
                _logger.$logger.info('billing_no_purchase_use_case');
                $scope.showReviewLaterText = false;
            }
        };

        var initBillingNoPurchasePlans = function initBillingNoPurchasePlans() {
            var isBillingNoPurchase = $scope.checkoutCart && $scope.checkoutCart.isBillingNoPurchase();

            $scope.plans = isBillingNoPurchase ? $scope.checkoutSession.get('futurePaymentInstruments') : $scope.checkoutSession.getPlanList();
        };

        var showBillingMessage = function showBillingMessage() {
            var merchant = $scope.checkoutAppData.get('merchant');
            var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';

            $scope.showMessage = true;
            var contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName });

            if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow() || $scope.checkoutCart.isSubscriptionsV1()) {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rp', { merchantName: merchantName });
                } else {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rt', { merchantName: merchantName });
                }

                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [contentDataKey]
                };
            }
        };

        var showMoreFiInit = function showMoreFiInit() {
            var showMoreFiEligibility = _factory4.$ShowMoreFiFactory.decideEligibility({ plans: $scope.plans });

            if (showMoreFiEligibility) {
                showMoreFiEligibility.then(function () {
                    _factory4.$ShowMoreFiFactory.init($scope.plans);
                });
            }
        };

        // TODO: please talk with AuthRate team on `xo_hermes_preferred_expired_msg_review_page` pxp when
        // they decide to turn the experiement on next year!
        // https://engineering.paypalcorp.com/pxptool/history?exptId=3935
        // const showExpiredMsgInit = () => {
        //     $scope.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg($scope.isNmj, $scope.checkoutSession);
        //     if ($scope.showExpiredMsg) {
        //         $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
        //             $scope.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
        //             $scope.preferredExpired = $scope.checkoutSession.getDisallowedPreferred();
        //         });
        //     }
        // };

        // lazy load some of the most popular routes to increase loading time
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                var routes = [];

                if (_integration.$integration.isFlow('WPS')) {
                    routes.push.apply(routes, [__webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-pay/route.js")), // eslint-disable-line
                    __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "../node_modules/xo-page-components/src/done/route.js")) // eslint-disable-line
                    ]);
                }

                routes.push.apply(routes, [__webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-sidebar/route.js"))]);

                // preload checkout.genericMessage route which is shown when transaction is completed
                // on devices. So basically user will see `Thanks for using PayPal!` and `You can close this tab at any time.`
                // and at the same time there will be client side redirect
                // https://github.paypal.com/Checkout/xo-return-to-merchant/blob/master/dist/util.js#L44
                // May help reduce noise in case of code split when it's trying to first download the js chunk and then make redirect
                // which may take longer than usual
                if (_index2.$DeviceInfo.isDevice()) {
                    routes.push(__webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-generic-message/route.js")));
                }

                Promise.all(routes)['catch'](function (err) {
                    _logger.$logger.info('code_split_review_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        var isUSCrossCurrency = function isUSCrossCurrency() {
            if ($scope.checkoutCart && $scope.checkoutCart.grossTotalAmount && $scope.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                return true;
            }
            return false;
        };

        var handleUnsupportUSCrossCurrency = function handleUnsupportUSCrossCurrency() {
            if ($scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.plans) {
                var plans = $scope.checkoutSession.fundingOptions.plans.filter(function (plan) {
                    return plan.primaryFs.name !== 'BILL_ME_LATER';
                });
                if (isUSCrossCurrency() && !plans.length) {
                    _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                } else if (isUSCrossCurrency()) {
                    doPlanSelection(plans[0].planId);
                }
            }
        };

        _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T0' });

        /**
         * This promise chain renders critical content in the page. Avoid
         * the temptation to tack on another `.then` to this promise chain.
         *
         * If you are making a critical network request, consider putting
         * function inside the `$q.all` array so it can be run in parallel
         * and not slow down page rendering.
         *
         * If your function requires values available on `$scope` after
         * the critical functions in `$q.all` are complete, put your
         * function in the following `.then` block.
         *
         * Otherwise, your function can likely go somewhere else.
         */
        populateScope().then(function () {
            stickyCTA();
            _factory3.$RewardsCheckboxFactory.buildCache();
            // applyCreditOptions could potentially redirect out of the RYI.
            // Seperate it out from the rest of the pack to avoid unnecessary code execution
            handleUnsupportUSCrossCurrency();
            applyCreditOptions();
            triggerPersonalizedBanner();
            applyMerchantName();
            applyPayButtonOption();
            checkIfSkipReview();
            applyChoiceExperimentVariant();
            applyNegativeBalanceStatus();
            applyKmliUpsellEligibility();
            applyShowShippingMethod();
            applyInvoicingRegEDetails();
            showLanguageToggleForRTR();
            initAndCallOnShippingChange();
            checkForReviewLaterText();
            initBillingNoPurchasePlans();
            showBillingMessage();
            applyBrPxp();
            initializePadToggleSupport();
            showGAC();
            _factory2.$NoBalanceFactory.decideEligibility();
            prepareTokenizedWallet();
            applyNewMemberVariant().then(function () {
                // TODO: see comment from above in regards to run this pxp again
                // showExpiredMsgInit();
            });
            showMoreFiInit();
            logSessionDetails();
            preloadCodeSplitRoutes();

            //  To show cvv box even though the cvvData already resolved.
            $scope.resetCVVContigency({ flow: 'page_refresh' });
            checkExperienceElmoTreatment();

            // Decide whether to display CIP_INCOMPLETE (AU only) message and disable PayPal balance
            // as a valid funding instrument
            _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                return shouldEnableBalance(currentState);
            });
        })['finally'](function () {
            if (window.appPerformanceEvents) {
                // TimeToFullyRender: The moment client is ready to receive with all data for the user.
                // Should be the last promise on the page
                // to be triggered after all data loads
                window.appPerformanceEvents.TimeToFullyRender = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function (params) {
            if (params) {
                _logger.$logger.debug('ryi_optin_isKmliSet_' + params.isKmliSet);
                if (params.isKmliSet) {
                    $scope.optin_toggle.setValue(true);
                }
            }
            _uiRouter.$state.go('checkout.review');
        };

        $scope.propValueObj = {};
        if ((0, _squid.$feature)('propValue')) {
            $scope.propValueObj.propHeader = 'memberReview.propHead';
            $scope.propValueObj.propVal = 'memberReview.propVal';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
        } else {
            $scope.propValueObj.propHeader = 'login.propHeadAlt';
            $scope.propValueObj.propVal = 'login.propValAlt';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
        }
    }]
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_uiRouter.$state;

_index.$miniBrowser;

_logger.$logger;

_integration.$integration;

_index2.$DeviceInfo;

_ul.$ul;

_pxp.$pxpCartAmt;

_marketingoffer.$fireMORSBeacon;

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_angular.noop;

_kmliUpsell.$KmliUpsell;

_utils.getSelectedPlan;

_utils.getInstrumentID;

_squid.$Class;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$featureCountries;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_squid.formatCurrency;

_squid.formatNameInformal;

_squid.$promise;

_squid.$ShortCircuit;

_squid.$elmo;

_squid.$event;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

_fiApis.$fiApis;

_eligibility.$stickyCTA;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_donation.$GiveAtCheckoutModel;

_bml.$ApplyForBMLModel;

_bml.$BMLModel;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditSharedInfoModel;

_fi.$AddCardModel;

_fi.$CardModel;

_fi.$PreferredFi;

_fi.$WalletPreferences;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_marketingoffer2.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_shippingMethod.$ShippingRuleSummaryModel;

_user.$AuthConsentModel;

_user.$UserEligibleToHoldBalanceModel;

_factory.$GiveAtCheckoutFactory;

_factory2.$NoBalanceFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$ShowMoreFiFactory;

_factory5.$AddCardFactory;

_factory6.$AddressNormalizationFactory;

_cardartInstrument.$CardArtInstrument;

_factory7.$BalanceFactory;

_factory8.$PADFactory;

_tokenizedFactory.$TokenizedFactory;

_shippingChangeFeature.createShippingChangeFeature;

_shippingChangeFeature.hasOnShippingChangeCallback;

_xoShippingOptions.getShippingOptions;

_xoShippingOptions.selectShippingOption;

_xoShippingOptions.getSelectedShippingOption;

_xoShippingOptions.$xoShippingOptions; // eslint-disable-line no-unused-vars;

_sharedUtil.$SharedUtil;

_balance.$BalanceEligibilityFactory;

_qs.parse;

_qs.stringify;

/***/ }),

/***/ "./pages/xo-review/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PADFactory', function () {

    /**
     *
     * get PAD or IACH plan id based on selected plan id and PAD toggle status
     * if selected plan is IACH and toggle is on -> use associated PAD plan id
     * if selected plan is IACH and toggle is off -> use it's ID
     * if selected plan is PAD and toggle is on -> use it's ID
     * if selected plan is PAD and toggle is off -> use associated IACH plan id
     */
    var getPadOrIachBankPlanId = function getPadOrIachBankPlanId(_ref) {
        var selectedMethodPlanId = _ref.selectedMethodPlanId,
            fundingOptions = _ref.fundingOptions,
            multiFiCheckboxStates = _ref.multiFiCheckboxStates;

        var plan = fundingOptions.getPlanByPlanId(selectedMethodPlanId);
        var padOrIachPlanId = void 0;

        if (fundingOptions.isPAD(plan) || fundingOptions.isIACH(plan)) {
            if (multiFiCheckboxStates[plan.primaryFs.id]) {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: true });
            } else {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: false });
            }
        }
        return padOrIachPlanId;
    };

    // check if PAD feature is applicable
    var isPadToggleFeatureApplicable = function isPadToggleFeatureApplicable(padToggleFeature, isPadToggleEnabled) {
        return padToggleFeature.applicable && isPadToggleEnabled;
    };

    return {
        getPadOrIachBankPlanId: getPadOrIachBankPlanId,
        isPadToggleFeatureApplicable: isPadToggleFeatureApplicable
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/factory.js"))

/***/ }),

/***/ "./pages/xo-review/lib/shippingChangeFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.createShippingChangeFeature = exports.hasOnShippingChangeCallback = undefined;

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _factory = __webpack_require__("../node_modules/xo-shipping-change/src/factory.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var hasOnShippingChangeCallback = exports.hasOnShippingChangeCallback = function hasOnShippingChangeCallback() {
    return window.xprops && window.xprops.onShippingChange;
};

var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderID = _ref.orderID,
        checkoutCart = _ref.checkoutCart,
        checkoutSession = _ref.checkoutSession,
        checkoutAppData = _ref.checkoutAppData,
        _ref$callbackFn = _ref.callbackFn,
        callbackFn = _ref$callbackFn === undefined ? _squid.$util.noop : _ref$callbackFn;

    var feature = {
        enums: {
            LOADING: 'loading',
            REJECTED: 'rejected',
            UPDATED: 'updated',
            FAILED: 'failed'
        },
        status: null,
        shippingChangeFactory: (0, _factory.$ShippingChangeFactory)({ orderID: orderID, checkoutAppData: checkoutAppData, checkoutCart: checkoutCart }),
        callOnShippingChange: _squid.$util.noop
    };

    feature.callOnShippingChange = function () {
        var doneFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$util.noop;

        if (!hasOnShippingChangeCallback()) {
            return doneFn();
        }

        var successFn = function successFn() {
            var updatedMsg = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
            });

            feature.status = feature.enums.UPDATED;
            checkoutSession.message = {
                msgs: [updatedMsg],
                type: 'info'
            };
        };

        var rejectFn = function rejectFn() {
            var rejectedMsg = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
                merchant: checkoutAppData.getMerchantDisplayName()
            });

            feature.status = feature.enums.REJECTED;
            checkoutSession.message = {
                msgs: [rejectedMsg],
                type: 'warning'
            };
        };

        var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');

        _squid.$event.emit('loading');
        _squid.$event.emit('loadingMessage', loadingMsg);

        return feature.shippingChangeFactory.getPayload(checkoutSession.get('shipping')).then(function (payload) {
            _logger.$logger.info('shipping_change_payload_recieved', payload);

            return feature.shippingChangeFactory.callOnShippingChange(payload);
        }).then(function (_ref2) {
            var cartHasChanged = _ref2.cartHasChanged,
                rejected = _ref2.rejected;


            _logger.$logger.info('shipping_change_called', { cartHasChanged: cartHasChanged, rejected: rejected });

            callbackFn();

            if (rejected) {
                return rejectFn();
            } else if (cartHasChanged) {
                return successFn();
            } else {
                // If the callback was not rejected, and the cart
                // was not changed we can remove any statuses
                // that prevent finishing checkout.
                feature.status = null;
            }
        }).then(doneFn)['catch'](function (err) {
            _logger.$logger.error('shipping_change_error', err);

            feature.status = feature.enums.FAILED;
            _uiRouter.$state.go('checkout.genericError');
        })['finally'](function () {
            _squid.$event.emit('loaded');
        });
    };

    return feature;
};

_squid.$renderContent;

_squid.$util;

_squid.$locale;

_squid.$event;

_factory.$ShippingChangeFactory;

_uiRouter.$state;

_logger.$logger;

/***/ }),

/***/ "./pages/xo-review/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReviewRoute = undefined;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

var _directive = __webpack_require__("./pages/xo-review/directive.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _choice = __webpack_require__("../node_modules/xo-models/src/choice/index.js");

var _credit = __webpack_require__("../node_modules/xo-models/src/credit/index.js");

var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {

    path: 'review',
    directive: _directive.$xoReviewPageComponent,
    titleContent: 'memberReview.memberReviewTitle',
    params: { message: null },
    trackingData: {
        fptiState: 'review',
        templateName: 'memberReview.dust',
        pageGoal: 'Payment Review',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-review',
                'pagename2': '%::fullpage-review:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },

    resolve: {
        action: function action() {

            // Determine if we should instead route to the selectFi choice experiment page
            if (!(0, _squid.$feature)('choiceExperiment')) {
                return;
            }

            var _$config$choiceExperi = _squid.$config.choiceExperiment;
            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
            var fromState = _uiRouter.$state.fromState,
                toParams = _uiRouter.$state.toParams;

            var skipStates = ['checkout.review', 'checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];

            // Is review route hit a result of CREDIT_CARD_AUTH_FAILED, i.e. smart $x auth check failure?
            var isFromCcAuthFailure = toParams && toParams.message === 'CREDIT_CARD_AUTH_FAILED';
            if (!isFromCcAuthFailure && (!fromState.name ||
            // Current state contains one of the skip states (can be nested)
            skipStates.some(function (state) {
                return fromState.name.indexOf(state) !== -1;
            }))) {
                return;
            }

            // If returning from credit application, skip the selectFi page
            var isCapeReturnKey = _credit.$CreditDataModel.instance(_angular.$rootScope.token).getCapeKey();

            if (isCapeReturnKey) {
                return;
            }

            return _choice.$ChoiceEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // Check if variant is selectFi variant
                if (fiPageVariants.indexOf(variant) === -1) {
                    return;
                }

                var models = {};

                // Check that there is more than one plan to choose from, or that plan is not preferred
                return (0, _squid.$populate)(models, {
                    checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                    checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token)
                }).then(function () {
                    /**
                     * instant update callback which is making external api calls
                     * to get shipping charge and same is getting updated into checkout session (patch call)
                     * selectFI page is updating the plan id from initial post on checkout session
                     * but because of patch call for shipping charge old plan id is not valid
                     * and the update to PAPS resulted in internal error
                     * skip the choice page if it is instant update flow
                     */
                    if (models.checkoutCart.get('instantUpdateIntegration')) {
                        return;
                    }

                    var plans = models.checkoutSession.get('fundingOptions.plans');
                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;

                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
                        return {
                            to: 'checkout.selectFi',
                            newState: true
                        };
                    } else {
                        _logger.$logger.info('skip_selectFi', {
                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
                        });
                        return;
                    }
                });
            });
        }
    },

    children: [{
        name: '$SidebarRoute',
        attributes: {
            'back-uri': 'backUri',
            'shipping-change-feature': 'shippingChangeFeature',
            'promotion': 'promotion',
            'update': 'update',
            'token': 'token',
            'installment': 'installment',
            'strict-address-normalization': 'strictAddressNormalization',
            'shipping-address': 'shippingAddress',
            'on-address-normalized': 'onAddressNormalized'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "./pages/xo-sidebar/route.js"));
        },
        slug: 'sidebar'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token',
            'on-complete': 'onComplete'
        },
        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "../node_modules/xo-login-components/src/onetouch-interstitial/route.js"));
        },
        slug: 'oneTouchUpsell'
    }, {
        name: '$xoConfirmUpopRoute',
        props: function props() {
            var props = {
                token: this.token,
                cardmodel: this.cardModel
            };

            if (this.upopCallbacks.isOnUpdate) {
                props.onSuccess = this.upopCallbacks.onUpdateSuccess;
                props.onCancel = this.upopCallbacks.onUpdateCancel;
            } else {
                props.onSuccess = this.upopCallbacks.onConfirmUpopSuccess;
                props.onCancel = this.upopCallbacks.onConfirmUpopCancel;
            }

            return props;
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "../node_modules/xo-wallet-components/src/confirm-upop/route.js"));
        },
        slug: 'confirmUpop'
    }, {
        name: '$SidepageRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: function lazyRoute() {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "./pages/xo-sidepage/route.js"));
        },
        slug: 'sidepage'
    }]
});

angular.value("$ReviewRoute", $ReviewRoute);
_logger.$logger;

_squid.$ComponentRoute;

_squid.$feature;

_squid.$config;

_squid.$populate;

_angular.$rootScope;

_uiRouter.$state;

_directive.$xoReviewPageComponent;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_choice.$ChoiceEligibility;

_credit.$CreditDataModel;

/***/ }),

/***/ "./pages/xo-review/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./pages/xo-review/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"review\" content ng-click=\"onPageClick($event)\" id=\"memberReview\" tabindex=-1 role=\"presentation\">\n    <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'top'\">\n        <!--Action button -->\n        <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('memberReview.viewPaypalPolicies')\"></p>\n\n        <div ng-if=\"showPaymentRights\">\n            <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n            <span class=\"diagonalArrow\"></span>\n        </div>\n\n        <!--Invoicing Flow RegE message in cases of RTR -->\n        <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n            <div>{{ invoicingRegEMsg }}</div>\n        </div>\n\n        <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n            {{ content('confirmUpop.confirmUpopToPay')}}\n        </p>\n\n        <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n        </p>\n\n        <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n            <!--content-->\n            <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n            <div>\n                <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n            </div>\n        </div>\n\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input\n                track-submit\n                type=\"submit\"\n                value=\"{{payButtonText()}}\"\n                id=\"confirmButtonTop\"\n                class=\"btn full confirmButton continueButton\"\n                data-test-id=\"continueButton\"\n                validate-submit=\"onPay()\"\n            />\n        </div>\n    </xo-sticky-cta>\n    <!-- >>> CTA Disclaimer -->\n    <span  ng-if=\"stickyEligibility === 'top'\" class=\"stickyCtaTopDisclaimers\">\n        <!-- checkoutSession.isRT need to review this -->\n        <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!buttonLabelIsPay && showReviewLaterText && !isCPAEligible\">\n                {{ content('common.reviewLater')}}\n            </p>\n\n            <xo-cpa-disclaimer selectedmethod=\"selectedmethod\" primaryplan=\"primaryplan\" ng-if=\"isCPAEligible\"></xo-cpa-disclaimer>\n            <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n            <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                    <p>\n            </div>\n\n            <div class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && (checkoutSession.plan.isAuthSignupEnabled || showAuthMsg)\">\n                <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                <span ng-if=\"showAuthMsgLearnMore\">\n                    <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                    <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                </span>\n            </div>\n    </span>\n    <!-- <<< CTA Disclaimer -->\n\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n    <div ng-if=\"!checkoutCart.isWalletTokenization()\" class=\"row-fluid justMember\" ng-class=\"{ bmlPopupOpen: bmlPopupOpen }\">\n        <div class=\"span14 trayInner reviewSections\" ng-show=\"!bmlPopupOpen\">\n            <xo-message ng-if=\"showCreditDisallowedMessage()\" message=\"creditDisallowedMessage\"></xo-message>\n            <xo-no-balance-banner ng-if=\"noBalanceFactoryState.eligible\"></xo-no-balance-banner>\n            <div class=\"rtrLanguageToggle\">\n                <a ng-if=\"showRTRLanguageToggle\" ng-click=\"reloadPageLanguageToggle()\">{{ rtrContent }}</a>\n            </div>\n            <div class=\"userBanner\">\n                <xo-banner ng-if=\"isNmjexpired || (personalizedBanner.show && !isMessengerBAIntegration)\" is-nmj=\"isNmj || isNmjexpired\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        <span ng-if=\"isNmjDesign1\">{{ content('memberReview.hiUser_welcome', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && !optin_toggle.isEnabled\">{{ content(!personalizedBanner.isFBSkipLogin ? 'memberReview.loggedInWithOneTouch' : 'memberReview.loggedInFaceBookBA', {userName: formattedNameInformal, lastName: auth.last_name, firstName: auth.first_name}) }}</span>\n                        <span ng-if=\"!isNmjDesign1 && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"isNmjexpired && optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                        <div ng-if=\"isNmjexpired\" id=\"notifications\" content>\n                            <div class=\"msgPage msg-normal\">\n                                <span class=\"icon\"></span>\n                                <ul>\n                                    <li>\n                                        <span ng-bind-html=\"htmlContent('creditcard.preferredExpired', {cardType: preferredExpired.displayName, last4:\n                                            preferredExpired.lastDigits})\" ></span><span>\n                                            <a id=\"updatePreferredExpired\" track-submit=\"update_preferred_expired\" href\n                                               ng-click=\"actions.goToManageWallet(preferredExpired.id)\">{{content('creditcard.updateItNow')}}</a></span>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </p>\n                </xo-banner>\n                <div class=\"greyHeader\" ng-if=\"showGreyHeader\">\n                    <xo-banner is-nmj=\"showGreyHeader\">\n                        <p class=\"userEmail\" id=\"reviewUserInfo\">\n                            <span>{{ headerMsg }}</span>\n                            <span ng-if=\"showNotYou\" class=\"greyHeaderNotYou\">\n                                <xo-not-you></xo-not-you>\n                            </span>\n                        </p>\n                    </xo-banner>\n                </div>\n                <xo-expired-message ng-if=\"showExpiredMsg && !isNmjexpired\" token=\"token\"></xo-expired-message>\n                <xo-message ng-if=\"!hideBlacklistMsg  && showMessage\" message=\"checkoutSession.message\" isGreyHeader=\"showGreyHeader\"></xo-message>\n                <div ng-if=\"!isNmj && !personalizedBanner.show && !isMessengerBAIntegration && !isNmjexpired && !isProcessorDeclineExperiment\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        {{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}\n                        <span ng-if=\"showNotYou\">\n                            <xo-not-you></xo-not-you>\n                        </span>\n                    </p>\n                </div>\n            </div>\n            <div ng-if=\"optin_toggle.isEnabled\" class=\"oneTouchBanner\">\n                <div ng-if=\"!isNmj\" class=\"highlight_bar\"></div>\n                <div class=\"oneTouchTerms\">\n                    <p class=\"enable_auto_login bold\" ng-if=\"!optin_toggle.value\">{{ content('memberReview.autoLoginOff') }}</p>\n                    <p class=\"enable_auto_login\" ng-if=\"optin_toggle.value\">{{ content('memberReview.autoLoginOn') }}</p>\n\n                    <div ng-show=\"optin_toggle.showExpandedTerms\" class=\"oneTouchTermsText\">\n                        <p class=\"expanded\" ng-bind-html=\"htmlContent('memberReview.expandedTermsOT')\"></p>\n                        <p class=\"securityInfo\">\n                            {{ content('memberReview.securityInfoOT') }} <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">{{ content('common.hide') }}</a>\n                        </p>\n                    </div>\n                    <div ng-show=\"!optin_toggle.showExpandedTerms\">\n                        <p class=\"securityInfo\">\n                            <span ng-show=\"!optin_toggle.value\">{{ content('memberReview.sharedDevicesOT') }}</span>\n                            <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">Details</a>\n                        </p>\n                    </div>\n                </div>\n                <div id=\"banner-switch\">\n                    <input id=\"optin_toggel\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" ng-model=\"optin_toggle.value\" ng-change=\"onTouchToggle(optin_toggle.value)\">\n                    <label for=\"optin_toggel\"></label>\n                </div>\n            </div>\n            <xo-decline-notification ng-if=\"isCPAEligible\" />\n            <form name=\"confirm\" class=\"proceed\" novalidate=\"novalidate\" id=\"ryiForm\">\n                <!-- {@if cond=\"'{data.updated}' === 'bmlSuccess'\" } -->\n                <div class=\"reviews\" ng-if=\"isNmjDesign1\">\n                    <xo-assist-banner\n                        header=\"assistBannerHeader\"\n                        body=\"assistBannerBody\"\n                        hide-highlight=\"checkoutSession.message\">\n                    </xo-assist-banner>\n                </div>\n\n                <xo-offer-top-banner ng-if=\"!isThirdPartyWalletExperience()\"></xo-offer-top-banner>\n\n                <div class=\"reviews\" ng-if=\"merchantMsg\">\n                    <h4 ng-if=\"!isMessengerBAIntegration\" class=\"noBottom gamma\" id=\"merchantMsgHeader\">\n                        {{ content('memberReview.merchantMsgHeader', { merchantName: merchantName }) }}\n                    </h4>\n                    <!--content-->\n                    <h1 ng-if=\"isFacebookBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.fbHeader') }}\n                    </h1>\n                    <h1 ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        {{ content('messenger.baHeader') }}\n                    </h1>\n                    <div class=\"merchantMsg\" id=\"merchantMsg\">\n                        <span class=\"given-name\">\n                            {{ merchantMsg }}\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign1 || isNmjDesign2\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign2\"></div>\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showInstallmentOption()\">\n                    <div id=\"installmentPlanInfo\" data-test-id=\"installmentPlanInfo\">\n                        <h4 class=\"noBottom gamma\" id=\"installmentInfoHeader\">\n                            {{content('chooseCreditOption.reviewPaymentPlan')}}\n                        </h4>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"showInstallmentOptionWithoutIncentives()\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: installmentInfo.monthlyPaymentAmt})\"> </p>\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: installmentInfo.totalInterestAmt, totalPayment: installmentInfo.totalPaymentAmt})\"> </p>\n                        </div>\n\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'SAC'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetails')\"> </p>\n                        </div>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'NI'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetailsNI')\"> </p>\n                        </div>\n                        <a class=\"edits creditEdit\" ng-if=\"showChange()\" ng-click=\"showCYCO()\">\n                            {{ content('common.change') }}\n                            <span class=\"frontArrow goTray ng-scope\"></span>\n                        </a>\n                    </div>\n                </div>\n\n                <div\n                    class=\"reviews shippingOptionsWrapper\"\n                    ng-if=\"!showShippingMethod && hasShippingOptions()\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign3\"></div>\n                    <h2 class=\"paymentsHeader zeta\">{{content('shipping.orderChoiceLabel')}}</h2>\n                    <xo-shipping-options\n                        ng-if=\"hasShippingOptions()\"\n                        token=\"token\"\n                        on-select=\"selectShippingOption\"\n                        selected-method=\"selectedShippingOption\"\n                        methods=\"shippingOptions\">\n                    </xo-shipping-options>\n                </div>\n                <div class=\"reviews\" ng-if=\"!hasShippingOptions() && showShippingAddress\">\n                    <div class=\"addPadding\" ng-if=\"isNmjDesign3\"></div>\n                    <xo-review-address\n                        token=\"token\"\n                        make-addr-preferred=\"makeAddrPreferred\"\n                        shipping-change-feature=\"shippingChangeFeature\"\n                        store-pick-up-selected=\"checkoutCart.isShippingMethodStorePickUp()\"\n                        nmj-experience=\"nmjExperience\"\n                    ></xo-review-address>\n                </div>\n\n                <xo-select-shipping-method ng-if=\"showShippingMethod\" token=\"token\" show-shipping-address=\"showShippingAddress\" error-handler-helper=\"errorHandlerHelper\" instant-update-feature=\"instantUpdateFeature\"></xo-select-shipping-method>\n\n                <div class=\"reviews\" ng-if=\"!isNmj\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\"\n                                       choice-balance-checkbox-state=\"choiceBalanceCheckboxState\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"isNmjDesign3\">\n                    <xo-review-paywith ng-if=\"!isThirdPartyWalletExperience()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\"\n                                       nmj-experience=\"isNmj\"\n                                       credit-parent-context=\"creditParentContext\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\" token=\"token\"></xo-review-paywith-venmo>\n                    <xo-review-paywith-baidu ng-if=\"determineThirdPartyWalletExperience() === 'BAIDU_EXPERIENCE'\" token=\"token\"></xo-review-paywith-baidu>\n                </div>\n\n                <p ng-if=\"isMessengerBAIntegration\" class=\"secondary messengerDisclaimer\">{{ content('messenger.disclaimer') }}</p>\n\n                <div ng-if=\"showCreditPlacement()\" class=\"PPCOffers\" ng-class=\"{ 'reviews hideOffersSeparator hideSeparator': isNmj}\">\n                    <xo-credit-offer-banners token=\"token\" />\n                </div>\n\n                <div id=\"optionalVaulting\" data-test-id=\"optionalVaulting\" class=\"optional-vault\" ng-if=\"isOptionalVaulting()\">\n                    <div id=\"optionalVaultContainer\">\n                        <label data-test-id=\"save_paypal_checkmark\" class=\"container\">{{ content('billingAgreement.saveTextHeader', { merchantName: merchantName })}}\n                            <input type=\"checkbox\" ng-model=\"vault.checked\" ng-change=\"changeVaultSelection()\">\n                            <span class=\"checkmark\"></span>\n                        </label>\n                    </div>\n                    <p id=\"optionalAgreementText\" data-test-id=\"optionalAgreementText\"  class=\"agreement-content\" bind-html-compile=\"getOptInContent()\"></p>\n                </div>\n\n                <div ng-if=\"isDonation\" class=\"gacDonation\">\n                    <xo-donate merchant-name={{merchantName}}></xo-donate>\n                </div>\n\n                <div ng-if=\"showRemittanceDisclosure\" class=\"rtrWrap\">\n                    {{ content('memberReview.rtrMsg', { merchantName: checkoutAppData.merchant.brand_name }) }}\n                </div>\n\n                <!--inc/bmlLearnMore-->\n                <div>\n                    <div class=\"buttons bmlSeeTermsBtn hide\">\n                        <button class=\"btn full hide\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                    </div>\n                </div>\n                <xo-sticky-cta eligibility=\"stickyEligibility\" ng-if=\"stickyEligibility === 'bottom'\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('{{policyContentKey()}}', country: locale.country, lang: locale.lang)\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n                        </div>\n                    </div>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" ng-disabled=\"onPayButtonDisabled\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </xo-sticky-cta>\n                <div ng-if=\"!stickyEligibility\">\n                    <!--Action button -->\n                    <p ng-if=\"showPaypalPolicy\" class=\"paypalPoliciesLink disclaimer\" bind-html-compile=\"content('{{policyContentKey()}}')\"></p>\n\n                    <div ng-if=\"showPaymentRights\">\n                        <div class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewYourPaymentMethodRights')\"></div>\n                        <span class=\"diagonalArrow\"></span>\n                    </div>\n\n                    <!--Invoicing Flow RegE message in cases of RTR -->\n                    <div ng-if=\"showInvoicingRegEMsg\" class=\"invRegE\">\n                        <div>{{ invoicingRegEMsg }}</div>\n                    </div>\n\n                    <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                        {{ content('confirmUpop.confirmUpopToPay')}}\n                    </p>\n\n                    <p ng-if=\"!isThirdPartyWalletExperience() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                    </p>\n\n                    <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                        <!--content-->\n                        <h4 class=\"noBottom paymentsHeader zeta\">{{ content('messenger.pluginHeader') }}</h4>\n                        <div>\n                            <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                            <p class=\"messengerLegalTxt\" data-ng-bind-html=\"content('messenger.legal')\"></p>\n                        </div>\n                    </div>\n\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" ng-disabled=\"onPayButtonDisabled\" data-test-id=\"continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n\n                    <div ng-if=\"isDEInstallmentsApproved()\" class=\"cancelButton\">\n\n                        <a href=\"\" ng-click=\"actions.openCancelApplicationModal()\">{{ content('memberReview.bmlCancelApplication') }}</a>\n\n                        <xo-modal show=showCancelApplicationModal show-close-button=\"true\" on-close=\"actions.closeCancelApplicationModal\"  ng-click=\"actions.handleCancelApplicationModalClick($event)\">\n                            <div class=\"confirmDialogTopBox\">\n                                <div class=\"confirmDialogText\">\n                                    <p>{{ content('memberReview.bmlCancelApplicationConfirmation') }}</p>\n                                </div>\n                                <div class=\"confirmDialogButtons\">\n                                    <input type=\"button\" class=\"btn full primary\" value=\"{{ content('memberReview.bmlCancelApplication') }}\" ng-click=\"cancelCreditApplication()\" />\n                                    <a href=\"\" ng-click=\"actions.closeCancelApplicationModal()\">{{ content('memberReview.bmlDoNotCancelApplication') }}</a>\n                                </div>\n                            </div>\n                        </xo-modal>\n                    </div>\n                </div>\n\n                <!--content-->\n                <div class=\"messengerBANotnow\" ng-if=\"isMessengerBAIntegration\">\n                    <a href=\"\" ng-click=\"onFBBANotNow()\">{{ content('messenger.button_notNow') }}</a>\n                </div>\n\n                <!-- >>> CTA Disclaimer -->\n                <span  ng-if=\"stickyEligibility !== 'top'\">\n                    <!-- checkoutSession.isRT need to review this -->\n                    <p class=\"reviewLaterContainer disclaimer\" data-test-id=\"reviewLaterContainer\" ng-if=\"!isThirdPartyWalletExperience() && !buttonLabelIsPay && showReviewLaterText && !isCPAEligible\">\n                        {{ content('common.reviewLater')}}\n                    </p>\n                    <p class=\"reviewLaterContainer disclaimer\" ng-if=\"determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE'\">\n                        {{ content('paymentMethod.venmoReceipt') }}\n                    </p>\n\n                    <xo-cpa-disclaimer selectedmethod=\"selectedmethod\" primaryplan=\"primaryplan\" ng-if=\"isCPAEligible\"></xo-cpa-disclaimer>\n\n                    <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                        ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n                    <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n                    <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                        <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                            <p>\n                    </div>\n\n                    <div class=\"disclaimer reviewMsg\" ng-if=\"!isThirdPartyWalletExperience() && (checkoutSession.plan.isAuthSignupEnabled || showAuthMsg)\">\n                        <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span>\n                        <span ng-if=\"showAuthMsgLearnMore\">\n                            <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                            <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                        </span>\n                    </div>\n                </span>\n                <!-- <<< CTA Disclaimer -->\n\n                <xo-credit-example-uk ng-if=\"showRepresentativeExample()\"/>\n            </form>\n\n        </div>\n\n        <xo-bml-popup ng-if=\"!isThirdPartyWalletExperience()\"></xo-bml-popup>\n\n        <div ng-show=\"bmlPopupOpen\" class=\"bmlPopup span14\">\n            <p>\n                {{ content('fundingInstruments.bmlLearnMoreDesc') }}\n            </p>\n\n            <input type=\"button\" class=\"btn full primary\" value=\"{{ content('fundingInstruments.ok') }}\" ng-click=\"hideBmlPopup()\" />\n        </div>\n\n        <div class=\"span10\" ng-if=\"!isThirdPartyWalletExperience()\">\n\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n                                 ng-if=\"!ryiDesignExp && !isMessengerBAIntegration\"\n            >\n            </xo-marketing-offers>\n\n            <xo-marketing-offers token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"'ryiDesignExp.propHeader'\"\n                                 subtitle-property=\"'ryiDesignExp.propText'\"\n                                 background-image=\"{{ryiDesignExp.propImage}}\"\n                                 ng-if=\"ryiDesignExp && !isMessengerBAIntegration\"\n\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div class=\"reviewTopup\" ng-if=\"checkoutCart.isWalletTokenization()\">\n        <div class=\"reviewTopupError\">\n            <xo-message message=\"tokenizedFactoryState.reviewTopupErrorMessage\"></xo-message>\n        </div>\n        <div class=\"topupError\" ng-if=\"topupError\">\n            <span class=\"topupErrorIcon\"></span>\n            <span>{{content('review.pinError')}}</span>\n        </div>\n        <xo-title title-txt=\"{{content('review.reviewDetailsTitle', {type: tokenizedWalletInfoModel.brandName()})}}\"></xo-title>\n        <div class=\"topupMsg\">\n            <span>{{content('review.tokenizationInfo', {type: tokenizedWalletInfoModel.brandName()})}}</span>\n        </div>\n\n        <xo-review-topup class=\"fillflex\" token=\"token\" flags=\"tokenizedFactoryState.tokenizationFlags\"></xo-review-topup>\n        <div ng-if=\"tokenizedFundingCapabilitiesModel.isTopupEnabled()\" class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupCommonSetting')\"></div>\n        <div class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupTokenizedWalletSetupAgreements', {type: tokenizedWalletInfoModel.brandName(), link: tokenizedWalletInfoModel.getDisclaimerLink()})\"></div>\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\"\n                class=\"btn full confirmButton continueButton\" data-test-id=\"continueButton\" ng-disabled=\"onPayButtonDisabled\" ng-click=\"onPay()\" />\n        </div>\n    </div>\n    <div ui-view></div>\n    <xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n\n    <!-- 3ds 2.0 -->\n    <xo-modal\n        ng-if=\"showThreedsPopup\"\n        show=\"showThreedsPopup\"\n        enable-mobile-interstitial=\"true\"\n        show-close-button=\"true\"\n        on-close=\"actions.onThreedsModalClose\"\n        override-default-container=\"true\">\n        <xo-three-ds\n            token=\"token\"\n            reference-id=\"threedsData.referenceId\"\n            jwt-info=\"threedsData.jwtInfo\"\n            card-bin=\"threedsData.cardBin\"\n            network-logo=\"threedsData.networkLogo\"\n            ddc-url=\"threedsData.ddcUrl\"\n            card-brand=\"threedsData.cardBrand\"\n            integration-type=\"threedsData.integrationType\"\n            init-threeds-data=\"threedsData.initThreedsData\"\n            on-complete=\"onCompletethreedsHandler\">\n        </xo-three-ds>\n    </xo-modal>\n\n\n</section>\n"

/***/ }),

/***/ "./pages/xo-review/tokenizedFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");

var _user = __webpack_require__("../node_modules/xo-models/src/user/index.js");

var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");

var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedFactory', function () {

    var state = {
        reviewTopupErrorMessage: {},
        tokenizationFlags: {
            sepaAgree: false
        }
    };

    var get = function get() {
        return state;
    };

    var AUTHORIZE_AND_UPDATE_SCOPE_BATCH = 'authorizeAndUpdateScope';
    var AUTHORIZE_CALL = 'authorize';

    /**
     * PatchXO api call for tokenization flows
     */
    var tokenizationPatchXO = function tokenizationPatchXO(checkoutSession, instrumentId) {
        return checkoutSession.action('setTopupFI', {
            data: {
                instrument_id: instrumentId
            }
        });
    };

    /**
     * Agree Sepa Mandate:
     *  When user has clicked on the checkbox, call SepaAccept api, then calls PatchXO
     *  When user has not clicked on the checkbox, show page level error message
     */
    var agreeSepaMandate = function agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel) {
        if (checkoutCart.isWalletTokenization()) {
            var bankId = checkoutSession.get('sepa_mandate.bankId');
            if (bankId && state.tokenizationFlags.sepaAgree) {
                // User agreed to the Sepa mandate by clicking on the checkbox
                return _fi.$SepaModel.instance().action('sepaAccept', {
                    data: {
                        bank: {
                            id: bankId
                        }
                    },
                    success: function success() {
                        // Patch XO after Sepa agreed by user, so as to update PAPS
                        return tokenizationPatchXO(checkoutSession, bankId);
                    }
                });
            } else if (bankId) {
                // User did not agree to the Sepa mandate
                var msg = (0, _squid.$renderContent)('tokenization.agreeToSepaMsg', {
                    type: tokenizedWalletInfoModel.brandName()
                });

                state.reviewTopupErrorMessage = {
                    msgs: [msg],
                    type: 'warning'
                };
                return _angular.$q.reject();
            }
        }
        return _angular.$q.when();
    };

    /**
     * Save the pin when its available
     */
    var setTokenizedWalletPin = function setTokenizedWalletPin(walletPinModel) {
        if (walletPinModel) {
            var pinModel = {
                data: {
                    pin: walletPinModel.userPin
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'TopUp_REVIEW',
                            'to': 'process_review',
                            'context_id': _angular.$rootScope.token,
                            'context_type': 'BA-Token',
                            'billing_token': _squid.$meta.baToken,
                            'int_error_code': 'pin_setup_contingencies',
                            'int_error_description': err,
                            'error_source': 'issuancemanagementserv'
                        });

                        throw err;
                    }
                }
            };

            if (walletPinModel.isSetupEligible()) {
                if (walletPinModel.isPinIdPresent()) {
                    pinModel.data.pinId = walletPinModel.getPinId();
                }
                return walletPinModel.save(pinModel);
            }
        }
        return _angular.$q.when();
    };

    var tokenizedOnPayCalls = function tokenizedOnPayCalls(checkoutCart, checkoutSession, tokenizedWalletInfoModel, walletPinModel) {
        return agreeSepaMandate(checkoutCart, checkoutSession, tokenizedWalletInfoModel).then(function () {
            return setTokenizedWalletPin(walletPinModel);
        });
    };

    /**
     * log FPTI event after authorize or authorizeAndUpdateScope call
     */
    var logProcessReviewToFPTI = function logProcessReviewToFPTI() {
        var _$WalletPreferences$i = _fi.$WalletPreferences.instance(_angular.$rootScope.token),
            _$WalletPreferences$i2 = _$WalletPreferences$i.topup,
            topup = _$WalletPreferences$i2 === undefined ? {} : _$WalletPreferences$i2,
            _$WalletPreferences$i3 = _$WalletPreferences$i.direct,
            direct = _$WalletPreferences$i3 === undefined ? {} : _$WalletPreferences$i3,
            currency = _$WalletPreferences$i.currency;

        _logger.$logger.info('tokenized_wallet', {
            'from': 'TopUp_REVIEW',
            'to': 'process_review',
            'topup_amt': topup.amount,
            'chosen_topup_fi': topup.fundingSource && topup.fundingSource.type,
            'chosen_direct_fi': direct.fundingSource && direct.fundingSource.type,
            'currency_code': currency || topup.currency,
            'context_id': _angular.$rootScope.token,
            'context_type': 'BA-Token',
            'billing_token': _squid.$meta.baToken
        });
    };

    /**
     * Update user's scope with "issuance" scope for Google account linking flow
     * Call must be triggered only after successfull "authorize" call
     *
     * If successfull - redirect back to success url
     *
     * If there is a contingency (UAL_ISSUANCE_UPDATE_SCOPE_ERROR) - go to default tokenized wallet error page (see public/js/lib/contingency.js)
     *
     * To improve latency - batch it with "authorize" call
     */
    var updateIssuanceScope = function updateIssuanceScope() {
        var authConsentModel = _user.$AuthConsentModel.instance();

        return authConsentModel.action('updateIssuanceScope', {
            batch: {
                name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
                id: 'updateIssuanceScope',
                dependencies: [AUTHORIZE_CALL]
            },
            data: {
                'ba_token': _squid.$meta.baToken
            },
            success: function success() {
                _logger.$logger.info('ual_update_issuance_scope_success');
                logProcessReviewToFPTI();

                return _uiRouter.$state.go('checkout.end');
            }
        });
    };

    /**
     * Check if flow is Google account linking
     */
    var isGoogleAccountLinking = function isGoogleAccountLinking() {
        var checkoutCart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var auth = _auth.$AuthModel.instance();

        return checkoutCart.isWalletTokenization() && auth.logged_in && auth.disallow_login_switch;
    };

    /**
     * Construct batch object for "authorize" call
     */
    var getAuthorizeBatch = function getAuthorizeBatch() {
        return {
            name: AUTHORIZE_AND_UPDATE_SCOPE_BATCH,
            id: AUTHORIZE_CALL,
            dependencies: []
        };
    };

    return {
        get: get,
        agreeSepaMandate: agreeSepaMandate,
        setTokenizedWalletPin: setTokenizedWalletPin,
        tokenizedOnPayCalls: tokenizedOnPayCalls,
        updateIssuanceScope: updateIssuanceScope,
        isGoogleAccountLinking: isGoogleAccountLinking,
        logProcessReviewToFPTI: logProcessReviewToFPTI,
        getAuthorizeBatch: getAuthorizeBatch
    };
});

_angular.$q;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_fi.$SepaModel;

_logger.$logger;

_user.$AuthConsentModel;

_auth.$AuthModel;

_fi.$WalletPreferences;

_checkout.$CheckoutCartModel;

_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-review", "pages/xo-review/tokenizedFactory.js"))

/***/ }),

/***/ "./pages/xo-select-fi/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceFactory', function () {
    // initial choiceBalanceState checkbox is unselected
    var state = {
        checkbox: undefined
    };

    var get = function get() {
        return state;
    };

    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var getPadAndCheckboxStatus = function getPadAndCheckboxStatus() {
        var balanceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var planList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var isChecked = balanceList.some(function (balance) {
            return balance.checked;
        });
        var hasPad = planList.some(function (plan) {
            return plan.primaryFs.subtype === 'PAD';
        });

        return {
            isChecked: isChecked,
            hasPad: hasPad
        };
    };

    return {
        get: get,
        set: set,
        getPadAndCheckboxStatus: getPadAndCheckboxStatus
    };
});

_squid.$util;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-select-fi", "pages/xo-select-fi/factory.js"))

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/xo-webpack-config/polyfills.js");
module.exports = __webpack_require__("./js/bootstrap.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/main-code-split.js